/**
 * @preserve
 * LIGHTSTREAMER - www.lightstreamer.com
 * Lightstreamer Web Client
 * Version 8.0.7 build 1808
 * Copyright (c) Lightstreamer Srl. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0
 *   See http://www.apache.org/licenses/LICENSE-2.0
 * Contains: LightstreamerClient, Subscription, ConnectionSharing, RemoteAppender, 
 *   MpnDevice, MpnSubscription, SafariMpnBuilder, FirebaseMpnBuilder, 
 *   LogMessages, Chart, DynaGrid, SimpleChartListener, 
 *   StaticGrid, StatusWidget, AlertAppender, BufferAppender, 
 *   ConsoleAppender, DOMAppender, FunctionAppender, SimpleLoggerProvider, 
 *   PromisePolyfill
 */
if (typeof Promise == "undefined") {

    /*!
     * @overview es6-promise - a tiny implementation of Promises/A+.
     * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
     * @license   Licensed under MIT license
     *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
     * @version   3.0.2
     *
     * @private
     */

    (function () {
      
      function lib$es6$promise$utils$$objectOrFunction(x) {
        return typeof x === "function" || typeof x === "object" && x !== null
      }

      function lib$es6$promise$utils$$isFunction(x) {
        return typeof x === "function"
      }

      function lib$es6$promise$utils$$isMaybeThenable(x) {
        return typeof x === "object" && x !== null
      }

      var lib$es6$promise$utils$$_isArray;
      if (!Array.isArray) {
        lib$es6$promise$utils$$_isArray = function (x) {
          return Object.prototype.toString.call(x) === "[object Array]"
        };
      } else {
        lib$es6$promise$utils$$_isArray = Array.isArray;
      }
      var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
      var lib$es6$promise$asap$$len = 0;
      var lib$es6$promise$asap$$customSchedulerFn;
      var lib$es6$promise$asap$$asap = function asap(callback, arg) {
        lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
        lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
        lib$es6$promise$asap$$len += 2;
        if (lib$es6$promise$asap$$len === 2) {
          if (lib$es6$promise$asap$$customSchedulerFn) {
            lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
          } else {
            lib$es6$promise$asap$$scheduleFlush();
          }
        }
      };

      function lib$es6$promise$asap$$setScheduler(scheduleFn) {
        lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
      }

      function lib$es6$promise$asap$$setAsap(asapFn) {
        lib$es6$promise$asap$$asap = asapFn;
      }

      var lib$es6$promise$asap$$browserWindow = typeof window !== "undefined" ? window : undefined;
      var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
      var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
      var lib$es6$promise$asap$$isNode = typeof process !== "undefined" && {}.toString.call(process) === "[object process]";
      var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";

      function lib$es6$promise$asap$$useNextTick() {
        return function () {
          process.nextTick(lib$es6$promise$asap$$flush);
        }
      }

      function lib$es6$promise$asap$$useMutationObserver() {
        var iterations = 0;
        var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
        var node = document.createTextNode("");
        // In the original version characterData is not included "'": this
        // provokes an unwanted minification of such property. 
        observer.observe(node, {'characterData': true});
        return function () {
          node.data = iterations = ++iterations % 2;
        }
      }

      function lib$es6$promise$asap$$useMessageChannel() {
        var channel = new MessageChannel;
        channel.port1.onmessage = lib$es6$promise$asap$$flush;
        return function () {
          channel.port2.postMessage(0);
        }
      }

      function lib$es6$promise$asap$$useSetTimeout() {
        return function () {
          setTimeout(lib$es6$promise$asap$$flush, 1);
        }
      }

      var lib$es6$promise$asap$$queue = new Array(1e3);

      function lib$es6$promise$asap$$flush() {
        for (var i = 0; i < lib$es6$promise$asap$$len; i += 2) {
          var callback = lib$es6$promise$asap$$queue[i];
          var arg = lib$es6$promise$asap$$queue[i + 1];
          callback(arg);
          lib$es6$promise$asap$$queue[i] = undefined;
          lib$es6$promise$asap$$queue[i + 1] = undefined;
        }
        lib$es6$promise$asap$$len = 0;
      }

      function lib$es6$promise$asap$$attemptVertx() {
//        try {
//          var r = require;
//          var vertx = r("vertx");
//          lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
//          return lib$es6$promise$asap$$useVertxTimer()
//        } catch (e) {
//          return lib$es6$promise$asap$$useSetTimeout()
//        }
          return lib$es6$promise$asap$$useSetTimeout()
      }

      var lib$es6$promise$asap$$scheduleFlush;
      if (lib$es6$promise$asap$$isNode) {
        lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
      } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
        lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
      } else if (lib$es6$promise$asap$$isWorker) {
        lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
      } else if (lib$es6$promise$asap$$browserWindow === undefined && typeof require === "function") {
        lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
      } else {
        lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
      }
      function lib$es6$promise$$internal$$noop() {
      }

      var lib$es6$promise$$internal$$PENDING = void 0;
      var lib$es6$promise$$internal$$FULFILLED = 1;
      var lib$es6$promise$$internal$$REJECTED = 2;
      var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject;

      function lib$es6$promise$$internal$$selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself")
      }

      function lib$es6$promise$$internal$$cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.")
      }

      function lib$es6$promise$$internal$$getThen(promise) {
        try {
          return promise.then
        } catch (error) {
          lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
          return lib$es6$promise$$internal$$GET_THEN_ERROR
        }
      }

      function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
        try {
          then.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
          return e
        }
      }

      function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
        lib$es6$promise$asap$$asap(function (promise) {
          var sealed = false;
          var error = lib$es6$promise$$internal$$tryThen(then, thenable, function (value) {
            if (sealed) {
              return
            }
            sealed = true;
            if (thenable !== value) {
              lib$es6$promise$$internal$$resolve(promise, value);
            } else {
              lib$es6$promise$$internal$$fulfill(promise, value);
            }
          }, function (reason) {
            if (sealed) {
              return
            }
            sealed = true;
            lib$es6$promise$$internal$$reject(promise, reason);
          }, "Settle: " + (promise._label || " unknown promise"));
          if (!sealed && error) {
            sealed = true;
            lib$es6$promise$$internal$$reject(promise, error);
          }
        }, promise);
      }

      function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
        if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
          lib$es6$promise$$internal$$fulfill(promise, thenable._result);
        } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
          lib$es6$promise$$internal$$reject(promise, thenable._result);
        } else {
          lib$es6$promise$$internal$$subscribe(thenable, undefined, function (value) {
            lib$es6$promise$$internal$$resolve(promise, value);
          }, function (reason) {
            lib$es6$promise$$internal$$reject(promise, reason);
          });
        }
      }

      function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
        if (maybeThenable.constructor === promise.constructor) {
          lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
        } else {
          var then = lib$es6$promise$$internal$$getThen(maybeThenable);
          if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
            lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
          } else if (then === undefined) {
            lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
          } else if (lib$es6$promise$utils$$isFunction(then)) {
            lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
          } else {
            lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
          }
        }
      }

      function lib$es6$promise$$internal$$resolve(promise, value) {
        if (promise === value) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
        } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
          lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
        } else {
          lib$es6$promise$$internal$$fulfill(promise, value);
        }
      }

      function lib$es6$promise$$internal$$publishRejection(promise) {
        if (promise._onerror) {
          promise._onerror(promise._result);
        }
        lib$es6$promise$$internal$$publish(promise);
      }

      function lib$es6$promise$$internal$$fulfill(promise, value) {
        if (promise._state !== lib$es6$promise$$internal$$PENDING) {
          return
        }
        promise._result = value;
        promise._state = lib$es6$promise$$internal$$FULFILLED;
        if (promise._subscribers.length !== 0) {
          lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
        }
      }

      function lib$es6$promise$$internal$$reject(promise, reason) {
        if (promise._state !== lib$es6$promise$$internal$$PENDING) {
          return
        }
        promise._state = lib$es6$promise$$internal$$REJECTED;
        promise._result = reason;
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
      }

      function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
        var subscribers = parent._subscribers;
        var length = subscribers.length;
        parent._onerror = null;
        subscribers[length] = child;
        subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
        subscribers[length + lib$es6$promise$$internal$$REJECTED] = onRejection;
        if (length === 0 && parent._state) {
          lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
        }
      }

      function lib$es6$promise$$internal$$publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) {
          return
        }
        var child, callback, detail = promise._result;
        for (var i = 0; i < subscribers.length; i += 3) {
          child = subscribers[i];
          callback = subscribers[i + settled];
          if (child) {
            lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
          } else {
            callback(detail);
          }
        }
        promise._subscribers.length = 0;
      }

      function lib$es6$promise$$internal$$ErrorObject() {
        this.error = null;
      }

      var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject;

      function lib$es6$promise$$internal$$tryCatch(callback, detail) {
        try {
          return callback(detail)
        } catch (e) {
          lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
          return lib$es6$promise$$internal$$TRY_CATCH_ERROR
        }
      }

      function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
        var hasCallback = lib$es6$promise$utils$$isFunction(callback), value, error, succeeded, failed;
        if (hasCallback) {
          value = lib$es6$promise$$internal$$tryCatch(callback, detail);
          if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
            failed = true;
            error = value.error;
            value = null;
          } else {
            succeeded = true;
          }
          if (promise === value) {
            lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
            return
          }
        } else {
          value = detail;
          succeeded = true;
        }
        if (promise._state !== lib$es6$promise$$internal$$PENDING) ; else if (hasCallback && succeeded) {
          lib$es6$promise$$internal$$resolve(promise, value);
        } else if (failed) {
          lib$es6$promise$$internal$$reject(promise, error);
        } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
          lib$es6$promise$$internal$$fulfill(promise, value);
        } else if (settled === lib$es6$promise$$internal$$REJECTED) {
          lib$es6$promise$$internal$$reject(promise, value);
        }
      }

      function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
        try {
          resolver(function resolvePromise(value) {
            lib$es6$promise$$internal$$resolve(promise, value);
          }, function rejectPromise(reason) {
            lib$es6$promise$$internal$$reject(promise, reason);
          });
        } catch (e) {
          lib$es6$promise$$internal$$reject(promise, e);
        }
      }

      function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
        var enumerator = this;
        enumerator._instanceConstructor = Constructor;
        enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);
        if (enumerator._validateInput(input)) {
          enumerator._input = input;
          enumerator.length = input.length;
          enumerator._remaining = input.length;
          enumerator._init();
          if (enumerator.length === 0) {
            lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
          } else {
            enumerator.length = enumerator.length || 0;
            enumerator._enumerate();
            if (enumerator._remaining === 0) {
              lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
            }
          }
        } else {
          lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
        }
      }

      lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function (input) {
        return lib$es6$promise$utils$$isArray(input)
      };
      lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function () {
        return new Error("Array Methods must be provided an Array")
      };
      lib$es6$promise$enumerator$$Enumerator.prototype._init = function () {
        this._result = new Array(this.length);
      };
      var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
      lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function () {
        var enumerator = this;
        var length = enumerator.length;
        var promise = enumerator.promise;
        var input = enumerator._input;
        for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
          enumerator._eachEntry(input[i], i);
        }
      };
      lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function (entry, i) {
        var enumerator = this;
        var c = enumerator._instanceConstructor;
        if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
          if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
            entry._onerror = null;
            enumerator._settledAt(entry._state, i, entry._result);
          } else {
            enumerator._willSettleAt(c.resolve(entry), i);
          }
        } else {
          enumerator._remaining--;
          enumerator._result[i] = entry;
        }
      };
      lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function (state, i, value) {
        var enumerator = this;
        var promise = enumerator.promise;
        if (promise._state === lib$es6$promise$$internal$$PENDING) {
          enumerator._remaining--;
          if (state === lib$es6$promise$$internal$$REJECTED) {
            lib$es6$promise$$internal$$reject(promise, value);
          } else {
            enumerator._result[i] = value;
          }
        }
        if (enumerator._remaining === 0) {
          lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
        }
      };
      lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function (promise, i) {
        var enumerator = this;
        lib$es6$promise$$internal$$subscribe(promise, undefined, function (value) {
          enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
        }, function (reason) {
          enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
        });
      };
      function lib$es6$promise$promise$all$$all(entries) {
        return new lib$es6$promise$enumerator$$default(this, entries).promise
      }

      var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;

      function lib$es6$promise$promise$race$$race(entries) {
        var Constructor = this;
        var promise = new Constructor(lib$es6$promise$$internal$$noop);
        if (!lib$es6$promise$utils$$isArray(entries)) {
          lib$es6$promise$$internal$$reject(promise, new TypeError("You must pass an array to race."));
          return promise
        }
        var length = entries.length;

        function onFulfillment(value) {
          lib$es6$promise$$internal$$resolve(promise, value);
        }

        function onRejection(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        }

        for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
          lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
        }
        return promise
      }

      var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;

      function lib$es6$promise$promise$resolve$$resolve(object) {
        var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) {
          return object
        }
        var promise = new Constructor(lib$es6$promise$$internal$$noop);
        lib$es6$promise$$internal$$resolve(promise, object);
        return promise
      }

      var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;

      function lib$es6$promise$promise$reject$$reject(reason) {
        var Constructor = this;
        var promise = new Constructor(lib$es6$promise$$internal$$noop);
        lib$es6$promise$$internal$$reject(promise, reason);
        return promise
      }

      var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
      var lib$es6$promise$promise$$counter = 0;

      function lib$es6$promise$promise$$needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")
      }

      function lib$es6$promise$promise$$needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")
      }

      var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;

      function lib$es6$promise$promise$$Promise(resolver) {
        this._id = lib$es6$promise$promise$$counter++;
        this._state = undefined;
        this._result = undefined;
        this._subscribers = [];
        if (lib$es6$promise$$internal$$noop !== resolver) {
          if (!lib$es6$promise$utils$$isFunction(resolver)) {
            lib$es6$promise$promise$$needsResolver();
          }
          if (!(this instanceof lib$es6$promise$promise$$Promise)) {
            lib$es6$promise$promise$$needsNew();
          }
          lib$es6$promise$$internal$$initializePromise(this, resolver);
        }
      }

      lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
      lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
      lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
      lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
      lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
      lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
      lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
      lib$es6$promise$promise$$Promise.prototype = {
        constructor: lib$es6$promise$promise$$Promise,
        then: function (onFulfillment, onRejection) {
          var parent = this;
          var state = parent._state;
          if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
            return this
          }
          var child = new this.constructor(lib$es6$promise$$internal$$noop);
          var result = parent._result;
          if (state) {
            var callback = arguments[state - 1];
            lib$es6$promise$asap$$asap(function () {
              lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
            });
          } else {
            lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
          }
          return child
        },
        "catch": function (onRejection) {
          return this.then(null, onRejection)
        }
      };
      function lib$es6$promise$polyfill$$polyfill() {
        var local;
        if (typeof global !== "undefined") {
          local = global;
        } else if (typeof self !== "undefined") {
          local = self;
        } else {
          try {
            local = Function("return this")();
          } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment")
          }
        }
        var P = local.Promise;
        if (P && Object.prototype.toString.call(P.resolve()) === "[object Promise]" && !P.cast) {
          return
        }


        lib$es6$promise$promise$$default["all"] = lib$es6$promise$promise$$default.all;
        lib$es6$promise$promise$$default["race"] = lib$es6$promise$promise$$default.race;
        lib$es6$promise$promise$$default["reject"] = lib$es6$promise$promise$$default.reject;
        lib$es6$promise$promise$$default["resolve"] = lib$es6$promise$promise$$default.resolve;
        lib$es6$promise$promise$$default.prototype["constructor"] = lib$es6$promise$promise$$default.prototype.constructor;
        lib$es6$promise$promise$$default.prototype["then"] = lib$es6$promise$promise$$default.prototype.then;
        //catch already declared as string as per IE<9 compatibility

        local["Promise"] = lib$es6$promise$promise$$default;

      }

      var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
      /*var lib$es6$promise$umd$$ES6Promise = {
        Promise: lib$es6$promise$promise$$default,
        polyfill: lib$es6$promise$polyfill$$default
      };
      if (typeof define === "function" && define["amd"]) {
        define(function () {
          return lib$es6$promise$umd$$ES6Promise
        })
      } else if (typeof module !== "undefined" && module["exports"]) {
        module["exports"] = lib$es6$promise$umd$$ES6Promise
      } else if (typeof this !== "undefined") {
        this["ES6Promise"] = lib$es6$promise$umd$$ES6Promise
      }*/
      lib$es6$promise$polyfill$$default();
    }).call(window);

  }

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var IllegalStateException = /*@__PURE__*/(function() {
  /**
   * Constructs an IllegalStateException with the specified detail message.
   * @constructor
   *
   * @param {String} message short description of the error.
   *
   * @exports IllegalStateException
   * @class Thrown to indicate that a method has been invoked at an illegal or 
   * inappropriate time or that the internal state of an object is incompatible 
   * with the call.
   * <BR>Use toString to extract details on the error occurred.
   */
  var IllegalStateException = function(message) {

    /**
     * Name of the error, contains the "IllegalStateException" String.
     * 
     * @type String
     */
    this.name = "IllegalStateException";

    /**
     * Human-readable description of the error.
     * 
     * @type String
     */
    this.message = message;

  };

  IllegalStateException.prototype = {

      toString: function() {
        return ["[",this.name,this.message,"]"].join("|");
      }
      
  };
  
  return IllegalStateException;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Environment = /*@__PURE__*/(function() {
  var isBrowserDocumentVar = (typeof window !== "undefined"  && typeof navigator !== "undefined" && typeof document !== "undefined");
  var isWebWorkerVar = typeof importScripts !== "undefined"; //potentially WebWorkers may appear on node.js
  var isNodeJSVar = typeof process == "object" && (/node(\.exe)?$/.test(process.execPath) || (process.node && process.v8) || (process.versions && process.versions.node && process.versions.v8 ));
  
  if (isBrowserDocumentVar && !document.getElementById) {
    throw new IllegalStateException("Not supported browser");
  }
  /**
   * @exports Environment
   */
  var Environment = {
      
      /**
       * Checks if the code is running inside an HTML document.
       * <BR/>Note that browsers not supporting DOM Level 2 (i.e.: document.getElementById) 
       * are not recognized by this method
       * 
       * @returns {Boolean} true if the code is running inside a Browser document, false otherwise.
       * 
       * @static
       */
      isBrowserDocument: function() {
        return isBrowserDocumentVar;
      },
      
      /**
       * Checks if the code is running inside a Browser. The code might be either running inside a
       * HTML page or inside a WebWorker.
       * <BR/>Note that browsers not supporting DOM Level 2 (i.e.: document.getElementById) 
       * are not recognized by this method
       * 
       * @returns {Boolean} true if the code is running inside a Browser, false otherwise.
       * 
       * @static
       */
      isBrowser: function() {
        return !isNodeJSVar && (isBrowserDocumentVar || isWebWorkerVar);
      },
      
      /**
       * Checks if the code is running inside Node.js.
       * 
       * @returns {Boolean} true if the code is running inside Node.js, false otherwise.
       * 
       * @static
       */
      isNodeJS: function() {
        return !isBrowserDocumentVar && isNodeJSVar;
      },
      
      /**
       * Checks if the code is running inside a WebWorker.
       * 
       * @returns {Boolean} true if the code is running inside a WebWorker, false otherwise.
       * 
       * @static
       */
      isWebWorker: function() {
        return !isBrowserDocumentVar && !isNodeJSVar && isWebWorkerVar;
      },

      /**
       * Checks if the code is not running on a known environment
       * @returns {boolean} true if the code not running on a known environment, false otherwise.
       */
      isOther: function() {
        return !isBrowserDocumentVar && !isNodeJSVar && !isWebWorkerVar;
      },

      /**
       * Helper method that will throw an IllegalStateException if the return value of isBrowserDocument is false.
       * This method is supposedly called as first thing in a module definition.
       * 
       * @throws {IllegalStateException} if this function is not called inside a HTML page. The message of the error
       * is the following: "Trying to load a browser-only module on non-browser environment".
       * 
       * @static
       * 
       * @example
       * define(["Environment"],function(Environment) {
       *   Environment.browserDocumentOrDie();
       *   
       *   //module definition here
       * });
       */
      browserDocumentOrDie: function() {
        if(!this.isBrowserDocument()) {
          throw new IllegalStateException("Trying to load a browser-only module on non-browser environment");
        }
      }
  
  };
  
  Environment["isBrowserDocument"] = Environment.isBrowserDocument;
  Environment["isBrowser"] = Environment.isBrowser;
  Environment["isNodeJS"] = Environment.isNodeJS;
  Environment["isWebWorker"] = Environment.isWebWorker;
  Environment["browserDocumentOrDie"] = Environment.browserDocumentOrDie;
    
  return Environment;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Helpers = /*@__PURE__*/(function() {
  var TRIM_REGEXP = new RegExp("^\\s*([\\s\\S]*?)\\s*$");
  var COMMA = new RegExp(",","g");
  var DOT = new RegExp("\\.","g");
  
  /**
   * This module is a motley collection of simple "shortcut" methods
   * @exports Helpers
   */
  var Helpers = {
      
      /**
       * Shortcut for new Date().getTime();
       * 
       * @returns the current timestamp
       */
      getTimeStamp: function() {
        return new Date().getTime();
      },
      
      /**
       * Shortcut for Math.round( Math.random() * max );
       * @param {Number} [max=1000] The max value to be returned
       * @returns the current timestamp
       */
      randomG: function(max) {
        max = max || 1000;
        return Math.round( Math.random() * max );
      },
      
      /**
       * Trims a string
       * @param {String} str the string to be trimmed
       * @returns {String} the trimmed string
       */
      trim: function(str) {
        return str.replace(TRIM_REGEXP,"$1");
      },
      
      /**
       * Gets a string and interpret it as a Number. The given string may contain dots or commas to separate decimals
       * @param {String} val the string to be converted
       * @param {Boolean} [commaAsDecimalSeparator=false] true to interpret the commas as decimal separators, false to interpret dots as decimal separators
       * @returns {Number} the interpreted number
       * @example
       * Helpers.getNumber("3.432.771,201",true) == 3432771.201
       */
      getNumber: function(val, commaAsDecimalSeparator) {
        if (val) {
          if (!val.replace) {
            return val;
          }
          if (commaAsDecimalSeparator) {
            val = val.replace(DOT, "");
            val = val.replace(COMMA, ".");
          } else {
            val = val.replace(COMMA, "");
          }
          return new Number(val);
        }
        return 0;
      },
      
      /**
       * Shortcut for val.join && typeof(val.join) == "function"
       * @param {Object} val the object to be verified 
       * @returns {Boolean} true if val is an array, false otherwise
       */
      isArray: function(val) {
        return val && val.join && typeof(val.join) == "function";
      },
      
      /**
       * Adds a handler for a browser event. The capture flag is set to false.
       * @param {Object} obj the element to be listened to.
       * @param {String} evnt the event to be listened to.
       * @param {Function} handler the function to be called
       * @returns {Boolean} true if the event was registered, false otherwise.
       * @example 
       * Helpers.addEvent(window, "load", function(){});
       */
      addEvent: function(obj, evnt, handler){ 
        if (!Environment.isBrowserDocument()) {
          return false;
        }
        if (typeof obj.addEventListener != "undefined") {
          obj.addEventListener(evnt, handler, false);
          
        } else if (typeof obj.attachEvent != "undefined") { //old IE
          obj.attachEvent("on" + evnt, handler);
        } 
        return true;
      },
      
      /**
       * Removes a handler for a browser event. 
       * @param {Object} obj the element that is listened to.
       * @param {String} evnt the event that is listened to.
       * @param {Function} handler the function that is called
       * @returns {Boolean} true if the event was removed, false otherwise.
       */
      removeEvent: function(obj, evnt, handler){ 
        if (!Environment.isBrowserDocument()) {
          return false;
        }
        if (typeof obj.removeEventListener != "undefined") {
          obj.removeEventListener(evnt, handler, false);
          
        } else if (typeof obj.detachEvent != "undefined") { //old IE
          obj.detachEvent("on" + evnt, handler);
        } 
        return true;
      } 
  };
  
  Helpers["getTimeStamp"] = Helpers.getTimeStamp;
  Helpers["randomG"] = Helpers.randomG;
  Helpers["trim"] = Helpers.trim;
  Helpers["getNumber"] = Helpers.getNumber;
  Helpers["isArray"] = Helpers.isArray;
  Helpers["addEvent"] = Helpers.addEvent;
  Helpers["removeEvent"] = Helpers.removeEvent;
  
  return Helpers;
})();

var Constants = /*@__PURE__*/(function() {
  var Constants = {

  /**
   * WARNING
   * if the flag is true, change TLCP_VERSION to 2.1.1 instead of 2.1.0
   */
    handleError5: false,
      
    REFRESH_STATUS_INTERVAL: 1000,
    REFRESH_STATUS_INTERVAL_TOLERANCE: 200,
    STOP_SEARCH_TIMEOUT: 10000,
    FRAME_NAME_INDEX: 1,
    TIMESTAMP_INDEX: 0,
    HOST_INDEX: 2,
    BUILD_INDEX: 3,
    PROTOCOL_INDEX: 4,
    BLOB_INDEX: 5,
    NULL_VALUE: "N",
    ALONE_CHECK_TIMEOUT: 200,

    MAIN_CLIENT: "MAIN",

    WORKER_BRIDGE_GLOBAL: "wbridge",
    FRAME_BRIDGE_GLOBAL: "fbridge",

    //channel fail codes
    PROMISE_TIMEOUT: 1,
    PROMISE_FAILURE: 2,


    BUILD: '1808',
    LIBRARY_VERSION: '8.0.7',
    LIBRARY_NAME: 'javascript',
    LIBRARY_TAG: 'javascript_client',
    LS_CID: 'pcYgxn8m8%20feOojyA1U661m3g2.pz47AfEw',
    
    PAGE_PROTOCOL: Environment.isBrowserDocument() && (document.location.protocol == "http:" || document.location.protocol == "https:") ? document.location.protocol : "file:",
      
    STREAM: "lightstreamer.stream",
    PROTOCOL: "lightstreamer.protocol",
    SESSION: "lightstreamer.session",
    REQUESTS: "lightstreamer.requests",
    SUBSCRIPTIONS: "lightstreamer.subscriptions",
    MESSAGES: "lightstreamer.messages",
    ACTIONS: "lightstreamer.actions",
    SHARING: "lightstreamer.sharing",  
    CROSSTAB: "lightstreamer.crosstab",  
    STATS: "lightstreamer.stats",  
    MPN: "lightstreamer.mpn",  
    
    STORAGE_PREFIX: "Lightstreamer_",
      
    LIGHTSTREAMER_PATH: "lightstreamer",
    
    _UNORDERED_MESSAGES: "UNORDERED_MESSAGES",
    
    //unchanged field
    UNCHANGED: {length:-1,toString:function(){return "[UNCHANGED]";}},
    
    // *****from LightstreamerConstants -->
    
    CONNECTING: "CONNECTING",
    // connected prefix
    CONNECTED: "CONNECTED:",
    // create_session response received, trying to setup a streaming connection
    SENSE: "STREAM-SENSING",
    // receiving pushed data
    WS_STREAMING: "WS-STREAMING",
    HTTP_STREAMING: "HTTP-STREAMING",
    // connected but doesn't receive data
    STALLED: "STALLED",
    // polling for data
    WS_POLLING: "WS-POLLING",
    HTTP_POLLING: "HTTP-POLLING",
    // disconnected
    DISCONNECTED: "DISCONNECTED",
    WILL_RETRY: "DISCONNECTED:WILL-RETRY",
    TRYING_RECOVERY: "DISCONNECTED:TRYING-RECOVERY",

    WS_ALL: "WS",
    HTTP_ALL: "HTTP",
    
    RAW: "RAW",
    DISTINCT: "DISTINCT",
    COMMAND: "COMMAND",
    MERGE: "MERGE",

    MASTER: "MASTER",
    
    TLCP_VERSION: "TLCP-2.1.0"
  
  };
    
  return Constants;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var BrowserDetection = /*@__PURE__*/(function() {
  //You'll find strange comments near the methods declarations; We use such comments to keep track of why are we using such browser sniffing 
  
  
 /* 
     stuff we never used or used in the past
   
      var is_icab = (window.ScriptEngine && (ScriptEngine().indexOf("InScript") > -1));
      var is_icab2down = (is_icab && !document.createElement);
      var is_icab3up = (is_icab && document.createElement);
      
      var is_konqueror = (navigator.vendor == "KDE")||(document.childNodes)&&(!document.all)&&(!navigator.taintEnabled);
      var is_safari = (document.childNodes)&&(!document.all)&&(!navigator.taintEnabled)&&(!navigator.accentColorName);
      var is_omniweb45plus = (document.childNodes)&&(!document.all)&&(!navigator.taintEnabled)&&(navigator.accentColorName);
      
      var is_nn6up = (navigator.product == "Gecko");
      var is_nn6 = (navigator.product == "Gecko" && !window.find);
      var is_nn7 = (navigator.product == "Gecko" && window.find);
  */
  //20110909 removed isOldKHTML and isIE5 detections. 
  //20130813 removed isProbablyWinPhone7 detection
  
  //null means "not yet checked", while false means that we are not on such browser; if we're not on a browser at all
  //we can directly set everything to false
  var INIT_VALUE = Environment.isBrowser() ? null : false;

  var LOW_UA = Environment.isBrowser() ? navigator.userAgent.toLowerCase() : null;
  
  function getSolution(myVer,reqVer,less) {
    if(!reqVer || !myVer) {
      return true;
    } else if (less === true) {
      // the given version or less
      return myVer <= reqVer;
    } else if (less === false) {
      //the given version or more 
      return myVer >= reqVer;
    } else {
      //exactly the given version
      return myVer == reqVer;
    }
  }
  
  function doUACheck(checkString) {
    return LOW_UA.indexOf(checkString) > -1;
  }
  
  function getSimpleUACheckFunction(checkString) {
    var resultVar = INIT_VALUE;
    return function() {
      if (resultVar === null) {
        resultVar = doUACheck(checkString);
      }
      return resultVar;
      
    };
  }  
  function getChainedANDFunction(funs) {
    var resultVar = INIT_VALUE;
    return function() {
      if (resultVar === null) {
        resultVar = true;
        for (var i=0; i<funs.length; i++) {
          resultVar = resultVar && funs[i]();
        }
      }
      return resultVar;
    };
  }
  function getChainedORFunction(funs) {
    var resultVar = INIT_VALUE;
    return function() {
      if (resultVar === null) {
        resultVar = false;
        for (var i=0; i<funs.length; i++) {
          resultVar = resultVar || funs[i]();
        }
      }
      return resultVar;
    };
  }
  
  function getVersionedFunction(preCheckFunction,versionExtractionFunction) {
    var isBrowser = INIT_VALUE;
    var browserVersion = INIT_VALUE; 
    return function(requestedVersion,orLowerFlag){
      if (isBrowser === null) {
        isBrowser = preCheckFunction();
        browserVersion = isBrowser ? versionExtractionFunction() : null;
      }
      return isBrowser ? getSolution(browserVersion,requestedVersion,orLowerFlag) : false;
    };
  }
  
  function getExtractVersioByRegexpFunction(regexp) {
    var isBrowser = INIT_VALUE;
    return function() {
      if (isBrowser === null) {
        var res = regexp.exec(LOW_UA);
      
        if (res && res.length >= 2) {
          return res[1];  
        }
      }
      return null;
    };
  }
  
  function getOperaVersion() {
    if (!opera.version) {
      //pre 7.6
      //we do not need to detect Opera 6 so we're cool like this
      return 7;
    } else {
      //> 7.6
      var verStr = opera.version();
      verStr = verStr.replace(new RegExp("[^0-9.]+","g"), "");
      
      return parseInt(verStr);
    }
         //side NOTE: opera 7 mobile does not have opera.postError
  }
  
  function hasOperaGlobal() {
    return typeof opera != "undefined";
  }
    
  function getNotFunction(f) {
    return function() {
      return !f();
    };
  }
  
  
  var khtmlVar = INIT_VALUE;
  
  /**
   * Simple module that can be used to try to detect the browser in use.If possible the use of this module should be avoided:
   * it should only be used if the behavior can't be guessed using feature detection. The module does not contain an extensive list
   * of browsers, new method were added only when needed in the Lightstreamer JavaScript Client library. 
   * <br/>There are two kinds of methods, one does simply recognize the browsers, the other can also discern the browser version.
   * As most of the methods are based on User Agent inspections all the method names contain the "probably" word to recall their
   * intrinsic weakness.
   * @exports BrowserDetection
   */
  var BrowserDetection = {
      /**
       * Check if the browser in use is probably a rekonq or not
       * @method
       * @return {Boolean} true if probably a rekonq, false if probably not.
       */
      isProbablyRekonq: getSimpleUACheckFunction("rekonq"),  //used by isProbablyApple thus "spin fix"
      /**
       * Check if the browser in use is probably a WebKit based browser or not
       * @method
       * @return {Boolean} true if probably a WebKit based browser, false if probably not.
       */
      isProbablyAWebkit: getSimpleUACheckFunction("webkit"),//iframe generation
      /**
       * Check if the browser in use is probably a Playstation 3 browser or not
       * @method
       * @return {Boolean} true if probably a Playstation 3 browser, false if probably not.
       */
      isProbablyPlaystation: getSimpleUACheckFunction("playstation 3"),  //expected streaming behavior
      /**
       * Check if the browser in use is probably a Chrome (or Chrome tab)  or not. A specific version or version range can be requested.
       * @method
       * @param {Number=} requestedVersion The version to be checked. If not specified any version will do.
       * @param {Boolean=} orLowerFlag true to check versions up to the specified one, false to check for greater versions; the specified version
       * is always included. If missing only the specified version is considered.
       * @return {Boolean} true if the browser is probably the correct one, false if probably not.
       */
      isProbablyChrome: getVersionedFunction( 
                                                  getSimpleUACheckFunction("chrome/"),
                                                  getExtractVersioByRegexpFunction(new RegExp("chrome/([0-9]+)","g"))
                                                  ),  // iframe content generation / used by isProbablyApple / used by isProbablyAndroid / windows communication
      /**
       * Check if the browser in use is probably a KHTML browser or not
       * @method
       * @return {Boolean} true if probably a KHTML browser, false if probably not.
       */
      isProbablyAKhtml: function() {
        if (khtmlVar === null) {
          khtmlVar = (document.childNodes) && (!document.all) && (!navigator.taintEnabled) && (!navigator.accentColorName);
        }
        return khtmlVar;
      }, //hourglass trick
      /**
       * Check if the browser in use is probably a Konqueror or not. A specific version or version range can be requested.
       * @method
       * @param {Number=} requestedVersion The version to be checked. If not specified any version will do.
       * @param {Boolean=} orLowerFlag true to check versions up to the specified one, false to check for greater versions; the specified version
       * is always included. If missing only the specified version is considered.
       * @return {Boolean} true if the browser is probably the correct one, false if probably not.
       */
      isProbablyKonqueror: getVersionedFunction( 
                                                  getSimpleUACheckFunction("konqueror"),
                                                  getExtractVersioByRegexpFunction(new RegExp("konqueror/([0-9.]+)","g"))
                                                  ),  //iframe communications / iframe content generation
      /**
       * Check if the browser in use is probably an Internet Explorer or not. A specific version or version range can be requested.
       * @method
       * @param {Number=} requestedVersion The version to be checked. If not specified any version will do.
       * @param {Boolean=} orLowerFlag true to check versions up to the specified one, false to check for greater versions; the specified version
       * is always included. If missing only the specified version is considered.
       * @return {Boolean} true if the browser is probably the correct one, false if probably not.
       */                                                 
      isProbablyIE: function(requestedVersion,orLowerFlag){
        if (
                getVersionedFunction(
                        getSimpleUACheckFunction("msie"), 
                        getExtractVersioByRegexpFunction(new RegExp("msie\\s"+"("+"[0-9]+"+")"+"[.;]","g"))
                )(requestedVersion,orLowerFlag)
                ||
                getVersionedFunction(
                        getSimpleUACheckFunction("rv:11.0"),
                        function() { return "11"; }
                )(requestedVersion,orLowerFlag)
                ) {
          return true;
        } else {
          return false;
        }
      },  //color name resolution / eval isolation / hourglass trick / expected streaming behavior / iframe communication / iframe domain handling / iframe creation
      /**
       * Check if the browser in use is probably an Internet Explorer 11 or not.
       * @method
       * @return {Boolean} true if the browser is probably the correct one, false if probably not.
       */                                                 
      isProbablyEdge: getSimpleUACheckFunction("edge"), // expected streaming behavior
      /**
       * Check if the browser in use is probably a Firefox or not. A specific version or version range can be requested.
       * @method
       * @param {Number=} requestedVersion The version to be checked. If not specified any version will do.
       * @param {Boolean=} orLowerFlag true to check versions up to the specified one, false to check for greater versions; the specified version
       * is always included. If missing only the specified version is considered.
       * @return {Boolean} true if the browser is probably the correct one, false if probably not.
       */  
      isProbablyFX: getVersionedFunction(
                                         getSimpleUACheckFunction("firefox"),
                                         getExtractVersioByRegexpFunction(new RegExp("firefox\\/(\\d+\\.?\\d*)"))
                                         ), //mad check
      /**
       * Check if the browser in use is probably an old Opera (i.e.: up to the WebKit switch) or not. A specific version or version range can be requested.
       * @method
       * @param {Number=} requestedVersion The version to be checked. If not specified any version will do.
       * @param {Boolean=} orLowerFlag true to check versions up to the specified one, false to check for greater versions; the specified version
       * is always included. If missing only the specified version is considered.
       * @return {Boolean} true if the browser is probably the correct one, false if probably not.
       */                                          
      isProbablyOldOpera: getVersionedFunction(hasOperaGlobal,getOperaVersion) //autoscroll / expected streaming behavior / windows communication / onload expectations / iframe communications / iframe content generation / iframe generation
  };
  
  /**
   * Check if the browser in use is probably an Android stock browser or not
   * @method
   * @return {Boolean} true if probably an Android stock browser, false if probably not.
   */
  BrowserDetection.isProbablyAndroidBrowser = getChainedANDFunction([
                                                       getSimpleUACheckFunction("android"),
                                                       BrowserDetection.isProbablyAWebkit,
                                                       getNotFunction(BrowserDetection.isProbablyChrome)
                                                       ]);//spin fix / connection behavior handling
   /**
    * Check if the browser in use is probably an Opera Mobile or not
    * @method
    * @return {Boolean} true if probably a an Opera Mobile, false if probably not.
    */
   BrowserDetection.isProbablyOperaMobile = getChainedANDFunction([
                                                    BrowserDetection.isProbablyOldOpera,
                                                    getSimpleUACheckFunction("opera mobi")
                                                    ]); //expected test results
     
    /**
     * Check if the browser in use is probably an Apple Browser (i.e. Safari or Safari Mobile) or not. A specific version or version range can be requested.
     * @method
     * @param {Number=} requestedVersion The version to be checked. If not specified any version will do.
     * @param {Boolean=} orLowerFlag true to check versions up to the specified one, false to check for greater versions; the specified version
     * is always included. If missing only the specified version is considered.
     * @return {Boolean} true if the browser is probably the correct one, false if probably not.
     */ 
    BrowserDetection.isProbablyApple = getVersionedFunction( 
                                        getChainedANDFunction([ // safari + (ipad || iphone || ipod || (!android+!chrome+!rekonq))
                                            getSimpleUACheckFunction("safari"),
                                            getChainedORFunction([
                                                                  getSimpleUACheckFunction("ipad"),
                                                                  getSimpleUACheckFunction("iphone"),
                                                                  getSimpleUACheckFunction("ipod"),
                                                                  getChainedANDFunction([
                                                                                         getNotFunction(BrowserDetection.isProbablyAndroidBrowser),
                                                                                         getNotFunction(BrowserDetection.isProbablyChrome),
                                                                                         getNotFunction(BrowserDetection.isProbablyRekonq)])
                                                                  ])
                                            ]),
                                            getExtractVersioByRegexpFunction(new RegExp("version\\/(\\d+\\.?\\d*)"))
                                          ); //spin fix / windows communication
  
  BrowserDetection["isProbablyRekonq"] = BrowserDetection.isProbablyRekonq;
  BrowserDetection["isProbablyChrome"] = BrowserDetection.isProbablyChrome;
  BrowserDetection["isProbablyAWebkit"] = BrowserDetection.isProbablyAWebkit;
  BrowserDetection["isProbablyPlaystation"] = BrowserDetection.isProbablyPlaystation;
  BrowserDetection["isProbablyAndroidBrowser"] = BrowserDetection.isProbablyAndroidBrowser;
  BrowserDetection["isProbablyOperaMobile"] = BrowserDetection.isProbablyOperaMobile;
  BrowserDetection["isProbablyApple"] = BrowserDetection.isProbablyApple;
  BrowserDetection["isProbablyAKhtml"] = BrowserDetection.isProbablyAKhtml;
  BrowserDetection["isProbablyKonqueror"] = BrowserDetection.isProbablyKonqueror;
  BrowserDetection["isProbablyIE"] = BrowserDetection.isProbablyIE;
  BrowserDetection["isProbablyEdge"] = BrowserDetection.isProbablyEdge;
  BrowserDetection["isProbablyFX"] = BrowserDetection.isProbablyFX;
  BrowserDetection["isProbablyOldOpera"] = BrowserDetection.isProbablyOldOpera;
  return BrowserDetection;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var List = /*@__PURE__*/(function() {  
  /**
   * Creates an empty List instance
   * @constructor
   *
   * @exports List
   * @class Very simple Array-backed List implementation.<br/>
   * It is discouraged the use of this class to handle big lists. 
   */
  var List = function() {
    this.data = [];
  };
  
  List.prototype = {
      
    /**
     * Adds the element to the end of the list (using Array.push).
     * Each element can be added multiple times; in such case it will be added to the list multiple times
     * 
     * @param {Object} newEl The element to be added
     */
    add: function(newEl) {
      this.data.push(newEl);
    },
    
    /**
     * Removes the first occurrence of the specified object in the List.<br/>
     * A linear search is performed to find the element; a non-strict comparison ( == )
     * is performed to identify the element. 
     * 
     * @param {Object} newEl The element to be removed
     * 
     * @returns {Boolean} true if element was found and deleted, false otherwise
     */
    remove: function(remEl) {
      var i = this.find(remEl);
      if (i < 0) {
        return false;
      }
      this.data.splice(i,1);
      return true;
    },

    /**
     * Checks if an element is in the list
     *
     * @param {Object} el the element to be searched
     *
     * @returns {Boolean} true if element was found, false otherwise
     */
    contains: function(el) {
      return this.find(el) >= 0;
    },

    /**
     * @private
     */
    find: function(el) {
      for (var i=0; i<this.data.length; i++) {
        if (this.data[i] === el) {
          return i;
        }
      }
      return -1;
    },
    
    /**
     * Executes a given callback passing each element of the list as the only
     * call parameter.<br/>  
     * Callbacks are executed synchronously before the method returns: calling 
     * {@link List#add} or {@link List#remove} during callback execution may result in
     * a wrong iteration.
     * 
     * @param {Function} cb The callback to be called.
     */
    forEach: function(cb) {
      for (var i=0; i<this.data.length; i++) {
        cb(this.data[i]);
      }
    },
    
    /**
     * Returns a copy of the internal array.
     * 
     * @returns {Array} A copy of the original array.
     */
    asArray: function() {
      return [].concat(this.data);
    },
    
    /**
     * Resets the list by re-instantiating the internal array.
     */
    clean: function() {
      this.data = [];
    }
    
  };
  
  //exports
  List.prototype["add"] = List.prototype.add;
  List.prototype["remove"] = List.prototype.remove;
  List.prototype["forEach"] = List.prototype.forEach;
  List.prototype["asArray"] = List.prototype.asArray;
  List.prototype["clean"] = List.prototype.clean;
  
  
  return List;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var EnvironmentStatus = /*@__PURE__*/(function() {
  //do not use EventDispatcher/Executor to avoid circular dependencies hell
    
  var onunloadFunctions = new List();
  var onloadFunctions = new List();  
  var onbeforeunloadFunctions = new List();
  var controlLoadTimeout = 1000;
  
  var isDOMLoaded = false;
  
  //closure compiler trick -->
  var names = {
    onloadDone : "onloadDone",
    onloadInprogress : "onloadInprogress",
    unloaded : "unloaded",
    unloading : "unloading",
    preunloading : "preunloading"
  };
  var reverse = {};
  for (var i in names) {
    reverse[names[i]] = i;
  }
  //<-- closure compiler trick
 
  
  function getOnloadClosure(that) {
    return getEventClosure(that,reverse['onloadDone'],reverse['onloadInprogress'],onloadFunctions,'onloadEvent');
  }
  
  function getUnloadClosure(that) {
    return getEventClosure(that,reverse['unloaded'],reverse['unloading'],onunloadFunctions,'unloadEvent');
  }
  
  function getBeforeUnloadClosure(that) {
    return getEventClosure(that,reverse['preunloading'],reverse['preunloading'],onbeforeunloadFunctions,'preUnloadEvent');
  }
  
  
  function getEventClosure(that,toCheck,toSet,toExe,methodName) {
    return function() {
      if (that[toCheck]) {
        return;
      }
      that[toSet] = true;
      
      toExe.forEach(function(elToExe) {
        try {
          singleEventExecution(elToExe,methodName);
        } catch (_e) {
        }
      });
      
      if (toCheck != 'preunloading') {
        toExe.clean();
      }

      that[toCheck] = true;
      that[toSet] = false;
    };
    
  }
  
  function singleEventExecution(elToExe,methodName) {
    if (elToExe[methodName]) {
      elToExe[methodName]();
    } else {
      elToExe();
    }
  }
  
  function asynchSingleEventExecution(elToExe,methodName) { 
    setTimeout(function() {
      singleEventExecution(elToExe,methodName);
    },0);
  }
  
  function executeLater(what,when,who,how) { 
    setTimeout(function() {
      if (who) {
        if (how) {
          what.apply(who,how);
        } else {
          what.apply(who);
        }
      } else if (how) {
        what.apply(null, how);
      } else {
        what();
      }
    },when);
  }
  
  function DOMloaded() {
    isDOMLoaded = true; //no need to initialize it anywhere
  }
    
  /**
   * Tries to track the loading status of the page. It may fallback to using timeouts or DOMContentLoaded events to address browser compatibilities: in such
   * cases there is a chance that the registered onload handlers are fired before the actual onload is. Also unload and beforeunload may not fire at all.
   * @exports EnvironmentStatus
   */
  var EnvironmentStatus = {
    /**
     * @private
     */
    onloadDone: false,
    /**
     * @private
     */
    onloadInprogress: false,
    /**
     * @private
     */
    unloaded: false,
    /**
     * @private
     */
    unloading: false,
    /**
     * @private
     */
    preunloading: false,
    
    /**
     * Checks if the load event has been fired.
     * @returns {Boolean} true if the load event has already been fired, false otherwise.
     */
    isLoaded: function() {
      return this.onloadDone;
    },
    /**
     * Checks if the unload event has been fired.
     * @returns {Boolean} true if the unload event has already been fired, false otherwise.
     */
    isUnloaded : function() {
      return this.unloaded;
    },
    /**
     * Checks if the unload event is currently being handled.
     * @returns {Boolean} true if the unload event is currently being handled, false otherwise.
     */
    isUnloading: function() {
      return this.unloading;
    },
    
    /**
     * Adds a handler for the load event. If the event was already fired the handler is sent in a setTimeout (with a 0 timeout).
     * @param {Function|EnvironmentStatusListener} the function to be executed or an object containing the onloadEvent function to be executed. 
     */
    addOnloadHandler: function(f) {
      if (this.isPreOnload()) {
        onloadFunctions.add(f);
      } else {
        asynchSingleEventExecution(f,'onloadEvent');
      }
    },
    
    /**
     * Adds a handler for the unload event. If the event was already fired the handler is sent in a setTimeout (with a 0 timeout).
     * @param {Function|EnvironmentStatusListener} the function to be executed or an object containing the unloadEvent function to be executed. 
     */
    addUnloadHandler: function(f) {
      if (this.isPreUnload()) {
        onunloadFunctions.add(f);
      } else {
        asynchSingleEventExecution(f,'unloadEvent');
      }
    },
    
    /**
     * Adds a handler for the onbeforeunload event.
     * @param {Function|EnvironmentStatusListener} the function to be executed or an object containing the preUnloadEvent function to be executed. 
     */
    addBeforeUnloadHandler: function(f) {
      onbeforeunloadFunctions.add(f);
      if (this.preunloading) {
        asynchSingleEventExecution(f,'preUnloadEvent');
      }
    },
    
    /**
     * Removes the specified load handler if present, otherwise it does nothing. 
     * @param {Function|EnvironmentStatusListener} the function or object to be removed
     */
    removeOnloadHandler: function(f) {
      onloadFunctions.remove(f);
    },
    
    /**
     * Removes the specified unload handler if present, otherwise it does nothing. 
     * @param {Function|EnvironmentStatusListener} the function or object to be removed
     */
    removeUnloadHandler: function(f) {
      onunloadFunctions.remove(f);
    },
    
    /**
     * Removes the specified onbeforeunload handler if present, otherwise it does nothing. 
     * @param {Function|EnvironmentStatusListener} the function or object to be removed.
     */
    removeBeforeUnloadHandler: function(f) {
      onbeforeunloadFunctions.remove(f);
    },
    
    /**
     * @private
     */
    isPreOnload: function() {
      return !(this.onloadDone || this.onloadInprogress);
    },
    
    /**
     * @private
     */
    isPreUnload: function() {
      return !(this.unloaded || this.unloading);
    },
  
    /**
     * @private
     */
    attachToWindow: function() {
      Helpers.addEvent(window,"unload",this.closeFun);
      Helpers.addEvent(window,"beforeunload",this.beforeCloseFun);
      
      //EXPERIMENTAL
      if (document && typeof document.readyState != "undefined") {
        var strState = document.readyState;
        if (strState.toUpperCase() == "COMPLETE") {
          //already loaded
          this.asynchExecution();
          return;
        } else {
          //It may happen that readyState is not "completed" but the onload
          //was already fired. We fire a timeout to check the case
          executeLater(this.controlReadyStateLoad,controlLoadTimeout,this);
        }
      } else if(this.isInBody()) {
        //already loaded
        this.asynchExecution();
        return;
      }
      //EXPERIMENTAL end
      

      var done = Helpers.addEvent(window,"load",this.readyFun);
      if (!done) {
        //Can't append an event listener to the onload event (webworker / nodejs)
        //Let's launch a timeout 
        this.asynchExecution(); //should not happen since we did the check on the module setup, why did we keep it?
      } else if (BrowserDetection.isProbablyOldOpera()) {
        //Old Opera did not fire the onload event on a page wrapped
        //in an iFrame if a brother iFrame is still loading (in the
        //worst case the second iFrame is a forever-frame)
        //To prevent the case we will fire a fake onload
       
        
        var checkDOM = false;
        //on Opera < 9 DOMContentLoaded does not exist, so we can't wait for it
        if (BrowserDetection.isProbablyOldOpera(9, false)) {
          checkDOM = true;
          //DOMContentLoaded did not fire yet or we should have not reach this point 
          //as per the readyState/isInBody checks
          Helpers.addEvent(document,"DOMContentLoaded",DOMloaded);
        } 
        executeLater(this.controlOperaLoad,controlLoadTimeout,this,[checkDOM]);
        
      }
    },
    
    /**
     * @private
     */
    asynchExecution: function() {
      executeLater(this.readyFun,0);
    },
    
    /**
     * @private
     */
    controlReadyStateLoad: function() {
      if (!this.onloadDone) {
        //onload not yet fired
        var strState = document.readyState;
        if (strState.toUpperCase() == "COMPLETE") {
          this.readyFun();
        } else {
          executeLater(this.controlReadyStateLoad,controlLoadTimeout,this);
        }
      }
    },
    
    /**
     * @private
     */
    controlOperaLoad: function(checkDOM) {
      if (!this.onloadDone) {
        //onload not yet fired
        if (isDOMLoaded || !checkDOM && this.isInBody()) {
          //DOM is there
          //let's fake the onload event
          this.readyFun(); 
        } else {
          //body is still missing
          executeLater(this.controlOperaLoad,controlLoadTimeout,this,[checkDOM]);
        }
      }
    },
    
    /**
     * @private
     */
    isInBody: function() {
      return (typeof document.getElementsByTagName != "undefined" && typeof document.getElementById != "undefined" && ( document.getElementsByTagName("body")[0] != null || document.body != null ) );
    }
    
  };
  
  
  EnvironmentStatus.readyFun = getOnloadClosure(EnvironmentStatus);
  EnvironmentStatus.closeFun = getUnloadClosure(EnvironmentStatus);
  EnvironmentStatus.beforeCloseFun = getBeforeUnloadClosure(EnvironmentStatus);
  if (Environment.isBrowserDocument()) {
    EnvironmentStatus.attachToWindow();
  } else {
    EnvironmentStatus.asynchExecution();
  }
  
  
  
  EnvironmentStatus["addOnloadHandler"] = EnvironmentStatus.addOnloadHandler;
  EnvironmentStatus["addUnloadHandler"] = EnvironmentStatus.addUnloadHandler;
  EnvironmentStatus["addBeforeUnloadHandler"] = EnvironmentStatus.addBeforeUnloadHandler;
  EnvironmentStatus["removeOnloadHandler"] = EnvironmentStatus.removeOnloadHandler;
  EnvironmentStatus["removeUnloadHandler"] = EnvironmentStatus.removeUnloadHandler;
  EnvironmentStatus["removeBeforeUnloadHandler"] = EnvironmentStatus.removeBeforeUnloadHandler;
  EnvironmentStatus["isLoaded"] = EnvironmentStatus.isLoaded;
  EnvironmentStatus["isUnloaded"] = EnvironmentStatus.isUnloaded;
  EnvironmentStatus["isUnloading"] = EnvironmentStatus.isUnloading;
  
  return EnvironmentStatus;
})();

var ls = "Lightstreamer";
  
  var Lightstreamer = {
    wstatus: EnvironmentStatus,
    
    
    toString: function() {
      return "["+ls+" "+this["library"]+" client version "+this["version"]+" build " +this["build"]+"]";
    },
   
    exportGlobal: function(exportId,exportName,exportVal,prefix) {
      prefix = prefix || "_";
      
      var gName = prefix+exportId;
      if (!this[gName]) {
        this[gName] = {};
      }
      this[gName][exportName] = exportVal;
      
      return ls+"."+gName+"."+exportName;
    },
    
    hasGlobal: function(exportId,exportName,prefix) {
      prefix = prefix || "_";
      var gName = prefix+exportId;
      return this[gName] && this[gName][exportName];
    },

    getGlobal: function(exportId,exportName,prefix) {
      prefix = prefix || "_";
      var gName = prefix+exportId;
      if (this[gName]) {
        return this[gName][exportName];
      }
      return null;
    },
    
    cleanGlobal: function(exportId,cleanName,prefix) {
      prefix = prefix || "_";
      
      var gName = prefix+exportId;
      if (this[gName] && this[gName][cleanName]) {
        delete(this[gName][cleanName]);
        
        for (var inThere in this[gName]) {
          return;
        }
        delete(this[gName]);
        
      }
    },
    
    cleanAllGlobals: function(exportId,prefix) {
      prefix = prefix || "_";
      
      var gName = prefix+exportId;
      if (this[gName]) {
        delete(this[gName]);
      }
    },
    
    //ExtIframe exports "EQCallback_"+frameName (QXXX) [OK]
      //nobody cleans...
    
    //SessionHandler exports LS_forceReload (_XXX) [OK]
      //cleaned by LightstreamerEngine.suicide
    
    //PushEvents exports: 
      //LS_e (_XXX) [OK]
      //LS_t (_XXX) [OK]
      //LS_u (_XXX) [OK]
      //LS_v (_XXX) [OK]
      //LS_o (_XXX) [OK]
      //LS_n (_XXX) [OK]
      //LS_s (_XXX) [OK]
      //LS_l (_XXX) [OK]
      //LS_w (_XXX) [OK]
        //cleaned by LightstreamerEngine.suicide
  
    //LightstreamerEngine exports lsEngine on its bind call (_XXX) [OK]
      //cleans all _XXX on its suicide call
    
    //AjaxFrame exports LS_a on its attachGlobal call (AXXX) [OK}
      //nobody cleans...
  
    //PushPage exports lsPage on its changeStatusPhase call (PXXX) [OK]
      //cleans PXXX.lsPage on its changeStatusPhase call 
      
    localSharedEngines: {},
    addSharableEngine: function(name,lsEngine) {
      var sharedEngines = this.localSharedEngines;

      if (!sharedEngines[name]) {
        sharedEngines[name] = [];
      }
      sharedEngines[name].push(lsEngine);
    },
    removeSharableEngine: function(name,lsEngine) {
      var sharedEngines = this.localSharedEngines[name];
      
      if (sharedEngines) {
        for (var i = 0; i < sharedEngines.length; i++) {
          if(sharedEngines[i] == lsEngine) {
            sharedEngines.splice(i,1);
          }
        }
        if (sharedEngines.length == 0) {
          delete(sharedEngines[name]);
        }
      }
    },
    
    getSharableEngine: function(engineName) {
      if (this.localSharedEngines[engineName]) {
        var sharedEngines = this.localSharedEngines[engineName];
        if (sharedEngines && sharedEngines.length > 0) {
          //we grab the first one 
          return sharedEngines[0];
        }
      }
      return null;
    }
    
    
    
  };
  
  //OpenAjax
  if (Environment.isBrowserDocument()) {
    if (window.OpenAjax && window.OpenAjax.hub) {
        window.OpenAjax.hub.registerLibrary(ls, "http://www.lightstreamer.com/", Lightstreamer.version);
    }

    //create the global object
    window["Lightstreamer"] = Lightstreamer;
  }


  Lightstreamer["library"] = Constants.LIBRARY_NAME;
  Lightstreamer["version"] = Constants.LIBRARY_VERSION;
  Lightstreamer["build"] = Constants.BUILD;

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Executor = /*@__PURE__*/(function() {
    var step = 50;
    var newStuffFlag = false;
    var toBeExecuted = [];
    var now = Helpers.getTimeStamp();
    var RESET_TIME = 3*60*60*1000; //3 hours
    var resetAt = now+RESET_TIME; //workaround for Safari 5 windows: after several hours the toBeExecuted array becomes unusable (OOM)
    var toBeRepeated = [];
    var timer = null;
    var nextId = 0;
    //var goodWakeups = 0;
    
    function sortFun(a,b) {
      if (a.time === b.time) {
        return a.orderId - b.orderId;
      }
      return a.time-b.time;
    }
    
    //TICK handling stuff
    var origin = Environment.isBrowserDocument() && (document.location.protocol == "http:" || document.location.protocol == "https:") ? (document.location.protocol+"//"+document.location.hostname+(document.location.port?":"+document.location.port:"")) : "*";
    var DEFAULT_GENERATE_TICK = function() { /*setTimeout(doTick,0); */ };
    var generateTickExecution = DEFAULT_GENERATE_TICK;
    var pendingGeneratedTick = false;
    function doTick() {
      pendingGeneratedTick = false;
      execute();
    }
    //we need to call this for urgent task as on FX5 and CH11 setInterval/setTimeout calls 
    //are made 1 per second on background pages (and our 50ms tick is based on a setInterval) 
    function generateTick() {
      if (!pendingGeneratedTick) {
        pendingGeneratedTick = true;
        generateTickExecution();
      }
    }
    
    
    function doInit() {
      if (!timer) {
        //set up the method to generate the tick
        //  on recent browsers we send a post message and trigger the doTick when we receive such message
        if (Environment.isBrowserDocument() && typeof postMessage != "undefined") {
          generateTickExecution = function() {
              try {
                  window.postMessage("Lightstreamer.run",origin);                    
              } catch (e) {
                  // sometimes on IE postMessage fails mysteriously but, if repeated, works
                  try {
                      window.postMessage("Lightstreamer.run",origin);
                  } catch (e) {
                      // await next tick (at most 50ms on foreground page and 1s in background pages)
                  }
              }
          };
          
          var postMessageHandler = function(event){
            if (event.data == "Lightstreamer.run" && origin == "*" || event.origin == origin) {
              doTick();
            }
          };
          Helpers.addEvent(window,"message", postMessageHandler);
          
          ///verify if postMessage can be used 
          generateTick();
          if (pendingGeneratedTick == false) {
            //post message can't be used, rollback
            Helpers.removeEvent(window,"message", postMessageHandler);
            generateTickExecution =  DEFAULT_GENERATE_TICK;
          }
          
        } else if (Environment.isNodeJS() && typeof process != "undefined" && process.nextTick) {
          //  on node versions having the nextTick method we rely on that
          generateTickExecution  = function() {
            process.nextTick(doTick);
          };
          
        } //  other cases will use the default implementation that's currently empty
        
      } else {
        clearInterval(timer);
      }
      
      //for "normal" tasks we use an interval
      timer = setInterval(execute,step);
    }
    
    
    //main execution method, the core of the Executor
    function execute() {
      if (EnvironmentStatus.unloaded) {
        clearInterval(timer);
        return;
      }
      
      var last = now;
      now = Helpers.getTimeStamp();
      if (now < last) {
        // not to be expected, but let's protect from this, because, otherwise,
        // the order of the events might not be respected
        now = last;
      }
      //adjustTimer(last, now);
      
      if (toBeExecuted.length > 0) {
        if (newStuffFlag) {
          toBeExecuted.sort(sortFun);
          newStuffFlag = false;
        } //no new tasks = no need to sort
        
        var exeNow;
        while (toBeExecuted.length > 0 && toBeExecuted[0].time <= now && !EnvironmentStatus.unloaded) {
          exeNow = toBeExecuted.shift();
          if (exeNow.fun) {
            Executor.executeTask(exeNow);
            
            //prepare to re-enqueue repetetive tasks
            if (exeNow.step) {  
              toBeRepeated.push(exeNow);
            }
          } 
        }
      } 

      if (toBeExecuted.length <= 0) { //if queue is empty reset the index
        nextId = 0;
      }
      
      // re-enqueue repetetive tasks 
      var t;
      while(toBeRepeated.length > 0) {
        t = toBeRepeated.shift();
        if (t.step) { //a task might have called stopRepetitiveTask on this task
          t.orderId = nextId++;
          Executor.addPackedTimedTask(t,t.step,true);
        }
      }
      
      if (now >= resetAt) {
        resetAt = now+RESET_TIME;
        toBeExecuted = [].concat(toBeExecuted);
      }
    }

    /**
     * An Executor based on a single setInterval that is triggered every 50ms to dequeue expired tasks.
     * When 0ms tasks are enqueued a postMessage call is used to trigger an immediate execution; on nodejs
     * the process.nextTick method is used in place of the postMessage; on older browser where postMessage
     * is not supported no action is taken.
     * 
     * @exports Executor
     * @extends module:ExecutorInterface
     */
    var Executor = {  
      
      toString: function() {
        return ["[","Executor",step,toBeExecuted.length,/*this.goodWakeups,*/"]"].join("|");
      },
     
    
      getQueueLength: function() {
        return toBeExecuted.length;
      },
      
      packTask: function(fun,context,params) {
        return {fun:fun,context:context||null,params:params||null,orderId:nextId++};
      },
      
      addPackedTimedTask: function(task,time,repetitive) {
        task.step = repetitive ? time : null;
        task.time = now + parseInt(time);
        // WARNING: "now" has not been refreshed;
        // hence, with this implementation, the order of the events is guaranteed
        // only when "time" is the same (or growing);
        // we assume that sequences of tasks to be kept ordered will have a the same "time"
        
        if (isNaN(task.time)) {
          try {
            throw new Error();
          } catch(e) {
            var err = "Executor error for time: " + time;
            if (e.stack) {
              err+= " " +e.stack;
            }
            throw err;
          }
        }
        toBeExecuted.push(task);
        newStuffFlag = true;
      },
      
      addRepetitiveTask: function(fun,interval,context,params) {
        return this.addTimedTask(fun,interval,context,params,true);
      },

      stopRepetitiveTask: function(task) {
        if (!task) {
          return;
        }
        task.fun = null;
        task.step = null;
      },

      addTimedTask: function(fun,time,context,params,repetitive) {
        var task = this.packTask(fun,context,params);
        this.addPackedTimedTask(task,time,repetitive);
        if (time == 0) {
          generateTick();
        }
        return task;
      },
      
      modifyTaskParam: function(task,index,newParam) {
        task.params[index] = newParam;
      },
      
      modifyAllTaskParams: function(task,extParams) {
        task.params = extParams;
      },
      
      delayTask: function(task,delay) {
        task.time += delay;
        newStuffFlag = true;
      },
      
      executeTask: function(task,extParams) {
        try {

            //IE doesn't like the simple form when useParams is null:
            //task.fun.apply(task.context, task.params);
            //if we leave the above code instead of using the below code, we fall into IE weird problem, where
            //the execution fails in exception, task.fun results not null nor undefined, but if we try to print it 
            //(toString) or call it results as undefined (exception "Object expected").
          
          var useParams = extParams || task.params;
          
          if (task.context) {
            if (useParams) {
              task.fun.apply(task.context, useParams);
            } else {
              task.fun.apply(task.context);
            }
          } else if (useParams) {
            task.fun.apply(null, useParams);
          } else {
            task.fun();
          }
          
        } catch (_e) {
          var sendName = null;
          try {
            sendName = task.fun.name || task.fun.toString();
          } catch(_x) {
          }
          //TODO report sendName
        } 
        
      }
      
   };
   
   if (Environment.isWebWorker()) {
     //we need this workaround otherwise on firefox 10 the Executor may not run as expected.
     //I wasn't able to create a simple test case as it seems that the number of classes involved
     //and the loading order have an impact on the issue (so that it is possible that once built the
     //issue will not be there)
     //I don't want to include BrowserDetection here so that I apply the workaround on all browsers
     setTimeout(doInit,1);
     
     //other possible workarounds (referring to the failing test)
     //that make the Executor run correctly:
     // *do not include Subscription
     // *do not include the descriptor classes (inside the library code)
     // *set the step value to a higher value (75 and 100 are suggested values that seem to work)
     
   } else {
     doInit();
   }
   
   Executor["getQueueLength"] = Executor.getQueueLength;
   Executor["packTask"] = Executor.packTask;
   Executor["addPackedTimedTask"] = Executor.addPackedTimedTask;
   Executor["addRepetitiveTask"] = Executor.addRepetitiveTask;
   Executor["stopRepetitiveTask"] = Executor.stopRepetitiveTask;
   Executor["addTimedTask"] = Executor.addTimedTask;
   Executor["modifyTaskParam"] = Executor.modifyTaskParam;
   Executor["modifyAllTaskParams"] = Executor.modifyAllTaskParams;
   Executor["delayTask"] = Executor.delayTask;
   Executor["executeTask"] = Executor.executeTask;
   
   return Executor;
})();

   
 
 
/*
      function adjustTimer(last, now) {
        var diff = now - last;
        
        if (diff <= step) {
          goodWakeups++;
        } else {
          goodWakeups--;
        }
        
        if (goodWakeups >= 10) {
          changeStep(step+1);
          goodWakeups = 0;
        } else if (goodWakeups < 0) {
          if (step >= 2) {
            changeStep(Math.round(step / 2));
            goodWakeups = 0;
          } else {
            goodWakeups = 0;
          }
        }
      }
      
      function changeStep (newStep) {
        step = newStep;
        doInit();
      }
*/

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var LoggerProxy = /*@__PURE__*/(function() {
  //used as default is*Enabled spares arguments handling
  var emptyFun = function() {
    return false;
  };
  
  //implements Logger :)
  var placeholder = {
      "error":emptyFun,
      "warn":emptyFun,
      "info":emptyFun,
      "debug":emptyFun,
      "fatal":emptyFun,
      "isDebugEnabled":emptyFun,
      "isInfoEnabled":emptyFun,
      "isWarnEnabled":emptyFun,
      "isErrorEnabled":emptyFun,
      "isFatalEnabled":emptyFun
  };
  
  
  /**
   * This constructor is used internally by {@link module:LoggerManager} and should not
   * be called manually. Use {@link module:LoggerManager.getLoggerProxy} to obtain a 
   * LoggerProxy instance.
   * @constructor
   * 
   * @exports LoggerProxy
   * 
   * @class Offers a simple proxy to {@link Logger} instances. The proxied instance can be
   * switched at any time with a different one.
   * <br>Other than the proxied methods it offers some utility methods that will join
   * together all of the specified parameters in a single string before passing it to
   * the proxied instance. 
   */
  var LoggerProxy = function(toWrap) {//called simply Log on the original .NET implementation
    this.setWrappedInstance(toWrap);
  };

  LoggerProxy.prototype = {
       
      /**
       * Called by LoggerManager to redirect the log to a different Logger
       * @param {Logger} [toWrap]
       */
      setWrappedInstance: function(toWrap) {
        this.wrappedLogger = toWrap || placeholder;
      },
      
      //fatal
      
      /**
       * Joins all the specified parameters and calls {@link Logger#fatal} on
       * the proxied instance.
       * @param {...*} mex The string or object to be logged. 
       */
      logFatal: function(mex) {
        if (!this.isFatalLogEnabled()) {
          return;
        }
        mex += this.logArguments(arguments,1);
        this.fatal(mex);
      },

      /**
       * Proxies the call to the underling {@link Logger}
       * 
       * @param {String} message The message to be logged.  
       * @param {Error} [exception] An Exception instance related to the current log message.
       */
      fatal: function(mex,exc) {
        this.wrappedLogger.fatal(mex,exc);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       */
      isFatalLogEnabled: function() {
        return !this.wrappedLogger.isFatalEnabled || this.wrappedLogger.isFatalEnabled();
      },
      
      //error
     
      /**
       * Joins all the specified parameters and calls {@link Logger#error} on
       * the proxied instance.
       * @param {...*} mex The string or object to be logged. 
       */
      logError: function(mex)  {
        if (!this.isErrorLogEnabled()) {
          return;
        }
        mex += this.logArguments(arguments,1);
        this.error(mex);
      },
      
      /**
       * Joins all the specified parameters and calls {@link Logger#error} on
       * the proxied instance.
       * @param {...*} mex The string or object to be logged. 
       */
      logErrorExc: function(exc,mex) {
        if (!this.isErrorLogEnabled()) {
          return;
        }
        mex += this.logArguments(arguments,2);
        this.error(mex,exc);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       * 
       * @param {String} message The message to be logged.  
       * @param {Error} [exception] An Exception instance related to the current log message.
       */
      error: function(mex,exc) {
        this.wrappedLogger.error(mex,exc);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       */
      isErrorLogEnabled: function() {
        return !this.wrappedLogger.isErrorEnabled || this.wrappedLogger.isErrorEnabled();
      },

      //warn
      
      /**
       * Joins all the specified parameters and calls {@link Logger#warn} on
       * the proxied instance.
       * @param {...*} mex The string or object to be logged. 
       */
      logWarn: function(mex) {
        if (!this.isWarnLogEnabled()) {
          return;
        }
        mex += this.logArguments(arguments,1);
        this.warn(mex);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       * 
       * @param {String} message The message to be logged.  
       * @param {Error} [exception] An Exception instance related to the current log message.
       */
      warn: function(mex,exc) {
        this.wrappedLogger.warn(mex,exc);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       */
      isWarnLogEnabled: function() {
        return !this.wrappedLogger.isWarnEnabled || this.wrappedLogger.isWarnEnabled();
      },
      
      //info

      /**
       * Joins all the specified parameters and calls {@link Logger#info} on
       * the proxied instance.
       * @param {...*} mex The string or object to be logged. 
       */
      logInfo: function(mex) {
        if (!this.isInfoLogEnabled()) {
          return;
        }
        mex += this.logArguments(arguments,1);
        this.info(mex);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       * 
       * @param {String} message The message to be logged.  
       * @param {Error} [exception] An Exception instance related to the current log message.
       */
      info: function(mex,exc) {
        this.wrappedLogger.info(mex,exc);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       */
      isInfoLogEnabled: function() {
        return !this.wrappedLogger.isInfoEnabled || this.wrappedLogger.isInfoEnabled();
      },


      //debug

      /**
       * Joins all the specified parameters and calls {@link Logger#debug} on
       * the proxied instance.
       * @param {...*} mex The string or object to be logged. 
       */
      logDebug: function(mex) {
        if (!this.isDebugLogEnabled()) {
          return;
        }
        mex += this.logArguments(arguments,1);
        this.debug(mex);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       * 
       * @param {String} message The message to be logged.  
       * @param {Error} [exception] An Exception instance related to the current log message.
       */
      debug: function(mex,exc) {
        this.wrappedLogger.debug(mex,exc);
      },
      
      /**
       * Proxies the call to the underling {@link Logger}
       */
      isDebugLogEnabled: function() {
        return !this.wrappedLogger.isDebugEnabled || this.wrappedLogger.isDebugEnabled();
      },
      
      /**
       * @private
       */
      logArguments: function(args, _start){ //Joins together all of the elements of an arguments array in a custom string
        _start = _start ? _start : 0;
        var _line = " {";
        for (var i = _start; i < args.length; i++) {
          try {
            var element = args[i];
            
            if (element === null) {
              _line += "NULL";
              
            } else if (element.length < 0) {
              _line += "*";
              
            } else if (element.charAt != null) {
              _line += element;
              
            } else if (element.message) {
              _line += element.message;
              if (element.stack) {
                _line += "\n"+element.stack+"\n";
              }
              
            } else if (element[0] == element) {
              // seen on Firefox?
              _line += element;
            } else if (Helpers.isArray(element)) {
              _line += "(";
              _line += this.logArguments(element);
              _line += ")";
            } else {
              _line += element;
            }
            _line += " ";
            
          } catch (_e) {
            _line += "??? ";
          }
        }
        return _line + "}";
      }
      
      
  };
  
  //closure exports
  LoggerProxy.prototype["debug"] = LoggerProxy.prototype.debug;
  LoggerProxy.prototype["isDebugLogEnabled"] = LoggerProxy.prototype.isDebugLogEnabled;
  LoggerProxy.prototype["logDebug"] = LoggerProxy.prototype.logDebug;
  
  LoggerProxy.prototype["info"] = LoggerProxy.prototype.info;
  LoggerProxy.prototype["isInfoLogEnabled"] = LoggerProxy.prototype.isInfoLogEnabled;
  LoggerProxy.prototype["logInfo"] = LoggerProxy.prototype.logInfo;
  
  LoggerProxy.prototype["warn"] = LoggerProxy.prototype.warn;
  LoggerProxy.prototype["isWarnEnabled"] = LoggerProxy.prototype.isWarnEnabled;
  LoggerProxy.prototype["logWarn"] = LoggerProxy.prototype.logWarn;
  
  LoggerProxy.prototype["error"] = LoggerProxy.prototype.error;
  LoggerProxy.prototype["isErrorEnabled"] = LoggerProxy.prototype.isErrorEnabled;
  LoggerProxy.prototype["logError"] = LoggerProxy.prototype.logError;
  LoggerProxy.prototype["logErrorExc"] = LoggerProxy.prototype.logErrorExc;
  
  LoggerProxy.prototype["fatal"] = LoggerProxy.prototype.fatal;
  LoggerProxy.prototype["isFatalEnabled"] = LoggerProxy.prototype.isFatalEnabled;
  LoggerProxy.prototype["logFatal"] = LoggerProxy.prototype.logFatal;

  return LoggerProxy;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var IllegalArgumentException = /*@__PURE__*/(function() {
  /**
   * Constructs an IllegalArgumentException with the specified detail message.
   * @constructor
   *
   * @param {String} message short description of the error.
   *
   * @exports IllegalArgumentException
   * @class Thrown to indicate that a method has been passed an illegal 
   * or inappropriate argument.
   * <BR>Use toString to extract details on the error occurred.
   */
  var IllegalArgumentException  = function(message) {
    
    /**
     * Name of the error, contains the "IllegalArgumentException" String.
     * 
     * @type String
     */
    this.name = "IllegalArgumentException";

    /**
     * Human-readable description of the error.
     * 
     * @type String
     */
    this.message = message;
   
  };
  
  IllegalArgumentException.prototype = {

      toString: function() {
        return ["[",this.name,this.message,"]"].join("|");
      }
      
  };
  
  return IllegalArgumentException;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var LoggerManager = /*@__PURE__*/(function() {
  var logInstances = {};
  var currentLoggerProvider = null;
  var NOT_LOGGER_PROVIDER = "The given object is not a LoggerProvider";
  
  /**
   * This singleton should be used to obtain {@link Logger} instances to
   * be used to produce the log.
   * @exports LoggerManager
   * 
   * @example
   * define(["LoggerManager"],function(LoggerManager) {
   *  
   *  //stuff
   *  var logger = LoggerManager.getLoggerProxy("myCategory");
   *  
   *  var MyClass = function() {
   *    //more stuff
   *    logger.info("my info log");
   *    //stuff
   *    logger.error("my error log");
   *  };
   *  
   *  return MyClass;
   *  
   * });
   * 
   * //elsewhere
   * require(["MyClass","LoggerManager","MyLoggerProvider"],
   *  function(MyClass,LoggerManager,MyLoggerProvider) {
   *  
   *  LoggerManager.setLoggerProvider(new MyLoggerProvider());
   *  var m = new MyClass(); //m will send log to the MyLoggerProvider instance
   *  
   * });
   * 
   * 
   */
  var LoggerManager = {
      
    /**
     * Sets the provider that will be used to get the Logger instances; it can
     * be set and changed at any time. All the new log will be sent to the 
     * {@link Logger} instances obtained from the latest LoggerProvider set.
     * Log produced before any provider is set is discarded. 
     * 
     * @param {LoggerProvider} [newLoggerProvider] the provider to be used; if
     * missing or null all the log will be discarded until a new provider is provided.
     */  
    setLoggerProvider: function(newLoggerProvider) {
      if (newLoggerProvider && !newLoggerProvider.getLogger) {
        //null is a valid value
        throw new IllegalArgumentException(NOT_LOGGER_PROVIDER);
      }
      
      currentLoggerProvider = newLoggerProvider;
      
      //updates the alive proxies
      for (var cat in logInstances) {
        if (!currentLoggerProvider) {
          logInstances[cat].setWrappedInstance(null);
        } else {
          logInstances[cat].setWrappedInstance(currentLoggerProvider.getLogger(cat));
        }
      }
      
    },
  
    /**
     * Gets a LoggerProxy to be used to produce the log bound to a defined category.
     * One single LoggerProxy instance will be created per each category: if the method
     * is called twice for the same category then the same instance will be returned.
     * On the other hand this method can potentially cause a memory leak as once a Logger 
     * is created it will never be dismissed. It is expected that the number of 
     * categories within a single application is somewhat limited and in any case
     * not growing with time.
     * 
     * @param {String} cat The category the Logger will be bound to.
     * @returns {LoggerProxy} the instance to be used to produce the log
     * for a certain category.
     */
    getLoggerProxy: function(cat) {
      if (!logInstances[cat]) {
        if (!currentLoggerProvider) {
          logInstances[cat] = new LoggerProxy();
        } else {
          logInstances[cat] = new LoggerProxy(currentLoggerProvider.getLogger(cat));
        }
         
      }
      return logInstances[cat];
    },
    
    /**
     * @private 
     */
    resolve: function(id){ //if LogMessages is included this method will be replaced
      return id;
    }
  };
  
  LoggerManager["setLoggerProvider"] = LoggerManager.setLoggerProvider;
  LoggerManager["getLoggerProxy"] = LoggerManager.getLoggerProxy;
  LoggerManager["resolve"] = LoggerManager.resolve;
  
  return LoggerManager;
})();

var Utils = /*@__PURE__*/(function() {
  var removeDot = new RegExp("\\.","g");
  var removeMinus = new RegExp("-","g");
  
  var requestIdCounter = 1;
  var subscriptionIdCounter = 1;

  var Utils = {

    isOffline: function() {
      return Environment.isBrowser() ? navigator.onLine === false : false;
    },

    canUseLocalStorage: function() {
      try {
		if (typeof localStorage != "undefined" && localStorage !== null && localStorage.getItem && localStorage.setItem) {
		  var x = '__canUseLocalStorage_test__',
		      y = 'true';

		  localStorage.setItem(x, y);
		  localStorage.removeItem(x);

		  return true;
		} else {
		  return false;
		}
      } catch(_e) {
        return false;
      }
    },

    getDomain: function() {
      try {
        return document.domain;
      } catch(e) {
        //wp8 webview (eg phonegapp apps) will throw an exception if try to read
        //document.domain. Yes I had the same look on my face when I discovered this
        return "";
      }
    },

    hasDefaultDomain: function() {
      if (!Environment.isBrowserDocument()) {
        return true;
      }
      try {
        var fixHost = document.location.host;
        if (fixHost.indexOf("[") > -1) {
          //if host is an IPv6 it's impossible that the domain has been changed
          return true;
        }

        return  Utils.getDomain() == document.location.hostname;
      } catch(_e) {
        //guess who's got an exception while reading location.host? IE of course
        return false;
      }
    },


    /**
     * necessario per IE7 altrimenti (faccio un esempio che mi vien + semplice):
     * Copio numero da finestra A a finestra B
     * B � un numero
     * Chiudo A
     * B magicamente diventa un oggetto.
     * L'errore riportato da IE7 �:
     * "Il chiamato (server [applicazione non server]) non � disponibile ed � scomparso.
     * Tutte le connessioni non sono valide. La chiamata non � stata effettuata."
     * [l'errore su IE7 sembra non presentarsi pi�]
     */
    copyByValue: function(_value) {

      if (typeof _value != "undefined") {
        if (_value === true || _value === false) {
          //booleano
          return _value === true;

        } else if (_value == null) {
          return null;

        } else if (typeof _value == "number" || _value instanceof Number) {
            return Number(_value);

        } else if (Helpers.isArray(_value)) {
          var arr = [];
          for (var i = 0; i<_value.length; i++) {
            arr[i] = this.copyByValue(_value[i]);
          }
          return arr;

        } else if (typeof _value == "string" || _value instanceof String) {
          return String(_value);

        } else if (_value.length === -1) {
          return Constants.UNCHANGED;

        } else if (isNaN(_value) && typeof _value == "number") {
          return NaN;

        } else {
          //it's not undefined, it's not null, it's not a number, it's not a string
          //it has not the toString method:
          //it should be a JSON object

          var obj = {};
          for (var i in _value) {
            obj[this.copyByValue(i)] = this.copyByValue(_value[i]);
          }
          return obj;

        }
      }
      return null;

    },

    extendObj: function(core,extension) {
      core = core || {};
      if (extension) {
        for (var p in extension) {
          core[p] = extension[p];
        }
      }
      return core;
    },

    sanitizeIFrameName: function(_name) {
      // ie does not want that there are points in the name of a frame and -
      // should be the only special characters present in a
      // domain so I don't have to replace anything else
      return _name.replace(removeDot,"_").replace(removeMinus,"__");
    },

    getReverse: function(map) {
      var res = {};

      for (var i in map) {
        res[map[i]] = i;
      }

      return res;
    },

    argumentsToArray: function(params) {
      if (params && !params.pop) {
        //this is an Arguments, not an array
        var tmp = [];
        for (var i=0; i<params.length; i++) {
          tmp.push(params[i]);
        }
        return tmp;
      }
      return params;
    },

    /**
     * Parses the value of a set-cookie header containing multiple cookie definitions separated by commas.
     * Notwithstanding RFC 6265 forbids cookie folding, some libraries (e.g. faye-websocket)
     * returns multiple set-cookie headers as a comma-separated string.
     *
     * @param {String} cookieStr comma-separated cookie definitions (e.g. 'cookie1=val1; attr1, cookie2=val2')
     * @return {String[]} an array of cookie definitions (e.g. ['cookie1=val1; attr1', 'cookie2=val2'])
     */
    parseSetCookieHeader: function(cookieDefs) {
        /*
         * Set-cookie syntax:
         *
         * <HEADER> ::= <COOKIE>* (separated by commas)
         * <COOKIE> ::= <NAME-VALUE>';'<ATTRIBUTE-SEQ>
         * <NAME-VALUE> ::= <CHAR>* (not containing commas or semicolons)
         * <ATTRIBUTE-SEQ> ::= <ATTRIBUTE>* (separated by semicolons)
         * <ATTRIBUTE> ::= <CHAR>* (not containing commas or semicolons)
         */

        if (! cookieDefs) {
            return [];
        }
        // string iterator (returns empty string when reaches the end)
        var it = {
                i: 0,
                next: function() {
                    return cookieDefs.charAt(this.i++);
                }
        };
        var expiresAttribute = /^\s*Expires/i;
        var cookies = [];
        var ch = it.next();
        /* <HEADER> */
        while (ch) {
            var cookie = '';
            /* <COOKIE> */
            var nameValue = '';
            /* <NAME-VALUE> */
            while (ch && ch != ';' && ch != ',') {
                nameValue += ch;
                ch = it.next();
            } /* end <NAME-VALUE> */
            nameValue = nameValue.trim();
            cookie += nameValue;
            if (ch == ';') {
                cookie += '; ';
                ch = it.next(); // consume semicolon
            }
            /* <ATTRIBUTE-SEQ> */
            while (ch && ch != ',') {
                var attribute = '';
                /* <ATTRIBUTE> */
                while (ch && ch != ';' && ch != ',') {
                    attribute += ch;
                    ch = it.next();
                } /* end <ATTRIBUTE> */

                // NB Expires attribute (e.g. Expires=Wed, 21 Oct 2015 07:28:00 GMT) needs a special processing
                // because it contains an internal comma, which must not be mistaken for a cookie separator
                if (attribute.match(expiresAttribute)) {
                    console.assert(ch == ',');
                    attribute += ch;
                    ch = it.next(); // consume internal comma
                    while (ch && ch != ';' && ch != ',') {
                        attribute += ch;
                        ch = it.next();
                    }
                }

                attribute = attribute.trim();
                cookie += attribute;
                if (ch == ';') {
                    cookie += '; ';
                    ch = it.next(); // consume semicolon
                }
            } /* end <ATTRIBUTE-SEQ> */
            /* end <COOKIE> */
            cookies.push(cookie);
            ch = it.next(); // consume comma
        } /* end <HEADER> */
        return cookies;
    },
    
    /**
     * LS_reqId generator.
     */
    nextRequestId: function() {
        return requestIdCounter++;
    },
    
    /**
     * LS_subId generator.
     */
    nextSubscriptionId: function() {
        return subscriptionIdCounter++;
    },
    
    /**
     * Returns a custom promise with two additional methods resolve and reject.
     */
    defer: function() {
        var res, rej;
        var p = new Promise(function(resolve, reject) {
            res = resolve;
            rej = reject;
        });
        p.resolve = res;
        p.reject = rej;
        return p;
    }

  };

  return Utils;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Inheritance = /*@__PURE__*/(function() {
  /**
   * @method
   * 
   * @param {Object} o
   * @param {Function} tc
   * @param {Object[]} params
   * 
   * @private
   */
  function doCall(o,tc,params) {
    if (tc) {
      if (params) {
        return tc.apply(o,params);
      } else {
        return tc.apply(o);
      }
    }
  }
  
  
  /**
   * @private
   */
  function searchAlias(proto,extendedName) {
    for (var i in proto) {
      if (proto[extendedName] == proto[i] && extendedName != i) {
        return i;
      }
    }
    return null;
  }
  
  /**
   * This module introduce a "classic" inheritance mechanism as well as an helper to
   * copy methods from one class to another. See the Inheritance method documentation below for details.
   * @exports Inheritance
   */
  var Inheritance = {
      
    /**
     * This method extends a class with the methods of another class preserving super
     * methods and super constructor. This method should be called on a class only
     * after its prototype is already filled, otherwise
     * super methods may not work as expected.<br/>
     * The <i>_super_</i>, <i>_callSuperMethod</i> and <i>_callSuperConstructor</i> names are reserved: extending and
     * extended classes' prototypes must not define properties with such names.<br/>
     * Once extended it is possible to call the super constructor calling the _callSuperConstructor
     * method and the super methods calling the _callSuperMethod method
     * <br/>Note that this function is the module itself (see the example)
     * 
     * @throws {IllegalStateException} if checkAliases is true and an alias of the super class
     * collides with a different method on the subclass.
     *
     * @param {Function} subClass the class that will extend the superClass
     * @param {Function} superClass the class to be extended
     * @param {boolean} [lightExtension] if true constructor and colliding methods of the
     * super class are not ported on the subclass hence only non-colliding methods will be copied
     * on the subclass (this kind of extension is also known as mixin)
     * @param {boolean} [checkAliases] if true aliases of colliding methods will be searched on the
     * super class prototype and, if found, the same alias will be created on the subclass. This is 
     * especially useful when extending a class that was minified using the Google Closure Compiler.
     * Note however that collisions can still occur, between a property and a method and between methods
     * when the subclass is minified too. The only way to prevent collisions is to minify super and sub 
     * classes together.
     * @function Inheritance
     * @static
     * 
     * @example
     * require(["Inheritance"],function(Inheritance) {
     *   function Class1() {
     *   }
     *
     *   Class1.prototype = {
     *     method1: function(a) {
     *       return a+1;
     *     }
     *   };
     * 
     *   function Class2() {
     *     this._callSuperConstructor(Class2);
     *   }
     *
     *   Class2.prototype = {
     *     method1: function(a,b) {
     *       return this._callSuperMethod(Class2,"method1",[a])+b;
     *     }
     *   };
     *
     *   Inheritance(Class2,Class1);
     *   
     *   var class2Instance = new Class2();
     *   class2Instance.method1(1,2); //returns 4
     *   
     * });
     */
    Inheritance: function(subClass, superClass, lightExtension, checkAliases){
      //iterate all of superClass's methods
      for (var i in superClass.prototype) {
        if (!subClass.prototype[i]) {
          //copy non-colliding methods directly
          subClass.prototype[i] = superClass.prototype[i];
        } else if(checkAliases) {
          //in case of collision search in the super prototype if the method has an alias
          //and create the alias here too
          var name = searchAlias(superClass.prototype,i);
          if (name) {
            //we want to copy  superClass.method to superClass.prototype[i], but subClass.prototype[i] already exists 
            //name is an alias of i --> superClass.prototype[name] == superClass.prototype[i]
            //if subClass has a name method thay is different not an alias of i (subClass.prototype[name] != subClass.prototype[i]) there is a collision problem
            if (subClass.prototype[name] && subClass.prototype[name] !== subClass.prototype[i]) {
              //unless the alias name was previously copied from superClass ( superClass.prototype[name] == superClass.prototype[name] )
              if (superClass.prototype[name] !== superClass.prototype[name]) {
                throw new IllegalStateException("Can't solve alias collision, try to minify the classes again (" + name + ", " + i + ")");
              }
            }
            subClass.prototype[name] = subClass.prototype[i];
          }
          
        }
      }
     
      if (!lightExtension) {
        //setup the extended class for super calls (square brakets used to support google closure)
        subClass.prototype["_super_"] = superClass;
        subClass.prototype["_callSuperConstructor"] = Inheritance._callSuperConstructor;
        subClass.prototype["_callSuperMethod"] = Inheritance._callSuperMethod;
      }

      return subClass;
    },
    
    /**
     * This method is attached to the prototype of each extended class as _callSuperMethod to make it possible to
     * call super methods. 
     * <br/>Note that it is not actually visible in this module.
     * 
     * @param {Function} ownerClass the class that calls this method.
     * @param {String} toCall the name of the super function to be called.
     * @param {Object[]} [params] array of parameters to be used to call the super method.
     * @static
     */
    _callSuperMethod: function(ownerClass, toCall, params){
      return doCall(this,ownerClass.prototype["_super_"].prototype[toCall],params);
    },
    
    /**
     * This method is attached to the
     * prototype of each extended class as _callSuperConstructor to make it possible
     * to call the super constructor.
     * <br/>Note that it is not actually visible in this module.
     *
     * @param {Function} ownerClass the class that calls this method.
     * @param {Object[]} [params] array of parameters to be used to call the super constructor.
     * @static
     */
    _callSuperConstructor: function(ownerClass, params){
      doCall(this,ownerClass.prototype["_super_"], params);
    }
  
  
  };
  
  //the way this is handled may look weird, well it is, I had to put
  //things this way with the only purpose to let JSDoc document the module
  //as I wanted to (and that didn't even turned out perfectly)
  return Inheritance.Inheritance;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Setter = /*@__PURE__*/(function() {
  //This is an abstract class; it could have been a module with a couple of static methods but I find it handier this way.
  
  /**
   * @private
   * @constant
   * @static
   */
  var VALUE_NOT_VALID = "The given value is not valid. ";
  /**
   * @private
   * @constant
   * @static
   */
  var USE_NUMBER = "Use a number";
  /**
   * @private
   * @constant
   * @static
   */
  var USE_INTEGER = "Use an integer";
  /**
   * @private
   * @constant
   * @static
   */
  var USE_POSITIVE = "Use a positive number";
  /**
   * @private
   * @constant
   * @static
   */
  var OR_ZERO = " or 0";
  /**
   * @private
   * @constant
   * @static
   */
  var USE_TRUE_OR_FALSE = "Use true or false";
  
  /**
   * Fake constructor. This abstract class is supposed to be extended using {@link module:Inheritance}
   * light extension.
   * @constructor
   *
   * @exports Setter
   * @abstract
   * @class Abstract class to be  extended to gain input validation for a class' setter methods.
   * 
   * @example
   * define(["Inheritance","Setter"],function(Inheritance,Setter) {
   *   
   *   var MyClass = function() {
   *     this.exampleProperty = 1;
   *     //do stuff
   *   }
   *   
   *   MyClass.prototype = {
   *     setExampleProperty: function(newVal) {
   *       this.exampleProperty = this.checkPositiveNumber(newVal,false,false);
   *     },
   *   
   *     //declare more stuff
   *   };
   *   
   *   Inheritance(MyClass,Setter,true);
   *   return MyClass;
   * });
   * 
   */
  var Setter = function() {
    
  };

  /**
   * Checks the given value to be a valid number. The input value is first explicitly converted into 
   * a Number (e.g. null would become 0) then is checked to be a valid number and finally it is verified
   * against the input configurations.    
   * 
   * @throws {IllegalArgumentException} if the input value is not a number or does not respect one of the given constraint.
   * 
   * @param newVal {Number|String|Object} the value to be verified.
   * @param canBeZero {Boolean} specifies if the given value can be 0 or not.
   * @param canBeDecimal {Boolean} specifies if the given value can be a decimal number or not.
   * @returns {Number} The explicitly converted Number is returned. 
   * 
   * @protected
   * @memberof Setter.prototype
   */
  function checkPositiveNumber(newVal,canBeZero,canBeDecimal) {
    var tmp = new Number(newVal);
    
    if (isNaN(tmp)) {
      throw new IllegalArgumentException(VALUE_NOT_VALID+USE_NUMBER);
    } 

    if(!canBeDecimal && tmp != Math.round(tmp)) {
      throw new IllegalArgumentException(VALUE_NOT_VALID+USE_INTEGER);  
      
    } 
      
    if (canBeZero) {
      if (newVal < 0) {
        throw new IllegalArgumentException(VALUE_NOT_VALID+USE_POSITIVE+OR_ZERO);
      }
    } else if(newVal <= 0) {
      throw new IllegalArgumentException(VALUE_NOT_VALID+USE_POSITIVE);
    } 
    return tmp;
    
  }
  
  /**
   * Checks the given value to be a boolean. The check is performed with the strict equal operactor (i.e.: ===)<br/>
   * If specified, empty strings, nulls, NaN, 0s, negative numbers 
   * and undefineds are also admitted values and are interpreted as false.
   *  
   * @param newVal the value to be verified.
   * @param notStrictFalse if true anything that would not-strictly equal (==) false is considered as
   * a valid false. 
   * @returns {Boolean} 
   * 
   * @throws {IllegalArgumentException} if the input value is not a valid boolean.  
   * 
   * @protected
   * @memberof Setter.prototype
   */
  function checkBool(newVal,notStrictFalse) {
    if (newVal === true || newVal === false || (notStrictFalse && !newVal)) {
      return newVal === true;
    }
    
    throw new IllegalArgumentException(VALUE_NOT_VALID+USE_TRUE_OR_FALSE);
  }
  
  
  Setter.prototype.checkPositiveNumber = checkPositiveNumber;
  Setter.prototype.checkBool = checkBool;
  Setter.prototype["checkPositiveNumber"] = checkPositiveNumber;
  Setter.prototype["checkBool"] = checkBool;
  
  
  return Setter;
})();

var actionsLogger = LoggerManager.getLoggerProxy(Constants.ACTIONS);
  var sharingLogger = LoggerManager.getLoggerProxy(Constants.SHARING);
  
  
  var Bean = function(orig){
    /**
     * this is an abstract class, actual classes must declare a valid name
     */ 
    this.constr = "Bean";

    this.parent = null;
    this.broadcastSimples = false;

    /*abstract*/ //this.noNotificationList = [];
    /*abstract*/ //this.doNotLogValueList = [];
    /*abstarct*/ //this.varNames = {};
    
    if (orig) {
      this.copySettings(orig);
    }
    
  };
  
  Bean.prototype = {
      
    getPropName: function(prop) {
      return this.varNames[prop];
    },
  
    /*public*/ simpleSetter: function(prop,_value) {
      var propName = this.getPropName(prop);
      
      var orig = this[propName];
      this[propName] = Utils.copyByValue(_value);
      
      //actionsLogger.logDebug(LoggerManager.resolve(493),this.parent,prop,this.getValueForLog(propName));
      
      if (this.parent && this.broadcastSimples) {
        this.broadcastSetting(prop);   
        
      } //else we should be a LightstreamerClient: only the engine sets broadcastSimples to true,
      //otherwise we'll have loop of broadcasts. LightstreamerClient only broadcasts setting made
      //through "proper" setters; simpleSetter MUST NOT be used by non-library calls
      
      if (orig != this[propName]) { //obviously notify changes only if the value is actually changed
        this.notifyChange(prop);
      }
    },
    
    /*private*/ getValueForLog: function(propName) {
      return this.doNotLogValueList && this.doNotLogValueList[propName] ? "[...]" : this[propName];
    },
    
    /*protected*/ heavySetter: function(prop,_value) {
      var propName = this.getPropName(prop);
            
      if(_value != this[propName]) {//obviously notify changes only if the value is actually changed
        //save the new value
        this[propName] = _value;
        
        //actionsLogger.logInfo(LoggerManager.resolve(494),prop,this.getValueForLog(propName));
        
        //spread the word
        this.broadcastSetting(prop);
        //once we have spread the word we issue the change event 
        this.notifyChange(prop);
      }
    },
    
    /*public*/ setBroadcaster: function(_parent,broadcastSimples) {
      this.parent = _parent;
      this.broadcastSimples = broadcastSimples;
    },
    
    /**
     * @param
     */
    /*private*/ broadcastSetting: function(prop) { 
      var propName = this.getPropName(prop);
      //sharingLogger.logDebug(LoggerManager.resolve(495),prop,this.getValueForLog(propName));
      
      if (this.parent && this.parent.broadcastSetting) {
        if (!this.parent.broadcastSetting(this.constr,prop,Utils.copyByValue(this[propName]))) {
          // if the broadcast fails only the local instance will have the update value
          return false;
        }
      }
      
      
      return true;
    },
    
    notifyChange: function(prop) {
      var propName = this.getPropName(prop);
      if (this.parent && this.parent.notifyOptionChange) {
        
        if (this.noNotificationList && this.noNotificationList[propName]) {
          return;
        }
        
        //actionsLogger.logDebug(LoggerManager.resolve(496),prop,this.getValueForLog(propName));
            
        this.parent.notifyOptionChange(prop,this);
      }
    },
    
    /*public*/ copySettings: function(original) {
      var sl = this.varNames;
      for (var i in sl) {
        //this[sl[i]] = Utils.copyByValue(original[sl[i]]); 
        this.simpleSetter(i, original[sl[i]]);
      }
    },

    forEachProperty: function(call) {
      for (var i in this.varNames) {
        call(i, this[this.varNames[i]]);
      }
    }

  };
  
  Inheritance(Bean,Setter,false,true);

var noNotificationList = {};

  var varNames = {
      connectionRequested: "connectionRequested",
      clientsCount: "clientsCount"
  };
  varNames = Utils.getReverse(varNames); 

  var Configuration = function(toClone){

    this.connectionRequested = false;
    this.clientsCount = 0;

    
    this.noNotificationList = noNotificationList; 
    this.varNames = varNames;
    
    this._callSuperConstructor(Configuration,arguments); 
    this.constr = "Configuration";
    
  };

  Configuration.prototype = {
    getConnectionRequested: function() {
      return this.connectionRequested;
    },
    getClientsCount: function() {
      return this.clientsCount;
    }
  };
  
  Inheritance(Configuration, Bean);

var log = LoggerManager.getLoggerProxy(Constants.SESSION);
    
    /**
     * WARNING
     * The algorithm is the same as ConnectTimeoutCounter. In case of change, consider whether the change must
     * be ported there.
     * <p>
     * 
     * Computes <code>currentRetryDelay</code> in the following way:
     * <ul>
     * <li>the first 10 times when increase() is called, currentRetryDelay equals retryDelay</li>
     * <li>the next times, currentRetryDelay is doubled until it reaches the value of 60s</li>
     * </ul>
     * 
     * @since December 2018
     */
    var RetryDelayCounter = function(delay) {
        this.initRetryDelay(delay);
    };
    
    RetryDelayCounter.prototype = {
            
            /**
             * Resets retryDelay and currentRetryDelay.
             */
            resetRetryDelay: function(delay) {
                this.initRetryDelay(delay);
                if (log.isDebugLogEnabled()) {
                    log.debug("Reset currentRetryDelay: " + this.currentRetryDelay);
                }
            },
            
            /**
             * Increase currentRetryDelay.
             */
            increaseRetryDelay: function() {
                if (this.retryAttempt >= 9 && this.currentRetryDelay < this.maxRetryDelay) {
                    this.currentRetryDelay *= 2;
                    if (this.currentRetryDelay > this.maxRetryDelay) {
                        this.currentRetryDelay = this.maxRetryDelay;
                    }
                    if (log.isDebugLogEnabled()) {
                        log.debug("Increase currentRetryDelay: " + this.currentRetryDelay);
                    }
                }
                this.retryAttempt++;
            },
            
            /**
             * Initializes retryDelay and currentRetryDelay.
             */
            initRetryDelay: function(retryDelay) {
                this.currentRetryDelay = retryDelay;
                this.minRetryDelay = retryDelay;
                this.maxRetryDelay = Math.max(60000, retryDelay);
                this.retryAttempt = 0;
            }
    };

var log$1 = LoggerManager.getLoggerProxy(Constants.SESSION);
    
    /**
     * WARNING
     * The algorithm is the same as RetryDelayCounter. In case of change, consider whether the change must
     * be ported there.
     * <p>
     * 
     * Computes <code>currentConnectTimeout</code> in the following way:
     * <ul>
     * <li>the first 10 times when increase() is called, currentConnectTimeout equals connectTimeout</li>
     * <li>the next times, currentConnectTimeout is doubled until it reaches the value of 60s</li>
     * </ul>
     * 
     * @since December 2018
     */
    var ConnectTimeoutCounter = function(delay) {
        this.initConnectTimeout(delay);
    };
    
    ConnectTimeoutCounter.prototype = {
            
            /**
             * Resets connectTimeout and currentConnectTimeout.
             */
            resetConnectTimeout: function(delay) {
                this.initConnectTimeout(delay);
                if (log$1.isDebugLogEnabled()) {
                    log$1.debug("Reset currentConnectTimeout: " + this.currentConnectTimeout);
                }
            },
            
            /**
             * Increase currentConnectTimeout.
             */
            increaseConnectTimeout: function() {
                if (this.connectAttempt >= 9 && this.currentConnectTimeout < this.maxConnectTimeout) {
                    this.currentConnectTimeout *= 2;
                    if (this.currentConnectTimeout > this.maxConnectTimeout) {
                        this.currentConnectTimeout = this.maxConnectTimeout;
                    }
                    if (log$1.isDebugLogEnabled()) {
                        log$1.debug("Increase currentConnectTimeout: " + this.currentConnectTimeout);
                    }
                }
                this.connectAttempt++;
            },
            
            /**
             * Increase the timeout to the maximum value.
             */
            increaseConnectTimeoutToMax: function() {
                this.currentConnectTimeout = this.maxConnectTimeout;
                if (log$1.isDebugLogEnabled()) {
                    log$1.debug("Increase currentConnectTimeout to max: " + this.currentConnectTimeout);
                }
            },
            
            /**
             * Initializes connectTimeout and currentConnectTimeout.
             */
            initConnectTimeout: function(connectTimeout) {
                this.currentConnectTimeout = connectTimeout;
                this.minConnectTimeout = connectTimeout;
                this.maxConnectTimeout = Math.max(60000, connectTimeout);
                this.connectAttempt = 0;
            }
    };

/*
     * WARNING
     * 
     * Unlike Java client where ConnectionOptions has references to the classes RetryDelayCounter
     * and ConnectTimeoutCounter,
     * in Javascript client RetryDelayCounter and ConnectTimeoutCounter are mixed into ConnectionOptions 
     * because ConnectionOptions
     * must be serializable (see ConnectionOptions super constructor where the method Utils.copyByValue
     * is used) but RetryDelayCounter and ConnectTimeoutCounter are not serializable (they declares methods).
     * 
     * Making RetryDelayCounter and ConnectTimeoutCounter mixins, we avoid the serialization problem 
     * but we must assure that
     *   1) there is no name clash between properties and methods of ConnectionOptions and RetryDelayCounter
     *      and ConnectTimeoutCounter
     *   2) the property names of RetryDelayCounter and ConnectTimeoutCounter are listed 
     *      in the global variable varNames (see below) because they are used for the serialization.
     */
    
  var connConstants = {};
  connConstants[Constants.HTTP_STREAMING] = true;
  connConstants[Constants.WS_POLLING] = true;
  connConstants[Constants.HTTP_POLLING] = true;
  connConstants[Constants.WS_STREAMING] = true;
  connConstants[Constants.WS_ALL] = true;
  connConstants[Constants.HTTP_ALL] = true;


  var WRONG_FORCED_TRANSPORT = "The given value is not valid. Use one of: HTTP-STREAMING, HTTP-POLLING, WS-STREAMING, WS-POLLING, WS, HTTP or null";
  
  
  var varNames$1 = {
      contentLength: "contentLength",
      idleTimeout: "idleTimeout",
      keepaliveInterval: "keepaliveInterval",
      requestedMaxBandwidth: "requestedMaxBandwidth",
      realMaxBandwidth: "realMaxBandwidth",
      pollingInterval: "pollingInterval",
      reconnectTimeout: "reconnectTimeout",
      stalledTimeout: "stalledTimeout",
      retryDelay: "retryDelay",
      firstRetryMaxDelay: "firstRetryMaxDelay",
      slowingEnabled: "slowingEnabled",
      forcedTransport: "forcedTransport",
      serverInstanceAddressIgnored: "serverInstanceAddressIgnored",
      cookieHandlingRequired: "cookieHandlingRequired",
      reverseHeartbeatInterval: "reverseHeartbeatInterval",
      earlyWSOpenEnabled: "earlyWSOpenEnabled",
      sessionRecoveryTimeout: "sessionRecoveryTimeout",
      spinFixTimeout: "spinFixTimeout",
      spinFixEnabled: "spinFixEnabled",
      xDomainStreamingEnabled: "xDomainStreamingEnabled",
      corsXHREnabled: "corsXHREnabled",
      forceBindTimeout: "forceBindTimeout", 
      switchCheckTimeout: "switchCheckTimeout",
      httpExtraHeaders : "httpExtraHeaders",
      httpExtraHeadersOnSessionCreationOnly : "httpExtraHeadersOnSessionCreationOnly",
      remoteAdapterStatusObserver: "remoteAdapterStatusObserver",
      
      /* BEGIN RetryDelayCounter properties */
      currentRetryDelay: "currentRetryDelay",
      minRetryDelay: "minRetryDelay",
      maxRetryDelay: "maxRetryDelay",
      retryAttempt: "retryAttempt",
      /* END RetryDelayCounter properties */
      
      /* BEGIN ConnectTimeoutCounter properties */
      currentConnectTimeout: "currentConnectTimeout",
      minConnectTimeout: "minConnectTimeout",
      maxConnectTimeout: "maxConnectTimeout",
      connectAttempt: "connectAttempt"
      /* END ConnectTimeoutCounter properties */
  };
  varNames$1 = Utils.getReverse(varNames$1); 
  
  
  /**
   * Used by LightstreamerClient to provide an extra connection properties data object.
   * @constructor
   *
   * @exports ConnectionOptions
   * @class Data object that contains the policy settings 
   * used to connect to a Lightstreamer Server.
   * <BR/>The class constructor, its prototype and any other properties should never
   * be used directly; the library will create ConnectionOptions instances when needed.
   * <BR>Note that all the settings are applied asynchronously; this means that if a
   * CPU consuming task is performed right after the call the effect of the setting 
   * will be delayed.
   * 
   * @see LightstreamerClient
   */
  var ConnectionOptions = function() {

    
    //PUBLIC
    /**
     * @private
     */
    this.contentLength = 4000000; //4 MB
    /**
     * @private
     */
    this.idleTimeout = 19000; // idle timeout
    /**
     * @private
     */
    this.keepaliveInterval = 0;  //The requested keepalive signals interval
    /**
     * @private
     */
    this.requestedMaxBandwidth = -1; //The max bandwidth requested from the client, saved as 0 means unlimited, also a negative value means unlimited but can only be sent by the server, not set via APIs
    /**
     * @private
     */
    this.pollingInterval = 0; //The requested polling interval
    /**
     * @private
     */
    this.reconnectTimeout = 3000;  // Timeout to enter the CONNECTING status (from STALLED)
    /**
     * @private
     */
    this.stalledTimeout = 2000;  // Timeout to enter the STALLED status (from STREAMING)
    /**
     * @private
     */
    this.retryDelay = 4000;
    this.initRetryDelay(this.retryDelay); // initialize RetryDelayCounter mixin
    this.initConnectTimeout(this.retryDelay); // initialize ConnectTimeoutCounter mixin
    /**
     * @private
     */
    this.firstRetryMaxDelay = 100; //time to wait when a connection breaks before connecting again
    /**
     * @private
     */
    this.slowingEnabled = false; // Use or not the slowing algorithm
    /**
     * @private
     */
    this.forcedTransport = null; //force a specific kind of connection
    /**
     * @private
     */
    this.serverInstanceAddressIgnored = false; //if true the control link will be ignored
    /**
     * @private
     */
    this.cookieHandlingRequired = false;
    /**
     * @private
     */
    this.reverseHeartbeatInterval = 0; //if > 0 is the interval between client sent heartbeats
    /**
     * @private
     */
    this.earlyWSOpenEnabled = false;
    /**
     * @private
     */
    this.spinFixTimeout = 5000;
    /**
     * @private
     */
    this.spinFixEnabled = null; //null -> default; true -> always; false -> never
    /**
     * @private
     */
    this.httpExtraHeaders = null;
    /**
     * @private
     */
    this.httpExtraHeadersOnSessionCreationOnly = false;
    /**
     * @private
     */
    this.sessionRecoveryTimeout = 15000;
    
    //PRIVATE 
    /**
     * @private
     */
    this.xDomainStreamingEnabled = true;
    /**
     * @private
     */
    this.corsXHREnabled = true;
    /**
     * @private
     */
    this.forceBindTimeout = 2000; //how long to wait before sending another force bind request (when the previous had no effect) 
    /**
     * @private
     */
    this.switchCheckTimeout = 4000; //how long to wait before creating a new session, instead of waiting for a loop command, when a force bind has been sent
    /**
     * @private
     */
    this.remoteAdapterStatusObserver = {};
    /**
     * @private
     */
    this.varNames = varNames$1;
    
    this._callSuperConstructor(ConnectionOptions,arguments); 
    /**
     * @private
     */
    this.constr = "ConnectionOptions";

    
  };
  
  ConnectionOptions.prototype = {
      
    ///////////////PUBLIC
      
    /** 
     * Setter method that sets the length in bytes to be used by the Server for the 
     * response body on a stream connection (a minimum length, however, is ensured 
     * by the server). After the content length exhaustion, the connection will be 
     * closed and a new bind connection will be automatically reopened.
     * <BR>NOTE that this setting only applies to the "HTTP-STREAMING" case (i.e. not to WebSockets).
     *  
     * <p class="default-value"><b>Default value:</b> A length decided by the library, to ensure
     * the best performance. It can be of a few MB or much higher, depending on the environment.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The content length should be set before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next streaming connection (either a bind
     * or a brand new session).</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "contentLength" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative, zero, decimal
     * or a not-number value is passed.
     * 
     * @param {Number} contentLength The length to be used by the Server for the 
     * response body on a HTTP stream connection.
     */
    setContentLength: function(contentLength) {
      this.heavySetter("contentLength",this.checkPositiveNumber(contentLength));
    },
    
    /**
     * Inquiry method that gets the length expressed in bytes to be used by the Server
     * for the response body on a HTTP stream connection.
     * 
     * @return {Number} the length to be used by the Server
     * for the response body on a HTTP stream connection
     */
    getContentLength: function() {
      return this.contentLength;
    },
    
    /**
     * Setter method that sets the maximum time the Server is allowed to wait
     * for any data to be sent in response to a polling request, if none has
     * accumulated at request time. Setting this time to a nonzero value and
     * the polling interval to zero leads to an "asynchronous polling"
     * behaviour, which, on low data rates, is very similar to the streaming
     * case. Setting this time to zero and the polling interval to a nonzero
     * value, on the other hand, leads to a classical "synchronous polling".
     * <BR>Note that the Server may, in some cases, delay the answer for more
     * than the supplied time, to protect itself against a high polling rate or
     * because of bandwidth restrictions. Also, the Server may impose an upper
     * limit on the wait time, in order to be able to check for client-side
     * connection drops.
     *
     * <p class="default-value"><b>Default value:</b> 19000 (19 seconds).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The idle timeout should be set before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next polling request.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "idleTimeout" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative or a decimal
     * or a not-number value is passed.
     *
     * @param {Number} idleTimeout The time (in milliseconds) the Server is
     * allowed to wait for data to send upon polling requests.
     * 
     * @see ConnectionOptions#setPollingInterval
     */
    setIdleTimeout: function(idleTimeout) {
      this.heavySetter("idleTimeout",this.checkPositiveNumber(idleTimeout,true));
    },
    
    /**  
     * Inquiry method that gets the maximum time the Server is allowed to wait
     * for any data to be sent in response to a polling request, if none has
     * accumulated at request time. The wait time used by the Server, however,
     * may be different, because of server side restrictions.
     *
     * @return {Number} The time (in milliseconds) the Server is allowed to wait for
     * data to send upon polling requests.
     *
     * @see ConnectionOptions#setIdleTimeout
     */
    getIdleTimeout: function() {
      return this.idleTimeout;
    },
    
    /**
     * Setter method that sets the interval between two keepalive packets
     * to be sent by Lightstreamer Server on a stream connection when
     * no actual data is being transmitted. The Server may, however, impose
     * a lower limit on the keepalive interval, in order to protect itself.
     * Also, the Server may impose an upper limit on the keepalive interval,
     * in order to be able to check for client-side connection drops.
     * If 0 is specified, the interval will be decided by the Server.
     * 
     * <p class="default-value"><b>Default value:</b> 0 (meaning that the Server
     * will send keepalive packets based on its own configuration).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The keepalive interval should be set before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next streaming connection (either a bind
     * or a brand new session).
     * <BR>Note that, after a connection,
     * the value may be changed to the one imposed by the Server.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "keepaliveInterval" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called or that received the setting from the
     * server
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative or a decimal
     * or a not-number value is passed.
     *
     * @param {Number} keepaliveInterval The time, expressed in milliseconds,
     * between two keepalive packets, or 0.
     */
    setKeepaliveInterval: function(keepaliveInterval) {
      this.heavySetter("keepaliveInterval",this.checkPositiveNumber(keepaliveInterval,true));
    },
    
    /**  
     * Inquiry method that gets the interval between two keepalive packets
     * sent by Lightstreamer Server on a stream connection when no actual data
     * is being transmitted.
     * <BR>If the value has just been set and a connection to Lightstreamer
     * Server has not been established yet, the returned value is the time that
     * is being requested to the Server. Afterwards, the returned value is the time
     * used by the Server, that may be different, because of Server side constraints.
     * If the returned value is 0, it means that the interval is to be decided
     * by the Server upon the next connection.
     *
     * @return {Number} The time, expressed in milliseconds, between two keepalive
     * packets sent by the Server, or 0.
     * 
     * @see ConnectionOptions#setKeepaliveInterval
     */
    getKeepaliveInterval: function() {
      /*if (! isNaN(this.serverKeepaliveInterval)) {
        return this.serverKeepaliveInterval;
      }*/ 
      return this.keepaliveInterval;
    },
    
    /**
     * Setter method that sets the maximum bandwidth expressed in kilobits/s that can be consumed for the data coming from 
     * Lightstreamer Server. A limit on bandwidth may already be posed by the Metadata Adapter, but the client can 
     * furtherly restrict this limit. The limit applies to the bytes received in each streaming or polling connection.
     *
     * <p class="edition-note"><B>Edition Note:</B> Bandwidth Control is
	 * an optional feature, available depending on Edition and License Type.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     *
     * <p class="default-value"><b>Default value:</b> "unlimited".</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The bandwidth limit can be set and changed at any time. If a connection is currently active, the bandwidth 
     * limit for the connection is changed on the fly. Remember that the Server may apply a different limit.
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to 
     * {@link ClientListener#onPropertyChange} with argument "requestedMaxBandwidth" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called or that received the setting from the
     * server
END_NODE_JSDOC_EXCLUDE
     * .
     * <BR>
     * Moreover, upon any change or attempt to change the limit, the Server will notify the client
     * and such notification will be received through a call to 
     * {@link ClientListener#onPropertyChange} with argument "realMaxBandwidth" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called or that received the setting from the
     * server
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @param {Number} maxBandwidth A decimal number, which represents the maximum bandwidth requested for the streaming
     * or polling connection expressed in kbps (kilobits/sec). The string "unlimited" is also allowed, to mean that
     * the maximum bandwidth can be entirely decided on the Server side (the check is case insensitive).
     * 
     * @throws {IllegalArgumentException} if a negative, zero, or a not-number value (excluding special values) is passed.
     * 
     * @see ConnectionOptions#getRealMaxBandwidth
     */
    setRequestedMaxBandwidth: function(maxBandwidth) {
      var maxBandwidthTmp = new String(maxBandwidth);
      if (maxBandwidthTmp.toLowerCase() == "unlimited") {
        maxBandwidth = 0;
      } else {
        maxBandwidth = this.checkPositiveNumber(maxBandwidth,false,true);
      }
      
      this.heavySetter("requestedMaxBandwidth",maxBandwidth);
    },
  
    /**
     * Inquiry method that gets the maximum bandwidth that can be consumed for the data coming from 
     * Lightstreamer Server, as requested for this session.
     * The maximum bandwidth limit really applied by the Server on the session is provided by
     * {@link ConnectionOptions#getRealMaxBandwidth}
     * 
     * @return {Number|String} A decimal number, which represents the maximum bandwidth requested for the streaming
     * or polling connection expressed in kbps (kilobits/sec), or the string "unlimited".
     * 
     * @see ConnectionOptions#setRequestedMaxBandwidth
     */
    getRequestedMaxBandwidth: function() {
      if (this.requestedMaxBandwidth <= 0) {
        return "unlimited";
      }
      return this.requestedMaxBandwidth;
    },
    
    /**
     * Inquiry method that gets the maximum bandwidth that can be consumed for the data coming from 
     * Lightstreamer Server. This is the actual maximum bandwidth, in contrast with the requested
     * maximum bandwidth, returned by {@link ConnectionOptions#getRequestedMaxBandwidth}. <BR>
     * The value may differ from the requested one because of restrictions operated on the server side,
     * or because bandwidth management is not supported (in this case it is always "unlimited"),
     * but also because of number rounding.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>If a connection to Lightstreamer Server is not currently active, null is returned;
     * soon after the connection is established, the value becomes available, as notified
     * by a call to {@link ClientListener#onPropertyChange} with argument "realMaxBandwidth".</p>
     * 
     * @return {Number|String} A decimal number, which represents the maximum bandwidth applied by the Server for the
     * streaming or polling connection expressed in kbps (kilobits/sec), or the string "unlimited", or null.
     * 
     * @see ConnectionOptions#setRequestedMaxBandwidth
     */
    getRealMaxBandwidth: function() {
        return this.realMaxBandwidth;
    },
    
    /**
     * Setter method that sets the polling interval used for polling
     * connections. The client switches from the default streaming mode
     * to polling mode when the client network infrastructure does not allow
     * streaming. Also, polling mode can be forced
     * by calling {@link ConnectionOptions#setForcedTransport} with 
     * "WS-POLLING" or "HTTP-POLLING" as parameter.
     * <BR>The polling interval affects the rate at which polling requests
     * are issued. It is the time between the start of a polling request and
     * the start of the next request. However, if the polling interval expires
     * before the first polling request has returned, then the second polling
     * request is delayed. This may happen, for instance, when the Server
     * delays the answer because of the idle timeout setting.
     * In any case, the polling interval allows for setting an upper limit
     * on the polling frequency.
     * <BR>The Server does not impose a lower limit on the client polling
     * interval.
     * However, in some cases, it may protect itself against a high polling
     * rate by delaying its answer. Network limitations and configured
     * bandwidth limits may also lower the polling rate, despite of the
     * client polling interval.
     * <BR>The Server may, however, impose an upper limit on the polling
     * interval, in order to be able to promptly detect terminated polling
     * request sequences and discard related session information.
     * 
     * 
     * <p class="default-value"><b>Default value:</b> 0 (pure "asynchronous polling" is configured).
     * </p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b>The polling interval should be set before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next polling request. 
     * <BR>Note that, after each polling request, the value may be
     * changed to the one imposed by the Server.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "pollingInterval" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called or that received the setting from the
     * server.
END_NODE_JSDOC_EXCLUDE
     * </p>
     * 
     * @throws {IllegalArgumentException} if a negative or a decimal
     * or a not-number value is passed.
     *
     * @param {Number} pollingInterval The time (in milliseconds) between
     * subsequent polling requests. Zero is a legal value too, meaning that
     * the client will issue a new polling request as soon as
     * a previous one has returned.
     * 
     * @see ConnectionOptions#setIdleTimeout
     */
    setPollingInterval: function(pollingInterval) {
      this.heavySetter("pollingInterval",this.checkPositiveNumber(pollingInterval,true));
    },
    
    /**  
     * Inquiry method that gets the polling interval used for polling
     * connections.
     * <BR>If the value has just been set and a polling request to Lightstreamer
     * Server has not been performed yet, the returned value is the polling interval that is being requested
     * to the Server. Afterwards, the returned value is the the time between
     * subsequent polling requests that is really allowed by the Server, that may be
     * different, because of Server side constraints.
     *
     * @return {Number} The time (in milliseconds) between subsequent polling requests.
     * 
     * @see ConnectionOptions#setPollingInterval
     */
    getPollingInterval: function() {
      /*if (!isNaN(this.serverPollingInterval)) {
        return this.serverPollingInterval;
      }*/
      return this.pollingInterval;
    },
    
    /**
     * Setter method that sets the time the client, after entering "STALLED" status,
     * is allowed to keep waiting for a keepalive packet or any data on a stream connection,
     * before disconnecting and trying to reconnect to the Server.
     * The new connection may be either the opening of a new session or an attempt to recovery
     * the current session, depending on the kind of interruption.
     *
     * <p class="default-value"><b>Default value:</b> 3000 (3 seconds).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This value can be set and changed at any time.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "reconnectTimeout" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative, zero, or a not-number 
     * value is passed.
     *
     * @param {Number} reconnectTimeout The idle time (in milliseconds)
     * allowed in "STALLED" status before trying to reconnect to the
     * Server.
     *
     * @see ConnectionOptions#setStalledTimeout
     */
    setReconnectTimeout: function(reconnectTimeout) {
      this.heavySetter("reconnectTimeout",this.checkPositiveNumber(reconnectTimeout));
    },
    
    /**  
     * Inquiry method that gets the time the client, after entering "STALLED" status,
     * is allowed to keep waiting for a keepalive packet or any data on a stream connection,
     * before disconnecting and trying to reconnect to the Server.
     *
     * @return {Number} The idle time (in milliseconds) admitted in "STALLED"
     * status before trying to reconnect to the Server.
     *
     * @see ConnectionOptions#setReconnectTimeout
     */
    getReconnectTimeout: function() {
      return this.reconnectTimeout;
    },
    
    /**
     * Setter method that sets the extra time the client is allowed
     * to wait when an expected keepalive packet has not been received on
     * a stream connection (and no actual data has arrived), before entering
     * the "STALLED" status.
     *
     * <p class="default-value"><b>Default value:</b> 2000 (2 seconds).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This value can be set and changed at any time.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "stalledTimeout" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative, zero, or a not-number 
     * value is passed.
     *
     * @param {Number} stalledTimeout The idle time (in milliseconds)
     * allowed before entering the "STALLED" status.
     *
     * @see ConnectionOptions#setReconnectTimeout
     */
    setStalledTimeout: function(stalledTimeout) {
      this.heavySetter("stalledTimeout",this.checkPositiveNumber(stalledTimeout));
    },
  
    /**  
     * Inquiry method that gets the extra time the client can wait
     * when an expected keepalive packet has not been received on a stream
     * connection (and no actual data has arrived), before entering the
     * "STALLED" status.
     *
     * @return {Number} The idle time (in milliseconds) admitted before entering the
     * "STALLED" status.
     *
     * @see ConnectionOptions#setStalledTimeout
     */
    getStalledTimeout: function() {
      return this.stalledTimeout;
    },
    
    /**
     * Does nothing.
     * <p>
     * <b>The method is deprecated and it has no effect.
     * To act on connection timeouts use {@link ConnectionOptions#setRetryDelay}.</b>
     */
    setConnectTimeout: function(connectTimeout) {
        // ignore: see setRetryDelay
    },


    /**
     * Returns the same value as {@link ConnectionOptions#getRetryDelay}.
     * <p>
     * <b>The method is deprecated: use {@link ConnectionOptions#getRetryDelay} instead.</b>
     */
    getConnectTimeout: function() {
        return String(this.getRetryDelay());
    },


    /**
     * Does nothing.
     * <p>
     * <b>The method is deprecated and it has no effect.
     * To act on connection timeouts, only {@link ConnectionOptions#setRetryDelay} is available.</b>
     */
    setCurrentConnectTimeout: function(currentConnectTimeout) {
        // ignore: see setRetryDelay
    },


    /**
     * Inquiry method that gets the maximum time to wait for a response to a request.
     * 
     * <p>
     * This value corresponds to the retry delay, but, in case of multiple failed attempts
     * on unresponsive connections, it can be changed dynamically by the library to higher values.
     * When this happens, the current value cannot be altered, but by issuing
     * {@link LightstreamerClient#disconnect} and {@link LightstreamerClient#connect}
     * it will restart from the retry delay.
     *
     * @return {Number} The time (in milliseconds) allowed to wait before trying a new connection.
     * 
     * @see ConnectionOptions#setRetryDelay
     */
    getCurrentConnectTimeout: function() {
        return this.currentConnectTimeout;
    },

    
    /**
     * Setter method that sets 
     * <ol>
     * <li>the minimum time to wait before trying a new connection
     * to the Server in case the previous one failed for any reason; and</li>
     * <li>the maximum time to wait for a response to a request 
     * before dropping the connection and trying with a different approach.</li>
     * </ol>
     * 
     * <p>
     * Enforcing a delay between reconnections prevents strict loops of connection attempts when these attempts
     * always fail immediately because of some persisting issue.
     * This applies both to reconnections aimed at opening a new session and to reconnections
     * aimed at attempting a recovery of the current session.<BR>
     * Note that the delay is calculated from the moment the effort to create a connection
     * is made, not from the moment the failure is detected.
     * As a consequence, when a working connection is interrupted, this timeout is usually
     * already consumed and the new attempt can be immediate (except that
     * {@link ConnectionOptions#setFirstRetryMaxDelay} will apply in this case).
     * As another consequence, when a connection attempt gets no answer and times out,
     * the new attempt will be immediate.
     * 
     * <p>
     * As a timeout on unresponsive connections, it is applied in these cases:
     * <ul>
     * <li><i>Streaming</i>: Applied on any attempt to setup the streaming connection. If after the 
     * timeout no data has arrived on the stream connection, the client may automatically switch transport 
     * or may resort to a polling connection.</li>
     * <li>Polling and pre-flight requests</i>: Applied on every connection. If after the timeout 
     * no data has arrived on the polling connection, the entire connection process restarts from scratch.</li>
     * </ul>
     * 
     * <p>
     * <b>This setting imposes only a minimum delay. In order to avoid network congestion, the library may use a longer delay if the issue preventing the
     * establishment of a session persists.</b>
     *    
     * <p class="default-value"><b>Default value:</b> 4000 (4 seconds).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This value can be set and changed at any time.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "retryDelay" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative, zero, or a not-number 
     * value is passed.
     * 
     * @param {Number} retryDelay The time (in milliseconds)
     * to wait before trying a new connection.
     *
     * @see ConnectionOptions#setFirstRetryMaxDelay
     * @see ConnectionOptions#getCurrentConnectTimeout
     */
    setRetryDelay: function(retryDelay) {
        var n = this.checkPositiveNumber(retryDelay);
        this.heavySetter("retryDelay", n);
        this.resetRetryDelay(n);
        this.resetConnectTimeout(n);
    },
    
    /**  
     * Inquiry method that gets the minimum time to wait before trying a new connection
     * to the Server in case the previous one failed for any reason, which is also the maximum time to wait for a response to a request 
     * before dropping the connection and trying with a different approach.
     * Note that the delay is calculated from the moment the effort to create a connection
     * is made, not from the moment the failure is detected or the connection timeout expires.
     *
     * @return {Number} The time (in milliseconds) to wait before trying a new connection.
     *
     * @see ConnectionOptions#setRetryDelay
     */
    getRetryDelay: function() {
        return this.retryDelay;
    },
    
    
    /**
     * Setter method that sets the maximum time to wait before trying a new connection to the Server
     * in case the previous one is unexpectedly closed while correctly working.
     * The new connection may be either the opening of a new session or an attempt to recovery
     * the current session, depending on the kind of interruption.
     * <BR/>The actual delay is a randomized value between 0 and this value. 
     * This randomization might help avoid a load spike on the cluster due to simultaneous reconnections, should one of 
     * the active servers be stopped. Note that this delay is only applied before the first reconnection: should such 
     * reconnection fail, only the setting of {@link ConnectionOptions#setRetryDelay} will be applied.
     *    
     * <p class="default-value"><b>Default value:</b> 100 (0.1 seconds).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This value can be set and changed at any time.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "firstRetryMaxDelay" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a negative, zero, or a not-number 
     * value is passed.
     * 
     * @param {Number} firstRetryMaxDelay The max time (in milliseconds)
     * to wait before trying a new connection. 
     */
    setFirstRetryMaxDelay: function(firstRetryMaxDelay) {
      this.heavySetter("firstRetryMaxDelay",this.checkPositiveNumber(firstRetryMaxDelay));
    },
    
    /**  
     * Inquiry method that gets the maximum time to wait before trying a new connection to the Server
     * in case the previous one is unexpectedly closed while correctly working.
     *
     * @return {Number} The max time (in milliseconds)
     * to wait before trying a new connection.
     * 
     * @see ConnectionOptions#setFirstRetryMaxDelay
     */
    getFirstRetryMaxDelay: function() {
      return this.firstRetryMaxDelay;
    },
    
    /**
     * Setter method that turns on or off the slowing algorithm. This heuristic
     * algorithm tries to detect when the client CPU is not able to keep the pace
     * of the events sent by the Server on a streaming connection. In that case,
     * an automatic transition to polling is performed.
     * <BR/>In polling, the client handles all the data before issuing the
     * next poll, hence a slow client would just delay the polls, while the Server
     * accumulates and merges the events and ensures that no obsolete data is sent.
     * <BR/>Only in very slow clients, the next polling request may be so much
     * delayed that the Server disposes the session first, because of its protection
     * timeouts. In this case, a request for a fresh session will be reissued
     * by the client and this may happen in cycle.
     *
     * <p class="default-value"><b>Default value:</b> false.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This setting should be performed before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next streaming connection (either a bind
     * or a brand new session).</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "slowingEnabled" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if a not boolean value is given.
     *
     * @param {boolean} slowingEnabled true or false, to enable or disable
     * the heuristic algorithm that lowers the item update frequency. 
     */
    setSlowingEnabled: function(slowingEnabled) {
      this.heavySetter("slowingEnabled",this.checkBool(slowingEnabled));
    },
    
    /**  
     * Inquiry method that checks if the slowing algorithm is enabled or not.
     *
     * @return {boolean} Whether the slowing algorithm is enabled or not.
     *
     * @see ConnectionOptions#setSlowingEnabled
     */
    isSlowingEnabled: function() {
      return this.slowingEnabled;
    },
    
    /**
     * Setter method that can be used to disable/enable the 
     * Stream-Sense algorithm and to force the client to use a fixed transport or a
     * fixed combination of a transport and a connection type. When a combination is specified the
     * Stream-Sense algorithm is completely disabled.
     * <BR>The method can be used to switch between streaming and polling connection 
     * types and between HTTP and WebSocket transports.
     * <BR>In some cases, the requested status may not be reached, because of 
     * connection or environment problems. In that case the client will continuously
     * attempt to reach the configured status.
     * <BR>Note that if the Stream-Sense algorithm is disabled, the client may still
     * enter the "CONNECTED:STREAM-SENSING" status; however, in that case,
     * if it eventually finds out that streaming is not possible, no recovery will
     * be tried.
     * 
     * <p class="default-value"><b>Default value:</b> null (full Stream-Sense enabled).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This method can be called at any time. If called while 
     * the client is connecting or connected it will instruct to switch connection 
     * type to match the given configuration.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "forcedTransport" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if the given value is not in the list
     * of the admitted ones.
     * 
     * @param {String} forcedTransport can be one of the following:
     * <BR>
     * <ul>
     *    <li>null: the Stream-Sense algorithm is enabled and
     *    the client will automatically connect using the most appropriate
     *    transport and connection type among those made possible by the
     *    browser/environment.</li>
     *    <li>"WS": the Stream-Sense algorithm is enabled as in the null case but
     *    the client will only use WebSocket based connections. If a connection
     *    over WebSocket is not possible because of the browser/environment
     *    the client will not connect at all.</li>
     *    <li>"HTTP": the Stream-Sense algorithm is enabled as in the null case but
     *    the client will only use HTTP based connections. If a connection
     *    over HTTP is not possible because of the browser/environment
     *    the client will not connect at all.</li>
     *    <li>"WS-STREAMING": the Stream-Sense algorithm is disabled and
     *    the client will only connect on Streaming over WebSocket. If 
     *    Streaming over WebSocket is not possible because of the browser/environment
     *    the client will not connect at all.</li>
     *    <li>"HTTP-STREAMING": the Stream-Sense algorithm is disabled and
     *    the client will only connect on Streaming over HTTP. If 
     *    Streaming over HTTP is not possible because of the browser/environment
     *    the client will not connect at all.</li> 
     *    <li>"WS-POLLING": the Stream-Sense algorithm is disabled and
     *    the client will only connect on Polling over WebSocket. If 
     *    Polling over WebSocket is not possible because of the browser/environment
     *    the client will not connect at all.</li>
     *    <li>"HTTP-POLLING": the Stream-Sense algorithm is disabled and
     *    the client will only connect on Polling over HTTP. If 
     *    Polling over HTTP is not possible because of the browser/environment
     *    the client will not connect at all.</li>
     *  </ul>
     */
    setForcedTransport: function(forcedTransport) {
      if (forcedTransport !== null && !connConstants[forcedTransport]) {
        throw new IllegalArgumentException(WRONG_FORCED_TRANSPORT);
      }
      
      this.heavySetter("forcedTransport",forcedTransport);
    },
    
    /**  
     * Inquiry method that gets the value of the forced transport (if any).
     *
     * @return {String} The forced transport or null
     *
     * @see ConnectionOptions#setForcedTransport
     */
    getForcedTransport: function() {
      return this.forcedTransport;
    },


    /**
     * Setter method that can be used to disable/enable the automatic handling of 
     * server instance address that may be returned by the Lightstreamer server 
     * during session creation.
     * <BR>In fact, when a Server cluster is in place, the Server address specified 
     * through {@link ConnectionDetails#setServerAddress} can identify various Server 
     * instances; in order to ensure that all requests related to a session are 
     * issued to the same Server instance, the Server can answer to the session 
     * opening request by providing an address which uniquely identifies its own 
     * instance.
     * <BR>Setting this value to true permits to ignore that address and to always connect
     * through the address supplied in setServerAddress. This may be needed in a test
     * environment, if the Server address specified is actually a local address
     * to a specific Server instance in the cluster.
     *
     * <p class="edition-note"><B>Edition Note:</B> Server Clustering is
	 * an optional feature, available depending on Edition and License Type.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     *
     * <p class="default-value"><b>Default value:</b> false.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This method can be called at any time. If called while connected, 
     * it will be applied when the next session creation request is issued.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "serverInstanceAddressIgnored" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @throws {IllegalArgumentException} if a not boolean value is given.
     *
     * @param {boolean} serverInstanceAddressIgnored true or false, to ignore
     * or not the server instance address sent by the server.
     * 
     * @see ConnectionDetails#setServerAddress
     */
    setServerInstanceAddressIgnored: function(serverInstanceAddressIgnored) {
      this.heavySetter("serverInstanceAddressIgnored",this.checkBool(serverInstanceAddressIgnored));
    },
    
    /**  
     * Inquiry method that checks if the client is going to ignore the server
     * instance address that will possibly be sent by the server.
     *
     * @return {boolean} Whether or not to ignore the server instance address sent by the 
     * server.
     * 
     * @see ConnectionOptions#setServerInstanceAddressIgnored
     */
    isServerInstanceAddressIgnored: function() {
      return this.serverInstanceAddressIgnored;
    },
    
    /**
     * Setter method that enables/disables the cookies-are-required policy on the 
     * client side.
     * Enabling this policy will guarantee that cookies pertaining to the 
     * Lightstreamer Server will be sent with each request.
START_NODE_JSDOC_EXCLUDE
     * <BR>This holds for both cookies returned by the Server (possibly affinity cookies
     * inserted by a Load Balancer standing in between) and for cookies set by
     * other sites (for instance on the front-end page) and with a domain
     * specification which includes Lightstreamer Server host.
     * Likewise, cookies set by Lightstreamer Server and with a domain
     * specification which includes other sites will be forwarded to them.
END_NODE_JSDOC_EXCLUDE
START_WEB_JSDOC_EXCLUDE
     * <BR>This holds only for cookies returned by the Server (possibly affinity cookies
     * inserted by a Load Balancer standing in between). If other cookies received
     * by the application also pertain to Lightstreamer Server host, they must be
     * manually set through the static {@link LightstreamerClient.addCookies} method.
     * Likewise, cookies set by Lightstreamer Server and also pertaining to other hosts
     * accessed by the application must be manually extracted through the static
     * {@link LightstreamerClient.getCookies} method and handled properly.
END_WEB_JSDOC_EXCLUDE
     * <BR>On the other hand enabling this setting may prevent the client from
     * opening a streaming connection or even to connect at all depending on the
     * browser/environment.
     * 
     * <p class="default-value"><b>Default value:</b> false.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This setting should be performed before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next HTTP request or WebSocket establishment.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "cookieHandlingRequired" on any 
     * {@link ClientListener} listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called.</p>
     *
     * @throws {IllegalArgumentException} if a not boolean value is given.
     * 
     * @param {boolean} cookieHandlingRequired true/false to enable/disable the 
     * cookies-are-required policy.
     */
    setCookieHandlingRequired: function(cookieHandlingRequired) {
      this.heavySetter("cookieHandlingRequired",this.checkBool(cookieHandlingRequired));
    },
    
    /**  
     * Inquiry method that checks if the client is going to connect only if it
     * can guarantee that cookies pertaining to the server will be sent.
     *
     * @return {boolean} true/false if the cookies-are-required policy is enabled or not.
     * 
     * @see ConnectionOptions#setCookieHandlingRequired
     */
    isCookieHandlingRequired: function() {
      return this.cookieHandlingRequired;
    },
    
    /**
     * Setter method that enables/disables the "early-open" of the WebSocket 
     * connection.<BR/>
     * When enabled a WebSocket is open to the address specified through
     * {@link ConnectionDetails#setServerAddress} before a potential server instance 
     * address is received during session creation. In this case if a server instance 
     * address is received, the previously open WebSocket is closed and a new one is open 
     * to the received server instance address.<br/> 
     * If disabled, the session creation is completed to verify if such
     * a server instance address is configured in the server before opening the
     * WebSocket.<BR/>
     * For these reasons this setting should be set to false if the server 
     * configuration specifies a &lt;control_link_address&gt; and/or a
     * &lt;control_link_machine_name&gt; element in its configuration;
     * viceversa it should be set to true if such elements are not set on
     * the target server(s) configuration.
     * 
     * <p class="edition-note"><B>Edition Note:</B> Server Clustering is
	 * an optional feature, available depending on Edition and License Type.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     *
     * <p class="default-value"><b>Default value:</b> false.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This method can be called at any time. If called while 
     * the client already owns a session it will be applied the next time a session 
     * is requested to a server.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "earlyWSOpenEnabled" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @throws {IllegalArgumentException} if a not boolean value is given.
     * 
     * @param {boolean} earlyWSOpenEnabled true/false to enable/disable the 
     * early-open of the WebSocket connection.
     * 
     * @see ConnectionOptions#setServerInstanceAddressIgnored
     */
    setEarlyWSOpenEnabled: function(earlyWSOpenEnabled) {
      this.heavySetter("earlyWSOpenEnabled",this.checkBool(earlyWSOpenEnabled));
    },
    
    /**  
     * Inquiry method that checks if the client is going to early-open the
     * WebSocket connection to the address specified in 
     * {@link ConnectionDetails#setServerAddress}.
     *
     * @return {boolean} true/false if the early-open of the WebSocket connection is 
     * enabled or not.
     * 
     * @see ConnectionOptions#setEarlyWSOpenEnabled
     */
    isEarlyWSOpenEnabled: function() {
      return this.earlyWSOpenEnabled;
    },
    
    /**
     * Setter method that enables/disables the reverse-heartbeat mechanism
     * by setting the heartbeat interval. If the given value 
     * (expressed in milliseconds) equals 0 then the reverse-heartbeat mechanism will
     * be disabled; otherwise if the given value is greater than 0 the mechanism  
     * will be enabled with the specified interval.
     * <BR>When the mechanism is active, the client will ensure that there is at most
     * the specified interval between a control request and the following one,
     * by sending empty control requests (the "reverse heartbeats") if necessary.
     * <BR>This can serve various purposes:<ul>
     * <li>Preventing the communication infrastructure from closing an inactive socket
     * that is ready for reuse for more HTTP control requests, to avoid
     * connection reestablishment overhead. However it is not 
     * guaranteed that the connection will be kept open, as the underlying TCP 
     * implementation may open a new socket each time a HTTP request needs to be sent.<BR>
     * Note that this will be done only when a session is in place.</li>
     * <li>Allowing the Server to detect when a streaming connection or Websocket
     * is interrupted but not closed. In these cases, the client eventually closes
     * the connection, but the Server cannot see that (the connection remains "half-open")
     * and just keeps trying to write.
     * This is done by notifying the timeout to the Server upon each streaming request.
     * For long polling, the {@link ConnectionOptions#setIdleTimeout} setting has a similar function.</li>
     * <li>Allowing the Server to detect cases in which the client has closed a connection
     * in HTTP streaming, but the socket is kept open by some intermediate node,
     * which keeps consuming the response.
     * This is also done by notifying the timeout to the Server upon each streaming request,
     * whereas, for long polling, the {@link ConnectionOptions#setIdleTimeout} setting has a similar function.</li>
     * </ul>
     * 
     * <p class="default-value"><b>Default value:</b> 0 (meaning that the mechanism is disabled).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This setting should be performed before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the setting will be obeyed immediately, unless a higher heartbeat
     * frequency was notified to the Server for the current connection. The setting
     * will always be obeyed upon the next connection (either a bind or a brand new session).</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "reverseHeartbeatInterval" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @throws {IllegalArgumentException} if a negative, decimal
     * or a not-number value is passed.
     * 
     * @param {Number} reverseHeartbeatInterval the interval, expressed in milliseconds,
     * between subsequent reverse-heartbeats, or 0.
     */
    setReverseHeartbeatInterval: function(reverseHeartbeatInterval) {
      this.heavySetter("reverseHeartbeatInterval",this.checkPositiveNumber(reverseHeartbeatInterval,true));
    },
    
    /**
     * Inquiry method that gets the reverse-heartbeat interval expressed in 
     * milliseconds.
     * A 0 value is possible, meaning that the mechanism is disabled.
     * 
     * @return {Number} the reverse-heartbeat interval, or 0.
     * 
     * @see ConnectionOptions#setReverseHeartbeatInterval
     */
    getReverseHeartbeatInterval: function() {
      return this.reverseHeartbeatInterval;
    },
    
    /**
     * Setter method that enables/disables the setting of extra HTTP headers to all the 
     * request performed to the Lightstreamer server by the client.
     * Note that when the value is set WebSockets are disabled
START_NODE_JSDOC_EXCLUDE
     * (as the current browser client API does not support the setting of custom HTTP headers)
END_NODE_JSDOC_EXCLUDE
     * unless {@link ConnectionOptions#setHttpExtraHeadersOnSessionCreationOnly}
     * is set to true. <BR> Also note that
     * if the browser/environment does not have the possibility to send extra headers while 
     * some are specified through this method it will fail to connect.
     * Also note that the Content-Type header is reserved by the client library itself,
     * while other headers might be refused by the browser/environment and others might cause the
     * connection to the server to fail.
START_WEB_JSDOC_EXCLUDE
     * <BR>For instance, you cannot use this method to specify custom cookies to be sent to
     * Lightstreamer Server. Use the static {@link LightstreamerClient.addCookies} instead
     * (and {@link LightstreamerClient.getCookies} for inquiries). <BR>
END_WEB_JSDOC_EXCLUDE
START_NODE_JSDOC_EXCLUDE
     * <BR>For instance, you cannot use this method to specify custom cookies to be sent to
     * Lightstreamer Server. They can only be set and inquired through the browser's
     * document.cookie object. <BR>
END_NODE_JSDOC_EXCLUDE
     * The use of custom headers might also cause the
     * browser/environment to send an OPTIONS request to the server before opening the actual connection.
START_NODE_JSDOC_EXCLUDE
     * Finally, note that, in case of cross-origin requests, extra headers have to be authorized
     * on the server configuration file, in the cross_domain_policy element.
END_NODE_JSDOC_EXCLUDE
     * 
     * <p class="default-value"><b>Default value:</b> null (meaning no extra headers are sent).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This setting should be performed before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next HTTP request or WebSocket establishment.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "httpExtraHeaders" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @param {Object} headersObj a JSON object containing header-name header-value pairs. 
     * Null can be specified to avoid extra headers to be sent.
     */
    setHttpExtraHeaders: function(headersObj) {
      //we store it and dispatch it as string so that it can be passed across windows using copyByBValue
      if (!headersObj) {
        this.heavySetter("httpExtraHeaders",null);
        return;
      }
      var headersStr = "";
      for (var i in headersObj) {
        headersStr += i +"\n"+ headersObj[i]+"\n";
      }
      
      this.heavySetter("httpExtraHeaders",headersStr);
      
    },
    
    /**
     * Inquiry method that gets the JSON object containing the extra headers
     * to be sent to the server.
     * 
     * @return {Object} the JSON object containing the extra headers
     * to be sent
     * 
     * @see ConnectionOptions#setHttpExtraHeaders
     */
    getHttpExtraHeaders: function() {
      //put together the object
      if (!this.httpExtraHeaders) {
        return this.httpExtraHeaders;
      }
      var headerObj = {};
      var headersArray = this.httpExtraHeaders.split('\n');
      
      for (var i=0; i<headersArray.length-1; i+=2 ) {
        headerObj[headersArray[i]] = headersArray[i+1];
      }
      
      return headerObj;
    },
    
    /**
     * Setter method that enables/disables a restriction on the forwarding of the extra http headers 
     * specified through {@link ConnectionOptions#setHttpExtraHeaders}.
     * If true, said headers will only be sent during the session creation process (and thus
     * will still be available to the Metadata Adapter notifyUser method) but will not
     * be sent on following requests. On the contrary, when set to true, the specified extra
     * headers will be sent to the server on every request: as a consequence, if any 
     * extra header is actually specified, WebSockets will be disabled (as the current browser
     * client API does not support the setting of custom HTTP headers).
     * 
     * <p class="default-value"><b>Default value:</b> false.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This setting should be performed before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next HTTP request or WebSocket establishment.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "httpExtraHeadersOnSessionCreationOnly" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @throws {IllegalArgumentException} if a not boolean value is given.
     * 
     * @param {boolean} httpExtraHeadersOnSessionCreationOnly true/false to enable/disable the 
     * restriction on extra headers forwarding.
     */
    setHttpExtraHeadersOnSessionCreationOnly: function(httpExtraHeadersOnSessionCreationOnly) {
      this.heavySetter("httpExtraHeadersOnSessionCreationOnly",this.checkBool(httpExtraHeadersOnSessionCreationOnly));
    },
    
    /**  
     * Inquiry method that checks if the restriction on the forwarding of the 
     * configured extra http headers applies or not.
     *
     * @return {boolean} true/false if the restriction applies or not.
     * 
     * @see ConnectionOptions#setHttpExtraHeadersOnSessionCreationOnly
     */
    isHttpExtraHeadersOnSessionCreationOnly: function() {
      return this.httpExtraHeadersOnSessionCreationOnly;
    },
    
    /**
     * Setter method that sets the maximum time allowed for attempts to recover
     * the current session upon an interruption, after which a new session will be created.
     * If the given value (expressed in milliseconds) equals 0, then any attempt
     * to recover the current session will be prevented in the first place.
     * <BR>In fact, in an attempt to recover the current session, the client will
     * periodically try to access the Server at the address related with the current
     * session. In some cases, this timeout, by enforcing a fresh connection attempt,
     * may prevent an infinite sequence of unsuccessful attempts to access the Server.
     * <BR>Note that, when the Server is reached, the recovery may fail due to a
     * Server side timeout on the retention of the session and the updates sent.
     * In that case, a new session will be created anyway.
     * A setting smaller than the Server timeouts may prevent such useless failures,
     * but, if too small, it may also prevent successful recovery in some cases.</p>
     * 
     * <p class="default-value"><b>Default value:</b> 15000 (15 seconds).</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This value can be set and changed at any time.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "sessionRecoveryTimeout" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionOptions upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @throws {IllegalArgumentException} if a negative, decimal
     * or a not-number value is passed.
     * 
     * @param {Number} sessionRecoveryTimeout the maximum time allowed
     * for recovery attempts, expressed in milliseconds, including 0.
     */
    setSessionRecoveryTimeout: function(sessionRecoveryTimeout) {
      this.heavySetter("sessionRecoveryTimeout",this.checkPositiveNumber(sessionRecoveryTimeout,true));
    },
    
    /**
     * Inquiry method that gets the maximum time allowed for attempts to recover
     * the current session upon an interruption, after which a new session will be created.
     * A 0 value also means that any attempt to recover the current session is prevented
     * in the first place.
     * 
     * @return {Number} the maximum time allowed for recovery attempts, possibly 0.
     * 
     * @see ConnectionOptions#setSessionRecoveryTimeout
     */
    getSessionRecoveryTimeout: function() {
      return this.sessionRecoveryTimeout;
    },
    
    ///////////////PRIVATE
    
    /**
     * @private
     */
    hasHttpExtraHeaders: function(sessionCreation) {
      //put together the object
      if (!this.httpExtraHeaders) {
        return false;
      } else if (sessionCreation) {
        return true;
      }
      return !this.httpExtraHeadersOnSessionCreationOnly;
    },
    
    /**
     * @private
     */
    extractHttpExtraHeaders: function(sessionCreation) {
      if (!sessionCreation && this.httpExtraHeadersOnSessionCreationOnly) {
        return null;
      } else {
        return this.getHttpExtraHeaders();
      }
    },
    
    /**
     * TODO documentation
     * @private
     */
    setXDomainStreamingEnabled: function(xDomainStreamingEnabled) {
      this.heavySetter("xDomainStreamingEnabled",this.checkBool(xDomainStreamingEnabled));
    },
    
    /**
     * TODO documentation
     * @private
     */
    isXDomainStreamingEnabled: function() {
      return this.xDomainStreamingEnabled;
    },
    
    /**
     * TODO documentation
     * @private
     */
    setCorsXHREnabled: function(corsXHREnabled) {
      this.heavySetter("corsXHREnabled",this.checkBool(corsXHREnabled));
    },
    
    /**
     * TODO documentation
     * @private
     */
    isCorsXHREnabled: function() {
      return this.corsXHREnabled;
    },
    
    /**
     * TODO documentation
     * @private
     */
    setForceBindTimeout: function(_timeout) {
      this.heavySetter("forceBindTimeout",this.checkPositiveNumber(_timeout));
    },
    
    /**
     * TODO documentation
     * @private
     */
    getForceBindTimeout: function() {
      return this.forceBindTimeout;
    },
    
    /**
     * TODO documentation
     * @private
     */
    setSwitchCheckTimeout: function(_timeout) {
      this.heavySetter("switchCheckTimeout",this.checkPositiveNumber(_timeout));
    },
    
    /**
     * TODO documentation
     * @private
     */
    getSwitchCheckTimeout: function() {
      return this.switchCheckTimeout;
    },
    
    /**
     * TODO documentation
     * @private
     */
    setSpinFixTimeout: function(_timeout) {
      this.heavySetter("spinFixTimeout",this.checkPositiveNumber(_timeout));
    },
    
    /**
     * TODO documentation
     * @private
     */
    getSpinFixTimeout: function() {
      return this.spinFixTimeout;
    },
    
    /**
     * TODO documentation
     * @private
     */
    setSpinFixEnabled: function(_enabled) {
      this.heavySetter("spinFixTimeout",this._enabled === null ? null : this.checkBool(_enabled));
    },
    
    /**
     * TODO documentation
     * @private
     */
    getSpinFixEnabled: function() {
      return this.spinFixEnabled;
    },
    
    /**
     * (used by LightstreamerClient)
     * @private
     */
    installRemoteAdapterStatusObserver: function(metadataErrorCode, dataAdapterName, statusItemName, reconnectMaxDelay) {
        this.remoteAdapterStatusObserver = {
                metadataErrorCode: metadataErrorCode, 
                dataAdapterName: dataAdapterName, 
                statusItemName: statusItemName, 
                reconnectMaxDelay: reconnectMaxDelay
        };
    }
    
  };


  ConnectionOptions.prototype["setContentLength"] = ConnectionOptions.prototype.setContentLength;
  ConnectionOptions.prototype["getContentLength"] = ConnectionOptions.prototype.getContentLength;
  ConnectionOptions.prototype["setIdleTimeout"] = ConnectionOptions.prototype.setIdleTimeout;
  ConnectionOptions.prototype["getIdleTimeout"] = ConnectionOptions.prototype.getIdleTimeout;
  ConnectionOptions.prototype["setKeepaliveInterval"] = ConnectionOptions.prototype.setKeepaliveInterval;
  ConnectionOptions.prototype["getKeepaliveInterval"] = ConnectionOptions.prototype.getKeepaliveInterval;
  ConnectionOptions.prototype["setRequestedMaxBandwidth"] = ConnectionOptions.prototype.setRequestedMaxBandwidth;
  ConnectionOptions.prototype["getRequestedMaxBandwidth"] = ConnectionOptions.prototype.getRequestedMaxBandwidth;
  ConnectionOptions.prototype["getRealMaxBandwidth"] = ConnectionOptions.prototype.getRealMaxBandwidth;
  ConnectionOptions.prototype["setPollingInterval"] = ConnectionOptions.prototype.setPollingInterval;
  ConnectionOptions.prototype["getPollingInterval"] = ConnectionOptions.prototype.getPollingInterval;
  ConnectionOptions.prototype["setReconnectTimeout"] = ConnectionOptions.prototype.setReconnectTimeout;
  ConnectionOptions.prototype["getReconnectTimeout"] = ConnectionOptions.prototype.getReconnectTimeout;
  ConnectionOptions.prototype["setStalledTimeout"] = ConnectionOptions.prototype.setStalledTimeout;
  ConnectionOptions.prototype["getStalledTimeout"] = ConnectionOptions.prototype.getStalledTimeout;
  ConnectionOptions.prototype["setConnectTimeout"] = ConnectionOptions.prototype.setConnectTimeout;
  ConnectionOptions.prototype["getConnectTimeout"] = ConnectionOptions.prototype.getConnectTimeout;
  ConnectionOptions.prototype["setCurrentConnectTimeout"] = ConnectionOptions.prototype.setCurrentConnectTimeout;
  ConnectionOptions.prototype["getCurrentConnectTimeout"] = ConnectionOptions.prototype.getCurrentConnectTimeout;
  ConnectionOptions.prototype["setRetryDelay"] = ConnectionOptions.prototype.setRetryDelay;
  ConnectionOptions.prototype["getRetryDelay"] = ConnectionOptions.prototype.getRetryDelay;
  ConnectionOptions.prototype["setFirstRetryMaxDelay"] = ConnectionOptions.prototype.setFirstRetryMaxDelay;
  ConnectionOptions.prototype["getFirstRetryMaxDelay"] = ConnectionOptions.prototype.getFirstRetryMaxDelay;
  ConnectionOptions.prototype["setSlowingEnabled"] = ConnectionOptions.prototype.setSlowingEnabled;
  ConnectionOptions.prototype["isSlowingEnabled"] = ConnectionOptions.prototype.isSlowingEnabled;
  ConnectionOptions.prototype["setForcedTransport"] = ConnectionOptions.prototype.setForcedTransport;
  ConnectionOptions.prototype["getForcedTransport"] = ConnectionOptions.prototype.getForcedTransport;
  ConnectionOptions.prototype["setServerInstanceAddressIgnored"] = ConnectionOptions.prototype.setServerInstanceAddressIgnored;
  ConnectionOptions.prototype["isServerInstanceAddressIgnored"] = ConnectionOptions.prototype.isServerInstanceAddressIgnored;
  ConnectionOptions.prototype["setCookieHandlingRequired"] = ConnectionOptions.prototype.setCookieHandlingRequired;
  ConnectionOptions.prototype["isCookieHandlingRequired"] = ConnectionOptions.prototype.isCookieHandlingRequired;
  ConnectionOptions.prototype["setEarlyWSOpenEnabled"] = ConnectionOptions.prototype.setEarlyWSOpenEnabled;
  ConnectionOptions.prototype["isEarlyWSOpenEnabled"] = ConnectionOptions.prototype.isEarlyWSOpenEnabled;
  ConnectionOptions.prototype["setReverseHeartbeatInterval"] = ConnectionOptions.prototype.setReverseHeartbeatInterval;
  ConnectionOptions.prototype["getReverseHeartbeatInterval"] = ConnectionOptions.prototype.getReverseHeartbeatInterval;
  ConnectionOptions.prototype["setHttpExtraHeaders"] = ConnectionOptions.prototype.setHttpExtraHeaders;
  ConnectionOptions.prototype["getHttpExtraHeaders"] = ConnectionOptions.prototype.getHttpExtraHeaders;
  ConnectionOptions.prototype["setHttpExtraHeadersOnSessionCreationOnly"] = ConnectionOptions.prototype.setHttpExtraHeadersOnSessionCreationOnly;
  ConnectionOptions.prototype["isHttpExtraHeadersOnSessionCreationOnly"] = ConnectionOptions.prototype.isHttpExtraHeadersOnSessionCreationOnly;
  ConnectionOptions.prototype["setSessionRecoveryTimeout"] = ConnectionOptions.prototype.setSessionRecoveryTimeout;
  ConnectionOptions.prototype["getSessionRecoveryTimeout"] = ConnectionOptions.prototype.getSessionRecoveryTimeout;
  
  //
  ConnectionOptions.prototype["setXDomainStreamingEnabled"] = ConnectionOptions.prototype.setXDomainStreamingEnabled;
  ConnectionOptions.prototype["isXDomainStreamingEnabled"] = ConnectionOptions.prototype.isXDomainStreamingEnabled;
  ConnectionOptions.prototype["setCorsXHREnabled"] = ConnectionOptions.prototype.setCorsXHREnabled;
  ConnectionOptions.prototype["isCorsXHREnabled"] = ConnectionOptions.prototype.isCorsXHREnabled;
  ConnectionOptions.prototype["setForceBindTimeout"] = ConnectionOptions.prototype.setForceBindTimeout;
  ConnectionOptions.prototype["getForceBindTimeout"] = ConnectionOptions.prototype.getForceBindTimeout;
  ConnectionOptions.prototype["setSwitchCheckTimeout"] = ConnectionOptions.prototype.setSwitchCheckTimeout;
  ConnectionOptions.prototype["getSwitchCheckTimeout"] = ConnectionOptions.prototype.getSwitchCheckTimeout;
  ConnectionOptions.prototype["setSpinFixTimeout"] = ConnectionOptions.prototype.setSpinFixTimeout;
  ConnectionOptions.prototype["getSpinFixTimeout"] = ConnectionOptions.prototype.getSpinFixTimeout;
  ConnectionOptions.prototype["setSpinFixEnabled"] = ConnectionOptions.prototype.setSpinFixEnabled;
  ConnectionOptions.prototype["getSpinFixEnabled"] = ConnectionOptions.prototype.getSpinFixEnabled;

  ConnectionOptions.prototype["setRetryTimeout"] = ConnectionOptions.prototype.setRetryDelay; //keep for backward compatibility with 6.1
  ConnectionOptions.prototype["getRetryTimeout"] = ConnectionOptions.prototype.getRetryDelay; //keep for backward compatibility with 6.1
  ConnectionOptions.prototype["setIdleMillis"] = ConnectionOptions.prototype.setIdleTimeout; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["getIdleMillis"] = ConnectionOptions.prototype.getIdleTimeout; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["setKeepaliveMillis"] = ConnectionOptions.prototype.setKeepaliveInterval; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["getKeepaliveMillis"] = ConnectionOptions.prototype.getKeepaliveInterval; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["setPollingMillis"] = ConnectionOptions.prototype.setPollingInterval; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["getPollingMillis"] = ConnectionOptions.prototype.getPollingInterval; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["setReverseHeartbeatMillis"] = ConnectionOptions.prototype.setReverseHeartbeatInterval; //keep for backward compatibility with 6.2 (and 7.0.1)
  ConnectionOptions.prototype["getReverseHeartbeatMillis"] = ConnectionOptions.prototype.getReverseHeartbeatInterval; //keep for backward compatibility with 6.2 (and 7.0.1)

  Inheritance(ConnectionOptions, Bean);
  Inheritance(ConnectionOptions, RetryDelayCounter, true); // mixin  
  Inheritance(ConnectionOptions, ConnectTimeoutCounter, true); // mixin

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var ASSERT = /*@__PURE__*/(function() {
  var logger = LoggerManager.getLoggerProxy("weswit.test");
  
  var failures = 0;
  
  var VOID = {};
  
  /**
   * you can use method of ASSERT to verify conditions
   * If a conditions is not met ASSERT.failures is increased
   * and an error log line is printed on the ASSERT category
   * @exports ASSERT
   */
  var ASSERT = {
    /**
     * The VOID property to be used in various calls
     */
    "VOID": VOID,
    
    /**
     * Gets the number of failures. A failure is added
     * each time any of the other methods return false.
     * @returns {Number}
     */
    getFailures: function() {
      return failures;
    },
    
    /**
     * Checks that two arrays contain the same elements
     * the sameOrder flag can be used to specify if the
     * elements must be in the same order in both arrays.
     * 
     * @param {Array} arr1 the first array to be compared
     * @param {Array} expected the second array to be compared
     * @param {Boolean} sameOrder true if the elements in the 
     * arrays must be placed in the same order, false otherwise.
     * In the latter case duplicated entries will be considered
     * as one.
     * 
     * @return true if the test pass, false otherwise.
     */
    compareArrays: function(arr1,expected,sameOrder) {
      if (arr1.length != expected.length) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(497),arr1,expected);
        return false;
      }
      
      if (!sameOrder) {
        var genMap = {};
        for (var i=0; i<arr1.length; i++) {
          genMap[arr1[i]] = 1;
        }
        
        for (var i=0; i<expected.length; i++) {
          if (!genMap[expected[i]]) {
            logger.logError(LoggerManager.resolve(498),expected[i]);
            this.failInternal();
            return false;
          } else {
            genMap[expected[i]]++;
          }
        }
        
        for (var i in genMap) {
          if (genMap[i] == 1) {
            logger.logError(LoggerManager.resolve(499),genMap[i]);
            this.failInternal();
            return false;
          }
        }
        
      } else {
        for (var i=0; i<arr1.length; i++) {
          if(arr1[i] != expected[i]) {
            logger.logError(LoggerManager.resolve(500), arr1[i], expected[i]);
            this.failInternal();
            return false;
          }
        }
      }
      
      return true;
    },
    
    /**
     * Calls the function method (passed as a string) of the
     * obj instance using param (that is an array of parameters) 
     * as parameters and verifies that the result is equal to res.
     * Specify ASSERT.VOID as param to not pass any input parameter.
     * Specify ASSERT.VOID as res to avoid checks on the return value.
     * Pass a function as compareFun if the check between res and 
     * the return value can't be done with a simple comparison (==) 
     * and must be done by such compareFun method, specify true as
     * compareFun if the check must be performed using the strict 
     * equal operator (===). The tested function is expected to not
     * throw any exception.
     * 
     * @param {Object} obj the object upon which the function method will 
     * be called
     * @param {String} method the name of the function to be called
     * @param {Array} param an array of parameters to be passed to the
     * function call or ASSERT.VOID if no parameters have to be passed.
     * @param {*} res the expected value or ASSERT.VOID if no value is
     * expected.
     * @param {Boolean|Function} [compareFun] if not specified the return 
     * value will be compared with the res parameter using the equal 
     * operator (==). If true is specified the strict equal operator 
     * (===) is used. If a function is passed the return value will 
     * be compared by such function with the res parameter.
     * 
     * @returns true if the function executes without exception 
     * and returns with the expected value, false otherwise.
     */
    verifySuccess: function(obj,method,param,res,compareFun) {
      return this.verify(obj,method,param,res,false,compareFun);
    },
    
    /**
     * Calls the function method (passed as a string) of the
     * obj instance using param (that is an array of parameters) 
     * as parameters and verifies that the method exits with an
     * exception.
     * Specify ASSERT.VOID as param to not pass any input parameter.
     * 
     * @param {Object} obj the object upon which the function method will 
     * be called
     * @param {String} method the name of the function to be called
     * @param {Array} param an array of parameters to be passed to the
     * function call or ASSERT.VOID if no parameters have to be passed.
     * 
     * @returns true if the function throws an exception, false otherwise.
     */
    verifyException: function (obj,method,param) {
      return this.verify(obj,method,param,null,true);
    },
    
    /**
     * Verifies that the given value is not null (strict check)
     * @param {*} val1 the value to be checked.
     * @returns {Boolean}
     */
    verifyNotNull: function(val1) {
      if (val1 === null) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(501),val1);
        return false;
      }
      return true;
    },
    
    /**
     * Compares two values.
     * 
     * @param {*} val1 the first value to be compared.
     * @param {*} val2 the second value to be compared.
     * @param {Boolean|Function} [compareFun] if not specified the return 
     * value will be compared with the res parameter using the equal 
     * operator (==). If true is specified the strict equal operator 
     * (===) is used. If a function is passed the return value will 
     * be compared by such function with the res parameter.
     * 
     * @returns true if the two values are the same, false otherwise.
     */
    verifyValue: function(val1,val2,compareFun) {
      var ok = false;
      if (compareFun === true) {
        ok = val1===val2;
      } else if (compareFun) {
        ok = compareFun(val1,val2);
      } else if (!isNaN(val1)) {
        
        var c1 = val1 && val1.charAt ? val1.charAt(0) : null;
        var c2 = val2 && val2.charAt ? val2.charAt(0) : null;
        
        if (c1 == "." || c1 == " " || c1 == "0" || c2 == "." || c2 == " " || c2 == "0") {
          ok = String(val1)==String(val2);
        } else {
          ok = val1==val2;
        }
        
        
      } else {
        ok = val1==val2;
      }
       
      if (!ok) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(502),val1,val2);
        return false;
      }
      return true;
    },
    
    /**
     * Compares two values expecting'em to be different.
     * 
     * @param {*} val1 the first value to be compared.
     * @param {*} val2 the second value to be compared.
     * @param {Boolean} [strict] if true a strict comparison
     * is performed.
     * 
     * @returns true if the two values are different, false otherwise.
     */
    verifyDiffValue: function(val1,val2,strict) {
      var ok = false;
      if (strict) {
        ok = val1 !== val2;
      } else {
        ok = val1 != val2;
      }
      
      if (!ok) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(503),val1,val2);
        return false;
      }
      return true;
    },
    
    /**
     * Simple check for a valid value 
     * (0, "", NaN etc do not pass this test)
     * 
     * @param {*} val the value to be checked.
     * @returns {Boolean} true if a valid value is passed, false otherwise.
     */
    verifyOk: function(val) {
      if (!val) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(504));
        return false;
      }
      return true;
    },
    
    /**
     * Simple check for a not valid value 
     * (0, "", NaN etc pass this test)
     * 
     * @param {*} val the value to be checked.
     * @returns {Boolean} true if a not valid value is passed, false otherwise.
     */
    verifyNotOk: function(val) {
      if (val) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(505));
        return false;
      }
      return true;
    },
    
    /**
     * Fails in any case
     * @returns {Boolean} false is always returned.
     */
    fail: function() {
      logger.logError(LoggerManager.resolve(506));
      this.failInternal();
      return false;
    },
    
    /**
     * @private
     */
    failInternal: function() {
      failures++;
    },
    
    /**
     * @private
     */
    verify: function(obj,method,param,res,expectingException,compareFun) {
      var flag = false;
      var ret = null;
      var exc = null;
      try {
        if (param !== VOID) {
          ret = obj[method].apply(obj,param);
        } else {
          ret = obj[method]();  
        }
        
      } catch(_e) {
        flag = true;
        exc = _e;
      }
      
      var what = expectingException ? "succes" : "failure";
      var ok = expectingException == flag;
      if (!ok) {
        this.failInternal();
        logger.logError(LoggerManager.resolve(507),what,"for",method,param,res,exc);
        return false;
      }
      
      
      if (!expectingException && res !== VOID) {
        return this.verifyValue(ret,res,compareFun);
      }
      return true;
    }
    
  };
  
  //closure exports
  ASSERT["getFailures"] = ASSERT.getFailures;
  ASSERT["fail"] = ASSERT.fail;
  ASSERT["verifyNotOk"] = ASSERT.verifyNotOk;
  ASSERT["verifyOk"] = ASSERT.verifyOk;
  ASSERT["verifyDiffValue"] = ASSERT.verifyDiffValue;
  ASSERT["verifyNotNull"] = ASSERT.verifyNotNull;
  ASSERT["verifyValue"] = ASSERT.verifyValue;
  ASSERT["verifyException"] = ASSERT.verifyException;
  ASSERT["verifySuccess"] = ASSERT.verifySuccess;
  ASSERT["compareArrays"] = ASSERT.compareArrays;
  
  
  return ASSERT;
})();

var protocolLogger = LoggerManager.getLoggerProxy(Constants.PROTOCOL);

  var SBU_PORTION = "STREAMING_IN_PROGRESS";
  var BIND_SESSION = "bind_session";
  var CREATE_SESSION = "create_session";
  
  var LSVersionParam = "LS_cid=" + Constants.LS_CID + "&";
  //                                   NOTE: the final & is not part of the CID
  
  var validMachinaName = new RegExp("^[a-z][a-z0-9\-]+$");
  var validHost = new RegExp("^((?:[a-z][a-z.0-9\-]+)\.(?:[a-z][a-z\-]+))(?![\\w.])");
  var validIP = new RegExp("^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?![\d])");
  var validIPv6 = new RegExp("^[a-f0-9:]+$");
  
   
  
  var RequestsHelper = {
    
    /**
     * 
     * @param {String} serverAddress
     * @return {boolean} true if the address is valid, an error message otherwise (hint, check it with === true)
     * @private
     */
    /*public*/ verifyServerAddress: function(serverAddress) {
      serverAddress = serverAddress.toLowerCase();
      var endSch = serverAddress.indexOf("http://") == 0 ? 7 : (serverAddress.indexOf("https://") == 0 ? 8 : -1);
      if (endSch == -1) {
        return "The given server address has not a valid scheme";
      }
      
      var startPort = serverAddress.lastIndexOf(":");
      startPort = startPort > endSch ? startPort : serverAddress.length;
      
      
      var port = this.extractPort(serverAddress,serverAddress.indexOf("://"));
      if (port != null && isNaN(port.substring(1))) {
        return "The given server address has not a valid port";
      }
      
      
      var endHost = serverAddress.indexOf("/",endSch);
      endHost = endHost < startPort ? endHost : startPort;
      
      
      if (serverAddress.charAt(endSch) == "[") {
        //IPv6
        
        var endIp = serverAddress.lastIndexOf("]");
        var toTest = serverAddress.substring(endSch+1,endIp);
        
        if (!validIPv6.test(toTest)) {
          return "The given server address is not a valid IPv6";
        }
        
      } else {
        
        var toTest = serverAddress.substring(endSch,endHost) ;
        
        
        if (toTest.indexOf(".") > -1) {
          if (!validHost.test(toTest)) {
            if (!validIP.test(toTest)) {
              return "The given server address is not a valid URL";
            }
          }
        } else if (!validMachinaName.test(toTest)) {
          return "The given server address is not a valid machine name";
        }
      }
      
      return true;
    },
    
    /*private*/ readUrl: function(url) {
        var urlParts = {};
        var schemaEnd = url.indexOf("://");
        if (schemaEnd != -1) {
            urlParts.schema = url.substring(0, schemaEnd);
            url = url.substring(schemaEnd + 3);
        } else {
            urlParts.schema = null;
        }
        var pathStart = url.indexOf("/");
        if (pathStart != -1) {
            urlParts.path = url.substring(pathStart);
            url = url.substring(0, pathStart);
        } else {
            urlParts.path = null;
        }
        var portStart = this.extractPortStart(url);
        if (portStart != -1) {
            urlParts.port = url.substring(portStart);
            urlParts.host = url.substring(0, portStart - 1);
        } else {
            urlParts.port = null;
            urlParts.host = url;
        }
        return urlParts;
    },

    /*private*/ writeUrl: function(urlParts) {
        var url = urlParts.host;
        if (urlParts.schema != null) {
            url = urlParts.schema + "://" + url;
        }
        if (urlParts.port != null) {
            url += ":" + urlParts.port;
        }
        if (urlParts.path != null) {
            url += urlParts.path;
        }
        if (url.substring(url.length - 1) != "/") {
            url += "/";
        }
        return url;
    },

    /*private*/ extractPortStart: function(address) {
        var portStarts = address.indexOf(":");
        if (portStarts <= -1) {
            return -1;
        }
        if (address.indexOf("]") > -1) {
            portStarts = address.indexOf("]:");
            if (portStarts <= -1) {
                return -1;
            }
            return portStarts + 2;
        } else if (portStarts != address.lastIndexOf(":")) {
            return -1;
        } else {
            return portStarts + 1;
        }
    },
  
    /*public*/ completeControlLink: function(extractFrom, controlLink) { 
        var baseUrl = this.readUrl(extractFrom);
        var clUrl = this.readUrl(controlLink);
        var fullClUrl = {
            schema: clUrl.schema != null ? clUrl.schema : baseUrl.schema,
            host: clUrl.host,
            port: clUrl.port != null ? clUrl.port : baseUrl.port,
            path: clUrl.path
        };
        return this.writeUrl(fullClUrl);
    },
    
    /*public*/ getPushCommand: function(
            pushPhase, sessionId, policyBean, connectionBean, 
            isCreate, isPolling, oldSession, reconnectionCause, 
            delay, askCL, askDomain,
            serverBusy) {
      
      var domainParam = askDomain && Environment.isBrowserDocument() && !Utils.hasDefaultDomain() ? "LS_domain=" + Utils.getDomain() + "&" : "";
      
      var LSContextParams = "LS_phase=" + pushPhase + "&" + domainParam + (reconnectionCause?"LS_cause="+reconnectionCause+"&":"");
    
      if (isCreate || isPolling) {
        //polling
        LSContextParams += "LS_polling=true&";
        
        var requestedPollingInterval = 0;
        var requestedIdleTimeout = 0;
        if (isPolling) {
           //real polling
          
          requestedPollingInterval = Number(policyBean.pollingInterval);
          // proponiamo il nostro polling interval,
          // anche se il server potra' costringerci ad un'attesa minore.
          // Da notare che noi stessi ci riserviamo poi di poter effettuare
          // un'attesa minore, se ne vale la pena; per esempio sul secondo polling
          if (delay != null && !isNaN(delay)) {
            // chiediamo al Server piu' tempo, per compensare la nostra lentezza
            requestedPollingInterval += delay;
          }
          
          requestedIdleTimeout = policyBean.idleTimeout;
          
        }
        
        if (!isNaN(requestedPollingInterval)) {
            LSContextParams += "LS_polling_millis=" + requestedPollingInterval + "&";
        }
        if (!isNaN(requestedIdleTimeout)) {
          LSContextParams += "LS_idle_millis=" + requestedIdleTimeout + "&";
        }
  
      } else {
        if (policyBean.keepaliveInterval > 0) {
          LSContextParams += "LS_keepalive_millis=" + policyBean.keepaliveInterval + "&";
        }
        
        if (policyBean.reverseHeartbeatInterval > 0) {
          LSContextParams += "LS_inactivity_millis=" + policyBean.reverseHeartbeatInterval + "&";
        }
          
        if (askCL) {
          LSContextParams += "LS_content_length=" + policyBean.contentLength + "&";
        }
      }
    
      if (!isCreate) {   
        // gestione della richiesta di aggancio a una sessione esistente;
        // bisogna usare l'indirizzo indicato nella sessione, se esiste
        
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyOk(sessionId)) {
          protocolLogger.logError(LoggerManager.resolve(508));
        }
      //>>excludeEnd("debugExclude");
  
        var LS_SessionString = "LS_session=" + sessionId + "&";
        
        var res = LS_SessionString + LSContextParams;
        
        protocolLogger.logDebug(LoggerManager.resolve(509),res);
        
        // URL di attivazione Lightstreamer
        return res;
  
      } else {
        // inizio una nuova sessione.

        //ok I know bandwidth has nothing to do with user params, btw...it's just a variable name :)
        
        var LSUserParams = "";
        if (policyBean.requestedMaxBandwidth > 0) { // <=0 means unlimited
          LSUserParams += "LS_requested_max_bandwidth=" + policyBean.requestedMaxBandwidth + "&";
        } 
        
        if (connectionBean.adapterSet != null) {
          LSUserParams += "LS_adapter_set=" + encodeURIComponent(connectionBean.adapterSet) + "&";
        }
        if (connectionBean.user != null) {
          LSUserParams += "LS_user=" + encodeURIComponent(connectionBean.user) + "&";
        }
        
        var lsUrl = /*"LS_op2=create&" +*/ LSContextParams + LSVersionParam + LSUserParams;
        if (oldSession) {
          // esiste gia` una sessione aperta; la nuova sessione la sostituira`.
          // per evitare problemi di diritti sulle risorse, la richiesta viene
          // corredata dall'indicazione della vecchia sessione da 'rottamare'
          lsUrl += ("LS_old_session=" + oldSession + "&");
        }
        
        if (serverBusy) {
            lsUrl += "LS_ttl=unlimited&";
        }
        
        protocolLogger.logDebug(LoggerManager.resolve(510),lsUrl);
        
        //first log the request, then attach the password...
        if (connectionBean.password != null) {
          lsUrl += "LS_password=" + encodeURIComponent(connectionBean.password) + "&";
        }
        
        return lsUrl;
      }
    },
    
    /**
     * A recovery request is a special type of bind_session request with the additional LS_recovery_from parameter.
     */
    getRecoveryCommand: function(pushPhase, sessionId, policyBean, reconnectionCause, delay, askDomain, sessionRecoveryProg) {
        var domainParam = askDomain && Environment.isBrowserDocument() && !Utils.hasDefaultDomain() ? "LS_domain=" + Utils.getDomain() + "&" : "";
        
        var LSContextParams = "LS_phase=" + pushPhase + "&" + domainParam + (reconnectionCause?"LS_cause="+reconnectionCause+"&":"");
        
        LSContextParams += "LS_polling=true&";
        var requestedPollingInterval = 0;
        if (delay != null && !isNaN(delay)) {
            requestedPollingInterval += delay;
        }
        LSContextParams += "LS_polling_millis=" + requestedPollingInterval + "&";
        LSContextParams += "LS_idle_millis=0&";
            
        if (policyBean.requestedMaxBandwidth > 0) { // <=0 means unlimited
            LSContextParams += "LS_requested_max_bandwidth=" + policyBean.requestedMaxBandwidth + "&";
        }
        
        LSContextParams += "LS_session=" + sessionId + "&";
        
        LSContextParams += "LS_recovery_from=" + sessionRecoveryProg + "&";
        
        protocolLogger.logDebug(LoggerManager.resolve(511), LSContextParams);
        
        return LSContextParams;
    },
    
    /*public*/ getDestroyParams: function(sessionId,reason) {
      var _data = {
          "LS_op": "destroy",
          "LS_session": sessionId,
          "LS_reqId": Utils.nextRequestId()
      };
      
      if (reason) {
        _data["LS_cause"]=reason;
      }
      
      protocolLogger.logDebug(LoggerManager.resolve(512));
      
      return _data;
    },
    
    /*public*/ getForceRebindParams: function(rebindCause,_delay) {
      var _data = {
          "LS_op": "force_rebind",
          "LS_reqId": Utils.nextRequestId()
      };
      if (rebindCause) {
        _data["LS_cause"]=rebindCause;
      }
      
      if(_delay != null && !isNaN(_delay)) {
        _data["LS_polling_millis"]=_delay;
      }
      
      protocolLogger.logDebug(LoggerManager.resolve(513));
      
      return _data;
    },
    
    /*public*/ getLogRequestParams: function(pushPhase,msg,buildNum) {
      msg["LS_build"] = buildNum;
      msg["LS_phase"] = pushPhase;
      return msg; 
    },
    
    /*public*/ getConstraintParams: function(policyBean) {
      return {
        "LS_op": "constrain",
        "LS_requested_max_bandwidth": (policyBean.requestedMaxBandwidth > 0 ? policyBean.requestedMaxBandwidth : "unlimited"),
        "LS_reqId": Utils.nextRequestId()
      };
    },
    
    /*public*/ getPushPath: function(isCreate,isPolling,suffix) {
      var res;
      if (isPolling || (suffix != null && suffix.indexOf(".txt") == 0) || suffix == "") {
          if (isCreate) {
              res = this.getCreateSessionExtraPath() + CREATE_SESSION + suffix;
          } else {
              res = BIND_SESSION + suffix;
          }
          
      } else {
          if (isCreate) {
              res = this.getCreateSessionExtraPath() + SBU_PORTION;
          } else {
              res = SBU_PORTION;
          }
      }
      return res;
    },
    
    /**
     * The recovery request is a special type of bind_session.
     */
    getRecoveryPath: function(suffix) {
        return BIND_SESSION + suffix;
    },
    
    /*private*/ getCreateSessionExtraPath: function() {
      return "";
    },

    /*private*/ setCID: function(str) {
        // available for test clients using the source code
        LSVersionParam = str;
    },
    
    /*private*/ extractPort: function(extractFrom,protLoc) {
        var portStarts = extractFrom.indexOf(":",protLoc+1);
        if (portStarts <= -1) {
          return null;
        }
        
        if (extractFrom.indexOf("]") > -1) {
          portStarts = extractFrom.indexOf("]:");
          if (portStarts <= -1) {
            return null;
          }
          portStarts+=1;
          
        } else if (portStarts != extractFrom.lastIndexOf(":")) {
          return null;
        }
          
        
        var portEnds = extractFrom.indexOf("/",protLoc+3);
        
        return portEnds > -1 ? extractFrom.substring(portStarts,portEnds) : extractFrom.substring(portStarts);
         
      }
    
  };

var varNames$2 = {
      serverAddress: "serverAddress",
      adapterSet: "adapterSet",
      user: "user",
      password: "password",
      serverInstanceAddress: "serverInstanceAddress",
      serverSocketName: "serverSocketName",
      sessionId: "sessionId",
      clientIp: "clientIp"
  };
  varNames$2 = Utils.getReverse(varNames$2); 
  
  var doNotLogValueList = {password:true};

  
  var DEFAULT_SERVER = !Environment.isBrowser() || (location.protocol != "http:" && location.protocol != "https:")  ? null : (location.protocol + "//" + location.hostname + (location.port ? ":"+location.port : "") + "/");
  

  
  /**
   * Used by LightstreamerClient to provide a basic connection properties data object.
   * @constructor
   *
   * @exports ConnectionDetails
   * @class Data object that contains the configuration settings needed
   * to connect to a Lightstreamer Server.
   * <BR/>The class constructor, its prototype and any other properties should never
   * be used directly; the library will create ConnectionDetails instances when needed.
   * <BR>Note that all the settings are applied asynchronously; this means that if a
   * CPU consuming task is performed right after the call, the effect of the setting 
   * will be delayed.
   * 
   * @see LightstreamerClient
   */
  var ConnectionDetails = function(){
    
  
    
    //server to connect to
    //web client has a default == page's host; if loaded from file:/// the default will generate an exception during the connect call
    /**
     * @private
     */
    this.serverAddress =  DEFAULT_SERVER;
    
    //Name of the adapter set to use
    /**
     * @private
     */
    this.adapterSet = null;
    
    //User name to connect with the adapter set
    /**
     * @private
     */
    this.user = null;
    
    //Password to connect with the adapter set
    /**
     * @private
     */
    this.password = null;
    
    /**
     * @private
     */
    this.serverInstanceAddress = null;
    /**
     * @private
     */
    this.serverSocketName = null;
    /**
     * @private
     */
    this.sessionId = null;

    /**
     * @private
     */
    this.doNotLogValueList = doNotLogValueList;
    /**
     * @private
     */
    this.varNames = varNames$2;
    
    this._callSuperConstructor(ConnectionDetails,arguments); 
    
    /**
     * @private
     */
    this.constr = "ConnectionDetails";
    
  };
  
  ConnectionDetails.prototype = {
      
    /**
     * Setter method that sets the address of Lightstreamer Server.
START_NODE_JSDOC_EXCLUDE
     * Setting Lightstreamer Server address is not required when the front-end
     * pages are supplied by Lightstreamer Server itself (although this
     * scenario is advised only for demo purpose).
     * On the other hand, the setting should be configured if the front-end pages are
     * served by an external Web server or loaded directly from the file system or
     * the library is not running inside a browser. 
     * <BR>When the client application is downloaded from a web server, the configured
     * server address should have the same protocol as the client page itself. If this
     * requirement is not respected, the client, depending on the browser in use, 
     * may be unable to open a streaming connection and will try to resort
     * to polling. 
END_NODE_JSDOC_EXCLUDE
     * <BR>Note that the addresses specified must always have the http: or https: scheme.
     * In case WebSockets are used, the specified scheme is 
     * internally converted to match the related WebSocket protocol
     * (i.e. http becomes ws while https becomes wss).
     * 
     * <p class="edition-note"><B>Edition Note:</B> HTTPS is an optional
	 * feature, available depending on Edition and License Type.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     * 
START_NODE_JSDOC_EXCLUDE
     * <p class="default-value"><b>Default value:</b> the address of the server
     * that supplies the library pages if any, null otherwise.</p>
END_NODE_JSDOC_EXCLUDE
     * 
     * <p class="lifecycle"><b>Lifecycle:</b>This method can be called at any time. If called while connected, 
     * it will be applied when the next session creation request is issued.
     * <BR>This setting can also be specified in the {@link LightstreamerClient} 
     * constructor.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "serverAddress" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionDetails upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @throws {IllegalArgumentException} if the given address is not valid.
     *
     * @param {String} serverAddress The full address of Lightstreamer Server.
     * A null value can also be used, to restore the default value.
     * An IPv4 or IPv6 can also be used in place of a hostname, if compatible with
     * the environment in use (see the notes in the summary of this documentation).
     * Some examples of valid values include:
     * <BR>http://push.mycompany.com
     * <BR>http://push.mycompany.com:8080
     * <BR>http://79.125.7.252
     * <BR>http://[2001:0db8:85a3:0000:0000:8a2e:0370:7334]
     * <BR>http://[2001:0db8:85a3::8a2e:0370:7334]:8080
     * 
     */
    setServerAddress: function(serverAddress) {
      if (serverAddress === null) {
        serverAddress = DEFAULT_SERVER;
      } else {
        
        if (serverAddress.substr(serverAddress.length-1) != "/") {
          serverAddress+="/";
        }
        var _valid = RequestsHelper.verifyServerAddress(serverAddress);
        if (_valid !== true) {
          throw new IllegalArgumentException(_valid);
        }
         
      }
      
      this.heavySetter("serverAddress",serverAddress);
    },  
    
    /**
     * Inquiry method that gets the configured address of Lightstreamer Server.
     * 
     * @return {String} the configured address of Lightstreamer Server.
     */
    getServerAddress: function() {
      return this.serverAddress;
    },
 
    /** 
     * Setter method that sets the name of the Adapter Set mounted on 
     * Lightstreamer Server to be used to handle all requests in the session.
     * <BR>An Adapter Set defines the Metadata Adapter and one or several
     * Data Adapters. It is configured on the server side through an
     * "adapters.xml" file; the name is configured through the "id" attribute
     * in the &lt;adapters_conf&gt; element.
     *
     * <p class="default-value"><b>Default value:</b> The default Adapter Set, configured as
     * "DEFAULT" on the Server.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The Adapter Set name should be set on the
     * {@link LightstreamerClient#connectionDetails} object before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next time a new session is 
     * requested to the server.
     * <BR>This setting can also be specified in the {@link LightstreamerClient} 
     * constructor.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "adapterSet" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionDetails upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @param {String} adapterSet The name of the Adapter Set to be used. A null value 
     * is equivalent to the "DEFAULT" name.
     */
    setAdapterSet: function(adapterSet) {
      this.heavySetter("adapterSet",adapterSet);
    },
    
    /**  
     * Inquiry method that gets the name of the Adapter Set (which defines
     * the Metadata Adapter and one or several Data Adapters) mounted on
     * Lightstreamer Server that supply all the items used in this application.
     *
     * @return {String} the name of the Adapter Set; returns null if no name
     * has been configured, so that the "DEFAULT" Adapter Set is used.
     *
     * @see ConnectionDetails#setAdapterSet
     */
    getAdapterSet: function() {
      return this.adapterSet;
    },
        
    
    /**
     * Setter method that sets the username to be used for the authentication
     * on Lightstreamer Server when initiating the push session.
     * The Metadata Adapter is responsible for checking the credentials
     * (username and password).
     * 
     * <p class="default-value"><b>Default value:</b> If no username is supplied, no user
     * information will be sent at session initiation. The Metadata Adapter,
     * however, may still allow the session.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The username should be set on the
     * {@link LightstreamerClient#connectionDetails} object before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next time a new session is 
     * requested to the server.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "user" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionDetails upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @param {String} user The username to be used for the authentication
     * on Lightstreamer Server. The username can be null.
     *
     * @see ConnectionDetails#setPassword
     */
    setUser: function(user) {
      this.heavySetter("user",user);
    },
    
    /**  
     * Inquiry method that gets the username to be used for the authentication
     * on Lightstreamer Server when initiating the push session.
     * 
     * @return {String} the username to be used for the authentication
     * on Lightstreamer Server; returns null if no user name
     * has been configured.
     *
     * @see ConnectionDetails#setUser
     */
    getUser: function() {
      return this.user;
    },
    
    /**
     * Setter method that sets the password to be used for the authentication
     * on Lightstreamer Server when initiating the push session.
     * The Metadata Adapter is responsible for checking the credentials
     * (username and password).
     * 
     * <p class="default-value"><b>Default value:</b> If no password is supplied, no password
     * information will be sent at session initiation. The Metadata Adapter,
     * however, may still allow the session.</p>
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> The username should be set on the
     * {@link LightstreamerClient#connectionDetails} object before calling the
     * {@link LightstreamerClient#connect} method. However, the value can be changed
     * at any time: the supplied value will be used for the next time a new session is 
     * requested to the server.
     * <BR><b>NOTE:</b> The password string will be stored as a JavaScript
     * variable.
     * That is necessary in order to allow automatic reconnection/reauthentication
     * for fail-over. For maximum security, avoid using an actual private
     * password to authenticate on Lightstreamer Server; rather use
     * a session-id originated by your web/application server, that can be
     * checked by your Metadata Adapter.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "password" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient owning the ConnectionDetails upon 
     * which the setter was called
END_NODE_JSDOC_EXCLUDE
     * .</p>
     * 
     * @param {String} password The password to be used for the authentication
     * on Lightstreamer Server. The password can be null.
     *
     * @see ConnectionDetails#setUser
     */
    setPassword: function(password) {
      this.heavySetter("password",password);
    },
    
    /**
     * Inquiry method that gets the server address to be used to issue all requests
     * related to the current session. In fact, when a Server cluster is in
     * place, the Server address specified through 
     * {@link ConnectionDetails#setServerAddress} can identify various Server 
     * instances; in order to ensure that all requests related to a session are 
     * issued to the same Server instance, the Server can answer to the session 
     * opening request by providing an address which uniquely identifies its own 
     * instance.
     * When this is the case, this address is returned by the method;
     * otherwise, null is returned.
     * <BR>Note that the addresses will always have the http: or https: scheme.
     * In case WebSockets are used, the specified scheme is 
     * internally converted to match the related WebSocket protocol
     * (i.e. http becomes ws while https becomes wss).
     *
     * <p class="edition-note"><B>Edition Note:</B> Server Clustering is
	 * an optional feature, available depending on Edition and License Type.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> The method gives a meaningful answer only when
     * a session is currently active.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "serverInstanceAddress" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient that received the setting from the
     * server
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @return {String} address used to issue all requests related to the current
     * session.
     */
    getServerInstanceAddress: function() { 
      return this.serverInstanceAddress;
    },
    
    /**
     * Inquiry method that gets the instance name of the Server which is
     * serving the current session. To be more precise, each answering port
     * configured on a Server instance (through a &lt;http_server&gt; or
     * &lt;https_server&gt; element in the Server configuration file) can be given
     * a different name; the name related to the port to which the session
     * opening request has been issued is returned.
     * <BR>Note that in case of polling or in case rebind requests are needed,
     * subsequent requests related to the same session may be issued to a port
     * different than the one used for the first request; the names configured
     * for those ports would not be reported. This, however, can only happen
     * when a Server cluster is in place and particular configurations for the
     * load balancer are used.
     *
     * <p class="edition-note"><B>Edition Note:</B> Server Clustering is
     * an optional feature, available depending on Edition and License Type.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> The method gives a meaningful answer only when
     * a session is currently active.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "serverSocketName" on any 
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same 
     * connection with the LightstreamerClient that received the setting from the
     * server
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @return {String} name configured for the Server instance which is managing the
     * current session.
     */
    getServerSocketName: function() { 
      return this.serverSocketName;
    },

    /**
     * Inquiry method that gets the ID associated by the server
     * to this client session.
     *
     * <p class="lifecycle"><b>Lifecycle:</b> The method gives a meaningful answer only when
     * a session is currently active.</p>
     *
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a
     * call to {@link ClientListener#onPropertyChange} with argument "sessionId" on any
     * {@link ClientListener}
START_NODE_JSDOC_EXCLUDE
     * listening to any LightstreamerClient sharing the same
     * connection with the LightstreamerClient that received the setting from the
     * server
END_NODE_JSDOC_EXCLUDE
     * .</p>
     *
     * @return {String} ID assigned by the Server to this client session.
     */
    getSessionId: function() {
      return this.sessionId;
    },
    
    /**
     * Inquiry method that gets the IP address of this client as seen by the Server which is serving
     * the current session as the client remote address (note that it may not correspond to the client host;
     * for instance it may refer to an intermediate proxy). If, upon a new session, this address changes,
     * it may be a hint that the intermediary network nodes handling the connection have changed, hence the network
     * capabilities may be different. The library uses this information to optimize the connection. <BR>  
     * Note that in case of polling or in case rebind requests are needed, subsequent requests related to the same 
     * session may, in principle, expose a different IP address to the Server; these changes would not be reported.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> If a session is not currently active, null is returned;
     * soon after a session is established, the value may become available; but it is possible
     * that this information is not provided by the Server and that it will never be available.</p>
     * 
     * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to 
     * {@link ClientListener#onPropertyChange} with argument "clientIp" on any 
     * ClientListener listening to the related LightstreamerClient.</p>
     * 
     * @return {String} A canonical representation of an IP address (it can be either IPv4 or IPv6), or null.
     */
    getClientIp: function() {
        return this.clientIp;
    }
    
  };
  
  ConnectionDetails.prototype["setServerAddress"] = ConnectionDetails.prototype.setServerAddress;
  ConnectionDetails.prototype["getServerAddress"] = ConnectionDetails.prototype.getServerAddress;
  ConnectionDetails.prototype["setAdapterSet"] = ConnectionDetails.prototype.setAdapterSet;
  ConnectionDetails.prototype["getAdapterSet"] = ConnectionDetails.prototype.getAdapterSet;
  ConnectionDetails.prototype["setUser"] = ConnectionDetails.prototype.setUser;
  ConnectionDetails.prototype["getUser"] = ConnectionDetails.prototype.getUser;
  ConnectionDetails.prototype["setPassword"] = ConnectionDetails.prototype.setPassword;
  ConnectionDetails.prototype["getServerInstanceAddress"] = ConnectionDetails.prototype.getServerInstanceAddress;
  ConnectionDetails.prototype["getServerSocketName"] = ConnectionDetails.prototype.getServerSocketName;
  ConnectionDetails.prototype["getSessionId"] = ConnectionDetails.prototype.getSessionId;
  ConnectionDetails.prototype["getClientIp"] = ConnectionDetails.prototype.getClientIp;
  
  Inheritance(ConnectionDetails, Bean);

/**
   * can be used as mixin, just call initChannel in your constructor
   * @constructor
   */
  var StandardHandler = {
    createCaller: function (name, definition) {
      if (definition.wantsResponse) {

        if (definition.addSessionPhase) {
          return function () {
            try {
              var r = this.target[name].apply(this.target, [this.sessionPhase].concat(Utils.argumentsToArray(arguments)));
              return Promise.resolve(r);
            } catch(e) {
              return Promise.reject(e);
            }
          };

        } else {
          return function () {
            try {
              var r = this.target[name].apply(this.target, arguments);
              return Promise.resolve(r);
            } catch(e) {
              return Promise.reject(e);
            }
          };
        }



      } else {
        if (definition.addSessionPhase) {
          return function () {
            try {
              this.target[name].apply(this.target, [this.sessionPhase].concat(Utils.argumentsToArray(arguments)));
            } catch (e) {
                console.error(e);
            }
          };
        } else {
          return function () {
            try {
              this.target[name].apply(this.target, arguments);
            } catch (e) {
                console.error(e);
            }
          };
        }
      }
    }
  };

function CallDefinition(wantsResponse,addSessionPhase,responseTimeout) {
    this.wantsResponse = wantsResponse;
    this.addSessionPhase = addSessionPhase;
    this.responseTimeout = responseTimeout || false;
  }
  var WANTS_RESPONSE = true;
  var NO_RESPONSE = false;
  var SESSION_BOUND = true;
  var NOT_BOUND = false;

  CallDefinition.simple = new CallDefinition(NO_RESPONSE,NOT_BOUND);
  CallDefinition.simpleWithResponse = new CallDefinition(WANTS_RESPONSE,NOT_BOUND);
  CallDefinition.simpleWithResponseAndTimeout = new CallDefinition(WANTS_RESPONSE,NOT_BOUND,2000);
  CallDefinition.session = new CallDefinition(NO_RESPONSE,SESSION_BOUND);
  CallDefinition.sessionWithResponse = new CallDefinition(WANTS_RESPONSE,SESSION_BOUND);
  CallDefinition.sessionWithResponseAndTimeout = new CallDefinition(WANTS_RESPONSE,SESSION_BOUND,4000);

var simple = CallDefinition.simple;
  var simpleWithSession = CallDefinition.session;
  //var simpleWithResponse = CallDefinition.simpleWithResponse;
  var simpleWithResponseAndTimeout = CallDefinition.simpleWithResponseAndTimeout;
  var sessionWithResponse = CallDefinition.sessionWithResponse;

  var methods = {
    onClientConfigurationChange: simple,
    callConnect: simpleWithSession,
    callDisconnect: simpleWithSession,
    pong: simpleWithResponseAndTimeout,
    subscribeTable: sessionWithResponse,
    unsubscribeTable: simpleWithSession,
    updateSubscriptionParams: simpleWithSession,
    forwardMessage: simpleWithSession,
    forwardLog: simple,
    clientDeath: simple,
    callDisconnectAndReconnect: simpleWithSession
  };
  
  var sharingLogger$1 = LoggerManager.getLoggerProxy(Constants.SHARING);

  var NewEngineHandler = function (client) {
    this.client = client;
    this.sessionAlive = false;
    this.sessionPhase = -1;
    this.engineId = null;
    this.engineType = "local";
  };

  NewEngineHandler.methods = methods;

  NewEngineHandler.prototype = {

    setPushPageHandler: function(pushpageHandler) {
      this.target = pushpageHandler; //for direct communication
    },

    setEngineId: function(id) {
      sharingLogger$1.logInfo(LoggerManager.resolve(514), this.engineType, id);
      this.engineId = id;
    },

    getEngineId: function() {
      return this.engineId;
    },

    dispose: function() {
      this.client = null;
      //future calls will get an exception that will cause an onPushPageLost event in the PushPage collection if remote
    },

    setSessionPhase: function(ph) {
      this.sessionPhase = ph;
    },

    isSessionAlive: function() {
      return this.sessionAlive;
    },

//calls from pushpage handler

    onEngineConfigurationChange: function(objClass,prop,val) {
      var toSet = objClass == "ConnectionDetails" ? this.client._connection : (objClass == "ConnectionOptions" ? this.client._policy : this.client._configuration);
      toSet.simpleSetter(prop, val);
    },

    onSessionEnd: function(ph) {
      this.sessionPhase = ph;
      if (this.sessionAlive) {
        this.sessionEnd(ph);
      }
    },

    sessionEnd: function(ph) {
      this.sessionAlive = false;
      this.client.sessionEnd();
    },

    onSessionStart: function(ph) {
      this.sessionPhase = ph;
      this.sessionAlive = true;
      this.client.sessionStart();
    },

    /**
     * @param noHopeToAttachToAnotherEngine if true, the client must not try to attach to another engine
     */
    onEngineDeath: function(suiciding, noHopeToAttachToAnotherEngine) {
        sharingLogger$1.logInfo(LoggerManager.resolve(515), this.engineId + " is dead");
        if (this.client) {
            this.sessionEnd(-1);
            this.client.engineMourningRoom(suiciding, noHopeToAttachToAnotherEngine);          
        }
    },

    checkDeath: function() {
      var that = this;
      this.pong()["then"](function() {
        //if didn't fail we're ok
      },function() {
        if (that.client) {
          that.onEngineDeath();
        }
      });
    },

    onEngineDying: function() {
      //there is the possibility that the engine is dead,
      //but also a resurrection is possible
      //so first check right now if the engine is still there
      this.checkDeath();
      //then check in 1 second
      Executor.addTimedTask(this.checkDeath,1000,this);
    },

    onServerError: function(flag,msg) {
      this.client.serverError(flag,msg);
    },

    onStatusChange: function(newStatus) {
      this.client.cacheEngineStatus(newStatus);
    },

    onSubscription: function(tableCode,keyPos,commandPos,numOfSubscribedItems,numOfSubscribedFields) {
      this.client.getTablesHandler().subscriptionEvent(tableCode,keyPos,commandPos,numOfSubscribedItems,numOfSubscribedFields);
    },

    onSubscriptionError: function(tableCode,code,msg) {
      this.client.getTablesHandler().errorEvent(tableCode,code,msg);
    },

    onUnsubscription: function(tableCode) {
      this.client.getTablesHandler().unsubscriptionEvent(tableCode);
    },

    onEndOfSnapshot: function(tableCode,item) {
      this.client.getTablesHandler().onEndOfSnapshotEvent(tableCode,item);
    },

    onUpdate: function(args,snap) {
      this.client.getTablesHandler().updatePage(args,snap);
    },

    onLostUpdates: function(tableCode,item,losts) {
      this.client.getTablesHandler().onLostUpdatesEvent(tableCode,item,losts);
    },

    onClearSnapshot: function(tableCode,item) {
      this.client.getTablesHandler().onClearSnapshotEvent(tableCode,item);
    },

    onMessageDiscarded: function(prog) {
      this.client.getMessageProxy().messageDiscarded(prog);
    },

    onMessageDenied: function(prog,_code,msg) {
      this.client.getMessageProxy().messageDenied(prog, _code, msg);
    },

    onMessageError: function(prog,_code,msg) {
      this.client.getMessageProxy().messageError(prog, _code, msg);
    },

    onMessageComplete: function(prog) {
      this.client.getMessageProxy().messageComplete(prog);
    },

    onMessageOnNetwork: function(prog) {
      this.client.getMessageProxy().messageOnNetwork(prog);
    },

    ping: function() {
      if(this.client === null) {
        throw "net";
      }
      return true;
    },

    onServerKeepalive: function() {
        this.client.onServerKeepalive();
    },
    
    onSubscriptionReconf: function(tableCode, frequency) {
        this.client.getTablesHandler().doSubscriptionReconf(tableCode, frequency);
    }

  };

  for (var i in methods) {
    NewEngineHandler.prototype[i] = StandardHandler.createCaller(i,methods[i]);
  }

var _RGX1 = "^https?://(?:[a-z][a-z0-9\-]+\.)*";
  //var _RGX1 = "^https?://([a-z\d\-]+\.)*";
  var _RGX2 = "(?:/|$|:)";

  var Request = function(_path,_file,_data,_method,cookieFlag,extraHeaders) {
    this.setPath(_path);
    this.setFile(_file);
    this.setData(_data);
    this.setMethod(_method);
    this.setCookieFlag(cookieFlag);
    this.setExtraHeaders(extraHeaders);
  };
  
  Request._GET = "GET";
  Request._POST = "POST";


  Request.prototype = {
    toString: function(){
      return ["[",this._path,this._file,this._data,this._method,"]"].join("|");
    },
    
    setPath: function(_path) {
      while (_path && _path.substring(_path.length-1) == "/") {
        _path = _path.substring(0,_path.length-1);
      }
      this._path = _path;
    },
    
    setFile: function(_file) {
      while (_file && _file.substring(0,1) == "/") {
        _file = _file.substring(1);
      }
      this._file = _file;
    },
    
    setMethod: function(_method) {
      this._method = _method || Request._POST;
    },
    
    setCookieFlag: function(cookieFlag) {
      this.cookieFlag = cookieFlag || false;
    },
    
    setExtraHeaders: function(extraHeaders) {
      this.extraHeaders = extraHeaders || null;
    },
    
    setData: function(_data) {
      this._data = _data;
    },
    
    extendData: function(moreData) {
      if (!this._data) {
        this.setData(moreData);
      } else if (!this.containsData(moreData)) {
        this._data += moreData;
      }
    },
    
    containsData: function(someData) {
      return this._data && this._data.indexOf(someData) > -1;
    },
    
    ////
    
    getPath: function() {
      return this._path;
    },
    
    getFile: function() {
      return this._file;
    },
    
    getUrl: function() {
      if (this._file) {
        return this._path+"/"+this._file;
      } else {
        return this._path;
      }
    },
    
    getCookieFlag: function() {
      return this.cookieFlag;
    },
    
    getExtraHeaders: function(extraHeaders) {
      return this.extraHeaders;
    },
    
    getData: function() {
      return this._data;
    },
    
    getUrlWithParams: function(sep) {
      if (this._data) {
        return this.getUrl()+"?"+this._data;
      } else {
        return this.getUrl();
      }
    },
    
    getMethod: function() {
      return this._method;
    },
    
    clone: function() {
      return new Request(this._path,this._file,this._data,this._method,this.cookieFlag,this.extraHeaders);
    },
    
    isRelativeRequest: function() {
      return !(this._path.indexOf("http://") == 0 || this._path.indexOf("https://") == 0 || this._path.indexOf("file:///") == 0);
    },
    
    /**
     * 
     * @param theDomain
     * @param prot in the form "scheme:"
     */
    isSameDomain: function(theDomain,prot) {
      
      if (!Environment.isBrowser()) {
        return false;
      }
      
      if (this.isRelativeRequest()) {
        //relative address
        return Environment.isWebWorker() ? location.hostname == theDomain :  Utils.getDomain() == theDomain;
        //on webworkers the document.domain is not accessible, the best aproximation is the location.hostname value
        
      } else if (prot) {
        if (!this.isSameProtocol(prot)) {
          //may be same domain but on a different protocol, we consider it not same domain
          return false;
        }
        
        if (prot == "file:") {
          //file requests have empty domain
          return theDomain == "";
        }
        
      }
      
      //convert the domain so that it can be used as part of a regexp
      theDomain = theDomain.replace(".","\.");
      //then make the regexp
      var rgx = new RegExp(_RGX1+theDomain+_RGX2,"i");
      
      //and test it
      return rgx.test(this._path);
      
    },
    
   
    isSameProtocol: function(prot) {
      
      if (!Environment.isBrowser()) {
        return false;
      }
      
      if (prot.indexOf(":") != prot.length-1) {
        //wrong form
        return false;
      }
      
      return this.isRelativeRequest() ? location.protocol == prot : this._path.indexOf(prot) == 0;
    },
    
    isCrossSite: function() {
      if (!Environment.isBrowser()) {
        return true;
      }
      
      var refDomain = Environment.isWebWorker() ? location.hostname :  Utils.getDomain(); 
      
      return !this.isSameDomain(refDomain,location.protocol);
    },
    
    isCrossProtocol: function() {
      if (!Environment.isBrowser()) {
        return true;
      }
      return !this.isSameProtocol(location.protocol);
    }
    
  };
  
  Request.aboutBlank = new Request("about:blank");

//we may make this an extension of request?
    
  var requestsLogger = LoggerManager.getLoggerProxy(Constants.REQUESTS);

  function ControlRequest(request,related,_type,relatedKey,retryingOrHost) {
    this.request = request;
    this.related = related;
    this.relatedKey = relatedKey;
    this._type = _type;
    this.retryingOrHost = retryingOrHost;
  }

  ControlRequest.ADD = 1;
  ControlRequest.REMOVE = 2;
  ControlRequest.CONSTRAINT = 3;
  ControlRequest.MESSAGE = 4;
  ControlRequest.LOG = 5;
  ControlRequest.DESTROY = 6;
  ControlRequest.FORCE_REBIND = 7;
  ControlRequest.HEARTBEAT = 8;  
  ControlRequest.CHANGE_SUB = 9;
  ControlRequest.MPN = 10;


  ControlRequest.prototype = {
    toString: function() {
      var req = (requestsLogger.isDebugLogEnabled() ? JSON.stringify(this.request) : this.request);
      return ["[","ControlRequest",this.relatedKey,this._type,this.retryingOrHost,req,"]"].join("|");
    },
    
    getBridge: function() {
      return this.related;
    },
    
    getKey: function() {
      return this.relatedKey;
    },
    
    getType: function() {
      return this._type;
    },
    
    getRequest: function() {
      return this.request;
    }
    
   
  };

var SEND_MESSAGE = "msg";
  var SEND_LOG = "send_log";
  var CONTROL = "control";
  var HEARTBEAT = "heartbeat";
  
  var MEX_PARAM = "LS_message";
  var LEN_PARAM = "LS_unq";
  
  function getCustomizedPath(_type) {
    if (_type == ControlRequest.MESSAGE) {
      return SEND_MESSAGE;
    } else  if (_type == ControlRequest.LOG) { 
      return SEND_LOG;
    } else  if (_type == ControlRequest.HEARTBEAT) { 
      return HEARTBEAT;
    } else {
      return CONTROL;
    }
  }
  
  
  var Encoder = function() {
    
  };
  
  
  Encoder.prototype = {
      
      toString: function() {
        return "[Encoder]";
      },
      
      initRequest: function(queue,cookieRequired,extraHeaders) {
        //(queue); //sets file and method, not server
        
        var req = new Request();
        var path = getCustomizedPath(queue.getBatchType());
        var ext = this.getExt();
        req.setFile(path + ext);
        req.setMethod(Request._POST);
        req.setCookieFlag(cookieRequired);
        req.setExtraHeaders(extraHeaders);
        
        return req;
        
      },
      
      /**
       * @return null if all requests are discarded in the process 
       */
      /*private*/ encode: function(queue,sessionId,first) {
        var data = first ? "" : "\r\n";
        
        while (queue.getLength() > 0) {
        
          
          var controlRequest = queue.firstRequest();
     
         
          var bridge = controlRequest.getBridge();
          var requestType = controlRequest.getType();
          
          
          /*if (requestType == ControlRequest.ADD && bridge.verifySuccess()) {
            //verifySuccess returns true if the pushPagehandler disappeared or if a deleteTable event was received
            //so that getPushPageHandlerFromTableNumber returns null
            queue.shift();
          } else if (requestType == ControlRequest.REMOVE && bridge.verifySuccess()) {
            //if the related add was not sent, it's useless to send the delete request
            //there is no risk that the related add request is somewhere in queue because each tableNumber
            //is related to a single couple of ADD-REMOVE requests and the delete can't arrive before the add. 
            //BTW even if the add request is on the queue it will be discarded because the deleteTable event
            //removes the table reference from the pushPageHandlers so that the isSubscribed method returns true so that 
            //the add is not sent anyway
            bridge.notifyAborted();
            queue.shift();
          
          } else*/ if (bridge && bridge.verifySuccess()) {
            //if verify success is true means that an answer arrived while the request was in the queue.
            //In case of a send message if we send it we risk an LS_msg_num=undefined message cause HTTPEncoder may not be able to get a prog number for the handled message
            bridge.notifyAborted();
            queue.shift();
            
          } else {
            
            var params = controlRequest.getRequest();
            
            if (requestType == ControlRequest.MESSAGE) {
              return data+this.encodeMessageRequest(params,bridge,sessionId);
            
            } else if (requestType == ControlRequest.DESTROY) {
              return data+this.encodeDestroyRequest(params,bridge,sessionId);
              
            } else if (requestType == ControlRequest.HEARTBEAT) {
              return data+this.encodeHeartbeatRequest(params,bridge,sessionId);
              
            } else if (requestType == ControlRequest.LOG) {
              return data+this.encodeLogRequest(params,bridge,sessionId);
              
            } else { //CHANGE_SUB - CONSTRAINT - FORCE_REBIND - ADD - REMOVE
              return data+this.encodeControlRequest(params,bridge,sessionId);
            }
            
          }
        
        
        }
        return null;
        
      },
      
      expand: function(params,unquotedParam) {
        var data = "";
        if (params) {
          for (var name in params) {
            if (name !== unquotedParam) {
              data += name+"="+params[name]+"&";
            } 
          }
        }
        return data;
      },
    
      
      /*private*/ encodeRequest: function(params,extraParams,sessionId) {
        var data = this.expand(params);
        data += this.expand(extraParams);
        
        
        
        return data;
      },
      
      encodeUnqRequest: function(params,extraParams,unquotedParam,sessionId) {
        var data = this.expand(params,unquotedParam);
        data += this.expand(extraParams,unquotedParam);
        
        if (params[unquotedParam]) {
          data += unquotedParam+"="+params[unquotedParam];
        } else if (extraParams) {
          data += unquotedParam+"="+extraParams[unquotedParam];
        }

        var unq = data.length;
        
        return LEN_PARAM+"="+unq+"&"+data;
      },
      
      wrapUp: function(requestData) {
        // if there is no data, return a blank line because the server dislikes empty requests
        return requestData ? requestData : "\n";
      },
      
      /*protected*/ getExt: function() {
        return ".txt" + "?LS_protocol=" + Constants.TLCP_VERSION;
      },
      
      /*protected*/ getFixedOverhead: function(fileName) {
        return 0;
      },
      
      /*protected*/ getInvisibleOverhead: function(data) {
        return 2; //the \r\n that separates requests one from the following 
      },
      
      /*protected*/ encodeControlRequest: function(params,bridge,sessionId,extraParams) {
        return this.encodeRequest(params,extraParams,sessionId);
      },
      
      /*protected*/ encodeDestroyRequest: function(params,bridge,sessionId,extraParams) {
        // here the session ID to be specified may not be the current one
        // and it is already included among the base parameters
        return this.encodeRequest(params,extraParams,sessionId);
      },
      
      /*protected*/ encodeHeartbeatRequest: function(params,bridge,sessionId,extraParams) {
        return this.encodeRequest(params,extraParams,sessionId);
      },
      
      /*protected*/ encodeLogRequest: function(params,bridge,sessionId,extraParams) {
        return this.encodeRequest(params,extraParams,sessionId);
      },
      
      /*protected*/ encodeMessageRequest: function(params,bridge,sessionId,extraParams) {
        //    righe di questo tipo non sono ammesse se la richiesta viene sovraencodata tramite il parametro LS_querystring (il vecchio caso "form").
        //encodeURIComponent(LS_message)
        return this.encodeUnqRequest(params,extraParams,MEX_PARAM,sessionId);
      }
  };

var unique = 1;
  
  var names = {
      encodeMessageRequest: "encodeMessageRequest",
      encodeControlRequest: "encodeControlRequest",
      encodeDestroyRequest: "encodeDestroyRequest",
      encodeHeartbeatRequest: "encodeHeartbeatRequest",
      encodeLogRequest: "encodeLogRequest"
  };
  names = Utils.getReverse(names); 
  
  var HTTPEncoder = function() {
    
  };
  
  HTTPEncoder.prototype = {
      /*private*/ encodeMessageRequest: function(params,bridge,sessionId,extraParams) {
        extraParams = Utils.extendObj(extraParams,{"LS_session": sessionId});
        return this._callSuperMethod(HTTPEncoder,names['encodeMessageRequest'],[params,bridge,sessionId,extraParams]);
      },
      
      /*private*/ encodeControlRequest: function(params,bridge,sessionId,extraParams) {
        extraParams = Utils.extendObj(extraParams,{"LS_session": sessionId});
        return this._callSuperMethod(HTTPEncoder,names['encodeControlRequest'],[params,bridge,sessionId,extraParams]);
      },
      
      /*private*/ encodeDestroyRequest: function(params,bridge,sessionId,extraParams) {
        return this._callSuperMethod(HTTPEncoder,names['encodeDestroyRequest'],[params,bridge,sessionId,extraParams]);
      },
      
      /*private*/ encodeHeartbeatRequest: function(params,bridge,sessionId,extraParams) {
        if (sessionId) {
          //heartbeat can be sent with or without LS_session
          extraParams = Utils.extendObj(extraParams,{"LS_session": sessionId});
        }
        extraParams = Utils.extendObj(extraParams,{"LS_unique": unique++});
        return this._callSuperMethod(HTTPEncoder,names['encodeHeartbeatRequest'],[params,bridge,sessionId,extraParams]);
      },
      
      /*private*/ encodeLogRequest: function(params,bridge,sessionId,extraParams) {
        if (sessionId) {
          //send_log can be sent with or without LS_session
          extraParams = Utils.extendObj(extraParams,{"LS_session": sessionId});
        }
        extraParams = Utils.extendObj(extraParams,{"LS_unique": unique++});
        return this._callSuperMethod(HTTPEncoder,names['encodeLogRequest'],[params,bridge,sessionId,extraParams]);
      },
      
      expand: function(params,unquotedParam) {
        var data = "";
        if (params) {
          for (var name in params) {
            if (name !== unquotedParam) {
              data += name+"="+params[name]+"&";
            } else {
              data += name+"="+encodeURIComponent(params[name])+"&";
            }
          }
        }
        return data;
      },
      
      //unquoted requests not supported, so we encode parameters that are not encoded and we do not attach the LS_unq parameter
      encodeUnqRequest: function(params,extraParams,unquotedParam) {
        var data = this.expand(params,unquotedParam);
        data += this.expand(extraParams,unquotedParam);
        
        return data;
      }
  };
  
  
  Inheritance(HTTPEncoder,Encoder);

var nodeUtils = {
    NodeWS: null,
    NodeXHR: null,
    getGlobalCookiesForNode: function() {},
    addGlobalCookiesForNode: function() {}
};

function retFalse() {
    return false;
  }

  function retTrue() {
    return true;
  }

  var BASIC_ENCODER = new HTTPEncoder();

  /**
   * ServerConnection interface to be implemented for a ServerConnection type to be used with ControlConnectionHandler
   * or to connect with the server
   * @private
   */
  var ServerConnection = function() {
    for(var i in  {_load:true}) {
      //used by implementation to call super methods without using the static string everywhere (it's a trick)
      this._loadName=i;
    }

    //implementation MUST declare the constr variable with their constructon on each instance.
    this.constr = ServerConnection;

  };

  ServerConnection.attachPublicStaticMethods = function(_class,obj) {
    for (var i in obj) {
      if (obj[i] === true) {
        _class[i] = retTrue;
      } else if (obj[i] === false) {
        _class[i] = retFalse;
      } else {
        _class[i] = obj[i];
      }
    }
  };

  ServerConnection.attachPublicStaticMethods(ServerConnection,{
    /**
     * @static
     * whenever this Class can be used in this browser.
     * It is possible to return true even if the connection is not available at the moment
     * in such case any call to the load method of any instance of this class must return null; btw
     * such situation can't go on forever so that after a timeout (handled by the class) this method and
     * the load method of any instance of this class MUST return false.
     *
     * If the load method of an instance of this class returns false this method MUST return false too
     * @param serverAddress the address this class is going to be used for
     * @private
     */
    isAvailable: false,
    isCrossSite: false,
    isCrossProtocol: false,
    areCookiesGuaranteed: false,
    attachEngineId: false,
    isStreamEnabled: false,
    canUseCustomHeaders: false
  });


  ServerConnection.prototype = {

    /**
     * if possible closes the connection, otherwise do nothing
     * @private
     */
    _close: function() {
      return;
    },

    sessionLoad: function(request,phase,responseCallback,errorCallback,connectionEndCallback,engId) {

      return this._load(request,phase,responseCallback,errorCallback,connectionEndCallback);
    },

    /**
     * Method that loads a requests
     * @param {Object} request
     * @param {Number} phase the phase of the request, must be returned as the second parameter of the callbacks
     * @param {Function} responseCallback this callback must be called when the request is complete. The first parameter
     * must be the result fetched while the second one is the phase and must be the same value passed to the load method.
     * In case the ServerConnection implementation does not handle server response for any reason it must call the responseCallback
     * callback with the first parameter set as null (for instance, the FakeNotifyConnection calls the callback after 1 second with no
     * idea of what has happened to the request; you may want to extend such abstract class if once sent you don't have any
     * idea on what happens to the request).
     * @param {Function} errorCallback this callback must be called if the request fails in any way.
     * It's completely alternative to the response callback (any load call produces only one between a responseCallback call
     * and a errorCallback call) It has 2 parameters, the first one represents the error (you may want to use an
     * Exception instance) the other one is the phase and must be the same value passed to the load method
     * @param {boolean} connectionEndCallback a callback to be called when the connection class is unsure if the connection
     * ended correctly or was broken; may be useful on Streaming connections implemented with XHR
     *
     * @return {boolean} true if the request was (presumably) sent, null if the request can't be sent but
     * probably can be sent in the future or false if there is no way this instance can send the request;
     * if this method returns null after a certain number of calls MUST return true or false;
     * @private
     */
    _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      return false;
    },

    getEncoder: function() {
      return BASIC_ENCODER;
    }
  };

//START_WEB_JSDOC_EXCLUDE
  ServerConnection.getGlobalCookiesForNode = nodeUtils.getGlobalCookiesForNode;
  ServerConnection.addGlobalCookiesForNode = nodeUtils.addGlobalCookiesForNode;

var log$2 = LoggerManager.getLoggerProxy("assertions");
    
    /**
     * Assertion utilities.
     * 
     * @since May 2018
     */
    var Assertions = {
            assert: function(cond, msg) {
                if (! cond) {
                   this.fail(msg);
                }
            },
            
            assertNotNull: function(val, msg) {
                if (val == null) {
                    this.fail(msg);
                }
            },
            
            assertNull: function(val, msg) {
                if (val != null) {
                    this.fail(msg);
                }
            },
            
            assertEquals: function(a, b, msg) {
                if (a !== b) {
                    this.fail(msg + ": Expected " + a + " but found " + b);
                }
            },
            
            implies: function(a, b, msg) {
                this.assert(! a || b, msg);
            },
            
            fail: function(msg) {
                if (msg != null) {
                    log$2.logError(msg);
                }
                ASSERT.fail();
            },
            
            verifyOk: function(a, msg) {
                if (! ASSERT.verifyOk(a)) {
                    if (msg != null) {
                        log$2.logError(msg);
                    }
                }
            },
            
            verifyNotOk: function(a, msg) {
                if (! ASSERT.verifyNotOk(a)) {
                    if (msg != null) {
                        log$2.logError(msg);
                    }
                }
            },
            
            verifyValue: function(a, b, msg) {
                if (! ASSERT.verifyValue(a, b, null)) {
                    if (msg != null) {
                        log$2.logError(msg);
                    }
                }
            },
            
            verifyDiffValue: function(a, b, msg) {
                if (! ASSERT.verifyDiffValue(a, b, null)) {
                    if (msg != null) {
                        log$2.logError(msg);
                    }
                }
            }
    };

var MessageProxy = function(engineHandler) {
    this.lastMessageListener = -1;
    this.pendingMessageListeners = {};
    this.pendingMessages = {};
    this.pendingMessagesOnNetwork = {};
    this.pendingMLCount = 0;
    this.engineHandler = engineHandler;
    this.queuedMessages = new List();
  };
  
  MessageProxy.prototype = {
      
    /*public*/ switchEngineHandler: function(engineHandler) {
      this.engineHandler = engineHandler;
    },  
      
    /*public*/ getMessageListenerProxy: function(message,listener) {
      this.lastMessageListener++;
      this.pendingMessageListeners[this.lastMessageListener] = listener;
      this.pendingMessages[this.lastMessageListener] = message;
      this.pendingMessagesOnNetwork[this.lastMessageListener] = false;
      this.pendingMLCount++;
      return this.lastMessageListener;
      /*
      var proxy = {};
      proxy.pageNum = this.engineHandler.getPageNumber();
      proxy.prog = this.lastMessageListener;
      return proxy;
      */
    },
    
    /*private*/ getListener: function(listenerProg) {
      return this.pendingMessageListeners[listenerProg];      
    },
    
    /*private*/ getOriginalMessage: function(listenerProg) {
      return this.pendingMessages[listenerProg];      
    },
    
    /*private*/ wasSentOnNetwork: function(listenerProg) {
      return this.pendingMessagesOnNetwork[listenerProg];      
    },
    
    /*public*/ cleanMessageListeners: function() {
      // Chiamato quando si perde l'Engine, oppure quando avviene una disconnessione;
      // nel secondo caso, lo strato di comunicazione garantisce che non si
      // riceveranno altre chiamate dall'Engine legate alla sessione finita.
      // Quindi possiamo ripartire da uno stato vuoto senza rischio di sovrapposizioni.

      // clear the enqueueWhileDisconnected queue if anything is there (if a message 
      // with a listener is there we will fire the on abort (such is listener is
      // in the pendingMessageListeners collection)
      this.clearQueuedMessages();
      

      // dobbiamo chiamare i listeners nell'ordine giusto;
      // non vogliamo ciclare a vuoto su un array arbitrariamente lungo;
      // gli elementi interessati dovrebbero essere tutti verso la fine;
      
      var _elements = [];
      for (var i in this.pendingMessageListeners) {
        _elements.push(i);
      }
      
      _elements.sort(function(a, b) {  
        return a - b;  
      });
      
      for (var i = 0; i < _elements.length; i++) {
        this.messageAbort(_elements[i]);
      }
      
      /*
      var _elements = {};
      var prog = 0;
      for (var i = this.lastMessageListener; i >= 0; i--) {
        if (prog == this.pendingMLCount) {
          break;
        }
        if (this.pendingMessageListeners[i]) {
          _elements[prog] = i;
          prog++;
        }
      }
      for (var i = prog - 1; i >= 0; i--) {
        this.messageAbort(_elements[i]);
      }*/
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(this.pendingMLCount,0, "Unexpected pending messages");
    //>>excludeEnd("debugExclude");
      this.lastMessageListener = -1;
      this.pendingMessageListeners = {};
      this.pendingMessages = {};
      this.pendingMessagesOnNetwork = {};
      this.pendingMLCount = 0;
    },
    
    /*private*/ clean: function(listenerProg) {
      delete this.pendingMessageListeners[listenerProg];
      delete this.pendingMessages[listenerProg];
      delete this.pendingMessagesOnNetwork[listenerProg];
      this.pendingMLCount--;
    },
    
    /*public*/  messageOnNetwork: function(listenerProg) {
      var listener = this.getListener(listenerProg);
      if (listener) {
        this.pendingMessagesOnNetwork[listenerProg] = true;
      }
    },
    
//////////MESSAGE QUEUE
    enqueueMessage: function(msg,sequence,listener,timeout) {
      this.queuedMessages.add({msg:msg,sequence:sequence,listener:listener,timeout:timeout});
    },
    
    /*private*/ clearQueuedMessages: function() {
      var that = this;
      this.queuedMessages.forEach(function(el) {
        //abort: call it here or it will never be called as this message does not have a listener proxy
        that.fireEvent("onAbort",el.listener,[el.msg,false]);
      });
      this.queuedMessages.clean();
    },
    
    handleAllWaitingMessages: function() {
      var that = this;
      this.queuedMessages.forEach(function(el) {
        //var listenerProxy = this.getMessageListenerProxy(el.msg,el.listener);
        that.forwardMessage(el.msg,el.sequence,el.listener,el.timeout);
      });
      this.queuedMessages.clean();
    },
    
    forwardMessage: function(msg,sequence,listener,timeout) {
      var listenerProxy = null;
      if (listener) {
        // non possiamo passare un listener alla pagina Engine:
        // lo sostituiamo con un indice in un array locale
        listenerProxy = this.getMessageListenerProxy(msg,listener);
      }
      this.engineHandler.forwardMessage(msg,sequence,listenerProxy,timeout);
    },
    
//////////EVENTS DISPATCHING
    
    fireEvent: function(event,listener,params) {
      if (!listener || !listener[event]) {
        return;
      }
      Executor.addTimedTask(listener[event],0,listener,params);
    },
    
    /*public*/ messageComplete: function(listenerProg) {
      var listener = this.getListener(listenerProg);
      
      this.fireEvent("onProcessed",listener,[this.getOriginalMessage(listenerProg)]);
      
      this.clean(listenerProg);
     
    },
    
    /*public*/ messageError: function(listenerProg,_code,msg) {
      var listener = this.getListener(listenerProg);
      if (_code != 32 && _code != 33) {
          /* errors 32 and 33 must not be notified to the user
           * because they are due to late responses of the server */
          this.fireEvent("onError",listener,[this.getOriginalMessage(listenerProg)]);
      }
      
      this.clean(listenerProg);
    },
    
    /*public*/ messageDenied: function(listenerProg,_code,msg) {
      var listener = this.getListener(listenerProg);
      
      this.fireEvent("onDeny",listener,[this.getOriginalMessage(listenerProg),_code,msg]);
           
      this.clean(listenerProg);
    },
    
    /*public*/ messageDiscarded: function(listenerProg) {
      var listener = this.getListener(listenerProg);
      
      this.fireEvent("onDiscarded",listener,[this.getOriginalMessage(listenerProg)]);
      
      this.clean(listenerProg);
    },
    
    /*private*/ messageAbort: function(listenerProg) {
      var listener = this.getListener(listenerProg);
     
      this.fireEvent("onAbort",listener,[this.getOriginalMessage(listenerProg),this.wasSentOnNetwork(listenerProg)]);
      
      this.clean(listenerProg);
    }    
    
  };

function UpdateCopy(args,reuse) {
   
    var copiedArgs = reuse ? args : [];
    copiedArgs.changedFields = [];
    if(!reuse) {
      copiedArgs[0] = parseInt(args[0]);
      copiedArgs[1] = parseInt(args[1]);
    }
    
    for (var i = 2, l=args.length; i < l; i++) {
      if (!args[i]) {
        if (!reuse) {
          if (args[i] === "") {
            copiedArgs[i] = "";
          } else {
            copiedArgs[i] = null;
          }
        }
        
        copiedArgs.changedFields.push(i-1);
      } else if (args[i].length == -1) {
        copiedArgs[i] = Constants.UNCHANGED;
      } else {
        if (!reuse) {
          copiedArgs[i] = args[i].toString();
        }
        copiedArgs.changedFields.push(i-1);
      }
    }
    
    return copiedArgs;
    
    
  }

var subscriptionsLogger = LoggerManager.getLoggerProxy(Constants.SUBSCRIPTIONS);
  
  
  var SubscriptionsHandler = function(policyBean) {
      
    /*
     * NB 
     * TableIds are internal codes to identify subscriptions.
     * TableNums are the values of the parameters LS_table (i.e. subIds in TLCP jargon),
     * are generated by Masters and are communicated asynchronously to Slaves
     * (as SubscriptionsHandlers).
     */
    
    this.nextId = 0;
    /* Map from tableIds to Subscriptions */
    this.tableInfosFromId = {};
    /* Map from tableNums (i.e. subIds) to tableIds */
    this.tableIdsFromNum = {};
    this.generationNumber = 1;

    /* Map from tableIds to Promises */
    this.promisesFromId = {};
    /* Map from tableIds to integers (what does it mean?!) */
    this.promiseQueuesFromId = {};
    // invariant on each element:
    // the promise exists iff the promiseQueue exists;
    // after the startup, the promiseQueue is always > 0;
    // the promise is created before the corresponding element in tableIdsFromNum
    
    this.eh = null;
    this.policyBean = policyBean;
    
    this.controlRequestTimeout = 4000;

    /*
     * Current phase used to discard promises created in a session 
     * but resolved in a successive session. 
     * It is incremented when a session finishes, 
     * that is when pauseAllTables is called.
     */
    this.phase = 0;
  };
  
  SubscriptionsHandler.prototype = {
      
    /*public*/ toString: function() {
      return "[SubscriptionsHandler]";
    }, 
    
    /*public*/ setControlRequestTimeout: function(val) {
      this.controlRequestTimeout = val;
      //PushPage guarantees this value is valid
    },
    
    /*public*/ switchEngineHandler:function(engineHandler) {
      this.eh = engineHandler;
    },
      
    /*public*/ getAllTables: function() {
      return this.tableInfosFromId;
    },
    
    /*public*/ addATable: function(tableIn) {
      var _id = ++this.nextId;
      
      subscriptionsLogger.logInfo(LoggerManager.resolve(516),tableIn);
      
      tableIn.onAdd(_id,++this.generationNumber,this);
      this.tableInfosFromId[_id] = tableIn;

      this.passTableToEngine(tableIn);

    },
   
    /*public*/ removeATable: function(subscriptionOut) {

      if (this.eh && this.eh.isSessionAlive()) {
        var tNum = subscriptionOut.getTableNumber();
        if (subscriptionOut.isSubscribing() || subscriptionOut.isPushing()) {
          if (tNum) {
            //we possess already a tableNumber for this table
            this.eh.unsubscribeTable(tNum);

            delete(this.tableIdsFromNum[tNum]);
          } // else the promise receiving the tablenum will take care of it

        }

      }

      subscriptionsLogger.logInfo(LoggerManager.resolve(517),subscriptionOut);

      var _id = subscriptionOut.getSubscriptionId();
      subscriptionOut.onRemove();
      delete(this.tableInfosFromId[_id]);

      return subscriptionOut;
      
    },
    
    /*public*/ updateSubscriptionParams: function(subscriptionChanging,changingParams) {
      if (!this.eh || !this.eh.isSessionAlive() || !subscriptionChanging.isActive()) {
        //new session will trigger the subscription
        return;
      }



      //>>excludeStart("debugExclude", pragmas.debugExclude);
      Assertions.verifyOk(subscriptionChanging.isActive(), "Inactive subscription");
      //>>excludeEnd("debugExclude");

        //notify the engine
        var tableId = subscriptionChanging.getSubscriptionId();
        if (this.promisesFromId[tableId]) {
          subscriptionsLogger.logDebug(LoggerManager.resolve(518),subscriptionChanging);
          var that = this;
          this.enqueueToPromise(tableId, function(tableNumber) {
            subscriptionsLogger.logDebug(LoggerManager.resolve(519),subscriptionChanging);
            that.eh.updateSubscriptionParams(tableNumber,changingParams);
          });
        } else {
            // we must possess already a tableNumber for this table
            subscriptionsLogger.logDebug(LoggerManager.resolve(520),subscriptionChanging);
            var tNum = subscriptionChanging.getTableNumber();
            this.eh.updateSubscriptionParams(tNum,changingParams);
        }

    },
    
    /*private*/ passTableToEngine: function(tableIn) {
      if (!this.eh || !this.eh.isSessionAlive()) {
        //new session will trigger the subscription
        return;
      }
      
      if (!tableIn.isPaused()) {
        //removed, pushing, or tableNum received... that's all
        return;
      }
      var tableId = tableIn.getSubscriptionId();

      subscriptionsLogger.logDebug(LoggerManager.resolve(521));

      var tableNumPromise = this.eh.subscribeTable(tableIn.getRequestParams());
      if (this.promisesFromId[tableId]) {
          subscriptionsLogger.logDebug(LoggerManager.resolve(522), tableId);
      } else {
          //>>excludeStart("debugExclude", pragmas.debugExclude);  
          Assertions.verifyNotOk(this.promisesFromId[tableId], "Promise unexpected (1)");
          Assertions.verifyNotOk(this.promiseQueuesFromId[tableId], "Promise unexpected (2)");
          //>>excludeEnd("debugExclude");
      }
      this.promisesFromId[tableId] = tableNumPromise;
      this.promiseQueuesFromId[tableId] = 0;

      tableIn.onSubmission();

      subscriptionsLogger.logDebug(LoggerManager.resolve(523),tableIn);
      var that = this;
      this.enqueueToPromise(tableId, function(tableNumber) {

        subscriptionsLogger.logDebug(LoggerManager.resolve(524),tableIn);
        if (! that.tableInfosFromId[tableId]) {
            //was removed
            if (that.eh) {
                that.eh.unsubscribeTable(tableNumber);
            }
        } else {
            tableIn.onTableNumber(tableNumber);
            that.tableIdsFromNum[tableNumber] = tableId;
        }

      });

    },
    
    enqueueToPromise: function(tableId, action) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
        Assertions.verifyOk(this.promisesFromId[tableId], "Promise not found (1)");
        if (this.promiseQueuesFromId[tableId] === 0) ; else {
            Assertions.verifyOk(this.promiseQueuesFromId[tableId], "Promise not found (2)");
        }
        //>>excludeEnd("debugExclude");
        var promise = this.promisesFromId[tableId];
        this.promiseQueuesFromId[tableId]++;
        
        var that = this;
        var actionPhase = this.phase;
        promise["then"](function(tableNumber) {
            if (that.promisesFromId[tableId] != promise) {
                // overridden (session changed?)
                subscriptionsLogger.logDebug(LoggerManager.resolve(525), tableId);
                return;
            }
            //>>excludeStart("debugExclude", pragmas.debugExclude);  
            Assertions.verifyOk(that.promisesFromId[tableId], "Promise not found (3)");
            Assertions.verifyOk(that.promiseQueuesFromId[tableId], "Promise not found (4)");
            //>>excludeEnd("debugExclude");
            if (that.promiseQueuesFromId[tableId] > 1) {
                that.promiseQueuesFromId[tableId]--;
            } else {
                delete(that.promisesFromId[tableId]);
                delete(that.promiseQueuesFromId[tableId]);
            }
            
            // check that session is not changed
            if (tableNumber != null && actionPhase == that.phase) {
                action(tableNumber);
            }
        },function() {
            if (that.promisesFromId[tableId] != promise) {
                // overridden (session changed?)
                subscriptionsLogger.logDebug(LoggerManager.resolve(526), tableId);
                return;
            }
            delete(that.promisesFromId[tableId]);
            delete(that.promiseQueuesFromId[tableId]);
        });
    },

    /*public*/ handleAllWaitingTables: function() {
      subscriptionsLogger.logDebug(LoggerManager.resolve(527));
      for (var _id in this.tableInfosFromId) {
        this.passTableToEngine(this.tableInfosFromId[_id]);
      }
    },
    
    /*private*/ pauseTable: function(_table) {
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyNotOk(_table.isOff(), "Table removed");
        //OFF means removed, if it was removed it must not be here now
    //>>excludeEnd("debugExclude");
      subscriptionsLogger.logDebug(LoggerManager.resolve(528),_table);

      delete(this.tableIdsFromNum[_table.getTableNumber()]);
      _table.onPause();
      if(_table.isSubTable()) {
        //don't remember about sub tables
        delete(this.tableInfosFromId[_table.getSubscriptionId()]);
      }
      
      
    },
    
    /*public*/ pauseAllTables: function() {
      subscriptionsLogger.logDebug(LoggerManager.resolve(529));
      
      for (var _id in this.tableInfosFromId) {
        this.pauseTable(this.tableInfosFromId[_id]);
      }
      this.tableIdsFromNum = {};
      this.phase++;
    },
    
    
/////EVENTS DISPATCHING
    
    callTableByNum: function(tableNum, method) {
        var _id = this.tableIdsFromNum[tableNum];
        if (_id) {
            // we already have a table number, but it is possible that
            // some previous task is still enqueued in the Promise
            var tableInfo = this.tableInfosFromId[_id];

            // TODO even though the initial Promise is removed in short time,
            // this check is always done; it can be relieved by saving some
            // information in the Subscription object
            if (this.promisesFromId[_id]) {
                subscriptionsLogger.logDebug(LoggerManager.resolve(530),tableInfo);
                var that = this;
                this.enqueueToPromise(_id, function(tableNumber) {
                    subscriptionsLogger.logDebug(LoggerManager.resolve(531),tableInfo);
                    //>>excludeStart("debugExclude", pragmas.debugExclude);  
                    Assertions.verifyValue(tableNumber, tableNum, "Wrong table number");
                    //>>excludeEnd("debugExclude");
                    if (that.tableIdsFromNum[tableNum] != _id) ; else {
                        var tableInfo = that.tableInfosFromId[_id];
                        if (tableInfo) {
                            method.apply(tableInfo);
                        }
                    }
                });

            } else {
                // subscriptionsLogger.logDebug(LoggerManager.resolve(532),tableInfo);
                if (tableInfo) {
                    method.apply(tableInfo);
                }
            }

        } else {
            // we are still waiting for the table number to be received;
            // unfortunately, we don't know which Promise is the one involved;
            // we can only find out all promises that are currently unfulfilled
            // (note that, since actions are sent asynchronously by the Promise,
            // we cannot ask that to the Promise itself
        	
            subscriptionsLogger.logDebug(LoggerManager.resolve(533),tableNum);
            var that = this;

            // TODO this has a quadratic effort, so it does not scale with the number
            // of subscriptions waiting to be issued when the engine is found
            var n = 0;
            for (var tableId in this.promisesFromId) {
                var sub = this.tableInfosFromId[tableId];
                if (sub) {
                    if (! sub.getTableNumber()) {
                        (function(tableId) {
                            that.enqueueToPromise(tableId, function(tableNumber) {
                                if (tableNumber == tableNum) {
                                    subscriptionsLogger.logDebug(LoggerManager.resolve(534),tableNum);
                                    if (that.tableIdsFromNum[tableNum] != tableId) ; else {
                                        var tableInfo = that.tableInfosFromId[tableId];
                                        if (tableInfo) {
                                            method.apply(tableInfo);
                                        }
                                    }
                                }
                            });
                        })(tableId);
                        // an intermediate call is needed here,
                        // otherwise "tableId" would not be considered with its current value
                        // in the closure, but with its last value after all the cycles
                        // (because javascript extends its scope to the whole hosting function)
                        n++;
                    } else {
                        //>>excludeStart("debugExclude", pragmas.debugExclude);  
                        Assertions.verifyDiffValue(sub.getTableNumber(), tableNum, "Unexpected table number");
                        //>>excludeEnd("debugExclude");
                    }
                }
            }
            subscriptionsLogger.logDebug(LoggerManager.resolve(535),n);
        }
    },
    
    updatePage: function(args, snap) { 
        // numero della table dell'update corrente
        var tableNum = args[0];
        
        this.callTableByNum(tableNum, function() {
            // TEMPORANEAMENTE l'indice su args corrisponde con il code del campo + 1
            // basterebbe fare due shift in questo punto per rinormalizzare tutto
            this.update(UpdateCopy(args,true),snap,false);
        });
    },
    

    onLostUpdatesEvent: function(tableNum,_item,lostUpdates) {
        this.callTableByNum(tableNum, function() {
            this.lostUpdates(_item,lostUpdates);
        });
    },
    
    onEndOfSnapshotEvent: function(tableNum,_item) {
        this.callTableByNum(tableNum, function() {
            this.endOfSnapshot(_item);
        });
    },
    
    onClearSnapshotEvent: function(tableNum,_item) {
        this.callTableByNum(tableNum, function() {
            this.clearSnapshot(_item);
        });
    },
    
    errorEvent: function(tableNum, flag, msg) {
        this.callTableByNum(tableNum, function() {
            this.serverDeny(flag, msg);
        });
    },
    
    subscriptionEvent: function(tableNum,kPos,cPos,itms,flds) {
        this.callTableByNum(tableNum, function() {
            this.onStartPush(kPos,cPos,itms,flds);
        });
    },
    
    unsubscriptionEvent: function(tableNum) {
        this.callTableByNum(tableNum, function() {
            this.onStopPush();
        });
    },
    
    doSubscriptionReconf: function(tableNum, frequency) {
        this.callTableByNum(tableNum, function() {
            this.configure(frequency);
        });
    }

    
  };

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var EventDispatcher = /*@__PURE__*/(function() {
  //var actionsLogger = LoggerManager.getLoggerProxy(LoggerManager.ACTIONS);   
  
  /**
   * This constructor simply calls the {@link EventDispatcher#initDispatcher initDispatcher} method. This class is supposed 
   * to be extended using {@link module:Inheritance} extension.
   * It can be either light extended or fully extended. When light extension is performed
   * the {@link EventDispatcher#initDispatcher initDispatcher} method should be called in the extended class constructor.
   * @constructor
   * 
   * @exports EventDispatcher
   * @class Class to be extended by classes requiring multiple listeners support.
   * The dispatcher can act in two different ways, either synchronously (all listeners are triggered
   * before the dispatching method exits) or asynchonously (all the listeners are triggered only when 
   * the currently running code has been executed).<br/>  
   * When extending this class is a good idea to also prepare an empty fake class to act as interface 
   * to keep track of the events that will be generated.
   * 
   *
   * 
   * 
   * @example
   * //using light extension
   * define(["Inheritance","EventDispatcher"],function(Inheritance,EventDispatcher) {
   *   
   *   var MyClass = function() {
   *     this.initDispatcher();
   *     //do stuff
   *   }
   *   
   *   MyClass.prototype = {
   *     foo: function() {
   *       //still doing stuff
   *       
   *       //send an eventName event to the listeners (their eventName method will be called)
   *       this.dispatchEvent("eventName",[paramForHandlers,otherParamForHandlers]);
   *       
   *       //do more stuff
   *     }
   *   };
   *   
   *   Inheritance(MyClass,EventDispatcher,true);
   *   return MyClass;
   * });
   * 
   * define([],function() {
   *   
   *   var MyClassListener = function() {
   *     //do stuff
   *   }
   *   
   *   MyClassListener = {
   *     eventName: function(param1,param2) {
   *       //handle event
   *     }
   *   };
   *   
   *   return MyClassListener;
   * });
   */
  var EventDispatcher = function() {
    this.initDispatcher();
  };
  
  EventDispatcher.prototype = {
      
      /**
       * Initializes the required internal structures and configures the dispatcher 
       * for sending asynchronous events.
       * <br/>If called more than once it will reset the status of the instance.
       * <br/>This method MUST be called at least once before event dispatching can 
       * be exploited, otherwise most methods will fail either silently or with unexpected
       * exceptions as no init-checks are performed by them.
       * @protected
       * 
       * @see EventDispatcher#useSynchEvents
       */
      initDispatcher: function() {
        this.theListeners = new AsymList();
        this.synchEvents = false;
      },
      
      /**
       * Adds a listener and fires the onListenStart event to it sending itself as only parameter.
       * Note that the onListenStart event is only fired on the involved listener not on previously
       * registered listeners.
       * 
       * @param {EventDispatcherListener} aListener a listener to receive events notifications. The listener does not need
       * to implement all of the possible events: missing events will not be fired on it.
       */
      addListener: function(aListener) {
        if (aListener && !this.theListeners.contains(aListener)) {
          var obj = {handler:aListener,listening:true};
          this.theListeners.add(obj);
          this.dispatchToOneListener("onListenStart",[this],obj,true);
        }
      },
      
      /**
       * Removes a listener and fires the onListenEnd event to it sending itself as only parameter.
       * Note that the onListenEnd event is only fired on the involved listener not on previously
       * registered listeners.
       * 
       * @param {EventDispatcherListener} aListener the listener to be removed.
       */
      removeListener: function(aListener) {
        if (!aListener) {
          return;
        }
        
        var obj = this.theListeners.remove(aListener);
        if (obj) {
          this.dispatchToOneListener("onListenEnd",[this],obj,true);
        }
      },
      
      /**
       * Returns an array containing the currently active listeners.
       * 
       * @returns {Array.<EventDispatcherListener>} an array of listeners.
       */
      getListeners: function() {
        return this.theListeners.asArray();
      },
      
      /**
       * Configures the EventDispatcher to send either synchronous or asynchronous events.
       * <br/>Synchronous events are fired on listeners before the {@link EventDispatcher#dispatchEvent} call
       * of the related event is returned.
       * </br>Asynchronous events are fired after the current code block is completed and possibly
       * after more code blocks are executed. Can be considered as if the calls are performed 
       * inside setTimeout with timeout 0.
       * 
       * @param {Boolean} [useSynch=false] true to fire events synchronously, any other value to fire them
       * asynchronously.
       * 
       * @see EventDispatcher#initDispatcher
       */
      useSynchEvents: function(useSynch) {
        this.synchEvents = useSynch === true;
      },

      /**
       * @private 
       * @param evt
       * @param params
       * @param listener
       * @param forced
       */
      dispatchToOneListener: function(evt,params,listener,forced) {
        if (this.synchEvents) {
          this.dispatchToOneListenerExecution(evt,params,listener,true);
        } else {
          Executor.addTimedTask(this.dispatchToOneListenerExecution,0,this,[evt,params,listener,forced]);
        }
      },
      
      /**
       * @private
       * @param evt
       * @param params
       * @param listener
       * @param forced
       */
      dispatchToOneListenerExecution: function(evt,params,listener,forced) {
        if (listener && listener.handler[evt] && (forced || listener.listening)) {
          try {
            //if we don't distinguish the two cases we will have problems on IE
            if (params) {
              listener.handler[evt].apply(listener.handler,params);
            } else {
              listener.handler[evt].apply(listener.handler);
            }
          } catch(_e) {
            //actionsLogger.logError(LoggerManager.resolve(536),evt,_e);
          }
        }
      },
      
      /**
       * Fires an event on all the listeners.
       * @param {String} evt The name of the event to be fired. A method with this name will be called on the listeners. 
       * @param {Array} [params] An array of objects to be used as parameters for the functions handling the event.
       * @see EventDispatcher#useSynchEvents
       */
      dispatchEvent: function(evt,params) {
        /*if (actionsLogger.isDebugLogEnabled()) {
          actionsLogger.logDebug(LoggerManager.resolve(537),evt);
        }*/
        
        var that = this;
        this.theListeners.forEach(function(el) {
          that.dispatchToOneListener(evt,params,el,false);
        });
      }
  };

  //closure compiler exports
  EventDispatcher.prototype["initDispatcher"] = EventDispatcher.prototype.initDispatcher;
  EventDispatcher.prototype["addListener"] = EventDispatcher.prototype.addListener;
  EventDispatcher.prototype["removeListener"] = EventDispatcher.prototype.removeListener;
  EventDispatcher.prototype["getListeners"] = EventDispatcher.prototype.getListeners;
  EventDispatcher.prototype["useSynchEvents"] = EventDispatcher.prototype.useSynchEvents;
  EventDispatcher.prototype["dispatchEvent"] = EventDispatcher.prototype.dispatchEvent;
  
  /**
   * extend the List class to power up the remove method:
   * as we get from outside object but we want to wrap them
   * before adding to the list we need a way to remove
   * the wrapped object given the original one
   * we also change the return value
   * @private
   */
  var AsymList = function() {
    this._callSuperConstructor(AsymList);
  };
  AsymList.prototype = {
    remove: function(remEl) {
      var i = this.find(remEl);
      if (i < 0) {
        return false;
      }
      var toRet = this.data[i];
      toRet.listening = false;
      this.data.splice(i,1);
      return toRet;
    },
    find: function(el) {
      for (var i=0; i<this.data.length; i++) {
        if (this.data[i].handler == el) {
          return i;
        }
      }
      return -1;
    },
    asArray: function() {
      var toRet = [];
      this.forEach(function(aListener) {
        toRet.push(aListener.handler);
      });
      return toRet;
    }
  };
  Inheritance(AsymList,List);
  
  
  return EventDispatcher;
})();

var protocolLogger$1 = LoggerManager.getLoggerProxy(Constants.PROTOCOL);

  var simulateSilence = false;

  var PushEvents = function(engId,tablePhaseChecker) {
    this.tablePhaseChecker = tablePhaseChecker;
    this.exportMethods(engId);

  };

  PushEvents.simulateSilence = function(silence) {
    simulateSilence = silence;
  };


  PushEvents.prototype = {

    changeSession: function(session) {
      protocolLogger$1.logDebug(LoggerManager.resolve(538),session);
      this.sessionHandler = session;
      if (this.sessionHandler.getSessionId() != this.currentIdForProg) {
          this.currentProg = null;
      }
    },

    exportMethods: function(engId) {
      var that = this;

      Lightstreamer.exportGlobal(engId,"LS_e",function(flag, phase, arg3, controlLink, keepaliveIntervalDefault, requestLimitLength) {
        that.onPushEvent(flag, phase, arg3, controlLink, keepaliveIntervalDefault, requestLimitLength);
      });
      Lightstreamer.exportGlobal(engId,"LS_t",function(_title) {
        that.onServerTitle(_title);
      });
      Lightstreamer.exportGlobal(engId,"LS_u",function(winPhase, args, snap) {
        that.onUpdate(winPhase, args, snap);
      });
      Lightstreamer.exportGlobal(engId,"LS_v",function(winPhase, args) {
        that.onUpdate(winPhase, args, true);
      });
      Lightstreamer.exportGlobal(engId,"LS_o",function(winPhase, args) {
        that.onLostUpdatesEvent(winPhase, args);
      });
      Lightstreamer.exportGlobal(engId,"LS_n",function(winPhase, args) {
        that.onEndOfSnapshotEvent(winPhase, args);
      });
      Lightstreamer.exportGlobal(engId,"LS_s",function(winPhase, args) {
        // WARNING!!! this contains a recovery for a Server bug that lasted up to 6.1
        // now the recovery is no longer needed, as this new version, for both Web and Node.js,
        // requires Server version 6.2 (because of other, more important, reasons);
        // however, we keep the recovery, for now, to ensure partial backward compatibility
        if (args.length) {
          that.onClearSnapshotEvent(winPhase, args);
        } else {
          // it is a sync signal instead
          var phase = winPhase;
          var secs = args;
          that.onPushEvent(6, phase, secs);
        }
      });
      Lightstreamer.exportGlobal(engId,"LS_l",function(flag, phase, tableCode, msg, isReqerr /*only for message errors*/) {
        that.onErrorEvent(flag, phase, tableCode, msg, isReqerr);
      });
      Lightstreamer.exportGlobal(engId,"LS_w",function(flag, phase, tableCode, its, flds, kPos, cPos) {
        that.onControlEvent(flag, phase, tableCode, its, flds, kPos, cPos);
      });
      Lightstreamer.exportGlobal(engId,"setTimeout",function(f,t) {
        setTimeout(f,t);
      });
      Lightstreamer.exportGlobal(engId,"alert",function(m) {
        if (typeof alert != "undefined") {
          alert(m);
        } else if (typeof console != "undefined") {
          //node.js and possibly other server-side-js-environments will pass from here
          console.log(m);
        }
      });
      Lightstreamer.exportGlobal(engId,"LS_svrname",function(name) {
          that.onServerName(name);
      });
      Lightstreamer.exportGlobal(engId,"LS_MPNREG",function(deviceId, adapterName) {
          that.onMPNREG(deviceId, adapterName);
      });
      Lightstreamer.exportGlobal(engId,"LS_MPNOK",function(lsSubId, pnSubId) {
          that.onMPNOK(lsSubId, pnSubId);
      });
      Lightstreamer.exportGlobal(engId,"LS_MPNDEL",function(pnSubId) {
          that.onMPNDEL(pnSubId);
      });
    },

    preliminaryCheck: function(ph,tph,isPause,canBeBothPauseOrNot) {
      var _ok = !simulateSilence && !EnvironmentStatus.isUnloaded() && this.sessionHandler!=null;
      //log(-1,_ok);

      /*
       * NB
       * Checks was disabled for these reasons:
       * 1) the first two checks are wrong because TLCP answers don't carry phase information
       * 2) the third check doesn't work as expected when transport is polling (and further it is incomprehensible to me)
       */
//      if (_ok && ph) { //sendMessage related messages do not carry session phase information
//        _ok &= this.sessionHandler.checkSessionPhase(ph);
//        //log(-2,_ok,ph,this.sessionHandler.push_phase);
//      }
//
//      if (_ok && tph) {
//        _ok &= this.tablePhaseChecker.checkSessionPhase(tph);
//      }
//
//      if (_ok && !canBeBothPauseOrNot) {
//        if (isPause) {
//          _ok &= this.sessionHandler.isWaitingOKFromNet();
//        } else {
//          _ok &= this.sessionHandler.isReceivingAnswer();
//        }
//        //log(-3,_ok);
//      }
//      /*if (!_ok) {
//        log(0);
//      }*/

      if (protocolLogger$1.isDebugLogEnabled()) {
        protocolLogger$1.logDebug(LoggerManager.resolve(539),_ok);
      }

      return _ok;
    },

    /**
     * Checks if a data notification can be forwarded to session.
     * In fact, in case of recovery, the initial notifications may be redundant.
     */
    processCountableNotification: function() {
        if (this.sessionHandler.getSessionId() != this.currentIdForProg) {
            // the associated sessionHandler object can be reused without notice
            this.currentProg = null;
        }
        var sessionProg = this.sessionHandler.getDataNotificationProg();
        protocolLogger$1.logDebug(LoggerManager.resolve(540),sessionProg);
        if (this.currentProg != null) {
            //>>excludeStart("debugExclude", pragmas.debugExclude);
            if(!ASSERT.verifyOk((this.currentProg <= sessionProg))) {
              protocolLogger$1.logError(LoggerManager.resolve(541),this.currentProg);
            }
            //>>excludeEnd("debugExclude");
            this.currentProg++;
            if (this.currentProg <= sessionProg) {
                // already seen: to be skipped
                protocolLogger$1.logDebug(LoggerManager.resolve(542),this.currentProg);
                return false;
            } else {
                this.sessionHandler.onDataNotification();
                sessionProg = this.sessionHandler.getDataNotificationProg();
                //>>excludeStart("debugExclude", pragmas.debugExclude);
                if(!ASSERT.verifyValue(this.currentProg,sessionProg)) {
                  protocolLogger$1.logError(LoggerManager.resolve(543),this.currentProg);
                }
                //>>excludeEnd("debugExclude");
                return true;
            }
        } else {
            this.sessionHandler.onDataNotification();
            return true;
        }
    },

    onServerTitle: function(_title) {
      //USELESS
    },

    onPushEvent: function(flag, phase, arg3, controlLink, keepaliveIntervalDefault, requestLimitLength) {
      if (!this.preliminaryCheck(phase,null,flag == 1,flag == 3||flag == 4)) {
        return;
      }

      if (flag == 1) {
        //OK
        this.sessionHandler.onOKReceived(arg3,controlLink,requestLimitLength,keepaliveIntervalDefault);

      } else if (flag == 2) {
        //LOOP
        this.sessionHandler.onLoopReceived(arg3);

      } else if (flag == 3) {
        //SYNC ERROR
        this.sessionHandler.onSyncError("syncerror");

      } else if (flag == 4) {
        //END
        var cause = 30;
        if (arg3 != null) {
          cause = arg3;
          if (cause == 41) {
            this.sessionHandler.onError41();
            return;
          } else if (cause == 48) {
            // session max duration reached: behave like a sync error
            this.sessionHandler.onSyncError("expired");
            return;
          }
          if ((cause > 0 && cause < 30) || cause > 39) {
            // cause code unexpected in this context, hence considered as an error
            cause = 39;
          }
        }
        var message = "The session has been forcibly closed by the Server";
        // NB controlLink contains the message of END
        if (controlLink != null) {
            message = controlLink;
        }
        this.onErrorEvent(cause, phase, null, message);

      } else if (flag == 5) {
        this.sessionHandler.onServerSentBandwidth(arg3);

      } else if (flag == 6) {
        this.sessionHandler.onSyncReceived(arg3);

      } else if (flag == 7) {
        this.onProg(arg3);

      } else {
        this.sessionHandler.onEnd("Unsupported Server version");
      }
    },
    
    onProg: function(prog) {
        if (this.sessionHandler.getSessionId() != this.currentIdForProg) {
            // the associated sessionHandler object can be reused without notice
            this.currentProg = null;
        }
        var sessionProg = this.sessionHandler.getDataNotificationProg();
        if (this.currentProg == null) {
            this.currentProg = prog;
            this.currentIdForProg = this.sessionHandler.getSessionId();
            if (this.currentProg > sessionProg) {
                //>>excludeStart("debugExclude", pragmas.debugExclude);
                ASSERT.fail();
                //>>excludeEnd("debugExclude");
                protocolLogger$1.logError(LoggerManager.resolve(544),prog,sessionProg);
                this.sessionHandler.onPROGCounterMismatch();
            }
        } else {
            // not allowed by the protocol, but we handle the case for testing scenarios;
            // these extra invocations of prog() can be enabled on the Server
            // through the <PROG_NOTIFICATION_GAP> private flag
            if (this.currentProg != prog) {
                //>>excludeStart("debugExclude", pragmas.debugExclude);
                ASSERT.fail();
                //>>excludeEnd("debugExclude");
                protocolLogger$1.logError(LoggerManager.resolve(545),prog,this.currentProg);
                this.sessionHandler.onPROGCounterMismatch();
            } else if (prog != sessionProg) {
                //>>excludeStart("debugExclude", pragmas.debugExclude);
                ASSERT.fail();
                //>>excludeEnd("debugExclude");
                protocolLogger$1.logError(LoggerManager.resolve(546),prog,sessionProg);
                this.sessionHandler.onPROGCounterMismatch();
            }
        }
    },

    onUpdate: function(winPhase, args, snap) {
      if (args.length < 2) {
        if (!this.preliminaryCheck(winPhase)) {
          return;
        }
        this.sessionHandler.onKeepalive();
      } else {
        if (!this.preliminaryCheck(null,winPhase)) {
          return;
        }
        if (! this.processCountableNotification()) {
          return;
        }
        this.sessionHandler.onUpdateReceived(args,snap || false);
      }
    },

    onSnapshot: function(winPhase,args) {
      this.onUpdate(winPhase,args,true);
    },

    onEndOfSnapshotEvent: function(winPhase,args) {
      if (!this.preliminaryCheck(null,winPhase)) {
        return;
      }
      if (! this.processCountableNotification()) {
        return;
      }

      this.sessionHandler.onEndOfSnapshotEvent(args);
    },

    onClearSnapshotEvent: function(winPhase,args) {
      if (!this.preliminaryCheck(null,winPhase)) {
        return;
      }
      if (! this.processCountableNotification()) {
        return;
      }

      this.sessionHandler.onClearSnapshotEvent(args);
    },

    //RAW; MERGE,DISTINCT or COMMAND with flag UNFILTERED; COMMAND without flag UNFILTERED (ADD and DELETE)
    onLostUpdatesEvent: function(winPhase, args) {
      if (!this.preliminaryCheck(null,winPhase)) {
        return;
      }
      if (! this.processCountableNotification()) {
        return;
      }

      this.sessionHandler.onLostUpdatesEvent(args);
    },

    /**
     * @param _code error code
     * @param num sequence number
     * @param messageCode sequence
     * @param msg error message
     * @param isReqerr when true, the error comes from a REQERR; when false, the error comes form a MSGFAIL.
     */
    onMessageErrorEvent: function(_code, num, messageCode, msg, isReqerr) {
      if (!this.preliminaryCheck()) {
        return;
      }
      
      //>>excludeStart("debugExclude", pragmas.debugExclude);
      if(!ASSERT.verifyValue(messageCode.substring(0, 3),"MSG")) {
        protocolLogger$1.logError(LoggerManager.resolve(547),messageCode);
      }
      //>>excludeEnd("debugExclude");
      var seq = messageCode.substr(3);
      
      // handle REQERR
      if (isReqerr) {
          this.sessionHandler.onMessageError(seq,_code,msg,num);
          return;
      }
      
      // handle MSGFAIL
      if (! this.processCountableNotification()) {
        return;
      }
      if (_code == 39) {  // 39 series of messages not received in time (and perhaps never arrived)
        var count = parseInt(msg);
        num = parseInt(num);
        for (var i = num - count + 1; i <= num; i++) {
          this.sessionHandler.onMessageDiscarded(seq, i);
        }

      } else if (_code == 38) {
        this.sessionHandler.onMessageDiscarded(seq,num);

      } else if (_code <= 0) {
        this.sessionHandler.onMessageDeny(seq,_code,msg,num);

      } else {
        // 34 request deemed invalid by the Metadata Adapter
        // 35 unexpected error in message processing
        this.sessionHandler.onMessageError(seq,_code,msg,num);
      }

    },

    /**
     * @param tableCode according to the format, it can represent a subscription error (when it is a number),
     * a CONERR (when null) or a message error (when starting with "MSG")
     * 
     * @param isReqerrFromMsg when true, the error comes from a REQERR; when false, the error comes form a MSGFAIL.
     * It is meaningful only if tableCode represents a message error
     */
    onErrorEvent: function(flag, phase, tableCode, msg, isReqerrFromMsg) {
      if (tableCode != null && isNaN(tableCode)) {
        this.onMessageErrorEvent(flag, phase, tableCode, msg, isReqerrFromMsg);
        return;
      }

      if (tableCode != null) {
        // handle REQERR about subscription errors
        if (!this.preliminaryCheck(null,phase)) {
          return;
        }
        this.sessionHandler.onTableError(tableCode,flag,msg);

      } else {
        // handle CONERR
        if (!this.preliminaryCheck(phase,null,null,true)) {
          return;
        }
        this.sessionHandler.forwardError(flag, msg);
      }

    },

    onControlEvent: function(flag, phase, tableCode, its, flds,kPos,cPos) {
      if (!this.preliminaryCheck(null,flag == 4 || flag == 5 || flag == 9 ? null : phase)) {
        return;
      }

      if (flag == 4) {
        // handle REQOK about message acknowledgments
        this.sessionHandler.onMessageAck(tableCode,phase);

      } else if (flag == 5) {
        // handle MSGDONE
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onMessageOk(tableCode,phase);

      } else if (flag == 8) {
        // handle UNSUB
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onUnsubscription(tableCode);

      } else if (flag == 6) {
        // handle SUBOK
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onSubscription(tableCode,its,flds,kPos+1,cPos+1);

      } else if (flag == 9) {
        // handle CONF (i.e. subscription frequency)
        // NB "its" is the frequency sent by the server 
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onSubscriptionReconf(tableCode,phase,its);

      } else {
        //?
        protocolLogger$1.logDebug(LoggerManager.resolve(548),flag);
      }

      // flag == 7
      // in response to a request of add_silent
      // to signal that the server is synchronized.

    },
    
    onServerName: function(name) {
        this.sessionHandler.onServerName(name);
    },
    
    onMPNREG: function(deviceId, adapterName) {
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onMpnRegisterOK(deviceId, adapterName);
    },
    
    onMPNOK: function(lsSubId, pnSubId) {
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onMpnSubscribeOK(lsSubId, pnSubId);
    },
    
    onMPNDEL: function(pnSubId) {
        if (! this.processCountableNotification()) {
            return;
        }
        this.sessionHandler.onMpnUnsubscribeOK(pnSubId);
    }

  };




/*END*/
  //call from the push frame to signal that a connection has been closed
  // voluntarily. In general it will be a connection that is already obsolete,
  // but if it were not so, the client should decide whether to try to reopen it
  // or give up and go immediately to the disconnected state.

  // the Server sends this event in each of the following cases,
  // which for the moment are not distinguished:
    // intervention of a new connection that sticks to the same session
      // (must have been made by hand)
    // unexpected exception during creation or during activity
      // (it never happened)
    // request closure with call destroy
    // closure requested by the Metadata Adapter via a ConflictingSessionException
      // (but only if it originated from another page; if it is
                // a reopening on this same page, the notification
                // does not arrive here, because it has the old phase)
    // closure required by identification as OldSession
      // (but, unless the request was made by hand,
                // the notification does not arrive here, because it has the old phase)
    // closure requested by JMX interface
  // don't send him in these cases
    // IOException on the connection
      // (but here could be the retry event, with flag == 3,
                // caused by the onload, managed by Safari and Chrome)
    // natural end of content-length
      // (here in reality it sends it, but the loop event, with flag == 2,
                // arrives first and sends this out of phase)

var MIN_TIMEOUT = 4000;
  
  var Tutor = function(connOptions,currentTimeout) {
    this.discarded = false;
    this.connOptions = connOptions;
    this.timeoutMs = this.getFixedTimeout ? this.getFixedTimeout() : (currentTimeout ? currentTimeout*2 : MIN_TIMEOUT);
  };
  
  Tutor.prototype = {

    /*public*/ notifySender: function(failed) {
      if (failed) {
        this.doRecovery();
      } else {
        var timeoutToUse = this.timeoutMs+Number(this.connOptions.pollingInterval);
        Executor.addTimedTask(this.onTimeout,timeoutToUse,this);
      }
    },
    
    /*private*/ onTimeout: function() {
      if (!(this.discarded || this.verifySuccess())) {
        this.doRecovery();
      } 
    },
    
    discard: function() {
        this.discarded = true;
    }
    
    /*abstract function verifySuccess()*/
    /*abstract function doRecovery()*/ 
    /*abstract function notifyAborted()*/ //called if the request will be willingly not sent
    /*abstract OPTIONAL function getFixedTimeout()*/ //if available the method is used to obtain the timeout value
  };

var UnsubscribeTutor = function(connOptions,tableNum,owner,effort,currentTimeout) {
    this._callSuperConstructor(UnsubscribeTutor,[connOptions,currentTimeout]);
    
    this.tableNum = tableNum;
    this.owner = owner;
    this.effort = effort;
    
  };

  UnsubscribeTutor.prototype = {
      verifySuccess: function () {
        return !this.owner.isWaitingUnsubscription(this.tableNum);
      },

      doRecovery: function () {
        this.owner.unsubscribeTable(this.tableNum,this.effort+1,this.timeoutMs);
      },
      
      notifyAborted: function() {
        //it means that a
        //sent was not actually sent
        this.owner.onUnsubscription(this.tableNum);
      }
  };
  
  
  Inheritance(UnsubscribeTutor,Tutor);

var notifySenderName;
  for(var i$1 in  {notifySender:true}) {
    notifySenderName=i$1;
  }

  var SubscribeTutor = function(connOptions,tableNum,owner,effort,currentTimeout) {
    this._callSuperConstructor(SubscribeTutor,[connOptions,currentTimeout]);
    
    this.tableNum = tableNum;
    this.owner = owner;
    this.effort = effort;
    
  };

  SubscribeTutor.prototype = {
      verifySuccess: function () {
        return !this.owner.isWaitingSubscription(this.tableNum);
      },
      
      doRecovery: function () {
        this.owner.subscribeTable(this.tableNum,this.effort+1,this.timeoutMs);
      },

      notifySender: function(failed) {
        if (!failed) {
          this.owner.subscriptionSent(this.tableNum);
        }
        this._callSuperMethod(SubscribeTutor,notifySenderName,arguments);
      },
      
      notifyAborted: function() {
        // we don't have anything to do, it means that a
        //delete was queued before the add was sent
        //so the subscription should not exists anymore
      }
  };
  
  
  Inheritance(SubscribeTutor,Tutor);

var SubscriptionChangeTutor = function(connOptions,tableNum,ph,owner,changingParams,effort,currentTimeout) {
    this._callSuperConstructor(SubscriptionChangeTutor,[connOptions,currentTimeout]);
    
    this.tableNum = tableNum;
    this.ph = ph;
    this.owner = owner;
    this.changingParams = changingParams;
    this.effort = effort;
    
  };
  
  SubscriptionChangeTutor.prototype = {
      verifySuccess: function () {
        return !this.owner.isWaitingSubscriptionReconfNotification(this.tableNum,this.ph);
      },
      
      doRecovery: function () {
        this.owner.sendUpdateSubscriptionParams(this.tableNum,this.ph,this.changingParams,this.effort+1,this.timeoutMs);
      },
      
      notifyAborted: function() {
        // possible if the subscription is closed?
      }
  };
  
  
  Inheritance(SubscriptionChangeTutor,Tutor);

var sharingLogger$2 = LoggerManager.getLoggerProxy(Constants.SHARING);

  var PushPageCollectionHandler = function(engine,configuration,details,options) {
    this.reqPhase = 1;
    this.engine = engine;
    this.configuration = configuration;
    this.details = details;
    this.options = options;
    this.sessionPhase = 0;
    this.sessionAlive = false;

    this.pushPages = {};
    this.clientsCount = 0;

    this.subscriptions = {};
    this.page2Tables = {};


    this.cleanTask = Executor.addRepetitiveTask(this.cleanThread,5000,this);

    EnvironmentStatus.addBeforeUnloadHandler(this);
    EnvironmentStatus.addUnloadHandler(this);
  };
  
  PushPageCollectionHandler.prototype = {
    
    /*public*/ toString: function() {
      return ["[","PushPageCollectionHandler","]"].join("|");
    },

    getSessionPhase: function() {
      return this.sessionPhase;
    },

    /*public*/ checkSessionPhase: function(pPhase) {
      return pPhase == this.sessionPhase;
    },


    checkConnectionPool: function(onlyMeCount) {
      var status = this.engine.getSharedStatus();
      if (status && status.getNumberOfConnectionsToServer(this.engine.sessionHandler.getPushServerAddress()) > onlyMeCount) {
        sharingLogger$2.logWarn(LoggerManager.resolve(549));
      }
    },


    /*private*/ cleanAll: function() {
      this.subscriptions = {};
      for (var i in this.page2Tables) {
        this.page2Tables[i] = {};
      }
    },

    forEachPushPage: function(callback) {
      for (var i in this.pushPages) {
        callback(this.pushPages[i],i);
      }
    },

    onNewPushPage: function(ppId,pp) {
      this.pushPages[ppId] = pp;
      this.page2Tables[ppId] = {};

      this.clientsCount++;
      this.configuration.simpleSetter('clientsCount',this.clientsCount);

      sharingLogger$2.logDebug(LoggerManager.resolve(550),this);
      if (ppId !== Constants.MAIN_CLIENT) {

        this.details.forEachProperty(function(prop,value) {
          pp.onEngineConfigurationChange("ConnectionDetails",prop,value);
        });
        this.options.forEachProperty(function(prop,value) {
          pp.onEngineConfigurationChange("ConnectionOptions",prop,value);
        });
        this.configuration.forEachProperty(function(prop,value) {
          pp.onEngineConfigurationChange("Configuration",prop,value);
        });

        pp.onStatusChange(this.engine.getStatus());

        if (this.sessionAlive) {
          pp.onSessionStart(this.sessionPhase);
        } else {
          pp.onSessionEnd(this.sessionPhase);
        }

      }



    },

    onPushPageLost: function(ppId) {
      sharingLogger$2.logDebug(LoggerManager.resolve(551),this,ppId);
      if (this.pushPages[ppId]) {
        var relatedTables = this.page2Tables[ppId];
        for (var tableNum in relatedTables) {
          this.removeTable(tableNum);
        }

        this.pushPages[ppId].dispose();
        delete (this.pushPages[ppId]);
        delete this.page2Tables[ppId];

        this.clientsCount--;
        this.configuration.simpleSetter('clientsCount',this.clientsCount);
      }
    },



    getPushPageHandlerFromTableNumber: function(tableNum) {
      var sub = this.subscriptions[tableNum];
      if (!sub) {
        sharingLogger$2.logDebug(LoggerManager.resolve(552));
        return null;
      }
      return this.getPushPageHandler(sub.pageNum);
    },
    /*public*/ getPushPageHandler: function(pageNum) {
      if (!this.pushPages[pageNum]) {
        sharingLogger$2.logDebug(LoggerManager.resolve(553));
        return null;
      }

      return this.pushPages[pageNum];
    },





    notifyNewStatus: function(newStatus,oldStatus) {
      this.forEachPushPage(function(pp) {
        pp.onStatusChange(newStatus);
      });
      return true;
    },

    /*public*/ onSessionStart: function() {
      // I delete the accumulated deletes, so the pushpages after this refresh will be
      // forced to repeat their requests and the deletes
      this.cleanAll();
      this.sessionAlive = true;
      var phase = ++this.sessionPhase;
      this.forEachPushPage(function(pp) {
        pp.onSessionStart(phase);
      });

    },

    /*public*/ onSessionEnd: function() {
      // I delete the accumulated deletes, so the pushpages after this refresh will be
      // forced to repeat their requests and the deletes
      this.cleanAll();
      this.sessionAlive = false;
      var phase = ++this.sessionPhase;
      this.forEachPushPage(function(pp) {
        pp.onSessionEnd(phase);
      });

    },

    onSubscription: function(tableNum) {
      if (!this.subscriptions[tableNum]) {
        return;
      }
      this.subscriptions[tableNum].pendingSubscription = false;
    },
    onSubscriptionError: function(tableNum) {
      /*if (!this.subscriptions[tableNum]) {
        return;
      }
      delete this.subscriptions[tableNum];
      if (this.page2Tables[pageNum]) {
        delete this.page2Tables[pageNum][tableNum];
      }*/
      this.onUnsubscription(tableNum);
      //this.subscriptions[tableNum].pendingSubscription = false;
    },
    isWaitingSubscription: function(tableNum) {
      if (!this.subscriptions[tableNum]) {
        //on subscribe received
        return false;
      }
      return this.subscriptions[tableNum].pendingSubscription && !this.subscriptions[tableNum].pendingUnsubscription;
    },
    subscriptionSent: function(tableNum) {
      if (!this.subscriptions[tableNum]) {
        return;
      }
      this.subscriptions[tableNum].sentSubscription = true;
    },

    onSubscriptionEvent: function(tableNum) {
    },


    onUnsubscription: function(tableNum) {
      if (!this.subscriptions[tableNum]) {
        return;
      }
      var pageNum = this.subscriptions[tableNum].pageNum;
      delete this.subscriptions[tableNum];

      if (this.page2Tables[pageNum]) {
        delete this.page2Tables[pageNum][tableNum];
      }

    },
    isWaitingUnsubscription: function(tableNum) {
      if (!this.subscriptions[tableNum]) {
        //on unsubscribe received
        return false;
      }
      return this.subscriptions[tableNum].sentSubscription && this.subscriptions[tableNum].pendingUnsubscription;
    },


    isWaitingSubscriptionReconfNotification: function(tableNum,ph) {
      if (!this.subscriptions[tableNum]) {
        //on unsubscribe received
        return false;
      }
      return this.subscriptions[tableNum].pendingChange && this.subscriptions[tableNum].pendingChangePhase == ph;
    },
    onSubscriptionReconfEvent: function(tableNum,phase) {
      if (!this.subscriptions[tableNum]) {
        //on unsubscribe received
        return;
      }
      if (phase == this.subscriptions[tableNum].pendingChangePhase) {
        this.subscriptions[tableNum].pendingChange = false;
      }
    },


    /*public*/ handleTable: function(ppId,body) {
      //since this call is session-synched and since the pushPage passes subscriptions to us only if session is alive
      //then at this moment we must be connected (otherwise this call is discarded during phase check)

      var pageH = this.pushPages[ppId];
      if (!pageH || !this.engine.isSessionOpenOrRecovering()) {
        //should never happen as to arrive here the existence of the pushPageHandler is checked

        //>>excludeStart("debugExclude", pragmas.debugExclude);
        ASSERT.fail();
        //>>excludeEnd("debugExclude");
        sharingLogger$2.logError(LoggerManager.resolve(554),this,ppId);
        return;
      }

      var tableNum = Utils.nextSubscriptionId();

      this.page2Tables[ppId][tableNum] = true;

      //delete-request handling, it's not handled on a per-PushPage basis as
      //even if a pushpage disappears we have to send its remove requests
      var reqs = this.getControlParams(body,tableNum);
      this.subscriptions[tableNum] = new SubscriptionStatus(ppId,reqs.add,reqs.remove);

      sharingLogger$2.logDebug(LoggerManager.resolve(555));

      this.subscribeTable(tableNum,1);
      return tableNum;
    },

    /*public*/ subscribeTable: function(tableNum,effort,currentTimeout) {
      if (!this.subscriptions[tableNum]) {
        return;
      }
      if (effort >= 3) {
        //if we're retrying we check cookies to see if it's possible that the connection is blocked due to
        //exhaustion of the pool
        this.checkConnectionPool(1);
      }

      this.subscriptions[tableNum].pendingSubscription = true;

      var tutor = new SubscribeTutor(this.options,tableNum,this,effort,currentTimeout);
      var addBody = this.subscriptions[tableNum].addBody;
      this.engine.sessionHandler.sendSubscription(tableNum,addBody,this,effort >= 2,tutor);

    },

    removeTable: function(tableNum) {
      if (!this.subscriptions[tableNum] || this.subscriptions[tableNum].pendingUnsubscription) {
        //already unsubscribed or already unsubscribing
        return;
      }

      this.unsubscribeTable(tableNum,1);
    },

    /*public*/ unsubscribeTable: function(tableNum,effort,currentTimeout) {
      if (!this.subscriptions[tableNum]) {
        return;
      }
      if (effort >= 3) {
        //if we're retrying we check cookies to see if it's possible that the connection is blocked due to
        //exhaustion of the pool
        this.checkConnectionPool(1);
      }

      this.subscriptions[tableNum].pendingUnsubscription = true;

      var tutor = new UnsubscribeTutor(this.options,tableNum,this,effort,currentTimeout);
      var deleteBody = this.subscriptions[tableNum].deleteBody;
      deleteBody['LS_reqId'] = Utils.nextRequestId();
      this.engine.sessionHandler.sendUnsubscription(tableNum,deleteBody,this,effort >= 2,tutor);

    },

    updateSubscriptionParams:function(tableNum,changingParams) {
      if (!this.subscriptions[tableNum]) {
        return;
      }

      var ph = ++this.subscriptions[tableNum].pendingChangePhase;

      this.sendUpdateSubscriptionParams(tableNum,ph,changingParams,1);
    },

    sendUpdateSubscriptionParams: function(tableNum,ph,changingParams,effort,currentTimeout) {
      if (!this.subscriptions[tableNum] || this.subscriptions[tableNum].pendingChangePhase != ph ) {
        return;
      }
      if (effort >= 3) {
        //if we're retrying we check cookies to see if it's possible that the connection is blocked due to
        //exhaustion of the pool
        this.checkConnectionPool(1);
      }

      this.subscriptions[tableNum].pendingChange = true;
      var rPhase = this.subscriptions[tableNum].pendingChangePhase;
      var reqParams = Utils.extendObj({
        "LS_subId": tableNum,
        "LS_op": "reconf",
        "LS_reqId": Utils.nextRequestId()
      },changingParams);

      var tutor = new SubscriptionChangeTutor(this.options,tableNum,rPhase,this,changingParams,effort,currentTimeout);
      this.engine.sessionHandler.sendSubscriptionChange(tableNum,reqParams,tutor);


    },




    /*public*/ notifyEngineIsDying: function() {
      this.forEachPushPage(function(pp) {
        pp.onEngineDying();
      });
    },

    /*public*/ notifyEngineDeath: function(suiciding) {
      var pps = this.pushPages;
      this.pushPages = {};
      for (var i in pps) {
        pps[i].onEngineDeath(suiciding);
      }
    },

    /*public*/ notifyServerError: function(flag,msg) {
      this.forEachPushPage(function(pp) {
        pp.onServerError(flag,msg);
      });
    },

    dispose: function() {
      Executor.stopRepetitiveTask(this.cleanTask);
      EnvironmentStatus.removeBeforeUnloadHandler(this);
      EnvironmentStatus.removeUnloadHandler(this);
    },

    unloadEvent: function() {
      this.notifyEngineDeath(false);
    },

    preUnloadEvent: function() {
      this.notifyEngineIsDying();
    },

    cleanThread: function() {
      var that = this;
      this.forEachPushPage(function(pp,id) {
        //this call on a dead page will result in a onPushPageLost call
        pp.ping()["then"](function(ok) {
          //if didn't fail we're ok
        },function() {
          that.onPushPageLost(id);
        });
      });
    },


    /**
     * Genera la querystring da utilizzare per la richiesta dei dati di push
     */
    /*public*/ getControlParams: function(_body,tableNum) {
      this.reqPhase++;

      var commonParams = {
        "LS_subId": tableNum
      };

      Utils.extendObj(_body,commonParams);

      return {
        add: Utils.extendObj(_body,{"LS_op":"add", "LS_reqId": Utils.nextRequestId()}),
        remove: Utils.extendObj(commonParams,{"LS_op": "delete", "LS_reqId": Utils.nextRequestId()})
      };

    },

    onServerKeepalive: function() {
        this.forEachPushPage(function(pp) {
            pp.onServerKeepalive();
        });
    }
  };

  function SubscriptionStatus(pageNum,addBody,deleteBody) {
    this.pendingSubscription = false;
    this.sentSubscription = false;
    this.pendingChange = false;
    this.pendingChangePhase = 0;
    this.pendingUnsubscription = false;
    this.deleteBody = deleteBody;
    this.addBody = addBody;
    this.pageNum = pageNum;
  }


  PushPageCollectionHandler.prototype["onPushPageLost"] = PushPageCollectionHandler.prototype.onPushPageLost;
  PushPageCollectionHandler.prototype["onNewPushPage"] = PushPageCollectionHandler.prototype.onNewPushPage;
  PushPageCollectionHandler.prototype["unloadEvent"] = PushPageCollectionHandler.prototype.unloadEvent;
  PushPageCollectionHandler.prototype["preUnloadEvent"] = PushPageCollectionHandler.prototype.preUnloadEvent;

var MAD_LIMIT = BrowserDetection.isProbablyFX(1.5,true) ? 10 : 50;
  
  //we know that the problem arises on FX<1.6. for other browsers we keep the control but we wait a lot more before showing the message
  var madLimit = MAD_LIMIT;
  var madCreates = 0;
  var lastTime = 0;
  var firstTime = 0;
  
  var oldMadCreates = null;
  var oldLastTime = null;
  var oldFirstTime = null;
  
  var sessionLogger = LoggerManager.getLoggerProxy(Constants.SESSION);


  var MadTester = {
    
    /*public*/ init: function() {
      madLimit = MAD_LIMIT;
      madCreates = 0;
      lastTime = 0;
      firstTime = 0;
      oldMadCreates = null;
      oldLastTime = null;
      oldFirstTime = null;
    },
    
    /*public*/ incMadTest: function() {
      //save data for possible rollback
      oldMadCreates = madCreates;
      oldLastTime = lastTime;
      oldFirstTime = firstTime;
      
      var nowTime = Helpers.getTimeStamp();
      
      if (!firstTime) {
        //first request
        firstTime = nowTime;
      }
      
      if ((nowTime - firstTime) >= 60000) {
        //more than 1 minute from the previous test, reset
        madCreates = 0;
        firstTime = nowTime;
      }
      
      if (lastTime && (nowTime - lastTime) < 1000) {
        //not enough time between create_session requests, inc
        madCreates++;    
      }
  
      lastTime = nowTime;
    },
    
    /*public*/ rollbackLastMadTest: function() {
      if (oldLastTime != lastTime) {
        madCreates = oldMadCreates;
        lastTime = oldLastTime;
        firstTime = oldFirstTime;
      }
    },
  
    /*public*/ canMakeRequest: function() {
      if (lastTime == 0) {
        // first step. I let it go ...
        return true;
      } else if (!madLimit) {
        // message already given. Return false and declare the client mad
        return false;
      } else if (madCreates >= madLimit) {
        sessionLogger.logError(LoggerManager.resolve(556));
        madLimit = 0;
        return false;
      }
      
      return true;
    }
  };

var names$1 = {
            encodeRequest: 'encodeRequest',
            encodeUnqRequest: 'encodeUnqRequest'
    };
    names$1 = Utils.getReverse(names$1);
  
  var WSEncoder = function(wsConnection) {
      this.wsConnection = wsConnection;
  };
  
  WSEncoder.prototype = {
      toString: function() {
        return "[WSEncoder]";
      },
      
      getFixedOverhead: function(fileName) {
        //the batching algorithm doesn't count the name of the 
        //request file (e.g. control.js) as part of the request and thus as part of the length of
        //the request; however in the ws case the file name is part of the request body and thus 
        //should be taken into account. 
        return fileName.length+2; //2 is \r\n
      },
      
      getExt: function() {
        return "";
      },
      
      /**
       * @override
       */
      encodeRequest: function(params,extraParams,sessionId) {
          extraParams = this.expandWithSessionId(extraParams, sessionId);
          return this._callSuperMethod(WSEncoder,names$1['encodeRequest'],[params,extraParams,sessionId]);
      },
      
      /**
       * @override
       */
      encodeUnqRequest: function(params,extraParams,unquotedParam,sessionId) {
          extraParams = this.expandWithSessionId(extraParams, sessionId);
          return this._callSuperMethod(WSEncoder,names$1['encodeUnqRequest'],[params,extraParams,unquotedParam,sessionId]);
      },
      
      /**
       * @override
       */
      encodeDestroyRequest: function(params,bridge,sessionId,extraParams) {
          // destroy request already have sessionId set
          return this._callSuperMethod(WSEncoder,names$1['encodeRequest'],[params,extraParams,sessionId]);
      },
      
      /**
	   * Adds the parameter LS_session only if the WS connection has no default sessionId.
       * The default sessionId is established when the client receives the response of
       * a bind_session request.
       *
       * @private
       */
      expandWithSessionId: function(extraParams, sessionId) {
          var defaultSessionId = this.wsConnection.getDefaultSessionId();
          if (defaultSessionId == null) {
              extraParams = Utils.extendObj(extraParams,{"LS_session": sessionId});

          } else {
              // omit LS_session since the server knows the sessionId of the connection
              //>>excludeStart("debugExclude", pragmas.debugExclude);            
              Assertions.verifyValue(defaultSessionId, sessionId, "Unexpected session ID");
              //>>excludeEnd("debugExclude");
          }
          return extraParams;
      }
  };
  
  Inheritance(WSEncoder,Encoder);

var sessionLogger$1 = LoggerManager.getLoggerProxy(Constants.SESSION);
  var streamLogger = LoggerManager.getLoggerProxy(Constants.STREAM);

  var NodeWS = null;
  if (Environment.isNodeJS()) {
    NodeWS = nodeUtils.NodeWS;
  }



  var JS_PROTOCOL = Constants.TLCP_VERSION + ".lightstreamer.com";

  var objectIdCounter = 1;

  function WebSocketConnection(wsSession) {
     this._callSuperConstructor(WebSocketConnection);

     this.objectId = objectIdCounter++;
     if (streamLogger.isDebugLogEnabled()) {
         streamLogger.logDebug(LoggerManager.resolve(557), this.objectId);
     }
     this.isOpen=false;
     this.exePhase=null;
     this.openPhase=null;
     this.openRequest=null;
     this.webSocketInstance = null;
     this.openEvent = false;
     this.openFailure = false;
     this.serverInUse = null;
     this.openEventFired = false;
     /*
      * When not null, the requests may omit the parameter LS_session because it is implicitly equal to this value.
      * This value is always equal to the LS_session parameter of the last sent bind_session request.
      */
     this.defaultSessionId = null;

     this.wsSession = wsSession;

     this.constr = WebSocketConnection;
     
     this.wsEncoder = new WSEncoder(this);
  }
  if (WebSocketConnection.name == null) {
      WebSocketConnection.name = "WebSocketConnection";
  }

  var disabled = false;
  var disabledFor = {};

  WebSocketConnection.disableClass = function(forAddress) {
    if (forAddress) {
      disabledFor[forAddress] = true;
    } else {
      disabled = true;
    }
  };
  WebSocketConnection.restoreClass = function(forAddress) {
    if (forAddress) {
      delete(disabledFor[forAddress]);
    } else {
      disabled = false;
      disabledFor = {};
    }
  };
  WebSocketConnection.isDisabledClass = function() {
    for (var i in disabledFor) {
      return true;
    }
    return disabled;
  };

  //this must become a factory that is able to give me the same websocket on different instances of WebSocketConnection (create/bind and control
  function getWebSocket(_url) {

    if (_url.indexOf("http://") == 0) {
      _url = _url.replace("http://","ws://");
    } else {
      _url = _url.replace("https://","wss://");
    }

    if (NodeWS) {
      var cookie = "";
      var cookies = ServerConnection.getGlobalCookiesForNode(_url);
      /* Set header Cookie */
      cookies.forEach(function(cookie_i, i, array) {
          // BEGIN ported from cookie_send in xmlhttprequest-cookie
          if (cookie !== "")
              cookie += "; ";
          cookie += cookie_i['name'] + "=" + cookie_i['value'];
          // END ported from cookie_send in xmlhttprequest-cookie
      });

      var options = {};
      if (cookie.length > 0) {
          options.headers = { 'Cookie' : cookie };
      }
      return new NodeWS(_url,JS_PROTOCOL,options);
    } else if (typeof WebSocket != "undefined") {
      return new WebSocket(_url,JS_PROTOCOL);
    } else if (typeof MozWebSocket != "undefined") {
      return new MozWebSocket(_url,JS_PROTOCOL);
    }

    //due to the isAvailable method this should never happen
    WebSocketConnection.disableClass();
    return null;
  }

  ServerConnection.attachPublicStaticMethods(WebSocketConnection,{
    isAvailable: function(address) {
      if (disabled) {
        return false;
      } else if (address && disabledFor[address]) {
        return false;
      }

      var WSClass = null;
      if (typeof WebSocket != "undefined") {
        WSClass = WebSocket;
      } else if (typeof MozWebSocket != "undefined") {
        WSClass = MozWebSocket;
      }

      if (WSClass) {
        if (WSClass.prototype.CLOSED == 2) {
          //Safari is still using version "-00" of the draft
          return false;
        }
      }

      return (NodeWS || WSClass);
    },
    isCrossSite: true,
    isCrossProtocol: function() {
      return !Environment.isBrowser() || location.protocol != "https:";
    },
    areCookiesGuaranteed: function() {
        return true;
    },
    attachEngineId: false,
    isStreamEnabled: true,
    canUseCustomHeaders: false
  });

  WebSocketConnection.prototype = {

    toString: function() {
      return ["[","WebSocketConnection",this.isOpen,this.openPhase,this.exePhase,this.isReadyToSend(),"]"].join("|");
    },

    _close: function() {
      if (!this.webSocketInstance) {
        return; //wait please :)
      }

      streamLogger.logDebug(LoggerManager.resolve(558));

      //"disable callbacks"
      this.openPhase = null;

      if (this.webSocketInstance) {
        try {
          this.webSocketInstance.close(1000);
        } catch (__e) {
          //INVALID_ACCESS_ERR
            //An invalid code was specified.
          //SYNTAX_ERR
            //The reason string is too long or contains unpaired surrogates.
          streamLogger.logDebug(LoggerManager.resolve(559),__e);
        }
      }

      this.off();

      return;
    },

    openSocket: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      if (this.isOpen) {
        streamLogger.logError(LoggerManager.resolve(560));
      } else if(disabled) {
        return false;
      }

      this.openFailure = false;

      this.serverInUse = request.getPath();
      this.openPhase = phase;

      try {
        this.webSocketInstance = getWebSocket(this.serverInUse);
      } catch(_e) {
        streamLogger.logDebug(LoggerManager.resolve(561),_e);
        return false;
        //SECURITY_ERR
        //The port to which the connection is being attempted is being blocked.
      }

      if (sessionLogger$1.isDebugLogEnabled()) {        
          sessionLogger$1.debug("Status timeout in " + this.wsSession.getCurrentConnectTimeout() + " [currentConnectTimeoutWS]");
      }
      Executor.addTimedTask(this.openWSTimeout,this.wsSession.getCurrentConnectTimeout(),this,[this.openPhase]);


      var that = this;
      this.webSocketInstance.onmessage = function(evt) {
        that.onPartialResponse(evt,phase,responseCallback);
      };
      this.webSocketInstance.onerror = function() {
        that.onErrorResponse(phase,errorCallback);
      };
      this.webSocketInstance.onclose = function(closeEv) {
        that.onCloseResponse(closeEv, phase, connectionEndCallback,errorCallback);
      };
      this.webSocketInstance.onopen = function() {
        if (Environment.isNodeJS()) {
            /*
             * Add cookie definitions in the WebSocket handshake response to the cookie jar (maintained by the HTTP transport manager).
             *
             * Problem: HTTP and WebSocket transports are independent components not sharing the cookies.
             *
             * Solution: Use the cookie manager of the HTTP transport to holds also the cookies returned by
             * the WebSocket handshake response.
             */
            var headers = that.webSocketInstance.headers;
            if (headers['set-cookie']) {
                /*
                 * NOTE
                 * Notwithstanding  RFC 6265 section 3 forbids set-cookie header folding,
                 * faye-websocket folds multiple set-cookie headers into a single header separating the values by commas.
                 *
                 * The procedure parseSetCookieHeader recovers the cookie definitions from the collapsed header.
                 */
                var cookies = Utils.parseSetCookieHeader(headers['set-cookie']);
                ServerConnection.addGlobalCookiesForNode(request.getUrl(), cookies);
            }
        }
        that.onOpenEvent(phase);
      };

      return true;

    },

    openWSTimeout: function(ph) {
      if (ph == this.openPhase && this.webSocketInstance && !this.openEventFired) {
        try {
          sessionLogger$1.logDebug(LoggerManager.resolve(562));
          this.wsSession.policyBean.increaseConnectTimeout();

          this.webSocketInstance.close(1000);
        } catch(_e) {
          streamLogger.logDebug(LoggerManager.resolve(563));
        }
      }
    },

    _load: function(request,phase) {
      if (this.isOpen) {
        streamLogger.logError(LoggerManager.resolve(564));
        return null;
        //instances of WebSocketConnection are never _load twice
        //so this should not happen
      } else if(disabled) {
        return false;
      }

      this.openRequest=request;

      this.exePhase = phase;

      streamLogger.logDebug(LoggerManager.resolve(565),request.getUrl());

      if (this.isReadyToSend()) {
        //on open event already fired
        this.sendFirstRequest(phase);

      } //else during the onOpen event we will send the cached request. If the onOpen is never fired we will have a timeout and a reconnect (that is the theoretical worst case as usually we have an open error event before the timeout goes off.

      return true;

    },

    isConnectedToServer: function(serverAddress) {
    //>>excludeStart("debugExclude", pragmas.debugExclude);
      if (!ASSERT.verifyOk(this.serverInUse)) {
        streamLogger.logError(LoggerManager.resolve(566));
        return false;
      }
    //>>excludeEnd("debugExclude");
      return this.serverInUse.indexOf(serverAddress)==0;
    },

    isReadyToSend: function() {
      return this.webSocketInstance != null && this.webSocketInstance.readyState == 1;  //OPEN = 1
    },

    _send: function(req,ph) {
      if (!this.isReadyToSend()) {
        return null;
      }

      if (ph) {
        //if a phase is specified, this is a bind request. In such case we have to update our internal phase
        //and to extend the request as sessionLoad does
        this.updatePhase(ph);
      }

      if (streamLogger.isDebugLogEnabled()) {
          streamLogger.logDebug(LoggerManager.resolve(567), this.objectId, req.getFile(), req.getData());
      }

      try {
        this.webSocketInstance.send(req.getFile() + "\r\n" + req.getData());
      } catch(_e) {
        streamLogger.logError(LoggerManager.resolve(568),_e);
        //INVALID_STATE_ERR
          //The connection is not currently OPEN.
        //SYNTAX_ERR
          //The data is a string that has unpaired surrogates.
        return false;
      }

      return true;
    },

    sendFirstRequest: function(phase) {

      var res = this._send(this.openRequest,phase);
    //>>excludeStart("debugExclude", pragmas.debugExclude);
      if (!ASSERT.verifyOk(res !== null)) {
        streamLogger.logError(LoggerManager.resolve(569),phase);
      }
    //>>excludeEnd("debugExclude");
      if (res) {
        this.isOpen = true;
        this.wsSession.firstSentNotification(this.openPhase);
      }

    },

    /*public*/ updatePhase: function(ph) {
      this.exePhase = ph;
    },

///////////////////////////EVENTS

    /*
    readyState
         CONNECTING 0 The connection is not yet open.
         OPEN  1 The connection is open and ready to communicate.
         CLOSING 2 The connection is in the process of closing.
         CLOSED  3 The connection is closed or couldn't be opened.

    bufferedAmount
        unsigned long The number of bytes of data that have been queued using calls to send() but not yet transmitted to the network. This value does not reset to zero when the connection is closed; if you keep calling send(), this will continue to climb. Read only.

    */

    /*private*/ onPartialResponse: function(evt,phase,responseCallback) {
      if (this.openPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }

      if (streamLogger.isDebugLogEnabled()) {
          streamLogger.logDebug(LoggerManager.resolve(570), this.objectId, evt.data);
      }

      //I had to move this flag here as it happened that a websocket received the onopen event and then anything else.
      //After a while the connection was broken and since this flag was already true the client did not disable the WS connection
      //and went on retrying the same connection. The loop of failures was broken when a WS did not break for long enough for the
      //stream-sense timeout to be executed
      //See email from Marc Bracher on 20121010

      this.openEvent = true;
      Executor.executeTask(responseCallback, [evt.data,this.exePhase]);
    },

    /*private*/ onErrorResponse: function(phase,errorCallback) {
      if (this.openPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }

      streamLogger.logError(LoggerManager.resolve(571), this.objectId);


      this.openFailure |= !this.openEvent;
      Executor.executeTask(errorCallback, ["wsc.unknown",this.openPhase,true,this.openFailure,false]);
    },

    /*private*/ onOpenEvent: function(phase,req) {
      if (this.openPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }

      this.openEventFired = true;
      //this.openEvent = true;
      streamLogger.logDebug(LoggerManager.resolve(572));

      if (this.openRequest) {
        //sessionLoad already called
        this.sendFirstRequest();
      }

    },

    /*private*/ onCloseResponse: function(closeEv,phase,connectionEndCallback,errorCallback) {
      if (this.openPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }

      var closeCode = closeEv ? closeEv.code : -1;

      streamLogger.logDebug(LoggerManager.resolve(573),closeCode,this.openEvent);

      if (closeCode == 1000 || closeCode == 1001) {
        //this is a good end, so it's supposed to happen for a good reason
        //the sad fact is that FX calls this when navigating away from a page so...
        //..let's delay the end check a little bit.
        Executor.modifyAllTaskParams(connectionEndCallback,[this.openPhase,true]);
        Executor.addPackedTimedTask(connectionEndCallback,300);
        this.off();

      } else if (closeCode == 1011) {
        //the server got an unexpected error;
        //we should retry, but in a reasonable time, in order to avoid loops;
        //the reconnection timeout could be a good compromise
        this.openFailure |= !this.openEvent;
        var ph = this.openPhase;
        this.off();
        Executor.executeTask(errorCallback, ["wsc.server",ph,true,this.openFailure,true]);

      } else {
        this.openFailure |= !this.openEvent;
        var ph = this.openPhase;
        this.off();
        Executor.executeTask(errorCallback, ["wsc."+closeCode,ph,true,this.openFailure,false]);
      }



      /*

      closeEv.code:

      0-999   Reserved and not used.

      1000 indicates a normal closure, meaning whatever purpose the connection was established for has been fulfilled.
      1001 indicates that an endpoint is "going away", such as a server going down, or a browser having navigated away from a page.
      1002 indicates that an endpoint is terminating the connection due to a protocol error.
      1003 indicates that an endpoint is terminating the connection because it has received a type of data it cannot accept (e.g. an endpoint that understands only text data MAY send this if it receives a binary message).
      1004 Reserved.  The specific meaning might be defined in the future.
      1005 is a reserved value and MUST NOT be set as a status code in a Close control frame by an endpoint.  It is designated for use in applications expecting a status code to indicate that no status code was actually present.
      1006 is a reserved value and MUST NOT be set as a status code in a Close control frame by an endpoint.  It is designated for use in applications expecting a status code to indicate that the connection was closed abnormally, e.g. without sending or receiving a Close control frame.
      1007 indicates that an endpoint is terminating the connection because it has received data within a message that was not  consistent with the type of the message (e.g., non-UTF-8 [RFC3629] data within a text message).
      1008 indicates that an endpoint is terminating the connection because it has received a message that violates its policy. is a generic status code that can be returned when there is no other more suitable status code (e.g. 1003 or 1009), or if there is a need to hide specific details about the policy.
      1009 indicates that an endpoint is terminating the connection because it has received a message which is too big for it to process.
      1010 indicates that an endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake.  The list of extensions which are needed SHOULD appear in the /reason/ part of the Close frame.   Note that this status code is not used by the server, because it can fail the WebSocket handshake instead.
      1011 indicates that a server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.
      1015 is a reserved value and MUST NOT be set as a status code in a Close control frame by an endpoint.  It is designated for use in applications expecting a status code to indicate that the connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).

      1000-2999   Status codes in the range 1000-2999 are reserved for definition by  this protocol, its future revisions, and extensions specified in a  permanent and readily available public specification.
      3000-3999   Status codes in the range 3000-3999 are reserved for use by libraries, frameworks and application.  These status codes are registered directly with IANA.  The interpretation of these codes is undefined by this protocol.
      4000-4999   Status codes in the range 4000-4999 are reserved for private use and thus can't be registered.  Such codes can be used by prior agreements between WebSocket applications. The interpretation of these codes is undefined by this protocol.

      NOTE (20111214) on MDN 1004 is described as CLOSE_TOO_LARGE The endpoint is terminating the connection because a data frame was received that is too large.

      closeEv.reason
      closeEv.wasClean

      */

    },


/////////////////////////////////////EVENTS END

    /*private*/ off: function() {
      this.isOpen = false;
      this.openEventFired = false;
      this.openPhase = null;
      this.openRequest=null;
      this.openEvent = false;
      this.webSocketInstance = null;
      this.serverInUse = null;
    },

    /*public*/ getEncoder: function() {
      return this.wsEncoder;
    },
    
    /**
     * Sets the default session id of a WebSocket connection.
     * The default id is the id returned in the response of a bind_session.
     * It lasts until the end of streaming/polling.
     */
    /*public*/ setDefaultSessionId: function(defaultSessionId) {
        if (streamLogger.isDebugLogEnabled()) {
            streamLogger.logDebug(LoggerManager.resolve(574), defaultSessionId + " on WS connection oid=" + this.objectId);
        }
        this.defaultSessionId = defaultSessionId;
    },
    
    /*public*/ getDefaultSessionId: function() {
        return this.defaultSessionId;
    }
  };


  Inheritance(WebSocketConnection, ServerConnection);

var ForceRebindTutor = function(_cause,session,_phase,connOptions) {
    
    this._callSuperConstructor(ForceRebindTutor,[connOptions]);
    
    this._cause = _cause;
    this._phase = _phase;
    this.session = session;
  };
  
  ForceRebindTutor.prototype = {

    verifySuccess: function() {
      //if push_pase is changed we've already received a loop so that our request is successful
      return !this.session.checkSessionPhase(this._phase);
    },
    
    doRecovery: function() {
      //let's try again
      this.session.forceRebind(this._cause);
    },
    
    getFixedTimeout: function() {
      return this.connOptions.forceBindTimeout;
    },
    
    notifyAborted: function() {
      //nothing to do
    }
    
  };
  
  Inheritance(ForceRebindTutor,Tutor);

/**
     * Bean about the status of the recovery attempt.
     * <p>
     * State graph of the bean. The event start=T means the client wants to recover the current session.
     * Transitions not depicted should not happen.
    <pre>
       start=F                            start=T
       +--+                               +--+
       |  |                               |  |
       |  |                               |  |
    +--+--v------+   start=T/set ts    +--+--v-----+
    |recovery=F  +--------------------->recovery=T |
    |            +<--------------------+           |
    +------------+   start=F/reset ts  +-----------+
    </pre>
     *
     * @since May 2018
     */
    var RecoveryBean = function() {
        if (arguments.length == 0) {
            this.ctor0();
        } else {
            Assertions.assert(arguments.length == 2, "Recovery error (1)");
            this.ctor2(arguments[0], arguments[1]);
        }
        Assertions.assert(this.invariant(), "Recovery error (2)");
    };
    
    RecoveryBean.prototype = {
            
            invariant: function() {
                return this.recovery ? this.recoveryTimestampMs != -1 : this.recoveryTimestampMs == -1;
            },
            
            /**
             * Initial state. No recovery.
             */
            ctor0: function() {
                this.recovery = false;
                this.recoveryTimestampMs = -1;
            },
            
            /**
             * Next state.
             * 
             * @param {boolean} startRecovery
             * @param {RecoveryBean} old
             */
            ctor2: function(startRecovery, old) {
                if (old.recovery) {
                    if (startRecovery) {
                        this.recovery = true;
                        this.recoveryTimestampMs = old.recoveryTimestampMs;                        
                    } else {
                        /*
                         * This case can occur when, for example, after a recovery
                         * the client rebinds in HTTP because the opening of Websockets takes too long. 
                         */
                        this.recovery = false;
                        this.recoveryTimestampMs = -1;
                    }
                    
                } else {
                    if (startRecovery) {
                        this.recovery = true;
                        this.recoveryTimestampMs = Date.now();
                        
                    } else {
                        Assertions.assert(old.recoveryTimestampMs == -1, "Recovery error (4)");
                        this.recovery = false;
                        this.recoveryTimestampMs = -1;
                    }
                }
            },
            
            /**
             * Restore the time left to complete a recovery, i.e. calling timeLeftMs(maxTimeMs) returns maxTimeMs.
             * The method must be called when a recovery is successful.
             */
            restoreTimeLeft: function() {
                this.recovery = false;
                this.recoveryTimestampMs = -1;
            },
            
            /**
             * True when the session has been created to recover the previous session,
             * which was discarded because of a network error.
             */
            isRecovery: function() {
                return this.recovery;
            },
            
            /**
             * Time left to recover the session.
             * When zero or a negative value, the session must be discarded.
             * 
             * @param {Number} maxTimeMs
             * @return {Number}
             */
            timeLeftMs: function(maxTimeMs) {
                if (this.recovery) {
                    Assertions.assert(this.recoveryTimestampMs != -1, "Recovery error (5)");
                    return maxTimeMs - (Date.now() - this.recoveryTimestampMs);
                    
                } else {            
                    return maxTimeMs;
                }
            }
    };

var _OFF = 1;
  /**
   * Expecting create_session/recovery response
   * (next: CREATED)
   */
  var CREATING = 2;
  /**
   * Expecting LOOP after having received CONOK as create_session/recovery response
   * (previous: CREATING, next: FIRST_PAUSE)
   */
  var CREATED = 3;
  /**
   * Expecting the expiration of a small pause after create_session/recovery response 
   * and before sending bind_session 
   * (previous: CREATED, next: FIRST_BINDING)
   */
  var FIRST_PAUSE = 4;
  /**
   * Expecting bind_session response 
   * (previous: FIRST_PAUSE, next: RECEIVING)
   */
  var FIRST_BINDING = 5;
  var PAUSE = 6;
  /**
   * Expecting bind_session response (transport is polling)
   */
  var BINDING = 7;
  /**
   * Reading item updates
   * (previous: FIRST_BINDING)
   */
  var RECEIVING = 8;
  var STALLING = 9;
  var _STALLED = 10;
  /**
   * Expecting the expiration of a timeout after an error 
   * and before creating a new session or recovering the current
   * (next: CREATING)
   */
  var SLEEP = 11;
  
  
  var statusStrings = [];
  statusStrings[_OFF] = "OFF";
  statusStrings[CREATING] = "CREATING";
  statusStrings[CREATED] = "CREATED";
  statusStrings[FIRST_PAUSE] = "FIRST_PAUSE";
  statusStrings[FIRST_BINDING] = "FIRST_BINDING";
  statusStrings[PAUSE] = "PAUSE";
  statusStrings[BINDING] = "BINDING";
  statusStrings[RECEIVING] = "RECEIVING";
  statusStrings[STALLING] = "STALLING";
  statusStrings[_STALLED] = "STALLED";
  statusStrings[SLEEP] = "SLEEP";
  
  
  //close session "helpers"
  var CLOSED_ON_SERVER = true;
  var OPEN_ON_SERVER = false;
  var NO_RECOVERY_SCHEDULED = true;
  var RECOVERY_SCHEDULED = false;
  //var JUST_SLEEP = true; //not used
  
  var sessionLogger$2 = LoggerManager.getLoggerProxy(Constants.SESSION);
  var protocolLogger$2 = LoggerManager.getLoggerProxy(Constants.PROTOCOL);
  
  var PERMISSION_TO_FAIL = 1; //called X in the session machine
  
  var objectIdCounter$1 = 1;
  
  var Session = function(isPolling,forced,handler,handlerPhase,originalSession,skipCors,sessionRecovery,mpnManager) {
    this.objectId = objectIdCounter$1++;
    if (sessionLogger$2.isDebugLogEnabled()) {
        sessionLogger$2.logDebug(LoggerManager.resolve(575), "oid=" + this.objectId);
    }
    this.cbOk = Executor.packTask(this.onStreamResponse,this);
    this.cbErr = Executor.packTask(this.onStreamError,this);
    this.cbEnd = Executor.packTask(this.onStreamEnd,this);
    
    
    this.isPolling = isPolling;
    this.forced = forced;
    this.dataNotificationCount = 0;
    
    this.phase = _OFF;
    this.phaseCount = 0;
    this.push_phase =  Helpers.randomG(100) * 100;
    
    this.handler = handler;
    this.handlerPhase = handlerPhase;
    
    //extracted from handler
    this.slowing = handler.getSlowing();
    this.policyBean = handler.getPolicyBean();
    this.connectionBean = handler.getConnectionBean();
    this.evalQueue = null;
    this.controlHandler = handler.getControlConnectionHandler();
    this.engineId = handler.getEngineId();
    
    this.serverSentBW = 0;
    this.workedBefore = 0;
    this.lastKATO = 0;
    this.lastKATask = null;
    this.reconnectTimeout = null;
    this.sentTime = null;
    
    this.reset();
    
    /**
     * The flag is true when the data connection fell down and the next actions will be the creation
     * of a new session object and the recovery of the (logical) session.
     * 
     * preparingRecovery is a kind of clone of the flag recoveryBean.isRecovery() with the difference
     * that preparingRecovery is true in the session object experiencing a network error 
     * (where recoveryBean.isRecovery() is false) 
     * while recoveryBean.isRecovery() is true in the session object created for the recovery 
     * (where preparingRecovery is false).
     */
    this.preparingRecovery = false;
    /**
     * Recovery can be temporarily disabled when the client discovers that the server counter
     * (as expressed by PROG) is different from the client counter.
     * The current session is not invalidated but in case of error a new session will be created.
     */
    this.isRecoveryDisabled = false;
    
    /**
     * When true, the special create request must be emitted which handles CONERR,5
     */
    this.serverBusy = false;
    
    if (originalSession) {
      //inheriting a session
      this.bindCount = originalSession.bindCount;
      this.dataNotificationCount = originalSession.dataNotificationCount;
      sessionLogger$2.logDebug(LoggerManager.resolve(576), this.dataNotificationCount);
      
      this.sessionId = originalSession.sessionId;
      /**
       * Address of the server for the current session.
       * It can be the control-link (carried by CONOK message), 
       * or {@link ConnectionDetails#getServerAddress()} if the control-link is not set.
       * It can also be null before receiving the first CONOK message.
       */
      this.sessionServerAddress = originalSession.sessionServerAddress;
      this.push_phase = originalSession.push_phase;
      this.serverSentBW = originalSession.serverSentBW;
      
      /**
       * Copy of {@link ConnectionDetails#getServerAddress()}.
       */
      this.serverAddressCache =  originalSession.serverAddressCache;
      /**
       * Copy of {@link ConnectionOptions#isServerInstanceAddressIgnored()}.
       */
      this.ignoreServerAddressCache = originalSession.ignoreServerAddressCache;
      
      this.recoveryBean = new RecoveryBean(sessionRecovery, originalSession.recoveryBean);
      
    }  else {
        Assertions.assert(! sessionRecovery, "Recovery unexpected");
        this.recoveryBean = new RecoveryBean();
    } 
    
    this.mpnManager = mpnManager;
    
    if (Environment.isBrowser()) {
        var that = this;
        this.onlineHandler = function(e) {
            var timeLeftMs = that.recoveryBean.timeLeftMs(that.policyBean.sessionRecoveryTimeout);
            if (timeLeftMs <= 0) {
                // close the current session and prepare to create a new one
                that.closeSession('recovery.timeout.elapsed', CLOSED_ON_SERVER, RECOVERY_SCHEDULED);
                //now is SLEEPing
            }
            that.launchTimeout("online.again", 0);
        };
        try {
            window.addEventListener('online', this.onlineHandler, false);
        } catch (e) {
            // online event not supported by the browser
        }
    }
  };
  
  //I need to expose these values to sub classes
  Session._OFF = _OFF;
  Session.CREATING = CREATING;
  Session.CREATED = CREATED;
  Session.FIRST_PAUSE = FIRST_PAUSE;
  Session.FIRST_BINDING = FIRST_BINDING;
  Session.BINDING = BINDING;
  Session.RECEIVING = RECEIVING;
  Session.STALLING = STALLING;
  Session._STALLED = _STALLED;
  Session.PAUSE = PAUSE;
  Session.SLEEP = SLEEP;
 
  Session.prototype = {

      /*private*/ reset: function() {
        if (sessionLogger$2.isDebugLogEnabled()) {            
            sessionLogger$2.logDebug(LoggerManager.resolve(577), this.objectId);
        }
        this.bindCount = 0;
        this.sessionServerAddress = null;
        this.sessionId = null;
        this.dataNotificationCount = 0;
        
        this.serverSentBW = 0;
        this.cachedRequiredBW = false; //this is set only if a changeBW request is received while in CREATING status (too late to send it via create_session, too early to issue a control)
        //note that when the session number is received the control handler is reset, so that put it there is not an option
        
        this.switchRequired = false;
        this.switchForced = false;
        this.switchCause = "";
        this.slowRequired = false;
        
        this.preparingRecovery = false;
      },
      
      /*public*/ resetConnectionList: function(skipCors) {
        //do nothing
      },
      
///////////////////////////////////phase handling
      
      /*private*/ changePhaseType: function(newType) {
        if (sessionLogger$2.isDebugLogEnabled()) {
            sessionLogger$2.logDebug(LoggerManager.resolve(578), this.objectId, statusStrings[this.phase], "->", statusStrings[newType]);
        }
        
        this.phase = newType;
        this.phaseCount++;
        var ph = this.phaseCount;
        
        this.handler.statusChanged(this.handlerPhase);
        
        return ph == this.phaseCount;
      },
      
      /*private*/ incPushPhase: function() {
        this.push_phase++; 
      },
      
      /*public*/ checkSessionPhase: function(ph) {
        return this.push_phase == ph;
      },
      
      /*public*/ getHighLevelStatus: function() {
        var ph = this.phase;
        
        if (ph == _OFF) {
          return Constants.DISCONNECTED;
          
        } else if (ph == SLEEP) {
          if (this.preparingRecovery) {
              return Constants.TRYING_RECOVERY;
          } else {
              return Constants.WILL_RETRY;
          }
          
        } else if (ph == CREATING) {
            if (this.recoveryBean.isRecovery()) {
                return Constants.TRYING_RECOVERY;
            } else {
                return Constants.CONNECTING;
            }
          
        } else if (ph == CREATED || ph == FIRST_PAUSE || ph == FIRST_BINDING) {
          return Constants.CONNECTED + this.getFirstConnectedStatus();
          
        } else if (ph == _STALLED) {
          return Constants.STALLED;
          
        /*} else if (ph == RECEIVING && (this.switchRequired || this.slowRequired)) {
          return Constants.CONNECTED + Constants.SENSE;
          
          this would avoid the SENSE->STREAMING->POLLING case but introduces the
          STREAMING->_STALLED->SENSE->POLLING one (problem is the client would be receiving data while in SENSE status)
          
          */
          
        } else { //BINDING RECEIVING STALLING PAUSE
          return Constants.CONNECTED + this.getConnectedHighLevelStatus();
        }        
      },
      
      /*public*/ isOpen: function() { 
        return this.phase != _OFF && this.phase != CREATING && this.phase != SLEEP;
      },
      
      /*public*/ isWaitingOKFromNet: function() {
        return this.phase == CREATING || this.phase == BINDING || this.phase == FIRST_BINDING;
      },
      
      /*public*/ isReceivingAnswer: function() { 
        return this.phase == CREATED ||  this.phase == RECEIVING ||  this.phase == STALLING ||  this.phase ==  _STALLED;
      },
      
      /*public*/ isRecovering: function() {
          return this.recoveryBean.isRecovery();
      },
      
      /*public*/ isStreamingSession: function() {
        return !this.isPolling;
      },
      
      /*public*/ getPushServerAddress: function() {
          // use the control-link address if available, otherwise use the address configured at startup 
          return this.sessionServerAddress == null ? this.serverAddressCache : this.sessionServerAddress;
      },
      
      /*public*/ getSessionId: function() {
        return this.sessionId;
      },
      
      /*public*/ getSessionHost: function() {
        return this.sessionServerAddress;
      },
      
      /*public*/ /*isSlowRequired: function() {
        return this.slowRequired;
      },*/

//////////////////////////////////external calls
      /*public*/ createSession: function(oldSessionId,reconnectionCause,serverBusy) {
        this.serverBusy = serverBusy;
        
        var openOnServer = this.phase != _OFF && this.phase != SLEEP ? OPEN_ON_SERVER : CLOSED_ON_SERVER;
        
        if (!MadTester.canMakeRequest()) {
          sessionLogger$2.logDebug(LoggerManager.resolve(579),this);
          this.closeSession("mad",openOnServer,NO_RECOVERY_SCHEDULED);
          return false;
        }
        
        if (openOnServer == OPEN_ON_SERVER) {
          sessionLogger$2.logDebug(LoggerManager.resolve(580),this);
          this.closeSession("new."+(reconnectionCause||""),OPEN_ON_SERVER,RECOVERY_SCHEDULED);
        }

        sessionLogger$2.logInfo(LoggerManager.resolve(581),this);
        
        this.reset();
        
        this.prepareSlowing();
        
        //this.policyBean.simpleSetter('serverKeepaliveInterval',NaN);
        //this.policyBean.simpleSetter('serverPollingInterval',NaN);
        //this.policyBean.simpleSetter('serverSideBandwidth',NaN);
        this.connectionBean.simpleSetter("sessionId",null);
        this.connectionBean.simpleSetter("serverSocketName",null);
        this.connectionBean.simpleSetter("serverInstanceAddress",null);
        
        this.serverAddressCache =  this.connectionBean.serverAddress;
        this.ignoreServerAddressCache =  this.policyBean.serverInstanceAddressIgnored;
        
        
        this.incPushPhase();
        
        return true; 
      },
      
      /*public*/ bindSession: function(bindCause) {
        if (!MadTester.canMakeRequest()) {
          this.closeSession("madb",OPEN_ON_SERVER,NO_RECOVERY_SCHEDULED);
          return false;
        }
        
        this.bindCount++;
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyOk(this.phase == PAUSE || this.phase == FIRST_PAUSE || this.phase == _OFF)) {
          sessionLogger$2.logError(LoggerManager.resolve(582));
        }
      //>>excludeEnd("debugExclude");
        
        if (this.phase == _OFF) {
          //bind someonelse's session
          if (!this.changePhaseType(FIRST_PAUSE)) { 
            return false;
          }
          
          this.prepareSlowing();
          
        }
        
        // upon the new connection, the reverse heartbeat interval may have changed;
        // this causes a dynamic invocation of handleReverseHeartbeat, but it is not enough;
        // now we have to set "force" to true, because the interval is also being communicated
        // to the Server with the bind_session request;
        // moreover, if we switch from HTTP to WS or from WS to HTTP,
        // the reverse heartbeat behavior may change (though currently not)
        this.handleReverseHeartbeat(true);
        
        this.incPushPhase();

        if (this.isPolling) {
          sessionLogger$2.logDebug(LoggerManager.resolve(583),this);
        } else {
          sessionLogger$2.logInfo(LoggerManager.resolve(584),this);
        }

        return true; 
      },
      
      isActive: function() {
          return this.phase == CREATED 
              || this.phase == FIRST_BINDING 
              || this.phase == BINDING 
              || this.phase == RECEIVING 
              || this.phase == STALLING 
              || this.phase == _STALLED;
      },
      
      /*public*/ requestSwitch: function(newHPhase,switchCause,forced) {
        this.handlerPhase = newHPhase;
        
        if (this.switchRequired) {
          //switch already requested!
          return;
        }

        sessionLogger$2.logDebug(LoggerManager.resolve(585),this);

        //in case we were waiting a slow-switch we have to override that command
        this.slowRequired = false;
        
        if (this.phase == CREATING || this.phase == SLEEP || this.phase == _OFF) { //Session Machine: during these statuses we do not have a session id
          /*
           * WARNING
           * I suppose that this condition does not happen because a session creation should never
           * superimpose another one, but I am not sure.
           */
          sessionLogger$2.logError(LoggerManager.resolve(586));
          this.handler.createMachine(this.handlerPhase,switchCause,forced);
          
        } else if (this.phase == PAUSE || this.phase == FIRST_PAUSE) {
          this.handler.switchMachine(this.handlerPhase,switchCause,forced);
          
        } else  { //Session Machine: during these statuses a control to ask for an immediate loop is sent if switch or slow are requested
          // CREATED, FIRST_BINDING, BINDING, RECEIVING, STALLING, STALLED
          this.switchRequired = true;
          this.switchForced = forced;
          this.switchCause = switchCause;
          
          this.forceRebind(switchCause);
        } 

      },
      
      /*public*/ requestSlow: function(newHPhase) {
        
        this.handlerPhase = newHPhase;
        
        if (this.slowRequired) {
          //slow already requested
          return;
        }

      sessionLogger$2.logDebug(LoggerManager.resolve(587),this);

      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyOk(this.phase != CREATING && this.phase != SLEEP && this.phase != _OFF)) {
          sessionLogger$2.logError(LoggerManager.resolve(588));
        }
      //>>excludeEnd("debugExclude");
 
        if (this.phase == PAUSE || this.phase == FIRST_PAUSE) {
          this.handler.slowMachine(this.handlerPhase);
          
        } else {
          this.slowRequired = true;
          this.forceRebind("slow");
        }
      },
      
      /*private*/ prepareSlowing: function() {
        if (this.phase == _OFF || this.phase == SLEEP) { 
          //otherwise we're binding someone else session 
          this.slowing.prepareForSync();
        }
        
        if (this.isPolling && this.forced) {
          // by convention, if polling is explicitly requested
          // we reset the estimate on the delay of the polling cycle
          this.slowing.resetSync();
        }
      },
      
      /*public*/ handleReverseHeartbeat: function(force) {
        if (this.phase == Session._OFF || this.phase == Session.CREATING || this.phase == Session.SLEEP) {
          return;
        } else {
          if (this.policyBean.reverseHeartbeatInterval > 0) {
            this.controlHandler.startReverseHeartbeats(this.policyBean.reverseHeartbeatInterval, force);
          } else {
            this.controlHandler.stopReverseHeartbeats(force);
          }
        }
      },
      
      /*public*/ closeSession: function(closeReason,alreadyClosedOnServer,noRecoveryScheduled) {
        sessionLogger$2.logInfo(LoggerManager.resolve(589),this,closeReason);
        if (this.phase != _OFF && this.phase != CREATING && this.phase != SLEEP) {
          this.handler.onObsoleteControlLink(this.getPushServerAddress());
          
          if (!alreadyClosedOnServer) {
            this.sendDestroySession(closeReason);
          }  
       
          this.handlerPhase = this.handler.onSessionClose(this.handlerPhase,noRecoveryScheduled);

          this.connectionBean.simpleSetter("sessionId",null);
          this.connectionBean.simpleSetter("serverSocketName",null);
          this.connectionBean.simpleSetter("serverInstanceAddress",null);

        } else {
            this.handlerPhase = this.handler.onSessionClose(this.handlerPhase,noRecoveryScheduled);
        }

        this.shutdown(!noRecoveryScheduled);
      },
      
      resetTimers: function() {
          this.policyBean.resetRetryDelay(this.policyBean.retryDelay);
          this.policyBean.resetConnectTimeout(this.policyBean.retryDelay);
      },
      
      /*public*/ shutdown: function(justSleep) {
        this.incPushPhase();
        this.reset();
        this.changePhaseType(justSleep?SLEEP:_OFF);
        if (this.phase == _OFF) {
            if (this.onlineHandler) {
                try {
                    window.removeEventListener('online', this.onlineHandler);
                } catch (e) {
                    // online event not supported by the browser
                }
            }
        }
        sessionLogger$2.logDebug(LoggerManager.resolve(590),this);
      },
      
      /*private*/ doPause: function(serverSentPause) {
        if (!this.changePhaseType(this.phase == CREATED ? FIRST_PAUSE : PAUSE)) {
          return;
        }
        
        //I have to inc here or I can wrongly handle a onStreamEnd notification. -
        this.incPushPhase();
        
        var pauseToUse = serverSentPause;
        if (this.isPolling) {
          //chiusura di un blocco di dati arrivati in polling
          
          if (serverSentPause >= this.policyBean.pollingInterval) ; else {
            this.policyBean.simpleSetter("pollingInterval", serverSentPause);
          }
          
          pauseToUse = this.getRealPollingInterval();

        }
        
        if (this.phase != FIRST_PAUSE && pauseToUse && pauseToUse > 0) {
          sessionLogger$2.logDebug(LoggerManager.resolve(591));
          this.launchTimeout("pause", pauseToUse);
        } else {
          this.onTimeout("noPause", this.phaseCount);
        }
      },
      
/////////////////////////////////////////EVENTS
      
      /*private*/ onTimeout: function(timeoutType, ph,usedTimeout,coreCause) {
          /*
           * !!!!! WARNING !!!!!
           * Check that the signature of this method is coherent with the use of modifyTaskParam
           * in method timeoutForStalling()
           */
        if (ph != this.phaseCount) {
          return;
        }
        if (sessionLogger$2.isDebugLogEnabled()) {
            sessionLogger$2.logDebug(LoggerManager.resolve(592), timeoutType, statusStrings[this.phase], 
                    "sid", this.sessionId,
                    "cause=", coreCause,
                    "preparingRecovery=", this.preparingRecovery);
        }

        //in case of sleep we lose information in the LS_cause
        var tCause = "timeout."+this.phase+"."+this.bindCount;
        if (this.phase == SLEEP && coreCause) {
          tCause = coreCause;
        }

        if (this.phase == CREATING) {
          var timeLeftMs = this.recoveryBean.timeLeftMs(this.policyBean.sessionRecoveryTimeout);
          if (this.recoveryBean.isRecovery() && timeLeftMs > 0) {
              /*
               * POINT OF RECOVERY (1/2):
               * a previous recovery request has received no response within the established timeout, 
               * so we send another request in loop.
               */
              if (sessionLogger$2.isDebugLogEnabled()) {
                  sessionLogger$2.logDebug(LoggerManager.resolve(593), timeLeftMs);
              }
              this.policyBean.increaseConnectTimeout();
              this.handler.recoverSession(this.handlerPhase, tCause, this.forced);
              
          } else {	    
              sessionLogger$2.logDebug(LoggerManager.resolve(594));
              var sleepCause = "create.timeout";
              //send to SLEEP
              this.closeSession(sleepCause,CLOSED_ON_SERVER,RECOVERY_SCHEDULED);
              
              this.policyBean.increaseConnectTimeout();
              this.launchTimeout("zeroDelay", 0, sleepCause);
          }

        } else if (this.phase == CREATED || this.phase == BINDING || this.phase == _STALLED || this.phase == SLEEP) {
          if (this.slowRequired || this.switchRequired) {
              sessionLogger$2.logDebug(LoggerManager.resolve(595));
              this.handler.createMachine(this.handlerPhase,tCause+".switch",this.switchForced);
          } else if (!this.isPolling || this.forced) {
              if (this.preparingRecovery) {
                  /*
                   * POINT OF RECOVERY (2/2):
                   * 
                   * This point is reached 
                   * 1) after the method onErrorEvent has detected a socket failure,
                   *    set the phase to SLEEP and scheduled the onTimeout task; or
                   * 2) when the session is STALLED because the client doesn't receive any data from the server
                   *    (see method timeoutForReconnect)
                   */
                  sessionLogger$2.logDebug(LoggerManager.resolve(596));
                  this.handler.recoverSession(this.handlerPhase, tCause, this.forced);
                  
              } else {
                  sessionLogger$2.logDebug(LoggerManager.resolve(597));
                  this.handler.retry(this.handlerPhase,tCause,this.forced,this.serverBusy);
              }
          } else {
              /*
               * Branch reserved for polling.
               * 
               * NOTE 
               * In the past, when an error occurred during polling, the new session was created not in polling
               * but in streaming (probably because polling was seen as sub-optimal transport).
               * With the introduction of the recovery, we are faced with 3 options:
               * 1) recovering the session in polling
               * 2) recovering the session in streaming
               * 3) creating a new session in streaming.
               * The second option is probably the best one, but, since the client falls-back rarely to polling,
               * in order to ease the implementation, I have decided to follow the third path.
               */
              sessionLogger$2.logDebug(this.preparingRecovery ? "Timeout: switch transport from polling (ignore recovery)" : "Timeout: switch transport from polling");
              this.handler.createMachine(this.handlerPhase,tCause,false);
          }

        } else if (this.phase == FIRST_BINDING) {
          this.workedBefore--;

          if (this.slowRequired || this.switchRequired) {
            this.handler.createMachine(this.handlerPhase,tCause+".switch",this.switchForced);
          } else if (this.workedBefore > 0 || this.forced) {
              this.handler.retry(this.handlerPhase,tCause,this.forced,this.serverBusy);
              //this.createSession(this.sessionId,tCause); //THIS is bad, because it forces us to reuse stuff
          } else if (this.createNewOnFirstBindTimeout()) {
            this.handler.createMachine(this.handlerPhase,tCause+".switch",this.switchForced);
          } else {
            this.onSessionGivesUp(this.handlerPhase,tCause);
          }

        } else if (this.phase == PAUSE) {
          if (this.isPolling) {
            this.slowing.testPollSync(usedTimeout);
          }
          this.bindSession("loop");

        } else if(this.phase == FIRST_PAUSE) {
          this.bindSession("loop1");

        } else if (this.phase == RECEIVING) {
          this.timeoutForStalled();

        } else if (this.phase == STALLING) {
          this.timeoutForReconnect();

        } else { //_OFF
          sessionLogger$2.logWarn(LoggerManager.resolve(598),this);
        }
      
      },
      
      /*protected*/ createNewOnFirstBindTimeout: function() {
        return this.isPolling;
      },
      
      /*private*/ shouldGiveUpTrying: function() {
        return this.forced || this.handler.shouldGiveUpTrying();
      },
      
      /*protected*/ onSessionGivesUp: function(ph,reason) {
        var mustClose = this.shouldGiveUpTrying();
        if (mustClose) {
          var openOnServer = this.phase != _OFF && this.phase != SLEEP ? OPEN_ON_SERVER : CLOSED_ON_SERVER;
          this.closeSession("giveup",openOnServer,NO_RECOVERY_SCHEDULED);
        }
        
        this.handler.onSessionGivesUp(ph,reason,mustClose);
      },
      
      formatArgs: function(obj) {
          var s = "";
          for (var p in obj) {
              s += p + "=" + obj[p] + " ";
          }
          return s;
      },
      
      /**
       * @param reason
       * @param closedOnServer true when receiving CONERR
       * @param fromWS
       * @param unableToOpen
       * @param noImplAvailable
       * @param possibleLoop
       * @param tryRecovery the flag is true when the method is called from onStreamError or from onStreamEnd
       * @param serverBusyError true when receiving CONERR,5
       * @param reconnectMaxDelay delay before reconnecting when the Remote Data Adapter or Metadata Adapter is disconnected (see LightstreamerClient.handleRemoteAdapterStatus)
       */
      /*protected*/ onErrorEvent: function(reason, args) {
        args = args || {};
        var closedOnServer = args.closedOnServer;
        var fromWS = args.fromWS;
        var unableToOpen = args.unableToOpen;
        var noImplAvailable = args.noImplAvailable;
        var possibleLoop = args.possibleLoop;
        var tryRecovery = args.tryRecovery;
        var serverBusyError = args.serverBusyError;
        var reconnectMaxDelay = args.reconnectMaxDelay;
        var timeLeftMs = this.recoveryBean.timeLeftMs(this.policyBean.sessionRecoveryTimeout);
        if (sessionLogger$2.isDebugLogEnabled()) {
            sessionLogger$2.logDebug(LoggerManager.resolve(599), statusStrings[this.phase], "reason=" + reason, 
                    "sid=" + this.sessionId,
                    "timeLeft=" + timeLeftMs,
                    "isRecoveryDisabled=" + this.isRecoveryDisabled,
                    this.formatArgs(args));
        }
        var startRecovery = tryRecovery && timeLeftMs > 0;
        if (this.phase == RECEIVING || this.phase == _STALLED ||this.phase == STALLING ||this.phase == BINDING || this.phase == PAUSE) {
          if (startRecovery && ! this.isRecoveryDisabled) {
              /*
               * POINT OF RECOVERY (1/2):
               * the socket failure has happened while we were receiving data.
               * 
               * To recover the session after a socket failure, set the phase to SLEEP 
               * and schedule the onTimeout task (see launchTimeout below), 
               * where the recovery will be performed.
               */
              sessionLogger$2.logDebug(LoggerManager.resolve(600));
              this.preparingRecovery = true;
              this.changePhaseType(SLEEP);
              this.launchTimeout("firstRetryMaxDelay", Helpers.randomG(this.policyBean.firstRetryMaxDelay), reason);
              
          } else {
              sessionLogger$2.logDebug(LoggerManager.resolve(601));
              this.closeSession(reason,closedOnServer,RECOVERY_SCHEDULED);
              //now is SLEEPing
              if (possibleLoop) {
                  this.launchTimeout("currentRetryDelay", this.calculateRetryDelay(),reason);
              } else {
                  if (reconnectMaxDelay) {
                      // Remote Data Adapter is disconnected
                      this.launchTimeout("reconnectMaxDelay", Math.ceil(Math.random() * reconnectMaxDelay), reason);
                  } else {                      
                      this.launchTimeout("firstRetryMaxDelay", Helpers.randomG(this.policyBean.firstRetryMaxDelay),reason);
                      // this can still lead to tight loops if the session always fails just after
                      // being established for some persistent cause; but see task:
                      // https://organizza.5pmweb.com/?def=1&task=2473
                  }
              }
          }
          
        } else if (this.phase == CREATING || this.phase == CREATED || this.phase == FIRST_BINDING) {
          if (this.recoveryBean.isRecovery() && timeLeftMs > 0 && ! closedOnServer) {
              /*
               * POINT OF RECOVERY (2/2):
               * the socket failure has happened while we were trying to do a recovery.
               * 
               * When a recovery request fails we send another one in loop until a recovery succeeds or
               * the server replies with a sync error.
               */
              sessionLogger$2.logDebug(LoggerManager.resolve(602));
              this.preparingRecovery = true;
              this.changePhaseType(SLEEP);              
              this.launchTimeout("currentRetryDelay", this.calculateRetryDelay(),reason);
              this.policyBean.increaseRetryDelay();
              
          } else if ((this.switchRequired && !this.forced) || BrowserDetection.isProbablyAndroidBrowser()) {
            sessionLogger$2.logDebug(LoggerManager.resolve(603));
            //connection is broken but we already requested a change in session type, so move on
            this.handler.createMachine(this.handlerPhase,this.switchCause+".error",this.switchForced);

          } else {
              var cause = (closedOnServer ? "closed on server" /*i.e. CONERR*/ : "socket error");
              sessionLogger$2.logDebug(LoggerManager.resolve(604), cause);
              this.closeSession(reason,closedOnServer,RECOVERY_SCHEDULED);
              //now is SLEEPing

              if (serverBusyError) {
                  // Manage CONERR 5
                  this.launchTimeout("zeroDelay", 0, reason);
                  this.policyBean.increaseConnectTimeoutToMax();
              } else if (closedOnServer) {
                  // Manage other CONERRs
                  if (reconnectMaxDelay) {
                      /*
                       * If the client is trying to create a new session
                       * When it receives a CONERR because the Metadata adapter is down
                       * Then it creates a new session after reconnectMaxDelay
                       */
                      this.launchTimeout("reconnectMaxDelay", Math.ceil(Math.random() * reconnectMaxDelay), reason);
                  } else {
                      /*
                       * If the client is trying to create a new session
                       * When it receives a CONERR 
                       * Then it creates a new session immediately
                       */
                      this.launchTimeout("zeroDelay", 0, reason);
                  }
              } else if (this.recoveryBean.isRecovery() && timeLeftMs <= 0) {
                  /*
                   * If the client is trying to recovering the current session
                   * When it detects a connection error but it can't do a recovery because the sessionRecoveryTimeout is expired
                   * Then it creates a new session immediately
                   */
                  this.launchTimeout("zeroDelay", 0, reason);
              } else {
                  this.launchTimeout("currentRetryDelay", this.calculateRetryDelay(), reason);
                  this.policyBean.increaseRetryDelay();                  
              }
          }
          
          
          
          
        }
                
      },
      
      /*private*/ onLoop: function(serverSentPause) {
        
        if (this.evalQueue && this.evalQueue.garbageCollection) {
          this.evalQueue.garbageCollection();
        }
        //phase check @ PushEvent level
        
        if (this.phase == RECEIVING || this.phase == STALLING || this.phase == _STALLED || this.phase == CREATED) {
          if (this.switchRequired) {
            this.handler.switchMachine(this.handlerPhase,this.switchCause,this.switchForced);
          } else if(this.slowRequired) {
            this.handler.slowMachine(this.handlerPhase);
          } else {
            this.doPause(serverSentPause);
          }
        } else {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$2.logError(LoggerManager.resolve(605),this);
        }
      },
      
      /*private*/ onEvent: function() {
        
        //phase check @ PushEvent level
        
        if (this.phase == CREATING) {
          if (!this.changePhaseType(CREATED)) { //inc phase count
            return;
          } 
          this.timeoutForExecution();
          
        } else if (this.phase == CREATED) ; else if (this.phase == BINDING || this.phase == FIRST_BINDING || this.phase == STALLING || this.phase == _STALLED || this.phase == RECEIVING) {
          if (!this.changePhaseType(RECEIVING)) { //inc phase count
            return;
          } 
          this.timeoutForStalling();

        } else { //FIRST_PAUSE PAUSE SLEEP _OFF 
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$2.logError(LoggerManager.resolve(606),this);
        }
        
      },
      
////////////////////////////////////////////////////////actions
      
      /*private*/ createSent: function() {
        MadTester.incMadTest();
        this.sentTime = Helpers.getTimeStamp();
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyOk(this.phase == _OFF || this.phase == SLEEP)) {
          sessionLogger$2.logError(LoggerManager.resolve(607));
        }
      //>>excludeEnd("debugExclude");
        if (!this.changePhaseType(CREATING)) {
          return false;
        }
        
        this.launchTimeout("currentConnectTimeout", this.getCurrentConnectTimeout());//will be executed if create does not return, no need to specify the cause
        
        this.evalQueue = this.handler.getEvalQueue();
      },
      
      /*private*/ bindSent: function() {
        this.sentTime = Helpers.getTimeStamp();
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyOk(this.phase == PAUSE || this.phase == FIRST_PAUSE)) {
          sessionLogger$2.logError(LoggerManager.resolve(608),this);
        }
      //>>excludeEnd("debugExclude");
        if (!this.changePhaseType(this.phase == PAUSE ? BINDING : FIRST_BINDING)) {
          return false;
        }
        
        this.serverBusy = false;
        
        this.launchTimeout("bindTimeout", this.getBindTimeout()); //will be executed if the bind does not return no need to specify the cause
        
        this.evalQueue = this.handler.getEvalQueue();
      },
      
      /*protected*/ launchTimeout: function(timeoutType, triggerAfter,timeoutCause) {
          /*
           * !!!!! WARNING !!!!!
           * Check that the signature of this method is coherent with the use of modifyTaskParam
           * in method timeoutForStalling()
           */
        if (sessionLogger$2.isDebugLogEnabled()) {        
            sessionLogger$2.logDebug(LoggerManager.resolve(609), triggerAfter, timeoutType);
        }
        return Executor.addTimedTask(this.onTimeout,triggerAfter,this,[timeoutType,this.phaseCount,triggerAfter,timeoutCause]);
      },
      
      /*private*/ timeoutForStalling: function() {
        if (this.policyBean.keepaliveInterval > 0) {
          var now = Helpers.getTimeStamp();
          //avoid filling the Executor with timeouts
          if (now - this.lastKATO < 50 && this.lastKATask) {
            /*
             * !!!!! WARNING !!!!!
             * 1) lastKATask will execute method onTimeout()
             * 2) We want to modify the parameter phase, which is currently the second one 
             *    on the signature of onTimeout()
             * 3) Check that the signatures of onTimeout() and of launchTimeout() are coherent 
             *    with the index of modifyTaskParam
             */
            Executor.modifyTaskParam(this.lastKATask,1,this.phaseCount);
          } else {
            this.lastKATO = now;
            this.lastKATask = this.launchTimeout("keepaliveInterval", this.policyBean.keepaliveInterval); //we won't reconnect if this executes, so no need to add a cause
          }
        }
      },
      
      /*private*/ timeoutForStalled: function() {
        if (!this.changePhaseType(STALLING)) {
          return;
        }
        this.launchTimeout("stalledTimeout", this.policyBean.stalledTimeout); //we won't reconnect if this executes, so no need to add a cause
      },
      
      /*private*/ timeoutForReconnect: function() {
        if (!this.changePhaseType(_STALLED)) {
          return;
        }
        var timeLeftMs = this.recoveryBean.timeLeftMs(this.policyBean.sessionRecoveryTimeout);
        this.preparingRecovery = timeLeftMs > 0 && ! this.isRecoveryDisabled;
        this.launchTimeout("reconnectTimeout", this.policyBean.reconnectTimeout); //the onTimeout already knows the cause for this because we're STALLED
      },
      
      /*private*/ timeoutForExecution: function() {
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyValue(this.phase,CREATED)) {
          sessionLogger$2.logError(LoggerManager.resolve(610));
        }
      //>>excludeEnd("debugExclude");
        this.launchTimeout("stalledTimeout", this.policyBean.stalledTimeout);  //we won't reconnect if this executes, so no need to add a cause
      },
      
////////////////////////////////////////////////////////timeouts      
      
      /*private*/ getBindTimeout: function() {
        if (this.isPolling) {
          return this.getCurrentConnectTimeout() + this.policyBean.idleTimeout;
        } else {
          return this.workedBefore > 0 && this.reconnectTimeout != null ? this.reconnectTimeout : this.getCurrentConnectTimeout();
        }
      },
      
      /*private*/ getRealPollingInterval: function() {
        if (this.phase == FIRST_PAUSE) {
          return this.policyBean.pollingInterval;
          
        } else {
        
          var refInterval = this.policyBean.pollingInterval;
  
          if (this.sentTime) {
            var now = Helpers.getTimeStamp();
            var diff = now - this.sentTime;
            if (refInterval > diff) {
              refInterval -= diff;
              // compensiamo il tempo gia' trascorso durante la richiesta;
              // notare che poteva trattarsi di polling asincrono
            } else {
              refInterval = 0;
            }
          }
  
          /*if (! isNaN(this.policyBean.serverPollingInterval)) {
            if (this.policyBean.serverPollingInterval < refInterval) {
              // non possiamo attendere piu' di quanto il Server ci concede
              refInterval = this.policyBean.serverPollingInterval;
            }
          }*/
          return refInterval;
        }
      },
      
      /*private*/ calculateRetryDelay: function() {
        var spent = Helpers.getTimeStamp() - this.sentTime;
        var currentRetryDelay = this.getCurrentRetryDelay();
        return spent > currentRetryDelay ? 0 : currentRetryDelay - spent;
      },
      
      /*private*/ calculateReconnectTimeout: function() {
        if (!this.sentTime) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$2.logError(LoggerManager.resolve(611),this);
          this.reconnectTimeout = null;
        }
        
        
        //is the actual time we spent to send the request and receive the reponse (the roundtirp) 
        var spentTime = Helpers.getTimeStamp() - this.sentTime;
        
        //we add to our connectTimeout the spent roundtrip and we'll use that time as next connectCheckTimeout
        //ok, we wanna give enough time to the client to connect if necessary, but we should not exaggerate :)
        //[obviously if spentTime can't be > this.policyBean.connectTimeout after the first connection, 
        //but it may grow connection after connection if we give him too much time]
        var ct = this.getCurrentConnectTimeout();
        this.reconnectTimeout = (spentTime > ct ? ct : spentTime) + ct;
      },
      
      
      
///////////////////////////////////////////////Callbacks
     
      /*private*/ onStreamResponse: function(_data,toCheckPhase) {
        if (EnvironmentStatus.isUnloaded() || !this.checkSessionPhase(toCheckPhase)) {  //must check the unloaded because may be called by the ajaxFrame thread
          //not from this phase, we don't care, this response is obsolete
          return;
        }
         
        if (_data === "") {
          //fake notification
          return;
        }
        
        if (_data == null) {
          //something went wrong
          //maybe the server went down? 
          //notify that something went wrong...
          MadTester.rollbackLastMadTest();
          this.onErrorEvent("nullresp");
          return;
        }
       
        this.evalQueue._enqueue(toCheckPhase,_data); //will fail if domain changes
      },
      
      /*private*/ onStreamError: function(reason,toCheckPhase,fromWS,unableToOpen,possibleLoop) {
        //must check the unloaded because may be called by the ajaxFrame thread
        //the call is usually in sync with the load call; that's not the case on Opera
        if (EnvironmentStatus.isUnloaded() || !this.checkSessionPhase(toCheckPhase)) { 
          return;
        }
        
        MadTester.rollbackLastMadTest();
        this.onErrorEvent("failure." + reason, {fromWS: fromWS, unableToOpen: unableToOpen, possibleLoop: possibleLoop, tryRecovery: true});
      },
      
      /*private*/ onStreamEnd: function(toCheckPhase,fromWS) {
          if (this.sessionRecovery && this.phase == SLEEP) {
              /*
               * The method is called because the recovery has failed due to a socket error and 
               * the socket has been closed.
               * But since we are expecting the expiration of the retryDelay to try again the recovery,
               * we don't generate an error event (see method onErrorEvent: POINT OF RECOVERY (2/2)).
               */
              return;
          }
        //in case of a good end the checkSessionPhase check will fail as we changed phase due to the loop [http cases]
        //in case of a good end the checkSessionPhase check will fail as we changed phase due to the fact that we're now in the off case [ws cases]
        
        if (this.checkSessionPhase(toCheckPhase)) {
          //avoid to count this connection as mad
          MadTester.rollbackLastMadTest();
          //try to open a new session
          this.onErrorEvent("wrongend",{fromWS: fromWS,tryRecovery: true});
        }
      
      },
      
      /*public*/ evaluationError: function() {
        this.onErrorEvent("eval");
      },
      

///////////////////////////////////////////////SlowingEvents
      
      //slowing calls this one
      onSlowRequested: function() {
        //if already slowing or switching I should not ask to slow again...
        if (this.switchRequired || this.slowRequired) {
          //this Session is already changing, we do not act
          return;
        }
            
        this.handler.onSlowRequired(this.handlerPhase);
      },
      
      //slowing calls this one
      /*public*/ onSynchOk: function() {
        
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(612));
        }
        
        this.onEvent();
        
        if (this.phase == RECEIVING) {
          //with XHRStreamingConnection we've seen cases (eg: Chrome on Android 2.2 / Opera 10.64 on Kubuntu)
          //where the first part of the connection is sent as expected while its continuation is not sent at all (Opera)
          //or is sent in blocks (Chrome) so we wait for the sync method before remembering that the streaming actually works
          this.workedBefore = PERMISSION_TO_FAIL; 
        }
      
      },
      
///////////////////////////////////////////////PushEvents
      
      onServerSentBandwidth: function(maxBandwidth) {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(613),maxBandwidth);
        }
        this.serverSentBW = maxBandwidth;
        this.policyBean.simpleSetter("realMaxBandwidth", (maxBandwidth == "unmanaged" ? "unlimited" : maxBandwidth));
      },
      
      onError41: function() {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(614));
        }
        //this is a nasty android browser bug, that causes a POST to be lost and another one to be reissued 
        //under certain circumnstances (https is fundamental for the issue to appear).
        //seen on Android: see mail thread with PartyGaming around the 13/12/2010 for further details. 

        //this is also a Sont-Bravia TV Opera bug, that causes frame-made requests to be reissued when the frame changes again
        //sometimes the correct answer reach the client, others the wrong one carrying error 41 does
        //seen on Opera on bravia TV: see mail thread with Cell-Data around 15/10/2011 for further details.  
        this.onErrorEvent("error41",{closedOnServer: true});
      },
      
      /*public*/ onKeepalive: function() {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(615));
        }
        this.onEvent();
        /*
         * In order to notify the client listener about a probe message, the following classes must be traversed:
         * - PushEvents
         * - Session
         * - SessionHandler
         * - LightstreamerEngine
         * - PushPageCollectionHandler
         * - NewPushPageHandler
         * - NewEngineHandler
         * - LightstreamerClient
         */
        this.handler.onServerKeepalive();
      },
      
      onOKReceived: function(newSession,controlLink,requestLimitLength,keepaliveIntervalDefault) {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(616));
        }
       	
        var lastUsedAddress = this.getPushServerAddress();
        var addressToUse = lastUsedAddress;
        if (controlLink != null && !this.ignoreServerAddressCache) {
          controlLink = RequestsHelper.completeControlLink(addressToUse, controlLink);
          addressToUse = controlLink;
        }
        this.sessionServerAddress = addressToUse;
        
        if (lastUsedAddress != this.sessionServerAddress) {
          this.handler.onObsoleteControlLink(lastUsedAddress);
          this.handler.onNewControlLink(this.sessionServerAddress);
        }
        
        if (keepaliveIntervalDefault) {
          if (this.isPolling) {
            //on polling sessions the longest inactivity permitted is sent instead of the keepalive setting
            this.policyBean.simpleSetter("idleTimeout", keepaliveIntervalDefault);
          } else {
            //this.policyBean.simpleSetter('serverKeepaliveInterval', keepaliveIntervalDefault);
            this.policyBean.simpleSetter("keepaliveInterval", keepaliveIntervalDefault);
          }
        }
        
        if (this.phase == CREATING) {
          //New session!
            if (this.sessionId != null && this.sessionId != newSession) {
                // nothing can be trusted here
                sessionLogger$2.logInfo(LoggerManager.resolve(617), newSession, this.sessionId);
                this.reset();
            }
          this.sessionId = newSession;
          
        } else {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          if (!ASSERT.verifyValue(this.sessionId,newSession)) {
            sessionLogger$2.logError(LoggerManager.resolve(618));
          }
        //>>excludeEnd("debugExclude");
          this.calculateReconnectTimeout();
          
        }
        
        this.slowing.startSync(this.isPolling);
        
        // NB 
        // onEvent() changes the connection status, 
        // so the connection details/options must be set before notifying the user
        this.connectionBean.simpleSetter("sessionId",newSession);
        this.connectionBean.simpleSetter("serverInstanceAddress",this.sessionServerAddress);

        this.onEvent();
       
        if (this.phase == CREATED) {
            if (this.recoveryBean.isRecovery()) {
                /* 
                 * branch reserved for recovery responses 
                 * (i.e. bind_session requests with LS_recovery_from parameter)
                 */
                this.recoveryBean.restoreTimeLeft();
                
            } else {
                /* 
                 * branch reserved for create_session responses 
                 */
                this.handler.onSessionStart(requestLimitLength);
                                
                if (this.cachedRequiredBW) {
                    this.changeBandwidth();
                    this.cachedRequiredBW = false;
                }
            }
          
        } else {
            /* 
             * branch reserved for bind_session responses (recovery responses excluded) 
             */
            this.handler.onChangeRequestLimitLength(requestLimitLength);
            this.handler.onSessionBound();
            this.onSessionBound();
        }
      },
      
      onIPReceived: function(clientIp) {
          if (clientIp) {
              this.handler.onIPReceived(clientIp);
              this.connectionBean.simpleSetter("clientIp", clientIp);
          }
      },
      
      onSyncReceived: function(secs) {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(619));
        }
        
        this.slowing.syncCheck(secs);
        
        this.onEvent();
      },
        
      /*public*/ onLoopReceived: function(serverSentPause) {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(620));
        }
      
        this.onLoop(serverSentPause);
      },
      
      /*public*/ onSyncError: function(cause) {
        this.onSessionError(cause);
      },
      
      /**
       * Manages CONERR errors.
       */
      forwardError: function(errorCode, errorMsg) {
          if (errorCode === this.policyBean.remoteAdapterStatusObserver.metadataErrorCode) {
              this.onMetadataAdapterError();
              return;
          }
          switch (errorCode) {
          
          case 20: // sync error
              this.onSyncError("syncerror");
              break;
              
          case 4: // recovery error
              this.onSyncError("recovery.error");
              break;
              
          case 5:
              {
                  this.onFatalError(errorCode, errorMsg);
              }
              break;
              
          case 40:
          case 41:
          case 48:
              // other errors which cause a new session creation
              this.onSessionError("error" + errorCode);
              break;
              
          default:
              this.onFatalError(errorCode, errorMsg);
          }
      },
      
	forwardREQERR: function(errorCode, errorMsg, listenerCallback) {
        if (errorCode == 20) { // sync error
            this.onSyncError("syncerror");
        } else if (errorCode == 11 || errorCode == 65 || errorCode == 67) {
            // error 11 is managed as CONERR 21
            if (errorCode == 11) {
                this.onFatalError(21, errorMsg);
            } else {
                this.onFatalError(errorCode, errorMsg);
            }
        } else if (listenerCallback != null) {
            try {
                listenerCallback();
            } catch (e) {
                this.handler.onFatalError(e);
            }
        } else {
            if (protocolLogger$2.isWarnLogEnabled()) {
                protocolLogger$2.logWarn(LoggerManager.resolve(621), errorCode, errorMsg);
            }
        }
	},
    
    forwardERROR: function(errorCode, errorMsg) {
        /*
         * close current session, don't create a new session, notify client listeners
         */
        this.onFatalError(errorCode, errorMsg);
    },
      
      onMetadataAdapterError: function() {
          MadTester.rollbackLastMadTest();
          this.onErrorEvent("metadata.adapter.disconnected", {
              closedOnServer: true, 
              reconnectMaxDelay: this.policyBean.remoteAdapterStatusObserver.reconnectMaxDelay});
      },
      
      /**
       * Closes the current session and creates a new session. 
       */
      onSessionError: function(cause) {
          //we've to rollback a count on the mad create or there is a tiny risk that we'll get a false positive
          //on the mad timeouts algorithm
          MadTester.rollbackLastMadTest();
          this.onErrorEvent(cause,{closedOnServer: true});
      },
      
      disconnectAndReconnect: function() {
          MadTester.rollbackLastMadTest();
          this.onErrorEvent("remote.adapter.disconnected", {
              reconnectMaxDelay: this.policyBean.remoteAdapterStatusObserver.reconnectMaxDelay});
      },
      
      onServerBusy: function() {
          //we've to rollback a count on the mad create or there is a tiny risk that we'll get a false positive
          //on the mad timeouts algorithm
          MadTester.rollbackLastMadTest();
          
          this.serverBusy = true;
          this.onErrorEvent("server.busy",{closedOnServer: true,serverBusyError: true});
      },
      
      /**
       * Closes the current session, doesn't create a new session and notifies the client listeners.
       */
      onFatalError: function(errorCode, errorMsg) {
          this.onServerError(errorCode, errorMsg);
      },
      
      /*public*/ onEnd: function(message) {
        if (protocolLogger$2.isDebugLogEnabled()) {
          protocolLogger$2.logDebug(LoggerManager.resolve(622),message);
        }
        this.closeSession("end",CLOSED_ON_SERVER,NO_RECOVERY_SCHEDULED);
      },
      
      onPROGCounterMismatch: function() {
          this.isRecoveryDisabled = true;
      },
      
      /*public*/ onUpdateReceived: function(args,snap) {
        this.onEvent();
        
        this.handler.onUpdateReceived(args,snap);
      },
      
      /*public*/ onEndOfSnapshotEvent: function(args) {
        this.onEvent();
        
        this.handler.onEndOfSnapshotEvent(args);
      },
      
      /*public*/ onClearSnapshotEvent: function(args) {
        this.onEvent();
        
        this.handler.onClearSnapshotEvent(args);
      },
      
      /*public*/ onLostUpdatesEvent: function(args) {
        this.onEvent();
        
        this.handler.onLostUpdatesEvent(args);
      },
      
      /*public*/ onMessageAck: function(sequence,num) {
        this.onEvent();
        
        this.handler.onMessageAck(sequence, num);
      },
      
      onMessageOk: function(sequence,num) {
        this.onEvent();
        
        this.handler.onMessageOk(sequence, num);
      },
      
      // <= 0 message rejected by the Metadata Adapter
      onMessageDeny: function(sequence,flag,msg,num) {
        this.onEvent();
        
        this.handler.onMessageDeny(sequence,flag,num,msg);
      },
      
      // 38 message has not arrived in time (and perhaps never come)
      /*public*/ onMessageDiscarded: function(sequence,num) {
        this.onEvent();
        
        this.handler.onMessageDiscarded(sequence,num);
      },
      
      /*public*/ onMessageError: function(sequence,flag,msg,num) {
         this.onEvent();
        
         this.handler.onMessageError(sequence,flag,num,msg);
      },
      
      /*public*/ onTableError: function(tableCode,flag,msg) {
        this.onEvent();
         
        this.handler.onTableError(tableCode,flag,msg);
      },
       
      /*public*/ onServerError: function(flag,msg) {
        this.onEnd(msg);
        
        this.handler.onServerError(flag,msg);
      },
      
      /*public*/ onUnsubscription: function(tableCode) {
        this.onEvent();
        
        this.handler.onUnsubscription(tableCode);
      },
      
      /*public*/ onSubscription: function(tableCode,numOfSubscribedItems,numOfSubscribedFields,keyPos,commandPos) {
        this.onEvent();
        
        this.handler.onSubscription(tableCode,numOfSubscribedItems,numOfSubscribedFields,keyPos,commandPos);
      },
      
      /*public*/ onSubscriptionReconf: function(tableCode,phase,frequency) {
        this.onEvent();
        
        this.handler.onSubscriptionReconf(tableCode,phase,frequency);
      },
           
      getDataNotificationProg: function() {
          return this.dataNotificationCount;
      },

      onDataNotification: function() {
          this.dataNotificationCount++;
      },
      
///////////////////////////////////////////////CONTROL      
      
      /*private*/ forceRebind: function(rebindCause) {  
        sessionLogger$2.logInfo(LoggerManager.resolve(623),this);
        
        var _data = RequestsHelper.getForceRebindParams(rebindCause,this.slowing.getDelay());

        //this is used to retry force_bind requests in case they fail to reach the server
        var tutor = new ForceRebindTutor(rebindCause,this,this.push_phase,this.policyBean);
        
        var requestListener = {
                onREQOK: function(LS_window) {
                    // nothing to do: expecting CONS
                },

                onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                    tutor.discard();
                    sessionLogger$2.logError(LoggerManager.resolve(624) + errorCode + " " + errorMsg + " - The error will be silently ignored.");
                }
        };
        this.controlHandler.addRequest(this.sessionId, _data, ControlRequest.FORCE_REBIND, tutor, null, requestListener);
        
      },
      
      // NB: you should never call sendDestroySession directly, call closeSession instead 
      // (sendDestroySession does not make checks on the situation) 
      /*private*/ sendDestroySession: function(reason) { 
        sessionLogger$2.logInfo(LoggerManager.resolve(625),this);
    
        //we always destroy the last session: if we need to destroy a session 
        //is on a browser were we don't permit the buffering of a second session
        
        var _data = RequestsHelper.getDestroyParams(this.sessionId,reason);
        
        var requestListener = {
                onREQOK: function(LS_window) {
                    // nothing to do
                },

                onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                    sessionLogger$2.logError(LoggerManager.resolve(626) + errorCode + " " + errorMsg + " - The error will be silently ignored.");
                }
        };
        this.forwardDestroyRequestToTransport(this.sessionId, _data, ControlRequest.DESTROY,null,this.getPushServerAddress(),requestListener);
      },
      
      changeBandwidth: function() {
        if (this.phase == _OFF || this.phase == SLEEP) {
          return;
        } else if (this.phase == CREATING) {
          //too late to send it via create_session
          //too early to send it via control
          this.cachedRequiredBW = true;
          return;
        } else if (this.serverSentBW == "unmanaged") {
          return;
        }
        var query = RequestsHelper.getConstraintParams(this.policyBean);
        
        var requestListener = {
                onREQOK: function(LS_window) {
                    // nothing to do: expecting CONS
                },

                onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                    sessionLogger$2.logError(LoggerManager.resolve(627) + printObj(query) + " caused the error: ", errorCode, errorMsg);
                }
        };
        this.controlHandler.addRequest(null, query, ControlRequest.CONSTRAINT, null, null, requestListener);
      },
      
      onServerName: function(name) {
          this.connectionBean.simpleSetter("serverSocketName", name);
      },

      /**@protected*/onSessionBound: function() {
          this.resetTimers();
      },
      
      /**
       * @abstract
       * Forwards a destroy request to the transport.
       * <p>
       * <i>HTTP and WebSocket implementations must be different because, since the method is called 
       * when the session is closing, WebSocket can delivery the request synchronously 
       * while HTTP has to delivery the request asynchronously.</i> 
       */
      forwardDestroyRequestToTransport: function(sessionId, request, type, related, retryingOrHost, requestListener) {
          throw new Error("abstract method");
      },
      
      onMpnRegisterOK: function(deviceId, adapterName) {
    	  this.mpnManager.eventManager.onRegisterOK(deviceId, adapterName);
      },
      
      onMpnRegisterError: function(code, message) {
    	  this.mpnManager.eventManager.onRegisterError(code, message);
      },
      
      onMpnSubscribeOK: function(lsSubId, pnSubId) {
          this.mpnManager.eventManager.onSubscribeOK(lsSubId, pnSubId);
      },
      
      onMpnSubscribeError: function(subId, code, message) {
          this.mpnManager.eventManager.onSubscribeError(subId, code, message);
      },
      
      onMpnUnsubscribeOK: function(pnSubId) {
          this.mpnManager.eventManager.onUnsubscribeOK(pnSubId);
      },
      
      onMpnUnsubscribeError: function(subId, code, message) {
          this.mpnManager.eventManager.onUnsubscribeError(subId, code, message);
      },
      
      getCurrentConnectTimeout: function() {
          return this.policyBean.currentConnectTimeout;
      },
      
      getCurrentRetryDelay: function() {
          return this.policyBean.currentRetryDelay;
      }
  };
  
  function printObj(obj) {
      var s = "{";
      for (var p in obj) {
          s += p + "=" + obj[p] + " ";
      }
      s += "}";
      return s;
  }

var StreamAsStringHandler = function(){
    this.progress=0;
  };
  
  StreamAsStringHandler.prototype = {
    
    /*private*/ extractNewData: function(_stream,isComplete) {
      
      var endIndex = -1;
      if (isComplete) {
        endIndex = _stream.length;
      } else {
        endIndex = _stream.lastIndexOf("\r\n");
        if (endIndex < 0) {
          return null;
        } else {
          endIndex += 2;
        }
      }
      
      var newData = _stream.substring(this.progress, endIndex);
      
      this.progress = endIndex;
      
      return newData;
      
    }, 
    
    /*public*/ streamProgress: function(_stream) {
      return this.extractNewData(_stream,false);
    },
    
    /*public*/ streamComplete: function(_stream) {
      return this.extractNewData(_stream,true);
    }
    
  };

var streamLogger$1 = LoggerManager.getLoggerProxy(Constants.STREAM);

  var HAVE_HTTP_STATUS = Environment.isBrowser() ? 2 : 3;

  //status 0 happens in case of a 307 redirect that gets in a CORS context
  //it is also received if the server is down.
  //In the former case we want to retry immediately, in the other case we want
  //a delay.
  //Thus we alternate the error caused by  status 0 between an unable-to-open
  //(i.e.: we were unable to send the request) and a standard error (network reached,
  //but we are unable to connect)
  var CONSIDER_STATUS_0_UNABLE_TO_OPEN = true;

  var NodeXHR;
  if (Environment.isNodeJS()) {
    NodeXHR = nodeUtils.NodeXHR;
  }
  
  var objectIdCounter$2 = 1;

  function XSXHRConnection() {
     this._callSuperConstructor(XSXHRConnection);
     
     this.objectId = objectIdCounter$2++;
     if (streamLogger$1.isDebugLogEnabled()) {
         streamLogger$1.logDebug(LoggerManager.resolve(628), this.objectId);
     }
     this.isOpen=false;

     this.sendPhase=null;
     this.cachedSenderStatus = null;
     this.xhrInstance = null;

     this.parser = null;

     this.status0Disabled = false;

     this.constr = XSXHRConnection;
  }  if (XSXHRConnection.name == null) {
      XSXHRConnection.name = "XSXHRConnection";
  }

  var doesWork = null;

  ServerConnection.attachPublicStaticMethods(XSXHRConnection,{
    isAvailable: function() {
      if (doesWork !== null) {
        return doesWork;
      }

      if (BrowserDetection.isProbablyIE(9,true)) {
        doesWork = false;
      } else if (typeof(XMLHttpRequest) != "undefined") {
        var t = new XMLHttpRequest();
        if (typeof(t.withCredentials) != "undefined") {
          doesWork = true;
        } else if (Environment.isOther()) {
          doesWork = true;
        }
      } else if (!Environment.isBrowser() && NodeXHR) {
        doesWork = true;
      }

      if (doesWork === null) {
        doesWork = false;
      }

      return doesWork;
    },
    isStreamEnabled: function() {
    //ATM, Environment.isOther() --> !t.withCredentials --> no streaming. We don't force though (isOther is currently react-active)
      return !BrowserDetection.isProbablyOldOpera() && !BrowserDetection.isProbablyPlaystation();
    },
    isCrossSite: true,
    isCrossProtocol: true,
    areCookiesGuaranteed: function() {
      if (Environment.isNodeJS()) {
        // uses a dedicated class
        return true;
      } else if (Constants.PAGE_PROTOCOL != "file:") {
        return true;
      } else if (! Environment.isBrowserDocument()) {
        // webworker results to be file: but a webworker can't be actually loaded from file: and
        // thus the withCredentials flag would always work
        return true;
      } else {
        // what about others? We do not know
        return false;
      }
    },
    attachEngineId: false,
    canUseCustomHeaders: true
  });

  function getCallback(cb) {
    return function() {
      Executor.executeTask(cb);
    };
  }

  XSXHRConnection.prototype = {

    /*public*/ toString: function() {
      return ["[","XSXHRConnection",this.isOpen,this.sendPhase,this.cachedSenderStatus,"]"].join("|");
    },

    /*public*/ _close: function() {
      if (!this.isOpen) {
        return; //wait please :)
      }

      if (streamLogger$1.isDebugLogEnabled()) {          
          streamLogger$1.logDebug(LoggerManager.resolve(629), this.objectId);
      }

      //"disable callbacks"
      this.sendPhase = null;

      if (this.xhrInstance) {
        try {
          this.xhrInstance.abort();
        } catch (e) {
          streamLogger$1.logDebug(LoggerManager.resolve(630));
        }
      }

      this.off();
      return;
    },

    /*public*/ _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      if (this.isOpen) {
        return null; //wait please :)
      }

      if (NodeXHR) {
        this.xhrInstance = new NodeXHR();
      } else {
        this.xhrInstance = new XMLHttpRequest();
      }
      this.parser = new StreamAsStringHandler();

      var loadCB = Executor.packTask(this.onPartialResponse,this,[phase,responseCallback,connectionEndCallback,errorCallback]);
      this.xhrInstance.onreadystatechange = getCallback(loadCB);

      /*var that = this;
      this.xhrInstance.onreadystatechange = function() {
        that.onPartialResponse(phase,responseCallback,connectionEndCallback);
      };*/

      this.sendPhase = phase;
      this.cachedSenderStatus = null;

      if (streamLogger$1.isDebugLogEnabled()) {
          streamLogger$1.logDebug(LoggerManager.resolve(631), this.objectId, request.getFile(), request.getData());
      }

      try {

        this.xhrInstance.open(request.getMethod(), request.getUrl(), true);

        this.xhrInstance.withCredentials = request.getCookieFlag();

        var headers = request.getExtraHeaders();
        if(headers) {
          for (var i in headers) {
            //this will prob make the browser send an OPTIONS request to the server
            this.xhrInstance.setRequestHeader(i,headers[i]);
          }
        }

        this.xhrInstance.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
        this.xhrInstance.send(request.getData());

        this.isOpen = true;

      } catch(_e) {
        streamLogger$1.logError(LoggerManager.resolve(632), this.objectId,_e);
        return false;
      }

      return true;

    },

    /*private*/ onPartialResponse: function(phase,responseCallback,connectionEndCallback,errorCallback) {
      if (this.sendPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }

      var newData = null;

      if (this.isHttpStatusOk() && responseCallback) {
        if (this.xhrInstance.readyState == 3) {
          newData = this.parser.streamProgress(this.xhrInstance.responseText);

        } else if (this.xhrInstance.readyState == 4) {
          newData = this.parser.streamComplete(this.xhrInstance.responseText);

        }

        if (streamLogger$1.isDebugLogEnabled()) {
            if (newData) {                
                streamLogger$1.logDebug(LoggerManager.resolve(633), this.objectId, newData);
            }
        }

        if(newData!=null) {
          Executor.executeTask(responseCallback, [newData,this.sendPhase]);
        }

      }

      if (this.xhrInstance.readyState == 4) {
        if (!this.isHttpStatusOk()) {
          if (this.status0Disabled) {
            if (errorCallback) {
              if (streamLogger$1.isDebugLogEnabled) {
                  streamLogger$1.logDebug(LoggerManager.resolve(634), this.objectId);
              }
              Executor.executeTask(errorCallback, ["status0",this.sendPhase,false,CONSIDER_STATUS_0_UNABLE_TO_OPEN,false]);
            }
            CONSIDER_STATUS_0_UNABLE_TO_OPEN = !CONSIDER_STATUS_0_UNABLE_TO_OPEN;
            this.status0Disabled = false;
          } else {
            if (responseCallback) {
              Executor.executeTask(responseCallback, [null,this.sendPhase]);
            }
          }


        }

        if (streamLogger$1.isDebugLogEnabled) {
            streamLogger$1.logDebug(LoggerManager.resolve(635), this.objectId);
        }

        if (( this.xhrInstance.readyState == 4 || newData == "") && connectionEndCallback) {
          //this is a good end of a connection or a broken connection;
          //let us check
          Executor.addTimedTask(this.notifyEnd, 100, this, [this.sendPhase,connectionEndCallback]);
        }

        this.off();
      }

    },

    /*private*/ notifyEnd: function(ph,connectionEndCallback) {
      Executor.executeTask(connectionEndCallback, [ph]);
    },

    /*private*/ off: function() {
      this.isOpen = false;
      this.sendPhase = null;
      if (this.xhrInstance) {
        //xhr.abort = null;
        delete(this.xhrInstance.onreadystatechange);
        delete(this.xhrInstance);
      }
    },

    /*private*/ isHttpStatusOk: function() {
      try {
        if (this.cachedSenderStatus === null) {
          if (this.xhrInstance.readyState < HAVE_HTTP_STATUS) {
            return false;
          }




          //we have to cache the value as on Chrome (seen on version 10) the status may change from 200 to 0 if the socket is closed...
          this.cachedSenderStatus = this.xhrInstance.status >= 200 && this.xhrInstance.status <= 299;

          if (this.xhrInstance.status == 0) {
            this.status0Disabled = true;
          }
        }
        return this.cachedSenderStatus;

      } catch (_e) {

        streamLogger$1.logDebug(LoggerManager.resolve(636), this.objectId,_e);
        return false;
      }
    }
  };


  Inheritance(XSXHRConnection, ServerConnection);

// var LICENSE_ERR = "LS_window.alert('License not valid for this Client version');";
    // no longer possible with the required Server versions (>= 6.2)
    // the related code has now been removed (without even knowing what it was for)
  
  var streamLogger$2 = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  var IEXSXHRConnection = function() {
     this._callSuperConstructor(IEXSXHRConnection);
     this.isOpen=false;
     
     this.sendPhase=null;
     this.parser=null;
     this.xDomainReqInstance=null;
     
     this.progresses = 0;
     
     this.constr = IEXSXHRConnection;
  };
  if (IEXSXHRConnection.name == null) {
      IEXSXHRConnection.name = "IEXSXHRConnection";
  }
  
  var canStream = null;
  
  ServerConnection.attachPublicStaticMethods(IEXSXHRConnection,{
    isAvailable: function() {
      if (canStream !== null) {
        return canStream;
      }
      
      if (typeof(XDomainRequest) != "undefined") {
        canStream = true;
      } else {
        canStream = false;
      }
      
      return canStream;  
    },
    isStreamEnabled: true,
    isCrossSite: true,
    isCrossProtocol: false,
    areCookiesGuaranteed: false,
    attachEngineId: false,
    canUseCustomHeaders: false
  });  
  
  function getCallback$1(cb) {
    return function() {
      Executor.executeTask(cb);
    };
  }
  
  IEXSXHRConnection.prototype = {
    
    /*public*/ toString: function() {
      return ["[","IEXSXHRConnection",this.isOpen,this.sendPhase,"]"].join("|");
    },
    
    /*public*/ _close: function() {
      if (!this.isOpen) {
        return;
      }
      
      streamLogger$2.logDebug(LoggerManager.resolve(637));
      
      //"disable callbacks"
      this.sendPhase = null;
      
      if (this.xDomainReqInstance) {
        try {
          this.xDomainReqInstance.abort();
          
        } catch (e) {
          streamLogger$2.logDebug(LoggerManager.resolve(638));
        }
      }
      
      this.off();
      
      return;
    },
    
    /*public*/ _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      if (this.isOpen) {
        return null; //wait please :)
      }
      
      this.progresses = 0;
      
      this.xDomainReqInstance = new XDomainRequest();
      this.parser = new StreamAsStringHandler();
          
          
      var loadCB = Executor.packTask(this.respCompleteEvent,this,[phase,responseCallback,connectionEndCallback]);  
      var errorCB = Executor.packTask(this.asyncError,this,[phase,errorCallback,"xdr.err"]);  
      var timeoutCB = Executor.packTask(this.asyncError,this,[phase,errorCallback,"xdr.timeout"]);  
      var progressCB = Executor.packTask(this.progressEvent,this,[phase,responseCallback,false]);  
        

      this.xDomainReqInstance.onload = getCallback$1(loadCB);
      this.xDomainReqInstance.onerror = getCallback$1(errorCB);
      this.xDomainReqInstance.ontimeout = getCallback$1(timeoutCB);
      this.xDomainReqInstance.onprogress = getCallback$1(progressCB);
      
      this.sendPhase = phase;
      
      if (streamLogger$2.isDebugLogEnabled()) {
          streamLogger$2.logDebug(LoggerManager.resolve(639), request.getFile(), request.getData());
      }
      
      try {
      
        this.xDomainReqInstance.open(request.getMethod(), request.getUrl());
        this.xDomainReqInstance.send(request.getData());
        
        this.isOpen = true;
       
        
      } catch(_e) {
        streamLogger$2.logError(LoggerManager.resolve(640),_e);
        return false;
      }
      
      return true;
    },
    
    /*private*/ asyncError: function(phase,errorCallback,mex) {
      if (this.sendPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }
      
      streamLogger$2.logDebug(LoggerManager.resolve(641));
      
      Executor.executeTask(errorCallback,[mex,phase,false,this.progresses==0,false]);
    },
    
    /*private*/ progressEvent: function(phase,responseCallback,completed) {
      if (this.sendPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }
      
      this.progresses++;
      
      if (responseCallback) {
        var newData;
        if (!completed) {
          newData = this.parser.streamProgress(String(this.xDomainReqInstance.responseText));
        } else {
          newData = this.parser.streamComplete(String(this.xDomainReqInstance.responseText));
        }
        
        if (streamLogger$2.isDebugLogEnabled()) {
            streamLogger$2.logDebug(LoggerManager.resolve(642), newData);
        }
        
        if(newData!=null) {
          Executor.executeTask(responseCallback,[newData,this.sendPhase]);
        }
      }       
    },
    
    /*private*/ respCompleteEvent: function(phase,responseCallback,connectionEndCallback) {
      if (this.sendPhase != phase || EnvironmentStatus.isUnloaded()) {
        return;
      }
      
      this.progressEvent(phase,responseCallback,true);
      
      this.off();
      
      streamLogger$2.logDebug(LoggerManager.resolve(643));
      
      if (connectionEndCallback) {
        //this is a good end of a connection or a broken connection;
        //let us check
        Executor.addTimedTask(this.notifyEnd, 100, this, [connectionEndCallback,phase]);
      }
      
    },
    
    /*private*/ notifyEnd: function(connectionEndCallback,ph) {
      Executor.executeTask(connectionEndCallback, [ph]);
    },
    
    
    /*private*/ off: function() {
      this.isOpen = false;
      this.sendPhase = null;
      this.parser = null;
      this.progresses = 0;
      
      if (this.xDomainReqInstance) {
        this.xDomainReqInstance.onload = null;
        this.xDomainReqInstance.onerror = null;
        this.xDomainReqInstance.ontimeout = null;
        this.xDomainReqInstance.onprogress = null;
        this.xDomainReqInstance = null;
      }
    }
  };
  
  
  Inheritance(IEXSXHRConnection, ServerConnection);

var FakeNotifyConnection = function() {
    this._callSuperConstructor(FakeNotifyConnection);
  };
  
  //this is an abstract class
  ServerConnection.attachPublicStaticMethods(FakeNotifyConnection,{
    isAvailable: false,
    isCrossSite: false,
    isCrossProtocol: false,
    areCookiesGuaranteed: false,
    attachEngineId: false,
    canUseCustomHeaders: false
  });
  
  FakeNotifyConnection.prototype = {
    
    _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      if (responseCallback) {
        Executor.addTimedTask(this.notifySender,1000,this,[responseCallback,phase]);
     }
      return true;
    },
    
    notifySender: function(responseCallback,phase) {
      //we don't have responses from the form requests (but we could...)
      //so we wait a moment and then send an empty response
      
      Executor.executeTask(responseCallback,["",phase]);
      
      
      //we could notify the handler now, in any case there is a traffic light on the formhandler
      //that will avoid "too-close" requests (the problem here is to not saturate the connection pool
    }
    
  };
  
  
  Inheritance(FakeNotifyConnection, ServerConnection);

var IFrameHandler = /*@__PURE__*/(function() {
    //Environment.browserDocumentOrDie();
  
    //about:blank causes entry in history on chrome (from the second iFrame on...)
    //null prevents IE from attaching
    //since chrome 33 using null causes a request to be sent by chrome, luckily the history issue seems solved now
    var DEFAULT_SRC = BrowserDetection.isProbablyAWebkit() && BrowserDetection.isProbablyChrome(32,true) ? null : "about:blank";

    var handledFrames = {}; 
    
    var IFrameHandler = {
      
      /**
       * Creates an invisible iFrame and returns its window if possible.
       * @param {String} name the name to assing to the iFrame's page
       * @param {String} [src] the path to be used to populate the iFrame. If not specified
       * about:blank or null will be used.
       * @returns {Window} the window inside the iFrame or null if the iFrame wasn't
       * generated or if the window is not accessible
       */
      createFrame: function(name,src) {
        if (!Environment.isBrowserDocument()) {
          return null;
        }
        var bodyEl = document.getElementsByTagName("BODY")[0];
        if (!bodyEl) {
          return null;
        }
        
        //if we already have this frame generated what should I do? 
        //if (handledFrames[name]) {
        
        src = src || DEFAULT_SRC;
        
        var iFrame = document.createElement("iframe");       
        
        iFrame.style.visibility = "hidden";
        iFrame.style.height = "0px";
        iFrame.style.width = "0px";
        iFrame.style.display="none";
        
        iFrame.name = name;
        iFrame.id = name;
        
        if (BrowserDetection.isProbablyIE() || BrowserDetection.isProbablyOldOpera()) {
          // on IE6 setting src after attaching the iFrame on an https page the browser may
          // give a non-secure alert. Some opera versions replicates the issue 
          iFrame.src = src;
          bodyEl.appendChild(iFrame);
        } else {
          // setting the src before attaching the iFrame to the page has issues on firefox
          // the set src is ignored and a different page may be loaded (if this is a reload and an iFrame was
          // generated with a different url on the previous life of the page). Hopefully the issue is now solved.
          bodyEl.appendChild(iFrame);
          iFrame.src = src;
        }
         
        try {
          if (iFrame.contentWindow) {
            try {
              iFrame.contentWindow.name = name;
            } catch(e) {
              //looks like this setting is not important; moreover Opera 10 may throw an exception here 
              //even if iFrame.contentWindow is valid         
            }
            handledFrames[name] = iFrame.contentWindow;
            return handledFrames[name];
            
          } else if (document.frames && document.frames[name]) {
            handledFrames[name] = document.frames[name];
            return handledFrames[name];
            
          } else {
            return null;
          }
        } catch(_e) {
          return null;
        }
        
      },
      
      /**
       * Get a previously created iFrame window or creates a new one.
       * @param {String} name the name for the iFrame. 
       * @param {Boolean} [createIfNull] if true and a previously created
       * iFrame with the specified name does not exists a new one will
       * be created
       * @param {String} [src] in case a new iFrame needs to be created
       * this will be the src assigned to it.
       * @returns {Window} the window inside the iFrame or null if the iFrame wasn't
       * generated or if the window is not accessible
       */
      getFrameWindow: function(name,createIfNull,src) {
        if (createIfNull && !handledFrames[name]) {
          this.createFrame(name,src);
        }
        
        return handledFrames[name] || null;
      },
      
      /**
       * Deletes the specified iFrame.
       * @param {String} name the name of the iFrame to be deleted. 
       */
      disposeFrame: function(name) {
        if (handledFrames[name]) {
          try {
             document.getElementsByTagName("BODY")[0].removeChild(document.getElementById(name));
          } catch(_e) {
            //don't know how to recover from here: we do nothing
          }
          delete(handledFrames[name]);
         }
       },
      
      /**
       * Deletes all the generated iFrames
       */ 
      removeFrames: function() {
        for (var name in handledFrames) {
          try {
            document.getElementsByTagName("BODY")[0].removeChild(document.getElementById(name));
          } catch (_e) {
          //we've seen IE7 passing from here
          }
        }
        
        handledFrames = {};
      }
      
    };
    
    IFrameHandler["createFrame"] = IFrameHandler.createFrame;
    IFrameHandler["getFrameWindow"] = IFrameHandler.getFrameWindow;
    IFrameHandler["disposeFrame"] = IFrameHandler.disposeFrame;
    IFrameHandler["removeFrames"] = IFrameHandler.removeFrames;
    
    
    EnvironmentStatus.addUnloadHandler(IFrameHandler.removeFrames);
    return IFrameHandler;
})();

//Encoder used by FormConnection and FrameConnection (note that FrameConnection is not used for control requests)
  
  var QUERY_STRING = "LS_querystring=";
  
  var QueryStringEncoder = function() {
    
  };
  
  QueryStringEncoder.prototype = {

      /*public*/ getFixedOverhead: function(fileName) {
        return QUERY_STRING.length;
      },
      
      /*public*/ getInvisibleOverhead: function(requestData) {
        if (requestData) {
          //to use the query string the entire requestData needs to be re-encoded again
          //when the full request is complete
          return encodeURIComponent(requestData).length - requestData.length;
        } else {
          return 0;
        }
      },
      
      wrapUp: function(requestData) {
        return QUERY_STRING+encodeURIComponent(requestData);
      }
  };
  
  Inheritance(QueryStringEncoder,HTTPEncoder);

//Encoder used by FormConnection and FrameConnection (note that FrameConnection is not used for control requests)
  
  var LegacyEncoder = function() {
    
  };
  
  LegacyEncoder.prototype = {
      toString: function() {
        return "[LegacyEncoder]";
      },
      
      getExt: function() {
        return ".html";
      },

      wrapUp: function(requestData) {
      //in this case the LS_querystring is added by the form itself so we skip the wrap up here.
        return requestData;
      }
  };
  
  Inheritance(LegacyEncoder,QueryStringEncoder);

var LEGACY_ENCODER = new LegacyEncoder();
  
  var streamLogger$3 = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  var formLifeSpan = 1000;
  
  var FormConnection = function(_target) {
    this._callSuperConstructor(FormConnection); 
    if (_target) {
      this.target = Utils.sanitizeIFrameName(_target);
      IFrameHandler.getFrameWindow(_target,true); 
    }
    
    this.isOpen = false;
    this.constr = FormConnection;
    this.loadPhase = 0;
  };
  
  ServerConnection.attachPublicStaticMethods(FormConnection,{
    isAvailable: function() {
      return Environment.isBrowserDocument();
    },
    isCrossSite: true, //is not actually cross site, btw as we ignore its responses we can say that isCrossSite 
    isCrossProtocol: true, //is not actually cross site, btw as we ignore its responses we can say that isCrossSite
    areCookiesGuaranteed: true,
    attachEngineId: true,
    canUseCustomHeaders: false
  });
  
  FormConnection.prototype = {
    
    /*public*/ toString: function() {
      return ["[","FormConnection",this.target,"]"].join("|");
    },
    
    /*public*/ _close: function() {
      streamLogger$3.logDebug(LoggerManager.resolve(644));
      this.isOpen = false;
      this.loadPhase++;
    },

    /*public*/ _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      if (this.isOpen) {
        return null; //please wait
      }
      this._callSuperMethod(FormConnection,this._loadName,[request,phase,responseCallback,errorCallback]);
      
      try {
        this.loadPhase++;
        var formToUse = this.generateForm();
        if (!formToUse) {
          return false;
        }
        
        if (streamLogger$3.isDebugLogEnabled()) {
            streamLogger$3.logDebug(LoggerManager.resolve(645), request.getFile(), request.getData());
        }
        
        formToUse.formEl.method = request.getMethod();
        formToUse.formEl.target = this.target;
        formToUse.formEl.action = request.getUrl();
        
        formToUse.queryString.value = request.getData();
        formToUse.formEl.submit();
        
        var ph = this.loadPhase;
        Executor.addTimedTask(this.deleteForm,formLifeSpan,this,[formToUse.formEl,ph]);
        
        this.isOpen = true;
        
      } catch(_e) {
        streamLogger$3.logError(LoggerManager.resolve(646),_e);
        return false;
      }

      return true;
    },
    
    /*private*/ generateForm: function() {
      var _body = document.getElementsByTagName("BODY")[0];
      if (!_body) {
        return null;
      }
      
      var formObj = {};
      formObj.formEl = document.createElement("FORM");
      try {
        formObj.formEl.acceptCharset="utf-8";
      } catch(_e) {
        //just in case
      }
      formObj.formEl.style.display = "none";
      
      formObj.queryString = document.createElement("INPUT");
      formObj.queryString.type = "hidden";
      formObj.queryString.name="LS_querystring";
      
      formObj.formEl.appendChild(formObj.queryString);
      
      _body.appendChild(formObj.formEl);
      
      return formObj;
 
      
      /*
      <form method="post" name="LS_form" id="LS_form" target="LS_CONTROLFRAME">
        <input type="hidden" name="LS_querystring" id="LS_querystring" value="">
      </form>
      */
    },
    
    /*private*/ deleteForm: function(_el,ph) {
      _el.parentNode.removeChild(_el);
      if (ph == this.loadPhase) {
        this.isOpen = false;
      }
    },
    
    /*public*/ getEncoder: function() {
      return LEGACY_ENCODER;
    }
  };
  
  
  
  Inheritance(FormConnection, FakeNotifyConnection);

var LEGACY_ENCODER$1 = new LegacyEncoder();

  var streamLogger$4 = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  var FrameConnection = function(target) {
    this._callSuperConstructor(FrameConnection); 
    this.target = Utils.sanitizeIFrameName(target);
    this.callPhase = 0;
    this.isOpen = false;
    this.formConnection = null;
    
    this._frame = IFrameHandler.getFrameWindow(this.target,true);
    
    this.constr = FrameConnection;
  };
  
  /*
  on IE10
    if page is https and server is https, on two different hosts but with the same domain set, this connection will unexpectedly fail.
    Lucky enough such combination does not lead to this connection unless the transport is forced to HTTP-STREAMING.  
  */
  
  ServerConnection.attachPublicStaticMethods(FrameConnection,{
    isAvailable: function() {
      return Environment.isBrowserDocument();
    },
    isCrossSite: false,
    isCrossProtocol: false,
    areCookiesGuaranteed: true,
    attachEngineId: true,
    isStreamEnabled: true,
    canUseCustomHeaders: false
  });
  
  FrameConnection.prototype = {
    
    /*public*/ toString: function() {
      return ["[","FrameConnection",this.isOpen,this.target,this.callPhase,this.formConnection,"]"].join("|");
    }, 
  
    /*private*/ _closeImpl: function(ph) {
      if (ph != this.callPhase) {
        return;
      }
      this.callPhase++;
      if (this.isOpen) {
        this._loadImpl(this.callPhase,Request.aboutBlank);
        this.isOpen = false;
      }
    },
    
    /*public*/ _close: function() {
      streamLogger$4.logDebug(LoggerManager.resolve(647));
      var ph = ++this.callPhase;
      Executor.addTimedTask(this._closeImpl,0,this,[ph]);
    },
     
    /*private*/ _loadImpl: function(ph,request,phase,responseCallback,errorCallback) {
      if (ph != this.callPhase || EnvironmentStatus.isUnloading()) {
        return;
      }
      this._callSuperMethod(FrameConnection,this._loadName,[request,phase,responseCallback,errorCallback]);
  
      this.callPhase++;
      
      if (streamLogger$4.isDebugLogEnabled()) {
          streamLogger$4.logDebug(LoggerManager.resolve(648), request.getFile(), request.getData());
      }
      
      try {
        //we could cache this reference but it seems more secure this way
        var frameRef = IFrameHandler.getFrameWindow(this.target);
        if (frameRef == null) {
            streamLogger$4.logError(LoggerManager.resolve(649));
            return false;
        }
        
        /*Simulates an error only saw on Dario's IE
        if (request.getUrl().indexOf("ajax_frame") == -1) {
          throw "Damned IE";
        }
        */
        
        var _url = request.getUrlWithParams();
      
        frameRef.location.replace(_url);
        this.isOpen = true;
        
      } catch(_e) {
        //what could I do? 
        streamLogger$4.logError(LoggerManager.resolve(650),_e);
        return false;
      }
      
      return true;
      
    },
    
    /*private*/ loadByForm: function(request,phase,responseCallback,errorCallback) {
      if (!this.formConnection) {
        this.formConnection = new FormConnection(this.target);
      }
      this.callPhase++;
      var res = this.formConnection._load(request,phase,responseCallback,errorCallback);
      if (res) {
        this.isOpen = true;
      }
      return res;
    },
    
    /*public*/ _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      if (request.method == Request._POST) {
        //we can't handle POST requests, so fall back to a FormConnection
        return this.loadByForm(request,phase,responseCallback,errorCallback);
      }
      var ph = ++this.callPhase;
      Executor.addTimedTask(this._loadImpl,0,this,[ph,request,phase,responseCallback,errorCallback]);
      return true;
    },
    
    /*public*/ getEncoder: function() {
      return LEGACY_ENCODER$1;
    }
    
  };
  
  Inheritance(FrameConnection, FakeNotifyConnection);

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Dismissable = /*@__PURE__*/(function() {
  var TOUCH_TIMEOUT = 5000;
  /**
   * This constructor simply calls the {@link Dismissable#initTouches initTouches} method. This abstract class is supposed 
   * to be extended using {@link module:Inheritance} extension.
   * It can be either light extended or fully extended. When light extension is performed
   * the {@link Dismissable#initTouches initTouches} method should be called in the extended class constructor.
   * <br/>For this class to properly work the {@link Dismissable#clean clean} method that releases the resources needs to be implemented.
   * @constructor
   * 
   * @exports Dismissable
   * @class Abstract class. Instances of extended classes can be used to keep track of the uses of a certain resources that can then be trashed 
   * after a timeout once it is no more used by anyone.
   */
  var Dismissable = function() {
    this.initTouches();
  };
  
  Dismissable.prototype = {
    
      /**
       * Abstract method that needs to be implemented to clean the used resources. This method is called internally after
       * a timeout when all of the uses ( i.e. calls to {@link Dismissable#touch touch} ) were dismissed (using {@link Dismissable#dismiss dismiss}).
       * @abstract
       */
      clean: function() {}, 
      
      /**
       * Method to be called to initialize the use of the Dismissable features.
       * If not called {@link Dismissable#touch touch} and {@link Dismissable#dismiss dismiss} calls will fail. Ideally this method
       * should be called in the constructor.
       * @protected
       *
       * @param {Number} timeout the time in ms to wait after all the uses were dismissed before actually clean the resources.
       * If a new call to {@link Dismissable#touch touch} is performed before the timeout is expired the clean is postponed until the 
       * touches count is back to 0 again. If not specified 5000 (5 seconds) is used.
       */
      initTouches: function(timeout) {
        this.inUse = 0;
        this.touchPhase = 0;
        this.timeout = timeout || TOUCH_TIMEOUT;
      },
      
      /**
       * @private
       */
      verifyTouches: function(ph) {
        if (ph == this.touchPhase && this.inUse <= 0) {
          this.clean();
        }
      },
      
      /**
       * Method to be called to declare that this instance is not in use anymore by some component. 
       * This method should only be called once per each previous {@link Dismissable#touch touch} call or the resource may be 
       * dismissed while some piece of code still needs it.
       */
      dismiss: function() {
        this.inUse--;
        
        if (this.inUse <= 0) {
          Executor.addTimedTask(this.verifyTouches,this.timeout,this,[this.touchPhase]);
        }
      },
      
      /**
       * Method to be called to declare that this instance is in use by some component. Per each
       * touch call a {@link Dismissable#dismiss dismiss} call should be called at some point or the resources will 
       * never be released.
       */
      touch: function() {
        this.touchPhase++;
        if (this.inUse < 0){
          this.inUse=0;
        }
        this.inUse++;
      }
      
      
  };
  
  //closure compiler exports
  Dismissable.prototype["touch"] = Dismissable.prototype.touch;
  Dismissable.prototype["dismiss"] = Dismissable.prototype.dismiss;
  Dismissable.prototype["clean"] = Dismissable.prototype.clean;
  Dismissable.prototype["initTouches"] = Dismissable.prototype.initTouches;
  
  return Dismissable;
})();

//possible statuses
  var DISABLED = -1; //we will never use XHR
  var LOADING_FRAME = 0; //downloading the ajax_frame.html
  var READY = 1; //can use XHR right now
  var NO_INIT = 2; //ajax_frame.html not yet loaded (ie requested by someone)
  var LOADING_AGAIN = 3; //download possibly failed, trying again
  var GIVE_UP = 4; //
  
  var streamLogger$5 = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  
  /**
   * this timeout does not block the current download, but let the sendXHR return false instead of returning true
   * this MUST be < than the connection timeout, otherwise:
   *   if the ajax frame is not on the server we will never connect
   *   also if the roundtrip is > than 4 seconds we will never try a connection in html;
   *      (actually if the roundtrip is > 4 seconds we will never wait enough for a server request to return, by the way...) 
   */
  var giveUpTimeout = 2000;
  var ajaxFrameTimeout = 10000;  // milliseconds
  
  var nextAFrame = 0;
  
  var createdFrames = {};
  
  var AjaxFrameHandler = function(path) {
    this.path = path;
    
    this.ajaxTimeoutPhase = Helpers.randomG(); 
    this.status = Environment.isBrowserDocument() && (window.ActiveXObject || typeof(XMLHttpRequest) != "undefined") ? NO_INIT  : DISABLED;
    
    this.aframeId = ++nextAFrame;
    this.frameName = "LS_AJAXFRAME_" + this.aframeId;
    
    this.initTouches();
    
    this.attachToGlobal();
  };
  
  AjaxFrameHandler.getAjaxFrame = function(serverAndServerUrlPath) {
    if (!createdFrames[serverAndServerUrlPath]){
      createdFrames[serverAndServerUrlPath] = new AjaxFrameHandler(serverAndServerUrlPath);
      createdFrames[serverAndServerUrlPath]._load(false);
    }
    return createdFrames[serverAndServerUrlPath];
  };
  
  function cleanStaticRef(serverAndServerUrlPath) {
    if (createdFrames[serverAndServerUrlPath]){
      delete (createdFrames[serverAndServerUrlPath]);
    }
  }
  

  AjaxFrameHandler.prototype = {
      
    /*public*/ toString: function() {
      return ["[","AjaxFrameHandler",this.status,"]"].join("|");
    },
    
    /*private*/ attachToGlobal: function() {
      //exports the LS_a method
      var that = this;
      Lightstreamer.exportGlobal(this.aframeId,"LS_a",function(phase) {
        that.onAjaxFrameReady(phase);
      },"A");
    },
    
    /*private*/ clean: function(ph) {
      this.status = DISABLED;
      Lightstreamer.cleanGlobal(this.aframeId,"LS_a","A");
      cleanStaticRef(this.path);
      IFrameHandler.disposeFrame(this.frameName);
    },
    
    /*private*/ init: function(retrying) {
      this.ajaxTimeoutPhase++; 
      this.status = retrying ? LOADING_AGAIN : LOADING_FRAME;
    },
    
    /*public*/ _load: function(retrying) {
      if (this.status == DISABLED) { //cannot use this.isDisabled() here as LOADING_AGAIN (and GIVE_UP) is a good status for _load to be called
        return;
      }
      
      streamLogger$5.logDebug(LoggerManager.resolve(651));
          
      if (this.isReady()) {
        //we already have this server's ajax frame 
        return;
        
      } else {
        this.init(retrying); //incs phases
        var localTimeoutPhase = this.ajaxTimeoutPhase;
        
        if (Utils.isOffline()) {
          //should be useless, if we're offline the createSession is continuosly checking if we have returned online; as soon as we are 
          //(online) a new _load will be called by the SessionHandler 
          streamLogger$5.logDebug(LoggerManager.resolve(652));
                    
          /*Executor.addTimedTask(this.asyncLoad,ajaxFrameTimeout,this,[localTimeoutPhase]);
          return;*/
        }
        
        var _command = "id="+this.aframeId+"&";
        if (!Utils.hasDefaultDomain()) {
          _command += "domain="+ Utils.getDomain() +"&";
        }
        
        var ajReq = new Request(this.path,"xhr.html",_command);
        
        var frameLoader = new FrameConnection(this.frameName);

        frameLoader._load(ajReq);
        
        //give some seconds to the ajax frame to be loaded
        Executor.addTimedTask(this.frameTimeout,ajaxFrameTimeout,this,[localTimeoutPhase]);
        Executor.addTimedTask(this.giveUp,giveUpTimeout,this,[localTimeoutPhase]);
        
      }
      
    },
    
    /*internal*/ onAjaxFrameReady: function() {
      if (EnvironmentStatus.isUnloaded()) { //must check the unloaded because is called by the ajaxFrame thread
        return;
      }

      if (this.status != READY) {

        streamLogger$5.logDebug(LoggerManager.resolve(653));
        //the ajax frame spent some time to be downloaded,
        //but now it's here and we can start using it again
        this.status = READY;
      }
    },
    
    /*private*/ frameTimeout: function(localTimeoutPhase) {
      if (this.status == DISABLED) {
        return;
      }
      if (this.ajaxTimeoutPhase == localTimeoutPhase && !this.isReady()) {
        streamLogger$5.logDebug(LoggerManager.resolve(654));
        //the ajax frame didn't arrive, next attempt will return false
        //in the meanwhile we try reloading it
        
        this._load(true);
      }
    },
    
    /*private*/ giveUp: function(localTimeoutPhase) {
      if (this.status == DISABLED) {
        return;
      }

      if (this.ajaxTimeoutPhase == localTimeoutPhase && !this.isReady()) {
        streamLogger$5.logDebug(LoggerManager.resolve(655));
        //next attempt will return false
        this.status = GIVE_UP;
      }
    },
    
    /*internal*/ disable: function() {
      this.status = DISABLED;
      this.ajaxTimeoutPhase++;
    },
    
    /*public*/ isReady: function() {
       return this.status === READY;
    },
    
    /*public*/ isDisabled: function() {
      return this.status === DISABLED || this.status === LOADING_AGAIN || this.status === GIVE_UP;
    },
    
    /**
     * @return {boolean} one of the following: 
     * null means "please wait", 
     * false means "no way", 
     * true means "sent"
     */
    /*public*/ sendXHR: function(_url,_data,senderObject,extraHeaders) {
      if (this.isDisabled()) {
        return false;
      } else if(this.status !== READY) {
        return null; //try later please
      }
        
      streamLogger$5.logDebug(LoggerManager.resolve(656),_url);
      
      var done;
      try {
        done = IFrameHandler.getFrameWindow(this.frameName)["sendRequest"](_url, _data, senderObject,extraHeaders) !== false;
        
      } catch(_e) {
        //we don't know what's happened, what should we do?
        done = false;
        streamLogger$5.logDebug(LoggerManager.resolve(657),_e);
      }
  
      if (done === false) {
        //if we received a false we completely disable the use of XHR
        this.disable();
      } 
      
      return done;
    }
  
  };
  
  Inheritance(AjaxFrameHandler,Dismissable,true,true);

//see (the name there are obsolete, but the flow is quite the same):

  var streamLogger$6 = LoggerManager.getLoggerProxy(Constants.STREAM);
  var COMM_START = "/"+"*";
  
  var XHRConnection = function() {
    this._callSuperConstructor(XHRConnection);
    
    this.sendPhase = null;
    this.sender = null; //this will be the actual XHR 
    
    this.cachedSenderStatus = null;
    
    this.response = null;
    this.error = null;
    
    this.isOpen = false;
    this.phase = 0;
    
    this["LS_x"] = this.onErrorImpl;
    this.myFrameHandler = null;
    
    this.constr = XHRConnection;
  };
  if (XHRConnection.name == null) {
      XHRConnection.name = "XHRConnection";
  }
  
  ServerConnection.attachPublicStaticMethods(XHRConnection,{
    isAvailable: function() {
      return Environment.isBrowserDocument() && (window.ActiveXObject || typeof XMLHttpRequest != "undefined");
    },
    isCrossSite: false,
    isCrossProtocol: false,
    areCookiesGuaranteed: true,
    attachEngineId: false,
    canUseCustomHeaders: true
  });
  
  XHRConnection.prototype = {
    
    /*public*/ toString: function() {
      return ["[","XHRConnection",this.isOpen,this.phase,this.sendPhase,"]"].join("|");
    },
    
    /*public*/ _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
      this.myFrameHandler = AjaxFrameHandler.getAjaxFrame(request.getPath()); 
      
      if (this.myFrameHandler.isDisabled()) {
        this.myFrameHandler.dismiss();
        return false;
      } else if (!this.myFrameHandler.isReady()) {
        //wait please :)
        return null;
      } else if (this.isOpen) {
        return null; //wait please :)
      }
      
      this.myFrameHandler.touch();
      
      this.sendPhase = phase;
      
      this.cachedSenderStatus = null;
      
      this.response = responseCallback;
      this.error = errorCallback;
      this.connectionEndCallback = connectionEndCallback;
      
      this.phase++;
      var that = this;
      var ph = this.phase;
      this["LS_h"] = function() {
        that.onReadyStateChangeImpl(ph);
      };
      
      this.isOpen = true;
      
      if (streamLogger$6.isDebugLogEnabled()) {
          streamLogger$6.logDebug(LoggerManager.resolve(658), request.getFile(), request.getData());
      }
      
      return this.myFrameHandler.sendXHR(request.getUrl(),request.getData(),this,request.getExtraHeaders());
      
    },
    
    /*public*/ _close: function() {
      if(!this.isOpen) {
        return;
      }
      this.off();
      
      streamLogger$6.logDebug(LoggerManager.resolve(659));
      
      try {
        if (this.sender && this.sender.abort) {
          this.sender.abort();
        }
      }catch(_ee) {
        //IE 8 may throw an exception while testing (just testing) the abort function, so we catch it  
        streamLogger$6.logError(LoggerManager.resolve(660),_ee);
      }
      this.cleanRef();
    },
    
    /*
     * on FX2 accessing the this.sender.status property of a request that failed due
     * to a network issue (ie the server is down) throws an exception. (IE9 in the same situation says status 12029...)
     * So it must be handled as a non-200 response (passing null to the responseCallback).
     * 
     * Note that IE9 RC throws an exception if the readyState is 3 and we check the status property; The message of the exception is "Unknown Error",
     * moreover if we try to access the responseText it says "not ready". In any case, at the moment XHRStreamingConnection is disabled on IE so that 
     * this problem should not arise.
     */
    /*private*/ isHttpStatusOk: function() {
      try {
        if (this.cachedSenderStatus === null) {
          if (this.sender.readyState < 2) {
            return false;
          } 
          //we have to cache the value as on Chrome (seen on version 10) the status may change from 200 to 0 if the socket is closed... 
          this.cachedSenderStatus = this.sender.status >= 200 && this.sender.status <= 299;
        } 
        return this.cachedSenderStatus;
        
      } catch (_e) {
        streamLogger$6.logDebug(LoggerManager.resolve(661),_e);
        return false;
      }
    },
    
    /*private*/ onReadyStateChangeImpl: function(ph) {
      if (EnvironmentStatus.isUnloaded() || ph != this.phase || !this.sender) { //must test unloaded because this method is called by XHR s thread
        return;
      }

      //should return true when the response is complete, false otherwise
    //not sure if "complete" is really needed (IE6 returns 4 as the other browsers)
      if (this.sender.readyState == 4 || this.sender.readyState == "complete") { 
        var _data = null;
        if (this.isHttpStatusOk()) {
          _data = this.sender.responseText;
          _data = _data.toString();
          if (_data.substring(0, 2) == COMM_START) { 
            _data = _data.substring(2, _data.length - 2);
          }
        } 
        
        if (streamLogger$6.isDebugLogEnabled()) {
          streamLogger$6.logDebug(LoggerManager.resolve(662),_data);
        }


        if (this.response) {
          Executor.executeTask(this.response,[_data, this.sendPhase]);
        }

        Executor.addTimedTask(this.notifyEnd, 100, this, [this.sendPhase]);

        this.off();
        //request complete, remove references
        this.cleanRef();
      }
    },

    /*private*/ notifyEnd: function(ph) {
      Executor.executeTask(this.connectionEndCallback, [ph]);
    },
    
    /*private*/ onErrorImpl: function(e) {
      if (EnvironmentStatus.isUnloaded()) { //must test unloaded because this method is called by XHR s thread
        return;
      }
      
      //when it happens XHR is disabled, there is no need to check phase and so on
      //http://www.w3.org/TR/XMLHttpRequest/#exceptions
      //Note that only SECURITY_ERR is possible as we make asynchronous XHR requests
      this.myFrameHandler.disable();
      
      streamLogger$6.logDebug(LoggerManager.resolve(663));
      
      this.off();
      if (this.error) {
        Executor.executeTask(this.error,["xhr.unknown",this.sendPhase,false,false,false]);
      }
      this.cleanRef();
    },
    
    /*private*/ cleanRef: function() {
       //try to remove circular reference (btw since such circle is wrapped 
        //it should not cause IE's leak even if left where it is)
        try {
          delete this.sender.onreadystatechange;
        } catch(_e) {
          //Firefox 3.5 sometimes passes from here
          streamLogger$6.logDebug(LoggerManager.resolve(664),_e);
        }
        try {
          delete this.sender;
        } catch(_e) {
          streamLogger$6.logDebug(LoggerManager.resolve(665),_e);
        }
        
        this.error = null;
        this.response = null;
        
        if (this.myFrameHandler) {
          this.myFrameHandler.dismiss();
        }
    },
    
    /*private*/ off: function() {
      this.isOpen = false;
      this.phase++;
    }
  };
  
  Inheritance(XHRConnection, ServerConnection);

var streamLogger$7 = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  var XHRStreamingConnection = function() {
    this._callSuperConstructor(XHRStreamingConnection);
   
    this.parser = null;

    this.constr = XHRStreamingConnection;
  };
  if (XHRStreamingConnection.name == null) {
      XHRStreamingConnection.name = "XHRStreamingConnection";
  }
  
  var xhrCanStream = null;
  
  ServerConnection.attachPublicStaticMethods(XHRStreamingConnection,{
    isAvailable: function() {
      if (xhrCanStream !== null) {
        return xhrCanStream;
      }
      
      if (!Environment.isBrowserDocument()) {
        xhrCanStream = false;
      } else if (BrowserDetection.isProbablyIE()) {
     // on IE9 the test passes but the XHR streaming does not work, so we add a IE specific clausole
        xhrCanStream = false; 
      } else if (typeof(XMLHttpRequest) != "undefined") {
        xhrCanStream = typeof(new XMLHttpRequest().addEventListener) != "undefined";
      } else {
        xhrCanStream = false;
      }
      return xhrCanStream;
    },
    isStreamEnabled: function() {
      return !BrowserDetection.isProbablyOldOpera();
    },
    isCrossSite: false,
    isCrossProtocol: false,
    areCookiesGuaranteed: true,
    attachEngineId: false,
    canUseCustomHeaders: true
  });
  
  
  XHRStreamingConnection.prototype = {
    
    /*public*/ toString: function() {
      return ["[","XHRStreamingConnection",this.isOpen,this.phase,this.sendPhase,"]"].join("|");
    },
    
    /*public*/ _load: function(request,phase,responseCallback,errorCallback,connectionEndCallback) {
       var superCall = this._callSuperMethod(XHRStreamingConnection,this._loadName,[request,phase,responseCallback,errorCallback,connectionEndCallback]);
       
       streamLogger$7.logDebug(LoggerManager.resolve(666));
       
       if (superCall) {
         this.parser = new StreamAsStringHandler();
       }
       return superCall;
    },

    /*private*/ onReadyStateChangeImpl: function(ph) {
      if (EnvironmentStatus.isUnloaded() || ph != this.phase || !this.sender) { //must test unloaded because this method is called by XHR s thread
        return;
      }
      
      var newData = null;
      if (this.isHttpStatusOk() && this.response) {
        if (this.sender.readyState == 3) {
          newData = this.parser.streamProgress(this.sender.responseText);
          
        } else if (this.sender.readyState == 4) {
          newData = this.parser.streamComplete(this.sender.responseText);
          
        }
        
        if (streamLogger$7.isDebugLogEnabled()) {
            streamLogger$7.logDebug(LoggerManager.resolve(667),newData);
        }
        
        if(newData!=null) {
          Executor.executeTask(this.response,[newData, this.sendPhase]);
        }
        
      }

      if (this.sender.readyState == 4) {
        if (!this.isHttpStatusOk() && this.response) {
          Executor.executeTask(this.response,[null, this.sendPhase]);
        }


        if (streamLogger$7.isDebugLogEnabled()) {
          streamLogger$7.logDebug(LoggerManager.resolve(668));
        }

        if ((this.sender.readyState == 4 || newData == "") && this.connectionEndCallback) {
          //this is a good end of a connection or a broken connection;
          //let us check
          Executor.addTimedTask(this.notifyEnd, 100, this, [this.sendPhase]);

        }

        this.off();
        //request complete, remove references
        this.cleanRef();
      }
      
    }
      
  };
  
  Inheritance(XHRStreamingConnection, XHRConnection);

function retFalse$1() {
      return false;
    }  
    var streamLogger$8 = LoggerManager.getLoggerProxy(Constants.STREAM);
    
    var ConnectionSelector = function(connList,blockXDomainRequest,blockCORS) {
      this.localList = connList;
      this.blockXDomainRequest = blockXDomainRequest;
      this.blockCORS = blockCORS;
      this.point = -1;
    };
    
    
    ConnectionSelector.disableWS = function() {
      WebSocketConnection.isAvailable = retFalse$1;
    };
    ConnectionSelector.disableXHRs = function() {
      XSXHRConnection.isAvailable = retFalse$1;
      IEXSXHRConnection.isAvailable = retFalse$1;
      XHRStreamingConnection.isAvailable = retFalse$1;
      XHRConnection.isAvailable = retFalse$1;
    };
    
    ConnectionSelector.STREAMING_LIST = [];
    var strList = [XSXHRConnection,IEXSXHRConnection,XHRStreamingConnection];
    for (var i$2=0; i$2 < strList.length; i$2++) {
      if (strList[i$2].isStreamEnabled()) {
        ConnectionSelector.STREAMING_LIST.push(strList[i$2]);
      }
    }
    
    ConnectionSelector.CONTROL_LIST = [XSXHRConnection,IEXSXHRConnection,XHRConnection];  
    ConnectionSelector.POLL_LIST = [XSXHRConnection,IEXSXHRConnection,XHRConnection];
    
    ConnectionSelector.useRealCallbacks = function(_instance) {
      //check if the class that we're going to use uses fake callbacks (i.e. inherits from FakeNotifyConnection) or not
      //this is a bad trick, do not abuse it
      return _instance.constr.prototype.notifySender != FakeNotifyConnection.prototype.notifySender;
    };
    
    ConnectionSelector.isGood = function(serverToUse,toTest,isCrossSite,areCookiesRequired,isCrossProtocol,hasExtraHeaders,_list) {
      if (streamLogger$8.isDebugLogEnabled()) {
          streamLogger$8.logDebug(LoggerManager.resolve(669), getClassName(toTest));
      }
      if (!toTest.isAvailable(serverToUse)) {
        streamLogger$8.logDebug(LoggerManager.resolve(670));
        return false;
      }
      
      if (isCrossSite && !toTest.isCrossSite()) {
        streamLogger$8.logDebug(LoggerManager.resolve(671));
        return false;
      }
      
      if (areCookiesRequired && !toTest.areCookiesGuaranteed()) {
        // WARNING!!! Cookie management also involves that requests on different transports
        // share the same cookies, so we cannot state that cookies are managed by taking
        // each transport separately;
        // for now we assume that xmlhttprequest is the master case and that other transports
        // support cookies only if we can share their cookies with those of xmlhttprequest
        streamLogger$8.logDebug(LoggerManager.resolve(672));
        return false;
      }
      
      if (isCrossProtocol && !toTest.isCrossProtocol()) {
        streamLogger$8.logDebug(LoggerManager.resolve(673));
        return false;
      }
      
      if (hasExtraHeaders && !toTest.canUseCustomHeaders()) {
        streamLogger$8.logDebug(LoggerManager.resolve(674));
        return false;
      }
      
      if (_list && !inList(toTest,_list)) {
        streamLogger$8.logDebug(LoggerManager.resolve(675));
        return false;
      }

      if (streamLogger$8.isDebugLogEnabled()) {
          streamLogger$8.logDebug(LoggerManager.resolve(676), getClassName(toTest));
      }
      
      return true;

    };
    
    function inList(toTest,_list) {
      for (var i = 0; i < _list.length; i++) {
        if (_list[i] == toTest) {
          return true;
        }
      }
      return false;
    }
    
    ConnectionSelector.prototype = {
        
      /*public*/ hasNext: function() {
        return this.point < this.localList.length-1;
      },
    
      /*public*/ getNext: function(serverToUse,isCrossSite,areCookiesRequired,isCrossProtocol,hasExtraHeaders) {
        if (streamLogger$8.isDebugLogEnabled()) {
            streamLogger$8.logDebug(LoggerManager.resolve(677),
                    "serverToUse",serverToUse,
                    "isCrossSite",isCrossSite,
                    "areCookiesRequired",areCookiesRequired,
                    "isCrossProtocol",isCrossProtocol,
                    "hasExtraHeaders",hasExtraHeaders);
        }
        while (this.hasNext()) {
          this.point++;
          
          var toTest = this.localList[this.point];
          
          if ((this.blockCORS || this.blockXDomainRequest) && toTest === IEXSXHRConnection) {
            continue;
          }
          
          if (this.blockCORS && toTest === XSXHRConnection) {
            continue;
          }
          
          if (!this.isGood(serverToUse,toTest,isCrossSite,areCookiesRequired,isCrossProtocol,hasExtraHeaders)) {
            continue;
          }
          
          return toTest;
        }
        
        return null;

      },
      
      /*public*/ isGood: function(serverToUse,toTest,isCrossSite,areCookiesRequired,isCrossProtocol,hasExtraHeaders) {
        return ConnectionSelector.isGood(serverToUse,toTest,isCrossSite,areCookiesRequired,isCrossProtocol,hasExtraHeaders,this.localList);
      },
      
      /*public*/ _reset: function() {
        streamLogger$8.logDebug(LoggerManager.resolve(678));
        this.point = -1;
      }
    };
    
    /**
     * Returns the class name of a constructor function.
     * <br>The name is set in *Connection class.
     */
    function getClassName(ctor) {
        return ctor.name;
    }

var hgFrameName = "LS6__HOURGLASS";
  var stopDelay = 900;
  
  var Hourglass = function() {
    this.needStopHourGlass = false;
    this.hgFrame=null;
  };

  Hourglass.prototype = {
    
    /*public*/ prepare: function(streamingClass) {
      this.needStopHourGlass = streamingClass === FrameConnection;
      if (this.needStopHourGlass) {
        this.hgFrame = IFrameHandler.getFrameWindow(hgFrameName,true);
      }
      
    },
  
    /*public*/ stopHourGlass: function() {
      Executor.addTimedTask(this.stopHourGlassExe, stopDelay, this);
    },
    
    /*public*/ stopHourGlassExe: function() {
      if (!this.needStopHourGlass) {
        return;
      }
      
      this.needStopHourGlass = false;
      if (BrowserDetection.isProbablyAKhtml()) {
        //SAFARI non soffre della clessidra. Inoltre la window.open porta in 
        //primo piano la pagina in streaming anche se l'uitente l'ha messa dietro
        return;
        
        //IE will not pass from here
        //Opera will not pass from here 
      }
  
      //20110526 -> IE9 on Win7, IE6 on XP   do not need the trick
      //            IE7 on XP,   IE8 on XP   need the trick
      if (BrowserDetection.isProbablyIE(6,true) || BrowserDetection.isProbablyIE(9,false)) {
        return;
      } 
      
      /*
      //this version does not work:
      var stopHourGlass = new Image(); //var stopHourGlass = document.createElement("img");
      stopHourGlass.src = "http://app.lightstreamer.com/PortfolioDemo/images/logo.gif";
      comms_buffer["SHG"] = stopHourGlass;
      */
     
      try {
        
        window.open("about:blank",hgFrameName, null, true);
                
      } catch(exc) {
        //happens on IE7 & IE8;
        //actually happened 326 times on 333 total on the same IP from Houston...
        //just ignore the exception as the only drawback is the hourglass that keeps spinning.
      }

    }
  };

var names$2 = {
      createSession: "createSession",
      bindSession: "bindSession",
      shutdown: "shutdown",
      bindSent: "bindSent",
      onEvent: "onEvent",
      onErrorEvent: "onErrorEvent"
  };
  names$2 = Utils.getReverse(names$2); 
  
  var MAYBE_ONLINE_TIMEOUT = 20000;
  var OFFLINE_CHECKS_PROTECTION = 1;
  var maybeOnline = 1;
  var maybePhase = 1;
  function resetMaybeOnline(mp) {
    if (mp && mp != maybePhase) {
      return;
    }
    maybePhase++;
    maybeOnline = OFFLINE_CHECKS_PROTECTION;
  }
  
  var sessionLogger$3 = LoggerManager.getLoggerProxy(Constants.SESSION);
  var protocolLogger$3 = LoggerManager.getLoggerProxy(Constants.PROTOCOL);
  
  var SessionHTTP = function(isPolling,forced,handler,handlerPhase,originalSession,skipCors,sessionRecovery) {
    this._callSuperConstructor(SessionHTTP,arguments);
    
    this.createList = null;
    this.chosenConnection = null;
    
    this.connectionList = null;
    this.myGlass = null;
    
    this.activeConnection = null;
    
    this.resetConnectionList(skipCors);
  };
  
  SessionHTTP.prototype = {
      
      /*public*/ resetConnectionList: function(skipCors) {
        
        skipCors = skipCors || !this.policyBean.corsXHREnabled;
        
        this.createList = new ConnectionSelector(ConnectionSelector.POLL_LIST, false, skipCors);
        if (this.isPolling) {
          //this.connectionList = this.createList;
          this.connectionList = new ConnectionSelector(ConnectionSelector.POLL_LIST, false, skipCors);
        } else {
          this.connectionList = new ConnectionSelector(ConnectionSelector.STREAMING_LIST, !this.policyBean.xDomainStreamingEnabled, skipCors);
        }
        
        this.chosenConnection = null;
      },
      
      getConnectedHighLevelStatus: function() {
        return this.isPolling?Constants.HTTP_POLLING:Constants.HTTP_STREAMING;
      },
      
      getFirstConnectedStatus: function() {
        return this.isPolling?Constants.HTTP_POLLING:Constants.SENSE;
      },

      toString: function() {
        return ["[","SessionHTTP","oid="+this.objectId,this.isPolling,this.forced,this.phase,this.phaseCount,this.push_phase,this.workedBefore,this.sessionId,this.dataNotificationCount,this.switchRequired,this.slowRequired,"]"].join("|");
      },
      
      /*public*/ createSession: function(oldSessionId,reconnectionCause,serverBusy) {
        if (!this._callSuperMethod(SessionHTTP,names$2['createSession'],[oldSessionId,reconnectionCause,serverBusy])) {
          return false;
        }
      
        this.createSessionExecution(this.phaseCount,reconnectionCause,oldSessionId);
        return true;
      },
      
      /*protected*/ createSessionExecution: function(ph,reconnectionCause,oldSessionId) {
        if (ph != this.phaseCount) {
          return;
        }
        
        this.handler.disableCorsCheck();
        
        if (Utils.isOffline()) {
          if (maybeOnline <= 0) {
            sessionLogger$3.logDebug(LoggerManager.resolve(679));
            Executor.addTimedTask(this.createSessionExecution,3000,this,[ph,oldSessionId,"offline"]); //overwrite reconnectionCause
            return;
          } else {
            maybeOnline--;
            if (maybeOnline == 0) {
              //avoid to lock on the offline flag, once in MAYBE_ONLINE_TIMEOUT seconds reset the flag
               Executor.addTimedTask(resetMaybeOnline,MAYBE_ONLINE_TIMEOUT,null,[maybePhase]);
            }
          }
        }
        var done = this.executeConnection(oldSessionId, this.createSessionExecution, reconnectionCause, false);
        
        if (done === null) {
          return;
          
        } else if (done) {
         this.createSent();
         
          
        } else if (done === false) {
          //WE GOT A PROBLEM!! And I don't have any solution!
          sessionLogger$3.logWarn(LoggerManager.resolve(680));
          
          this.onErrorEvent("no_impl_available",{closedOnServer: true,noImplAvailable: true});
        }
        
       
      },
      
      /*public*/ bindSession: function(bindCause) {
        if (!this._callSuperMethod(SessionHTTP,names$2['bindSession'],[bindCause])) {
          return false;
        }
        
        if (this.activeConnection) {
          this.activeConnection._close();
        }
        
        this.fixSpin();
        
        this.bindSessionExecution(this.phaseCount,bindCause);
        return true;
      },
      
      /*private*/ fixSpin: function() {
        if (!EnvironmentStatus.isLoaded()) {
          //if a bind connection is opened before the onload event on Apple browsers and Android 
          //browsers the loading indicator will remain on. This trick should remove it...
          if ((this.policyBean.spinFixEnabled === null &&  (BrowserDetection.isProbablyAndroidBrowser() || BrowserDetection.isProbablyApple())) || this.policyBean.spinFixEnabled === true) {
            var ph = this.bindCount;          
            var that = this;
            EnvironmentStatus.addOnloadHandler(function() {
              Executor.addTimedTask(function() {
                //check bindCount to prevent multiple forceRebind
                //check that a connection is currently open otherwise the fix is useless
                if (ph == that.bindCount && that.phase == Session.RECEIVING) {
                  that.forceRebind("spinfix");
                }
              },that.policyBean.spinFixTimeout);
            });
          }
        }
      },
      
      
      /*protected*/ bindSessionExecution: function(ph,bindCause) {
        if (ph != this.phaseCount) {
          return;
        }
        
        if (!this.myGlass && !this.isPolling) {
          this.myGlass = new Hourglass();
        }
        
        var done = this.executeConnection(null,this.bindSessionExecution,bindCause,false);
        
        if (done === null) {
          return;
          
        } else if (done) {
          this.bindSent();
          
        } else if (done === false) {
          //done === false
          //WE GOT A PROBLEM!!
          if (!this.isPolling) {
            //we may have more luck in polling if the request is cross-site and we're on a browser that doesn't support
            //cross-site streaming: JSONP may save us
            this.onSessionGivesUp(this.handlerPhase,"streaming.unavailable");
            return;
          }
          
          //WE GOT A PROBLEM!! And I don't have any solution!
        }
        
      },
      
      /*public*/ recoverSession: function() {
          this.incPushPhase();
          var done = this.executeConnection(null, this.recoverSession, "network.error", true);
          
          if (done === null) {
              return;

          } else if (done) {
              /*
               * Start a timeout. If the server doesn't answer to the recovery request,
               * the recovery request is sent again.
               */
              this.createSent();

          } else if (done === false) {
              sessionLogger$3.logError(LoggerManager.resolve(681));
              this.onErrorEvent("no_impl_available",{closedOnServer: true,noImplAvailable: true});
          }
      },
      
      shutdown: function(justSleep) {
        this._callSuperMethod(SessionHTTP,names$2['shutdown'],[justSleep]);
        if (this.activeConnection) {
          this.activeConnection._close();
        }
      },
      
      generateRequest: function(oldSession, reconnectionCause, askCL, sessionRecovery) {
        var isCreate = this.phase == Session._OFF || this.phase == Session.SLEEP;
        var _serverToUse = this.getPushServerAddress();
        
        var req = new Request(_serverToUse+Constants.LIGHTSTREAMER_PATH);
        
        req.setCookieFlag(this.policyBean.isCookieHandlingRequired());
        req.setExtraHeaders(this.policyBean.extractHttpExtraHeaders(isCreate));
        
        var askDomain = !req.isCrossProtocol() && !req.isCrossSite();
  
        var pushCommand;
        if (sessionRecovery) {
            pushCommand = RequestsHelper.getRecoveryCommand(this.push_phase, this.sessionId, this.policyBean, reconnectionCause, this.slowing.getDelay(), askDomain, this.dataNotificationCount);
        } else {            
            pushCommand = RequestsHelper.getPushCommand(
                    this.push_phase, this.sessionId, this.policyBean, this.connectionBean, 
                    isCreate, this.isPolling, oldSession, reconnectionCause, 
                    this.slowing.getDelay(), askCL, askDomain,
                    this.serverBusy);
        }
        req.setData(pushCommand);
        
//        protocolLogger.logDebug(LoggerManager.resolve(682),req);
        
        return req;
      },
      
      /*private*/ executeConnection: function(oldSession,retryMethod,reconnectionCause,sessionRecovery) {
        var isCreate = this.phase == Session._OFF || this.phase == Session.SLEEP;
        
        var connRequest = this.generateRequest(oldSession,reconnectionCause,true,sessionRecovery);
        var serverToUse = this.getPushServerAddress();
        
        this.controlHandler.assignWS(null); //just in case this is a switch
        
        if (this.chosenConnection && this.chosenConnection.constr == IEXSXHRConnection) {
          this.chosenConnection = null;
        }
        
        var connList = isCreate ? this.createList : this.connectionList;
        if (this.chosenConnection) {
          if (!connList.isGood(serverToUse,
              this.chosenConnection.constr,
              connRequest.isCrossSite(),
              this.policyBean.isCookieHandlingRequired(),
              connRequest.isCrossProtocol(),
              this.policyBean.hasHttpExtraHeaders(isCreate))) {
            connList._reset();
            this.chosenConnection=null;
          }
        }
        
        var done = false; //true OK / false NEVER with this connection class / null TRYLATER
        var targetName = (!this.isPolling ? "LS6__PUSHFRAME" : "LS6__POLLFRAME") + "_" + this.engineId;
        /*
         * The following loop tries a list of "connections" (i.e. transports) until
         * one of them succeeds to open the session.
         * 
         * "done == false" means that the chosenConnection was unable to open the session 
         * ==> loop again
         * 
         * "done == null"  means that the chosenConnection is trying to open the session 
         * ==> exit from loop and retry after a while with the same connection (see Executor.addTimedTask below)
         * 
         * "done == true" means that the chosenConnection was able to open the session
         * ==> set activeConnection and exit from loop
         * 
         */
        while ((this.chosenConnection || connList.hasNext()) && done === false) {
          
          if (!this.chosenConnection) {
            var classTU = connList.getNext(serverToUse,
                connRequest.isCrossSite(),
                this.policyBean.isCookieHandlingRequired(),
                connRequest.isCrossProtocol(),
                this.policyBean.hasHttpExtraHeaders(isCreate));
            
            if (!classTU) {
              //no solutions, exit
              connList._reset();
              return false;
            }
            
            this.chosenConnection = new classTU(targetName);
          }
          
          //I can't understand why after a while the constructor of this.chosenConnection become [native code], so I had to put a constr element inside the instances
          connRequest.setMethod(Request._POST);
          if (sessionRecovery) {
            connRequest.setFile(RequestsHelper.getRecoveryPath(this.chosenConnection.getEncoder().getExt()));
          } else {
            connRequest.setFile(RequestsHelper.getPushPath(isCreate,this.isPolling,this.chosenConnection.getEncoder().getExt()));
          }

          var pp = this.push_phase;
          
          done = this.chosenConnection.sessionLoad(connRequest,pp,this.cbOk,this.cbErr,this.cbEnd,this.engineId);
          
          if (done === null) {
            //try later...
            sessionLogger$3.logDebug(LoggerManager.resolve(683));
            Executor.addTimedTask(retryMethod,50,this,[this.phaseCount,reconnectionCause,oldSession]);
            return null;
          } else if (done === false) {
            this.chosenConnection = null;
          } else { 
            //if (done === true)
            sessionLogger$3.logDebug(LoggerManager.resolve(684));
            connList._reset();
            this.activeConnection = this.chosenConnection;
          }
          
        }
      
        return done;
      },
      
      
      /*protected*/ bindSent: function() {
        this._callSuperMethod(SessionHTTP,names$2['bindSent']);
        if (this.needsHourglassTrick()) {
          this.myGlass.prepare(this.activeConnection.constr);
        }
      },
      
      /*private*/ needsHourglassTrick: function() {
        return !this.isPolling;
      },
      
      /*protected*/ onErrorEvent: function(reason, args) {
        args = args || {};
        var closedOnServer = args.closedOnServer;
        var fromWS = args.fromWS;
        var unableToOpen = args.unableToOpen;
        var noImplAvailable = args.noImplAvailable;
        var possibleLoop = args.possibleLoop;
        var tryRecovery = args.tryRecovery;
        var serverBusyError = args.serverBusyError;
        if (unableToOpen && (this.chosenConnection.constr == XSXHRConnection || this.chosenConnection.constr == IEXSXHRConnection) ) {
          /* 
           * Check added to prevent the following scenario:
           * - we are in polling when we got a connection error
           * - we want to do a recovery
           * - but connections of type CORS-XHR are disabled.
           * 
           * Since CORS-XHR was receiving data before the error, we want to use it for the recovery.
           */  
          if (! tryRecovery) {
              this.handler.onCorsError(this.handlerPhase);
          }
        }
        this._callSuperMethod(SessionHTTP,names$2['onErrorEvent'],arguments);
      },
      
      /*private*/ onEvent: function() {
        if (this.phase == Session.FIRST_BINDING) {
          resetMaybeOnline();
        }
        
        if (this.needsHourglassTrick() && (this.phase == Session.BINDING || this.phase == Session.FIRST_BINDING)) {
        //"if needed" check is inside, async is done inside)
          this.myGlass.stopHourGlass(); 
        }
        
        this._callSuperMethod(SessionHTTP,names$2['onEvent']);
      },
      
      /**@override*/
      forwardDestroyRequestToTransport: function(sessionId, request, type, related, retryingOrHost, requestListener) {
          this.controlHandler.addRequest(sessionId, request, type, related, retryingOrHost, requestListener);
      }
  };
    
  
  Inheritance(SessionHTTP,Session);

var WS_OFF = 1;
  var WS_OPEN = 2;
  var WS_FAIL = 3;
  var WS_ALIVE = 4;
  var WS_INADEQUATE = 5;
  var WS_LIGHT_FAIL = 6;
  
  var names$3 = {
      createSent: "createSent",
      onTimeout: "onTimeout",
      onLoop: "onLoop",
      onStreamError: "onStreamError",
      onStreamEnd: "onStreamEnd",
      onErrorEvent: "onErrorEvent",
      shutdown: "shutdown",
      onSessionGivesUp: "onSessionGivesUp",
      onSessionBound: "onSessionBound"
  };
  names$3 = Utils.getReverse(names$3); 
    
  
  var sessionLogger$4 = LoggerManager.getLoggerProxy(Constants.SESSION);
  
  var RECOVERY_SCHEDULED$1 = false;
  
  var SessionWS = function(isPolling,forced,handler,handlerPhase,originalSession,skipCors,sessionRecovery) {
    this._callSuperConstructor(SessionWS,arguments);
    
    this.wsConn = null;
    
    this.wsPhase = WS_OFF;
    this.openWSPhase = null;
    
    this.forceEarlyWSOff = false;
    
  };
  
  
  SessionWS.prototype = {
      toString: function() {
        return ["[","SessionWS","oid="+this.objectId,this.isPolling,this.forced,this.phase,this.phaseCount,this.push_phase,this.wsPhase,this.workedBefore,this.sessionId,this.dataNotificationCount,this.wsConn,this.switchRequired,this.slowRequired,"]"].join("|");
      },
      
      /*reset: function() {
        this._callSuperMethod(SessionWS,"reset");
      },*/
      
      changeWSPhase: function(newPhase) {
        this.wsPhase = newPhase;
      },
      
      getConnectedHighLevelStatus: function() {
        return this.isPolling?Constants.WS_POLLING:Constants.WS_STREAMING;
      },
      
      getFirstConnectedStatus: function() {
        return Constants.SENSE;
      },
      
      /*private*/ openWS: function() {
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        if (!ASSERT.verifyValue(this.wsPhase,WS_OFF)) {
          sessionLogger$4.logError(LoggerManager.resolve(685));
        }
      //>>excludeEnd("debugExclude");
        
        this.openWSPhase = this.push_phase;
        
        this.wsConn =  new WebSocketConnection(this);
        var _serverToUse = this.getPushServerAddress();
        var connRequest = new Request(_serverToUse+Constants.LIGHTSTREAMER_PATH);
        
        connRequest.setCookieFlag(this.policyBean.isCookieHandlingRequired()); 
        connRequest.setExtraHeaders(this.policyBean.extractHttpExtraHeaders(false));
        
        if (ConnectionSelector.isGood(_serverToUse,
            WebSocketConnection,
            connRequest.isCrossSite(),
            this.policyBean.isCookieHandlingRequired(),
            connRequest.isCrossProtocol(),
            this.policyBean.hasHttpExtraHeaders(false))) {
            sessionLogger$4.logDebug(LoggerManager.resolve(686));
          
          if (this.wsConn.openSocket(connRequest,this.openWSPhase,this.cbOk,this.cbErr,this.cbEnd)) {
            this.controlHandler.assignWS(this.wsConn);
            this.changeWSPhase(WS_OPEN);
            return true;
          } 
        } 
        // (if this is an early open) calling this while the create has not returned yet 
        //would generate a new create
        //this.onSessionGivesUp(this.handlerPhase,"ws.notgood");
        this.changeWSPhase(WS_INADEQUATE);
        return false;
        
      },
      
      /*public*/ createSent: function() {
        this._callSuperMethod(SessionWS,names$3['createSent']);
        
        if (this.policyBean.earlyWSOpenEnabled && !this.forceEarlyWSOff) {
          this.openWS();
        } 
      },
      
      /*public*/ bindSessionExecution: function(ph,bindCause) {
        if (ph != this.phaseCount) {
          return;
        }
        
        this.forceEarlyWSOff = false;
       
        if(this.wsPhase == WS_OFF) {
          this.openWS();
        } else if (this.wsPhase == WS_OPEN) {
          //If we opened the ws to the loadbalancer but then we received a control link 
          //then we must close the current ws and open a new one
          if (!this.wsConn.isConnectedToServer(this.getPushServerAddress())) {
            sessionLogger$4.logWarn(LoggerManager.resolve(687));
            this.wsConn._close();
            this.changeWSPhase(WS_OFF);
            this.openWS();
          }
        }
        
        if (this.wsPhase == WS_LIGHT_FAIL) {
          this.onSessionGivesUp(this.handlerPhase,"ws.early.closed");
          return;
          
        } else if (this.wsPhase == WS_INADEQUATE) {
          this.onSessionGivesUp(this.handlerPhase,"ws.notgood");
          return;
          
        } else if (this.wsPhase == WS_FAIL) {
          //if we're here the create call was successful while the websocket open was not
          WebSocketConnection.disableClass(this.getPushServerAddress());
          this.onSessionGivesUp(this.handlerPhase,"ws.early.openfail");
          return;
        } 


        var connRequest = this.generateRequest(null,bindCause,false,false);
        var done = false;
        connRequest.setFile(RequestsHelper.getPushPath(false,this.isPolling,this.wsConn.getEncoder().getExt()));
        
        var firstSend = false;
        if (this.wsPhase == WS_OPEN) {
          done = this.wsConn.sessionLoad(connRequest,this.push_phase,this.cbOk,this.cbErr,this.cbEnd,this.engineId);
          firstSend = true;
          
        } else if (this.wsPhase == WS_ALIVE) {
          done = this.wsConn._send(connRequest,this.push_phase);
          
        } else {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$4.logError(LoggerManager.resolve(688),this);
        }
        
        
        if (done === null) {
          sessionLogger$4.logDebug(LoggerManager.resolve(689));
          Executor.addTimedTask(this.bindSessionExecution,50,this,[ph,bindCause]);
        } else if (done === false) {
          sessionLogger$4.logWarn(LoggerManager.resolve(690));
          this.onSessionGivesUp(this.handlerPhase,"ws.false");
        } else if (!firstSend) { 
          sessionLogger$4.logDebug(LoggerManager.resolve(691));
          this.bindSent();
        } //else wsConnection will call the firstSentNotification
        
      },
      
      firstSentNotification: function(oPhase) {
        if (this.openWSPhase == oPhase) {
          sessionLogger$4.logDebug(LoggerManager.resolve(692));
          this.bindSent();
          this.changeWSPhase(WS_ALIVE);
        }
      },
      
      /*private*/ onTimeout: function(timeoutType,ph,usedTimeout,coreCause,sessionRecovery) {
        if (ph != this.phaseCount) {
          return;
        }
      
        if (this.phase == Session.CREATING) {
          this.forceEarlyWSOff = true;
        }
        
        this._callSuperMethod(SessionWS,names$3['onTimeout'],[timeoutType,ph,usedTimeout,coreCause,sessionRecovery]);
      },
  
      onLoop: function(serverSentPause) {
        this._callSuperMethod(SessionWS,names$3['onLoop'],[serverSentPause]);
        
        if (this.wsConn) {
          //we consider ourselves paused, but still the websocket is open (polling case) or 
          //may be open (streaming case with early open)
          //I need to change its phase to handle events that may occur while we are "paused"
          this.wsConn.updatePhase(this.push_phase);
        }
      },

      /*private*/ onStreamError: function(reason,toCheckPhase,fromWS,unableToOpen,possibleLoop) {
        if (fromWS) {
          //in this case we check the openWSPhase that is semi-unrelated to the phase of the session,
          //we may open the websocket during all of the phases from OFF to FIRST_PAUSE and such
          //opening does not aff3ect the status of the session at all.
          //A positive note: when a websocket is opened but nothing is sent the only possible event it can
          //generate is an onStreamError          
          if (toCheckPhase == this.openWSPhase) {
            //once we've assessed that the open phase is correct we can forward the event
            //with the current phase.
            this._callSuperMethod(SessionWS,names$3['onStreamError'],[reason,this.push_phase,fromWS,unableToOpen,possibleLoop]);
          }
        } else {
          if (this.phase == Session.CREATING) {
            this.forceEarlyWSOff = true;
          }
          this._callSuperMethod(SessionWS,names$3['onStreamError'],arguments);
        }
      },
      
      /*private*/ onStreamEnd: function(toCheckPhase,fromWS) {
        if (fromWS) {
          if (toCheckPhase == this.openWSPhase) {
            
            if (this.phase == Session.OFF || this.phase == Session.CREATING || this.phase ==  Session.CREATED) {
              //this is the end of an early socket, consider it as an error event
              this.onErrorEvent("ws.early.end",{fromWS: true});
              
            } else {
            //>>excludeStart("debugExclude", pragmas.debugExclude);  
              if (!ASSERT.verifyDiffValue(this.phase,Session.FIRST_PAUSE)) {
                sessionLogger$4.logError(LoggerManager.resolve(693),this);
              }
            //>>excludeEnd("debugExclude"); 
              this._callSuperMethod(SessionWS,names$3['onStreamEnd'],[this.push_phase,fromWS]);
            }
            
          }
        } else {
          if (this.phase == Session.CREATING) {
            this.forceEarlyWSOff = true;
          }
          this._callSuperMethod(SessionWS,names$3['onStreamEnd'],arguments);
        }
      },
      
      /*protected*/ onErrorEvent: function(reason, args) {
        args = args || {};
        var closedOnServer = args.closedOnServer;
        var fromWS = args.fromWS;
        var unableToOpen = args.unableToOpen;
        var noImplAvailable = args.noImplAvailable;
        var possibleLoop = args.possibleLoop;
        var tryRecovery = args.tryRecovery;
        var serverBusyError = args.serverBusyError;
        if (fromWS) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          if (!ASSERT.verifyDiffValue(this.wsPhase,WS_OFF)) {
            sessionLogger$4.logError(LoggerManager.resolve(694),this);
          }
        //>>excludeEnd("debugExclude"); 
          if (unableToOpen) {
            this.changeWSPhase(WS_FAIL);
          } else {
            this.changeWSPhase(WS_LIGHT_FAIL);
          }
          
          if (this.phase == Session.OFF || this.phase == Session.CREATING || this.phase ==  Session.CREATED) {
            //this is an error on a early open, we can't act now as we must wait for the loop from the create
            //otherwise we would waste the entire session
            //NOPPING!
            sessionLogger$4.logDebug(LoggerManager.resolve(695),this);
           
          } else if (this.phase == Session.FIRST_PAUSE) {
            //ws is now in control
            //so let's act now
            sessionLogger$4.logDebug(LoggerManager.resolve(696),this);
            
            if (unableToOpen) {
              WebSocketConnection.disableClass(this.getPushServerAddress());
            }

            //as the bind was not yet sent (otherwise we would be in the FIRST_BINDING phase) we can recover
            //binding via HTTP
            this.onSessionGivesUp(this.handlerPhase,"ws.error."+reason);
            
          } else if (this.isPolling && this.phase == Session.PAUSE) {
          //>>excludeStart("debugExclude", pragmas.debugExclude);  
            if (!ASSERT.verifyNotOk(unableToOpen)) {
              sessionLogger$4.logError(LoggerManager.resolve(697),this);
            }
          //>>excludeEnd("debugExclude");
            
            sessionLogger$4.logDebug(LoggerManager.resolve(698),this);
            this.closeSession(reason,closedOnServer,RECOVERY_SCHEDULED$1);
            this.onTimeout("zeroDelay",this.phaseCount,0,"ws.broken.wait");
                      
          } else {
            //classic case, we can use the default handling
            this._callSuperMethod(SessionWS,names$3['onErrorEvent'],arguments);
            
          }
          
        } else {
          if (this.phase == Session.CREATING) {
            this.forceEarlyWSOff = true;
          }
          this._callSuperMethod(SessionWS,names$3['onErrorEvent'],arguments);
        }
        
      },
   
      /*public*/ shutdown: function(justSleep) {
        this._callSuperMethod(SessionWS,names$3['shutdown'],[justSleep]);
        if (this.wsConn) {
          this.openWSPhase = null;
          this.wsConn._close();
          this.wsConn = null;
          
          this.controlHandler.assignWS(null);
        }
        this.changeWSPhase(WS_OFF);
      },
      
      /*protected*/ needsHourglassTrick: function() {
        return false;
      },
      
      /*protected*/ onSessionGivesUp: function(ph,reason) {
          /*
           * Since a bind_session request over WebSocket failed,
           * the WebSocket support is disabled.
           * When the client IP changes, the support will be enabled again.
           */
          WebSocketConnection.disableClass(this.getPushServerAddress());
          this._callSuperMethod(SessionWS,names$3['onSessionGivesUp'],[ph, reason]);
      },
      
      /**@override*/
      onSessionBound: function() {
          this._callSuperMethod(SessionWS,names$3['onSessionBound']);
          this.wsConn.setDefaultSessionId(this.sessionId);
      },
      
      /**@override*/
      forwardDestroyRequestToTransport: function(sessionId, request, type, related, retryingOrHost, requestListener) {
          this.controlHandler.addSyncRequest(sessionId, request, type, related, retryingOrHost, requestListener);
      }
  };
  
  
  Inheritance(SessionWS,SessionHTTP);

//Coefficient of the moving average used to collect samples of delays.
  var momentum = 5/10;
  //Maximum level of the delay allowed, beyond which the adjustment is triggered (milliseconds).
  var maxMean = 7000;
  var hugeDelay = 20000;
  
  var protocolLogger$4 = LoggerManager.getLoggerProxy(Constants.PROTOCOL);
  var sessionLogger$5 = LoggerManager.getLoggerProxy(Constants.SESSION);
  
  var SlowingHandler = function(policyBean,engId) {
    
    // Time of reception of the first synchronization signal from the server; acts as a reference for subsequent checks on the delay with respect to the server.
    this.refTime = 0;
    // Average delay compared to the server so far measured (milliseconds).
    this.meanElaborationDelay = null;
    
    this.hugeFlag = false;
    
    this.policyBean = policyBean;
    
    this.session = null;
  };
  
  
  SlowingHandler.prototype = {
    
    
    /*public*/ toString: function() {
      return ["[","SlowingHandler",this.meanElaborationDelay,this.refTime,momentum,maxMean,"]"].join("|");
    },
    
    /*public*/ isLate: function(lateVal) {
      return this.meanElaborationDelay!=null  && this.meanElaborationDelay > lateVal;
    },
    
    /*public*/ changeSession: function(newSession) {
      this.session = newSession;
    },
    
    /*public*/ getDelay: function() {
      /*if (!this.policyBean.slowingEnabled) {
        return null;
      }*/
      return this.meanElaborationDelay!=null && this.meanElaborationDelay>0 ? Math.round(this.meanElaborationDelay) : null;
    },
    
    /*public*/ resetSync: function() {
      this.meanElaborationDelay = null;
      this.hugeFlag = false;
    },
    
    /*public*/ prepareForSync: function() {
      this.hugeFlag = false;
    },
   
    /*public*/ testPollSync: function(millis) {
      // we reuse the mechanism for calculating the statistics of streaming
      this.testSync(millis);
      // ignore the result; for polling, if the delays are too high,
      // we could run into a sync error with subsequent reconnection
    },
    
    /*private*/ syncCheck: function(secs) {
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      if (!ASSERT.verifyOk(this.session.isReceivingAnswer())) {
        protocolLogger$4.logError(LoggerManager.resolve(699));
      }
    //>>excludeEnd("debugExclude");
      // request for synchronization control
      if (this.session.isStreamingSession()) {
        // sync does not arrive in polling
        // and moreover they would not be significant
        var syncProblem = this.testSync(secs * 1000);

        if (!syncProblem) {
          this.session.onSynchOk();
          
        } else if (this.policyBean.slowingEnabled) {
          // we could use constrains to reduce the flow,
          // but we've seen that polling is enough
          this.session.onSlowRequested();
          
          // the average delay (meanElaborationDelay) of the streaming case
          // remains as the initial estimate of the expected delay to each poll
        }
    
      }
      
    },
    
    /*public*/ startSync: function(isPolling) {
      if (!isPolling) {
        // by convention, in streaming we reset the measurements 
        // of average delays at each new session
        this.resetSync();
      }
      
      this.refTime = Helpers.getTimeStamp();
    },
    
    /*private*/ testSync: function(millis) {
      // heuristic check to determine if the client lags behind
      // and possible relaunch of the server with heuristic modification of the minimum refresh time
      var currTime = Helpers.getTimeStamp();
      
      
      if (!this.refTime) {
        //this cannot happen..btw we handle the case signaling a delay problem
        return true;
      }
      
  /////// leave the comment to trigger the heuristic: //////////////////////////////////////////////////////////////////////////
      // this.refTime -= 2000;
      
      /*cc = !cc ? 1 : cc+1;
       if (cc == 4) {
         this.refTime -= 200000;
       } else if (cc == 5) {
         this.refTime += 200000;
       }*/
      
      var diffTime = (currTime - this.refTime) - millis;
      // calculate a moving average of delays;
      // I do not take into account the distance between the different observations
      if (this.meanElaborationDelay == null) {
        this.meanElaborationDelay = diffTime;
        sessionLogger$5.logDebug(LoggerManager.resolve(700));
        return false;        // the first time, I don't check
        
      } else {
        
        //detect unlucky sleep
        //we should avoid false positive...how? 
        //If we got a huge delay we forgive the first one but not the second one 
        if (diffTime > hugeDelay && diffTime > this.meanElaborationDelay*2) {
          this.hugeFlag = !this.hugeFlag;
          if (this.hugeFlag) {
            sessionLogger$5.logInfo(LoggerManager.resolve(701));
            //let's try to ignore this check, the pc probably slept; we should get a sync error soon
            return this.meanElaborationDelay > maxMean;
          }
        } 
        
        
        this.meanElaborationDelay = this.meanElaborationDelay * momentum + diffTime * (1 - momentum);

        if (this.meanElaborationDelay < 60) { //the executer runs every 50ms, we can forgive such delay
          this.meanElaborationDelay = 0;
          sessionLogger$5.logDebug(LoggerManager.resolve(702));
          return false;
              
        } else if (this.isLate(maxMean)) {
          // things are going bad
          sessionLogger$5.logInfo(LoggerManager.resolve(703));
          return true;
            
        } else {
          sessionLogger$5.logDebug(LoggerManager.resolve(704));
          return false;
            
        }
      }
    }
    

  };

var requestsLogger$1 = LoggerManager.getLoggerProxy(Constants.REQUESTS);
  
  function ControlRequestBatch(_batchType) {
    this.queue = [];
    this.keys = {};
    
    this.batchType = _batchType;
    this.messageNextKey = 0;
  }
  
  var CONSTRAINT_KEY = "C";
  var FORCE_REBIND_KEY = "F";
  var CHANGE_SUB_KEY = "X";
  var REVERSE_HB_KEY = "H";
  var MPN_KEY = "M";
  
  //ported from FLEX client
  ControlRequestBatch.prototype = {
    
    /*public*/ toString: function() {
      return ["[","ControlRequestBatch",this.batchType,this.queue.length,"]"].join("|");
    },
      
    /*private*/ addRequestInternal: function(tKey,request) {
      this.keys[tKey] = request;
      this.queue.push(tKey);
      
      (function(that) {
          /* check that there is no duplicated message request */
          if (that.batchType == ControlRequest.MESSAGE) {
              var seq = request["LS_sequence"];
              var prog = request["LS_msg_prog"];
              if (seq != null && prog != null) {
                  for (var i = 0, len = that.queue.length - 1 /* exclude last request */; i < len; i++) {
                      var currentReq = that.queue[i];
                      var currentSeq = currentReq["LS_sequence"];
                      var currentProg = currentReq["LS_msg_prog"];
                      if (seq == currentSeq && prog == currentProg) {
                          if (requestsLogger$1.isDebugLogEnabled()) {
                              requestsLogger$1.logErrorExc(new Error("backtrace"),
                                      "Duplicated message",
                                      "seq=", seq, "prog=", prog, "ptr=", request === currentReq);
                          }
                          requestsLogger$1.logError(LoggerManager.resolve(705), "seq=", seq, "prog=", prog);
                      }
                  }
              }
          }
      }(this));
    },
    
    /*private*/ addUniqueRequestInternal: function(tKey,request) {
        /*
         * If a request with the same key is already present, substitute the request whit the new one.
         * Otherwise add the request.
         */
        if (this.keys[tKey]) {
            this.keys[tKey] = request;            
        } else {
            this.addRequestInternal(tKey, request);
        }
      },
    
    addRequestToBatch:function(request,preventOverride) {
      
      var requestType = request.getType();
      
      
      if (requestType == ControlRequest.MESSAGE || requestType == ControlRequest.LOG || requestType == ControlRequest.HEARTBEAT) {
        if (this.batchType != requestType) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          requestsLogger$1.logError(LoggerManager.resolve(706),this);
          //should I send an exception?
          return false;
        }
      //>>excludeEnd("debugExclude");
        if (requestType == ControlRequest.HEARTBEAT) {
            /* there is at most one heartbeat request in the batch */
            this.addUniqueRequestInternal(REVERSE_HB_KEY, request);
        } else {
            //I should only add to queue, the sendMessages and log messages are always sent to the server
            this.addRequestInternal(this.messageNextKey++,request);
        }
        
        return true;
      }
      
      if ( ! (this.batchType == ControlRequest.ADD || this.batchType == ControlRequest.MPN)) {//for ADD REMOVE DESTROY CONSTRAIN or MPN
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        ASSERT.fail();
      //>>excludeEnd("debugExclude");
        requestsLogger$1.logError(LoggerManager.resolve(707),this);
        //should I send an exception?
        return false;
      }
      
      var tKey;
      switch(requestType) {
        case ControlRequest.CONSTRAINT: tKey = CONSTRAINT_KEY;
          break;
        case ControlRequest.FORCE_REBIND: tKey = FORCE_REBIND_KEY;
          break;
        case ControlRequest.CHANGE_SUB: tKey = CHANGE_SUB_KEY+request.getKey();
          break;
        case ControlRequest.MPN: tKey = MPN_KEY+request.getKey();
          break;
        default: tKey = request.getKey();
          break;
      }
      
      var queuedRequest = this.keys[tKey];
      requestsLogger$1.logDebug(LoggerManager.resolve(708),this,tKey,request);
      
      if (queuedRequest) {
        
        //there is already a request for this key, handle it
        
        if (requestType == ControlRequest.CONSTRAINT 
                || requestType == ControlRequest.FORCE_REBIND
                || requestType == ControlRequest.MPN) {
          //each constraint/force_rebind/mpn_register request override the previous one, just substitute the request in the queue.
          if (!preventOverride) {
            requestsLogger$1.logDebug(LoggerManager.resolve(709));
            this.substituteRequest(tKey,request);
          }
          return;
          
        } else if (requestType == ControlRequest.REMOVE) {
          
          if (queuedRequest.retryingOrHost) {
            requestsLogger$1.logDebug(LoggerManager.resolve(710));
            //if the ADD request that's in the queue was already sent and this is a new 
            //effort for the same ADD we send anyway the REMOVE
            //request as the other ADD request could be just very slow and not lost
            if (!preventOverride) {
              this.substituteRequest(tKey,request);
            }
            //another possibility is to remove such add, since if an update for a removed table
            //arrives a new delete request is sent
            
          } else if (queuedRequest.getType() == ControlRequest.REMOVE)  {
            requestsLogger$1.logDebug(LoggerManager.resolve(711));
            //both new and queued request are REMOVE requests for the same table, 
            //this shouldn't happen btw if it happens we don't have anything to do, 
            //we just leave the request that's already on the queue
            
          } else {
            requestsLogger$1.logDebug(LoggerManager.resolve(712));
            //if the old request was an ADD (sent for the first time) and the new one is a REMOVE, 
            //we don't need to send anything to the server, just delete the ADD
            //request and return
            
          //>>excludeStart("debugExclude", pragmas.debugExclude);  
            if (!ASSERT.verifyNotOk(preventOverride)) {
              requestsLogger$1.logError(LoggerManager.resolve(713),this);
            }
          //>>excludeEnd("debugExclude");
            if (!preventOverride) {
              this.removeRequestByKey(tKey);
            }
            
          }
          return;
        
        } else if (requestType == ControlRequest.DESTROY) {
          //we've already queued the DESTORY request for this session. 
          //Since Destroy are indexed by session id there can be a very unlucky case where 
          //two sessions from two different servers have the same id. So check for this case, you'll never know...
          
          while (queuedRequest && request.retryingOrHost != queuedRequest.retryingOrHost) {
            requestsLogger$1.logDebug(LoggerManager.resolve(714));
            tKey += "_";
            queuedRequest = this.keys[tKey];
          }
          
          if (queuedRequest) {
            requestsLogger$1.logDebug(LoggerManager.resolve(715));
            return;
          }
         
        } else { //if (requestType == ControlRequest.ADD || requestType == ControlRequest.CHANGE_SUB)
          //can never happen that an ADD request substitutes a REMOVE request for 2 reasons:
          //  *if those requests are part of the same session than to remove and re-add a table
          //   change its key.
          //  *if those requests are not part of the same session than during session change
          //   all pending request are removed.
          //so, all cases should pass from the if (requestType == ControlRequest.REMOVE) case
          if (!preventOverride) {
              requestsLogger$1.logDebug(LoggerManager.resolve(716));
            //by the way, if something terribly wrong happened, we have to do something...
            //let's try substituting
            //(for the RECONF case is perfectly ok to pass from here)
            this.substituteRequest(tKey,request);
          }
          return; 
        }
      } 
      
      requestsLogger$1.logDebug(LoggerManager.resolve(717));
      this.addRequestInternal(tKey,request);

    },
    
    getLength: function() {
      return this.queue.length;
    },
    
    /*private*/ substituteRequest : function(tKey,newRequest) {
      this.keys[tKey] = newRequest;
    },
    
    /*private*/ removeRequestByIndex: function(_index) {
      if (this.queue.length <= _index) {
        requestsLogger$1.logError(LoggerManager.resolve(718));
        return null;
      }
      var tKey = this.queue[_index];
      this.queue.splice(_index, 1);
      
      var req = this.keys[tKey];
      delete this.keys[tKey];
      
      return req;
      
    },
    
    /*private*/ removeRequestByKey: function(tKey) {
      if (!this.keys[tKey]) {
        requestsLogger$1.logError(LoggerManager.resolve(719));
        return null;
      }
      
      for (var i = 0; i < this.queue.length; i++) {
        if (this.queue[i] == tKey) {
          return this.removeRequestByIndex(i);
        }
      }
      
    },
    
    
    /*public*/ shift: function() {
      return this.removeRequestByIndex(0);
    },
    
    /*public*/ pop: function() {
      return this.removeRequestByIndex(this.queue.length-1);
    },
    
    /*public*/ last: function() {
      return this.getRequestObject(this.queue.length-1);
    },
    
    /*public*/ firstRequest: function() {
      return this.getRequestObject(0);
    },
    
    /*public*/ getRequestObject: function(num) {
      if (this.queue.length <= 0) {
        return null;
      }
      var tKey = this.queue[num];
      return this.keys[tKey];
    },
    
    /*public*/ getBatchType: function() {
      return this.batchType;
    }
    
  };

var requestsLogger$2 = LoggerManager.getLoggerProxy(Constants.REQUESTS);
  var streamLogger$9 = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  
  var _IDLE = 1;
  var _STANDBY = 2;
  var _WAITING = 3;
  
  var phNames = {};
  phNames[_IDLE] = "IDLE";
  phNames[_STANDBY] = "STAND BY";
  phNames[_WAITING] = "WAITING RESP";
  
  var SYNC_DEQUEUE = true;
  var ASYNC_DEQUEUE = false;
  var WAIT_CONN_DELAY = 200;
  var WAIT_RESP_DELAY = 4000;
  
  var REQ_EMPTY = 1;
  var SEND_LATER = 2;
  var NO_CONN = 3;
  var SENT_HTTP = 4;
  var SENT_WS = 5;
  
  var SECURITY_LIMIT = 1;
  
  
  function phToStr(ph) {
    return phNames[ph];
  }
  
  
  
 
  
  
  
  
  
  function firstRequestToRequest(queueToSend,srvAddr,cookieRequired,extraHeaders) {
    var firstRequest = queueToSend.firstRequest();
    if (!firstRequest) {
      return null;
    }
    var req = new Request(((firstRequest.retryingOrHost && firstRequest.retryingOrHost !== true) ? firstRequest.retryingOrHost : srvAddr)+Constants.LIGHTSTREAMER_PATH);
    req.setCookieFlag(cookieRequired);
    req.setExtraHeaders(extraHeaders);
    return req;
  }
  
  
  
  
  /**
   * accumula richieste di controllo
   * si basa sulla gestione dei thread JS, lanciando il lanciatore in una
   * setTimeout questo metodo dovrebbe fare in tempo a accumulare assieme
   * tutte le table ADDate durante il thread corrente
   */
  var ControlConnectionHandler = function(owner,policyBean,engId,skipCors) {
    this.corsDisabled = false;
    this.connectionList = null;
    this.conn = null;
    
    this.messageQueue = null; 
    this.controlQueue = null;
    this.logQueue = null;
    this.destroyQueue = null;
    this.hbQueue = null;
    this.mpnQueue = null;
    
    this.currentReverseHeartbeatInterval = 0;
    this.grantedReverseHeartbeatInterval = 0;
    // grantedReverseHeartbeatInterval was declared in a streaming bind_session,
    // so, it must be maintained as long as the streaming connection is active;
    // hence the invariant:
        // grantedReverseHeartbeatInterval == 0 || 0 != currentReverseHeartbeatInterval <= grantedReverseHeartbeatInterval
    
    this.requestLimit = 0; 

    this.statusPhase = 1;
    this.status = _IDLE;
    this.phase = 1; //this phase is incremented only by the reset method. It is used to check if between addRequest and addRequestExe a reset occurred

    this.typeFlag = 0; // handles turns (control-sendMessage-sendLog)
   
    this.lastBatch = null;

//>>excludeStart("debugExclude", pragmas.debugExclude);
    this.fakeSyncError = false;
//>>excludeEnd("debugExclude");
  
    
    
    this._owner = owner;
    this.policyBean = policyBean;
    this.engId = engId;
    
    this.wsConn = null;
    
    /**
     * Maps LS_reqId with the corresponding request listeners.
     * The listeners (called by EvalQueue) manage REQOK/REQERR responses according to the request types.
     */
    this.requestListenerMap = {};
  
    this.resetConnectionList(skipCors);
    this._reset();
  };
  
  ControlConnectionHandler.prototype = {
    
    /*public*/ toString: function() {
      return ["[","ControlConnectionHandler",phToStr(this.status),this.lastBatch,this.requestLimit,this.currentReverseHeartbeatInterval,"]"].join("|");
    },
    
    /*public*/ setRequestLimit: function(newLimit) {
      this.requestLimit = newLimit;
      requestsLogger$2.logDebug(LoggerManager.resolve(720),this);
    },
    
    /*public*/ startReverseHeartbeats: function(newInterval, force) {
      if (force) {
          this.currentReverseHeartbeatInterval = newInterval;
          this.grantedReverseHeartbeatInterval = newInterval;
          requestsLogger$2.logInfo(LoggerManager.resolve(721),this);
      } else {
          if (this.grantedReverseHeartbeatInterval == 0 || newInterval < this.grantedReverseHeartbeatInterval) {
              this.currentReverseHeartbeatInterval = newInterval;
              requestsLogger$2.logInfo(LoggerManager.resolve(722),this);
          } else {
              this.currentReverseHeartbeatInterval = this.grantedReverseHeartbeatInterval;
              requestsLogger$2.logInfo(LoggerManager.resolve(723),this);
          }
      }
      if (this.status == _IDLE) {
        this.sendReverseHeartbeat(this.statusPhase);
        // this may be redundant in many cases, for instance if we are sending a bind request,
        // but the case is rare and we don't want to complicate things with a check
      }
    },
    
    sendReverseHeartbeat: function(sc) {
      if (this.status != _IDLE || this.statusPhase != sc || this.currentReverseHeartbeatInterval == 0) {
        return;
      }
      
      requestsLogger$2.logDebug(LoggerManager.resolve(724),this);
      this.addRequest(null, "", ControlRequest.HEARTBEAT);
   
    },
    
    /*public*/ stopReverseHeartbeats: function(force) {
      if (force) {
          requestsLogger$2.logInfo(LoggerManager.resolve(725),this);
          this.currentReverseHeartbeatInterval = 0;
          this.grantedReverseHeartbeatInterval = 0;
          //do nothing, the next heartbeat will not be sent because of the 0 interval
      } else {
          if (this.grantedReverseHeartbeatInterval == 0) {
              requestsLogger$2.logInfo(LoggerManager.resolve(726),this);
              this.currentReverseHeartbeatInterval = 0;
              //do nothing, the next heartbeat will not be sent because of the 0 interval
          } else {
              requestsLogger$2.logInfo(LoggerManager.resolve(727),this);
              this.currentReverseHeartbeatInterval = this.grantedReverseHeartbeatInterval;
          }
      }
    },
    
    /*public*/ resetConnectionList: function(skipCors) {
      this.connectionList = new ConnectionSelector(ConnectionSelector.CONTROL_LIST,false,!this.policyBean.corsXHREnabled || skipCors);
      this.conn = null;
    },
    
    /*private*/ _close: function() {
      requestsLogger$2.logDebug(LoggerManager.resolve(728));
      if (this.conn) {
        this.conn._close();
      }
    },
    
    /*private*/ changeStatus: function(newStatus, caller) {
      this.statusPhase++; //used to verify deque and sendHeartbeats calls
            
      if (newStatus == _IDLE && this.currentReverseHeartbeatInterval > 0) {
        Executor.addTimedTask(this.sendReverseHeartbeat,this.currentReverseHeartbeatInterval,this,[this.statusPhase]);
      }
      if (requestsLogger$2.isDebugLogEnabled()) {          
          requestsLogger$2.logDebug(LoggerManager.resolve(729), caller + phNames[this.status] + " -> " + phNames[newStatus]);
      }
      this.status = newStatus;
    },

    /*public*/ _reset: function() {
      requestsLogger$2.logDebug(LoggerManager.resolve(730),this);
      this.requestLimit = 0;
      
      this.messageQueue = new ControlRequestBatch(ControlRequest.MESSAGE); 
      this.controlQueue = new ControlRequestBatch(ControlRequest.ADD); //for ADD REMOVE CONSTRAIN and FORCE_REBIND
      this.hbQueue = new ControlRequestBatch(ControlRequest.HEARTBEAT); 
      this.mpnQueue = new ControlRequestBatch(ControlRequest.MPN);
      
      this.wsConn = null;
      
      this.currentReverseHeartbeatInterval = 0;
      this.grantedReverseHeartbeatInterval = 0;

      //log and destroy are not session bound
      if (!this.logQueue) {
        this.logQueue = new ControlRequestBatch(ControlRequest.LOG); 
      }
      if (!this.destroyQueue) {
        //destroy queue is declared of type ADD for simplicity
        this.destroyQueue = new ControlRequestBatch(ControlRequest.ADD);
      }
      
      this.reqQueues = [this.messageQueue,this.controlQueue,this.logQueue,this.destroyQueue,this.hbQueue,this.mpnQueue];
      
      //we should avoid blocking the pending request if it's a DESTROY or a LOG;
      //from a general point of view if a request is going to a non-session host
      //we let it go on.
      
      //addRequest->addRequestExe in the middle will be discarded (excluding destroy and log)       
      this.phase++; 
      
      //excluding destroy and log requests, requests active now are aborted
      var _type = this.lastBatch ? this.lastBatch.getBatchType() : null;
      
      if (_type !== null && _type !== ControlRequest.DESTROY && _type !== ControlRequest.LOG) {  

        //>>excludeStart("debugExclude", pragmas.debugExclude);            
        if (!ASSERT.verifyDiffValue(this.status,_IDLE)) {
          requestsLogger$2.logError(LoggerManager.resolve(731));
        }
        //>>excludeEnd("debugExclude");         
        
        this._close();
        
        this.lastBatch = null;
        
        this.changeStatus(_IDLE, "_reset");
        
        //at this point we may have blocked DESTROY or LOG requets that will remain in the queue until a dequeue is called.
        //to avoid waiting for an external intervention (ie a new request in the queue) before dequeuing the survived requests
        //we call the dequeue here
        this.dequeue(ASYNC_DEQUEUE, "reset1"); //the status will immediately change to STANDBY


      } else if (_type === null) {
     
        //>>excludeStart("debugExclude", pragmas.debugExclude);            
        if (!ASSERT.verifyValue(this.status,_IDLE)) {
          requestsLogger$2.logError(LoggerManager.resolve(732));
        }
        
        //nothing to close
        //lastBatch is already null
        if (!ASSERT.verifyValue(this.lastBatch,null)) {
          requestsLogger$2.logError(LoggerManager.resolve(733));
        }
      //>>excludeEnd("debugExclude");  
        
        //there should not be nothing to dequeue, btw let's call dequeue anyway  
        this.dequeue(ASYNC_DEQUEUE,"reset2"); 
        
      } 
      //else we're dequeuing a DESTROY or LOG request so don't change the statusPhase NOR THE PHASE
     
 
      //NOTE:
      //phase affects all the addRequest that are still pending (and are not DESTROY or LOG)
      //statusPhase only affects the lastBatch
 
    },
    
    assignWS: function(wsConn) {
      
      if (wsConn) {
        requestsLogger$2.logDebug(LoggerManager.resolve(734),this);
      } else if (this.wsConn) {
        requestsLogger$2.logDebug(LoggerManager.resolve(735),this);
      }
      
      this.wsConn = wsConn;
    },
    
    /**
     * Notes:
     * 
     * - each batch has a type (see ControlRequest constants)
     * 
     * - there are 5 batches: 
     *      messageQueue (batchType = ControlRequest.MESSAGE)
     *      controlQueue (batchType = ControlRequest.ADD)
     *      hbQueue (batchType = ControlRequest.HEARTBEAT)
     *      logQueue (batchType = ControlRequest.LOG)
     *      destroyQueue (batchType = ControlRequest.ADD)
     *      
     * - each batch can contain requests of different types (see ControlRequest constants)
     * 
     * - checks in ControlRequestBatch.addRequestToBatch avoid that requests go in the wrong batch
     * 
     * - each request has a type (see ControlRequest constants)
     *  
     * - each request has a key (see ControlRequest.getKey)
     * 
     * - each request in a batch has a key which is composed of a letter and ControlRequest.getKey value
     *   (for example CHANGE_SUB_KEY+request.getKey()) (see ControlRequestBatch.addRequestToBatch)
     *   
     * @param num table index for add & delete, session number for destroy, null for everything else
     * @param request request query LS_table=...LS_sanpshot...
     * @param _type one of the request type constants (@see ControlRequest)
     * @param related request-related listener
     * @param flag that shows if this is the first time this request is sent for this session or not,
     *   (for add requests) or host to be forced for this request (for DESTROY)
     * @param listener managing REQOK/REQERR response
     */
    /*public*/ addRequest: function(num, request, _type, related, retryingOrHost, requestListener) {
        this.addRequestListener(request, requestListener);
        Executor.addTimedTask(this.addRequestExe,0,this,[this.phase, num, request, _type, related, retryingOrHost]);
    },
  
    /**
     * @public
     * Synchronous version of addRequest method. The request is immediately written into the available connection.
     */
    addSyncRequest: function(num, request, _type, related, retryingOrHost) {
        this.addRequestExe(this.phase, num, request, _type, related, retryingOrHost);
    },
  
    /*private*/ checkPhase: function(toCheck,_type) {
      if (_type == ControlRequest.DESTROY || _type == ControlRequest.LOG) {
        //LOG and DESTROY do not care about phase, must always go to the server
        return true;
      } else {
        return this.phase === toCheck;
      }
    },
    
    /*private*/ addToProperBatch: function(_type,controlRequestObj) {
      if (_type == ControlRequest.MESSAGE) {
        this.messageQueue.addRequestToBatch(controlRequestObj);
        
      } else if (_type == ControlRequest.LOG) {
        this.logQueue.addRequestToBatch(controlRequestObj);
        
      } else if (_type == ControlRequest.DESTROY) {
        this.destroyQueue.addRequestToBatch(controlRequestObj);
        
      } else if (_type == ControlRequest.HEARTBEAT) {  
        this.hbQueue.addRequestToBatch(controlRequestObj);
        
      } else if (_type == ControlRequest.MPN) {
          this.mpnQueue.addRequestToBatch(controlRequestObj);
          
      } else {
        //various control.js requests
        this.controlQueue.addRequestToBatch(controlRequestObj);
        
      }
    },
    
    /**
     * @param num table index for add & delete, session number for destroy, null for everything else
     * @param request request query LS_table=...LS_sanpshot...
     * @param _type one of the request type constants (@see ControlRequest)
     * @param related request-related listener
     * @param retryingOrHost flag that shows if this is the first time this request is sent for this session or not,
     *   (for add requests) or host to be forced for this request (for DESTROY)
     */
    /*private*/ addRequestExe: function(ph, num, request, _type, related, retryingOrHost) {
      if(!this.checkPhase(ph,_type)) {
        return;
      }
      
      requestsLogger$2.logInfo(LoggerManager.resolve(736),this,request);
     
      //retrying flag is only "needed" for ADD requests
      var controlRequestObj = new ControlRequest(request,related,_type,num,retryingOrHost);
      
      this.addToProperBatch(_type,controlRequestObj);

      if (this.status == _IDLE) {
        this.dequeue(SYNC_DEQUEUE,"add");
      } else {
        //we're already busy, we'll dequeue when we'll be back
        requestsLogger$2.logDebug(LoggerManager.resolve(737),this);
      }
      
    },
    
    /*private*/ dequeue: function(sync,who) {
      if (sync === true) {
        requestsLogger$2.logDebug(LoggerManager.resolve(738),sync,this);
        this.dequeueControlRequests(this.statusPhase,who);
        
      } else {
        requestsLogger$2.logDebug(LoggerManager.resolve(739),sync,this);
        var delay = sync === false ? 0 : sync;
        Executor.addTimedTask(this.dequeueControlRequests,delay,this,[this.statusPhase,"async."+who]);
      }      
    },
    
    /*private*/ dequeueControlRequests: function(ph,who) {
      
      if(ph != this.statusPhase) {
        return;
      }
      
      //just to avoid too-long loops
      var security = 0;
      while(security < SECURITY_LIMIT) {
        security++;
        
        this.changeStatus(_STANDBY, "dequeueControlRequests");
        
        requestsLogger$2.logDebug(LoggerManager.resolve(740),who,this);
        
        var outcome = null;
        if (this.lastBatch != null) {
          requestsLogger$2.logDebug(LoggerManager.resolve(741));
          outcome = this.sendBatch(this.lastBatch);
        } else {
          requestsLogger$2.logDebug(LoggerManager.resolve(742));
          outcome = this.selectAndSendBatch();
        }
        
        if (outcome == REQ_EMPTY) {
          requestsLogger$2.logInfo(LoggerManager.resolve(743));
          
          this.lastBatch = null;
          //this.dequeue(SYNC_DEQUEUE); 
          
          //we do not call SYNC_DEQUEUE, we let the loop to continue (that's quite the same!)
          
        } else if (outcome == SEND_LATER) {
          requestsLogger$2.logInfo(LoggerManager.resolve(744));
          //will try to send lastBatch
          this.dequeue(WAIT_CONN_DELAY,"later");
          return;
          
        } else if (outcome == NO_CONN) {
          requestsLogger$2.logWarn(LoggerManager.resolve(745));
          
          //I have no way to open a connection;
          //this should never happen because, unless
          //we're sending a log line, we had a working
          //connection upon which the session id was received
          
          //so, no way to send the request, what should I do now??
          //notify the senders and hope...
          if (this.lastBatch) {
            this.lastBatch.notifySenders(true);
          }
          this.lastBatch = null;
          
          this.dequeue(ASYNC_DEQUEUE,"no");
          return;
          
        } else if (outcome == SENT_HTTP) {
          requestsLogger$2.logInfo(LoggerManager.resolve(746));
          
          this.changeStatus(_WAITING, "dequeueControlRequests");
          if (this.lastBatch) {
              this.lastBatch.notifySenders();
          }
          
          //if still the same phase when this happen,
          //we send again the lastBatch
          this.dequeue(WAIT_RESP_DELAY,"http");
          return;
          
        } else if (outcome == SENT_WS) {
          requestsLogger$2.logInfo(LoggerManager.resolve(747));
          
          this.changeStatus(_WAITING, "dequeueControlRequests");
          if (this.lastBatch) {
              this.lastBatch.notifySenders();
          }

          //we don't need a timeout, we're ready right now to handle a new request (plus we'll never have notification of responses on WebSocket as responses are handled by the stream connection listener)
          this.lastBatch = null;
          
          //we have to move in the _IDLE status as we're not waiting anything
          this.changeStatus(_IDLE, "dequeueControlRequests");
          
          //we will be back to the _STANDBY phase immediately if the loop goes on
          
          //this.dequeue(SYNC_DEQUEUE);
          
        } else {
          requestsLogger$2.logInfo(LoggerManager.resolve(748));
          
          this._close(); //I think that this call is useless
          //nothing to do now
          this.changeStatus(_IDLE, "dequeueControlRequests");
          return;
        }
      }
      
      //if SECURITY_LIMIT batches are handled in a single loop, then we pause for a moment
      this.dequeue(ASYNC_DEQUEUE,"limit");
    },
    
    /*private*/ selectAndSendBatch: function() {
      var c=0;
      while(c < this.reqQueues.length ) {
        
        //switch the flag to change turn
        this.typeFlag = this.typeFlag < this.reqQueues.length-1 ? this.typeFlag+1 : 0;
        
        if (this.reqQueues[this.typeFlag].getLength() > 0) {
          return this.sendBatch(this.reqQueues[this.typeFlag]);
        }
        c++;
      }
      return null;
    },
    
    /*private*/ sendBatch: function(queueToSend) {
      (function(){
          /* check that there is no duplicated message request */
          if (queueToSend.batchType == ControlRequest.MESSAGE) {
              for (var i = 0, ilen = queueToSend.queue.length; i < ilen; i++) {
                  var request = queueToSend.queue[i];
                  var seq = request["LS_sequence"];
                  var prog = request["LS_msg_prog"];
                  if (seq != null && prog != null) {
                      for (var j = i + 1, jlen = queueToSend.queue.length; j < jlen; j++) {
                          var currentReq = queueToSend.queue[j];
                          var currentSeq = currentReq["LS_sequence"];
                          var currentProg = currentReq["LS_msg_prog"];
                          if (seq == currentSeq && prog == currentProg) {
                              if (requestsLogger$2.isDebugLogEnabled()) {
                                  requestsLogger$2.logErrorExc(new Error("backtrace"),
                                          "Duplicated message",
                                          "seq=", seq, "prog=", prog, "ptr=", request === currentReq);
                              }
                              requestsLogger$2.logError(LoggerManager.resolve(749), "seq=", seq, "prog=", prog);
                          }
                      }
                  }
              }
          }
      }());
      
      var serverToUse = this._owner.getPushServerAddress();
      var mainRequest = firstRequestToRequest(queueToSend,serverToUse,this.policyBean.isCookieHandlingRequired(),this.policyBean.extractHttpExtraHeaders(false));

      //mainRequest is now like http://www.myserver.com/lightstreamer
      if (mainRequest == null) {
        requestsLogger$2.logDebug(LoggerManager.resolve(750));
        return REQ_EMPTY;
      }
      
      requestsLogger$2.logDebug(LoggerManager.resolve(751));
      
      var sent = false;
      
//////////////////////////////WS CASE      
      
      if (this.wsConn) {
        requestsLogger$2.logDebug(LoggerManager.resolve(752));
        
        var controlRequest = this.customizeRequest(queueToSend,this.wsConn);
        if(controlRequest == null) {
          requestsLogger$2.logDebug(LoggerManager.resolve(753));
          return REQ_EMPTY;
        }
        
        mainRequest.setFile(controlRequest.getFile());
        mainRequest.setData(controlRequest.getData());
        
        sent = this.wsConn._send(mainRequest);
        
        if (sent === false) {
          this.wsConn = null;
        } else if (sent === null) {
          //with the early open of WebSocket this may happen
          return SEND_LATER;
   
        } else { //sent == true
          //we've done our job :)
          
          return SENT_WS;
        }
        
      } 
      
//////////////////////////////HTTP CASE      
      if (this.conn) {
        if (!this.connectionList.isGood(serverToUse,
              this.conn.constr,
              mainRequest.isCrossSite(),
              this.policyBean.isCookieHandlingRequired(),
              mainRequest.isCrossProtocol(),
              this.policyBean.hasHttpExtraHeaders(false))) {
          this.connectionList._reset();
          this.conn = null;
        }
      }
      
      
      
      var done = false;
      while ((this.conn || this.connectionList.hasNext()) && done === false) {
      
        if (!this.conn) {
          var classTU = this.connectionList.getNext(serverToUse,
              mainRequest.isCrossSite(),
              this.policyBean.isCookieHandlingRequired(),
              mainRequest.isCrossProtocol(),
              this.policyBean.hasHttpExtraHeaders(false));
          
          if (!classTU) {
          //>>excludeStart("debugExclude", pragmas.debugExclude);  
//            ASSERT.fail(); //no reason to be here, we have a session id so there should be at least one working connection
          //>>excludeEnd("debugExclude");  
            requestsLogger$2.logWarn(LoggerManager.resolve(754),this.conn);
            
            //no solutions, exit
            this.connectionList._reset();
            
            return NO_CONN;
          }
          
          this.conn = new classTU("LS6__CONTROLFRAME");
          requestsLogger$2.logDebug(LoggerManager.resolve(755),this.conn);
        }      
        
        var controlRequest = this.customizeRequest(queueToSend,this.conn);
        if(controlRequest == null) {
          requestsLogger$2.logDebug(LoggerManager.resolve(756));
          return REQ_EMPTY;
        }
        
        mainRequest.setFile(controlRequest.getFile());
        mainRequest.setData(controlRequest.getData());
        mainRequest.setMethod(controlRequest.getMethod());
        
        this.lastBatch.setPhase(this.statusPhase);
        this.conn._close();


//>>excludeStart("debugExclude", pragmas.debugExclude);
        if (this.fakeSyncError) {
          mainRequest._data = mainRequest._data.replace(/LS_session=.*&/g,"LS_session=FAKE&");
        }
//>>excludeEnd("debugExclude");



        sent = this.conn._load(mainRequest, this.lastBatch.getPhase(), Executor.packTask(this.onReadyForNextRequest,this), Executor.packTask(this.onErrorEvent,this));
        
        if (sent === false) {
          requestsLogger$2.logDebug(LoggerManager.resolve(757));
          this.conn = null;
          
        } else if (sent === null) {
          requestsLogger$2.logDebug(LoggerManager.resolve(758));
          //wait and try again
          return SEND_LATER;
          
        } else { //sent === true
          //requests sent, notify the owners
          this.connectionList._reset();
          return SENT_HTTP;
        }
        
      }
      
//////////////////////////////???? CASE 
      
      if (sent === false) {
        //all my connections failed :(
        return NO_CONN;
      } else {
      //>>excludeStart("debugExclude", pragmas.debugExclude);  
        ASSERT.fail();
      //>>excludeEnd("debugExclude");
        requestsLogger$2.logError(LoggerManager.resolve(759));
      }
      
      return NO_CONN;
      
    },

    
    /**
     * Fill attribute lastBatch with requests from the same queue until the queue is empty or the request limit is reached.
     * @private
     */
    customizeRequest: function(queueToSend,connToUse) {
      var encoder = connToUse.getEncoder();
      
      //compose
      //run this once; if the while is performed more times we will not recalculate the overhead, if the request is too big 
      //the server will ignore it and the client will recompose with the new connection. It should be a very rare case,
      //especially now as the FormConnection is much more difficult to reach and is the only one with a different overhead calculation
      if (this.lastBatch == null) {      
        
        this.lastBatch = new LastBatch();
        this.lastBatch.setEncoder(encoder);
        this.lastBatch.fill(queueToSend,this.requestLimit,this._owner.getSessionId(),this.policyBean.isCookieHandlingRequired(),this.policyBean.extractHttpExtraHeaders(false));
        
      } else if (this.lastBatch.needsNewEncode(encoder)) {

        this.lastBatch.setEncoder(encoder);
        var overflow = this.lastBatch.refill(this.requestLimit,this._owner.getSessionId(),this.policyBean.isCookieHandlingRequired(),this.policyBean.extractHttpExtraHeaders(false));
        
        if (overflow) {
          var batchType = overflow.getBatchType();
          //TODO I NEED A TEST TO PASS FROM HERE!
          
          while(overflow.getLength() > 0) {
            this.addToProperBatch(batchType,overflow.shift());
          }
        }
        
        
      }
      
      if (this.lastBatch.isEmpty()) {
        this.lastBatch = null;
        return null;
      }
      return this.lastBatch.getRequest();
     
    },
    
    /**
     * HTTP case only
     */
    /*private*/ onReadyForNextRequest: function(_responseText,sentPhase) {
      if (!this.lastBatch || sentPhase !=  this.lastBatch.getPhase()) {
        //a reset occurred, we don't care about this response
        //flex client has a call to asynchDequeueControlRequests here
        return;
      }
      
      if (streamLogger$9.isDebugLogEnabled()) {
          streamLogger$9.logDebug(LoggerManager.resolve(760), sentPhase, _responseText);          
      }
      requestsLogger$2.logInfo(LoggerManager.resolve(761),sentPhase);
      this.changeStatus(_IDLE, "onReadyForNextRequest");

      var realType = this.lastBatch.firstRequest().getType();
      this.lastBatch = null;

      this._owner.enqueueControlResponse(_responseText);
      //check if there are other requests
      this.dequeue(ASYNC_DEQUEUE,"ready4next");
    },
    
    /**
     * HTTP case only
     */
    /*private*/ onErrorEvent: function(exc,sentPhase) {
      if (!this.lastBatch || sentPhase != this.lastBatch.getPhase()) {
        //a reset occurred, we don't care about this response 
        return;
      }
      requestsLogger$2.logInfo(LoggerManager.resolve(762),this,exc);
   
      //what should I do in this case? Should I resend the last request or is it better if I
      //wait for the owners to re-enqueue their requests?
      //I decided to go the safe way by not resending the same request. If important the client will ask
      //to send the request again
      
      this.changeStatus(_IDLE, "onErrorEvent");
      this.lastBatch = null;
      //check if there are other requests already in queue
      this.dequeue(ASYNC_DEQUEUE,"error"); 
    },
    
    /**
     * Associates the LS_reqId of the request with its listener.
     */
    addRequestListener: function(request, requestListener) {
        var reqId = request['LS_reqId'];
        if (reqId != null && requestListener != null) {
            this.requestListenerMap[reqId] = requestListener;
        }
    },
    
    /**
     * Gets and removes from the listener map the listener having the given LS_reqId.
     */
    getAndRemoveRequestListener: function(reqId) {
        var requestListener = this.requestListenerMap[reqId];
        delete this.requestListenerMap[reqId];
        return requestListener;
    }
    
  };
  
  
  var LastBatch = function() {
    this.batch = null;
    this.encoder = null;
    this.request = null; 
    this.phase = null;
  };
  
  LastBatch.prototype = {
      toString: function() {
        return this.batch ? this.batch.toString() : null;
      },
      
      getBatchType: function() {
        return this.batch ? this.batch.getBatchType() : null;
      },
      
      firstRequest: function() {
        return this.batch ? this.batch.firstRequest() : null;
      },
      
      getLength: function() {
        return this.batch ? this.batch.getLength() : 0;
      },
      
      shift: function() {
        return this.batch ? this.batch.shift() : null;
      },
      
      getRequest: function() {
        return this.request;
      },
      
      needsNewEncode: function(encoder) {
        return encoder != this.encoder;
      },
      
      setEncoder: function(encoder) {
        this.encoder = encoder;
      }, 
      
      fill: function(queue,lengthLimit,sessionId,cookieHandlingRequired,extraHeaders) {
        if (queue.getLength() <= 0) {
          return;
        }
        
        this.batch = new ControlRequestBatch(queue.getBatchType());
        this.request = this.encoder.initRequest(queue,cookieHandlingRequired,extraHeaders); //sets file and method, not server
        
        //NOTE we always queue the first request
        var requestData = "";
        var nextEncodedReq = this.encoder.encode(queue,sessionId,true);
        if (nextEncodedReq === null) {
          //nothing to send
          this.batch = null;
          this.request = null;
          return;
        }

        var expectedFinalLength = this.encoder.getFixedOverhead(this.request.getFile());
        var nextExpectedLength = this.encoder.getInvisibleOverhead(nextEncodedReq) + nextEncodedReq.length;
        
        if (lengthLimit > 0 && (nextExpectedLength+expectedFinalLength) > lengthLimit) {
          requestsLogger$2.logWarn(LoggerManager.resolve(763),requestData);
        }
        
        
        do {
          requestData+=nextEncodedReq;
          this.batch.addRequestToBatch(queue.shift());
          expectedFinalLength +=  nextExpectedLength; 
          
          if (queue.getLength() > 0) {
            nextEncodedReq = this.encoder.encode(queue,sessionId);
            if (nextEncodedReq) {
              nextExpectedLength = this.encoder.getInvisibleOverhead(nextEncodedReq) + nextEncodedReq.length;
            }
          }
        } while (nextEncodedReq && (lengthLimit == 0 || expectedFinalLength + nextExpectedLength < lengthLimit) && queue.getLength() > 0);
        
        this.request.setData(this.encoder.wrapUp(requestData));
        
      },
      
      refill: function(lengthLimit,sessionId,cookieHandlingRequired,extraHeaders) {
        var dismissing = this.batch;
        this.batch = null;
        this.fill(dismissing,lengthLimit,sessionId,cookieHandlingRequired,extraHeaders);
        if (dismissing.getLength() > 0) {
          return dismissing;
        }
        return null;
      },
      
      getPhase: function() {
        return this.phase;
      },
      
      setPhase: function(ph) {
        this.phase = ph;
      },
      
      isEmpty: function() {
        return this.getLength() <= 0;
      }, 
      
      notifySenders: function(failed) {
        var i = 0;
        var sentReq = null;
        while(sentReq = this.batch.getRequestObject(i)) {
          var bridge = sentReq.getBridge();
          if (bridge) {
            Executor.addTimedTask(bridge.notifySender,0,bridge,[failed]);
          }
          i++;
        }
      }
      
      
  };

var notifySenderName$1;
  for(var i$3 in  {notifySender:true}) {
    notifySenderName$1=i$3;
  }
  
  
  var SendMessageBridge = function(owner,connOptions,_phase,_seqData,_num,_sequence,_ack) {
    
    this._callSuperConstructor(SendMessageBridge,[connOptions]);
    
    this.seqData = _seqData;
    this.num = _num;
    this.sequence = _sequence;
    this.phase = _phase;
    //this.attempts = 0;
    this._owner = owner;
    this.waitingAck = _ack;
  };
  
  SendMessageBridge.prototype = {
      
    /*public*/ notifySender: function(failed) {
      this._callSuperMethod(SendMessageBridge,notifySenderName$1,[failed]);
      
      if (!failed) {
        this._owner.sentOnNetwork(this.sequence,this.num);
        
        if (!this.waitingAck) {
          this._owner.noAckMessageSent(this.sequence,this.num);
          return;
        }
      }
      
      
      /*this.attempts++;
      if (this.attempts >= 5) {
        
      }*/
    },
      
    verifySuccess: function() {
      //if push_pase is changed we've already received a loop so that our request is successful
      if (this._owner.checkMessagePhase(this.phase)) {
        //phase is correct
        if (this.seqData.messages[this.num]) { //the message is still in the queue
          if (this.seqData.messages[this.num].query != null) { //the message has not been acknowledged yet
            return false;
          }
        }
      }
      return true;
    },
    
    doRecovery: function() {
      //let's try again
      this._owner.resend(this.num,this);
    },
    
    notifyAborted: function() {
      //nothing to do
    },
    
    getProg: function() {
      return this.num;
    },
    
    getOwner: function() {
      return this._owner;
    }
    
  };
  
  Inheritance(SendMessageBridge,Tutor);

var messagesLogger = LoggerManager.getLoggerProxy(Constants.MESSAGES);
  
  var SendMessageHandler = function(controlHandler,pushPagesHandler,connOptions) {
    this.active = false;
    this.messagePhase = 0;
    this.sequences = {};
    
    this.unorderedMap = {};
    this.unorderedSeqNum = 0;
    
    this.controlHandler = controlHandler;
    this.pushPagesHandler = pushPagesHandler;
    
    this.connOptions = connOptions;
  };
  
  
  SendMessageHandler.prototype = {
    
    /*public*/ _close: function() {
      // Called when a disconnection occurs;
      // the communication layer guarantees that no further calls will be received
      // originated from the pushFrame linked to the finite session.
      // So we can start from an empty state without the risk of overlapping.
  
      this.active = false;
      // what do we do with messages that have not yet been answered?
      // no need to answer here because pushpages can do this by themselves;
      // indeed, it is not even permissible to make calls to pages based on a finished session
      this.sequences = {};
      
      this.unorderedSeqNum = 0;
      this.unorderedMap = {};
      
      this.messagePhase++;
      messagesLogger.logDebug(LoggerManager.resolve(764));
    },
    
    /*public*/ activate: function() {
      messagesLogger.logDebug(LoggerManager.resolve(765));
      if (! this.active) {
        for (var seq in this.sequences) {
          var seqData = this.sequences[seq];
          for (var num in seqData.messages) {
            var query = seqData.messages[num].query;
            if (query != null) {
              var bridge = new SendMessageBridge(this,this.connOptions,this.messagePhase,seqData,num);
              this.sendExe(num,query,bridge);
            }
          }
        }
        this.active = true;
      }
    },
    
    /**
     * 
     * <b>NB1</b> A fire-and-forget behavior is enacted when the user calls {@link LightstreamerClient#sendMessage(String)}
     * or {@link LightstreamerClient#sendMessage(String, String, int, com.lightstreamer.client.ClientMessageListener, boolean)}
     * having (1) "UNORDERED_MESSAGES" as a sequence and (2) no listener. 
     * In this scenario the server doesn't send acknowledgments (i.e. REQOK) and the client doesn't do retransmissions.
     * In a fire-and-forget message request both the parameters LS_ack and LS_outcome are set to false.
     * 
     * <p>
     * Flags set to true with respect to the presence of a listener and a ordered sequence.
     * 
     * <table border="1">
     * <tr>
     *  <th></th>
     *  <th>listener</th>
     *  <th>no listener</th>
     * </tr>
     * <tr>
     *  <th>sequence</th>
     *  <td>prog outcome ack</td>
     *  <td>prog ack</td>
     * </tr>
     * <tr>
     *  <th>no sequence</th>
     *  <td>prog outcome ack</td>
     *  <td>ack (only in HTTP)</td>
     * </tr>
     * </table>
     */
    _send: function(_message, sequence, listener, _timeout) {
      messagesLogger.logDebug(LoggerManager.resolve(766));

      var seqData = this.sequences[sequence];
      if (seqData == null) {
        seqData = {};
        seqData.messageNum = 0;
        seqData.messages = {};
        this.sequences[sequence] = seqData;
      }
  
      seqData.messageNum++;
    
      var query = {
          "LS_message": _message, //if necessary the encoder will encode it
          "LS_reqId": Utils.nextRequestId()
      };
      
      //we add the prog if
      //1 - we expect an outcome
      //2 - the sequence is not unordered
      
      var needsProg = false;
      
      if (listener) {
          // query["LS_outcome"]=""; (no needed: the default is true)
          needsProg=true;
      } else {
          query["LS_outcome"]= "false";
      }
            
      if (sequence != Constants._UNORDERED_MESSAGES) {
        query["LS_sequence"]=encodeURIComponent(sequence);
        needsProg=true;

        if (_timeout) {
          query["LS_max_wait"]=_timeout;
        }
      }
      
      if (needsProg) {
          // query["LS_ack"]=""; (no needed: the default is true)
          query["LS_msg_prog"]= sequence == Constants._UNORDERED_MESSAGES ? this.mapUnordered(seqData.messageNum) : seqData.messageNum;
      } else if (listener == null) {
          query["LS_ack"] = "false";
      }
      
      var msgData = {};
      msgData.query = query;
      msgData.listener = listener;
      seqData.messages[seqData.messageNum] = msgData;
      if (this.active) {
        messagesLogger.logInfo(LoggerManager.resolve(767),query);
        var bridge = new SendMessageBridge(this,this.connOptions,this.messagePhase,seqData,seqData.messageNum,sequence,needsProg);
        this.sendExe(seqData.messageNum,query,bridge);
      }
    },
    
    /*public*/ mapUnordered: function(prog) {
      var realProg = ++this.unorderedSeqNum;
      this.unorderedMap[realProg] = prog;
      return realProg;
    },
    
    /*private*/ resolveUnorderedNum: function(prog) {
      return this.unorderedMap[prog] ? this.unorderedMap[prog] : prog;
    },
    
    /*private*/ removeFromUnorderedMap: function(prog) {
      //not optimized at all; should I keep a reverse map to be faster?
      for (var i in this.unorderedMap) {
        if (this.unorderedMap[i] == prog) {
          delete(this.unorderedMap[i]);
          return;
        }
      }
    },
    
    /*public*/ extractMappedUnordered: function(prog) {
    //not optimized at all; should I keep a reverse map to be faster?
      for (var i in this.unorderedMap) {
        if (this.unorderedMap[i] == prog) {
          return i;
        }
      }
    },
    
    /*public*/ checkMessagePhase: function(ph) {
      return ph == this.messagePhase;
    },
    
    //FROM SendMessageBridge that knows the actual num
    /*public*/ resend: function(num,bridge) {
      var query = bridge.seqData.messages[num].query;
      messagesLogger.logDebug(LoggerManager.resolve(768),query);
      this.sendExe(num,query,bridge); //resend the message!
    },
    
    /*private*/ sendExe: function(prog,query,bridge) {
        var sequence = (query['LS_sequence'] == null ? Constants._UNORDERED_MESSAGES : query['LS_sequence']);
        var ack = query['LS_ack'] != "false";
        var requestListener = {
                onREQOK: function(LS_window) {
                    /*
                     * NB1 LS_window is an object defined in EvalQueue, where the listener will be called.
                     * 
                     * NB2 LS_w must be called only if the request was expecting an acknowledgment (i.e. LS_ack=true).
                     * This check is important because in HTTP the server send always a REQOK even if LS_ack was false.
                     */
                    if (ack) {                        
                        LS_window.LS_w(4, prog, sequence, 0, 0);
                    }
                },
                
                onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                    LS_window.LS_l(errorCode, prog, "MSG" + sequence, errorMsg, true/*isReqerr*/);
                }
        };
        this.controlHandler.addRequest(prog, query, ControlRequest.MESSAGE, bridge, null, requestListener); 
    },

    //FROM net, needs num translation
    /*public*/ ack: function(sequence, num) {
      num = sequence == Constants._UNORDERED_MESSAGES ? this.resolveUnorderedNum(num) : num;
      messagesLogger.logInfo(LoggerManager.resolve(769),sequence,num);
      
      var seqData = this.sequences[sequence];
      if (seqData.messages[num]) {
        if (seqData.messages[num].query != null) {
          messagesLogger.logDebug(LoggerManager.resolve(770));
          seqData.messages[num].query = null;
        }
        if (seqData.messages[num].listener == null) {
          messagesLogger.logDebug(LoggerManager.resolve(771));
          this._clear(sequence, num);
        }
      } 
    },
    
    //FROM SendMessageBridge that knows the actual num
    /*public*/ noAckMessageSent: function(sequence, num) {
      messagesLogger.logDebug(LoggerManager.resolve(772),sequence,num);
      this._clear(sequence, num);
    },
    
    /*private*/ _clear: function(sequence, num) {
      //this method is always called with the actual num
      messagesLogger.logDebug(LoggerManager.resolve(773));
      var seqData = this.sequences[sequence];
      if (seqData && seqData.messages[num]) {
        delete (seqData.messages[num]);
        if (sequence == Constants._UNORDERED_MESSAGES) {
          this.removeFromUnorderedMap(num);
        }
      }
    },
    
    /*private*/ getListener: function(sequence,num) {
      var seqData = this.sequences[sequence];
      if (seqData && seqData.messages[num] && seqData.messages[num].listener) {
        return seqData.messages[num].listener;
      }
      return null;
    },
    
    //FROM SendMessageBridge that knows the actual num
    sentOnNetwork: function(sequence, num) {
      messagesLogger.logDebug(LoggerManager.resolve(774),sequence, num);
      var listenerInfo = this.getListener(sequence, num);
      if(listenerInfo) {
        
        var ppHandler = this.pushPagesHandler.getPushPageHandler(listenerInfo.pageNum);
        if (ppHandler) {
          ppHandler.onMessageOnNetwork(listenerInfo.prog);
        }
              
      }
    }, 

    //FROM net, needs num translation
    /*public*/ _complete: function(sequence, num) {
      num = sequence == Constants._UNORDERED_MESSAGES ? this.resolveUnorderedNum(num) : num;
      messagesLogger.logInfo(LoggerManager.resolve(775),sequence, num);
      var listenerInfo = this.getListener(sequence, num);
      if(listenerInfo) {
      
        var ppHandler = this.pushPagesHandler.getPushPageHandler(listenerInfo.pageNum);
        if (ppHandler) {
          ppHandler.onMessageComplete(listenerInfo.prog);
        }
              
      }
      
      this._clear(sequence, num);
      
    },
    
    //FROM net, needs num translation
    /*public*/ notifyDiscarded: function(sequence,num) {
      num = sequence == Constants._UNORDERED_MESSAGES ? this.resolveUnorderedNum(num) : num;
      messagesLogger.logInfo(LoggerManager.resolve(776),sequence, num);
      
      var listenerInfo = this.getListener(sequence, num);
      
      if(listenerInfo) {
        var ppHandler = this.pushPagesHandler.getPushPageHandler(listenerInfo.pageNum);
        if (ppHandler) {
          ppHandler.onMessageDiscarded(listenerInfo.prog);
        }
      }
      
      this._clear(sequence, num);
    },
    
    //FROM net, needs num translation
    /*public*/ notifyDenied: function(sequence,_code,msg,num) {
      num = sequence == Constants._UNORDERED_MESSAGES ? this.resolveUnorderedNum(num) : num;
      messagesLogger.logInfo(LoggerManager.resolve(777),sequence, num);
      var listenerInfo = this.getListener(sequence, num);
      if(listenerInfo) {
        var ppHandler = this.pushPagesHandler.getPushPageHandler(listenerInfo.pageNum);
        if (ppHandler) {
          ppHandler.onMessageDenied(listenerInfo.prog,_code,msg);
        }
      }
      
      this._clear(sequence, num);
    },

    //FROM net, needs num translation
    /*public*/ notifyError: function(sequence,_code,msg,num) {
      num = sequence == Constants._UNORDERED_MESSAGES ? this.resolveUnorderedNum(num) : num;
      messagesLogger.logInfo(LoggerManager.resolve(778),sequence, num);
      var listenerInfo = this.getListener(sequence, num);
      if(listenerInfo) {
        
        var ppHandler = this.pushPagesHandler.getPushPageHandler(listenerInfo.pageNum);
        if (ppHandler) {
          ppHandler.onMessageError(listenerInfo.prog,_code,msg);
        }
              
        
      }
      
      this._clear(sequence, num);
    }
  
  };

/**
 * @since January 2018
 */

    
    /**
     * Converts a string containing sequences as {@code %<hex digit><hex digit>} into a new string 
     * where such sequences are transformed in UTF-8 encoded characters. <br> 
     * For example the string "a%C3%A8" is converted to "aè" because the sequence 'C3 A8' is 
     * the UTF-8 encoding of the character 'è'.
     */
    var EncodingUtils = {unquote: decodeURIComponent};

/**
 * @since January 2018
 */


    var TlcpServerMessage = function(msg) {
        this.msg = msg;
        this.fields = msg.split(',');
    };
    
    TlcpServerMessage.prototype = {
            
            getField: function(n) {
                if (n >= this.fields.length) {
                    throw new Error('Field ' + n + ' does not exist');
                }
                return this.fields[n];
            },
            
            getFieldUnquoted: function(n) {
                return EncodingUtils.unquote(this.getField(n));
            },
            
            getFieldAsInt: function(n) {
                var f = this.getField(n);
                var num = parseInt(f, 10);
                if (isNaN(num)) {
                    throw new Error('Not an integer field');
                }
                return num;
            },
            
            getFieldAsFloat: function(n) {
                var f = this.getField(n);
                var num = parseFloat(f); 
                if (isNaN(num)) {
                    throw new Error('Not a float field');
                }
                return num;
            },
            
            getRawMsg: function() {
                return this.msg;
            }
    };

var streamLogger$a = LoggerManager.getLoggerProxy(Constants.STREAM);
  
  var EvalQueue = function(engId) {
    this.engId = engId;
        
    this.equeue = [];

    this.hasFailed = false;
    this["lsc"] = {};
    this["lsc"]["LS_window"] = Lightstreamer["_"+engId];
    this["lsc"]["window"] = this["lsc"]["LS_window"];
    this.LS_window = this['lsc']['LS_window'];
    this.LS_l = this.LS_window['LS_l'];
    this.LS_u = this.LS_window['LS_u'];
    this.LS_w = this.LS_window['LS_w'];
    this.LS_e = this.LS_window['LS_e'];
    this.LS_svrname = this.LS_window['LS_svrname'];
    this.LS_n = this.LS_window['LS_n'];
    this.LS_s = this.LS_window['LS_s'];
    this.LS_o = this.LS_window['LS_o'];
    this.LS_l = this.LS_window['LS_l'];
    this.LS_MPNREG = this.LS_window['LS_MPNREG'];
    this.LS_MPNOK = this.LS_window['LS_MPNOK'];
    this.LS_MPNDEL = this.LS_window['LS_MPNDEL'];
    this.dequeueAction = this.generateClosure(this["lsc"]);
  };
  
  EvalQueue.prototype = {
    
    /*public*/ toString: function() {
      return "[EvalQueue|"+this.equeue.length+"]";
    },
    
    generateClosure: function() {
        var that = this;
        return function(jobToDo) {
            try {
                that.parseText(jobToDo);
                
            } catch (e) {
                that.LS_l(61, null, null, "Malformed message received");
            }
        };
    },
    
    /*public*/ _enqueue: function(_phase,_data) {
      if (!this.stillValid()) {
        //this EvalQueue is corrupted, exit
        return;
      }
      
      this.equeue.push({p:_phase,d:_data});
      
      if (streamLogger$a.isDebugLogEnabled()) {
        streamLogger$a.logDebug(LoggerManager.resolve(779));
      }
     
      //this.dequeueAll();
      Executor.addTimedTask(this.dequeueAll,0,this);
    },
    
    /*public*/ changeSession: function(newSession) {
      this.session = newSession;
    },
    
    /*
    * executes the eval with the received string
    * it is launched in a new thread in fear that
    * otherwise may cause the browser to not
    * reuse connections and maintain the ajax_frame context / thread
    * NOTE: it is now also used on XHR streaming responses.
    */
    /*private*/ dequeueAll: function() {
      
      if(streamLogger$a.isDebugLogEnabled()) {
        streamLogger$a.logDebug(LoggerManager.resolve(780),this.equeue.length);
      }
      
      
      while (this.equeue.length > 0) {
        var _el = this.equeue.shift();
        
        if (!this.session || !this.session.checkSessionPhase(_el.p)) {
          streamLogger$a.logWarn(LoggerManager.resolve(781), _el.p, _el.d, this.session);
          continue;
        }
        
        
        try {
          this.dequeueAction(_el.d);
        } catch(_e) {
          this.hasFailed = true;
          this.equeue = []; //prevent continuation on a corrupted flow
        //>>excludeStart("debugExclude", pragmas.debugExclude);   
          console.log(_e);
        //>>excludeEnd("debugExclude");
          streamLogger$a.logError(LoggerManager.resolve(782),_e,_el.d);
          this.session.evaluationError();
        }
        
      }
      
    },
    
    stillValid: function() {
      return !this.hasFailed;
    },
    
    dispose: function() {
      
    },
    
    parseText: function(text) {
        var lines = text.split('\r\n');
        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            if (line == '') {
                continue;
            }
            try {
                var msg = new TlcpServerMessage(line);
                switch (msg.getField(0)) {

                case "U":
                    this.processUpdate(msg);
                    break;

                case "REQOK":
                    this.processREQOK(msg);
                    break;

                case "SUBOK":
                    this.processSUBOK(msg);
                    break;

                case "SUBCMD":
                    this.processSUBCMD(msg);
                    break;

                case "UNSUB":
                    this.processUNSUB(msg);
                    break;

                case "CONOK":
                    this.processCONOK(msg);
                    break;

                case "SERVNAME":
                    this.processSERVNAME(msg);
                    break;

                case "CLIENTIP":
                    this.processCLIENTIP(msg);
                    break;

                case "CONS":
                    this.processCONS(msg);
                    break;

                case "LOOP":
                    this.processLOOP(msg);
                    break;

                case "PROG":
                    this.processPROG(msg);
                    break;

                case "CONERR":
                    this.processCONERR(msg);
                    break;

                case "REQERR":
                    this.processREQERR(msg);
                    break;

                case "ERROR":
                    this.processERROR(msg);
                    break;

                case "MSGDONE":
                    this.processMSGDONE(msg);
                    break;

                case "MSGFAIL":
                    this.processMSGFAIL(msg);
                    break;

                case "EOS":
                    this.processEOS(msg);
                    break;

                case "CS":
                    this.processCS(msg);
                    break;

                case "OV":
                    this.processOV(msg);
                    break;

                case "CONF":
                    this.processCONF(msg);
                    break;

                case "PROBE":
                    this.processPROBE(msg);
                    break;

                case "SYNC":
                    this.processSYNC(msg);
                    break;

                case "NOOP":
                    break;

                case "END":
                    this.processEND(msg);
                    break;
                    
                case "MPNREG":
                    this.processMPNREG(msg);
                    break;
                    
                case "MPNOK":
                    this.processMPNOK(msg);
                    break;
                    
                case "MPNDEL":
                    this.processMPNDEL(msg);
                    break;

                default:
                    throw new Error("Unknown message: " + line);
                }
                
            } catch (e) {
                streamLogger$a.logError(LoggerManager.resolve(783), line, e);
                throw new Error("Malformed message: " + line);
            }
        }
    },
    
    processUpdate: function(msg) {
        // U,<table>,<item>|<field1>|...|<fieldN>
        // or U,<table>,<item>,<field1>|^<number of unchanged fields>|...|<fieldN>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var item = msg.getFieldAsInt(2);
        var updates = this.parseUpdates(msg.getRawMsg());
        try {
            this.LS_u(phase, [table, item].concat(updates));
        } catch (e) {
            streamLogger$a.logError(LoggerManager.resolve(784), e);
        }
    },
    
    processSUBOK: function(msg) {
        // SUBOK,<table>,<total items>,<total fields>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var totalItems = msg.getFieldAsInt(2);
        var totalFields = msg.getFieldAsInt(3);
        this.LS_w(6, phase, table, totalItems, totalFields, -1, -1);
    },
    
    processSUBCMD: function(msg) {
        // SUBCMD,<table>,<total items>,<total fields>,<key field>,<command field>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var totalItems = msg.getFieldAsInt(2);
        var totalFields = msg.getFieldAsInt(3);
        var keyPos = msg.getFieldAsInt(4);
        var cmdPos = msg.getFieldAsInt(5);
        this.LS_w(6, phase, table, totalItems, totalFields, keyPos - 1, cmdPos - 1);
    },
    
    processUNSUB: function(msg) {
        // UNSUB,<table>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        this.LS_w(8, phase, table);
    },
    
    processCONOK: function(msg) {
        // CONOK,<session id>,<request limit>,<keep alive>,<control link>
        var phase = null;
        var sessionId = msg.getField(1);
        var reqLimit = msg.getFieldAsInt(2);
        var keepAlive = msg.getFieldAsInt(3);
        var controlLink = msg.getField(4) == '*' ? null : msg.getField(4);
        this.LS_e(1, phase, sessionId, controlLink, keepAlive, reqLimit);
    },
    
    processSERVNAME: function(msg) {
        // SERVNAME,<name>
        var serverName = msg.getField(1);
        this.LS_svrname(serverName);
    },
    
    processCLIENTIP: function(msg) {
        // CLIENTIP,<ip>
        var clientIp = msg.getField(1);
        if (this.session != null) {
            this.session.onIPReceived(clientIp);
        }
    },
    
    processCONS: function(msg) {
        // CONS,(unmanaged|unlimited|<bandwidth>)
        var phase = null;
        var maxBandWidth;
        var rawBandWidth = msg.getField(1);
        if (rawBandWidth == "unlimited" || rawBandWidth == "unmanaged") {
            maxBandWidth = rawBandWidth;
        } else {
            maxBandWidth = msg.getFieldAsFloat(1);
        }
        this.LS_e(5, phase, maxBandWidth);
    },
    
    processLOOP: function(msg) {
        var phase = null;
        var loopMs = msg.getFieldAsInt(1);
        this.LS_e(2, phase, loopMs);
    },
    
    processCONERR: function(msg) {
        // CONERR,<error code>,<error message>
        var phase = null;
        var errorCode = msg.getFieldAsInt(1);
        var errorMsg = msg.getFieldUnquoted(2);
        this.LS_l(errorCode, phase, null, errorMsg);
    },
    
    processREQOK: function(msg) {
        if (msg.getRawMsg() == "REQOK") {
            // heartbeats and remote logs don't have reqId and don't need further handling
            return;
        }
        // REQOK,<reqId>
        var reqId = msg.getFieldAsInt(1);
        var requestListener = this.getRequestListener(reqId);
        if (requestListener != null) {
            requestListener.onREQOK(this);
        }
    },
    
    processREQERR: function(msg) {
        // REQERR,<reqId>,<errorCode>,<errorMsg>
        var phase = null;
        var reqId = msg.getFieldAsInt(1);
        var errorCode = msg.getFieldAsInt(2);
        var errorMsg = msg.getFieldUnquoted(3);
        var requestListener = this.getRequestListener(reqId);
        var listenerCallback = null;
        if (requestListener != null) {
            var that = this;
            listenerCallback = function() {                
                requestListener.onREQERR(that, phase, errorCode, errorMsg);
            };
        }
        if (this.session != null) {
            this.session.forwardREQERR(errorCode, errorMsg, listenerCallback);
        }
    },
    
    processERROR: function(msg) {
        // ERROR,<errorCode>,<errorMsg>
        var errorCode = msg.getFieldAsInt(1);
        var errorMsg = msg.getFieldUnquoted(2);
        if (this.session != null) {
            this.session.forwardERROR(errorCode, errorMsg);
        }
    },
    
    processEOS: function(msg) {
        // EOS,<table>,<item>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var item = msg.getFieldAsInt(2);
        this.LS_n(phase, [table, item]);
    },
    
    processCS: function(msg) {
        // CS,<table>,<item>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var item = msg.getFieldAsInt(2);
        this.LS_s(phase, [table, item]);
    },
    
    processMSGDONE: function(msg) {
        // MSGDONE,<sequence>,<prog>
        var sequence = msg.getField(1);
        if (sequence == '*') {
            sequence = Constants._UNORDERED_MESSAGES;
        }
        var prog = msg.getFieldAsInt(2);
        this.LS_w(5, prog, sequence, 0, 0);
    },
    
    processMSGFAIL: function(msg) {
        // MSGFAIL,<sequence>,<prog>,<error-code>,<error-message>
        var sequence = msg.getField(1);
        if (sequence == '*') {
            sequence = Constants._UNORDERED_MESSAGES;
        }
        var prog = msg.getFieldAsInt(2);
        var errCode = msg.getFieldAsInt(3);
        var errMsg = msg.getFieldUnquoted(4);
        this.LS_l(errCode, prog, "MSG" + sequence, errMsg);
    },
    
    processOV: function(msg) {
        // OV,<table>,<item>,<lost updates>
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var item = msg.getFieldAsInt(2);
        var lost = msg.getFieldAsInt(3);
        this.LS_o(phase, [table, item, lost]);
    },
    
    processCONF: function(msg) {
        // CONF,<table>,(unlimited|<frequency>),(filtered|unfiltered)
        var phase = null;
        var table = msg.getFieldAsInt(1);
        var frequency;
        var rawFrequency = msg.getField(2);
        var mode = msg.getField(3);
        if (mode != "filtered" && mode != "unfiltered") {
            throw new Error("Unknown mode");
        }
        if (rawFrequency == "unlimited") {
            frequency = rawFrequency;
        } else {
            frequency = msg.getFieldAsFloat(2);
        }
        this.LS_w(9, phase, table, frequency);
    },
    
    processPROG: function(msg) {
        // PROG,<number>
        var phase = null;
        var prog = msg.getFieldAsInt(1);
        this.LS_e(7, phase, prog);
    },
    
    processPROBE: function(msg) {
        // PROBE
        var phase = null;
        this.LS_u(phase, []);
    },
    
    processEND: function(msg) {
        // END,<cause>,<message>
        var phase = null;
        var cause = msg.getFieldAsInt(1);
        var message = msg.getFieldUnquoted(2);
        this.LS_e(4, phase, cause, message);
    },
    
    processSYNC: function(msg) {
        // SYNC,<secs>
        var phase = null;
        var secs = msg.getFieldAsInt(1);
        this.LS_s(phase, secs);
    },
    
    processMPNREG: function(msg) {
        var deviceId = msg.getField(1);
        var adapterName = msg.getField(2);
        this.LS_MPNREG(deviceId, adapterName);
    },
    
    processMPNOK: function(msg) {
        var lsSubId = msg.getField(1);
        var pnSubId = msg.getField(2);
        this.LS_MPNOK(lsSubId, pnSubId);
    },
    
    processMPNDEL: function(msg) {
        var pnSubId = msg.getField(1);
        this.LS_MPNDEL(pnSubId);
    },
    
    parseUpdates: function(message) {
        // U,<table>,<item>|<field1>|...|<fieldN>
        // or U,<table>,<item>,<field1>|^<number of unchanged fields>|...|<fieldN>
        /* parse table and item */
        var tableIndex = message.indexOf(',') + 1;
        ASSERT.verifyOk(tableIndex == 2); // tested by the caller
        var itemIndex = message.indexOf(',', tableIndex) + 1;
        if (itemIndex <= 0) {
            throw new Error("Missing subscription field");
        }
        var fieldsIndex = message.indexOf(',', itemIndex) + 1;
        if (fieldsIndex <= 0) {
            throw new Error("Missing item field");
        }
        ASSERT.verifyOk(message.substring(0, tableIndex) == "U,"); // tested by the caller
        var table = myParseInt(message.substring(tableIndex, itemIndex - 1), "Invalid subscription");
        var item = myParseInt(message.substring(itemIndex, fieldsIndex - 1), "Invalid item");

        /* parse fields */
        var unchangedMarker = {};
        unchangedMarker.length = -1;

        var values = [];
        var fieldStart = fieldsIndex - 1; // index of the separator introducing the next field
        ASSERT.verifyOk(message.charAt(fieldStart) == ','); // tested above
        while (fieldStart < message.length) {

            var fieldEnd = message.indexOf('|', fieldStart + 1);
            if (fieldEnd == -1) {
                fieldEnd = message.length;
            }
            /*
                 Decoding algorithm:
                     1) Set a pointer to the first field of the schema.
                     2) Look for the next pipe “|” from left to right and take the substring to it, or to the end of the line if no pipe is there.
                     3) Evaluate the substring:
                            A) If its value is empty, the pointed field should be left unchanged and the pointer moved to the next field.
                            B) Otherwise, if its value corresponds to a single “#” (UTF-8 code 0x23), the pointed field should be set to a null value and the pointer moved to the next field.
                            C) Otherwise, If its value corresponds to a single “$” (UTF-8 code 0x24), the pointed field should be set to an empty value (“”) and the pointer moved to the next field.
                            D) Otherwise, if its value begins with a caret “^” (UTF-8 code 0x5E):
                                    - take the substring following the caret and convert it to an integer number;
                                    - for the corresponding count, leave the fields unchanged and move the pointer forward;
                                    - e.g. if the value is “^3”, leave unchanged the pointed field and the following two fields, and move the pointer 3 fields forward;
                            E) Otherwise, the value is an actual content: decode any percent-encoding and set the pointed field to the decoded value, then move the pointer to the next field.
                               Note: “#”, “$” and “^” characters are percent-encoded if occurring at the beginning of an actual content.
                     4) Return to the second step, unless there are no more fields in the schema.
             */
            var value = message.substring(fieldStart + 1, fieldEnd);
            if (value == "") { // step A
                values.push(unchangedMarker);

            } else if (value.charAt(0) == '#') { // step B
                if (value.length != 1) {
                    throw new Error("Wrong field quoting");
                } // a # followed by other text should have been quoted
                values.push(null);

            } else if (value.charAt(0) == '$') { // step C
                if (value.length != 1) {
                    throw new Error("Wrong field quoting");
                } // a $ followed by other text should have been quoted
                values.push("");

            } else if (value.charAt(0) == '^') { // step D
                var count = myParseInt(value.substring(1), "Invalid field count");
                while (count-- > 0) {
                    values.push(unchangedMarker);
                }

            } else { // step E
                var unquoted = EncodingUtils.unquote(value);
                values.push(unquoted);
            }
            fieldStart = fieldEnd;
        }
        return values;
    },
    
    /**
     * Returns the handler of a request. A request handler has only two methods: onREQOK and onREQERR. 
     * <br>
     * Can be null. 
     */
    getRequestListener: function(reqId) {
        goodcase: 
        {
            if (this.session == null) {                
                break goodcase;
            }
            var requestListener = this.session.controlHandler.getAndRemoveRequestListener(reqId);
            if (requestListener == null) {                
                break goodcase;
            }
            return requestListener;
        }
        return null;
    }
    
  };
  
  function myParseInt(field, errorMsg) {
      var n = parseInt(field, 10);
      if (isNaN(n)) {
          throw new Error(errorMsg);
      }
      return n;
  }

var _OFF$1 = 1;
  var STREAMING_WS = 2;
  var SWITCHING_STREAMING_WS = 3;
  var POLLING_WS = 4;
  var SWITCHING_POLLING_WS = 5;
  var STREAMING_HTTP = 6;
  var SWITCHING_STREAMING_HTTP = 7;
  var POLLING_HTTP = 8;
  var SWITCHING_POLLING_HTTP = 9;
  var END = 10;
  
  //frozen is used if a status can't change transport because the setForcedTransport simply specified WS or HTTP 
  var FROZEN = "_";
  var NOT_FROZEN = "";
  
  function toStr(_type){
    switch(_type) {
      case _OFF$1:
        return "No session";
      case STREAMING_WS:
        return "WS Streaming";
      case SWITCHING_STREAMING_WS:
        return "prepare WS Streaming";
      case POLLING_WS:
        return "WS Polling";
      case SWITCHING_POLLING_WS:
        return "prepare WS Polling";
      case STREAMING_HTTP:
        return "HTTP Streaming";
      case SWITCHING_STREAMING_HTTP:
        return "prepare HTTP Streaming";
      case POLLING_HTTP:
        return "HTTP Polling";
      case SWITCHING_POLLING_HTTP:
        return "prepare HTTP Polling";
      case END:
        return "Shutting down";
    }
  }
  
  var CREATE_FALLS = {};
  CREATE_FALLS[STREAMING_WS] = SWITCHING_STREAMING_HTTP;
  CREATE_FALLS[STREAMING_HTTP] = SWITCHING_POLLING_HTTP;
  CREATE_FALLS[POLLING_WS] = SWITCHING_STREAMING_WS;
  CREATE_FALLS[POLLING_HTTP] = SWITCHING_STREAMING_WS;
  
  CREATE_FALLS[FROZEN+STREAMING_WS] = SWITCHING_STREAMING_WS; 
  CREATE_FALLS[FROZEN+STREAMING_HTTP] = SWITCHING_POLLING_HTTP; 
  CREATE_FALLS[FROZEN+POLLING_WS] = SWITCHING_STREAMING_WS; 
  CREATE_FALLS[FROZEN+POLLING_HTTP] = SWITCHING_STREAMING_HTTP;
  
  //NOTE, Polling HTTP actually never gives up http://goo.gl/81k22
  var GIVEUP_FALLS = {};
  GIVEUP_FALLS[STREAMING_WS] = SWITCHING_STREAMING_HTTP;
  GIVEUP_FALLS[STREAMING_HTTP] = SWITCHING_POLLING_HTTP;
  GIVEUP_FALLS[POLLING_WS] = SWITCHING_STREAMING_WS;
  GIVEUP_FALLS[POLLING_HTTP] = SWITCHING_STREAMING_WS;
  
  GIVEUP_FALLS[FROZEN+STREAMING_WS] = SWITCHING_STREAMING_WS;
  GIVEUP_FALLS[FROZEN+STREAMING_HTTP] = SWITCHING_POLLING_HTTP;
  GIVEUP_FALLS[FROZEN+POLLING_WS] = SWITCHING_STREAMING_WS;
  GIVEUP_FALLS[FROZEN+POLLING_HTTP] = SWITCHING_POLLING_HTTP;
  
  var FROZEN_CHECK = {};
  FROZEN_CHECK[STREAMING_WS] = SWITCHING_STREAMING_WS;
  FROZEN_CHECK[STREAMING_HTTP] = SWITCHING_STREAMING_HTTP;
  FROZEN_CHECK[POLLING_WS] = SWITCHING_POLLING_WS;
  FROZEN_CHECK[POLLING_HTTP] = SWITCHING_POLLING_HTTP;
  
  
  
  var SLOW_FALLS = {};
  SLOW_FALLS[STREAMING_WS] = SWITCHING_POLLING_WS;
  SLOW_FALLS[STREAMING_HTTP] = SWITCHING_POLLING_HTTP;
  //a slow command can be issued while we're switching (while we wait for the loop command)
  SLOW_FALLS[SWITCHING_STREAMING_HTTP] = SWITCHING_POLLING_HTTP;
  SLOW_FALLS[SWITCHING_POLLING_HTTP] = SWITCHING_POLLING_HTTP;
  //it's still not possible during SWITCHING_STREAMING_WS (unless we manually ask to switch) 
  //and during SWITCHING_POLLING_WS (unless we manually ask to switch we only switch to polling ws because
  //of a slowing so that a second call is not possible because of the isSlowRequired check.) 
  
  var SWITCHING_STATUSES = {};
  SWITCHING_STATUSES[SWITCHING_STREAMING_WS] = true;
  SWITCHING_STATUSES[SWITCHING_POLLING_WS] = true;
  SWITCHING_STATUSES[SWITCHING_STREAMING_HTTP] = true;
  SWITCHING_STATUSES[SWITCHING_POLLING_HTTP] = true;
  
  var STREAMING_SESSION = false;
  var POLLING_SESSION = true;
  var WS_SESSION = false;
  var HTTP_SESSION = true;
  
  var AVOID_SWITCH = true;
  var NO_RECOVERY = true;
  var YES_RECOVERY = false;
  
  var protocolLogger$5 = LoggerManager.getLoggerProxy(Constants.PROTOCOL);
  var sessionLogger$6 = LoggerManager.getLoggerProxy(Constants.SESSION);
  
  var objectIdCounter$3 = 1;
  
  var SessionHandler = function(owner,ppHandler,mpnManager) {
    this.objectId = objectIdCounter$3++;
    if (sessionLogger$6.isDebugLogEnabled()) {
        sessionLogger$6.logDebug(LoggerManager.resolve(785), this.objectId);
    }
    this.status = _OFF$1;
    this.statusPhase = 0;
    this.session = null;
    
    this.clientIP = null;
    
    this.frozen = NOT_FROZEN;
    
    this.owner = owner;
    
    this.pushPagesHandler = ppHandler;
    this.policyBean = owner._policy;
    this.connectionBean = owner._connection;
    this.engineId =  owner.getEngineId();
    
    this.slowing = new SlowingHandler(this.policyBean,this.engineId);
    this.pEvents = new PushEvents(this.engineId,ppHandler);
    
    EnvironmentStatus.addUnloadHandler(this);
    
    this.exportForceReload();
    
    this.disableXSXHRTime = null;
        
    this.controlHandler = new ControlConnectionHandler(this,owner._policy,this.engineId,false);
    this.sendMessageHandler = new SendMessageHandler(this.controlHandler,this.pushPagesHandler,this.policyBean);
    
    this.mpnManager = mpnManager;
    
    /**
     * Counts the bind_session requests following the corresponding create_session.
     */
    this.nBindAfterCreate = 0;
  };

  SessionHandler.prototype = {
    
      /*private*/ exportForceReload: function() {
        var that = this;
        
        Lightstreamer.exportGlobal(this.engineId,"LS_forceReload",function() {
          if (that.session) {
            that.session.onErrorEvent("server.exit",{closedOnServer: true});
          }
        });
      },
      
      /*private*/ changeStatus: function(newStatus) {
        if (sessionLogger$6.isDebugLogEnabled()) {
            sessionLogger$6.logDebug(LoggerManager.resolve(786), toStr(this.status), "->", toStr(newStatus));
        }
        this.status = newStatus;
        this.statusPhase++;
      },
      
////////////////////////////////////////////////API CALLS
      

      /*public*/ closeSession: function(fromAPI,reason,noRecoveryScheduled) {
        if (this.status == _OFF$1 || this.status == END) {
          return;
        }
        
        if (this.session) {
          this.session.closeSession(fromAPI?"api":reason,false,noRecoveryScheduled);
        }
      },
      
      disconnectAndReconnect: function() {
          if (this.status == _OFF$1 || this.status == END) {
              return;
          }
          if (this.session) {
              this.session.disconnectAndReconnect();
          }
      },

      syncErrorOnControl: function() {
        if (this.status == _OFF$1 || this.status == END) {
          return;
        }

        if (this.session) {
          this.session.onSyncError("control.syncerror");
        }
      },

      /*private*/ isAlive: function() {
        return this.status != _OFF$1 && this.status != END;
      },
      
      changeTransport: function(fromAPI, isTransportForced, isComboForced, isPolling, isHTTP) {
          if (this.session != null && this.session.isActive()) {
              /*
               * the session is active: send a force_rebind
               */
              this.createOrSwitchSession(fromAPI, isTransportForced, isComboForced, isPolling, isHTTP);
          } else {
              /*
               * the session is not active (i.e. TRYING-RECOVERY or WILL-RETRY):
               * await that the client is connected and then bind the session with the new transport
               */
              var nextPH = isPolling ? (isHTTP ? SWITCHING_POLLING_HTTP : SWITCHING_POLLING_WS) : (isHTTP ? SWITCHING_STREAMING_HTTP : SWITCHING_STREAMING_WS);
              this.status = nextPH;
              this.session.switchRequired = true;
          }
      },
      
      retry: function(handlerPhase, retryCause, forced, serverBusy) {
          if (handlerPhase != this.statusPhase) {
              return;
          }
          
          var strOrPoll = this.status === STREAMING_WS || this.status === STREAMING_HTTP ? STREAMING_SESSION : POLLING_SESSION;
          var wsOrHttp = this.status === STREAMING_WS || this.status === POLLING_WS ? WS_SESSION : HTTP_SESSION;
          
          this.createSession(false,this.frozen,forced,strOrPoll,wsOrHttp,retryCause,serverBusy);
      },
      
      /*public*/ createOrSwitchSession: function(fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason,avoidSwitch) {
        
        if (!avoidSwitch && this.isAlive()) {
          this.switchSession(fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason);
        } else {
          this.createSession(fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason,false/*serverBusy*/);
        }
        
      },
      
      switchSession: function(fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason) {
          if (fromAPI) {
              MadTester.init();
          }
            
          this.disableCorsCheck();
            
          var reason = fromAPI?"api":_reason;
            
          this.frozen = isTransportForced ? FROZEN : NOT_FROZEN;
            
          var nextPH = isPolling ? (isHTTP ? SWITCHING_POLLING_HTTP : SWITCHING_POLLING_WS) : (isHTTP ? SWITCHING_STREAMING_HTTP : SWITCHING_STREAMING_WS);
          this.changeStatus(nextPH);
          this.startSwitchTimeout(reason);
          this.session.requestSwitch(this.statusPhase,reason,isComboForced);
      },
      
      createSession: function(fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason,serverBusy) {
          if (fromAPI) {
              MadTester.init();
          }

          this.disableCorsCheck();

          var reason = fromAPI?"api":_reason;

          this.frozen = isTransportForced ? FROZEN : NOT_FROZEN;

          //there is no session active or we want to start from scratch
          
          this.resetControlHandlers();
          
          var currSessionId = this.session ? this.session.getSessionId() : null;
          
          reason = "new."+reason;
          this.closeSession(false,reason,YES_RECOVERY);
          
          var nextPH = isPolling ? (isHTTP ? POLLING_HTTP : POLLING_WS) : (isHTTP ? STREAMING_HTTP : STREAMING_WS);
          this.changeStatus(nextPH);

          if (this.session != null) {
            this.session.shutdown(false);
          }
          this.prepareNewSessionInstance(isPolling,isComboForced,isHTTP);
          
          this.session.createSession(currSessionId,reason,serverBusy);
      },
      
      /*private*/ prepareNewSessionInstance: function(isPolling,isForced,isHTTP,prevSession,sessionRecovery) {
        var skipCors = this.disableXSXHRTime !== null;
        var chosenClass = isHTTP ? SessionHTTP : SessionWS;
        if (sessionRecovery) {
            /*
             * Check added to avoid a bug in HTTP polling.
             * When a poll fails, we must not disable CORS
             * because the error can be recoverable.
             */
            skipCors = false;
        }
        this.session = new chosenClass(
        		isPolling,
        		isForced,
        		this,
        		this.statusPhase,
        		prevSession,
        		skipCors,
        		sessionRecovery,
        		this.mpnManager);
        if (prevSession) {
          prevSession.shutdown();//close it without killing the session, the new session is taking its place
        }
        this.slowing.changeSession(this.session);
        if (this.evalQueue) {
          this.evalQueue.changeSession(this.session);
        }
        this.pEvents.changeSession(this.session);
        
      },
      
      /*private*/ bindSession: function(isForced,isPolling,isHTTP,switchCause) {
        var nextPH = isPolling ? (isHTTP ? POLLING_HTTP : POLLING_WS) : (isHTTP ? STREAMING_HTTP : STREAMING_WS);
        this.changeStatus(nextPH);
        
        this.prepareNewSessionInstance(isPolling,isForced,isHTTP,this.session);
        
        this.session.bindSession(switchCause);       
      },
      
      /*public*/ recoverSession: function(ph,switchCause,forced) {
          sessionLogger$6.logDebug(LoggerManager.resolve(787), switchCause);
          if (ph != this.statusPhase) {
              sessionLogger$6.logDebug(LoggerManager.resolve(788));
              return;
          }
          
          /* 
           * Since this is a recovery, we keep the same transport we had before the network error
           * (FROZEN_CHECK makes a transition from a transport to itself).
           */
          var switchType = FROZEN_CHECK[this.status] || this.status;
          var isPolling = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_STREAMING_HTTP ? STREAMING_SESSION : POLLING_SESSION;
          var isHTTP = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_POLLING_WS ? WS_SESSION : HTTP_SESSION;
          var nextPH = isPolling ? (isHTTP ? POLLING_HTTP : POLLING_WS) : (isHTTP ? STREAMING_HTTP : STREAMING_WS);
          this.changeStatus(nextPH);
          
		  this.prepareNewSessionInstance(isPolling,forced,isHTTP,this.session,true);
          this.session.recoverSession();
      },
      
      shouldGiveUpTrying: function() {
        //if is frozen (i.e. forced transport, not forced method) and the next connection is gonna try is the same 
        //as the last just tried.
        return this.frozen == FROZEN && FROZEN_CHECK[this.status] == GIVEUP_FALLS[this.frozen+this.status]; //switchType
      },
      
      //AKA request switch
      onSessionGivesUp: function(ph,reason,stop) {
        if (ph != this.statusPhase) {
          return;
        } else if (stop) {
          //we can't go on this way
          //but we don't want to go on in any other way
          //so stop everything and go home
          sessionLogger$6.logInfo(LoggerManager.resolve(789));
          
          this.changeStatus(_OFF$1);
          return;
        }
        
        var switchType = GIVEUP_FALLS[this.status] || this.status;
        if (switchType == SWITCHING_STREAMING_HTTP && BrowserDetection.isProbablyEdge()) {
            /*
             * HTTP streaming is broken in Edge. 
             * The browser notifies to the client only a piece of the bind_session response sent by the server
             * causing a timeout and a change of transport.
             * See https://organizza.5pmweb.com/?def=1&task=2742
             */
            switchType = SWITCHING_POLLING_HTTP;
        }
        
        sessionLogger$6.logInfo(LoggerManager.resolve(790), toStr(this.status),toStr(switchType));
        
        if (switchType == _OFF$1 || switchType == END) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$6.logError(LoggerManager.resolve(791));
          return;
        }
        
        this.changeStatus(switchType);
        
        this.startSwitchTimeout(reason);
        this.session.requestSwitch(this.statusPhase,reason,false);
        
      },
      
      onSlowRequired: function(ph) {
        if (ph != this.statusPhase) {
          return;
        }
        
        //redundant as session checks itself before calling the handler
        /*if (this.session.isSlowRequired()) {
          //nothing to do
          return;
        }*/
        
        var switchType = SLOW_FALLS[this.status];
        
        sessionLogger$6.logInfo(LoggerManager.resolve(792), toStr(this.status),toStr(switchType));
        
        if(!switchType) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$6.logError(LoggerManager.resolve(793), toStr(this.status), this.session);
          return;
        }
        this.changeStatus(switchType);
        
        this.startSwitchTimeout("slow");
        this.session.requestSlow(this.statusPhase);
        
      },
      
      createMachine: function(ph,switchCause,forced) {
        if (ph != this.statusPhase) {
          return;
        }
        
        var switchType = CREATE_FALLS[this.frozen+this.status] || this.status;
        sessionLogger$6.logInfo(LoggerManager.resolve(794), toStr(this.status),toStr(switchType));
        
        if (switchType == _OFF$1 || switchType == END) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$6.logError(LoggerManager.resolve(795));
          return;
        }
        
        var strOrPoll = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_STREAMING_HTTP ? STREAMING_SESSION : POLLING_SESSION;
        var wsOrHttp = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_POLLING_WS ? WS_SESSION : HTTP_SESSION;
         
        //if we enter the createMachine the status of the session is unknown, so we can't recover by switching so 
        //we ask to AVOID_SWITCH
        this.createOrSwitchSession(false,this.frozen==FROZEN,forced,strOrPoll,wsOrHttp,switchCause,AVOID_SWITCH);
        
      },
      
      switchMachine: function(ph,switchCause,forced) {
        if (ph != this.statusPhase) {
          return;
        }
        
        var switchType = this.status;
        sessionLogger$6.logInfo(LoggerManager.resolve(796), toStr(this.status));
        
        if (!SWITCHING_STATUSES[switchType]) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$6.logError(LoggerManager.resolve(797));
          return;
        }
        
        var strOrPoll = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_STREAMING_HTTP ? STREAMING_SESSION : POLLING_SESSION;
        var wsOrHttp = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_POLLING_WS ? WS_SESSION : HTTP_SESSION;
         
        this.bindSession(forced,strOrPoll,wsOrHttp,switchCause);
        
      },
      
      slowMachine: function(ph) {
        sessionLogger$6.logInfo(LoggerManager.resolve(798));
        this.switchMachine(ph,"slow",false);      
      },
      
      switchTimeout: function(ph,reason) {
        if (ph != this.statusPhase) {
          return;
        }
        
        
        var switchType = this.status;
        
        sessionLogger$6.logInfo(LoggerManager.resolve(799), toStr(this.status));
        
        if (!SWITCHING_STATUSES[switchType]) {
        //>>excludeStart("debugExclude", pragmas.debugExclude);  
          ASSERT.fail();
        //>>excludeEnd("debugExclude");
          sessionLogger$6.logError(LoggerManager.resolve(800));
          return;
        }
        
        reason = "switch.timeout."+reason;
        
        var strOrPoll = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_STREAMING_HTTP ? STREAMING_SESSION : POLLING_SESSION;
        var wsOrHttp = switchType == SWITCHING_STREAMING_WS || switchType == SWITCHING_POLLING_WS ? WS_SESSION : HTTP_SESSION;
         
        this.createOrSwitchSession(false,this.frozen==FROZEN,false,strOrPoll,wsOrHttp,reason,AVOID_SWITCH);
        
      },
      
      startSwitchTimeout: function(reason) {
        var _timeout = this.policyBean.switchCheckTimeout + (this.slowing.getDelay()||0);
       
        Executor.addTimedTask(this.switchTimeout,_timeout,this,[this.statusPhase,reason]);
      },
      
////////////////////////////////////////////////////CONTROL
      
      /*private*/ resetControlHandlers: function() {
        //le richieste di controllo devono essere tutte riproposte.
        //Elimino quelle accumulate finora.
        this.controlHandler._reset();
        
        // riazzero lo stato delle sendMessage;
        // sulla nuova sessione dovranno ripartire da 0
        this.sendMessageHandler._close();
        
      },
      
      /*public*/ connectionsEnableFlagsChanged: function() {
        var skipCors = this.disableXSXHRTime !== null;
        if (this.session) {
          this.session.resetConnectionList(skipCors);
        }
        if (this.controlHandler) {
          this.controlHandler.resetConnectionList(skipCors);
        }
      },
      
      /*public*/ onCorsError: function(ph) {
        if (ph != this.statusPhase) {
          return;
        }
        /*
		 * 23/05/2018
		 * Never disable Cross-origin feature
		 */
        //this.disableXSXHRTime = Helpers.getTimeStamp();
        this.connectionsEnableFlagsChanged();
      },
      
      /*private*/ disableCorsCheck: function() {
        if (this.disableXSXHRTime === null) {
          return;
        }
        var diff = Helpers.getTimeStamp() - this.disableXSXHRTime;
        if (diff > 1000) {
          this.disableXSXHRTime = null;
          this.connectionsEnableFlagsChanged();
        }
      },
      
////////////////////////////////////////////////GETTERS
      
      isSessionOpen: function() {
        return !this.session ? null : this.session.isOpen();
      },
      
      isSessionOpenOrRecovering: function() {
        return !this.session ? null : this.session.isOpen() || this.session.isRecovering();
      },
      
      getHighLevelStatus: function() {
        return !this.session ? Constants.DISCONNECTED : this.session.getHighLevelStatus();
      },
      
      getSessionHost: function() {
        return !this.session ? null : this.session.getSessionHost();
      },
      
      /*public*/ getPushServerAddress: function() {
        return !this.session ? this.connectionBean.serverAddress : this.session.getPushServerAddress();
      },
      
      getSessionId: function() {
        return !this.session ? null : this.session.getSessionId();
      },
      
      /*public*/ getPolicyBean: function() {
        return this.policyBean;
      },
      
      /*public*/ getConnectionBean: function() {
        return this.connectionBean;
      },
      
      /*public*/ getSlowing: function() {
        return this.slowing;
      },
      
      /*public*/ getEvalQueue: function() {
        if (!this.evalQueue || !this.evalQueue.stillValid()) {
            this.evalQueue = new EvalQueue(this.engineId);
            this.evalQueue.changeSession(this.session);
        }
        return this.evalQueue;
      },
      
      /* public */ dispose: function() {
        if (this.evalQueue) {
          this.evalQueue.dispose();
        }
        EnvironmentStatus.removeUnloadHandler(this);
      },
      
      unloadEvent: function() {
        this.closeSession(false,"unload",NO_RECOVERY);
        this.changeStatus(END);
      },
      
      /*public*/ getControlConnectionHandler: function() {
        return this.controlHandler;
      },
      
      getEngineId: function() {
        return this.engineId;
      },
      
////////////////////////////////////////////////PUSH EVENTS 

      statusChanged: function(ph) {
        if (ph != this.statusPhase) {
          return;
        }
        
        this.owner.notifyLSStatus();
      },
      
      /*public*/ onSessionStart: function(requestLimitLength) {
        sessionLogger$6.logInfo(LoggerManager.resolve(801),this.session);
        
        this.onChangeRequestLimitLength(requestLimitLength);
        
        this.sendMessageHandler.activate();
        
        this.owner.onSessionStart();
        
        this.handleReverseHeartbeat(false);
        
        this.nBindAfterCreate = 0;
      },
      
      onChangeRequestLimitLength: function(requestLimitLength) {
          if (requestLimitLength) {
              this.controlHandler.setRequestLimit(requestLimitLength);
          }
      },
      
      /*public*/ onSessionBound: function() {
          if (this.nBindAfterCreate == 0) {
              /*
               * The check is needed to distinguish a true change of session (i.e. a new session id)
               * from a change of transport preserving the session.
               * We are only interested in true change of session.
               */
              this.mpnManager.eventManager.onSessionStart();
          }
          this.nBindAfterCreate++;
      },
      
      /*public*/ onSessionClose: function(ph,noRecoveryScheduled) {
        if (ph != this.statusPhase) {
          return null;
        }
        
        sessionLogger$6.logDebug(LoggerManager.resolve(802),this.session);
        
        this.resetControlHandlers();
        this.owner.onSessionEnd();
        if(noRecoveryScheduled) {
          this.changeStatus(_OFF$1);
        } else {
          this.changeStatus(this.status);//so that the statusPhase changes
        }
        
        this.mpnManager.eventManager.onSessionClose(! noRecoveryScheduled);
        
        return this.statusPhase;
      },

      /*public*/ onUpdateReceived: function(args,snap) {
        // table number which this update is related to is in args[0]
        this.pushPagesHandler.onSubscriptionEvent(args[0]);
        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(args[0]);
        
        if (!ppHandler) {
          protocolLogger$5.logDebug(LoggerManager.resolve(803),this);
          return;
        }
        
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(804),args);
        }
        ppHandler.onUpdate(args,snap);
      },
      
      
      
      /*public*/ onLostUpdatesEvent: function(args) {
        this.pushPagesHandler.onSubscriptionEvent(args[0]);
        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(args[0]);
        if (!ppHandler) {
          //we used to call the deletes here, but when a page disappears its delete are 
          //automatically sent so we can just return
          protocolLogger$5.logDebug(LoggerManager.resolve(805),this);
          return;
        }
        
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(806),args);
        }
        
        
        //send the overflow to the page
        ppHandler.onLostUpdates(args[0],args[1],args[2]);
        
      },
      
      /*public*/ onEndOfSnapshotEvent: function(args) {
        this.pushPagesHandler.onSubscriptionEvent(args[0]);
        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(args[0]);
        if (!ppHandler) {
          //we used to call the deletes here, but when a page disappears its delete are 
          //automatically sent so we can just return
          protocolLogger$5.logDebug(LoggerManager.resolve(807),this);
          return;
        }
        
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(808),args);
        }
        
        ppHandler.onEndOfSnapshot(args[0],args[1]);
      },
      
      /*public*/ onClearSnapshotEvent: function(args) {
        this.pushPagesHandler.onSubscriptionEvent(args[0]);
        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(args[0]);
        if (!ppHandler) {
          //we used to call the deletes here, but when a page disappears its delete are 
          //automatically sent so we can just return
          protocolLogger$5.logDebug(LoggerManager.resolve(809),this);
          return;
        }
        
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(810),args);
        }
        
        ppHandler.onClearSnapshot(args[0],args[1]);
      },
      
      /*public*/ onServerError: function(flag,msg) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(811),flag,msg);
        }
        this.changeStatus(_OFF$1);
        this.pushPagesHandler.notifyServerError(flag,msg);
      },
      
      /*public*/ onTableError: function(tableCode,flag,msg) {

        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(tableCode);
        if (ppHandler) {
          if (protocolLogger$5.isDebugLogEnabled()) {
            protocolLogger$5.logDebug(LoggerManager.resolve(812),tableCode,flag,msg);
          }
          ppHandler.onSubscriptionError(tableCode,flag,msg);
        } else {
          //we used to call the deletes here, but when a page disappears its delete are
          //automatically sent so we can just return
          protocolLogger$5.logDebug(LoggerManager.resolve(813),this);
        }

        this.pushPagesHandler.onSubscriptionError(tableCode);


    },
      
      /*public*/ onUnsubscription: function(tableCode) {
        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(tableCode);
        if (ppHandler) {
          if (protocolLogger$5.isDebugLogEnabled()) {
            protocolLogger$5.logDebug(LoggerManager.resolve(814),tableCode);
          }

          ppHandler.onUnsubscription(tableCode);
        } else {
          //we used to call the deletes here, but when a page disappears its delete are
          //automatically sent so we can just return
          protocolLogger$5.logDebug(LoggerManager.resolve(815),this);
        }

        this.pushPagesHandler.onUnsubscription(tableCode);

      },
      
      /*public*/ onSubscriptionReconf: function(tableCode,ph,frequency) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(816),tableCode,ph,frequency);
        }
        
        this.pushPagesHandler.onSubscriptionReconfEvent(tableCode,ph);
        
        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(tableCode);
        if (ppHandler != null) {
            ppHandler.onSubscriptionReconf(tableCode, frequency);
        } else {
            protocolLogger$5.logWarn(LoggerManager.resolve(817), tableCode);
        }
      },
      
      /*public*/ onSubscription: function(tableCode,numOfSubscribedItems,numOfSubscribedFields,keyPos,commandPos) {
        this.pushPagesHandler.onSubscription(tableCode);

        var ppHandler = this.pushPagesHandler.getPushPageHandlerFromTableNumber(tableCode);
        if (!ppHandler) {
          //we used to call the deletes here, but when a page disappears its delete are
          //automatically sent so we can just return
          protocolLogger$5.logDebug(LoggerManager.resolve(818),this);
          return;
        }

        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(819),tableCode,numOfSubscribedItems,numOfSubscribedFields,keyPos,commandPos);
        }

        ppHandler.onSubscription(tableCode,keyPos,commandPos,numOfSubscribedItems,numOfSubscribedFields);
      },
      
      /*public*/ onMessageAck: function(sequence,num) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(820),sequence,num);
        }
        
        this.sendMessageHandler.ack(sequence, num);
      },
      
      onMessageOk: function(sequence,num) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(821),sequence,num);
        }
        
        this.sendMessageHandler._complete(sequence, num);
      },
      
      // <= 0 message rejected by the Metadata Adapter
      onMessageDeny: function(sequence,flag,msg,num) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(822),sequence,num,flag,msg);
        }
        
        this.sendMessageHandler.notifyDenied(sequence,flag,num,msg);
      },
            
      // 38 message has not arrived in time (and perhaps never come)
      /*public*/ onMessageDiscarded: function(sequence,num) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(823),sequence,num);
        }
        
        this.sendMessageHandler.notifyDiscarded(sequence,num);
      },
      
      // 34 request deemed invalid by the Metadata Adapter
      // 35 unexpected error in message processing
      /*public*/ onMessageError: function(sequence,flag,msg,num) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(824),sequence,num,flag,msg);
        }
        
         this.sendMessageHandler.notifyError(sequence,flag,num,msg);
      },
      
      onObsoleteControlLink: function(serverAddress) {
        // delete any links referring to the load balancer
        this.owner.onObsoleteControlLink(serverAddress);
      },
      
      onNewControlLink: function(serverAddress) {
        if (protocolLogger$5.isDebugLogEnabled()) {
          protocolLogger$5.logDebug(LoggerManager.resolve(825),serverAddress);
        }
        this.owner.onNewControlLink(serverAddress);
      },

      onIPReceived: function(newIP) {
        if (this.clientIP && newIP != this.clientIP && WebSocketConnection.isDisabledClass()) {
          WebSocketConnection.restoreClass();
          this.createOrSwitchSession(false,this.frozen==FROZEN,false,false,false,"ip",false);
        }
        this.clientIP = newIP;
      },
      
      onServerKeepalive: function() {
          this.owner.onServerKeepalive();
      },
      
      
////////////////////////////////////////////////CONTROLS

      /*public*/ sendAMessage: function(msg, sequence, listener, delayTimeout) {
        this.sendMessageHandler._send(msg, sequence, listener, delayTimeout);
      },
      
      /*public*/ sendLog: function(msg,buildNum) {
        var query = RequestsHelper.getLogRequestParams(this.statusPhase,msg,buildNum);

        this.controlHandler.addRequest(null, query, ControlRequest.LOG, null);
      },
      
      /*public*/ changeBandwidth: function(newBw) {
        if (this.session) {
          this.session.changeBandwidth();
        }
      },
      
      /*public*/ sendSubscription: function(tableNum,addBody,ppHandler,retrying,tutor) {
        var requestListener = {
                onREQOK: function(LS_window) {
                    // nothing to do: expecting SUBOK
                },
                
                onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                    LS_window.LS_l(errorCode, phase, tableNum, errorMsg);
                }
        };
        this.controlHandler.addRequest(tableNum, addBody, ControlRequest.ADD, tutor, retrying, requestListener);
      },
      
      /*public*/ sendUnsubscription: function(tableNum,delBody,ppHandler,retrying,tutor) {
          var requestListener = {
                  onREQOK: function(LS_window) {
                      // nothing to do: expecting UNSUB
                  },

                  onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                      // it is possible that if an unsubscription request immediately follows 
                      // a subscription request, the server, which processes the requests 
                      // in parallel, processes the unsubscription before the subscription. 
                      // but since there is no active subscription at the moment, the server returns 
                      // the error 19 to the client. 
                      // in that case the client should resend the unsubscription request in order to 
                      // free resources on the server. 
                      // this is achieved by not discarding the retransmission tutor.
                      if (errorCode != 19) {
                        tutor.discard();
                      }
                      sessionLogger$6.logError(LoggerManager.resolve(826) + printObj$1(delBody) + " caused the error: ", errorCode, errorMsg);
                  }
          };
          this.controlHandler.addRequest(tableNum,delBody,ControlRequest.REMOVE, tutor, retrying, requestListener);
      },
      
      /*public*/ sendSubscriptionChange: function(tableNum,changeBody,tutor) {
          var requestListener = {
                  onREQOK: function(LS_window) {
                      // nothing to do: expecting CONF
                  },

                  onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                      tutor.discard();
                      sessionLogger$6.logError(LoggerManager.resolve(827) + printObj$1(changeBody) + "] caused the error: " + errorCode + " " + errorMsg);
                  }
          };
          this.controlHandler.addRequest(tableNum,changeBody,ControlRequest.CHANGE_SUB,tutor,null,requestListener);
      },
      
      //not exactly part of this group, but close enough
      /*public*/ handleReverseHeartbeat: function(force) {
        if (this.session) {
          this.session.handleReverseHeartbeat(force);
        }
      },
      
      /**
       * Enqueues the response to a control request to the queue processing the message stream.
       */
      enqueueControlResponse: function (txtResponse) {
          var phase = (this.session == null ? null : this.session.push_phase);
          this.getEvalQueue()._enqueue(phase, txtResponse);
      },
      
      sendRegisterForMpn: function(mpnRegisterRequest, mpnRegisterTutor) {
          var that = this;
          var requestListener = {
                  onREQOK: function(LS_window) {
                	  mpnRegisterTutor.onResponse();
                  },
                  
                  onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                      mpnRegisterTutor.onResponse();
                	  if (that.session != null) {
                		  that.session.onMpnRegisterError(errorCode, errorMsg);
                	  }
                  }
          };
          var requestKey = mpnRegisterRequest.reqId;
          var retryOrHost = null;
          this.controlHandler.addRequest(
                  requestKey, 
                  mpnRegisterRequest.query, 
                  ControlRequest.MPN, 
                  mpnRegisterTutor, 
                  retryOrHost, 
                  requestListener);
      },
      
      sendMpnSubscription: function(mpnSubscribeRequest, mpnSubscribeTutor) {
          var that = this;
          var requestListener = {
                  onREQOK: function(LS_window) {
                      mpnSubscribeTutor.onResponse();
                  },
                  
                  onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                      mpnSubscribeTutor.onResponse();
                      if (that.session != null) {
                          that.session.onMpnSubscribeError(mpnSubscribeRequest.subscriptionId, errorCode, errorMsg);
                      }
                  }
          };
          var requestKey = mpnSubscribeRequest.reqId;
          var retryOrHost = null;
          this.controlHandler.addRequest(
                  requestKey, 
                  mpnSubscribeRequest.query, 
                  ControlRequest.MPN,
                  mpnSubscribeTutor, 
                  retryOrHost, 
                  requestListener);
      },
      
      sendMpnUnsubscription: function(mpnUnsubscribeRequest, mpnUnsubscribeTutor) {
          var that = this;
          var requestListener = {
                  onREQOK: function(LS_window) {
                      mpnUnsubscribeTutor.onResponse();
                  },
                  
                  onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                      mpnUnsubscribeTutor.onResponse();
                      if (that.session != null) {
                          that.session.onMpnUnsubscribeError(mpnUnsubscribeRequest.subscriptionId, errorCode, errorMsg);
                      }
                  }
          };
          var requestKey = mpnUnsubscribeRequest.reqId;
          var retryOrHost = null;
          this.controlHandler.addRequest(
                  requestKey, 
                  mpnUnsubscribeRequest.query, 
                  ControlRequest.MPN,
                  mpnUnsubscribeTutor, 
                  retryOrHost, 
                  requestListener);
      },
      
      sendMpnFilteredUnsubscription: function(mpnUnsubscribeFilterRequest, mpnUnsubscribeFilterTutor) {
          var requestListener = {
                  onREQOK: function(LS_window) {
                      mpnUnsubscribeFilterTutor.onResponse();
                  },
                  
                  onREQERR: function(LS_window, phase, errorCode, errorMsg) {
                      mpnUnsubscribeFilterTutor.onResponse();
                  }
          };
          var requestKey = mpnUnsubscribeFilterRequest.reqId;
          var retryOrHost = null;
          this.controlHandler.addRequest(
                  requestKey, 
                  mpnUnsubscribeFilterRequest.query, 
                  ControlRequest.MPN, 
                  mpnUnsubscribeFilterTutor, 
                  retryOrHost, 
                  requestListener);
      },
      
      /**
       * A non-recoverable error causing the closing of the session.
       */
      onFatalError: function(error) {
          sessionLogger$6.logError(LoggerManager.resolve(828), error.stack || error);
          if (this.session) {
              this.session.onFatalError(61, "Internal error: " + error);
          }
      }
      
  };
  
  function printObj$1(obj) {
      var s = "{";
      for (var p in obj) {
          s += p + "=" + obj[p] + " ";
      }
      s += "}";
      return s;
  }

  
  SessionHandler.prototype["unloadEvent"] = SessionHandler.prototype.unloadEvent;

var simple$1 = CallDefinition.simple;
  //var simpleWithResponse = CallDefinition.simpleWithResponse;
  var simpleWithResponseAndTimeout$1 = CallDefinition.simpleWithResponseAndTimeout;

  var methods$1 = {
    onEngineConfigurationChange: simple$1,
    onEngineDeath: simple$1,
    onStatusChange: simple$1,
    onSessionStart: simple$1,
    onSessionEnd: simple$1,
    onEngineDying: simple$1,
    onServerError: simple$1,
    onServerKeepalive: simple$1,
    ping: simpleWithResponseAndTimeout$1,
    onSubscription: simple$1,
    onUnsubscription: simple$1,
    onEndOfSnapshot: simple$1,
    onUpdate: simple$1,
    onLostUpdates: simple$1,
    onClearSnapshot: simple$1,
    onSubscriptionError: simple$1,
    onMessageDiscarded: simple$1,
    onMessageDenied: simple$1,
    onMessageError: simple$1,
    onMessageComplete: simple$1,
    onMessageOnNetwork: simple$1,
    onSubscriptionReconf: simple$1
  };


  function NewPushPageHandler(engine,id) {
    this.engine = engine;
    this.id = id;
  }

  NewPushPageHandler.methods = methods$1;

  NewPushPageHandler.prototype = {

    setEngineHandler: function(engineHandler) {
      this.target = engineHandler;
    },

//calls from engine handler

    onClientConfigurationChange: function(objClass,prop,val) {
      var toSet = objClass == "ConnectionDetails" ? this.engine._connection : (objClass == "ConnectionOptions" ? this.engine._policy : this.engine._configuration);
      toSet.simpleSetter(prop, val);
    },

    callConnect: function(sessionPhase) {
      if (sessionPhase != this.engine.getSessionPhase()) {
        return;
      }
      this.engine.doConnect();
    },

    callDisconnect: function(sessionPhase) {
      if (sessionPhase != this.engine.getSessionPhase()) {
        return;
      }
      this.engine.doDisconnect();
    },
    
    callDisconnectAndReconnect: function(sessionPhase) {
        if (sessionPhase != this.engine.getSessionPhase()) {
            return;
        }
        this.engine.doDisconnectAndReconnect();
    },

    pong: function() {
      if(this.engine === null) {
        throw "net";
      }
      return true;
    },

    clientDeath: function() {
      Executor.addTimedTask(this.engine.checkClientHealth,0,this.engine);
      Executor.addTimedTask(this.engine.checkClientHealth,1000,this.engine);
    },

    subscribeTable: function(sessionPhase,body) {
      if (sessionPhase != this.engine.getSessionPhase()) {
        return null;
      }

      return this.engine.subscribe(this.id,body);
    },

    unsubscribeTable: function(sessionPhase,tableNum) {
      if (sessionPhase != this.engine.getSessionPhase()) {
        return null;
      }

      return this.engine.unsubscribe(tableNum);
    },

    updateSubscriptionParams: function(sessionPhase,tableNum,changingParams) {
      if (sessionPhase != this.engine.getSessionPhase()) {
        return null;
      }

      return this.engine.updateSubscriptionParams(tableNum,changingParams);
    },

    forwardMessage: function(sessionPhase,msg,sequence,listenerProxy,timeout) {
      if (sessionPhase != this.engine.getSessionPhase()) {
        return null;
      }
      var listener = listenerProxy == null ? null : {
        prog: listenerProxy,
        pageNum: this.id
      };
      this.engine.sendAMessage(msg,sequence,listener,timeout);
    },

    forwardLog: function(msg) {
      this.engine.sendLog(msg);
    },

    dispose: function() {
      this.engine = null;
      //future calls will get an exception that will cause an onPushPageLost event in the PushPage collection if remote
    }
  };

  for (var i$4 in methods$1) {
    NewPushPageHandler.prototype[i$4] = StandardHandler.createCaller(i$4,methods$1[i$4]);
  }

//THIS CLASS IMPLEMENTS BeanParent

  var idPivot = Helpers.randomG();
  
  var buildNum = Constants.BUILD;
  if (isNaN(buildNum)) {
    buildNum = 0;
  }
  
  var sessionLogger$7 = LoggerManager.getLoggerProxy(Constants.SESSION);
  
  var LightstreamerEngine = function(conf,options,details,sharing,engineHandler,dontDieFor,mpnManager) {

    this._configuration = new Configuration(conf);
    this._configuration.setBroadcaster(this,true);

    this._connection = new ConnectionDetails(details);
    this._connection.setBroadcaster(this,true);
    
    this._policy = new ConnectionOptions(options);
    this._policy.setBroadcaster(this,true);

    this.lastStatus = null;

    this.pushPages = new PushPageCollectionHandler(this,this._configuration,this._connection,this._policy);
    if (sharing && sharing.isPossible()) {
      this.sharedStatus = sharing.createSharedStatus(this,Executor.packTask(this.dispose,this),dontDieFor);
      var bridge = this.sharedStatus.getBridge();
      if (bridge != null) {
        this.channels = sharing.createChannelsManager(this, bridge);
        this.channels.addListener(this.pushPages);
      }
      this.id = this.sharedStatus.getId();
    } else {
      this.sharedStatus = null;
      do {
        this.id = "NS" + (idPivot++);
      } while(Lightstreamer.hasGlobal(this.id,'lsEngine'));
    }

    Lightstreamer.exportGlobal(this.id,'lsEngine',this);

    this.sessionHandler = new SessionHandler(
    		this,
    		this.pushPages,
    		mpnManager);

    this.bindLocalClient(engineHandler,Constants.MAIN_CLIENT);

    //restore the status now
    if (this._configuration.connectionRequested) {
      this.doConnect();
    }
   
  };
  
  LightstreamerEngine.prototype = {


    toString: function() {
      return "[LightstreamerEngine "+this.id+"]";
    },

    bindLocalClient: function(eHandler,name) {
      if (!name) {
        name = "LOCAL"+idPivot++;
      }

      var ppHandler = new NewPushPageHandler(this,name);
      ppHandler.setEngineHandler(eHandler);
      eHandler.setPushPageHandler(ppHandler);

      this.pushPages.onNewPushPage(name,ppHandler);
    },

    getEngineId: function() {
      return this.id;
    },

    /*public*/ isSessionOpen: function() {
      return this.sessionHandler.isSessionOpen();
    },
    
    /*public*/ isSessionOpenOrRecovering: function() {
        return this.sessionHandler.isSessionOpenOrRecovering();
    },

    getSharedStatus: function() {
      return this.sharedStatus;
    },

    getSessionPhase: function() {
      return this.pushPages.getSessionPhase();
    },

    onSessionEnd: function() {
      this.pushPages.onSessionEnd();
    },
    onSessionStart: function() {
      this.pushPages.onSessionStart();
    },

    dispose: function() {

      this.sessionHandler.closeSession(false,"suicide",true);
      this.sessionHandler.dispose();

      Lightstreamer.cleanAllGlobals(this.id); //no one should be able to find me now

      if (this.sharedStatus) {
        this.sharedStatus.dispose();
      }

      this.pushPages.notifyEngineDeath(true);
      this.pushPages.dispose();

      if (this.channels) {
        this.channels.dispose();
      }

    },

    doDisconnect: function() {
      sessionLogger$7.logInfo(LoggerManager.resolve(829));

      this._configuration.simpleSetter('connectionRequested',false);

      this.sessionHandler.closeSession(true,"api",true);
    },
    
    doDisconnectAndReconnect: function() {
        this._configuration.simpleSetter('connectionRequested',false);
        this.sessionHandler.disconnectAndReconnect();
    },
    
    doChangeTransport: function() {
        var ft = this._policy.forcedTransport;
        sessionLogger$7.logInfo(LoggerManager.resolve(830), ft);
        if (ft === null) {
            var fromAPI = true;
            var isTransportForced = false;
            var isComboForced = false;
            var isPolling = false;
            var isHTTP = false;
            this.sessionHandler.changeTransport(fromAPI, isTransportForced, isComboForced, isPolling, isHTTP);
        } else {
            var fromAPI = true;
            var isTransportForced = ft == Constants.WS_ALL || ft == Constants.HTTP_ALL;
            var isComboForced = !isTransportForced;
            var isPolling = ft == Constants.WS_POLLING || ft == Constants.HTTP_POLLING;
            var isHTTP = ft == Constants.HTTP_POLLING || ft == Constants.HTTP_STREAMING || ft == Constants.HTTP_ALL;
            this.sessionHandler.changeTransport(fromAPI, isTransportForced, isComboForced, isPolling, isHTTP);
        }
    },


    doConnect: function() {
      sessionLogger$7.logInfo(LoggerManager.resolve(831));

      this._configuration.simpleSetter('connectionRequested',true);

      var ft = this._policy.forcedTransport;
      if (ft === null) {
        //fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason,avoidSwitch
        this.sessionHandler.createOrSwitchSession(true,false,false,false,false);

      } else {
        this.doConnectForced(ft);
      }
    },

    doConnectForced: function(ft) {
      var isPolling = ft == Constants.WS_POLLING || ft == Constants.HTTP_POLLING;
      var isHTTP = ft == Constants.HTTP_POLLING || ft == Constants.HTTP_STREAMING || ft == Constants.HTTP_ALL;
      var isTransportForced = ft == Constants.WS_ALL || ft == Constants.HTTP_ALL;
      var isComboForced = !isTransportForced;

      //fromAPI,isTransportForced,isComboForced,isPolling,isHTTP,_reason,avoidSwitch
      this.sessionHandler.createOrSwitchSession(true,isTransportForced,isComboForced,isPolling,isHTTP);
    },

    broadcastSetting: function(objClass,prop,val) {
      this.pushPages.forEachPushPage(function(pp) {
        pp.onEngineConfigurationChange(objClass,prop,val);
      });

      if (prop == "requestedMaxBandwidth") {
        //broadcast to the server too
        this.sessionHandler.changeBandwidth(val);
      } else if (prop == "forcedTransport") {

        if (this._configuration.connectionRequested) {
            this.doChangeTransport();
        }

      } else if (prop == "reverseHeartbeatInterval") {
        //change heartbeat handling
        this.sessionHandler.handleReverseHeartbeat(false);
      } else if (prop == "corsXHREnabled" || prop == "xDomainStreamingEnabled") {
        this.sessionHandler.connectionsEnableFlagsChanged();
      }

      return true;
    },

    onObsoleteControlLink: function(serverAddress) {
      if(this.sharedStatus) {
        this.sharedStatus.removeConnectionToServerFlag(serverAddress);
      }
    },

    onNewControlLink: function(serverAddress) {
      if(this.sharedStatus) {
        this.sharedStatus.addConnectionToServerFlag(serverAddress);
      }
    },

    getStatus: function() {
      return this.sessionHandler.getHighLevelStatus();
      // but the pushpage proxies will not need this remote call (they cache state as it changes)
    },

    notifyLSStatus: function() {
      var newStatus = this.getStatus();
      if (this.lastStatus == newStatus) {
        return;
      }

      var oldStatus = this.lastStatus;
      this.lastStatus = newStatus;

      this.pushPages.notifyNewStatus(newStatus,oldStatus);

      //NOTE: this is only called to do a favor to the test
      if (this.onStatusChange) {
        this.onStatusChange(newStatus);
      }

    },


    sendAMessage: function(msg, sequence, listener, delayTimeout) {
      // NOTE: in spite of what is documented,
      // the proxy on the pushpage will not pass a pointer to the listener,
      // but an object containing the necessary information
      var cs = this.getStatus();
      if (cs == Constants.DISCONNECTED || cs == Constants.WILL_RETRY) {
        return false;
        // but the return value is not sent back to the proxy;
        // the case is rare, because the state check has just been done on the proxy;
        // the message is not sent, but it is as if it was sent and not received,
        // which is consistent, since the session is closing;
        // in this case, it is the pushpage that notifies the listener
      }

      this.sessionHandler.sendAMessage(msg, sequence, listener, delayTimeout);

      return true;
    },

    sendLog: function(msg) {
      this.sessionHandler.sendLog(msg,buildNum);

      return true;
    },


    subscribe: function(pageId,body) {
      return this.pushPages.handleTable(pageId,body);
    },

    unsubscribe: function(tableNum) {
      this.pushPages.removeTable(tableNum);
    },

    updateSubscriptionParams: function(tableNum,changingParams) {
      this.pushPages.updateSubscriptionParams(tableNum,changingParams);
    },



    checkClientHealth: function() {
      this.pushPages.cleanThread();
    },
    
    onServerKeepalive: function() {
        this.pushPages.onServerKeepalive();
    },
    
    sendRegisterForMpn: function(mpnRegisterRequest, mpnRegisterTutor) {
        this.sessionHandler.sendRegisterForMpn(mpnRegisterRequest, mpnRegisterTutor);
    },
    
    sendMpnSubscription: function(mpnSubscribeRequest, mpnSubscribeTutor) {
        this.sessionHandler.sendMpnSubscription(mpnSubscribeRequest, mpnSubscribeTutor);
    },
    
    sendMpnUnsubscription: function(mpnUnsubscribeRequest, mpnUnsubscribeTutor) {
        this.sessionHandler.sendMpnUnsubscription(mpnUnsubscribeRequest, mpnUnsubscribeTutor);
    },
    
    sendMpnFilteredUnsubscription: function(mpnUnsubscribeFilterRequest, mpnUnsubscribeFilterTutor) {
        this.sessionHandler.sendMpnFilteredUnsubscription(mpnUnsubscribeFilterRequest, mpnUnsubscribeFilterTutor);
    },
    
    /**
     * A non-recoverable error causing the closing of the session.
     */
    onFatalError: function(error) {
        this.sessionHandler.onFatalError(error);
    }
    
  };

var VAL_SEP = "|";
  
  function EngineStatus(id,shareName,status) {
    this.id= id;
    this.shareName = shareName;
    this.status = status;
  }
  EngineStatus.prototype = {
    getStatus: function() {
      return this.status;
    }
  };
  
  var StringStringManager = { 
    
    /*abstract*/ 
    /*read: function(key) {
      
    },
    write: function(key,val) {
      
    },
    clean: function(key) {
      
    },*/
    
    /*public*/ readSharedStatus: function(shareName,id) {
      return this.readComposedValue(id+"_"+shareName);
    },
    
    //timestamp,frameName,host
    /*public*/ writeSharedStatus: function(shareName,id,values) {
      values = values.join(VAL_SEP);
      var key = Constants.STORAGE_PREFIX+id+"_"+shareName;
      this.write(key,values);
    },
    
    /*public*/ cleanSharedStatus: function(shareName,id) {
      var key = Constants.STORAGE_PREFIX+id+"_"+shareName;
      this.clean(key);
    },
    
    /*public*/ readIds: function(name) {
      return this.readComposedValue(name);
    },
    
    /*public*/ readIdsObjects: function(name) {
      var ids =  this.readComposedValue(name);
      if (!ids) {
        return null;
      }
      var objects = [];
      
      for (var i=0; i<ids.length; i++) {
        var split = ids[i].split("_"); //id_sharename
        if (split.length != 2) {
          continue; //unexpected
        }
        var status = this.readSharedStatus(split[1],split[0]);
        if (status != null) {
          objects.push(new EngineStatus(split[0],split[1],status));
        }
      }
      
      return objects;
    },
    
    /**
     * adds an id to a list of ids in the form |val1|val2|valX| (or val1|val2|valX) if such value is not in the list
     * @param {Object} name
     * @param {Object} id
     * @return {boolean} false if the id is already in the list, false otherwise
     */
    /*public*/ addId: function(name,id,shareName) {
      name = Constants.STORAGE_PREFIX+name;
      id = id+(shareName?"_"+shareName:"");
      
      var val = this.read(name);
      if (!val) {
        val = VAL_SEP;
      } else if (val.indexOf(VAL_SEP+id+VAL_SEP) > -1) {
        return false;
      }
      
      val += id + VAL_SEP;
      this.write(name,val);
      return true;
    },
    
    /**
     * removes an id from a list of ids in the form |val1|val2|valX| (or val1|val2|valX) if such value is in the list
     * @param {Object} name
     * @param {Object} id
     */
    /*public*/ removeId: function(name,id,shareName) {
      name = Constants.STORAGE_PREFIX+name;
      id = id+(shareName?"_"+shareName:"");
      var val = this.read(name);
      if (!val) {
        return;
      }
      var find = VAL_SEP+id+VAL_SEP;
      if (val.indexOf(find) > -1) {
        val = val.replace(find,VAL_SEP);
        if (val == VAL_SEP) {
          this.clean(name);
        } else {
          this.write(name, val);
        }
      }
    },
    
    /*public*/ getAllKeys: function() {
      //contains _ --> engine status
      //contains :// --> server conn
      //neither --> list of engines
      var keys = this.keys();
      var res = [];
      for (var i=0; i<keys.length; i++) {
        if (keys[i].indexOf(Constants.STORAGE_PREFIX) == 0) {
          keys[i] = keys[i].substring(Constants.STORAGE_PREFIX.length);
          res.push(keys[i]);
        }
      }
      return res;
    },
    
    
    /**
     * reads values in the form |val1|val2|valX| (or val1|val2|valX) and return an array with the read values
     */
    /*private*/ readComposedValue: function(key) {
      key = Constants.STORAGE_PREFIX+key;
      var composedVal = this.read(key);
      if(!composedVal) {
        return null;
      }
      var splitted = composedVal.split(VAL_SEP);
      if (splitted[0] == "") {
        splitted.shift();
      }
      
      if (splitted[splitted.length-1] == "") {
        splitted.pop();
      }
      return splitted.length > 0 ? splitted : null;
    }    
  };

var WebStorageManager = Utils.extendObj({    
    read: function(key) {
      return localStorage.getItem(key);
    },
    write: function(key,val) {
      localStorage.setItem(key,val);
    },
    clean: function(key) {
      localStorage.removeItem(key);
    },
    keys: function() {
      var list = [];
      for (var i=0; i<localStorage.length; i++) {
        list.push(localStorage.key(i));
      }
      return list;
    }
    
  },StringStringManager);

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var CookieManager = /*@__PURE__*/(function() {
  /*
   ******FROM RFC 2965
    
   3.1  Syntax:  General

   The two state management headers, Set-Cookie2 and Cookie, have common
   syntactic properties involving attribute-value pairs.  The following
   grammar uses the notation, and tokens DIGIT (decimal digits), token

   (informally, a sequence of non-special, non-white space characters),
   and http_URL from the HTTP/1.1 specification [RFC2616] to describe
   their syntax.

   av-pairs    =     av-pair *(";" av-pair)
   av-pair     =     attr ["=" value]              ; optional value
   attr        =     token
   value       =     token | quoted-string

   Attributes (names) (attr) are case-insensitive.  White space is
   permitted between tokens.  Note that while the above syntax
   description shows value as optional, most attrs require them.

   NOTE: The syntax above allows whitespace between the attribute and
   the = sign.

    
   *******FROM RFC 2616
    
   Many HTTP/1.1 header field values consist of words separated by LWS
   or special characters. These special characters MUST be in a quoted
   string to be used within a parameter value (as defined in section
   3.6).

     token          = 1*<any CHAR except CTLs or separators>
     separators     = "(" | ")" | "<" | ">" | "@"
                    | "," | ";" | ":" | "\" | <">
                    | "/" | "[" | "]" | "?" | "="
                    | "{" | "}" | SP | HT

  *******SO

  we broke the rules as the address of the Lightstreamer server was used inside a cookie name with its :// part
  so we solve the problem by encoding the cookie name before writing/reading it.
  
  we don't change the values as we use only legal characters: 
    the applicationName is alphanumeric
    the engine random number is a number... 
    we tie the applicationName and the engine number with a _ (which is legal)
    the timestamp (1st value of the "big cookie") is a number
    the engine kind (2nd value of the "big cookie") is a single letter...
    the frame name (3rd value of the "big cookie") contains the host name (after the substitution of . and - for other reasons) 
      and is tied with applicationName and engine number with _ (again, legal)
    the host name (optional 4th value of the big cookie) may contain . and - (both legal)
    we separate the values in a single cookies with a | (which is legal)
    
 */
  
  var cookiesEnabled = false;
  
  /**
   * This module contains some utility methods to read and write cookies.
   * <br/>The module makes some assumptions on the cookie usage: some cookie options
   * are not configurable and use fixed defaults.
   * @exports CookieManager
   */
  var CookieManager = {
    
    /**
     * Checks if the module is able to read and write cookies: when the module is loaded it performs
     * a simple check to verify the functionality. When running on Node.js or WebWorkers it is always false. 
     * @returns {Boolean}
     */
    areCookiesEnabled: function() {
      return cookiesEnabled;
    },
    
    /**
     * Returns document.cookie if {@link module:CookieManager.areCookiesEnabled areCookiesEnabled} is true, null otherwise
     * @returns the document.cookie or null
     */
    getAllCookiesAsSingleString: function() {
      if (!this.areCookiesEnabled()) {
        return null;
      }
      return document.cookie.toString();
    },
    
    /**
     * Writes a cookie. The path specified in the cookie is always /
     * @param {String} key the name of the cookie to be written. The key is encoded before it is used.
     * @param {String} val the value of the cookie to be written
     */
    writeCookie: function(key, val) {
      this.writeCookieExe(key, val,"");
    },
    
    /**
     * @private
     */
    writeCookieExe: function(key, val, expireStr) {
      if (!this.areCookiesEnabled()) {
        return;
      }
      
      //Prepare to write cookie
      
      var domainStr = ""; //hasDefaultDomain ? "" : "domain=."+document.domain+"; ";
  
      var valStr = encodeURIComponent(key) + "=" + val + "; ";
      
      var cookieStr = valStr + domainStr + expireStr + "path=/;";
      
      document.cookie = cookieStr;
      
      //Cookies updated
    },
    
    /**
     * Reads a cookie from the browser
     * @param {String} key the name of the cookie to be read. The key is encoded before it is used.
     * @returns {String} the cookie value or null if the cookie does not exists or if {@link module:CookieManager.areCookiesEnabled areCookiesEnabled} is false.
     */
    readCookie: function(key) {
      if (!this.areCookiesEnabled()) {
        return null;
      }
      key = encodeURIComponent(key) + "=";
      
      //... we've cookies!
      var cookies = this.getAllCookiesAsSingleString();

      /*if (cookies.charAt(cookies.length-1) == "=") {
        //rekonq 0.4.0 shows this bug where a = is placed in place of an ; on the last cookie in list...
        cookies = cookies.substring(0,cookies.length-1);
        
        //rekonq 0.7.90 does not show the issue.
      }*/
      
      //tokenize the cookies string ";"
      cookies = cookies.split(";");
      for(var i=0; i < cookies.length; i++) {
        cookies[i] = Helpers.trim(cookies[i]);
          
        //check if we found the cookie we were looking for
        if (cookies[i].indexOf(key) == 0) {
          //we've the cookie, let's return the value
          return cookies[i].substring(key.length,cookies[i].length);
          
        } //else this is not the cookie you are looking for 
    
      }
      
      //cookie not found
      return null;
    },
    
    /**
     * Removes a cookie by setting its expire date to "yesterday"
     * @param key {String} key the name of the cookie to be deleted. The key is encoded before it is used.
     */ 
    removeCookie: function(key) { 
      if (!this.areCookiesEnabled()) {
        return;
      }
      //Removing cookie
      
      var yesterday = new Date();
      yesterday.setTime(yesterday.getTime()-86400000); //Yesterday: (-1*24*60*60*1000)); using -1 should be good too
      var expireStr = "expires="+yesterday.toUTCString()+"; ";
    
      this.writeCookieExe(key, "deleting", expireStr);
      
      //Cookie removed
    },

    /**
     * @private
     */
    checkCookiesFunctionality: function() {
      /*if (typeof navigator != "undefined") {
        if (navigator.cookieEnabled) {
          //cookies
        } else {
          //no cookie
        }
      }*/
      
      if (!Environment.isBrowserDocument()) {
        return;
      }
      
      if (document.location.protocol != "http:" && document.location.protocol != "https:") {
        //do not write cookies if loaded from filesystem.
        return;
      }
      
      
      cookiesEnabled = true; //enable to test
      
      //Checking cookies functionality
   
     // it is used to guard against a possible competition with other pages
      var rand = Helpers.randomG(); 
      
      // I'm not interested in the test above, I do a test of functionality
      
      var cookieTestName = "LS__cookie_test"+rand;
      this.writeCookie(cookieTestName, "testing");
      var testCookie = this.readCookie(cookieTestName);
      if (testCookie == "testing") {
        //Cookies functionality write test passed
        this.removeCookie(cookieTestName);
        testCookie = this.readCookie(cookieTestName);
        if (testCookie == null) {
          //Cookies functionality delete test passed
          //cookiesEnabled = true;
          return;
        }
      }
      
      //no way
      //Cookies functionality tests failed
      cookiesEnabled = false;
      
    }
     
  };
  
  CookieManager.checkCookiesFunctionality();
  
  //closure compiler exports
  CookieManager["areCookiesEnabled"] = CookieManager.areCookiesEnabled;
  CookieManager["getAllCookiesAsSingleString"] = CookieManager.getAllCookiesAsSingleString;
  CookieManager["writeCookie"] = CookieManager.writeCookie;
  CookieManager["removeCookie"] = CookieManager.removeCookie;
  CookieManager["readCookie"] = CookieManager.readCookie;
  
  return CookieManager;
})();

var SharedCookieManager = Utils.extendObj({    
    
    read: function(key) {
      return CookieManager.readCookie(key);
    },
    write: function(key,val) {
      CookieManager.writeCookie(key,val);
    },
    clean: function(key) {
      CookieManager.removeCookie(key);
    },
    keys: function() {
      var list = [];
      var allCookies = CookieManager.getAllCookiesAsSingleString();
      list = allCookies.split(";");
      for (var i=0; i<list.length; i++) {
        list[i] = Helpers.trim(list[i]);
        list[i] = list[i].substring(0,list[i].indexOf("="));
        list[i] = decodeURIComponent(list[i]);
      }
      return list;
    }
    
  },StringStringManager);

var collectors = [];
  var MAX_DELAY = Constants.REFRESH_STATUS_INTERVAL + Constants.REFRESH_STATUS_INTERVAL_TOLERANCE;
  var interval = 60000;
  
  var Collector = function(manager) {
    this._callSuperConstructor(Collector);
    this.manager = manager;
    this.task = null;
  };
  Collector.prototype = {
      start: function() {
        if (this.task) {
          Executor.stopRepetitiveTask(this.task);
        }
        this.task = Executor.addRepetitiveTask(this.collect,interval,this);
        Executor.addTimedTask(this.collect,0,this);//also run now        
      },
      clean: function() {
        Executor.stopRepetitiveTask(this.task);
        for (var i=0; i<collectors.length; i++) {
          if (collectors[i] == this) {
            collectors.splice(i,1);
            return;
          }
        }
      }, 
      collect: function() {
        //contains _ --> engine status
        //contains :// --> server conn
        //neither --> list of engines
        var ts = Helpers.getTimeStamp();
                
        var keys = this.manager.getAllKeys();
        for (var i = 0; i < keys.length; i++) {
          if (keys[i].indexOf("_") > 0) {
            this.checkEngine(keys[i],null,ts);
          }
        }
        
        for (var i = 0; i < keys.length; i++) {
          if (keys[i].indexOf("_") <= -1) {
            this.checkList(keys[i]);
          }
        }
        
      },
      
      checkEngine: function(id,shareName,now) {
        if (!shareName) {
          var split = id.split("_");
          if (split.length != 2) {
            return false;
          }
          id = split[0];
          shareName = split[1];
        }
        
        var status = this.manager.readSharedStatus(shareName,id);
        
        
        
        if (!status) {
          return false;
        }
        
        if (!now) {
          return true;
        }
        
        var diff = now - status[Constants.TIMESTAMP_INDEX];
        if (diff > MAX_DELAY) {
          this.manager.cleanSharedStatus(shareName,id);
          return false;
        }
        return true;
      },
      
      checkList: function(key) {
        var list = this.manager.readIds(key);
        
        for (var i=0; i<list.length; i++) {
          if (list[i].indexOf("_")>0) {
            if(!this.checkEngine(list[i])) {
              this.manager.removeId(key,list[i]);
            }
          } else {
            if (!this.checkEngine(list[i],key)) {
              this.manager.removeId(key,list[i]);
            }
          }
          
        }
        
      }
  };
  Inheritance(Collector,Dismissable,false,true);
  
  var wsCollector = new Collector(WebStorageManager);
  var cookieCollector = new Collector(SharedCookieManager);
  var defaultCollector = Utils.canUseLocalStorage() ? wsCollector : cookieCollector;
  
 
  var SharedCollector = {
    start: function(forcedCookies) {
      var collector = forcedCookies ? cookieCollector : defaultCollector;
      for (var i=0; i<collectors.length; i++) {
        if (collectors[i] == collector) {
          collector.touch();
          return;
        }
      }
     
      collectors.push(collector);
      collector.touch();
      collector.start();
    },
    
    stop: function(forcedCookies) {
      var collector = forcedCookies ? cookieCollector : defaultCollector;
      for (var i=0; i<collectors.length; i++) {
        if (collectors[i] == collector) {
          collector.dismiss();
        }
      }
    },
    
    changeInterval: function(newInterval) {
      interval = newInterval;
      for (var i=0; i<collectors.length; i++) {
        collectors[i].start();
      }
    }
    
  };

var values = {};

  var NoStorageManager = Utils.extendObj({
    read: function(key) {
      return values[key];
    },
    write: function(key,val) {
      values[key] = val;
    },
    clean: function(key) {
      delete(values[key]);
    },
    keys: function() {
      var list = [];
      for (var key in values) {
        list.push(key);
      }
      return list;
    }

  },StringStringManager);

var SharedWorkerManager = {
    canGenerate: function() {
      return Environment.isBrowserDocument() && typeof SharedWorker !== "undefined" && typeof Blob !== "undefined" && window.URL;
    },

    createWorker: function(code) {
      var blob = new Blob([code]);
      // Obtain a blob URL reference to our worker 'file'.
      var blobURL = window.URL.createObjectURL(blob);
      return blobURL;
    },


    removeWorker: function(blobURL) {
      window.URL.revokeObjectURL(blobURL);
    }
  };

var MASTER = Constants.MASTER;
   var REMOTE="REMOTE";
   var INITIALIZATION ="INITIALIZATION";
   var REMOVE="REMOVE";
   var FAILED="FAILED";
   var KILL = "KILL";

   var sharingLogger$3 = LoggerManager.getLoggerProxy(Constants.SHARING);
   
   // LOG DI DETTAGLIO DEL DISPATCHING E DELL'ESECUZIONE:
   // SCOMMENTARE QUANTO SEGUE
   /*
   var att = Executor.addTimedTask;
   Executor.addTimedTask = function() {
	   if (this.externalLogger != sharingLogger) {
		   if (sharingLogger.isDebugLogEnabled()) {
			   this.externalLogger = sharingLogger;
		   }
	   }
	   att.apply(this, arguments);
   };
   */
   // AGGIUNGERE QUANTO SEGUE ALL'INTERNO DI Executor.js A TOP LEVEL
   /*
   {
       var psh = toBeExecuted.push;
       var srt = toBeExecuted.sort;
       var shf = toBeExecuted.shift;
       function printVal(val, action, logger) {
           for (var fld in val) {
               if (fld.toString() != "fun") {
                   action += (" " + fld.toString() + ":" + val[fld]);
               } else {
                   action += (" fun:" + (fld != null));
               }
           }
           logger.logDebug(action);
       }
       toBeExecuted.push = function() {
           printVal(arguments[0], "DISPATCHING", Executor.externalLogger);
           psh.apply(this, arguments);
           resetAt = now + RESET_TIME;
       }
       toBeExecuted.sort = function() {
           Executor.externalLogger.logDebug(LoggerManager.resolve(832) + now + " with " + toBeExecuted.length);
           srt.apply(this, arguments);
       }
       toBeExecuted.shift = function() {
           var val = shf.apply(this, arguments);
           printVal(val, "EXECUTING", Executor.externalLogger);
           return val;
       }
   }
   */

  /*implements CommunicationInterface*/
  function SharedWorkerBridge() {
    this._callSuperConstructor(SharedWorkerBridge);
    this.worker=null;
    this.senderId = null;
  }

  //the below string is the worker.js file 8pay attention to the constants if the file is regenerated
  SharedWorkerBridge.WORKER_CODE = 'var listeners={},nextId=0,MASTER="MASTER",REMOTE="REMOTE",INITIALIZATION="INITIALIZATION",REMOVE="REMOVE",ALL="ALL",FAILED="FAILED",KILL="KILL";onconnect=function(a){var b=a.ports[0];a=nextId++;listeners[MASTER]||(a=MASTER);listeners[a]=b;b.addEventListener("message",function(a){a=a.data;if(a.type==REMOVE)delete listeners[a.target];else if(a.type==KILL)terminate();else if(a.target===ALL)for(var c in listeners)listeners[c]!=b&&sendMessage(c,a,b);else sendMessage(a.target,a,b)});b.start();b.postMessage({type:INITIALIZATION,id:a});a!==MASTER&&listeners[MASTER].postMessage({type:REMOTE,id:a})};function sendMessage(a,b,d){(a=listeners[a])?a.postMessage(b):(b.type=FAILED,d.postMessage(b))}function terminate(){self.close();for(var a in listeners)listeners[a].close()};';
      
  SharedWorkerBridge.prototype = {

    isReady: function() {
      return this.senderId !== null;
    },

    getBridgeId: function() {
      return this.senderId;
    },

    start: function(workerId) {
      var sw = new SharedWorker(workerId);
      var promise = new Promise(function(resolve, reject) {
          sw.onerror = function() {
              sharingLogger$3.logInfo(LoggerManager.resolve(833));
              reject("SharedWorker broken");
          };
      });
      this.worker = sw.port;

      var that = this;
      this.worker.onmessage = function (event) {
        that.onMessageReceived(event.data);
      };

      this.worker.start();
      return promise;
    },

    dispose: function() {
      try {
        if (this.senderId == MASTER) {
          this.worker.postMessage({
            type: KILL
          });
        }
        this.worker.close();
      } catch(e) {
        //already dead?
      }
      this.worker = null;
    },

/* for testing of alternative messsage sequences, possible in some scenarios
    pending: [],
*/

    onMessageReceived: function(event) {

/* for testing of alternative messsage sequences, possible in some scenarios
		if (event.type == "onUpdate") {
			while (this.pending.length > 0) {
				var related = this.pending.shift();
				sharingLogger.logDebug(LoggerManager.resolve(834) + this.pending.length);
				this.dispatchEvent("onMessage",[related]);
			}
		}
*/
        try {
            if (sharingLogger$3.isDebugLogEnabled()) {
                var line = "RECEIVED";
                for (var fld in event) {
                    line += (" " + fld.toString() + ":" + event[fld]);
                }
                sharingLogger$3.logDebug(line);
            }

            if (event.type == INITIALIZATION) {
                this.senderId = event.id;
                this.dispatchEvent("onReady");
            } else if (event.type == REMOTE) {
                this.dispatchEvent("onRemote",[event.id]);
            } else if  (event.type == FAILED) {
                this.dispatchEvent("onMessageFail",[event.target,event.messageId]);
            } else {

/* for testing of alternative messsage sequences, possible in some scenarios
			if (event.type == "RESPONSE" && event.messageId == "0_0" || this.pending.length > 0) {
				this.pending.push(event);
				sharingLogger.logDebug(LoggerManager.resolve(835) + this.pending.length);
				return;
			}
*/
                this.dispatchEvent("onMessage",[event]);
            }
        } catch (e) {
            sharingLogger$3.logError(LoggerManager.resolve(836), e);
        }
    },

    removeTarget: function(id) {
      if (!id) {
        id = this.senderId;
      }
      try {
        this.worker.postMessage({
          type: REMOVE,
          target: id
        });
      } catch(e) {
        //just avoid exception is enough
      }
    },

    sendMessage: function(target,type,messageId,params) {
      if (!this.isReady()) {
        return false;
      }

      var sender = this.senderId;
      var message = {
          type: type,
          sender: sender,
          target: target,
          messageId: messageId,
          params: params
      };

      if (sharingLogger$3.isDebugLogEnabled()) {
        var line = "SENDING";
        for (var fld in message) {
            line += (" " + fld.toString() + ":" + message[fld]);
        }
        sharingLogger$3.logDebug(line);
      }

      try {
        this.worker.postMessage(message);
      } catch(e) {
        sharingLogger$3.logError(LoggerManager.resolve(837), e);
        this.dispatchEvent("onMessageFail",[target,messageId]);
      }

      return true;
    }
  };

  Inheritance(SharedWorkerBridge,EventDispatcher);

//the old CrossPageProxy was initially developed when the library still manually used setTimeout (no Executor available then)
  //thus took extra steps to ensure that event were executed in order. Executor now takes care of executing stuff in order, thus we
  //don't have to care anymore: in terms of the old CrossPageProxy we always do the asynchEnqueuing

  var sharingLogger$4 = LoggerManager.getLoggerProxy(Constants.SHARING);

  var INITIALIZATION$1 = "INITIALIZATION";
  var MASTER$1 = Constants.MASTER;

  /*implements CommunicationInterface*/
  function CrossPageBridge() {
    this._callSuperConstructor(CrossPageBridge);
    this.connections = {};
    this.senderId = null;
    this.othersIds = 1;
  }

  CrossPageBridge.prototype = {

    isReady: function() {
      return this.senderId !== null;
    },

    start: function (masterObject) {
      this.ready = true;
      if (masterObject) {
        this.connections[MASTER$1] = masterObject;

        var that = this;
        Executor.addTimedTask(function() {
          // on many IE versions the call, if performed in the executor, 
          // succedes while at the same time throws an exception
          // removing the executor wrapping you only get the exception
          try {
            masterObject.connect(that);
          } catch(e) {
            if (e.number == -2147467260) ; else {
              // no exceptions are expected here;
              // if anyone occurs, we must check the whole call chain
              // and understand how the exception can be propagated back
              sharingLogger$4.logError(LoggerManager.resolve(838), e);
            }
          }
        },0);

      } else {
        this.senderId = MASTER$1;
        this.dispatchEvent("onReady");
      }

    },

    dispose: function() {
    },

    /**potentially from other window**/
    connect: function (remoteObj) {
      //change context before modifiyng local variables
      Executor.addTimedTask(this._connect, 0, this, [remoteObj]);
    },

    _connect: function (remoteObj) {
      var newId = this.othersIds++;
      this.connections[newId] = remoteObj;
      this.dispatchEvent("onRemote",[newId]);
      this.sendMessage(newId, INITIALIZATION$1, -1, [newId]);
    },

    removeTarget: function(target) {
      delete(this.connections[target]);
    },

    sendMessage: function (target, type, messageId, params) {
      if (!this.isReady()) {
        return false;
      }

      if (target == "ALL") {
        for (var i in this.connections) {
          this._sendOneMessage(i, type, messageId, params);
        }
      } else {
        this._sendOneMessage(target, type, messageId, params);
      }

      return true;
    },

    _sendOneMessage: function(target, type, messageId, params) {
      try {

        if (!this.connections[target] || !this.connections[target].onMessageReceived) {
          this.dispatchEvent("onMessageFail", [target, messageId]);
        } else {

          var that = this;
          Executor.addTimedTask(function() {
            try {
              // on many IE versions the call, if performed in the executor, 
              // succedes while at the same time throws an exception
              // removing the executor wrapping you only get the exception
              that.connections[target].onMessageReceived(target, that.senderId, type, messageId, params);
            } catch(e) {
              if (e.number == -2147467260) {
                // this is a harmless exception from IE
              } else {
                sharingLogger$4.logError(LoggerManager.resolve(839), e);
                that.dispatchEvent("onMessageFail", [target, messageId]);
              }
            }
          },0);

        }
      } catch(e) {
        this.dispatchEvent("onMessageFail", [target, messageId]);
      }

    },

    /**potentially from other window**/
    onMessageReceived: function (target, sender, type, messageId, params) {

      var event = {
        target: Utils.copyByValue(target),
        type: Utils.copyByValue(type),
        messageId: Utils.copyByValue(messageId),
        sender: Utils.copyByValue(sender)
      };
      if (params) {
        event.params = [];
        for (var i = 0; i < params.length; i++) {
          event.params[i] = Utils.copyByValue(params[i]);
        }
      }

      this._onMessageReceived(event);
    },

    _onMessageReceived: function (event) {
      try {
        if (event.type == INITIALIZATION$1) {
          this.senderId = event.params[0];
          this.dispatchEvent("onReady");
        } else {

          this.dispatchEvent("onMessage", [event]);
        }
      } catch(e) {
        if (e.number == -2147467260) ; else {
          sharingLogger$4.logError(LoggerManager.resolve(840), e);
        }
      }

    }
  };

  Inheritance(CrossPageBridge,EventDispatcher,false,true);

var sharingLogger$5 = LoggerManager.getLoggerProxy(Constants.SHARING);
  var defaultManager = Utils.canUseLocalStorage() ? WebStorageManager : SharedCookieManager;
  
  var idPivot$1 = Helpers.randomG();

  var DEFAULT_SHARE_FRAME_TIMEOUT = 500;

  var SharedStatus = function(shareName,engine) {
    this.shareName = shareName;
    this.engine = engine;
    this.id = null;
    this.bridge = null;
    this.manager = NoStorageManager;
  };
  
  
  var TIMESTAMP_INDEX = Constants.TIMESTAMP_INDEX;
  
  SharedStatus.getManager = function(forceCookies) {
    return forceCookies ? SharedCookieManager : defaultManager;
  };
    
  SharedStatus.prototype = {
    toString: function() {
      return ["[SharedStatus",this.id,this.shareName,"]"].join("|");
    },

    getBridge: function() {
      return this.bridge;
    },

    _start: function() {
      this.running = true;
      EnvironmentStatus.addBeforeUnloadHandler(this);
      EnvironmentStatus.addUnloadHandler(this);
    },

    setupCrossTabSharing: function(suicideNotification,dontDieFor,forceCookies,forceFrame) {
      if (this.running) {
        return false;
      }

      this.dontDieFor = dontDieFor || {};

      this.lastTimestamp = null;

      this.shareFrameTimeout = DEFAULT_SHARE_FRAME_TIMEOUT;

      this.suicideNotification = suicideNotification;

      this.currentServer = null;
      this.host = location.host;
      this.frameName = Constants.NULL_VALUE;
      this.blobId = Constants.NULL_VALUE;
      this.preClean = false;

      this.foolOffset = 0;

      //forceCookies is never used by the library, is used by the test though
      if (forceCookies) {
        this.manager = SharedCookieManager;
        SharedCollector.start(true);
      } else {
        this.manager = defaultManager;
        SharedCollector.start();
      }
      this.forceCookies = forceCookies;

      this.startupThread = null;
      this.thread = null;

      this._initId();

      this._setupLocalSharing();
      this.bridge = null;
      if (forceFrame || !SharedWorkerManager.canGenerate()) {
        this.frameName = this.generateFrame();
      } else {
        this.blobId = this.generateWorker();
      }

      this.newerEngines = {};

      sharingLogger$5.logInfo(LoggerManager.resolve(841));

      this._start();
      return true;

    },

    setupLocalSharing: function() {
      if (this.running) {
        return false;
      }

      this._initId(true);
      this._setupLocalSharing();

      sharingLogger$5.logInfo(LoggerManager.resolve(842));

      this._start();
      return true;
    },

    _setupLocalSharing: function() {
      Lightstreamer.addSharableEngine(this.shareName,this.engine);
    },
      
    _initId: function(localOnly) {
      do {
        this.id = idPivot$1++;
      } while(Lightstreamer.hasGlobal(this.id,'lsEngine'));

      if (localOnly) {
        return;
      }

      //first add our id to the list of ids per application 
      if (!this.manager.addId(this.shareName,this.id)) {
        //same ID already there? uhm,
         this._initId(); //will generate a new id
         return;
      }
      
      if(this.manager.readSharedStatus(this.shareName,this.id)) {
        //ID not in list but specific cookie already exists? uhm uhm
        this._initId(); //will generate a new id
        return;
      }
    },
    
    _startRefreshThread: function() {
      this.thread = Executor.addRepetitiveTask(this.refreshStatusThread,Constants.REFRESH_STATUS_INTERVAL,this);
      sharingLogger$5.logInfo(LoggerManager.resolve(843),this);
    },
    
    /*private*/ generateFrame: function() {
      var frameName = this.frameName;
      if (frameName == Constants.NULL_VALUE) {
        frameName = Utils.sanitizeIFrameName("LSF__"+ Utils.getDomain() +"_"+this.id+"_"+this.shareName);

        this.bridge = new CrossPageBridge();


        Lightstreamer.exportGlobal(this.id,Constants.FRAME_BRIDGE_GLOBAL,this.bridge);
      }

      if (!IFrameHandler.getFrameWindow(frameName,true)) {
        this.startupThread = Executor.addTimedTask(this.generateFrame,this.shareFrameTimeout,this);
        this.shareFrameTimeout *= 2;
      } else {
        this.shareFrameTimeout = DEFAULT_SHARE_FRAME_TIMEOUT;
        this._startBridge();

      }

      return frameName;
    },

    /*private*/ generateWorker: function() {
      var worker = SharedWorkerManager.createWorker(SharedWorkerBridge.WORKER_CODE);


      this.bridge = new SharedWorkerBridge();
      this._startBridge(worker);

      Lightstreamer.exportGlobal(this.id,Constants.WORKER_BRIDGE_GLOBAL,worker);

      return worker;
    },

    _startBridge: function(obj) {
      var that = this;
      this.bridge.addListener({
        "onReady": function() {
          that.refreshStatus();
          that.startupThread = Executor.addTimedTask(that._startRefreshThread,0,that);


          that.bridge.removeListener(this);
        }
      });
      this.bridge.start(obj);
    },

    /*public*/ getId: function() {
      return this.id;
    },

    /*public*/ addConnectionToServerFlag: function(serverAddress) {
      if (serverAddress == this.currentServer) {
        return;
      }
      this.currentServer = serverAddress;
      this.manager.addId(serverAddress,this.id,this.shareName);
    },
    
    /*public*/ removeConnectionToServerFlag: function(serverAddress) {
      if (this.currentServer != serverAddress) {
        //unexpected!
        if (this.currentServer == null) {
          sharingLogger$5.logWarn(LoggerManager.resolve(844),serverAddress);
        } else {
          sharingLogger$5.logError(LoggerManager.resolve(845),this.currentServer,serverAddress);
        }
      } else {
        this.currentServer = null;
      }
      this.manager.removeId(serverAddress,this.id,this.shareName);
    },
    
    /*public*/ getNumberOfConnectionsToServer: function(serverAddress) {
      var ids = this.manager.readIdsObjects(serverAddress);
      if (!ids) {
        return 0;
      }
      var count = 0;
      for (var i=0; i<ids.length; i++) {
        var diff =  Helpers.getTimeStamp() - ids[i].getStatus()[TIMESTAMP_INDEX];
        if (diff >  Constants.REFRESH_STATUS_INTERVAL) {
          continue;
        }
        count++;
      }
      
      return count;
    },
    
    /*private*/ refreshStatus: function() {
      this.lastTimestamp = Helpers.getTimeStamp()+this.foolOffset;
      var myValues = [this.lastTimestamp,this.frameName,this.host,Constants.BUILD,Constants.PAGE_PROTOCOL,this.blobId];
      
      this.manager.writeSharedStatus(this.shareName,this.id,myValues);
    },
    /*private*/ refreshStatusThread: function() {
      if (this.preClean) {
        sharingLogger$5.logDebug(LoggerManager.resolve(846));
        
        //cleanedCookies is true if the onbeforeunload was executed but the onunload didn't yet 
        //(as we passed the unloaded check)
        //in this case we avoid one refresh, if in 1 second the onunload doesn't execute than 
        //we probably got a false positive onbeforeunload so we can restart refreshing the cookies
        this.preClean = false;
        return;
        //in any case it's not a huge problem to leave cookies as multiple control on the validity of a cookie are performed
      }
      
      var foundFlag = false;
      
      if (this.suicideNotification) { //we may not care about suicide
        sharingLogger$5.logDebug(LoggerManager.resolve(847),this);
        var engines = this.manager.readIds(this.shareName);
        if (!engines) {
         //where is my id? do not worry, we're going to rewrite it later
          sharingLogger$5.logDebug(LoggerManager.resolve(848),this);
        } else {
          sharingLogger$5.logDebug(LoggerManager.resolve(849),this.shareName);
          
          for (var i = 0; i < engines.length; i++) { 
            if (engines[i] == this.id) {
              continue;
            }
            
            var values = this.manager.readSharedStatus(this.shareName,engines[i]);
            if (!values) {
              sharingLogger$5.logDebug(LoggerManager.resolve(850),engines[i]);
              continue;
            }
            
            if (values[Constants.BUILD_INDEX] != Constants.BUILD || values[Constants.PROTOCOL_INDEX] != Constants.PAGE_PROTOCOL) {
              //not compatible, skip
              sharingLogger$5.logDebug(LoggerManager.resolve(851),engines[i]);
              continue;
            }
            
            //in Opera we've seen a case where 2 engines didn't suicide because they had quite always the same value
            //now we try to detect the case and to fool the test...
            if (values[TIMESTAMP_INDEX] == this.lastTimestamp) {
              this.foolOffset = Helpers.randomG(5);
            } 
  
            if (values[TIMESTAMP_INDEX] > this.lastTimestamp) {
              foundFlag |= this.newerEngineFound(engines[i],values[TIMESTAMP_INDEX]);
              
            } else if (this.newerEngines[engines[i]]) {
              delete (this.newerEngines[engines[i]]);
            }
            
          }
        }
      }
      
      if (!foundFlag) {
        sharingLogger$5.logDebug(LoggerManager.resolve(852));
        this.manager.addId(this.shareName, this.id);//just in case it disappeared
        this.refreshStatus();
      }
    },
    
    /*private*/ newerEngineFound: function(id,value) {
      sharingLogger$5.logDebug(LoggerManager.resolve(853), id + " with a newer status");

      if (this.newerEngines[id]) {
        if (this.newerEngines[id] != value && !this.dontDieFor[id]) {
          sharingLogger$5.logInfo(LoggerManager.resolve(854), this.id);
          this.executeSuicide();
        } else {
          return false;
        }
      }
      this.newerEngines[id] = value;
      return true;
    },

    /*private*/ executeSuicide: function() {
      this.clean();
      
      if (this.suicideNotification) {
        Executor.executeTask(this.suicideNotification);
      }
    },
    
    
    /*private*/ lightClean: function() {
      //remove my personal values
      
      this.manager.cleanSharedStatus(this.shareName,this.id);
      //remove me from the id list
      this.manager.removeId(this.shareName,this.id);
          
      this.preClean = true;
    },
    
    /*private*/ clean: function() {
      
      //Executor and IFrameHandler are resilient so we don't have to be
      sharingLogger$5.logInfo(LoggerManager.resolve(855),this);
      Executor.stopRepetitiveTask(this.thread);
      Executor.stopRepetitiveTask(this.startupThread);//works even if the task is not actually repetitive
      this.thread = null;
      this.startupThread = null;

      if (this.frameName != Constants.NULL_VALUE) {
        IFrameHandler.disposeFrame(this.frameName);
      } else if (this.blobId != Constants.NULL_VALUE) {
        SharedWorkerManager.removeWorker(this.blobId);
      }
      this.frameName = Constants.NULL_VALUE;
      this.blobId = Constants.NULL_VALUE;

      
      this.removeConnectionToServerFlag(this.currentServer);

      if (this.shareName) {
        Lightstreamer.removeSharableEngine(this.shareName, this.engine);
      }
      if (this.bridge) {
        Lightstreamer.cleanGlobal(this.id,Constants.FRAME_BRIDGE_GLOBAL);
        Lightstreamer.cleanGlobal(this.id,Constants.WORKER_BRIDGE_GLOBAL);
      }
      this.bridge = null;

      this.lightClean();
    },
    
    /*internal*/ unloadEvent: function() {
      this.clean();
    },
    
    /*internal*/ preUnloadEvent: function() {
      this.lightClean();
    },
    
    /*public*/ dispose: function() {
      this.clean();

      EnvironmentStatus.removeBeforeUnloadHandler(this);
      EnvironmentStatus.removeUnloadHandler(this);
      
      SharedCollector.stop(this.forceCookies);
    }
    
  };
  
  
  SharedStatus.prototype["unloadEvent"] = SharedStatus.prototype.unloadEvent;
  SharedStatus.prototype["preUnloadEvent"] = SharedStatus.prototype.preUnloadEvent;

var proxedId = 0;

  //special message types
  var RESPONSE = "RESPONSE";

  /**
   *
   * @param {CommunicationInterface} sender
   * @constructor
   */
  function CrossTabChannel(receiver,bridge,target) {
    this.receiver = receiver;
    this.target = target;

    this.id = proxedId++;
    this.buffer = [];
    this.ready = false;
    this.pendingRequests = {};
    this.nextMessageId = 0;

    if (bridge) {
      this.setBridge(bridge);
    }
  }



  CrossTabChannel.prototype = {

    setBridge: function(bridge) {
      this.bridge = bridge;
      bridge.addListener(this);
      if (bridge.isReady()) {
        this.onReady();
      }
    },

    dispose: function(preserveBridge) {
      if(this.bridge && !preserveBridge) {
        this.bridge.dispose();
      }
    },

    onListenStart: function() {
      if (this.bridge.isReady()) {
        this.onReady();
      }
    },

    onReady: function() {
      if (this.ready) {
        return;
      }

      this.ready = true;
      for (var i=0; i<this.buffer.length; i++) {
        var pending = this.buffer[i];

        var res = this.call(pending.method, pending.params,
            pending.expectResponse);

        if (pending.expectResponse) {
          pending.promised(res);
        }
      }

      this.buffer = [];
    },

    onMessage: function (message) {
      this._onMessage(message.sender,message.messageId,message.type,message.params);
    },
    _onMessage: function (sender,messageId,type,params) {

      if (type == RESPONSE) {
        //means the message is a response to a previous message somebody sent

        //messageId in this case is a local id (if it's not ours we can't have it)
        if (this.pendingRequests[messageId]) {
          //this.pendingRequests[messageId] is the resolve method of a Promise
          this.pendingRequests[messageId].ok(params[0]);
          delete(this.pendingRequests[messageId]);
        } //else we didn't care about the response or the message is for a different CrossTabChannel


      } else if (sender === this.target) {
        var resp = this.receiver[type].apply(this.receiver, params);

        if (typeof resp !== "undefined") {
          this.sendResponse(sender,messageId,resp);
        }

      } //else not for us
    },
    onMessageFail: function(target,messageId) {
      //messageId in this case is a local id (if it's not ours we can't have it)
      if (this.pendingRequests[messageId]) {
        //this.pendingRequests[messageId] is the resolve method of a Promise
        this.pendingRequests[messageId].no(Constants.PROMISE_FAILURE);
        delete(this.pendingRequests[messageId]);
      } //else we didn't care about the response or the message is for a different CrossTabChannel
    },


    sendResponse: function(sender,messageId,resp) {
      this.bridge.sendMessage(sender,RESPONSE,messageId,[resp]);
    },


    /**
     *
     * @param method
     * @param params
     * @return Promise
     */
    call: function(method,params,expectResponse,responseTimeout) {
      params = Utils.argumentsToArray(params);

      if (!this.ready) {
        var bufferized = {
          target: this.target,
          method: method,
          params: params,
          expectResponse: expectResponse,
          callTimeout: responseTimeout
        };

        this.buffer.push(bufferized);

        if (expectResponse) {
          return new /*SyncPromise*/Promise(function (resolve) {
            bufferized.promised = resolve;
          });
        }

      } else {
        var messageId = this.id+"_"+(this.nextMessageId++);
        this.bridge.sendMessage(this.target,method,messageId,params);

        if (expectResponse) {
          var that = this;
          var res = new /*SyncPromise*/Promise(function(resolve,reject) {
            that.pendingRequests[messageId] = {
              ok: resolve,
              no: reject
            };

            if (responseTimeout) {
              Executor.addTimedTask(function () {
                if (that.pendingRequests[messageId]) {
                  reject(Constants.PROMISE_TIMEOUT);
                }
              },responseTimeout);
            }

          });



          return res;
        }


      }
    }

  };

  CrossTabChannel.prototype["onReady"] = CrossTabChannel.prototype.onReady;
  CrossTabChannel.prototype["onMessageFail"] = CrossTabChannel.prototype.onMessageFail;
  CrossTabChannel.prototype["onMessage"] = CrossTabChannel.prototype.onMessage;
  CrossTabChannel.prototype["onListenStart"] = CrossTabChannel.prototype.onListenStart;

/**
   * can be used as mixin, just call initChannel in your constructor
   * @constructor
   */
  function ChanneledHandler(bridge,remoteId) {
    this.initChannel(bridge,remoteId);
  }

  ChanneledHandler.createCaller = function(name,definition) {
    if (definition.addSessionPhase) {
      return function() {
        return this.channel.call(name,[this.sessionPhase].concat(Utils.argumentsToArray(arguments)),definition.wantsResponse,definition.responseTimeout);
      }
    } else {
      return function() {
        return this.channel.call(name,arguments,definition.wantsResponse,definition.responseTimeout);
      }
    }
  };

  ChanneledHandler.prototype = {
    initChannel: function(bridge,remoteId) {
      this.channel = new CrossTabChannel(this,bridge,remoteId);
    },
    terminateChannel: function(preserveBridge) {
      this.channel.dispose(preserveBridge);
    }
  };

var disposeName;
  for(var i$5 in  {dispose:true}) {
    disposeName=i$5;
  }

  function NewPushPageHandlerRemote(engine,bridge,pushPageId) {
    this._callSuperConstructor(NewPushPageHandlerRemote,[engine,pushPageId]);
    this.initChannel(bridge,pushPageId);
  }

  NewPushPageHandlerRemote.prototype = {
    dispose: function() {
      this._callSuperMethod(NewPushPageHandlerRemote,disposeName);
      this.terminateChannel(true); //the pushpage handler must not kill the channel as the channel can be used by others
      //future calls will get an exception that will cause an onPushPageLost event in the PushPage collection if remote
    }
  };

  var methods$2 = NewPushPageHandler.methods;
  for (var i$5 in methods$2) {
    NewPushPageHandlerRemote.prototype[i$5] = ChanneledHandler.createCaller(i$5,methods$2[i$5]);
  }

  Inheritance(NewPushPageHandlerRemote,NewPushPageHandler);
  Inheritance(NewPushPageHandlerRemote,ChanneledHandler,true);

function ChannelsHandlerMaster(engine,bridge) {
    this._callSuperConstructor(ChannelsHandlerMaster);
    this.bridge = bridge;
    this.engine = engine;

    this.bridge.addListener(this);
  }

  ChannelsHandlerMaster.prototype = {
    onRemote: function(id) {
      //yay a new pushpage!
      var pushPage = new NewPushPageHandlerRemote(this.engine,this.bridge,id);
      this.dispatchEvent("onNewPushPage",[id,pushPage]);
    },

    onMessageFail: function(target) {
      this.bridge.removeTarget(target);
      this.dispatchEvent("onPushPageLost",[target]);
    },

    dispose: function() {
      this.bridge.dispose();
    }

  };

  ChannelsHandlerMaster.prototype["onRemote"] = ChannelsHandlerMaster.prototype.onRemote;
  ChannelsHandlerMaster.prototype["onMessageFail"] = ChannelsHandlerMaster.prototype.onMessageFail;

  Inheritance(ChannelsHandlerMaster,EventDispatcher);

var Policies = {
    ATTACH: "ATTACH",
    FAST: "ATTACH:FAST", //sharePolicyOnFound ?ATTACH:FAST? means that when searching for an engine it will behave as if enableFasterSeekEngine(true) was called on client 5
    IGNORE: "IGNORE", //sharePolicyOnFound ?IGNORE? means that the client will behave using the sharePolicyOnNotFound policy even if it finds an engine.
    ABORT: "ABORT",
    CREATE: "CREATE",
    WAIT: "WAIT"
  };

var disposeName$1;
  for(var i$6 in  {dispose:true}) {
    disposeName$1=i$6;
  }
  
  var sharingLogger$6 = LoggerManager.getLoggerProxy(Constants.SHARING);

  var READY_TIMEOUT = 2000;

  var NewEngineHandlerRemote = function (client,bridge) {
    this._callSuperConstructor(NewEngineHandlerRemote,[client]);
    this.engineType = "remote";
    this.initChannel(bridge,Constants.MASTER);
    this.verifyBridge(bridge);
  };

  NewEngineHandlerRemote.prototype = {
    verifyBridge: function(bridge) {

      //if the worker is dead we get a new worker and thus become the master, that's bad
      //so we have to get back on searching
      var that = this;
      if (bridge.isReady()) {
        this.remoteReady(bridge);
      } else {
        bridge.addListener({
          "onReady": function () {
            that.remoteReady(bridge);
          }
        });
        //add a timeout to verify the  bridge is working
        Executor.addTimedTask(this.verifyRemoteReady, READY_TIMEOUT, this);
      }

    },

    verifyRemoteReady:function(bridge) {
      if (!bridge.isReady()) {
        READY_TIMEOUT*=2; //XXX rethink the increase logic of this timeout
        this.onEngineDeath();
      }
    },

    remoteReady:function(bridge) {
      if (bridge.getBridgeId() == Constants.MASTER) {
        sharingLogger$6.logInfo(LoggerManager.resolve(856), this.engineId + " is a master but should be a slave: engine must die");
        /*
         * This type of error happens in (some) installations of Firefox 57+.
         * The scenario is roughly as follows.
         * Two pages with the same host name and protocol are open. The first page creates a shared worker.
         * The second page tries to connect to the shared worker (whose id is found on localStorage) but
         * the effect is the creation of a new shared worker. When the second client detects that it should be a slave
         * but it is a master, it commits suicide.
         * 
         * To avoid endless attempts, the client must ignore other engines.
         */
        Executor.addTimedTask(this.onEngineDeath, 0, this, [false/*suiciding*/, true/*noHopeToAttachToAnotherEngine*/]);
      }
    },

    dispose: function() {
      this._callSuperMethod(NewEngineHandlerRemote,disposeName$1);
      this.terminateChannel();
      //future calls will get an exception that will cause an onPushPageLost event in the PushPage collection if remote
    }
  };

  var methods$3 = NewEngineHandler.methods;
  for (var i$6 in methods$3) {
    NewEngineHandlerRemote.prototype[i$6] = ChanneledHandler.createCaller(i$6,methods$3[i$6]);
  }

  Inheritance(NewEngineHandlerRemote,NewEngineHandler);
  Inheritance(NewEngineHandlerRemote,ChanneledHandler,true);

var PageProxy = /*@__PURE__*/(function() {
  var trySym = 0;
  var foundWins = 0;
  var messageSeen = false;
  
  var neverOpenAgain = false; 
  
  var sharingLogger = LoggerManager.getLoggerProxy(Constants.SHARING);
  
  var linkedWindows = [];
  
  /*
   * Composes the code to be executed in the frame found by name.
   * It works both for the search of an engine and for a pushpage.
   * For various bugs in all browsers, it is not possible to write
   * an ordinary function and extract the source.
   * If the page name does not match the one given as
   * parameter, we will try to close it.
   *
   * @param {String} _name name of the page
   * @param {String} trash page name to be assigned in case it should be closed
   *
   * @return {String} the call to be made
   */
  function makeCall(_name, trash) {
    var funBase = function(_name, trash) {
      if (window.name == _name) { 
        if (window == top && ! (window["Lightstreamer"] && window["Lightstreamer"].wstatus)) {
          window.name = trash;
          window.close();
        }
      }
    };

    var funName = "callFun";  //so we are sure that
    //will be obfuscated or not evenly
    return "var " + funName + " = " + funBase.toString() + "; " + funName + "('" + _name + "', '" + trash + "');";

  }
  
  function closeTrashPopup (pageFound, pageName, trashName)  {
    // we must first verify that we are not caught in the Opera 7 bug
    if (pageFound.name != pageName && pageFound.name != trashName) {
      return;
    }
    pageFound.close();
  }
    
  /*
   * @return {boolean} false if the window open was PROBABLY not executed at all
   * returns null (at least on FX) if the open was blocked by a popup blocker
   * returns a value if it was successfull or if it opened a popup  
   */
  function windowOpen(_url, pageName) {
    var result = null;
    sharingLogger.logDebug(LoggerManager.resolve(857));
    if (neverOpenAgain) {
      return false;
    }
    try {
      result = openWindowExe(_url, pageName);
    } catch(_e) {
      sharingLogger.logDebug(LoggerManager.resolve(858),_e);
      return false;
    }
    if (result) {
      try {
        foundWins++; //???
      } catch(unexpected) {
        //the window object went out from the scope chain
        //ensure that other popups are not open by setting the
        //neverOpenAgain flag
        neverOpenAgain = true;
      }
    } 
    return result;
  }

  function openNortonWindowExe(_url, pageName) {
    var tryFlag = true;
    if ((foundWins - trySym) < -5) {
      // I tried at least 10 times and had 10 null pointers
      // I believe this browser is not able to run the window.open
      // if it has been copied to another variable
      tryFlag = false;
    }
    if (window["SymRealWinOpen"] && tryFlag) {
      trySym++;

      // this method could go into exception.
      return window["SymRealWinOpen"](_url, pageName, "height=100,width=100", true);
      
    } else if (!messageSeen) {
      messageSeen = true;
      
      sharingLogger.logWarn(LoggerManager.resolve(859));     
    } 
    
    trySym = 0; //why do we do this? This will generate more window.open
    return null; //return false?
  }
    
  function openWindowExe(_url, pageName)  {
    try {
      if (window["SymError"]) {
        return openNortonWindowExe(_url, pageName);
      } else {
        return window.open(_url, pageName, "height=100,width=100", true);
      }
    } catch(e) {
      return null;
    }
  }
  
  /*
   * Object containing the pointer to an external page.
   * It is managed as an object to allow the methods of
   * search to deal with exceptions more easily.
   *
   * @constructor
   * @params {window} page the page to which to build the proxy.
   * it can be declared initially null and searched for later
   */
  var PageProxy = function() {
    this.refPage = null;
  };

  PageProxy.prototype = {
    
    /*public*/ getWindowRef: function() {
      return this.refPage;
    },

    
    /*
     * Get the pointer to a page, searching for it by name.
     * To be sure it's a framework page,
     * verify that there is support for logging.
     * @param {String} pageName page name
     * @param {boolean} get_parent links with the parent of the page pageName
     * @return {boolean} true if a window.open was performed, false otherwise
     */
    linkLSPage: function(pageName, get_parent) {
      var pageFound = null;
      try {
        if (linkedWindows[pageName]) {
          pageFound = linkedWindows[pageName];
        }
      } catch(_e) {
        pageFound = null;
      }
      
      if (pageFound) {
        delete(linkedWindows[pageName]); //will be restored later on if we pass the first tests
        if(this.linkedLSPageVerify(pageFound,pageName,get_parent)) {
          return true;
        }
      }
      
      var trashName = pageName + "__TRASH";
      var cwCall = makeCall(pageName, trashName);
      var safeScript = "eval(" + '"' + cwCall + "; " + '"' + ")";
      // without eval, IE 5.01 and earlier sometimes do not handle the URL (we do not support anymore IE <6)
      
      pageFound = windowOpen("javascript:" + safeScript, pageName);
      
      if (pageFound === false) {
        sharingLogger.logDebug(LoggerManager.resolve(860));
        return false;
      } else if (!pageFound) {
        //THIS IS PROBABLY A BLOCKED POPUP. Safari and Firefox pass from here, btw I can't find where safari notifies the issue to the user.
        sharingLogger.logDebug(LoggerManager.resolve(861));
        return true;
      }
   
      sharingLogger.logDebug(LoggerManager.resolve(862));
      this.linkedLSPageVerify(pageFound,pageName,get_parent);
      return true;
      
    },
    
    /*private*/ linkedLSPageVerify: function(pageFound,pageName,get_parent) {
            
      try {
      
        sharingLogger.logDebug(LoggerManager.resolve(863));
        if (pageFound.closed) {
          sharingLogger.logDebug(LoggerManager.resolve(864));
          return false;
        }
        
        var searchedPage = pageFound;
        
        if (get_parent) {
          if (pageFound == pageFound.top && !pageFound["Lightstreamer"]) {
            sharingLogger.logDebug(LoggerManager.resolve(865));
            //THIS IS PROBABLY A SHOWN POPUP CASE. Chrome passes from here but blocks the popup 

            // probably the engine is not there and a popup has been opened;
            // the popup should close by itself, but let's try to close it
            // also from here
            var trashName = pageName + "__TRASH";
            try {
              closeTrashPopup(pageFound, pageName, trashName);
            } catch (_e) {
              sharingLogger.logDebug(LoggerManager.resolve(866),_e);
            }
            return false;
          }
          
          searchedPage = pageFound.parent;
          
          if (searchedPage == null) {
            sharingLogger.logDebug(LoggerManager.resolve(867));
            //on Opera THIS IS PROBABLY A BLOCKED POPUP CASE. We do not special-log this as opera always passes from here (link through win.open does not work)
            return false;
          }
        }
        
        if (!searchedPage["Lightstreamer"]) {
          sharingLogger.logDebug(LoggerManager.resolve(868));
          return false;
        }
        
        if (!searchedPage["Lightstreamer"].wstatus) {
          sharingLogger.logDebug(LoggerManager.resolve(869));
          return false;
        }
        
        sharingLogger.logDebug(LoggerManager.resolve(870));
        this.refPage = searchedPage;
        this.pageName = pageName;
        linkedWindows[pageName] = pageFound;
        
      } catch(_e) {
        sharingLogger.logDebug(LoggerManager.resolve(871),_e);
        return false;
      }
      return true;
    }
    
  };

  
  
  return PageProxy;
})();

var blackList = {};

  function RemotePage(frameName) {
    this.frameName = frameName;
  }

  RemotePage.prototype = {

    getRemotePageReference: function() {
      if (blackList[this.frameName]) {
        return Promise.resolve(null);
      } else {
        var pageProxy = new PageProxy();

        var windowOpened = pageProxy.linkLSPage(this.frameName, true);
        if (windowOpened) {
          var ref = pageProxy.getWindowRef();
          if (ref == null) {
            blackList[this.frameName] = true;
            return Promise.resolve(null);
          } else {
            return Promise.resolve(ref);
          }
        } else {
          return Promise.resolve(null);
        }
      }
    }

/*
    if(this.openedFrames[values[Constants.FRAME_NAME_INDEX]]) {
      sharingLogger.logDebug(LoggerManager.resolve(872),iEngineName);
      //we've already done a window.open on this engine
      continue;
    }
    */
  };

var sharingLogger$7 = LoggerManager.getLoggerProxy(Constants.SHARING);

  var WAIT_ENGINE_TIMEOUT = 1000;

  var TYPE_DIRECT = 1;
  var TYPE_REMOTE_DIRECT = 2;
  var TYPE_WORKER = 3;

  function cleanEngineCookies(id,appName) {
    var manger = SharedStatus.getManager();

    manger.cleanSharedStatus(appName,id);
    manger.removeId(appName,id);
  }

  function Search(client,shareName,policyOnFound,policyOnNotFound,localOnly,shareRef,aloneTimeout) {
    this.shareName = shareName;
    
    this.localOnly = localOnly;
    this.policyOnFound = policyOnFound; //NOTE if shared workers are used we always do it fast
    this.policyOnNotFound = policyOnNotFound;
    this.shareRef = shareRef;

    this.getNextPhase = 0;

    this.checkedEngines = {}; //this is used to prevent getEngineValues from returning twice the same engine

    this.searchPhase = 0;

    this.client = client;
    this.resolved = false;

    this.aloneTimeout = aloneTimeout || Constants.ALONE_CHECK_TIMEOUT;

    this.ok = null;
    this.no = null;
    
    this.noHope = false;
  }

  Search.activeSearches = 0;

  Search.prototype = {

    stop: function() {
      sharingLogger$7.logInfo(LoggerManager.resolve(873));
      this.searchPhase++;
      if (!this.resolved){
        this._callNo();
      }
    },
    find: function(alreadyUsed) {
      this.checkedEngines = alreadyUsed || {};
      var promise = this._makePromise();
      this._find(this.searchPhase,false);
      return promise;
    },
    getCheckedEngineList: function() {
      return this.checkedEngines;
    },

    _callOk: function(value) {
      this.resolved = true;
      // promise resolve (see _makePromise)
      this.ok(value);
      this.stop();
    },
    _callNo: function() {
      this.resolved = true;
      // promise reject (see _makePromise)
      this.no();
      this.stop();
    },
    
    _noHope: function() {
      this.noHope = true;
    },

    _onEngineNotFound: function() {

      if (this.policyOnNotFound == Policies.CREATE) {
        sharingLogger$7.logInfo(LoggerManager.resolve(874));
        this._callOk(null);

      } else if (this.policyOnNotFound == Policies.WAIT) {
        sharingLogger$7.logInfo(LoggerManager.resolve(875),WAIT_ENGINE_TIMEOUT);
        Executor.addTimedTask(this._find,WAIT_ENGINE_TIMEOUT,this,[this.searchPhase, false]);

      } else {
        //FAIL
        sharingLogger$7.logInfo(LoggerManager.resolve(876));
        this._callNo();
      }

    },

    _onEngineFound: function(engineType,ref,engineId) {
      if (this.policyOnFound == Policies.ABORT) {
        sharingLogger$7.logInfo(LoggerManager.resolve(877));
        this._callNo();

      } else if (this.policyOnFound != Policies.IGNORE) {
        //ATTACH or ATTACH:FAST
        sharingLogger$7.logInfo(LoggerManager.resolve(878), engineId);
        var eh;
        if (engineType == TYPE_DIRECT) {
          //ref is the LightstreamerEngine
          eh = new NewEngineHandler(this.client);
          ref.bindLocalClient(eh);

        } else {

          var bridge;
          if (engineType == TYPE_REMOTE_DIRECT) {
            //ref is the remote bridge
            bridge = new CrossPageBridge();

          } else /*TYPE_WORKER*/ {
            //ref is the worker blob url
            bridge = new SharedWorkerBridge();
          }
          var promise = bridge.start(ref);
          eh = new NewEngineHandlerRemote(this.client,bridge);
          promise['then'](
                  null,
                  function() { /* error handler */
                      sharingLogger$7.logInfo(LoggerManager.resolve(879), engineId + " must die");
                      /*
                       * This type of error happens in the following scenario (for example):
                       * - a page is open in HTTP
                       * - another page is open in HTTPS
                       * - both pages have an iframe open in HTTPS containing a LS client connected in HTTPS.
                       * 
                       * Every time a client tries to connect to the shared worker of the other page, 
                       * it gets this fatal error (no communication is possible between the two pages).
                       * 
                       * To avoid endless attempts, the client must ignore other engines.
                       */
                      eh.onEngineDeath(false/*suicided*/, true/*noHopeToAttachToAnotherEngine*/);
                  });
        }

        eh.setEngineId(engineId);
        this._callOk(eh);

      } else {
        //IGNORE
        //what do I need this policy for? o_O
        sharingLogger$7.logInfo(LoggerManager.resolve(880));
        this.stop();
      }


    },



    _find: function(phase,targeted) {
      if (this.searchPhase != phase) {
        return;
      }
      phase =  ++this.searchPhase;


      sharingLogger$7.logDebug(LoggerManager.resolve(881));

      /* Local sharing was disabled because it didn't work well
      var lsEngine = Global.getSharableEngine(this.shareName);
      if (lsEngine) {
        sharingLogger.logDebug(LoggerManager.resolve(882));
        //engine is on this window, we use it
        this._onEngineFound(TYPE_DIRECT, lsEngine, lsEngine.getEngineId());

      } else
      */ 
      if (this.localOnly) {
        sharingLogger$7.logDebug(LoggerManager.resolve(883));
        this._onEngineNotFound();

      } else if (this.shareRef) {
        sharingLogger$7.logDebug(LoggerManager.resolve(884));
        try {
          var remoteGlobal = this.shareRef["Lightstreamer"];
          var remoteEngine = remoteGlobal.getSharableEngine(this.shareName);
          
          sharingLogger$7.logDebug(LoggerManager.resolve(885), remoteEngine + " (" + this.shareName + ").");
          
          if (remoteEngine != null) {
            var remoteEngineId = remoteEngine.getEngineId();

            if (remoteGlobal.hasGlobal(remoteEngineId, Constants.WORKER_BRIDGE_GLOBAL)) {
              var worker = remoteGlobal.getGlobal(remoteEngineId, Constants.WORKER_BRIDGE_GLOBAL);
              this._onEngineFound(TYPE_WORKER, worker, remoteEngineId);
              return;

            } else if (remoteGlobal.hasGlobal(remoteEngineId, Constants.FRAME_BRIDGE_GLOBAL)) {
              var bridge = remoteGlobal.getGlobal(remoteEngineId, Constants.FRAME_BRIDGE_GLOBAL);
              this._onEngineFound(TYPE_REMOTE_DIRECT, bridge, remoteEngineId);
              return;
            }
          } else {
            if (targeted == true) {
              this._noHope();
            }
          }
        } catch(e) {
          sharingLogger$7.logDebug(LoggerManager.resolve(886), e);
        }

        this.shareRef = null;
        this._find(this.searchPhase,false);


      } else {

        sharingLogger$7.logDebug(LoggerManager.resolve(887));

        var that = this;

        var np = ++this.getNextPhase;
        Executor.addTimedTask(function() {
          if (np == that.getNextPhase) {
            that.getNextPhase++;
          }
        },Constants.STOP_SEARCH_TIMEOUT);

        Search.activeSearches++;
        this._getNextEngineValues(this.getNextPhase)["then"](function(obj) {
          Search.activeSearches--;
          if (phase != that.searchPhase) {
            return;
          }

          sharingLogger$7.logDebug(LoggerManager.resolve(888));

          if (obj == null) {
            sharingLogger$7.logDebug(LoggerManager.resolve(889));
            that._onEngineNotFound();
          } else {

            sharingLogger$7.logInfo(LoggerManager.resolve(890), obj.id);

            var values = obj.values;
            var blobId = values[Constants.BLOB_INDEX];
            var frameName = values[Constants.FRAME_NAME_INDEX];
            if (blobId !== Constants.NULL_VALUE) {
              try {
                sharingLogger$7.logDebug(LoggerManager.resolve(891), obj.id + " shares through shared worker", blobId);
                that._onEngineFound(TYPE_WORKER, blobId, obj.id);
              } catch(e) {
                //no luck with that worker, blacklist it, try again
                that._find(phase,false);
              }
            } else if (frameName !== Constants.NULL_VALUE) {
              sharingLogger$7.logDebug(LoggerManager.resolve(892), obj.id + " shares through direct communication", frameName);
              var remotePage = new RemotePage(frameName);
              var remoteWindow = remotePage.getRemotePageReference();

              if (remoteWindow != null) {
                
                //reference is good, try to find an engine in it
                remoteWindow["then"](function(winRef) {
                  that.shareRef = winRef;
                  if (!winRef) {
                      that._noHope();
                    } 
                  
                    that._find(phase, true);
                  
                });
              } else {
                //we were unable to get a hold on the page, ignore this engine and try
                //again
                that._find(phase,false);
              }

            } else {
              //the found values are invalid, ignore this engine and keep going
              sharingLogger$7.logInfo(LoggerManager.resolve(893),values);
              that._find(phase,false);
            }
          }


        });
      }
    },

    _makePromise: function() {
      var that = this;
      return new Promise(function(ok,no) {
        that.ok = ok;
        that.no = no;
      });
    },

    _getNextEngineValues: function(ph,prevCallData) {
      if (this.getNextPhase != ph) {
        return Promise.resolve(null);
      }
      var that = this;

      var standardDelay = Constants.REFRESH_STATUS_INTERVAL;
      var slowDelay = Constants.REFRESH_STATUS_INTERVAL+Constants.REFRESH_STATUS_INTERVAL_TOLERANCE;
      var sharedManager = SharedStatus.getManager();

      return new Promise(function(endCall) {
        if (prevCallData) {
          for (var prev in prevCallData) {
            //these are the engines that were valid during the previous check, let's see if they are good to be used
            var values = sharedManager.readSharedStatus(that.shareName, prev);
            if (values && values[Constants.TIMESTAMP_INDEX] != prevCallData[prev]) {
              //promoted! let's attach to it
              that.checkedEngines[prev] = true;
              endCall({
                id: prev,
                values:values
              });
              return;
            }
          }
        }
        var newCallData = {};


        var engines = sharedManager.readIds(that.shareName);
        if (engines) {

          var somethingGood = false;
          for (var i=0; i<engines.length; i++) {
            if (that.checkedEngines[engines[i]]) {
              continue;
            }

            var values = sharedManager.readSharedStatus(that.shareName,engines[i]);
            if (!values  || values.length < 5) {
              cleanEngineCookies(engines[i],that.shareName);
              sharingLogger$7.logDebug(LoggerManager.resolve(894),engines[i]);
              continue;
            }

            if (values[Constants.BUILD_INDEX] != Constants.BUILD || values[Constants.PROTOCOL_INDEX] != Constants.PAGE_PROTOCOL) {
              //not compatible, skip
              sharingLogger$7.logDebug(LoggerManager.resolve(895),values);
              continue;
            }


            var ts = Helpers.getTimeStamp();
            var engineTime = parseInt(values[Constants.TIMESTAMP_INDEX]);
            var diff = ts -engineTime;

            var fastLink = values[Constants.BLOB_INDEX] != Constants.NULL_VALUE || that.policyOnFound == Policies.FAST;
            var maxDiff = fastLink ?  standardDelay : slowDelay;

            if (diff <= maxDiff) {
              //good value

              if (fastLink) {
                //want it fast, solve now!
                that.checkedEngines[engines[i]] = true;
                endCall({
                  id: engines[i],
                  values:values
                });
                return;

              } else {
                //first time we got a good value from this engine, save it and try again
                somethingGood = true;
                newCallData[engines[i]] = engineTime;
              }
            } else {
              //this value is old
              if (fastLink && diff <= slowDelay) {
                //this was a fast link, let's try treat it as a slow link
                somethingGood = true;
                newCallData[engines[i]] = engineTime;

              } else if (diff > 60000) {
                sharingLogger$7.logInfo(LoggerManager.resolve(896));
                cleanEngineCookies(engines[i],that.shareName);
                //this engine is dead, go on
                continue;

              }//else this is really old, do not consider it

            }
             //we already returned this but we got back here, thus it wasn't good enough
          }

        }

        if (somethingGood) {
          //we have found a valid engine but we have to wait and check again before trying to attach to it
          sharingLogger$7.logDebug(LoggerManager.resolve(897));
          Executor.addTimedTask(function() {
            that._getNextEngineValues(ph,newCallData)["then"](function(obj) {
              endCall(obj);
            });
          },Constants.REFRESH_STATUS_INTERVAL);

        } else if (prevCallData) {
          sharingLogger$7.logDebug(LoggerManager.resolve(898));
          endCall(null);
        } else {
          //first call got no engine, wait a bit and try again, just in case
          sharingLogger$7.logDebug(LoggerManager.resolve(899),that.aloneTimeout);
          Executor.addTimedTask(function() {
            that._getNextEngineValues(ph,{})["then"](function(obj) {
              endCall(obj);
            });
          },that.aloneTimeout);
        }
      });
    }


  };

  Search.failSearch = {
    stop: function(){},
    find: function() {
      return Promise.resolve(null);
    },
    getCheckedEngineList: function() {
      return {};
    }
  };
  Search.abortSearch = {
    stop: function(){},
    find: function() {
      return Promise.reject(null);
    },
    getCheckedEngineList: function() {
      return {};
    }
  };

var ConnectionSharing = /*@__PURE__*/(function() {
  var alpha_numeric = new RegExp("^[a-zA-Z0-9]*$");

  var foundPolicyCheck = {};
  foundPolicyCheck[Policies.ATTACH] = true;
  foundPolicyCheck[Policies.FAST] = true;
  foundPolicyCheck[Policies.IGNORE] = true;
  foundPolicyCheck[Policies.ABORT] = true;

  var notFoundPolicyCheck = {};
  notFoundPolicyCheck[Policies.CREATE] = true;
  notFoundPolicyCheck[Policies.ABORT] = true;
  notFoundPolicyCheck[Policies.WAIT] = true;

  var browserOnlyFoundPolicy = {};
  browserOnlyFoundPolicy[Policies.ATTACH] = true;
  browserOnlyFoundPolicy[Policies.FAST] = true;

  
  var NAME_IS_MANDATORY = "The share name is missing";
  var INVALID_NAME = "The given share name is not valid, use only alphanumeric characters";
  var WRONG_FOUND_POLICY = "sharePolicyOnFound must be one of: ATTACH, ATTACH:FAST, IGNORE, ABORT";
  var BROWSER_ONLY_POLICY = "ATTACH* can only be used if the LightstreamerClient is loaded inside a browser document";
  var WRONG_NOT_FOUND_POLICY = "sharePolicyOnNotFound must be one of: CREATE, ABORT, WAIT";
  
  var sharingLogger = LoggerManager.getLoggerProxy(Constants.SHARING);
  
    

  /**
   * Data object describing the sharing policies to be used by a LightstreamerClient
   * instance.
   * If the front-end includes more than one LightstreamerClient instance that
   * need to subscribe to the same server, it is advised that such instances
   * share the same connection to avoid saturating the client connection pool and
   * to open fewer sessions on the Lightstreamer Server.
   * Note that sharing is also possible between clients living in different
   * HTML pages, provided that they come from the same host. Note that Browser
   * capabilities and/or restrictions might prevent the sharing.
   * If sharing is enabled some Cookies or values on the Web Storage may
   * be used to exchange preliminary information across windows. The used keys
   * are prefixed with the "Lightstreamer_" string. Specifying true on the
   * preventCrossWindowShare parameter it is possible to prevent the
   * Cookies/Web Storage usage.
   * <BR>When different LightstreamerClient share the same connection, the one
   * actually holding the connection is also known as the current "Master" client.
   * Whenever possible, the Master LightstreamerClient should be hosted by a permanent page.
   * <BR>If the current Master, for any reason, disappears, then the connection to
   * Lightstreamer Server has to be reestablished: the election algorithm will
   * choose a new Master among the surviving LightstreamerClient instances and
   * will restore the same status that was in place before the previous Master
   * disappeared.
   * @constructor
   * 
   * @exports ConnectionSharing
   *
   * @param {String} shareName A unique alphanumeric name for the shared
   * connection. The name can be used by different LightstreamerClient in order to
   * recognize a compatible shared connection. Two LightstreamerClient instances
   * should use the same shareName for their enableSharing calls only if they are
   * going to configure the connection in the same way to connect to the same
   * server. Obviously, this includes the user credentials.
   *
   * @param {String} sharePolicyOnFound The action to be taken in case a client
   * sharing a connection using the same shareName and coming from the same
   * host is found in the browser (i.e. an active Master is found).
   * <BR>Can be one of the following:
   * <ul>
   * <li>"ATTACH" the client will try to become a Slave to the found Master.
   * <BR>Note that this policy can only be used on clients living inside a
   * browser window (i.e. no web workers nor non-browser environments).
   * Also the "ATTACH" policy might not work as expected if the involved clients
   * are instantiated in HTML pages loaded from the file system rather than
   * downloaded from a web server.
   * <BR>Note that it is an application responsibility to ensure that the
   * configuration of the Master client (the user credentials, for instance)
   * is consistent with the configuration required by the new instance of the
   * application front-end. In particular, note that the allocated bandwidth
   * would be shared among the two (or more) LightstreamerClient instances as
   * well.
   * <BR>Note that a connection, to be correctly shared between different
   * pages, has to be created in the &lt;BODY&gt; part of the page.
   * If this condition is not met, on some browsers, slave clients may
   * waste some extra time before being able to access the shared connection.
   * <BR>Sharing the connection also enables the so called "Master election"
   * feature. If the Master client is closed and other clients share the
   * connection with it, then one of the existing clients will be automatically
   * chosen as the new Master; this client will restore the status and
   * configuration of the previous Master client as it was before its death.
   * <BR>Note that there may be cases in which the library is not able to
   * determine whether a shared connection is currently active. Moreover,
   * there may be cases in which the library is not able to obtain a reference
   * to a currently active Master client.
   * </li>
   * <li>"ATTACH:FAST" same as "ATTACH" but the client will take some risks
   * of making a popup appear in order to speed up things.</li>
   * <li>"IGNORE" the found Master will be ignored and the sharePolicyOnNotFound
   * behavior will be applied.</li>
   * <li>"ABORT" the client will give up in the search of an active shared
   * connection and will neither try to create its own; the
   * {@link ClientListener#onShareAbort} event will be fired.
   * <BR>This policy may be useful in order to avoid that multiple streaming
   * connections are open (note that the browser may have a limited pool of
   * connections) or that multiple sessions for the same user are open.</li>
   * </ul>
   *
   * @param {String} sharePolicyOnNotFound The action to be taken in case a client
   * sharing a connection using the same shareName and coming from the same
   * host is not found in the browser (i.e. no active Master is found).
   * <BR>Can be one of the following:
   * <ul>
   * <li>"CREATE" the client will create its own connection.</li>
   * <li>"ABORT" the client will give up in the search of an active shared
   * connection and will neither try to create its own; the
   * {@link ClientListener#onShareAbort} event will be fired.</li>
   * <li>"WAIT" the client will wait until it finds a connection using the same
   * shareName and coming from the same host; then the sharePolicyOnFound
   * behavior will be applied.</li>
   * </ul>
   *
   * @throws {IllegalArgumentException} if the sharename is not specified or
   * is invalid.
   * @throws {IllegalArgumentException} if a non-existent policy was specified
   * or if the specified policy is not compatible with the current environment.
   *
   * @param {boolean} [preventCrossWindowShare] <b>[optional]</b> Flag to enable/disable the sharing
   * of a connection that belongs to a LightstreamerClient instances living
   * in a different html page.
   * <BR>Note that cross-window sharing might be impossible in certain circumstances.
   * <BR>If this flag is set to true, a Master living on a different window will
   * not trigger the sharePolicyOnFound policy; hence, only sharing with another
   * LightstreamerClient instance belonging to the same page will be possible.
   * <BR>The parameter is optional; if not supplied, the default value is false.
   *
   * @param {Window} [shareRef] If known, the reference to a Window containing a
   * shared connection can be passed. For the passed reference to be used, "ATTACH"
   * or "ATTACH:FAST" should be used as sharePolicyOnFound.
   *
   * @class Data object that contains information about if and how the connection
   * is shared between different {@link LightstreamerClient} instances possibly
   * living on different html pages.
   *
   * @see LightstreamerClient#enableSharing
   */
  var ConnectionSharing = function(shareName, sharePolicyOnFound, sharePolicyOnNotFound, preventCrossWindowShare, shareRef){


    if (!shareName) {
      throw new IllegalArgumentException(NAME_IS_MANDATORY);
    }

    if (!alpha_numeric.test(shareName)) {
      throw new IllegalArgumentException(INVALID_NAME);
    }

    if(!notFoundPolicyCheck[sharePolicyOnNotFound]) {
      throw new IllegalArgumentException(WRONG_NOT_FOUND_POLICY);
    }

    if(!foundPolicyCheck[sharePolicyOnFound]) {
      throw new IllegalArgumentException(WRONG_FOUND_POLICY);
    }

    this.preventCrossWindowShare = this.checkBool(preventCrossWindowShare,true);

    if (!Environment.isBrowserDocument()) {
      if (browserOnlyFoundPolicy[sharePolicyOnFound]) {
        throw new IllegalArgumentException(BROWSER_ONLY_POLICY);
      }
      this.preventCrossWindowShare = true;
    }

    if (Constants.PAGE_PROTOCOL == "file:" && !preventCrossWindowShare) {
      sharingLogger.logWarn(LoggerManager.resolve(900));
      preventCrossWindowShare = true;
    }

    /**
     * @private
     */
    this.checkEngineTimeout = 5000;
    /**
     * @private
     */
    this.disposing = false;
    /**
     * @private
     */
    this.preventCrossWindowShare = preventCrossWindowShare;
    /**
     * @private
     */
    this.shareName = shareName;
    /**
     * @private
     */
    this.sharePolicyOnFound = sharePolicyOnFound;
    /**
     * @private
     */
    this.sharePolicyOnNotFound = sharePolicyOnNotFound;
    /**
     * @private
     */
    this.shareRef = shareRef;
    /**
     * @private
     */
    this.aloneTimeout = null;
    /**
     * @private
     */
    this.noHopeToAttach = false;
        
    if (sharingLogger.isDebugLogEnabled()) {
        sharingLogger.logDebug(LoggerManager.resolve(901), 
                "shareName=" + this.shareName,
                "sharePolicyOnFound=" + this.sharePolicyOnFound,
                "sharePolicyOnNotFound=" + this.sharePolicyOnNotFound,
                "preventCrossWindowShare=" + this.preventCrossWindowShare,
                "shareRef=" + this.shareRef);
    }
  };
  
  ConnectionSharing.prototype = {
    /**
     * @private
     */
    createSharedStatus: function(engine,suicideTask,dontDieFor) {
      var shared = new SharedStatus(this.shareName,engine);

      if (this.preventCrossWindowShare) {
        shared.setupLocalSharing();
      } else {
        suicideTask = this.avoidSuicide() ? null : suicideTask;
        shared.setupCrossTabSharing(suicideTask,dontDieFor);

      }

      return shared;

    },

    /**
     * @private
     */
    createChannelsManager: function(engine,bridge) {
      return new ChannelsHandlerMaster(engine,bridge);
    },

    /**
     * @private
     */
    avoidSuicide: function() {
      return ((this.sharePolicyOnFound === Policies.IGNORE) || this.noHopeToAttach);
    },
    
    /**
     * @private
     */
    noHope: function() {
      this.noHopeToAttach = true;
    },
    
    /**
     * @private
     * @param noHopeToAttachToAnotherEngine if true, the client must not try to attach to another engine
     */
    convertToElectionVersion: function(aloneTimeout, noHopeToAttachToAnotherEngine) {
      var newSharePolicyOnFound = noHopeToAttachToAnotherEngine ? Policies.IGNORE : this.sharePolicyOnFound;
      var newSharePolicyOnNotFound = this.sharePolicyOnFound == Policies.ATTACH || this.sharePolicyOnFound == Policies.FAST ? Policies.CREATE : this.sharePolicyOnNotFound;
      var newSharing = new ConnectionSharing(this.shareName, newSharePolicyOnFound, newSharePolicyOnNotFound, this.preventCrossWindowShare, this.shareRef);
      newSharing.aloneTimeout = aloneTimeout;
      return newSharing;
    },

    /**
     * @private
     */
    findEngine: function(client) {

      if (this.sharePolicyOnFound == Policies.IGNORE && this.sharePolicyOnNotFound == Policies.CREATE) {
        //IGNORE && CREATE
        //create now
        sharingLogger.logInfo(LoggerManager.resolve(902));
        return Search.failSearch;

      } else if ((this.sharePolicyOnFound == Policies.IGNORE || this.sharePolicyOnFound == Policies.ABORT) && this.sharePolicyOnNotFound == Policies.ABORT) {
        //IGNORE && ABORT
        //fail now
        //ABORT && ABORT
        //fail now
        sharingLogger.logInfo(LoggerManager.resolve(903));
        return Search.abortSearch;

      } else {
        //IGNORE && WAIT
        //will search forever :O

        //ABORT && WAIT
        //will search until it aborts

        //ABORT && CREATE
        //search, if found abort otherwise create

        //ATTACH/ATTACH:FAST && CREATE
        //search, if found attach otherwise create

        //ATTACH/ATTACH:FAST && ABORT
        //search, if found attach otherwise abort

        //ATTACH/ATTACH:FAST && WAIT
        //will search until it finds one

        sharingLogger.logInfo(LoggerManager.resolve(904));
                
        return new Search(client,this.shareName,this.sharePolicyOnFound,this.sharePolicyOnNotFound,this.preventCrossWindowShare,this.shareRef,this.aloneTimeout);

      }

    },

    /**
     * Inquiry method that returns the share name configured in this instance.
     *
     * @return {String} The configured share name.
     *
     * @see LightstreamerClient#enableSharing
     */
    getShareName: function() {
      return this.shareName;
    },
    
    /**
     * Connection sharing is possible only if the environment supports SharedWorkers or the user requested a local sharing.
     */
    isPossible: function() {
        return this.preventCrossWindowShare || SharedWorkerManager.canGenerate();
    }


  };

  ConnectionSharing.prototype["getShareName"] = ConnectionSharing.prototype.getShareName;

  Inheritance(ConnectionSharing,Setter,true,true);
  return ConnectionSharing;
})();

function ls_sbc(client) {
    return {
      "enableSharing": function(n,p1,p2,c,s) {
        if (p1 == p2 && p1 == "ABORT") {
          client.enableSharing(null);
        } else {
          client.enableSharing(new ConnectionSharing(n, p1, p2, c, s));
        }
      },
      "isMaster": function() {
        return client.isMaster();
      }
    };
  }

var SecondLevelSubscriptionListener = function(parentTable,itemRef,relKey) {
    this.parentTable = parentTable;
    this.itemReference = itemRef;
    this.relKey = relKey;
  };
  
  SecondLevelSubscriptionListener.prototype = {
  
    /*onEndOfSnapshot: function(itemName, itemPos) {
      return;
    },
    
    onClearSnapshot: function(itemName, itemPos) {
      // not expected, as MERGE mode is implied here
      return;
    },
    
    onSubscription: function() {
      return;
    },
    
    onUnsubscription: function() {
      return;
    },*/  
      
    /*public*/ onItemLostUpdates: function(itemName, itemPos, lostUpdates) {
      if (!this.shouldDispatch()) {
        return;
      }
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(itemPos,1, "Unexpected item position");
    //>>excludeEnd("debugExclude");
      this.parentTable.sonLostUpdates(this.relKey,lostUpdates);
    },        
    
    /*public*/ onSubscriptionError: function(flag, msg) {
      if (!this.shouldDispatch()) {
        return;
      }
      
      this.parentTable.sonServerDeny(flag,msg,this.relKey);
    },
    
    /*public*/ onItemUpdate: function(updateInfo) {
      if (!this.shouldDispatch()) {
        return;
      }
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(updateInfo.getItemPos(),1, "Unexpected item position");
    //>>excludeEnd("debugExclude");
      var args = updateInfo.extract();
      this.parentTable.setSecondLevelSchemaSize(args.length - 2);
      
      //args contiene l'update per la sola sotto-tabella.
      //qui viene convertito in modo che rappresenti un update per 
      //la tabella padre
      args = this.convertMultiSonUpdate(args);

      //una volta convertito l'update la table di riferimento diventa il padre
      return this.parentTable.update(args,false,true);
      
    },
    
    /*private*/ shouldDispatch: function() {
      return this.parentTable.hasSubTable(this.itemReference,this.relKey);
    },
    
    /*private*/ convertMultiSonUpdate: function(args) {
      var fatherTable = this.parentTable;
      var _item = this.itemReference;
      
      var newArgs = [];
      newArgs[0] = fatherTable.getTableNumber();
      newArgs[1] = _item;
      newArgs.changedFields = [];
      
      var newLen = fatherTable.getFullSchemaSize()+2; //the combined length of the schemas + 2 (table number and item number)
      
      
      var y = 2; //y represents the 1-based position shifted by 1 (so field 1 is in position 2) of the underlying schema 
      //i represents the 1-based position shifted by 1 (so field 1 is in position 2) of the combined schema
      for (var i = 2; i < newLen; i++) {
        if (i == (fatherTable.getKeyPos() + 1)) {
          //l'item interessato risulta sempre come groupID
          
          newArgs[i] = this.relKey;
        } else if (i == (fatherTable.getCommandPos() + 1)) {
          // the command can only be an update
          newArgs[i] =  "UPDATE";
        } else if (i <= (fatherTable.getMainSchemaSize() + 1)) {
          // for fields that depend on the table in COMMAND, sign always unchanged (this update
          // is already prepared on item | key)
          newArgs[i] = Constants.UNCHANGED;
        } else {
          //fields from subtable
          newArgs[i] = args[y];

          //args has alrady been filled with real values!
          if (!args.unchangedMap[y]) {
          //if(args[y] != Constants.UNCHANGED) {
            newArgs.changedFields.push(i-1);
          } else {
            newArgs[i] = Constants.UNCHANGED;
          }
          
          y++;
          
        } 
      }
      return newArgs;
    }
    
  };
  
  //export these methods as they're called by the dispatcher
  SecondLevelSubscriptionListener.prototype["onSubscriptionError"] = SecondLevelSubscriptionListener.prototype.onSubscriptionError;
  SecondLevelSubscriptionListener.prototype["onItemUpdate"] = SecondLevelSubscriptionListener.prototype.onItemUpdate;
  SecondLevelSubscriptionListener.prototype["onItemLostUpdates"] = SecondLevelSubscriptionListener.prototype.onItemLostUpdates;

var actionsLogger$1 = LoggerManager.getLoggerProxy(Constants.ACTIONS);
   
   
   /**
    * Used by the client library to provide a value object to each call of the 
    * {@link SubscriptionListener#onItemUpdate} event.
    * @constructor
    * 
    * @exports ItemUpdate
    * @class Contains all the information related to an update of the field values 
    * for an item. It reports all the new values of the fields.
    * <BR>
    * <BR>
    * <B>COMMAND Subscription</B><BR>
    * If the involved Subscription is a COMMAND Subscription, then the values for 
    * the current update are meant as relative to the same key.
    * <BR>Moreover, if the involved Subscription has a two-level behavior enabled,
    * then each update may be associated with either a first-level or a second-level 
    * item. In this case, the reported fields are always the union of the first-level 
    * and second-level fields and each single update can only change either the 
    * first-level or the second-level fields (but for the "command" field, which is 
    * first-level and is always set to "UPDATE" upon a second-level update); note 
    * that the second-level field values are always null until the first second-level
    * update occurs).
    * When the two-level behavior is enabled, in all methods where a field name
    * has to be supplied, the following convention should be followed:
    * <ul>
    * <li>
    * The field name can always be used, both for the first-level and the second-level 
    * fields. In case of name conflict, the first-level field is meant. 
    * </li>
    * <li>
    * The field position can always be used; however, the field positions for 
    * the second-level fields start at the highest position of the first-level 
    * field list + 1. If a field schema had been specified for either first-level or 
    * second-level Subscriptions, then client-side knowledge of the first-level schema 
    * length would be required.
    * </li>
    * </ul>
    */
   var ItemUpdate = function() {
     
     // function(itemName, itemPos, fieldDescriptor, _isSnapshot, updateValues)
     
     //need to use arguments array to avoid documenting parameters in the public jsdocs
     /**
      * @private
      */
     this.itemPos = arguments[1];
     /**
      * @private
      */
     this.itemName = arguments[0];
     /**
      * @private
      */
     this._isSnapshot = arguments[3];
     /**
      * @private
      */
     this.fieldDescriptor = arguments[2];
     /**
      * @private
      */
     this.updateValues = arguments[4];
   };
   
   ItemUpdate.prototype = {
       
       /**  
        * Inquiry method that retrieves the name of the item to which this update 
        * pertains.
        * <BR>The name will be null if the related Subscription was initialized
        * using an "Item Group".
        * 
        * @return {String} the name of the item to which this update pertains.
        * 
        * @see Subscription#setItemGroup
        * @see Subscription#setItems
        */
       getItemName: function() {
         return this.itemName;
       },
       
       /**  
        * Inquiry method that retrieves the position in the "Item List" or "Item Group"
        * of the item to which this update pertains.
        * 
        * @return {Number} the 1-based position of the item to which this update pertains.
        * 
        * @see Subscription#setItemGroup
        * @see Subscription#setItems
        */
       getItemPos: function() {
         return this.itemPos;
       },
       
       /**
        * Inquiry method that gets the value for a specified field, as received 
        * from the Server with the current or previous update.
        * 
        * @throws {IllegalArgumentException} if the specified field is not
        * part of the Subscription.
        * 
        * @param {String} fieldNameOrPos The field name or the 1-based position of the field
        * within the "Field List" or "Field Schema".
        * 
        * @return {String} The value of the specified field; it can be null in the following 
        * cases:
        * <ul>
        * <li>a null value has been received from the Server, as null is a 
        * possible value for a field;</li>
        * <li>no value has been received for the field yet;</li>
        * <li>the item is subscribed to with the COMMAND mode and a DELETE command 
        * is received (only the fields used to carry key and command information 
        * are valued).</li>
        * </ul>
        * 
        * @see Subscription#setFieldSchema
        * @see Subscription#setFields
        */
       getValue: function(fieldNameOrPos) {
         var arrPos = this.toPos(fieldNameOrPos);
         var el = this.updateValues[arrPos];
         if (el && el.isUnchanged) {
           return el.value;
         }
         return el;
       },
       
       /**
        * Inquiry method that asks whether the value for a field has changed after 
        * the reception of the last update from the Server for an item.
        * If the Subscription mode is COMMAND then the change is meant as 
        * relative to the same key.
        * 
        * @param {String} fieldNameOrPos The field name or the 1-based position of the field
        * within the field list or field schema.
        * 
        * @return {boolean} Unless the Subscription mode is COMMAND, the return value is true 
        * in the following cases:
        * <ul>
        * <li>It is the first update for the item;</li>
        * <li>the new field value is different than the previous field value received 
        * for the item.</li>
        * </ul>
        * If the Subscription mode is COMMAND, the return value is true in the 
        * following cases:
        * <ul>
        * <li>it is the first update for the involved key value 
        * (i.e. the event carries an "ADD" command);</li>
        * <li>the new field value is different than the previous field value 
        * received for the item, relative to the same key value (the event 
        * must carry an "UPDATE" command);</li>
        * <li>the event carries a "DELETE" command (this applies to all fields 
        * other than the field used to carry key information).</li>
        * </ul>
        * In all other cases, the return value is false.
        * 
        * @throws {IllegalArgumentException} if the specified field is not
        * part of the Subscription.
        */
       isValueChanged: function(fieldNameOrPos) {
         var arrPos = this.toPos(fieldNameOrPos);
         return !this.updateValues.unchangedMap[arrPos];
       },
       
       /**
        * Inquiry method that asks whether the current update belongs to the 
        * item snapshot (which carries the current item state at the time of 
        * Subscription). Snapshot events are sent only if snapshot information
        * was requested for the items through {@link Subscription#setRequestedSnapshot}
        * and precede the real time events. 
        * Snapshot information take different forms in different subscription
        * modes and can be spanned across zero, one or several update events. 
        * In particular:
        * <ul>
        * <li>if the item is subscribed to with the RAW subscription mode, 
        * then no snapshot is sent by the Server;</li>
        * <li>if the item is subscribed to with the MERGE subscription mode, 
        * then the snapshot consists of exactly one event, carrying the current 
        * value for all fields;</li>
        * <li>if the item is subscribed to with the DISTINCT subscription mode, then
        * the snapshot consists of some of the most recent updates; these updates 
        * are as many as specified through 
        * {@link Subscription#setRequestedSnapshot}, unless fewer are available;</li>
        * <li>if the item is subscribed to with the COMMAND subscription mode, 
        * then the snapshot consists of an "ADD" event for each key that is 
        * currently present.</li>
        * </ul>
        * Note that, in case of two-level behavior, snapshot-related updates 
        * for both the first-level item (which is in COMMAND mode) and any 
        * second-level items (which are in MERGE mode) are qualified with this flag.
        * 
        * @return {boolean} true if the current update event belongs to the item snapshot; 
        * false otherwise.
        */
       isSnapshot: function() {
         return this._isSnapshot;
       },
       
       
       
       /**
        * Receives an iterator function and invokes it once per each field 
        * changed with the last server update. 
        * <BR>Note that if the Subscription mode of the involved Subscription is 
        * COMMAND, then changed fields are meant as relative to the previous update 
        * for the same key. On such tables if a DELETE command is received, all the 
        * fields, excluding the key field, will be iterated as changed, with null value. All of this 
        * is also true on tables that have the two-level behavior enabled, but in 
        * case of DELETE commands second-level fields will not be iterated. 
        * <BR>Note that the iterator is executed before this method returns.
        * 
        * @param {ItemUpdateChangedFieldCallback} iterator Function instance that will be called once 
        * per each field changed on the last update received from the server. 
        */
       forEachChangedField: function(iterator) {
         var ch = this.updateValues.changedFields;
         for (var i = 0; i < ch.length; i++) {
           var name = this.fieldDescriptor.getName(ch[i]); 
           var newV = this.updateValues[ch[i] + 1];
           
           try {
             iterator(name,ch[i],newV);
           } catch(_e) {
             actionsLogger$1.logErrorExc(_e,LoggerManager.resolve(905));
           }
           
         }
       },
       
       /**
        * Receives an iterator function and invokes it once per each field 
        * in the Subscription. 
        * <BR>Note that the iterator is executed before this method returns.
        * 
        * @param {ItemUpdateChangedFieldCallback} iterator Function instance that will be called once 
        * per each field in the Subscription. 
        */
       forEachField: function(iterator) {
         for (var i = 2; i < this.updateValues.length; i++) {
           
           var fieldPos = i-1;
           var name = this.fieldDescriptor.getName(fieldPos);
           var newV = this.updateValues[i];
           
           try {
             iterator(name,fieldPos,newV);
           } catch(_e) {
             actionsLogger$1.logErrorExc(_e,LoggerManager.resolve(906));
           }
           
         }
       },
       
       /**
        * @private
        */
       /*private*/ toPos: function(fieldNameOrPos) {
         var arrPos = (isNaN(fieldNameOrPos) ? this.fieldDescriptor.getPos(fieldNameOrPos) : fieldNameOrPos);
         
         if (arrPos == null) {
           throw new IllegalArgumentException( "the specified field does not exist");
           
         } else if (arrPos <= 0 || arrPos > this.fieldDescriptor.getFullSize()+1) {
           throw new IllegalArgumentException("the specified field position is out of bounds");
           
         }
         
         //need to shift because before the updates in the array we have table and item.
         //table is shifted by the fact that the array index starts from 0 not from 1, item is shifted via the +1
         return arrPos+1; 
         
       },
       /**
        * @private
        */
       /*internal*/ extract: function() {
         return this.updateValues;
       },
       
       //I need this method to keep compatibility with the flash bridge
       /**
        * @private
        */
       /*internal*/ getNumFields: function() {
         return this.updateValues.length - 2;
       },
       
       //I need this method to keep compatibility with the flash bridge
       /**
        * @private
        */
       /*internal*/ getFieldName: function(pos) {
         return this.fieldDescriptor.getName(pos);
       }
           
   };
   
   ItemUpdate.prototype["getItemName"] = ItemUpdate.prototype.getItemName;
   ItemUpdate.prototype["getItemPos"] = ItemUpdate.prototype.getItemPos;
   ItemUpdate.prototype["getValue"] = ItemUpdate.prototype.getValue;
   ItemUpdate.prototype["isValueChanged"] = ItemUpdate.prototype.isValueChanged;
   ItemUpdate.prototype["isSnapshot"] = ItemUpdate.prototype.isSnapshot;
   ItemUpdate.prototype["forEachChangedField"] = ItemUpdate.prototype.forEachChangedField;
   ItemUpdate.prototype["forEachField"] = ItemUpdate.prototype.forEachField;
   
   /**
    * Callback for {@link ItemUpdate#forEachChangedField} and {@link ItemUpdate#forEachField} 
    * @callback ItemUpdateChangedFieldCallback
    * @param {String} fieldName of the involved changed field. If the related Subscription was
    * initialized using a "Field Schema" it will be null.
    * @param {Number} fieldPos 1-based position of the field within
    * the "Field List" or "Field Schema".
    * @param {String} value the value for the field. See {@link ItemUpdate#getValue} for details.
    */

var Descriptor = function() {
    this.subDescriptor = null;
    this.len = 0;
  };
  
  Descriptor.prototype = {
      setSubDescriptor: function(subDescriptor) {
        this.subDescriptor = subDescriptor;
      },
      
      getSubDescriptor: function() {
        return this.subDescriptor;
      },
      
      getSize: function() {
        return this.len;
      },
      
      getFullSize: function() {
        if (this.subDescriptor) {
          return this.getSize() + this.subDescriptor.getSize();
        }
        return this.getSize();
      },
      
      setSize: function(len) {
        this.len = len;
      }
      
      /*abstract*/ /*getComposedString*/
      /*abstract*/ /*getPos*/
      /*abstract*/ /*getName*/
      /*abstract*/ /*isList*/
  };

function getReverseList(list) {
    var reverseList = {};
    for (var i=0; i<list.length; i++) {
      reverseList[list[i]] = i+1;
    }
    return reverseList;
  }
  
  var ListDescriptor = function(val) {
    this._callSuperConstructor(ListDescriptor); 
    this.list = val;
    this.reverseList = getReverseList(val);
    this.len = val.length;
  };
  
  ListDescriptor.prototype = {
      
      setSize: function(len) {
        return;
      },
      
      getComposedString: function() {
        return this.list.join(" ");
      },
      
      getPos: function(name) {
        if(this.reverseList[name]) {
          return this.reverseList[name];
        } else if (this.subDescriptor) {
          var fromSub = this.subDescriptor.getPos(name);
          return fromSub !== null ? fromSub+this.len : null;
        }
        return null;
      },
      
      getName: function(pos) {
        if (pos > this.len) {
          if (this.subDescriptor) {
            return this.subDescriptor.getName(pos-this.len);
          }
         
        } 
        return this.list[pos-1] || null;
        
      },
      
      getOriginal: function() {
        return this.list;
      },
      
      isList: function() {
          return true;
      }
      
  };
  
  Inheritance(ListDescriptor, Descriptor);

var NameDescriptor = function(val) {
    this._callSuperConstructor(NameDescriptor); 
    this.name = val;
  };
  
  NameDescriptor.prototype = {
      getComposedString: function() {
        return this.name;
      },
      
      getPos: function(name) {
        if (this.subDescriptor) {
          var fromSub = this.subDescriptor.getPos(name);
          return fromSub!==null ? fromSub+this.len : null;
        }
        return null;
      },
      
      getName: function(pos) {
        if (this.subDescriptor) {
          return this.subDescriptor.getName(pos-this.len);
        }
        return null;
      },
      
      getOriginal: function() {
        return this.name;
      },
      
      isList: function() {
          return false;
      }
  };
  
  Inheritance(NameDescriptor, Descriptor);

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Matrix = /*@__PURE__*/(function() { 
  /**
   * Creates a Matrix instance; if specified the matrix is initialized with the given object.
   * @constructor
   * 
   * @param {Object} inputMatrix the matrix to initialize this object with.
   * 
   * @exports Matrix
   * @class Very simple object-backed bi-dimensional Matrix implementation.
   */
  var Matrix = function(inputMatrix) {
    /**
     * @private
     */
    this.matrix = inputMatrix || {};
  };
  
  
  Matrix.prototype = {
    /**
     * Inserts an element in the matrix. If another element is already present in the
     * specified position it is overwritten.
     * 
     * @param insObject {Object} the element to be added.
     * @param row {String|Number} the row in the matrix where the element is placed.
     * @param column {String|Number} the column in the row where the element is placed.
     */ 
    insert: function(insObject,row,column) {
      if (!(row in this.matrix)) {
        this.matrix[row] = {};
      }
      this.matrix[row][column] = insObject;
    },
    
    /**
     * Gets the element at the specified position in the matrix. If the position is empty null is returned.
     * @param row {String|Number} the row in the matrix where the element is located.
     * @param column {String|Number} the column in the row where the element is located.
     * @returns {Object} the element at the specified location or null.
     */
    get: function(row,column) {
      if (row in this.matrix && column in this.matrix[row]) {
        return this.matrix[row][column];
      }
      return null;
    },
    /**
     * Removes the element at the specified position in the matrix.
     * @param row {String|Number} the row in the matrix where the element is located.
     * @param column {String|Number} the column in the row where the element is located.
     */
    del: function(row, column) {
      if (!row in this.matrix) {
        return;
      }
      if (column in this.matrix[row]) {
        delete this.matrix[row][column];
      }
        
      for (var i in this.matrix[row]) {
        //at least a cell in the row
        return;
      }
      //row is empty, get rid of it
      delete this.matrix[row];
    },
    /**
     * Inserts a full row in the matrix. If another row is already present in the
     * specified position it is overwritten.
     *  
     * @param insRow {Object} the row to be added.
     * @param row {String|Number} the row position.
     */
    insertRow: function(insRow, row) {
      this.matrix[row] = insRow;
    },
    /**
     * @deprecated
     */
    getRow: function(row) {
      if (row in this.matrix) {
        return this.matrix[row];
      }
      return null;
    },
    /**
     * Removes the row at the specified position in the matrix.
     * @param row {String|Number} the row position.
     */
    delRow: function(row) {
      if (row in this.matrix) {
        delete this.matrix[row];
      }
    },
    
    /**
     * @deprecated
     */
    getEntireMatrix: function() {
      return this.matrix;
    },
    
    /**
     * Verify if there are elements in the grid
     * @returns true if the matrix is empty, false otherwise
     */
    isEmpty: function() {
      for (var row in this.matrix) {
        return false;
      }
      return true;
    },
   
    /**
     * Executes a given callback passing each element of the Matrix. The callback
     * receives the element together with its coordinates.<br/>  
     * Callbacks are executed synchronously before the method returns: calling 
     * insert or delete methods during callback execution may result in 
     * a wrong iteration.
     * 
     * @param {ForEachCallback} callback The callback to be called.
     */
    forEachElement: function(callback) {
      for (var row in this.matrix) {
        this.forEachElementInRow(row,callback);
      }
      
      /*this.forEachRow(function(row) {
        that.forEachElementInRow(row,callback);
      });*/
    },
    
    /**
     * Executes a given callback passing the key of each row containing at least one element.
     * @param {RowsCallback} callback The callback to be called. 
     */
    forEachRow: function(callback) {
      for (var row in this.matrix) {
        callback(row);
      }
    },
    
    /**
     * Executes a given callback passing each element of the specified row. The callback
     * receives the element together with its coordinates.<br/>  
     * Callbacks are executed synchronously before the method returns: calling 
     * insert or delete methods during callback execution may result in 
     * a wrong iteration.
     * 
     * @param {ForEachCallback} callback The callback to be called.
     */
    forEachElementInRow: function(row,callback) {
      var rowElements = this.matrix[row];
      for (var col in rowElements) {
        callback(rowElements[col],row,col);
      }
    }
    
  };
  
  /**
   * Callback for {@link Matrix#forEachElement} and {@link Matrix#forEachElementInRow}
   * @callback ForEachCallback
   * @param {Object} value the element.
   * @param {String|Number} row the row where the element is located
   * @return {String|Number} col the column in the row where the element is located 
   */
  
  /**
   * Callback for {@link Matrix#forEachRow}
   * @callback RowsCallback
   * @param {String|Number} row a non-empty row in the Matrix.
   */
  
  Matrix.prototype["insert"] = Matrix.prototype.insert; 
  Matrix.prototype["get"] = Matrix.prototype.get;
  Matrix.prototype["del"] = Matrix.prototype.del;
  Matrix.prototype["insertRow"] = Matrix.prototype.insertRow;
  Matrix.prototype["getRow"] = Matrix.prototype.getRow;
  Matrix.prototype["delRow"] = Matrix.prototype.delRow;
  Matrix.prototype["getEntireMatrix"] = Matrix.prototype.getEntireMatrix;
  Matrix.prototype["forEachElement"] = Matrix.prototype.forEachElement; 
  Matrix.prototype["forEachElementInRow"] = Matrix.prototype.forEachElementInRow;
  Matrix.prototype["forEachRow"] = Matrix.prototype.forEachRow;
  Matrix.prototype["isEmpty"] = Matrix.prototype.isEmpty; 
  
  
  return Matrix;
})();

/**
 * Manages the maximum real frequency of a subscription. 
 * In case of change, SubscriptionListener.onRealMaxFrequency is triggered.
 * If the subscription is a two-level command subscription, the notified frequency is the maximum real frequency
 * of the first-level and second-level subscriptions.
 * 
 * @since February 2018
 */

    
    /**
     * A frequency is a decimal number or the string "unlimited".
     */
    var Frequency = function(frequency) {
        this.frequency = frequency;
    };

    Frequency.prototype = {
            /**
             * Returns whether this frequency is greater than or equal to the given frequency. 
             */
            isGTE: function(otherFrequency) {
                if (this.frequency == "unlimited") {
                    return true;
                } else if (otherFrequency.frequency == "unlimited") {
                    return false;
                } else {
                    return this.frequency > otherFrequency.frequency;
                }
            },

            equals: function(otherFrequency) {
                return this.frequency == otherFrequency.frequency;
            }
    };

    /**
     * Manages a subscription which is neither a first-level nor a second-level subscription.
     */
    var FlatPushRealMaxFrequencyManager = function(subscription) {
        this.subscription = subscription;
    };

    FlatPushRealMaxFrequencyManager.prototype = {
            /**
             * Changes the maximum real frequency of a subscription
             * and notifies SubscriptionListener.onRealMaxFrequency if there is a change.
             */
            configure: function(frequency) {
                var oldRealMaxFrequency = this.subscription.realMaxFrequency;
                this.subscription.realMaxFrequency = new Frequency(frequency);
                if (!oldRealMaxFrequency.equals(this.subscription.realMaxFrequency)) {
                    this.subscription.dispatchEvent("onRealMaxFrequency", [this.subscription.realMaxFrequency.frequency]);
                }
            }
    };

    /**
     * Manages the first-level subscription of a two-level command subscription.
     */
    var FirstLevelMultiMetaPushRealMaxFrequencyManager = function(subscription) {
        this.subscription = subscription;
        this.multiMetaPushRealMaxFrequency = new Frequency(null);
    };

    FirstLevelMultiMetaPushRealMaxFrequencyManager.prototype = {
            /**
             * Changes the maximum real frequency of a subscription
             * and notifies SubscriptionListener.onRealMaxFrequency if there is a change.
             */
            configure: function(frequency) {
                this.subscription.realMaxFrequency = new Frequency(frequency);
                this.configureMultiMetaPushRealMaxFrequency();
            },

            /**
             * Calculates the maximum frequency among first-/second-level subscriptions 
             * and notifies SubscriptionListener.onRealMaxFrequency if there is a change.
             */
            configureMultiMetaPushRealMaxFrequency: function() {
                var maxFrequency = this.subscription.realMaxFrequency;
                this.subscription.subTables.forEachElement(function(secondLevelSubscription) {
                    if (secondLevelSubscription.realMaxFrequency.isGTE(maxFrequency)) {
                        maxFrequency = secondLevelSubscription.realMaxFrequency;
                    }
                });
                if (!maxFrequency.equals(this.multiMetaPushRealMaxFrequency)) {
                    this.multiMetaPushRealMaxFrequency = maxFrequency;
                    this.subscription.dispatchEvent("onRealMaxFrequency", [this.multiMetaPushRealMaxFrequency.frequency]);
                }
            },

            /**
             * Recalculates the maximum frequency when a second-level subscription is deleted
             * and notifies SubscriptionListener.onRealMaxFrequency if there is a change.
             */
            onDeleteSecondLevelSubscription: function() {
                this.configureMultiMetaPushRealMaxFrequency();
            }
    };

    /**
     * Manages a second-level subscription of a two-level command subscription.
     */
    var SecondLevelMultiMetaPushRealMaxFrequencyManager = function(subscription, firstLevelSubscription) {
        this.subscription = subscription;
        this.firstLevelSubscription = firstLevelSubscription;
    };

    SecondLevelMultiMetaPushRealMaxFrequencyManager.prototype = {
            /**
             * Changes the maximum real frequency of a subscription
             * and notifies SubscriptionListener.onRealMaxFrequency of the first-level subscription 
             * if there is a change.
             */
            configure: function(frequency) {
                this.subscription.realMaxFrequency = new Frequency(frequency);
                this.firstLevelSubscription.realMaxFrequencyManager.configureMultiMetaPushRealMaxFrequency();
            }
    };
    
    var RealMaxFrequencyManager = {
        Frequency: Frequency,
        FlatPushRealMaxFrequencyManager: FlatPushRealMaxFrequencyManager,
        FirstLevelMultiMetaPushRealMaxFrequencyManager: FirstLevelMultiMetaPushRealMaxFrequencyManager,
        SecondLevelMultiMetaPushRealMaxFrequencyManager: SecondLevelMultiMetaPushRealMaxFrequencyManager
    };

var NO_VALID_ARRAY = "Please specifiy a valid array";
    var NO_EMPTY = " name cannot be empty";
    var NO_SPACE = " name cannot contain spaces";
    var NO_NUMBER = " name cannot be a number";
    
    function checkItemNames(_array, head) {
        if (!Helpers.isArray(_array)) {
            throw new IllegalArgumentException(NO_VALID_ARRAY);
        }
        for (var i = 0; i < _array.length; i++) {
            if (!_array[i]) {
                throw new IllegalArgumentException(head+NO_EMPTY);

            } else if (_array[i].indexOf(" ") > -1) {
                // An item name cannot contain spaces
                throw new IllegalArgumentException(head+NO_SPACE);

            } else if (!isNaN(_array[i])) {
                // An item name cannot be a number
                throw new IllegalArgumentException(head+NO_NUMBER);
            }
        }
    }

    function checkFieldNames(_array, head) {
        if (!Helpers.isArray(_array)) {
            throw new IllegalArgumentException(NO_VALID_ARRAY);
        }
        for (var i = 0; i < _array.length; i++) {
            if (!_array[i]) {
                throw new IllegalArgumentException(head+NO_EMPTY);

            } else if (_array[i].indexOf(" ") > -1) {
                // A field name cannot contain spaces
                throw new IllegalArgumentException(head+NO_SPACE);
            }
        }
    }
      
    var ValidationUtils = {
        checkItemNames: checkItemNames,
        checkFieldNames: checkFieldNames,
        NO_SCHEMA_NOR_LIST: "The field list/field schema of this Subscription was not initiated",
        NO_GROUP_NOR_LIST: "The item list/item group of this Subscription was not initiated",
        USE_GET_ITEM_GROUP: "This Subscription was initiated using an item group, use getItemGroup instead of using getItems",
        USE_GET_ITEMS: "This Subscription was initiated using an item list, use getItems instead of using getItemGroup",
        USE_GET_FIELD_SCHEMA: "This Subscription was initiated using a field schema, use getFieldSchema instead of using getFields",
        USE_GET_FIELDS: "This Subscription was initiated using a field list, use getFields instead of using getFieldSchema",
        MAX_BUF_EXC: "The given value is not valid for this setting; use null, 'unlimited' or a positive number instead",
        MAX_FREQ_EXC: "The given value is not valid for this setting; use null, 'unlimited', 'unfiltered' or a positive number instead",
        YES_FIELDS_NO_ITEMS: "Please specify a valid item or item list",
        NO_VALID_FIELDS: "Please specify a valid field list"
    };

var Subscription = /*@__PURE__*/(function() {
  var TABLE_OFF = 1;
  var TABLE_WAITING = 2;
  var TABLE_SUBSCRIBING = 3;
  var TABLE_PUSHING = 4;
  var TABLE_PAUSED = 5;
  
  var modeCheck = {
      "COMMAND": true,
      "RAW": true,
      "MERGE": true,
      "DISTINCT": true};
  
  
  var SIMPLE = 1;
  var METAPUSH = 2;
  var MULTIMETAPUSH = 3;
  
  var UNCHANGED = Constants.UNCHANGED;
  
  var subscriptionsLogger = LoggerManager.getLoggerProxy(Constants.SUBSCRIPTIONS);
  
  var INVALID_MODE =  "The given value is not a valid subscription mode. Admitted values are MERGE, DISTINCT, RAW, COMMAND";
  
  var INVALID_SECOND_LEVEL_KEY = "The received key value is not a valid name for an Item";

  var NO_ITEMS = "Invalid Subscription, please specify an item list or item group";
  var NO_FIELDS = "Invalid Subscription, please specify a field list or field schema";
  
  var IS_ALIVE = "Cannot modify an active Subscription, please unsubscribe before applying any change";
  var NOT_ALIVE = "Subscription is not active";
  
  var ILLEGAL_FREQ_EXC = "Can't change the frequency from/to 'unfiltered' or to null while the Subscription is active";
  
  var NUMERIC_DISTINCT_ONLY = "Numeric values are only allowed when the subscription mode is DISTINCT";
  var RAW_NO_SNAPSHOT = "Snapshot is not permitted if RAW was specified as mode";
  var REQ_SNAP_EXC = "The given value is not valid for this setting; use null, 'yes', 'no' or a positive number instead";
  
  var NO_SUB_SCHEMA_NOR_LIST = "The second level of this Subscription was not initiated";
 
  var NO_SECOND_LEVEL = "Second level field list is only available on COMMAND Subscriptions";
  var NO_COMMAND = "This method can only be used on COMMAND subscriptions";

  function sortFun(a,b) {
    return a-b;
  }
  

  /**
   * Creates an object to be used to describe a Subscription that is going
   * to be subscribed to through Lightstreamer Server.
   * The object can be supplied to {@link LightstreamerClient#subscribe} and
   * {@link LightstreamerClient#unsubscribe}, in order to bring the Subscription to
   * "active" or back to "inactive" state.
   * <BR>Note that all of the methods used to describe the subscription to the server
   * can only be called while the instance is in the "inactive" state; the only
   * exception is {@link Subscription#setRequestedMaxFrequency}.
   * @constructor
   * 
   * @exports Subscription
   * 
   * @throws {IllegalArgumentException} If no or invalid subscription mode is 
   * passed.
   * @throws {IllegalArgumentException} If the list of items is specified while
   * the list of fields is not, or viceversa.
   * @throws {IllegalArgumentException} If the specified "Item List" or "Field List"
   * is not valid; see {@link Subscription#setItems} and {@link Subscription#setFields} for details.
   *
   * @param {String} subscriptionMode the subscription mode for the
   * items, required by Lightstreamer Server. Permitted values are:
   * <ul>
   * <li>MERGE</li>
   * <li>DISTINCT</li>
   * <li>RAW</li>
   * <li>COMMAND</li>
   * </ul>
   * 
   * @param {String|String[]} [items] an array of Strings containing a list of items to
   * be subscribed to through the server. In case of a single-item subscription the String
   * containing the item name can be passed in place of the array; both of the 
   * following examples represent a valid subscription:
   * <BR><code>new Subscription(mode,"item1",fieldList);</code>
   * <BR><code>new Subscription(mode,["item1","item2"],fieldList);</code>
   * <BR>It is also possible to pass null (or nothing) and specify the
   * "Item List" or "Item Group" later through {@link Subscription#setItems} and
   * {@link Subscription#setItemGroup}. In this case the fields parameter must not be specified.
   
   * 
   * @param {String[]} [fields] An array of Strings containing a list of fields 
   * for the items to be subscribed to through Lightstreamer Server.
   * <BR>It is also possible to pass null (or nothing) and specify the
   * "Field List" or "Field Schema" later through {@link Subscription#setFields} and
   * {@link Subscription#setFieldSchema}. In this case the items parameter must not be specified.
   *
   * @class Class representing a Subscription to be submitted to a Lightstreamer
   * Server. It contains subscription details and the listeners needed to process the
   * real-time data. 
   * <BR>After the creation, a Subscription object is in the "inactive"
   * state. When a Subscription object is subscribed to on a {@link LightstreamerClient} 
   * object, through the {@link LightstreamerClient#subscribe} method, its state 
   * becomes "active". This means that the client activates a subscription to the 
   * required items through Lightstreamer Server and the Subscription object begins 
   * to receive real-time events.
   * 
   * <BR>A Subscritpion can be configured to use either an Item Group or an Item List to 
   * specify the items to be subscribed to and using either a Field Schema or Field List
   * to specify the fields.
   * <BR>"Item Group" and "Item List" are defined as follows:
   * <ul>
   * <li>"Item Group": an Item Group is a String identifier representing a list of items.
   * Such Item Group has to be expanded into a list of items by the getItems method of the
   * MetadataProvider of the associated Adapter Set. When using an Item Group, items in the 
   * subscription are identified by their 1-based index within the group.
   * <BR>It is possible to configure the Subscription to use an "Item Group" using the {@link Subscription#setItemGroup}
   * method.
   * </li> 
   * <li>"Item List": an Item List is an array of Strings each one representing an item.
   * For the Item List to be correctly interpreted a LiteralBasedProvider or a MetadataProvider
   * with a compatible implementation of getItems has to be configured in the associated Adapter Set.
   * <BR>Note that no item in the list can be empty, can contain spaces or can 
   * be a number. 
   * <BR>When using an Item List, items in the subscription are identified by their name or by
   * their 1-based index within the list.
   * <BR>It is possible to configure the Subscription to use an "Item List" using the {@link Subscription#setItems}
   * method or by specifying it in the constructor.
   * </li> 
   * </ul>
   * <BR>"Field Schema" and "Field List" are defined as follows:
   * <ul>
   * <li>"Field Schema": a Field Schema is a String identifier representing a list of fields.
   * Such Field Schema has to be expanded into a list of fields by the getFields method of the
   * MetadataProvider of the associated Adapter Set. When using a Field Schema, fields in the 
   * subscription are identified by their 1-based index within the schema.
   * <BR>It is possible to configure the Subscription to use a "Field Schema" using the {@link Subscription#setFieldSchema}
   * method.
   * </li>
   * <li>"Field List": a Field List is an array of Strings each one representing a field.
   * For the Field List to be correctly interpreted a LiteralBasedProvider or a MetadataProvider
   * with a compatible implementation of getFields has to be configured in the associated Adapter Set.
   * <BR>Note that no field in the list can be empty or can contain spaces. 
   * <BR>When using a Field List, fields in the subscription are identified by their name or by
   * their 1-based index within the list.
   * <BR>It is possible to configure the Subscription to use a "Field List" using the {@link Subscription#setFields}
   * method or by specifying it in the constructor.
   * </li> 
   * </ul>
   */
  var Subscription = function(subscriptionMode, items, fields) {

    //admitted calls:
    //mode, item, fields
    //mode, items, fields
    //mode
    
    this._callSuperConstructor(Subscription);
    
    subscriptionMode = new String(subscriptionMode).toUpperCase();
    if (!subscriptionMode || !modeCheck[subscriptionMode]) {
      throw new IllegalArgumentException(INVALID_MODE);
    }
    this._mode = subscriptionMode;
    
    this.itemList = null;
    this.itemGroup = null;
    this.itemDescriptor = null;

    this.fieldList = null;
    this.fieldSchema = null;
    this.fieldDescriptor = null;
    
    //DEFAULT: yes if mode is MERGE, DISTINCT, or COMMAND; null if mode is RAW 
    this.isRequiredSnapshot = subscriptionMode === "RAW" ? null : "yes";
    this.requestedMaxFrequency = null;
    this.requestedBufferSize = null;
    this._start = null;
    this._end = null;
    this._selector = null;
    this.dataAdapter = null;
    
    this.tableNumber = null;
   
    this.requestParams = null;
    
    /*
     * The real max frequency, i.e. the argument of a CONF message.
     */
    this.realMaxFrequency = new RealMaxFrequencyManager.Frequency(null);
    /*
     * An instance of RealMaxFrequencyManager.
     */
    this.realMaxFrequencyManager = null;
    
/////////////////
  
    this.oldValuesByItem = new Matrix(); 
    
    this.oldValuesByKey = new Matrix(); 
    
/////////////////    
    
    this.handler = null;

    this.tablePhaseType = TABLE_OFF; 
    this.tablePhase = 0;  
    this._id = null;

    this.onCount = 0;
    this.sCount = 0;
    
    this.setBehavior(this._mode == Constants.COMMAND ? METAPUSH : SIMPLE);
    
/////////////////To manage Metapush
   
    this.commandCode = null;
    this.keyCode = null;
    
/////////////////To manage MultiMetapush
 
    this.underDataAdapter = null;
    this.subTables = new Matrix();
    
    this.subFieldList = null;
    this.subFieldSchema = null;
    this.subFieldDescriptor = null;
    
    //completely useless (may directly use the constant)
    //I save it here so that I can modifiy it to DISTINCT in the SubscriptionUnusualEvents test.
    this.subMode = Constants.MERGE;

/////////////////Setup   
    if (items) {
      if (!fields || !Helpers.isArray(fields)) {
        throw new IllegalArgumentException(ValidationUtils.NO_VALID_FIELDS);
      }
      
      
      if (Helpers.isArray(items)) {
        //list of items
        this.setItems(items);
      } else {
        this.setItems([items]);
      }
      
      this.setFields(fields);
      
    } else if (fields) {
      throw new IllegalArgumentException(ValidationUtils.YES_FIELDS_NO_ITEMS);
    }
    
  };
  
  Subscription.prototype = {
      
    toString: function() {
      return ["[","Subscription",this.tablePhaseType,this.tablePhase,this._id,this.tableNumber,"]"].join("|");
    },
    
//table status events    
    
    cleanData: function() {
      //called at the end of a pushing life (onRemove and onPause), empties structures that will be reinited on the onSubmission
      this.tableNumber = null;
      
      this.oldValuesByItem = new Matrix(); 
      this.oldValuesByKey = new Matrix(); 
      this.snapshotByItem = null;
      
      //resets the schema size
      this.fieldDescriptor.setSize(0);
      this.itemDescriptor.setSize(0);
      
      
      if (this.behavior == MULTIMETAPUSH) {
        this.fieldDescriptor.setSubDescriptor(null);
        this.subTables = new Matrix();
      }

      subscriptionsLogger.logDebug(LoggerManager.resolve(907),this);
    },
    
    onAdd: function(_id, nGen, handler) {
      this.notAliveCheck();
      if (!this.itemDescriptor) {
        throw new IllegalArgumentException(NO_ITEMS);
      }
      if (!this.fieldDescriptor) {
        throw new IllegalArgumentException(NO_FIELDS);
      }
      
      
      this.tablePhaseType = TABLE_PAUSED;
      this._id = _id;
      this.handler = handler;
          
      this.onCount++;
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(this.onCount,1,"Wrong count while adding");
    //>>excludeEnd("debugExclude");
      

      subscriptionsLogger.logInfo(LoggerManager.resolve(908),this);
      
      return true;
    },
    
    onSubmission: function() {
      this.tablePhaseType = TABLE_WAITING;

      subscriptionsLogger.logDebug(LoggerManager.resolve(909),this);
    },
    
    onTableNumber: function(tableNum) {
          this.tableNumber = tableNum;
          this.tablePhaseType = TABLE_SUBSCRIBING;
          
          subscriptionsLogger.logDebug(LoggerManager.resolve(910),this);        
    },
    
    onPause: function() {
      //called after an onSessionEnd, remove session related data (eg received push...)
      var unsub = this.isPushing();
      
      this.tablePhaseType = TABLE_PAUSED;
      
      this.cleanData();
      
      if (unsub) {
        this.onEndPush();
      }
       
      subscriptionsLogger.logDebug(LoggerManager.resolve(911),this);
    },
    
    onRemove: function() {
      this.isAliveCheck();
      
      var unsub = this.isPushing();
      
      this.tablePhaseType = TABLE_OFF; 
      this._id = null;
      delete(this.requestParams);
      
      if (this.behavior == MULTIMETAPUSH) {
        this.removeSubTables();
      }
      
      this.cleanData();
      
      this.onCount--;
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(this.onCount,0, "Wrong count while removing");
    //>>excludeEnd("debugExclude");
      if (unsub) {
        this.onEndPush();
      }
      
      this.handler = null;
      
      subscriptionsLogger.logDebug(LoggerManager.resolve(912),this);
      
    },

    onStartPush: function(kPos,cPos,itms,flds) {
      this.tablePhaseType = TABLE_PUSHING;
      
      this.sCount++;
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(this.sCount,1, "Wrong count starting push");
    //>>excludeEnd("debugExclude");
      subscriptionsLogger.logInfo(LoggerManager.resolve(913),this);
      
      if (this.behavior == MULTIMETAPUSH) {
        this.fieldDescriptor.setSubDescriptor(this.subFieldDescriptor);
      }
      
      if (this.fieldSchema && this.behavior != SIMPLE) {
        this.setServerSentMetapushFields(cPos, kPos);
      }
      
      this.itemDescriptor.setSize(itms);
      this.fieldDescriptor.setSize(flds);
      
      this.snapshotByItem = [];
      for (var i = 1; i <= itms; i++) {
        this.snapshotByItem[i] = new SnapshotManager(this);  
      }
      
      //notify table start
      this.dispatchEvent("onSubscription");
      
    },
    
    onStopPush: function() {
      //onEndPush sends the unsubscription notifications
    },
    
    onEndPush: function() {
      
      this.sCount--;
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(this.sCount,0, "Wrong count ending push");
    //>>excludeEnd("debugExclude");
      subscriptionsLogger.logInfo(LoggerManager.resolve(914),this);
      
      //notify table end
      this.dispatchEvent("onUnsubscription");
        
    },
    
    removeSubTables: function() {
      var that = this;
      this.subTables.forEachElement(function(el,item,key) {
        that.removeSubTable(item,key);
      });
    },
    
    removeItemSubTables: function(_item) {
      var that = this;
      this.subTables.forEachElementInRow(function(el,item,key) {
        that.removeSubTable(item,key);
      });
    },
    
    getTableNumber: function() {
      return this.tableNumber;
    },
    
    getTablePhase: function() {
      return this.tablePhase;
    },
    
    getRequestParams: function() {
      this.generateRequest();
      return this.requestParams;
    },

    /*private*/ generateMaxFrequencyParam: function() {
      if (this.requestedMaxFrequency != null) {
        var rmf = this.requestedMaxFrequency;
        return {"LS_requested_max_frequency": rmf};
      }
      return {};
    },
    
    /*private*/ generateRequest: function() {
      
      var req = {
          "LS_mode": this._mode,
          "LS_group": encodeURIComponent(this.itemDescriptor.getComposedString()),
          "LS_schema": encodeURIComponent(this.fieldDescriptor.getComposedString())
      };
      
      if (this.dataAdapter != null) {
        req["LS_data_adapter"]= encodeURIComponent(this.dataAdapter);
      }
    
      if (this._selector != null) {
        req["LS_selector"]= encodeURIComponent(this._selector);
      }
  
      if (this._start != null) {
        req["LS_start"]=this._start;
      }
      if (this._end != null) {
        req["LS_end"]=this._end;
      }
      if (this.isRequiredSnapshot != null) {
        req["LS_snapshot"]= this.isRequiredSnapshot === "yes" ? "true" : (this.isRequiredSnapshot === "no" ? "false" : this.isRequiredSnapshot);
      }
      
      //LS_requested_max_frequency
      Utils.extendObj(req,this.generateMaxFrequencyParam());

      
      if (this.requestedBufferSize != null) {
        var rbs = this.requestedBufferSize;
        if (rbs == "unlimited" || rbs > 0) {
          req["LS_requested_buffer_size"]=rbs;
        }
      }
      
      subscriptionsLogger.logDebug(LoggerManager.resolve(915),this);
      
      this.requestParams = req;
      
      return this.requestParams;
    },
    
    setSchemaReadMetapushFields: function() {
      if (this._mode != Constants.COMMAND || this.fieldList == null) {
        return;
      }
      
      this.commandCode = this.fieldList.getPos("command"); 
      this.keyCode = this.fieldList.getPos("key");
      
      if (!this.commandCode || !this.keyCode) {
        throw new IllegalArgumentException("A field list for a COMMAND subscription must contain the key and command fields");
      }
      
    },
   
    setServerSentMetapushFields: function(commandPos, keyPos) {
      subscriptionsLogger.logDebug(LoggerManager.resolve(916),this,commandPos,keyPos);
      
      this.commandCode = commandPos; 
      this.keyCode = keyPos;
    },
    
    getSubscriptionId: function() {
      return this._id;
    },
    
    notAliveCheck: function() {
      if (this.isActive()) {
        throw new IllegalStateException(IS_ALIVE);
      }
    },
    
    isAliveCheck: function() {
      if (!this.isActive()) {
        throw new IllegalStateException(NOT_ALIVE);
      }
    },
    
    secondLevelCheck: function() {
      if (this._mode != Constants.COMMAND) {
        throw new IllegalStateException(NO_SECOND_LEVEL);
      }
    },
    
    commandCheck: function() {
      if (this._mode != Constants.COMMAND) {
        throw new IllegalStateException(NO_COMMAND);
      }
    },
    
//////////////////phases, see https://docs.google.com/a/lightstreamer.com/drawings/d/1SsbEMF78re0ASAgByUhy5EQeKWjTG9FUkGR4zMGhtSc/edit?hl=en_US
    
    isOff: function() {
      return this.tablePhaseType == TABLE_OFF;
    },
    isWaiting: function() {
      return this.tablePhaseType == TABLE_WAITING;
    },
    isSubscribing: function() {
      return this.tablePhaseType == TABLE_SUBSCRIBING;
    },
    isPushing: function() {
      return this.tablePhaseType == TABLE_PUSHING;
    },
    isPaused: function() {
      return this.tablePhaseType == TABLE_PAUSED;
    },
    
  
    /**  
     * Inquiry method that checks if the Subscription is currently "active" or not.
     * Most of the Subscription properties cannot be modified if a Subscription is "active".
     * <BR>The status of a Subscription is changed to "active" through the  
     * {@link LightstreamerClient#subscribe} method and back to "inactive" through the
     * {@link LightstreamerClient#unsubscribe} one.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {boolean} true/false if the Subscription is "active" or not.
     * 
     * @see LightstreamerClient#subscribe
     * @see LightstreamerClient#unsubscribe
     */
    isActive: function() {
      return this.tablePhaseType != TABLE_OFF;
    },
    
    /**  
     * Inquiry method that checks if the Subscription is currently subscribed to
     * through the server or not.
     * <BR>This flag is switched to true by server sent Subscription events, and 
     * back to false in case of client disconnection, 
     * {@link LightstreamerClient#unsubscribe} calls and server sent unsubscription
     * events. 
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {boolean} true/false if the Subscription is subscribed to
     * through the server or not.
     */
    isSubscribed: function() {
      return this.isPushing(); 
    },
   
    /**
     * Setter method that sets the "Item List" to be subscribed to through 
     * Lightstreamer Server.
     * <BR>Any call to this method will override any "Item List" or "Item Group"
     * previously specified.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalArgumentException} if the given object is not an array.
     * @throws {IllegalArgumentException} if any of the item names in the "Item List"
     * contains a space or is a number or is empty/null.
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * 
     * @param {String[]} items An array of Strings containing an "Item List" to
     * be subscribed to through the server. 
     */
    setItems: function(items) {
      this.notAliveCheck();
      
      ValidationUtils.checkItemNames(items,"An item");
      
      this.itemList = items == null ? null : new ListDescriptor(items);
      this.itemGroup = null;
      this.itemDescriptor = this.itemList; 

    },
    
    /**
     * Inquiry method that can be used to read the "Item List" specified for this
     * Subscription.
     * <BR>Note that if a single item was specified in the constructor, this method
     * will return an array of length 1 containing such item.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the Subscription has
     * been initialized with an "Item List".
     * </p>
     * 
     * @throws {IllegalStateException} if the Subscription was initialized
     * with an "Item Group" or was not initialized at all.
     * 
     * @return {String[]} the "Item List" to be subscribed to through the server. 
     */
    getItems: function() {
      if (!this.itemList) {
        if (this.itemGroup) {
          throw new IllegalStateException(ValidationUtils.USE_GET_ITEM_GROUP);
        } else  {
          throw new IllegalStateException(ValidationUtils.NO_GROUP_NOR_LIST);
        }
      }
      return this.itemList.getOriginal();
    },
    
    /**
     * Setter method that sets the "Item Group" to be subscribed to through 
     * Lightstreamer Server.
     * <BR>Any call to this method will override any "Item List" or "Item Group"
     * previously specified.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * 
     * @param {String} groupName A String to be expanded into an item list by the
     * Metadata Adapter. 
     */
    setItemGroup: function(groupName) {
      this.notAliveCheck();
      
      this.itemList = null;
      this.itemGroup = groupName == null ? null : new NameDescriptor(groupName);
      this.itemDescriptor = this.itemGroup;
    },

    /**
     * Inquiry method that can be used to read the item group specified for this
     * Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the Subscription has
     * been initialized using an "Item Group"
     * </p>
     *
     * @throws {IllegalStateException} if the Subscription was initialized
     * with an "Item List" or was not initialized at all.
     * 
     * @return {String} the "Item Group" to be subscribed to through the server. 
     */
    getItemGroup: function() {
      if (!this.itemGroup) {
        if (this.itemList) {
          throw new IllegalStateException(ValidationUtils.USE_GET_ITEMS);
        } else {
          throw new IllegalStateException(ValidationUtils.NO_GROUP_NOR_LIST);
        }
      }
      return this.itemGroup.getOriginal();
    },
    
    /**
     * Setter method that sets the "Field List" to be subscribed to through 
     * Lightstreamer Server.
     * <BR>Any call to this method will override any "Field List" or "Field Schema"
     * previously specified.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalArgumentException} if the given object is not an array.
     * @throws {IllegalArgumentException} if any of the field names in the list
     * contains a space or is empty/null.
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * 
     * @param {String[]} fields An array of Strings containing a list of fields to
     * be subscribed to through the server. 
     */
    setFields: function(fields) {
      this.notAliveCheck();
      
      ValidationUtils.checkFieldNames(fields,"A field");
      
      this.fieldList =  fields == null ? null : new ListDescriptor(fields);
      this.fieldSchema = null;
      this.fieldDescriptor = this.fieldList;
      
      this.setSchemaReadMetapushFields();
      
    },

    /**
     * Inquiry method that can be used to read the "Field List" specified for this
     * Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the Subscription has
     * been initialized using a "Field List". 
     * </p>
     * 
     * @throws {IllegalStateException} if the Subscription was initialized
     * with a "Field Schema" or was not initialized at all.
     * 
     * @return {String[]} the "Field List" to be subscribed to through the server. 
     */
    getFields: function() {
      if (!this.fieldList) {
        if (this.fieldSchema) {
          throw new IllegalStateException(ValidationUtils.USE_GET_FIELD_SCHEMA);
        } else {
          throw new IllegalStateException(ValidationUtils.NO_SCHEMA_NOR_LIST);
        }
      }
      return this.fieldList.getOriginal();
    },
    
    /**
     * Setter method that sets the "Field Schema" to be subscribed to through 
     * Lightstreamer Server.
     * <BR>Any call to this method will override any "Field List" or "Field Schema"
     * previously specified.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * 
     * @param {String} schemaName A String to be expanded into a field list by the
     * Metadata Adapter. 
     */
    setFieldSchema: function(schemaName) {
      this.notAliveCheck();
      
      this.fieldList = null;
      this.fieldSchema = schemaName == null ? null : new NameDescriptor(schemaName);
      this.fieldDescriptor = this.fieldSchema;
    },

    /**
     * Inquiry method that can be used to read the field schema specified for this
     * Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the Subscription has
     * been initialized using a "Field Schema" 
     * </p>
     * 
     * @throws {IllegalStateException} if the Subscription was initialized
     * with a "Field List" or was not initialized at all.
     * 
     * @return {String} the "Field Schema" to be subscribed to through the server. 
     */
    getFieldSchema: function() {
      if (!this.fieldSchema) {
        if (this.fieldList) {
          throw new IllegalStateException(ValidationUtils.USE_GET_FIELDS);
        } else {
          throw new IllegalStateException(ValidationUtils.NO_SCHEMA_NOR_LIST);
        }
      }
      return this.fieldSchema.getOriginal();
    },
    
    /**
     * Inquiry method that can be used to read the mode specified for this
     * Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} the Subscription mode specified in the constructor.
     */
    getMode: function() {
      return this._mode;
    },
   
    /**
     * Setter method that sets the name of the Data Adapter
     * (within the Adapter Set used by the current session)
     * that supplies all the items for this Subscription.
     * <BR>The Data Adapter name is configured on the server side through
     * the "name" attribute of the "data_provider" element, in the
     * "adapters.xml" file that defines the Adapter Set (a missing attribute
     * configures the "DEFAULT" name).
     * <BR>Note that if more than one Data Adapter is needed to supply all the
     * items in a set of items, then it is not possible to group all the
     * items of the set in a single Subscription. Multiple Subscriptions
     * have to be defined.
     *
     * <p class="default-value"><b>Default value:</b> The default Data Adapter for the Adapter Set,
     * configured as "DEFAULT" on the Server.</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     *
     * @param {String} dataAdapter the name of the Data Adapter. A null value 
     * is equivalent to the "DEFAULT" name.
     *  
     * @see ConnectionDetails#setAdapterSet
     */
    setDataAdapter: function(dataAdapter) {
      this.notAliveCheck();
      
      this.dataAdapter = dataAdapter;
      subscriptionsLogger.logDebug(LoggerManager.resolve(917),this,dataAdapter);
    },
    
    /**
     * Inquiry method that can be used to read the name of the Data Adapter 
     * specified for this Subscription through {@link Subscription#setDataAdapter}.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} the name of the Data Adapter; returns null if no name
     * has been configured, so that the "DEFAULT" Adapter Set is used.
     */
    getDataAdapter: function() {
      return this.dataAdapter;
    },
    
    /**
     * Setter method that sets the selector name for all the items in the
     * Subscription. The selector is a filter on the updates received. It is
     * executed on the Server and implemented by the Metadata Adapter.
     *
     * <p class="default-value"><b>Default value:</b> null (no selector).</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     *
     * @param {String} selector name of a selector, to be recognized by the
     * Metadata Adapter, or null to unset the selector.
     */
    setSelector: function(selector) {
      this.notAliveCheck();
      
      this._selector = selector;
      subscriptionsLogger.logDebug(LoggerManager.resolve(918),this,selector);
    },
    
    /**
     * Inquiry method that can be used to read the selctor name  
     * specified for this Subscription through {@link Subscription#setSelector}.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} the name of the selector.
     */
    getSelector: function() {
      return this._selector;
    },
      
    /**
     * Setter method that sets the maximum update frequency to be requested to
     * Lightstreamer Server for all the items in the Subscription. It can
     * be used only if the Subscription mode is MERGE, DISTINCT or
     * COMMAND (in the latter case, the frequency limitation applies to the
     * UPDATE events for each single key). For Subscriptions with two-level behavior
     * (see {@link Subscription#setCommandSecondLevelFields} and {@link Subscription#setCommandSecondLevelFieldSchema})
     * , the specified frequency limit applies to both first-level and second-level items. <BR>
     * Note that frequency limits on the items can also be set on the
     * server side and this request can only be issued in order to furtherly
     * reduce the frequency, not to rise it beyond these limits. <BR>
     * This method can also be used to request unfiltered dispatching
     * for the items in the Subscription. However, unfiltered dispatching
     * requests may be refused if any frequency limit is posed on the server
     * side for some item.
     *
     * <p class="edition-note"><B>Edition Note:</B> A further global frequency limit could also
	 * be imposed by the Server, depending on Edition and License Type; this specific limit also applies to RAW mode
	 * and to unfiltered dispatching.
	 * To know what features are enabled by your license, please see the License tab of the
	 * Monitoring Dashboard (by default, available at /dashboard).</p>
     *
     * <p class="default-value"><b>Default value:</b> null, meaning to lean on the Server default based on the subscription
     * mode. This consists, for all modes, in not applying any frequency 
     * limit to the subscription (the same as "unlimited"); see the "General Concepts"
     * document for further details.</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> This method can can be called at any time with some
     * differences based on the Subscription status:
     * <ul>
     * <li>If the Subscription instance is in its "inactive" state then
     * this method can be called at will.</li>
     * <li>If the Subscription instance is in its "active" state then the method
     * can still be called unless the current value is "unfiltered" or the
     * supplied value is "unfiltered" or null.
     * If the Subscription instance is in its "active" state and the
     * connection to the server is currently open, then a request
     * to change the frequency of the Subscription on the fly is sent to the server.</li>
     * </ul>
     * </p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active" and the current value of this property is "unfiltered".
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active" and the given parameter is null or "unfiltered".
     * @throws {IllegalArgumentException} if the specified value is not
     * null nor one of the special "unlimited" and "unfiltered" values nor
     * a valid positive number.
     *
     * @param {Number} freq A decimal number, representing the maximum update frequency (expressed in updates
     * per second) for each item in the Subscription; for instance, with a setting
     * of 0.5, for each single item, no more than one update every 2 seconds
     * will be received. If the string "unlimited" is supplied, then no frequency
     * limit is requested. It is also possible to supply the string 
     * "unfiltered", to ask for unfiltered dispatching, if it is allowed for the 
     * items, or a null value to stick to the Server default (which currently
     * corresponds to "unlimited").
     * The check for the string constants is case insensitive.
     */
    setRequestedMaxFrequency: function(freq) {
      //can be:
      //null -> do not send to the server
      //unfiltered or unlimited
      //>0 double
      
      if (freq) {
        freq = new String(freq);
        freq = freq.toLowerCase();
      }
      
      var orig = this.requestedMaxFrequency;
      if (this.isActive()) {
        if (!freq && freq != 0) {
          throw new IllegalStateException(ILLEGAL_FREQ_EXC);
        } else if (freq == "unfiltered" || this.requestedMaxFrequency == "unfiltered") {
          throw new IllegalStateException(ILLEGAL_FREQ_EXC);
        }
      }
      
      if (!freq && freq != 0) {
        this.requestedMaxFrequency = null;
      } else {
      
        if (freq == "unfiltered" || freq == "unlimited") {
          this.requestedMaxFrequency = freq;
        } else {
          try {
            this.requestedMaxFrequency = this.checkPositiveNumber(freq,false,true) ;
          } catch(_e) {
            throw new IllegalArgumentException(ValidationUtils.MAX_FREQ_EXC);
          }
        }
      }


      
      
      if ((this.isWaiting() || this.isSubscribing() || this.isPushing()) && String(orig) != String(this.requestedMaxFrequency)) {

        //the value changes at runtime, we need to regenerate the request
        //this.generateRequest();

        //we've already sent the subscription request to the engine,
        //send a new request to contain the frequency change
        this.handler.updateSubscriptionParams(this,this.generateMaxFrequencyParam());
        
        if (this.behavior == MULTIMETAPUSH) {
          var that = this;
          this.subTables.forEachElement(function(el,row,col) {
            //>>excludeStart("debugExclude", pragmas.debugExclude);  
              Assertions.verifyOk(that.isPushing(), "Table not pushing");
            //>>excludeEnd("debugExclude");
              el.setRequestedMaxFrequency(that.requestedMaxFrequency);
          });
        } // if not alive we cannot have subtables...
        
      }
      
      subscriptionsLogger.logDebug(LoggerManager.resolve(919),this,this.requestedMaxFrequency);
    },
    
    /**
     * Inquiry method that can be used to read the max frequency, configured
     * through {@link Subscription#setRequestedMaxFrequency}, to be requested to the 
     * Server for this Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} A decimal number, representing the max frequency to be requested to the server
     * (expressed in updates per second), or the strings "unlimited" or "unfiltered", or null.
     */
    getRequestedMaxFrequency: function() {
      return this.requestedMaxFrequency == null ? null : String(this.requestedMaxFrequency);
    },
  
    /**
     * Setter method that sets the length to be requested to Lightstreamer
     * Server for the internal queueing buffers for the items in the Subscription.
     * A Queueing buffer is used by the Server to accumulate a burst
     * of updates for an item, so that they can all be sent to the client,
     * despite of bandwidth or frequency limits. It can be used only when the
     * subscription mode is MERGE or DISTINCT and unfiltered dispatching has
     * not been requested. Note that the Server may pose an upper limit on the
     * size of its internal buffers.
     *
     * <p class="default-value"><b>Default value:</b> null, meaning to lean
     * on the Server default based on the subscription mode. This means that
     * the buffer size will be 1 for MERGE subscriptions and "unlimited" for
     * DISTINCT subscriptions. See the "General Concepts" document for further details.</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * @throws {IllegalArgumentException} if the specified value is not
     * null nor  "unlimited" nor a valid positive integer number.
     *
     * @param {Number} size The length of the internal queueing buffers to be
     * used in the Server. If the string "unlimited" is supplied, then no buffer
     * size limit is requested (the check is case insensitive). It is also possible
     * to supply a null value to stick to the Server default (which currently
     * depends on the subscription mode).
     *
     * @see Subscription#setRequestedMaxFrequency
     */
    setRequestedBufferSize: function(size) {
      this.notAliveCheck();
      
      //can be
      //null -> do not send to the server
      //unlimited
      //>0 integer
      
      if (!size && size != 0) {
        this.requestedBufferSize = null;
      } else {
        size = new String(size);
        size = size.toLowerCase();
        if (size == "unlimited") {
          this.requestedBufferSize = size;
        } else {
          try {
            this.requestedBufferSize = this.checkPositiveNumber(size);
          } catch(_e) {
            throw new IllegalArgumentException(ValidationUtils.MAX_BUF_EXC);
          }
        }
      }
      
      subscriptionsLogger.logDebug(LoggerManager.resolve(920),this,this.requestedBufferSize);
    },
    
    /**
     * Inquiry method that can be used to read the buffer size, configured though
     * {@link Subscription#setRequestedBufferSize}, to be requested to the Server for
     * this Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} the buffer size to be requested to the server.
     */
    getRequestedBufferSize: function() {
      return this.requestedBufferSize == null ? null : String(this.requestedBufferSize);
    },
  
  
    /**
     * Setter method that enables/disables snapshot delivery request for the
     * items in the Subscription. The snapshot can be requested only if the
     * Subscription mode is MERGE, DISTINCT or COMMAND.
     *
     * <p class="default-value"><b>Default value:</b> "yes" if the Subscription mode is not "RAW",
     * null otherwise.</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * @throws {IllegalArgumentException} if the specified value is not
     * "yes" nor "no" nor null nor a valid integer positive number.
     * @throws {IllegalArgumentException} if the specified value is not
     * compatible with the mode of the Subscription: 
     * <ul>
     *  <li>In case of a RAW Subscription only null is a valid value;</li>
     *  <li>In case of a non-DISTINCT Subscription only null "yes" and "no" are
     *  valid values.</li>
     * </ul>
     *
     * @param {String} required "yes"/"no" to request/not request snapshot
     * delivery (the check is case insensitive). If the Subscription mode is 
     * DISTINCT, instead of "yes", it is also possible to supply a number, 
     * to specify the requested length of the snapshot (though the length of 
     * the received snapshot may be less than requested, because of insufficient 
     * data or server side limits);
     * passing "yes"  means that the snapshot length should be determined
     * only by the Server. Null is also a valid value; if specified no snapshot 
     * preference will be sent to the server that will decide itself whether
     * or not to send any snapshot. 
     * 
     * @see ItemUpdate#isSnapshot
     */
    setRequestedSnapshot: function(required) {
      this.notAliveCheck();

      if (!required && required != 0) {
        //null - admitted for all modes
        this.isRequiredSnapshot = null;
        
      } else {
        required = new String(required);
        required = required.toLowerCase();
        
        if (required == "no") {  
          //the string no - admitted for all modes
          this.isRequiredSnapshot = required;
        
        } else {
          if (this._mode == Constants.RAW) {
            throw new IllegalStateException(RAW_NO_SNAPSHOT);
          }
          
          if (required == "yes") {
            //the string yes - admitted for MERGE, DISTINCT, COMMAND modes
            this.isRequiredSnapshot = required;
            
          } else if (!isNaN(required)) {
            if (this._mode != Constants.DISTINCT) {
              //THROW
              throw new IllegalStateException(NUMERIC_DISTINCT_ONLY);
            }
            
            //a String to be parsed as a >0 int - admitted for DISTINCT mode
            try {
              this.isRequiredSnapshot = this.checkPositiveNumber(required);
            } catch(_e) {
              throw new IllegalArgumentException(REQ_SNAP_EXC);
            }
          
          }  else {
            throw new IllegalArgumentException(REQ_SNAP_EXC);
          }
          
        }
        
      }
      
      subscriptionsLogger.logDebug(LoggerManager.resolve(921),this,this.isRequiredSnapshot);
    },
    
    /**
     * Inquiry method that can be used to read the snapshot preferences, configured
     * through {@link Subscription#setRequestedSnapshot}, to be requested to the Server for
     * this Subscription.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} the snapshot preference to be requested to the server.
     */
    getRequestedSnapshot: function() {
      return this.isRequiredSnapshot;
    },
    
    /**
     * Setter method that sets the "Field List" to be subscribed to through 
     * Lightstreamer Server for the second-level items. It can only be used on
     * COMMAND Subscriptions.
     * <BR>Any call to this method will override any "Field List" or "Field Schema"
     * previously specified for the second-level.
     * <BR>Calling this method enables the two-level behavior:
     * <BR>in synthesis, each time a new key is received on the COMMAND Subscription, 
     * the key value is treated as an Item name and an underlying Subscription for
     * this Item is created and subscribed to automatically, to feed fields specified
     * by this method. This mono-item Subscription is specified through an "Item List"
     * containing only the Item name received. As a consequence, all the conditions
     * provided for subscriptions through Item Lists have to be satisfied. The item is 
     * subscribed to in "MERGE" mode, with snapshot request and with the same maximum
     * frequency setting as for the first-level items (including the "unfiltered" 
     * case). All other Subscription properties are left as the default. When the 
     * key is deleted by a DELETE command on the first-level Subscription, the 
     * associated second-level Subscription is also unsubscribed from. 
     * <BR>Specifying null as parameter will disable the two-level behavior.
     *       
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalArgumentException} if the given object is not null nor 
     * an array.
     * @throws {IllegalArgumentException} if any of the field names in the "Field List"
     * contains a space or is empty/null.
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * @throws {IllegalStateException} if the Subscription mode is not "COMMAND".
     * 
     * @param {String[]} fields An array of Strings containing a list of fields to
     * be subscribed to through the server.
     * <BR>Ensure that no name conflict is generated between first-level and second-level
     * fields. In case of conflict, the second-level field will not be accessible
     * by name, but only by position.
     * 
     * @see Subscription#setCommandSecondLevelFieldSchema
     */
    setCommandSecondLevelFields: function(fields) {
      this.notAliveCheck();
      this.secondLevelCheck();
      
      ValidationUtils.checkFieldNames(fields,"A field");
      
      this.subFieldList = fields == null ? null : new ListDescriptor(fields);
      this.subFieldSchema = null;
      this.subFieldDescriptor = this.subFieldList;
      
      this.prepareSecondLevel();
      
    },
    
    /**
     * Inquiry method that can be used to read the "Field List" specified for 
     * second-level Subscriptions.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the second-level of
     * this Subscription has been initialized using a "Field List"  
     * </p>
     * 
     * @throws {IllegalStateException} if the Subscription was initialized
     * with a field schema or was not initialized at all.
     * 
     * @return {String[]} the list of fields to be subscribed to through the server. 
     */
    getCommandSecondLevelFields: function() {
      if (!this.subFieldList) {
        if (this.subFieldSchema) {
          throw new IllegalStateException("The second level of this Subscription was initiated using a field schema, use getCommandSecondLevelFieldSchema instead of using getCommandSecondLevelFields");
        } else {
          throw new IllegalStateException(NO_SUB_SCHEMA_NOR_LIST);
        }
      }
      return this.subFieldList.getOriginal();
    },
    
    /**
     * Setter method that sets the "Field Schema" to be subscribed to through 
     * Lightstreamer Server for the second-level items. It can only be used on
     * COMMAND Subscriptions.
     * <BR>Any call to this method will override any "Field List" or "Field Schema"
     * previously specified for the second-level.
     * <BR>Calling this method enables the two-level behavior:
     * <BR>in synthesis, each time a new key is received on the COMMAND Subscription, 
     * the key value is treated as an Item name and an underlying Subscription for
     * this Item is created and subscribed to automatically, to feed fields specified
     * by this method. This mono-item Subscription is specified through an "Item List"
     * containing only the Item name received. As a consequence, all the conditions
     * provided for subscriptions through Item Lists have to be satisfied. The item is 
     * subscribed to in "MERGE" mode, with snapshot request and with the same maximum
     * frequency setting as for the first-level items (including the "unfiltered" 
     * case). All other Subscription properties are left as the default. When the 
     * key is deleted by a DELETE command on the first-level Subscription, the 
     * associated second-level Subscription is also unsubscribed from. 
     * <BR>Specify null as parameter will disable the two-level behavior.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     * 
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * @throws {IllegalStateException} if the Subscription mode is not "COMMAND".
     * 
     * @param {String} schemaName A String to be expanded into a field list by the
     * Metadata Adapter. 
     * 
     * @see Subscription#setCommandSecondLevelFields
     */
    setCommandSecondLevelFieldSchema: function(schemaName) {
      this.notAliveCheck();
      this.secondLevelCheck();
      
      this.subFieldList = null;
      this.subFieldSchema = schemaName == null ? null : new NameDescriptor(schemaName);
      this.subFieldDescriptor = this.subFieldSchema;
      
      this.prepareSecondLevel();
      
    },
    
    /**
     * Inquiry method that can be used to read the "Field Schema" specified for 
     * second-level Subscriptions.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the second-level of
     * this Subscription has been initialized using a "Field Schema".
     * </p>
     * 
     * @throws {IllegalStateException} if the Subscription was initialized
     * with a "Field List" or was not initialized at all.
     * 
     * @return {String} the "Field Schema" to be subscribed to through the server. 
     */
    getCommandSecondLevelFieldSchema: function() {
      if (!this.subFieldSchema) {
        if (this.subFieldList) {
          throw new IllegalStateException("The second level of this Subscription was initiated using a field list, use getCommandSecondLevelFields instead of using getCommandSecondLevelFieldSchema");
        } else {
          throw new IllegalStateException(NO_SUB_SCHEMA_NOR_LIST);
        }
      }
      return this.subFieldSchema.getOriginal();
    },
    
    /**
     * Setter method that sets the name of the second-level Data Adapter (within 
     * the Adapter Set used by the current session) that supplies all the 
     * second-level items.
     * All the possible second-level items should be supplied in "MERGE" mode 
     * with snapshot available. 
     * The Data Adapter name is configured on the server side through the 
     * "name" attribute of the &lt;data_provider&gt; element, in the "adapters.xml" 
     * file that defines the Adapter Set (a missing attribute configures the 
     * "DEFAULT" name).
     * 
     * <p class="default-value"><b>Default value:</b> The default Data Adapter for the Adapter Set,
     * configured as "DEFAULT" on the Server.</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the Subscription
     * instance is in its "inactive" state.</p>
     *
     * @throws {IllegalStateException} if the Subscription is currently 
     * "active".
     * @throws {IllegalStateException} if the Subscription mode is not "COMMAND".
     *
     * @param {String} dataAdapter the name of the Data Adapter. A null value 
     * is equivalent to the "DEFAULT" name.
     *  
     * @see Subscription#setCommandSecondLevelFields
     * @see Subscription#setCommandSecondLevelFieldSchema
     */
    setCommandSecondLevelDataAdapter: function(dataAdapter) {
      this.notAliveCheck();
      this.secondLevelCheck();
      
      this.underDataAdapter = dataAdapter;
      subscriptionsLogger.logDebug(LoggerManager.resolve(922),this,dataAdapter);
    },
    
    /**
     * Inquiry method that can be used to read the second-level Data 
     * Adapter name configured through {@link Subscription#setCommandSecondLevelDataAdapter}.
     *  
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @return {String} the name of the second-level Data Adapter.
     */
    getCommandSecondLevelDataAdapter : function() {
      return this.underDataAdapter;
    },
    
    /**
     * Returns the latest value received for the specified item/field pair.
     * <BR>It is suggested to consume real-time data by implementing and adding
     * a proper {@link SubscriptionListener} rather than probing this method.
     * In case of COMMAND Subscriptions, the value returned by this
     * method may be misleading, as in COMMAND mode all the keys received, being
     * part of the same item, will overwrite each other; for COMMAND Subscriptions,
     * use {@link Subscription#getCommandValue} instead.
     * <BR>Note that internal data is cleared when the Subscription is 
     * unsubscribed from. 
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time; if called 
     * to retrieve a value that has not been received yet, then it will return null. 
     * </p>
     * 
     * @throws {IllegalArgumentException} if an invalid item name or field
     * name is specified or if the specified item position or field position is
     * out of bounds.
     * 
     * @param {String} itemIdentifier a String representing an item in the 
     * configured item list or a Number representing the 1-based position of the item
     * in the specified item group. (In case an item list was specified, passing 
     * the item position is also possible).
     * 
     * @param {String} fieldIdentifier a String representing a field in the 
     * configured field list or a Number representing the 1-based position of the field
     * in the specified field schema. (In case a field list was specified, passing 
     * the field position is also possible).
     * 
     * @return {String} the current value for the specified field of the specified item
     * (possibly null), or null if no value has been received yet.
     */
    getValue: function(itemIdentifier, fieldIdentifier) {
      return this.oldValuesByItem.get(this.toItemPos(itemIdentifier),this.toFieldPos(fieldIdentifier));
    },
    
    /**
     * Returns the latest value received for the specified item/key/field combination.
     * This method can only be used if the Subscription mode is COMMAND.
     * Subscriptions with two-level behavior are also supported, hence the specified
     * field can be either a first-level or a second-level one.
     * <BR>It is suggested to consume real-time data by implementing and adding
     * a proper {@link SubscriptionListener} rather than probing this method.
     * <BR>Note that internal data is cleared when the Subscription is 
     * unsubscribed from. 
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time; if called 
     * to retrieve a value that has not been received yet, then it will return null.
     * </p>
     * 
     * @throws {IllegalArgumentException} if an invalid item name or field
     * name is specified or if the specified item position or field position is
     * out of bounds.
     * @throws {IllegalStateException} if the Subscription mode is not 
     * COMMAND.
     * 
     * @param {String} itemIdentifier a String representing an item in the 
     * configured item list or a Number representing the 1-based position of the item
     * in the specified item group. (In case an item list was specified, passing 
     * the item position is also possible).
     * 
     * @param {String} keyValue a String containing the value of a key received
     * on the COMMAND subscription.
     * 
     * @param {String} fieldIdentifier a String representing a field in the 
     * configured field list or a Number representing the 1-based position of the field
     * in the specified field schema. (In case a field list was specified, passing
     * the field position is also possible).
     * 
     * @return {String} the current value for the specified field of the specified
     * key within the specified item (possibly null), or null if the specified
     * key has not been added yet (note that it might have been added and eventually deleted).
     */
    getCommandValue: function(itemIdentifier, keyValue, fieldIdentifier) {
      this.commandCheck();
     
      return this.oldValuesByKey.get(this.toItemPos(itemIdentifier)+" "+keyValue,this.toFieldPos(fieldIdentifier,true));
    },  
    
    /**
     * Returns the position of the "key" field in a COMMAND Subscription.
     * <BR>This method can only be used if the Subscription mode is COMMAND
     * and the Subscription was initialized using a "Field Schema".
     *  
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @throws {IllegalStateException} if the Subscription mode is not 
     * COMMAND or if the {@link SubscriptionListener#onSubscription} event for this Subscription
     * was not yet fired.
     * 
     * @return {Number} the 1-based position of the "key" field within the "Field Schema".
     */
    getKeyPosition: function() {
      this.commandCheck();
      
      if (!this.fieldSchema && this.fieldList) {
        throw new IllegalStateException("This Subscription was initiated using a field list, key field is always 'key'");
      }
      
      if (this.keyCode == null) {
        throw new IllegalStateException("The position of the key field is currently unknown");
      }
      
      return this.keyCode;
    },
    
    /**
     * Returns the position of the "command" field in a COMMAND Subscription.
     * <BR>This method can only be used if the Subscription mode is COMMAND
     * and the Subscription was initialized using a "Field Schema".
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
     * 
     * @throws {IllegalStateException} if the Subscription mode is not 
     * COMMAND or if the {@link SubscriptionListener#onSubscription} event for this Subscription
     * was not yet fired.
     * 
     * @return {Number} the 1-based position of the "command" field within the "Field Schema".
     */
    getCommandPosition: function() {
      this.commandCheck();

      if (!this.fieldSchema && this.fieldList) {
        throw new IllegalStateException("This Subscription was initiated using a field list, command field is always 'command'");
      }
      
      if (this.commandCode == null) {
        throw new IllegalStateException("The position of the command field is currently unknown");
      }
      
      return this.commandCode;
    },
    
    /*private*/ toFieldPos: function(fieldNameOrPos,full) {
      var res = this.toPos(fieldNameOrPos,this.fieldDescriptor,full);
      if (res === null) {
        throw new IllegalArgumentException("the specified field does not exist");
      } else if (res === false) {
        throw new IllegalArgumentException("the specified field position is out of bounds");
      }
      
      return res; 
    },
    
    /*private*/toItemPos: function(itemNameOrPos) {
      var res = this.toPos(itemNameOrPos,this.itemDescriptor);
      if (res === null) {
        throw new IllegalArgumentException("the specified item does not exist");
      } else if (res === false) {
        throw new IllegalArgumentException("the specified item position is out of bounds");
      } 
      return res;
    },
    
    /*private*/ toPos: function(nameOrPos,descriptor,full) {
      var pos = (isNaN(nameOrPos) ? descriptor.getPos(nameOrPos) : nameOrPos);
      if (pos == null) {
        return null;
      } else if (pos <= 0 || pos > (full ? descriptor.getFullSize() : descriptor.getSize())) {
        return false;
      }
      
      return pos;
    },
    
    
    prepareSecondLevel: function() {
      if (this.subFieldDescriptor == null) {
        //disable second level
        this.setBehavior(METAPUSH);
        
      } else {
        //enable second level
        this.setBehavior(MULTIMETAPUSH);
      }
    },

    endOfSnapshot: function(_item) {
      var _name = this.itemDescriptor.getName(_item);
      
      Assertions.assertNotNull(this.snapshotByItem[_item], "Item index out of range");
      this.snapshotByItem[_item].endOfSnapshot();
      this.dispatchEvent("onEndOfSnapshot",[_name,_item]);
    },
    
    clearSnapshot: function(_item) {
      var _name = this.itemDescriptor.getName(_item);
      
      if (this.behavior == METAPUSH) {
        //delete key-status
        this.oldValuesByKey = new Matrix();
      } else if (this.behavior == MULTIMETAPUSH) {
        //delete key-status
        this.oldValuesByKey = new Matrix();
        //unsubscribe subtables
        this.removeItemSubTables(_item);
      }
      this.dispatchEvent("onClearSnapshot",[_name,_item]);
      
    },
    
    lostUpdates: function(_item,lostUpdates,optKeyVal) {
      var _name = this.itemDescriptor.getName(_item);
      
      this.dispatchEvent("onItemLostUpdates",[_name,_item,lostUpdates]);
    },
    
    sonLostUpdates: function(relKey,lostUpdates) {
      this.dispatchEvent("onCommandSecondLevelItemLostUpdates",[lostUpdates,relKey]);
    },
    
    serverDeny: function(flag,msg) {
      this.dispatchEvent("onSubscriptionError",[flag,msg]);
    },
    
    sonServerDeny: function(code,msg,relKey) {
      this.dispatchEvent("onCommandSecondLevelSubscriptionError",[code,msg,relKey]);
    },
    
    update: function(args,snap,fromMultison) {
    //>>excludeStart("debugExclude", pragmas.debugExclude);  
      Assertions.verifyValue(TABLE_PUSHING,this.tablePhaseType, "Wrong table phase");
    //>>excludeEnd("debugExclude");
      // number of the item of the current update
      var _item = args[1];
      
      Assertions.assertNotNull(this.snapshotByItem[_item], "Item index out of range");
      this.snapshotByItem[_item].update();
      var isSnapshot = this.snapshotByItem[_item].isSnapshot();
      
      //OLD for METAPUSH (old is the new value)
      //for item|key and not for per item.
      var _key = new String(_item);
      
      if (this.behavior != SIMPLE) {
        //handle metapush update
        //WARNING, args is modified by the method
        _key = this.organizeMPUpdate(args,_item,fromMultison);
       
        //args enters UNCHANGED by item exits UNCHANGED by key
        //oldValuesByItem is updated with new values
        
      } 
      
      if (this.behavior == MULTIMETAPUSH && !fromMultison) {
        // multi table,
        // here the logic of subscriptions and unregistration is managed
        // here we do not enter if the update is generated by a son as such
        // update all carry as UPDATE command
        this.handleMultiTableSubscriptions(args); 
      }
      
      if (this.behavior == SIMPLE) {
        this.updateStructure(this.oldValuesByItem,_item,args,true);
      } else {
        this.updateStructure(this.oldValuesByKey,_key,args,true);
        
        //organizeMPUpdate has already updated the oldValuesByItem array
      }
      var updateObj =  new ItemUpdate(this.itemDescriptor.getName(_item), _item, this.fieldDescriptor, isSnapshot, args);
      this.dispatchEvent("onItemUpdate",[updateObj]);
 
      if (this.oldValuesByKey.get(_key,this.commandCode) == "DELETE") {
        this.oldValuesByKey.delRow(_key);
      }
      
    },
    
    updateStructure: function(struct,_key,args, fillInUnchanged) {
      var len = args.length - 2;
      var _field = 1;
      var fieldInArgs = 2;
      args.unchangedMap = {};
      for (; _field <= len; _field++, fieldInArgs++) {
        
        if (args[fieldInArgs] !== UNCHANGED) {
          struct.insert(args[fieldInArgs], _key, _field);
        } else if (fillInUnchanged) {
          args[fieldInArgs] = struct.get(_key,_field);
          args.unchangedMap[fieldInArgs] = true;
        }
        
      }
    },
    
    
/////////////METAPUSH    
    
    organizeMPUpdate: function(args,_item,fromMultison) {
      
      var item_key;
      if ((typeof args[this.keyCode + 1] == "undefined")||(typeof args[this.commandCode + 1] == "undefined")) {
        subscriptionsLogger.logWarn(LoggerManager.resolve(923));
        return null;
      }
      
      // the server unchanged are not covered yet, so I need to evaluate what value I need
      if (args[this.keyCode + 1] == UNCHANGED) {
        //unchanged, so take the old value
        item_key = _item + " " + this.oldValuesByItem.get(_item,this.keyCode);
      } else {
        //take the new value
        item_key = _item + " " + args[this.keyCode + 1];
      }
      
      // I cover unchanged item with unchanged key and prepare old item for the next round
      // only makes sense for COMMAND updates, multimetapush child updates
      // are already organized by single key
      if (!fromMultison) {
        args.changedFields = [];
      
        for (var i = 2; i < args.length; i++) {
          if (args[i] && args[i] == UNCHANGED) {
            //if unchanged on server take old _item
            args[i] = this.oldValuesByItem.get(_item,(i - 1));
          } else {
            //copy on old _item the new value
            this.oldValuesByItem.insert(args[i],_item,(i - 1));
          }
          
          if (args[i] == this.oldValuesByKey.get(item_key,(i - 1))) {
            // if server value = old key, overwrite server value with unchanged value
            args[i] = UNCHANGED;
          } else {
            args.changedFields.push(i-1);
          }
        }
      
      
        if (this.behavior == MULTIMETAPUSH) {
          var newL = this.getFullSchemaSize() + 2;
          if(newL > args.length) {
            // I received an update on the table in COMMAND.
            // since this update does not have the fields of the
            // subtable MERGE, I extend the update with unchanged ones.
           
            for (var i = args.length; i < newL; i++) {
              args[i] = UNCHANGED;
            }
          }
        }
        
      } else {
        
        // the update of a child has the same key as item|key which certainly hasn't changed
        args[this.keyCode + 1] = UNCHANGED;
        // the command probably hasn't changed either:
        if (args[this.commandCode + 1] == this.oldValuesByKey.get(item_key,this.commandCode)) {
          args[this.commandCode + 1] = UNCHANGED;
        } else {
          args.changedFields.push(this.commandCode);
          args.changedFields.sort(sortFun);
        }
      }
      return item_key;
    },
    
    
//////////MULTI-METAPUSH    
    
    handleMultiTableSubscriptions: function(args) {
      // manage the logic of subscriptions and unregistration
      var _item = args[1];
      var _key = (args[this.keyCode + 1] == UNCHANGED) ? this.oldValuesByItem.get(_item,this.keyCode) : args[this.keyCode + 1];
      var itemCommand = args[this.commandCode + 1];
      
      var subTableExists = this.hasSubTable(_item,_key);
      if (itemCommand == "DELETE") {
        if (subTableExists) {
          this.removeSubTable(_item,_key);
        }
      } else if (!subTableExists) {
        this.addSubTable(_item,_key);
      }
    },
    
    makeSubTable: function(parentSubscription) {
      this.subTableFlag = true;
      this.realMaxFrequencyManager = new RealMaxFrequencyManager.SecondLevelMultiMetaPushRealMaxFrequencyManager(this, parentSubscription);
    },
    
    isSubTable: function() {
      //do not abuse
      return this.subTableFlag;
    },
    
    hasSubTable: function(_item,_key) {
      return this.subTables.get(_item,_key) !== null;
    },
    
    removeSubTable: function(_item,_key) {
      this.handler.removeATable(this.subTables.get(_item,_key));
      this.subTables.del(_item,_key);
      this.realMaxFrequencyManager.onDeleteSecondLevelSubscription();
    },
    
    addSubTable: function(_item,_key) {
      var st = new Subscription(this.subMode);
      st.makeSubTable(this);
            
      try {
        st.setItems([_key]);
        this.subTables.insert(st,_item,_key);
      } catch(e) {
        this.dispatchEvent("onCommandSecondLevelSubscriptionError", [14, INVALID_SECOND_LEVEL_KEY, _key]);
        return;
      }
      
      if (this.subFieldList) {
        st.setFields(this.subFieldList.getOriginal());
      } else {
        st.setFieldSchema(this.subFieldSchema.getOriginal());
      }
      
      st.setDataAdapter(this.underDataAdapter);
      st.setRequestedSnapshot("yes");
      st.requestedMaxFrequency = this.requestedMaxFrequency;
      

      var subList = new SecondLevelSubscriptionListener(this,_item,_key);
      st.addListener(subList);
            
      this.handler.addATable(st);
    },
    
    setSecondLevelSchemaSize: function(size) {
      this.subFieldDescriptor.setSize(size);
    },
    
    getMainSchemaSize: function() {
      return this.fieldDescriptor.getSize();
    },
    
    getFullSchemaSize: function() {
      return this.fieldDescriptor.getFullSize();
    },
    
    getKeyPos: function() {
      return this.keyCode;
    },
    
    getCommandPos: function() {
      return this.commandCode;
    },
    
    /**
     * Adds a listener that will receive events from the Subscription 
     * instance.
     * <BR>The same listener can be added to several different Subscription 
     * instances.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
     * 
     * @param {SubscriptionListener} listener An object that will receive the events
     * as shown in the {@link SubscriptionListener} interface.
     * <BR>Note that the given instance does not have to implement all of the 
     * methods of the SubscriptionListener interface. In fact it may also 
     * implement none of the interface methods and still be considered a valid 
     * listener. In the latter case it will obviously receive no events.
     */
    addListener: function(listener) {
      this._callSuperMethod(Subscription,"addListener",[listener]);
    },
    
    /**
     * Removes a listener from the Subscription instance so that it
     * will not receive events anymore.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
     * 
     * @param {SubscriptionListener} listener The listener to be removed.
     */
    removeListener: function(listener) {
      this._callSuperMethod(Subscription,"removeListener",[listener]);
    },
    
    /**
     * Returns an array containing the {@link SubscriptionListener} instances that
     * were added to this client.
     * 
     * @return {SubscriptionListener[]} an Array containing the listeners that were added to this client.
     * Listeners added multiple times are included multiple times in the array.
     */
    getListeners: function() {
      return this._callSuperMethod(Subscription,"getListeners");
    },
    
    setBehavior: function(behavior) {
        this.behavior = behavior;
        switch (behavior) {
        case SIMPLE:
        case METAPUSH:
            this.realMaxFrequencyManager = new RealMaxFrequencyManager.FlatPushRealMaxFrequencyManager(this);
            break;
            
        case MULTIMETAPUSH:
            this.realMaxFrequencyManager = new RealMaxFrequencyManager.FirstLevelMultiMetaPushRealMaxFrequencyManager(this);
            break;
            
        default:
            ASSERT.verifyOk(false);
        }
    },
    
    /**
     * Changes the real max frequency of this subscription.
     * <br>If there is a change, the method SubscriptionListener.onRealMaxFrequency is triggered.
     * <br>The method SubscriptionListener.onRealMaxFrequency is also triggered if there is a new maximum
     * among the item frequencies of a two-level command subscription.
     */
    configure: function(frequency) {
        this.realMaxFrequencyManager.configure(frequency);
    }

  };
  
  /*
   * Detects whether the current update is a snapshot according to the rules in the following table.
   * <pre>
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
|                    | r1    | r2       | r3       | r4      | r5      | r6    | r7    | r8    |
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
| snapshot requested | false | true     | true     | true    | true    | true  | true  | true  |
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
| mode               | -     | DISTINCT | DISTINCT | COMMAND | COMMAND | MERGE | MERGE | RAW   |
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
| first update       | -     | -        | -        | -       | -       | false | true  | -     |
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
| EOS received       | -     | false    | true     | false   | true    | -     | -     | -     |
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
| isSnapshot()       | false | true     | false    | true    | false   | false | true  | error |
+--------------------+-------+----------+----------+---------+---------+-------+-------+-------+
   * </pre>
   */
  function SnapshotManager(subscription) {
      this.firstUpdate = true;
      this.eosReceived = false;
      this.state = SnapshotManagerState.NO_UPDATE_RECEIVED;
      this.subscription = subscription;
  }
  
  /**
   * Notifies the manager that a new update is available.
   */
  SnapshotManager.prototype.update = function() {
      if (this.state == SnapshotManagerState.NO_UPDATE_RECEIVED) {
          this.state = SnapshotManagerState.ONE_UPDATE_RECEIVED;
          
      } else if (this.state == SnapshotManagerState.ONE_UPDATE_RECEIVED) {
          this.state = SnapshotManagerState.MORE_THAN_ONE_UPDATE_RECEIVED;
          this.firstUpdate = false;
      }
  };
  
  /**
   * Notifies the manager that the message EOS has arrived.
   */
  SnapshotManager.prototype.endOfSnapshot = function() {
      this.eosReceived = true;
  };
  
  /**
   * Returns true if the user has requested the snapshot.
   */
  SnapshotManager.prototype.snapshotRequested = function() {
      return this.subscription.isRequiredSnapshot != null && this.subscription.isRequiredSnapshot != "no";
  };
  
  /**
   * Returns true if the current update is a snapshot.
   */
  SnapshotManager.prototype.isSnapshot = function() {
      if (! this.snapshotRequested()) {
          // r1
          return false;
          
      } else if (Constants.MERGE == this.subscription._mode) {
          // r6, r7
          return this.firstUpdate;
          
      } else if (Constants.COMMAND == this.subscription._mode || Constants.DISTINCT == this.subscription._mode) {
          // r2, r3, r4, r5
          return ! this.eosReceived;
          
      } else {
          // r8
          // should never happen
          return false;
      }
  };
  
  /*
   * Control states of {@link SnapshotManager}.
   */
  var SnapshotManagerState = {
          NO_UPDATE_RECEIVED: 0,
          ONE_UPDATE_RECEIVED: 1,
          MORE_THAN_ONE_UPDATE_RECEIVED: 2
  };
  
  Subscription.prototype["isActive"] = Subscription.prototype.isActive;
  Subscription.prototype["isSubscribed"] = Subscription.prototype.isSubscribed;
  Subscription.prototype["setItems"] = Subscription.prototype.setItems;
  Subscription.prototype["getItems"] = Subscription.prototype.getItems;
  Subscription.prototype["setItemGroup"] = Subscription.prototype.setItemGroup;
  Subscription.prototype["getItemGroup"] = Subscription.prototype.getItemGroup;
  Subscription.prototype["setFields"] = Subscription.prototype.setFields;
  Subscription.prototype["getFields"] = Subscription.prototype.getFields;
  Subscription.prototype["setFieldSchema"] = Subscription.prototype.setFieldSchema;
  Subscription.prototype["getFieldSchema"] = Subscription.prototype.getFieldSchema;
  Subscription.prototype["getMode"] = Subscription.prototype.getMode;
  Subscription.prototype["setDataAdapter"] = Subscription.prototype.setDataAdapter;
  Subscription.prototype["getDataAdapter"] = Subscription.prototype.getDataAdapter;
  Subscription.prototype["setSelector"] = Subscription.prototype.setSelector;
  Subscription.prototype["getSelector"] = Subscription.prototype.getSelector;
  Subscription.prototype["setRequestedMaxFrequency"] = Subscription.prototype.setRequestedMaxFrequency;
  Subscription.prototype["getRequestedMaxFrequency"] = Subscription.prototype.getRequestedMaxFrequency;
  Subscription.prototype["setRequestedBufferSize"] = Subscription.prototype.setRequestedBufferSize;
  Subscription.prototype["getRequestedBufferSize"] = Subscription.prototype.getRequestedBufferSize;
  Subscription.prototype["setRequestedSnapshot"] = Subscription.prototype.setRequestedSnapshot;
  Subscription.prototype["getRequestedSnapshot"] = Subscription.prototype.getRequestedSnapshot;
  Subscription.prototype["setCommandSecondLevelFields"] = Subscription.prototype.setCommandSecondLevelFields;
  Subscription.prototype["getCommandSecondLevelFields"] = Subscription.prototype.getCommandSecondLevelFields;
  Subscription.prototype["setCommandSecondLevelFieldSchema"] = Subscription.prototype.setCommandSecondLevelFieldSchema;
  Subscription.prototype["getCommandSecondLevelFieldSchema"] = Subscription.prototype.getCommandSecondLevelFieldSchema;
  Subscription.prototype["setCommandSecondLevelDataAdapter"] = Subscription.prototype.setCommandSecondLevelDataAdapter;
  Subscription.prototype["getCommandSecondLevelDataAdapter"] = Subscription.prototype.getCommandSecondLevelDataAdapter;
  Subscription.prototype["getValue"] = Subscription.prototype.getValue;
  Subscription.prototype["getCommandValue"] = Subscription.prototype.getCommandValue;
  Subscription.prototype["getKeyPosition"] = Subscription.prototype.getKeyPosition;
  Subscription.prototype["getCommandPosition"] = Subscription.prototype.getCommandPosition;
  Subscription.prototype["addListener"] = Subscription.prototype.addListener;
  Subscription.prototype["removeListener"] = Subscription.prototype.removeListener;
  Subscription.prototype["getListeners"] = Subscription.prototype.getListeners;
  
  Inheritance(Subscription,EventDispatcher,false,true);
  Inheritance(Subscription,Setter,true,true);
  return Subscription;
})();

var log$3 = LoggerManager.getLoggerProxy(Constants.MPN);

    var SubscriptionEventManager = function(subscription) {
        this.subscription = subscription;
    };
    
    SubscriptionEventManager.prototype = {
      
            /**
             * Called when the user requests a subscription.
             */
            onSubscribe: function(coalescing) {
                this.subscription.coalescing = coalescing;
                this.subscription.stateMachine.subscribe();
            },
            
            /**
             * Called when the user requests an unsubscription.
             */
            onUnsubscribe: function() {
                this.subscription.stateMachine.unsubscribe();
            },
            
            setSubscriptionId: function(subId) {
                this.subscription.PN_subscriptionId = subId;
            },
            
            /**
             * Called when MPNOK is received.
             */
            onSubscribeOK: function(subId) {
                this.setSubscriptionId(subId);
            },
            
            /**
             * Called when the MPN internal adapter sends a new status. 
             */
            onStatusChange: function(status, timestamp) {
                this.subscription.statusTimestamp = timestamp;
                switch (status) {
                case "ACTIVE":
                    this.subscription.stateMachine.activate();
                    break;
                case "TRIGGERED":
                    this.subscription.stateMachine.trigger();
                    break;
                default:
                    var msg = "Unknown status " + status + " (" + this.subscription.PN_subscriptionId + ")";
                    log$3.logError(msg);
                    throw new Error(msg);
                }
            },
            
            /**
             * Called when REQERR is received as subscription response.
             */
            onSubscribeError: function(code, message) {
                this.subscription.stateMachine.onSubscribeError(code, message);
            },
            
            /**
             * Called when REQERR is received as unsubscription response.
             */
            onUnsubscribeError: function(code, message) {
                this.subscription.stateMachine.onUnsubscribeError(code, message);
            },
            
            /**
             * Called when the MPN internal adapter publishes a new server subscription 
             * (i.e. not created by the user by means of a subscription request).
             */
            simulateSubscribe: function(startStatus, timestamp) {
                this.subscription.statusTimestamp = timestamp;
                if ("ACTIVE" == startStatus) {
                    this.subscription.stateMachine.onAddSubscribed();
                } else {
                    //assert "TRIGGERED" == startStatus;
                    this.subscription.stateMachine.onAddTriggered();
                }
            },
            
            /**
             * Called when the MPN internal adapter deletes an item.
             */
            simulateUnsubscribe: function() {
                this.subscription.stateMachine.onDelete();
            },
            
            /**
             * Called when an unsubscription cancels a subscription not already sent over the network.
             */
            cancelSubscription: function() {
                this.subscription.stateMachine.cancelSubscription();
            },
            
            /*
             * Internal setters
             */
            
            onChangeMode: function(_mode) {
                if (this.subscription.mode != _mode) {
                    this.subscription.mode = _mode;
                    this.onPropertyChange("mode");                    
                }
            },

            onChangeGroup: function(group) {
                if (this.subscription.items != group) {
                    this.subscription.items = group;
                    this.onPropertyChange("group");
                }
            },

            onChangeSchema: function(schema) {
                if (this.subscription.fields != schema) {
                    this.subscription.fields = schema;
                    this.onPropertyChange("schema");
                }
            },
            
            onChangeFormat: function(_format) {
                if (this.subscription.format != _format) {
                    this.subscription.format = _format;
                    this.onPropertyChange("notification_format");
                }
            },

            onChangeTrigger: function(trigger) {
                if (this.subscription.trigger != trigger) {
                    this.subscription.trigger = trigger;
                    this.onPropertyChange("trigger");                    
                }
            },

            onChangeAdapter: function(_adapter) {
                if (this.subscription.adapter != _adapter) {
                    this.subscription.adapter = _adapter;
                    this.onPropertyChange("adapter");                    
                }
            },
            
            onChangeRequestedBufferSize: function(size) {
                size = this.subscription._convertBufferSize(size);
                if (this.subscription.requestedBufferSize != size) {
                    this.subscription.requestedBufferSize = size;
                    this.onPropertyChange("requested_buffer_size");
                }
            },
            
            onChangeRequestedMaxFrequency: function(freq) {
                freq = this.subscription._convertFrequency(freq);
                if (this.subscription.requestedMaxFrequency != freq) {
                    this.subscription.requestedMaxFrequency = freq;
                    this.onPropertyChange("requested_max_frequency");
                }
            },

            onChangeTimestamp: function(ts) {
                if (this.subscription.statusTimestamp != ts) {
                    this.subscription.statusTimestamp = ts;
                    this.onPropertyChange("status_timestamp");                    
                }
            },
            
            onPropertyChange: function(prop) {
                this.subscription.dispatchEvent("onPropertyChanged", [prop]);
            }
    };

var MpnSubscription = /*@__PURE__*/(function() {
    var log = LoggerManager.getLoggerProxy(Constants.MPN);

    /**
     * Creates an object to be used to describe an MPN subscription that is going to be subscribed to through the MPN Module of Lightstreamer Server.<BR>
     * The object can be supplied to {@link LightstreamerClient#subscribeMpn} in order to bring the MPN subscription to "active" state.<BR>
     * Note that all of the methods used to describe the subscription to the server can only be called while the instance is in the "inactive" state.
     *
     * <p>
     * Alternatively you can create an MpnSubscription object by passing a single argument either of type
     * <ul>
     * <li> {@link Subscription}: the new object is initialized by copying subscription mode, items, fields 
     * and data adapter from the specified real-time subscription; or</li>
     * <li> {@link MpnSubscription}: the new object is initialized by copying all properties 
     * (including the subscription ID) from the specified MPN subscription. <b>The created MpnSubscription is a copy of 
     * the original MpnSubscription object and represents the same MPN subscription, since their subscription ID 
     * is the same. When the object is supplied to {@link LightstreamerClient#subscribeMpn} in order to bring it 
     * to "active" state, the MPN subscription is modified: any property changed in this MpnSubscription 
     * replaces the corresponding value of the MPN subscription on the server.</b></li>
     * </ul>
     * 
     * @constructor
     * @exports MpnSubscription
     * 
     * @param {String} subscriptionMode The subscription mode for the items, required by Lightstreamer Server. Permitted values are:<ul>
     * <li><code>MERGE</code></li>
     * <li><code>DISTINCT</code></li>
     * </ul>
     * @param {String[]} items An array of items to be subscribed to through Lightstreamer Server. It is also possible specify the "Item List" or
     * "Item Group" later through {@link MpnSubscription#setItems} and {@link MpnSubscription#setItemGroup}.
     * @param {String[]} fields An array of fields for the items to be subscribed to through Lightstreamer Server. It is also possible to specify the "Field List" or
     * "Field Schema" later through {@link MpnSubscription#setFields} and {@link MpnSubscription#setFieldSchema}.
     * @throws IllegalArgumentException If no or invalid subscription mode is passed.
     * @throws IllegalArgumentException If either the items or the fields array is left null.
     * @throws IllegalArgumentException If the specified "Item List" or "Field List" is not valid; see {@link MpnSubscription#setItems} and {@link MpnSubscription#setFields} for details.
     * 
     * @class Class representing a Web Push Notification subscription to be submitted to the MPN Module of a Lightstreamer Server.<BR>
     * It contains subscription details and the listener needed to monitor its status. Real-time data is routed via native push notifications.<BR>
     * In order to successfully subscribe an MPN subscription, first an MpnDevice must be created and registered on the LightstreamerClient with
     * {@link LightstreamerClient#registerForMpn}.<BR>
     * After creation, an MpnSubscription object is in the "inactive" state. When an MpnSubscription object is subscribed to on an LightstreamerClient
     * object, through the {@link LightstreamerClient#subscribeMpn} method, its state switches to "active". This means that the subscription request
     * is being sent to the Lightstreamer Server. Once the server accepted the request, it begins to send real-time events via native push notifications and
     * the MpnSubscription object switches to the "subscribed" state.<BR>
     * If a trigger expression is set, the MPN subscription does not send any push notifications until the expression evaluates to true. When this happens,
     * the MPN subscription switches to "triggered" state and a single push notification is sent. Once triggered, no other push notifications are sent.<BR>
     * When an MpnSubscription is subscribed on the server, it acquires a permanent subscription ID that the server later uses to identify the same
     * MPN subscription on subsequent sessions.<BR>
     * An MpnSubscription can be configured to use either an Item Group or an Item List to specify the items to be subscribed to, and using either a Field Schema
     * or Field List to specify the fields. The same rules that apply to {@link Subscription} apply to MpnSubscription.<BR>
     * An MpnSubscription object can also be provided by the client to represent a pre-existing MPN subscription on the server. In fact, differently than real-time
     * subscriptions, MPN subscriptions are persisted on the server's MPN Module database and survive the session they were created on.<BR>
     * MPN subscriptions are associated with the MPN device, and after the device has been registered the client retrieves pre-existing MPN subscriptions from the
     * server's database and exposes them with the {@link LightstreamerClient#getMpnSubscriptions} method.
     */
    var MpnSubscription = function() {
        this.initDispatcher();
        /* set attribute default values */
        this.mode = null;
        this.format = null;
        this.trigger = null;
        this.items = null;
        this.fields = null;
        this.adapter = null;
        this.PN_subscriptionId = null;
        this.statusTimestamp = 0;
        this.requestedBufferSize = -1;
        this.requestedMaxFrequency = -2;
        this.coalescing = false;
        /*
         * As a general rule, the subscription is wholly initialized when the
         * MpnManager sets the subscription fields with the values coming from the
         * subscription internal adapter.
         * <p>
         * For example suppose that a subscription is created as a copy of another active subscription.
         * It is reasonable that the copy starts in the state INACTIVE (*), but, since the original subscription
         * is already in state SUBSCRIBED, the updates coming from the internal adapter don't mark the field
         * status as modified. However this flag remembers that the copy is not fully initialized so
         * the status is set notwithstanding the internal adapter incoherent information.
         * <p>
         * (*) Starting as INACTIVE, when the state becomes SUBSCRIBED, we can fire the subscription triggers.
         */
        this.needsInitialization = true; // written by MpnManager
        this.eventManager = new SubscriptionEventManager(this);
        this.stateMachine = new StateMachine(this);

        var arg0 = arguments[0];
        if (typeof arg0 == 'string' || arg0 instanceof String) {
            this._init0(arg0, arguments[1], arguments[2]);

        } else if (arg0 instanceof MpnSubscription) {
            this._initFromMpnSubscription(arg0);

        } else if (arg0 instanceof Subscription) {
            this._initFromSubscription(arg0);

        } else {
            throw new Error("Wrong arguments for MpnSubscription constructor");
        }
    };

    MpnSubscription.prototype = {

            _init0: function(mode, items, fields) {
                /* construct object */
                mode = new String(mode).toUpperCase();
                if (mode != "MERGE" && mode != "DISTINCT") {
                    throw new IllegalArgumentException("Only MERGE and DISTINCT modes are allowed for MPN subscriptions");
                }
                this.mode = mode;
                if (items != null) {
                    if (fields == null) {
                        throw new IllegalArgumentException(ValidationUtils.NO_VALID_FIELDS);
                    }
                    if (Helpers.isArray(items)) {
                        this.setItems(items);
                    } else {
                        this.setItems([items]);
                    }
                    this.setFields(fields);
                } else if (fields != null) {
                    throw new IllegalArgumentException(ValidationUtils.YES_FIELDS_NO_ITEMS);
                }
            },

            _initFromSubscription: function(/*Subscription*/ copyFrom) {
                this.mode = copyFrom._mode;
                this.items = copyFrom.itemDescriptor.getComposedString();
                this.fields = copyFrom.fieldDescriptor.getComposedString();
                this.adapter = copyFrom.dataAdapter;
            },

            _initFromMpnSubscription: function(/*MpnSubscription*/ copyFrom) {
                this.mode = copyFrom.mode;
                this.items = copyFrom.items;
                this.fields = copyFrom.fields;
                this.format = copyFrom.format;
                this.trigger = copyFrom.trigger;
                this.adapter = copyFrom.adapter;
                this.PN_subscriptionId = copyFrom.PN_subscriptionId;
                this.requestedBufferSize = copyFrom.requestedBufferSize;
                this.requestedMaxFrequency = copyFrom.requestedMaxFrequency;
            },

            /**
             * Adds a listener that will receive events from the MpnSubscription
             * instance.
             * <BR>The same listener can be added to several different MpnSubscription
             * instances.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
             *
             * @param {MpnSubscriptionListener} listener An object that will receive the events
             * as shown in the {@link MpnSubscriptionListener} interface.
             * <BR>Note that the given instance does not have to implement all of the
             * methods of the MpnSubscriptionListener interface. In fact it may also
             * implement none of the interface methods and still be considered a valid
             * listener. In the latter case it will obviously receive no events.
             */
            addListener: function(listener) {
                this._callSuperMethod(MpnSubscription, "addListener", [listener]);
            },

            /**
             * Removes a listener from the MpnSubscription instance so that it
             * will not receive events anymore.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
             *
             * @param {MpnSubscriptionListener} listener The listener to be removed.
             */
            removeListener: function(listener) {
                this._callSuperMethod(MpnSubscription, "removeListener", [listener]);
            },

            /**
             * Returns an array containing the {@link MpnSubscriptionListener} instances that
             * were added to this client.
             *
             * @return {MpnSubscriptionListener[]} an Array containing the listeners that were added to this client.
             * Listeners added multiple times are included multiple times in the array.
             */
            getListeners: function() {
                return this._callSuperMethod(MpnSubscription, "getListeners");
            },

            /**
             * Returns the JSON structure to be used as the format of push notifications.<BR>
             * This JSON structure is sent by the server to the push notification service provider (FCM or APNs), hence it must follow
             * its specifications.<BR>
             *
             * @return {String} the JSON structure to be used as the format of push notifications.
             *
             * @see #setNotificationFormat
             */
            getNotificationFormat: function() {
                return this.format;
            },

            /**
             * Sets the JSON structure to be used as the format of push notifications.<BR>
             * This JSON structure is sent by the server to the push notification service provider (FCM or APNs), hence it must follow
             * its specifications.<BR>
             * The JSON structure may contain named arguments with the format <code>${field}</code>, or indexed arguments with the format <code>$[1]</code>. These arguments are
             * replaced by the server with the value of corresponding subscription fields before the push notification is sent.<BR>
             * For instance, if the subscription contains fields "stock_name" and "last_price", the notification format could be something like this:<ul>
             * <li><code>{ "notification" : { "body" : "Stock ${stock_name} is now valued ${last_price}" } }</code></li>
             * </ul>
             * Named arguments are available if the Metadata Adapter is a subclass of LiteralBasedProvider or provides equivalent functionality, otherwise only
             * indexed arguments may be used. In both cases common metadata rules apply: field names and indexes are checked against the Metadata Adapter, hence
             * they must be consistent with the schema and group specified.<BR>
             * A special server-managed argument may also be used:<ul>
             * <li><code>${LS_MPN_subscription_ID}</code>: the ID of the MPN subscription generating the push notification.
             * </ul>
             * The MpnBuilder object provides methods to build an appropriate JSON structure from its defining fields.<BR>
             * Note: if the MpnSubscription has been created by the client, such as when obtained through {@link LightstreamerClient#getMpnSubscriptions},
             * named arguments are always mapped to its corresponding indexed argument, even if originally the notification format used a named argument.<BR>
             * Note: the content of this property may be subject to length restrictions (See the "General Concepts" document for more information).
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>notification_format</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {String} format the JSON structure to be used as the format of push notifications.
             * @throws IllegalStateException if the MpnSubscription is currently "active".
             *
             * @see FirebaseMpnBuilder
             * @see SafariMpnBuilder
             */
            setNotificationFormat: function(format) {
                this.throwErrorIfActive();
                this.format = format;
            },

            /**
             * Returns the boolean expression that is evaluated against each update and acts as a trigger to deliver the push notification.
             *
             * @return {boolean} the boolean expression that acts as a trigger to deliver the push notification.
             *
             * @see #setTriggerExpression
             */
            getTriggerExpression: function() {
                return this.trigger;
            },

            /**
             * Sets the boolean expression that will be evaluated against each update and will act as a trigger to deliver the push notification.<BR>
             * If a trigger expression is set, the MPN subscription does not send any push notifications until the expression evaluates to true. When this happens,
             * the MPN subscription "triggers" and a single push notification is sent. Once triggered, no other push notifications are sent. In other words, with a trigger
             * expression set, the MPN subscription sends *at most one* push notification.<BR>
             * The expression must be in Java syntax and can contain named arguments with the format <code>${field}</code>, or indexed arguments with the format <code>$[1]</code>.
             * The same rules that apply to {@link MpnSubscription#setNotificationFormat} apply also to the trigger expression. The expression is verified and evaluated on the server.<BR>
             * Named and indexed arguments are replaced by the server with the value of corresponding subscription fields before the expression is evaluated. They are
             * represented as String variables, and as such appropriate type conversion must be considered. E.g.<ul>
             * <li><code>Double.parseDouble(${last_price}) &gt; 500.0</code></li>
             * </ul>
             * Argument variables are named with the prefix <code>LS_MPN_field</code> followed by an index. Thus, variable names like <code>LS_MPN_field1</code> should be considered
             * reserved and their use avoided in the expression.<BR>
             * Consider potential impact on server performance when writing trigger expressions. Since Java code may use classes and methods of the JDK, a badly written
             * trigger may cause CPU hogging or memory exhaustion. For this reason, a server-side filter may be applied to refuse poorly written (or even
             * maliciously crafted) trigger expressions. See the "General Concepts" document for more information.<BR>
             * Note: if the MpnSubscription has been created by the client, such as when obtained through {@link LightstreamerClient#getMpnSubscriptions},
             * named arguments are always mapped to its corresponding indexed argument, even if originally the trigger expression used a named argument.<BR>
             * Note: the content of this property may be subject to length restrictions (See the "General Concepts" document for more information).
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>trigger</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {boolean} expr the boolean expression that acts as a trigger to deliver the push notification.
             * @throws IllegalStateException if the MpnSubscription is currently "active".
             *
             * @see #isTriggered
             */
            setTriggerExpression: function(expr) {
                this.throwErrorIfActive();
                this.trigger = expr;
            },

            /**
             * Checks if the MpnSubscription is currently "active" or not.<BR>
             * Most of the MpnSubscription properties cannot be modified if an MpnSubscription is "active".<BR>
             * The status of an MpnSubscription is changed to "active" through the {@link LightstreamerClient#subscribeMpn} method and back to "inactive"
             * through the {@link LightstreamerClient#unsubscribeMpn} and {@link LightstreamerClient#unsubscribeMpnSubscriptions} ones.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {boolean}true if the MpnSubscription is currently "active", false otherwise.
             *
             * @see #getStatus
             * @see LightstreamerClient#subscribeMpn
             * @see LightstreamerClient#unsubscribeMpn
             * @see LightstreamerClient#unsubscribeMpnSubscriptions
             */
            isActive: function() {
                return this.stateMachine.state.isActive;
            },

            /**
             * Checks if the MpnSubscription is currently subscribed to through the server or not.<BR>
             * This flag is switched to true by server sent subscription events, and back to false in case of client disconnection,
             * {@link LightstreamerClient#unsubscribeMpn} or {@link LightstreamerClient#unsubscribeMpnSubscriptions} calls, and server sent
             * unsubscription events.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {boolean} true if the MpnSubscription has been successfully subscribed on the server, false otherwise.
             *
             * @see #getStatus
             * @see LightstreamerClient#unsubscribe
             * @see LightstreamerClient#unsubscribeMpnSubscriptions
             */
            isSubscribed: function() {
                return this.stateMachine.state.isSubscribed;
            },

            /**
             * Checks if the MpnSubscription is currently triggered or not.<BR>
             * This flag is switched to true when a trigger expression has been set and it evaluated to true at least once. For this to happen, the subscription
             * must already be in "active" and "subscribed" states. It is switched back to false if the subscription is modified with a
             * {@link LightstreamerClient#subscribeMpn} call on a copy of it, deleted with {@link LightstreamerClient#unsubscribeMpn} or
             * {@link LightstreamerClient#unsubscribeMpnSubscriptions} calls, and server sent subscription events.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {boolean} true if the MpnSubscription's trigger expression has been evaluated to true at least once, false otherwise.
             *
             * @see #getStatus
             * @see LightstreamerClient#subscribe
             * @see LightstreamerClient#unsubscribe
             * @see LightstreamerClient#unsubscribeMpnSubscriptions
             */
            isTriggered: function() {
                return this.stateMachine.state.isTriggered;
            },

            /**
             * The status of the subscription.<BR>
             * The status can be:<ul>
             * <li><code>UNKNOWN</code>: when the MPN subscription has just been created or deleted (i.e. unsubscribed). In this status {@link MpnSubscription#isActive}, {@link MpnSubscription#isSubscribed}
             * and {@link MpnSubscription#isTriggered} are all false.</li>
             * <li><code>ACTIVE</code>: when the MPN subscription has been submitted to the server, but no confirm has been received yet. In this status {@link MpnSubscription#isActive} is true,
             * {@link MpnSubscription#isSubscribed} and {@link MpnSubscription#isTriggered} are false.</li>
             * <li><code>SUBSCRIBED</code>: when the MPN subscription has been successfully subscribed on the server. If a trigger expression is set, it has not been
             * evaluated to true yet. In this status {@link MpnSubscription#isActive} and {@link MpnSubscription#isSubscribed} are true, {@link MpnSubscription#isTriggered} is false.</li>
             * <li><code>TRIGGERED</code>: when the MPN subscription has a trigger expression set, has been successfully subscribed on the server and
             * the trigger expression has been evaluated to true at least once. In this status {@link MpnSubscription#isActive}, {@link MpnSubscription#isSubscribed} and {@link MpnSubscription#isTriggered} are all true.</li>
             * </ul>
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the status of the subscription.
             *
             * @see #isActive
             * @see #isSubscribed
             * @see #isTriggered
             */
            getStatus: function() {
                return this.stateMachine.state.status;
            },

            /**
             * The server-side timestamp of the subscription status.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>status_timestamp</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @return {Number} The server-side timestamp of the subscription status, expressed as a Java time.
             *
             * @see #getStatus
             */
            getStatusTimestamp: function() {
                return this.statusTimestamp;
            },

            /**
             * Setter method that sets the "Item List" to be subscribed to through
             * Lightstreamer Server. <BR>
             * Any call to this method will override any "Item List" or "Item Group"
             * previously specified.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>group</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {String[]} items an array of items to be subscribed to through the server.
             * @throws IllegalArgumentException if any of the item names in the "Item List"
             * contains a space or is a number or is empty/null.
             * @throws IllegalStateException if the MpnSubscription is currently
             * "active".
             */
            setItems: function(items) {
                this.throwErrorIfActive();
                ValidationUtils.checkItemNames(items, "An item");
                this.items = items.join(' ');
            },

            /**
             * Inquiry method that can be used to read the "Item List" specified for this MpnSubscription.<BR>
             * Note that if the single-item-constructor was used, this method will return an array
             * of length 1 containing such item.<BR>
             * Note: if the MpnSubscription has been created by the client, such as when obtained through {@link LightstreamerClient#getMpnSubscriptions},
             * items are always expressed with an "Item Group"", even if originally the MPN subscription used an "Item List".
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the MpnSubscription has been initialized
             * with an "Item List".</p>

             * @return {String[]} the "Item List" to be subscribed to through the server.
             *
             * @throws IllegalStateException if the MpnSubscription was not initialized.
             */
            getItems: function() {
                if (this.items == null) {
                    throw new IllegalStateException(ValidationUtils.NO_GROUP_NOR_LIST);
                }
                return this.items.split(' ');
            },

            /**
             * Setter method that sets the "Item Group" to be subscribed to through
             * Lightstreamer Server. <BR>
             * Any call to this method will override any "Item List" or "Item Group"
             * previously specified.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>group</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {String} groupName A String to be expanded into an item list by the
             * Metadata Adapter.
             * @throws IllegalStateException if the MpnSubscription is currently
             * "active".
             */
            setItemGroup: function(group) {
                this.throwErrorIfActive();
                this.items = (group == null ? null : String(group));
            },

            /**
             * Inquiry method that can be used to read the item group specified for this MpnSubscription.<BR>
             * Note: if the MpnSubscription has been created by the client, such as when obtained through {@link LightstreamerClient#getMpnSubscriptions},
             * items are always expressed with an "Item Group"", even if originally the MPN subscription used an "Item List".
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the MpnSubscription has been initialized
             * using an "Item Group"</p>
             *
             * @return {String} the "Item Group" to be subscribed to through the server.
             *
             * @throws IllegalStateException if the MpnSubscription was not initialized.
             */
            getItemGroup: function() {
                if (this.items == null) {
                    throw new IllegalStateException(ValidationUtils.NO_GROUP_NOR_LIST);
                }
                return this.items;
            },

            /**
             * Setter method that sets the "Field List" to be subscribed to through
             * Lightstreamer Server. <BR>
             * Any call to this method will override any "Field List" or "Field Schema"
             * previously specified.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>schema</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {String[]} fields an array of fields to be subscribed to through the server.
             * @throws IllegalArgumentException if any of the field names in the list
             * contains a space or is empty/null.
             * @throws IllegalStateException if the MpnSubscription is currently
             * "active".
             */
            setFields: function(fields) {
                this.throwErrorIfActive();
                ValidationUtils.checkFieldNames(fields, "A field");
                this.fields = fields.join(' ');
            },

            /**
             * Inquiry method that can be used to read the "Field List" specified for this MpnSubscription.<BR>
             * Note: if the MpnSubscription has been created by the client, such as when obtained through {@link LightstreamerClient#getMpnSubscriptions},
             * fields are always expressed with a "Field Schema"", even if originally the MPN subscription used a "Field List".
             *
             * <p class="lifecycle"><b>Lifecycle:</b>  This method can only be called if the MpnSubscription has been initialized
             * using a "Field List".</p>
             *
             * @return {String[]} the "Field List" to be subscribed to through the server.
             *
             * @throws IllegalStateException if the MpnSubscription was not initialized.
             */
            getFields: function() {
                if (this.fields == null) {
                    throw new IllegalStateException(ValidationUtils.NO_SCHEMA_NOR_LIST);
                }
                return this.fields.split(' ');
            },

            /**
             * Setter method that sets the "Field Schema" to be subscribed to through
             * Lightstreamer Server. <BR>
             * Any call to this method will override any "Field List" or "Field Schema"
             * previously specified.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>schema</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {String} schemaName A String to be expanded into a field list by the
             * Metadata Adapter.
             *
             * @throws IllegalStateException if the MpnSubscription is currently
             * "active".
             */
            setFieldSchema: function(schema) {
                this.throwErrorIfActive();
                this.fields = (schema == null ? null : String(schema));
            },

            /**
             * Inquiry method that can be used to read the field schema specified for this MpnSubscription.<BR>
             * Note: if the MpnSubscription has been created by the client, such as when obtained through {@link LightstreamerClient#getMpnSubscriptions},
             * fields are always expressed with a "Field Schema"", even if originally the MPN subscription used a "Field List".
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called if the MpnSubscription has been initialized
             * using a "Field Schema"</p>
             *
             * @return {String} the "Field Schema" to be subscribed to through the server.

             * @throws IllegalStateException if the MpnSubscription was not initialized.
             */
            getFieldSchema: function() {
                if (this.fields == null) {
                    throw new IllegalStateException(ValidationUtils.NO_SCHEMA_NOR_LIST);
                }
                return this.fields;
            },

            /**
             * Setter method that sets the name of the Data Adapter
             * (within the Adapter Set used by the current session)
             * that supplies all the items for this MpnSubscription. <BR>
             * The Data Adapter name is configured on the server side through
             * the "name" attribute of the "data_provider" element, in the
             * "adapters.xml" file that defines the Adapter Set (a missing attribute
             * configures the "DEFAULT" name). <BR>
             * Note that if more than one Data Adapter is needed to supply all the
             * items in a set of items, then it is not possible to group all the
             * items of the set in a single MpnSubscription. Multiple MpnSubscriptions
             * have to be defined.
             *
             * <p class="default-value"><b>Default value:</b> The default Data Adapter for the Adapter Set,
             * configured as "DEFAULT" on the Server.</p>
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>adapter</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param {String} dataAdapter the name of the Data Adapter. A null value
             * is equivalent to the "DEFAULT" name.
             * @throws IllegalStateException if the Subscription is currently
             * "active".
             *
             * @see ConnectionDetails#setAdapterSet
             */
            setDataAdapter: function(adapter) {
                this.throwErrorIfActive();
                this.adapter = adapter;
            },

            /**
             * Inquiry method that can be used to read the name of the Data Adapter specified for this
             * MpnSubscription through {@link MpnSubscription#setDataAdapter}.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the name of the Data Adapter; returns null if no name has been configured,
             * so that the "DEFAULT" Adapter Set is used.
             */
            getDataAdapter: function() {
                return this.adapter;
            },

            /**
             * Setter method that sets the length to be requested to Lightstreamer
             * Server for the internal queuing buffers for the items in the MpnSubscription.<BR>
             * A Queuing buffer is used by the Server to accumulate a burst
             * of updates for an item, so that they can all be sent to the client,
             * despite of bandwidth or frequency limits.<BR>
             * Note that the Server may pose an upper limit on the size of its internal buffers.
             *
             * <p class="default-value"><b>Default value:</b> null, meaning to lean on the Server default based on the subscription
             * mode. This means that the buffer size will be 1 for MERGE
             * subscriptions and "unlimited" for DISTINCT subscriptions. See
             * the "General Concepts" document for further details.</p>
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>requested_buffer_size</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param size  An integer number, representing the length of the internal queuing buffers
             * to be used in the Server. If the string "unlimited" is supplied, then no buffer
             * size limit is requested (the check is case insensitive). It is also possible
             * to supply a null value to stick to the Server default (which currently
             * depends on the subscription mode).
             * @throws IllegalStateException if the MpnSubscription is currently
             * "active".
             * @throws IllegalArgumentException if the specified value is not
             * null nor "unlimited" nor a valid positive integer number.
             *
             * @see MpnSubscription#setRequestedMaxFrequency
             */
            setRequestedBufferSize: function(size) {
                this.throwErrorIfActive();
                var n = this._convertBufferSize(size);
                if (isNaN(n)) {
                    throw new IllegalArgumentException(ValidationUtils.MAX_BUF_EXC);
                }
                this.requestedBufferSize = n;
            },

            _convertBufferSize: function(size) {
                if (size == null) {
                    return -1;
                } else if (new String(size).toLowerCase() == "unlimited") {
                    return 0;
                } else {
                    var n = parseInt(size, 10);
                    return (n > 0 ? n : NaN);
                }
            },

            /**
             * Inquiry method that can be used to read the buffer size, configured though
             * {@link MpnSubscription#setRequestedBufferSize}, to be requested to the Server for
             * this MpnSubscription.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {Number|String} An integer number, representing the buffer size to be requested to the server,
             * or the string "unlimited", or null.
             */
            getRequestedBufferSize: function() {
                if (this.requestedBufferSize == -1) {
                    return null;
                } else if (this.requestedBufferSize == 0) {
                    return "unlimited";
                } else {
                    return String(this.requestedBufferSize);
                }
            },

            /**
             * Setter method that sets the maximum update frequency to be requested to
             * Lightstreamer Server for all the items in the MpnSubscription.<BR>
             * Note that frequency limits on the items can also be set on the
             * server side and this request can only be issued in order to further
             * reduce the frequency, not to rise it beyond these limits.
             *
             * <p class="edition-note"><B>Edition Note:</B> A further global frequency limit could also be imposed by the Server,
             * depending on Edition and License Type.
             * To know what features are enabled by your license, please see the License tab of the
             * Monitoring Dashboard (by default, available at /dashboard).</p>
             *
             * <p class="default-value"><b>Default value:</b> null, meaning to lean on the Server default based on the subscription
             * mode. This consists, for all modes, in not applying any frequency
             * limit to the subscription (the same as "unlimited"); see the "General Concepts"
             * document for further details.</p>
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called while the MpnSubscription
             * instance is in its "inactive" state.</p>
             *
             * <p class="notification"><b>Notification:</b> A change to this setting will be notified through a call to {@link MpnSubscriptionListener#onPropertyChanged}
             * with argument <code>requested_max_frequency</code> on any {@link MpnSubscriptionListener} listening to the related MpnSubscription.</p>
             *
             * @param freq  A decimal number, representing the maximum update frequency (expressed in updates
             * per second) for each item in the Subscription; for instance, with a setting
             * of 0.5, for each single item, no more than one update every 2 seconds
             * will be received. If the string "unlimited" is supplied, then no frequency
             * limit is requested. It is also possible to supply the null value to stick
             * to the Server default (which currently corresponds to "unlimited").
             * The check for the string constants is case insensitive.
             * @throws IllegalStateException if the MpnSubscription is currently
             * "active".
             * @throws IllegalArgumentException if the specified value is not
             * null nor the special "unlimited" value nor a valid positive number.
             */
            setRequestedMaxFrequency: function(freq) {
                this.throwErrorIfActive();
                var n = this._convertFrequency(freq);
                if (isNaN(n)) {
                    throw new IllegalArgumentException("The given value is not valid for this setting; use null, 'unlimited' or a positive number instead");
                }
                this.requestedMaxFrequency = n;
            },

            _convertFrequency: function(freq) {
                if (freq == null) {
                    return -2;

                } else {
                    var strFreq = String(freq).toLowerCase();
                    if (strFreq == "unlimited") {
                        return 0;

                    } else {
                        var n = parseFloat(freq);
                        return (n > 0 ? n : NaN);
                    }
                }
            },

            /**
             * Inquiry method that can be used to read the max frequency, configured
             * through {@link MpnSubscription#setRequestedMaxFrequency}, to be requested to the
             * Server for this MpnSubscription.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {Number|String} A decimal number, representing the max frequency to be requested to the server
             * (expressed in updates per second), or the string "unlimited", or null.
             */
            getRequestedMaxFrequency: function() {
                if (this.requestedMaxFrequency == -2) {
                    return null;
                } else if (this.requestedMaxFrequency == 0) {
                    return "unlimited";
                } else {
                    return String(this.requestedMaxFrequency);
                }
            },

            /**
             * Inquiry method that can be used to read the mode specified for this
             * MpnSubscription.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the MpnSubscription mode specified in the constructor.
             */
            getMode: function() {
                return this.mode;
            },

            /**
             * The server-side unique persistent ID of the MPN subscription.<BR>
             * The ID is available only after the MPN subscription has been successfully subscribed on the server. I.e. when its status is <code>SUBSCRIBED</code> or
             * <code>TRIGGERED</code>.<BR>
             * Note: more than one MpnSubscription may exists at any given time referring to the same MPN subscription, and thus with the same subscription ID.
             * For instace, copying an MpnSubscription with the copy initializer creates a second MpnSubscription instance with the same subscription ID. Also,
             * the <code>coalescing</code> flag of {@link LightstreamerClient#subscribeMpn} may cause the assignment of a pre-existing MPN subscription ID
             * to the new subscription.<BR>
             * Two MpnSubscription objects with the same subscription ID always represent the same server-side MPN subscription. It is the client's duty to keep the status
             * and properties of these objects up to date and aligned.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the MPN subscription ID.
             */
            getSubscriptionId: function() {
                return this.PN_subscriptionId;
            },

            /* Support methods */

            throwErrorIfActive: function() {
                if (this.stateMachine.state.isActive) {
                    throw new IllegalStateException(
                            "Cannot modify an active subscription, please unsubscribe before applying any change");
                }
            },

            throwErrorIfInactiveOrUnsubscribing: function() {
                if (this.stateMachine.state == State.INACTIVE || this.stateMachine.state == State.UNSUBSCRIBING) {
                    // this is the same behavior of removing a Subscription: the error is directed to the user
                    throw new IllegalStateException("MpnSubscription is not active");
                }
            }
    };

    function State(isActive, isSubscribed, isTriggered, status, internalName) {
        this.isActive = isActive;
        this.isSubscribed = isSubscribed;
        this.isTriggered = isTriggered;
        this.status = status;
        this.internalName = internalName;
    }

    State.INACTIVE = new State(false, false, false, "UNKNOWN", "INACTIVE");
    State.SUBSCRIBING = new State(true, false, false, "ACTIVE", "SUBSCRIBING");
    State.SUBSCRIBED = new State(true, true, false, "SUBSCRIBED", "SUBSCRIBED");
    State.TRIGGERED = new State(true, true, true, "TRIGGERED", "TRIGGERED");
    State.UNSUBSCRIBING = new State(true, false, false, "UNKNOWN", "UNSUBSCRIBING");

    var StateMachine = function(subscription) {
        this.subscription = subscription;
        this.state = State.INACTIVE;
    };

    StateMachine.prototype = {

            /**
             * User wants to subscribe.
             */
            subscribe: function() {
                var event = "subscribe";
                switch (this.state) {

                case State.INACTIVE:
                    this.next(State.SUBSCRIBING, event);
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * User wants to unsubscribe.
             */
            unsubscribe: function() {
                var event = "unsubscribe";
                switch (this.state) {

                case State.SUBSCRIBING:
                case State.SUBSCRIBED:
                case State.TRIGGERED:
                    this.next(State.UNSUBSCRIBING, event);
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * Called when an unsubscription cancels a subscription not already sent over the network.
             */
            cancelSubscription: function() {
                var event = "cancelSubscription";
                switch (this.state) {

                case State.UNSUBSCRIBING:
                    this.next(State.INACTIVE, event);
                    this.subscription.dispatchEvent("onUnsubscription");
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * MPN internal adapter sends ACTIVE.
             */
            activate: function() {
                var event = "activate";
                switch (this.state) {

                case State.SUBSCRIBING:
                case State.TRIGGERED:
                    this.next(State.SUBSCRIBED, event);
                    this.subscription.dispatchEvent("onSubscription");
                    break;

                case State.UNSUBSCRIBING:
                    this.next(State.UNSUBSCRIBING, event);
                    this.subscription.dispatchEvent("onSubscription");
                    break;

                case State.SUBSCRIBED:
                    // two activations in a row can happen if the client creates a new session after a session error:
                    // the first activation happens in the first session, while the second activation happens in
                    // the second session
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * MPN internal adapter sends TRIGGERED.
             */
            trigger: function() {
                var event = "trigger";
                switch (this.state) {
                case State.SUBSCRIBING:
                case State.SUBSCRIBED:
                    this.next(State.TRIGGERED, event);
                    this.subscription.dispatchEvent("onTriggered");
                    break;

                case State.UNSUBSCRIBING:
                    this.next(State.UNSUBSCRIBING, event);
                    this.subscription.dispatchEvent("onSubscription");
                    break;

                case State.TRIGGERED:
                    // two triggers in a row can happen if the client creates a new session after a session error
                    // the first trigger happens in the first session, while the second trigger happens in
                    // the second session
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * MPN internal adapter deletes the server subscription.
             */
            onDelete: function() {
                var event = "onDelete";
                switch (this.state) {
                case State.SUBSCRIBED:
                case State.TRIGGERED:
                case State.UNSUBSCRIBING:
                    this.subscription.dispatchEvent("onUnsubscription");
                    this.next(State.INACTIVE, event);
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * Subscription request receives REQERR.
             */
            onSubscribeError: function(code, message) {
                var event = "onREQERR";
                switch (this.state) {

                case State.SUBSCRIBING:
                case State.UNSUBSCRIBING:
                    this.subscription.dispatchEvent("onSubscriptionError", [code, message]);
                    this.next(State.INACTIVE, event);
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * Unsubscription request receives REQERR.
             */
            onUnsubscribeError: function(code, message) {
                var event = "onREQERR";
                switch (this.state) {

                case State.UNSUBSCRIBING:
                    this.subscription.dispatchEvent("onUnsubscriptionError", [code, message]);
                    this.next(State.INACTIVE, event);
                    break;

                default:
                    this.throwError(event);
                }
            },

            /**
             * MPN internal adapter publishes one new server subscription starting as subscribed.
             */
            onAddSubscribed: function() {
                if (this.state != State.INACTIVE) {
                    this.throwError("onAddAsSubscribed");
                }
                this.next(State.SUBSCRIBED, "onAddAsSubscribed");
                this.subscription.dispatchEvent("onSubscription");
            },

            /**
             * MPN internal adapter publishes one new server subscription starting as triggered.
             */
            onAddTriggered: function() {
                if (this.state != State.INACTIVE) {
                    this.throwError("onAddAsTriggered");
                }
                this.next(State.TRIGGERED, "onAddAsTriggered");
                this.subscription.dispatchEvent("onTriggered");
            },

            next: function(next, event) {
                if (log.isDebugLogEnabled()) {
                    var from = this.state.internalName;
                    var to = next.internalName;
                    log.logDebug(LoggerManager.resolve(924), this.subscription.PN_subscriptionId + " on '" + event + "': " + from + " -> " + to);
                }
                var old = this.state;
                this.state = next;
                if (old.status != next.status) {
                    this.subscription.dispatchEvent("onStatusChanged", [this.state.status, this.subscription.statusTimestamp]);
                }
            },

            throwError: function(event) {
                var msg = "Unexpected event '" + event + "' in state " + this.state.internalName + " (" + this.subscription.PN_subscriptionId + ")";
                log.logError(msg);
                throw new Error(msg);
            }
    };

    MpnSubscription.prototype["getNotificationFormat"] = MpnSubscription.prototype.getNotificationFormat;
    MpnSubscription.prototype["setNotificationFormat"] = MpnSubscription.prototype.setNotificationFormat;
    MpnSubscription.prototype["getTriggerExpression"] = MpnSubscription.prototype.getTriggerExpression;
    MpnSubscription.prototype["setTriggerExpression"] = MpnSubscription.prototype.setTriggerExpression;
    MpnSubscription.prototype["isActive"] = MpnSubscription.prototype.isActive;
    MpnSubscription.prototype["isSubscribed"] = MpnSubscription.prototype.isSubscribed;
    MpnSubscription.prototype["isTriggered"] = MpnSubscription.prototype.isTriggered;
    MpnSubscription.prototype["getStatus"] = MpnSubscription.prototype.getStatus;
    MpnSubscription.prototype["getStatusTimestamp"] = MpnSubscription.prototype.getStatusTimestamp;
    MpnSubscription.prototype["setItems"] = MpnSubscription.prototype.setItems;
    MpnSubscription.prototype["getItems"] = MpnSubscription.prototype.getItems;
    MpnSubscription.prototype["setItemGroup"] = MpnSubscription.prototype.setItemGroup;
    MpnSubscription.prototype["getItemGroup"] = MpnSubscription.prototype.getItemGroup;
    MpnSubscription.prototype["setFields"] = MpnSubscription.prototype.setFields;
    MpnSubscription.prototype["getFields"] = MpnSubscription.prototype.getFields;
    MpnSubscription.prototype["setFieldSchema"] = MpnSubscription.prototype.setFieldSchema;
    MpnSubscription.prototype["getFieldSchema"] = MpnSubscription.prototype.getFieldSchema;
    MpnSubscription.prototype["setDataAdapter"] = MpnSubscription.prototype.setDataAdapter;
    MpnSubscription.prototype["getDataAdapter"] = MpnSubscription.prototype.getDataAdapter;
    MpnSubscription.prototype["setRequestedBufferSize"] = MpnSubscription.prototype.setRequestedBufferSize;
    MpnSubscription.prototype["getRequestedBufferSize"] = MpnSubscription.prototype.getRequestedBufferSize;
    MpnSubscription.prototype["setRequestedMaxFrequency"] = MpnSubscription.prototype.setRequestedMaxFrequency;
    MpnSubscription.prototype["getRequestedMaxFrequency"] = MpnSubscription.prototype.getRequestedMaxFrequency;
    MpnSubscription.prototype["getMode"] = MpnSubscription.prototype.getMode;
    MpnSubscription.prototype["getSubscriptionId"] = MpnSubscription.prototype.getSubscriptionId;
    MpnSubscription.prototype["addListener"] = MpnSubscription.prototype.addListener;
    MpnSubscription.prototype["removeListener"] = MpnSubscription.prototype.removeListener;
    MpnSubscription.prototype["getListeners"] = MpnSubscription.prototype.getListeners;

    Inheritance(MpnSubscription,EventDispatcher);
    return MpnSubscription;
})();

/**
     * API exposed to SessionManager
     */
	var MpnEventManager = function(mpnManager) {
		this.mpnManager = mpnManager;
	};
	
	MpnEventManager.prototype = {
			
			/**
	         * Fired when a new session is started.
	         */
	        onSessionStart: function() {
	            try {
	                this.mpnManager.stateMachine.onSessionStart();	                
	            } catch(e) {
	                this.mpnManager.onFatalError(e);
	            }
	        },
	        
	        /**
	         * Fired when the current session is closed.
	         * 
	         * @param recovery if the flag is true, the closing is due to an automatic recovery.
	         * Otherwise the closing is due to a disconnection made by the user
	         * (see {@link LightstreamerClient#disconnect()}).
	         */
	        onSessionClose: function(recovery) {
	            try {
	                this.mpnManager.stateMachine.onSessionClose(recovery);
	            } catch(e) {
                    this.mpnManager.onFatalError(e);
                }
            },
	        
	        /**
	         * Fired when the message MPNREG is received.
	         */
	        onRegisterOK: function(deviceId, adapterName) {
	            try {
	                this.mpnManager.stateMachine.onRegisterOK(deviceId, adapterName);
	            } catch(e) {
                    this.mpnManager.onFatalError(e);
                }
	        },
	        
	        /**
	         * Fired when a REQERR is received as a response of a register request.
	         */
	        onRegisterError: function(code, message) {
	        	this.mpnManager.stateMachine.onRegisterError(code, message);
	        },
	        
	        /**
	         * Fired when the message MPNOK is received.
	         * <p>
	         * <b>NB</b> Each subscription request has two identifiers: a subId, which is used to identify the 
	         * subscription and corresponds to the second argument of the message MPNOK, and an ephemeralSubId,
	         * which temporarily identifies the request until MPNOK is received and corresponds to the parameter
	         * LS_subId of the subscription request.
	         */
	        onSubscribeOK: function(ephemeralSubId, subId) {
	            this.mpnManager.subscribeManager.onUserSubscribeOK(ephemeralSubId, subId);
	        },
	        
	        /**
	         * Fired when a REQERR is received as a response of a subscription request.
	         */
	        onSubscribeError: function(subId, code, message) {
	            this.mpnManager.subscribeManager.onSubscribeError(subId, code, message);
	        },
	        
	        /**
	         * Fired when the message MPNDEL is received.
	         */
	        onUnsubscribeOK: function(subId) {
	            this.mpnManager.subscribeManager.onUnsubscribeOK(subId);
	        },
	        
	        /**
	         * Fired when a REQERR is received as a response of an unsubscription request.
	         */
	        onUnsubscribeError: function(subId, code, message) {
	            this.mpnManager.unsubscribeManager.onUnsubscribeError(subId, code, message);
	        }
	};

/**
     * An instance of the class is shared by all the tutors created within a session.
     * When the MpnManager closes a session, by setting the {@code dismissed} flag to true
     * it signals that all the tutors in the context must stop to retransmit.
     */
	var MpnTutorContext = function() {
		this.dismissed = false;
	};

/**
	 * Superclass of all the MPN tutors.
	 * <p>
	 * <b>NB</b> An MPN tutor is designed to stop retransmitting a request when the corresponding REQOK/REQERR is received.
	 * Thus it is important that the {@link MpnRequestListener} of the request calls the method {@link #onResponse()}
	 * at the end of the methods {@link MpnRequestListener#onOK()} and {@link MpnRequestListener#onError()}.
	 */
	var MpnTutor = function(timeoutMs, tutorContext, mpnManager) {
		this._callSuperConstructor(MpnTutor, [mpnManager.lsClient.connectionOptions, timeoutMs]);
		this.responseReceived = false;
		this.tutorContext = tutorContext;
		this.mpnManager = mpnManager;
	};
	
	MpnTutor.prototype = {
			
			/**
			 * Should be called when a REQOK/REQERR is received to stop retransmissions.
			 */
			onResponse: function() {
				this.responseReceived = true;
			},
			
			verifySuccess: function() {
		        // a request must be retransmitted only if 1) the server has not responded (with either REQOK or REQERR)
		        // and 2) the tutor is not dismissed 
		        return this.responseReceived || this.tutorContext.dismissed;
		    },
		    
		    notifyAbort: function() {
		        // process the abort as a (sort of) response
		        this.responseReceived = true;
		    }
	};
	
	Inheritance(MpnTutor,Tutor);

/**
     * Tutor of MPN registration requests.
     */
    var MpnRegisterTutor = function(timeoutMs, mpnManager, tutorContext) {
        this._callSuperConstructor(MpnRegisterTutor, [timeoutMs, tutorContext, mpnManager]);
    };

    MpnRegisterTutor.prototype = {
            
            doRecovery: function() {
                this.mpnManager.requestManager.sendRegisterRequest(this.timeoutMs);
            }
    };

    Inheritance(MpnRegisterTutor,MpnTutor);

var MpnRequest = function() {
        this.query = {};
        this.reqId = Utils.nextRequestId();
        this.addParam('LS_reqId', this.reqId);
    };
    
    MpnRequest.prototype = {
            
            addParam: function(key, value) {
                this.query[key] = encodeURIComponent(value);
            }
    };

/**
	 * A MPN registration request.
	 */
	var MpnRegisterRequest = function(device) {
	    this._callSuperConstructor(MpnRegisterRequest);
	    this.addParam('LS_op', 'register');
	    this.addParam('PN_type', device.platform);
	    this.addParam('PN_appId', device.appId);
		if (device.prevDeviceToken == null) {
		    this.addParam('PN_deviceToken', device.deviceToken);
		} else {
		    this.addParam('PN_deviceToken', device.prevDeviceToken);
		    this.addParam('PN_newDeviceToken', device.deviceToken);
		}
	};
	
	Inheritance(MpnRegisterRequest, MpnRequest);

/**
     * An MPN subscription request.
     * <br>
     * If a PN_subscriptionId is present, the request is meant to modify the setting of the corresponding subscription.
     * <br>
     * If a PN_coalescing is present, the request is meant to modify the setting of the subscription having similar
     * setting (typically the same adapter and items). If there is no such subscription, a new one is created.
     */
    var MpnSubscribeRequest = function(subId, deviceId, /*MpnSubscription*/ sub) {
        this._callSuperConstructor(MpnSubscribeRequest);
        this.subscriptionId = subId;
        this.addParam('LS_subId', subId);
        this.addParam('LS_op', 'activate');
        this.addParam('LS_group', sub.items);
        this.addParam('LS_schema', sub.fields);
        this.addParam('LS_mode', sub.getMode());
        this.addParam('PN_deviceId', deviceId);
        if (sub.getDataAdapter() != null) {
            this.addParam('LS_data_adapter', sub.getDataAdapter());
        }
        if (sub.getSubscriptionId() != null) {
            // a request to the server to modify the subscription having the specified id
            this.addParam('PN_subscriptionId', sub.getSubscriptionId());
        }
        if (sub.getNotificationFormat() != null) {
            this.addParam('PN_notificationFormat', sub.getNotificationFormat());
        }
        if (sub.getTriggerExpression() != null) {
            this.addParam('PN_trigger', sub.getTriggerExpression());
        }
        if (sub.coalescing) {
            this.addParam('PN_coalescing', 'true');
        }
        if (sub.getRequestedBufferSize() != null) {
            this.addParam('LS_requested_buffer_size', sub.getRequestedBufferSize());
        }
        if (sub.getRequestedMaxFrequency() != null) {
            this.addParam('LS_requested_max_frequency', sub.getRequestedMaxFrequency());
        }
    };
    
    Inheritance(MpnSubscribeRequest, MpnRequest);

/**
     * Tutor of MPN subscription requests.
     */
    var MpnSubscribeTutor = function(timeoutMs, ephemeralSubId, /*MpnSubscription*/ sub, mpnManager, tutorContext) {
        this._callSuperConstructor(MpnSubscribeTutor, [timeoutMs, tutorContext, mpnManager]);
        this.ephemeralSubId = ephemeralSubId;
        this.subscription = sub;
    };
    
    MpnSubscribeTutor.prototype = {
      
            doRecovery: function() {
                this.mpnManager.requestManager.sendSubscribeRequest(this.timeoutMs, this.ephemeralSubId, this.subscription);
            }
    };
    
    Inheritance(MpnSubscribeTutor,MpnTutor);

var MpnUnsubscribeFilterRequest = function(deviceId, filter) {
        this._callSuperConstructor(MpnUnsubscribeFilterRequest);
        //assert filter == "ALL" || filter == "ACTIVE" || filter == "TRIGGERED"
        this.addParam('LS_op', 'deactivate');
        this.addParam('PN_deviceId', deviceId);
        if (filter != "ALL") {            
            this.addParam('PN_subscriptionStatus', filter);
        }
    };
    
    Inheritance(MpnUnsubscribeFilterRequest, MpnRequest);

/**
     * Tutor managing the deletion of the subscriptions satisfying the filter 
     * (see {@link LightstreamerClient#unsubscribeMpnSubscriptions(String)}).
     */
    var MpnUnsubscribeFilterTutor = function(timeoutMs, /*MpnUnsubscribeFilter*/ filter, mpnManager, tutorContext) {
        this._callSuperConstructor(MpnUnsubscribeFilterTutor, [timeoutMs, tutorContext, mpnManager]);
        this.filter = filter;
    };
    
    MpnUnsubscribeFilterTutor.prototype = {
            
            doRecovery: function() {
                this.mpnManager.requestManager.sendUnsubscribeFilteredRequest(this.timeoutMs, this.filter);
            },
            
            onResponse: function() {
                this._callSuperMethod(MpnUnsubscribeFilterTutor, "onResponse");
                this.mpnManager.requestManager.onUnsubscriptionFilterResponse(this.filter);
            }
    };
    
    Inheritance(MpnUnsubscribeFilterTutor,MpnTutor);

/**
     * An MPN request to delete a subscription.
     */
    var MpnUnsubscribeRequest = function(deviceId, /*MpnSubscription*/ sub) {
        this._callSuperConstructor(MpnUnsubscribeRequest);
        this.subscriptionId = sub.getSubscriptionId();
        this.addParam('LS_op', 'deactivate');
        this.addParam('PN_deviceId', deviceId);
        this.addParam('PN_subscriptionId', this.subscriptionId);
    };
    
    Inheritance(MpnUnsubscribeRequest, MpnRequest);

/**
     * Tutor of MPN unsubscription requests.
     */
    var MpnUnsubscribeTutor = function(timeoutMs, /*MpnSubscription*/ sub, mpnManager, tutorContext) {
        this._callSuperConstructor(MpnUnsubscribeTutor, [timeoutMs, tutorContext, mpnManager]);
        this.subscription = sub;
    };
    
    MpnUnsubscribeTutor.prototype = {
            
            doRecovery: function() {
                this.mpnManager.requestManager.sendUnsubscribeRequest(this.timeoutMs, this.subscription);
            }
    };
    
    Inheritance(MpnUnsubscribeTutor,MpnTutor);

/**
     * API exposed to {@link MpnTutor}
     */
    var MpnRequestManager = function(mpnManager) {
        this.mpnManager = mpnManager;
        // the context shared by all the tutors belonging to the same session
        this.tutorContext = new MpnTutorContext();
    };
    
    MpnRequestManager.prototype = {
        
            /**
             * Dismisses the old context and creates a new one.
             */
            createTutorContext: function() {
                // dismiss the old context and create a new one
                this.tutorContext.dismissed = true;
                this.tutorContext = new MpnTutorContext();
            },
            
            /**
             * Sends a registration request.
             */
            sendRegisterRequest: function(timeoutMs) {
                var request = new MpnRegisterRequest(this.mpnManager.mpnDevice);
                var tutor = new MpnRegisterTutor(timeoutMs, this.mpnManager, this.tutorContext);
                this.mpnManager.lsClient.getLsEngine().then(function(lsEngine) {
                    lsEngine.sendRegisterForMpn(request, tutor);
                });
            },
            
            /**
             * Sends a subscription request.
             */
            sendSubscribeRequest: function(timeoutMs, ephemeralSubId, /*MpnSubscription*/ sub) {
                var request = new MpnSubscribeRequest(ephemeralSubId, this.mpnManager.mpnDevice.getDeviceId(), sub);
                var tutor = new MpnSubscribeTutor(timeoutMs, ephemeralSubId, sub, this.mpnManager, this.tutorContext);
                this.mpnManager.lsClient.getLsEngine().then(function(lsEngine) {
                    lsEngine.sendMpnSubscription(request, tutor);
                });
            },
            
            /**
             * Sends an unsubscription request.
             */
            sendUnsubscribeRequest: function(timeoutMs, /*MpnSubscription*/ sub) {
                var request = new MpnUnsubscribeRequest(this.mpnManager.mpnDevice.getDeviceId(), sub);
                var tutor = new MpnUnsubscribeTutor(timeoutMs, sub, this.mpnManager, this.tutorContext);
                this.mpnManager.lsClient.getLsEngine().then(function(lsEngine) {
                    lsEngine.sendMpnUnsubscription(request, tutor);
                });
            },
            
            /**
             * Sends a filtered unsubscription request.
             */
            sendUnsubscribeFilteredRequest: function(timeoutMs, /*MpnUnsubscribeFilter*/ unsubFilter) {
                var request = new MpnUnsubscribeFilterRequest(this.mpnManager.mpnDevice.getDeviceId(), unsubFilter.filter);
                var tutor = new MpnUnsubscribeFilterTutor(timeoutMs, unsubFilter, this.mpnManager, this.tutorContext);
                this.mpnManager.lsClient.getLsEngine().then(function(lsEngine) {
                    lsEngine.sendMpnFilteredUnsubscription(request, tutor);
                });
            },

            /**
             * Sends the requests on the waiting list.
             */
            sendWaitings: function() {
                /* send pending mpn subscriptions */
                this.mpnManager.subscribeManager.subscribeWaitings();
                /* send pending mpn unsubscriptions */
                this.mpnManager.unsubscribeManager.unsubscribeWaitings();
                this.mpnManager.unsubscribeFilterManager.unsubscribeWaitings();
            },
            
            /**
             * 
             * Fired when the message REQOK/REQERR is received as a response to a filtered unsubscription.
             */
            onUnsubscriptionFilterResponse: function(/*MpnUnsubscribeFilter*/ filter) {
                this.mpnManager.unsubscribeFilterManager.onUnsubscribeRepsone(filter);
            }
    };

/**
     * Manages the subscription/unsubscription of the DEV- adapter publishing info about the current MPN device. 
     */
	var DEV_Manager = function(mpnManager) {
		this.mpnManager = mpnManager;
	};
	
	DEV_Manager.prototype = {
			
			/**
	         * Subscribes to DEV- adapter.
	         */
	        subscribeToDEVAdapter: function() {
	        	var that = this;
	        	this.listener = {
	        			/**
	        	         * When dismissed, incoming messages are discarded.
	        	         */
	        			dismissed: false,
	        			
	        			// preserve the name of the method as it is called by the dispatcher
	        			"onItemUpdate": function(itemUpdate) {
	        				if (this.dismissed) {
	                            return;
	                        }
	        				try {
	        				    var status = itemUpdate.getValue("status");
	        				    var timestamp = parseInt(itemUpdate.getValue("status_timestamp"), 10);
	        				    that.mpnManager.mpnDevice.eventManager.onStatusChange(status, timestamp);
                            } catch (e) {
                                that.mpnManager.onFatalError(e);
                            }
	        			}
	        	};
	        	this.subscription = new Subscription(
	        			"MERGE", 
	        			"DEV-" + this.mpnManager.mpnDevice.deviceId, 
	        			["status", "status_timestamp"]);
	        	this.subscription.setDataAdapter(this.mpnManager.mpnDevice.adapterName);
	            this.subscription.setRequestedMaxFrequency("unfiltered");
	        	this.subscription.addListener(this.listener);
	        	this.mpnManager.lsClient.subscribe(this.subscription);
	        },
	        
	        /**
	         * Unsubscribes from DEV- adapterName.
	         */
	        unsubscribeFromDEVAdapter: function() {
	            if (this.subscription != null) {
	                this.mpnManager.lsClient.unsubscribe(this.subscription);
	                this.subscription.removeListener(this.listener);
	                this.listener.dismissed = true;
	                this.subscription = null;
	                this.listener = null;
	            }
	        }
	};

/**
     * Manages the subscription/unsubscription of the SUBS- adapter publishing info about the MPN items. 
     */
    var SUBS_Manager = function(mpnManager) {
        this.mpnManager = mpnManager;
    };
    
    SUBS_Manager.prototype = {
      
            /**
             * Subscribes to SUBS- adapter.
             */
            subscribeToSUBSAdapter: function(adapterName) {
                var that = this;
                /**
                 * Listener of the item SUBS- publishing the adding/removal of the MPN items on the server.
                 * SUBS- is a two-level command-mode item. The second level publishes the information
                 * of a single MPN item. 
                 */
                this.listener = {
                  
                        /**
                         * When dismissed, incoming messages are discarded.
                         */
                        dismissed: false,
                        
                        // preserve the name of the method as it is called by the dispatcher
                        "onItemUpdate": function(itemUpdate) {
                            if (this.dismissed) {
                                return;
                            }

                            try {
                                var command = itemUpdate.getValue("command");
                                switch (command) {
                                case "UPDATE":
                                    that.onUpdate(itemUpdate);
                                    break;
                                case "ADD":
                                    that.onAdd(itemUpdate);
                                    break;
                                case "DELETE":
                                    that.onDelete(itemUpdate);
                                    break;
                                }
                            } catch (e) {
                                that.mpnManager.onFatalError(e);
                            }
                        },
                        
                        // preserve the name of the method as it is called by the dispatcher
                        "onEndOfSnapshot": function(itemName, itemPos) {
                            if (this.dismissed) {
                                return;
                            }

                            try {
                                that.mpnManager.subscribeManager.onEndOfSnapshot();                                
                            } catch(e) {
                                that.mpnManager.onFatalError(e);
                            }
                        }
                };
                this.subscription = new Subscription(
                        "COMMAND", 
                        "SUBS-" + this.mpnManager.mpnDevice.deviceId, 
                        ["key", "command"]);
                this.subscription.setDataAdapter(this.mpnManager.mpnDevice.adapterName);
                this.subscription.setRequestedMaxFrequency("unfiltered");
                this.subscription.setCommandSecondLevelFields([
                        "status", "status_timestamp", "notification_format", "trigger", "group", 
                        "schema", "adapter", "mode", "requested_buffer_size", "requested_max_frequency"]);
                this.subscription.setCommandSecondLevelDataAdapter(this.mpnManager.mpnDevice.adapterName);
                this.subscription.addListener(this.listener);
                this.mpnManager.lsClient.subscribe(this.subscription);
            },
            
            /**
             * Unsubscribes from SUBS- adapter.
             */
            unsubscribeFromSUBSAdapter: function() {
                if (this.subscription != null) {
                    this.mpnManager.lsClient.unsubscribe(this.subscription);
                    this.subscription.removeListener(this.listener);
                    this.listener.dismissed = true;
                    this.subscription = null;
                    this.listener = null;
                }
            },
            
            /*
             * Subscription listener support methods
             */
    
            /**
             * Manages both the updating of an existing subscription and the adding of a new server subscription.
             * The adding is recognized by the fact that the subscription is not in the subscription list
             * kept by the MpnManager.
             */
            onUpdate: function(itemUpdate) {
                var that = this;
                var subId = this.getSubId(itemUpdate);
                this.mpnManager.subscriptions.forEachWithSubId(subId, /*SubscriptionList.Visitor*/ {
                    
                    onEmpty: function() {
                        that.doCreateNewSubscription(subId, itemUpdate);
                    },
                    
                    visit: function(/*MpnSubscription*/ sub) {
                        that.doUpdateExistingSubscription(sub, itemUpdate);
                    }
                });
            },
            
            /**
             * Updates the subscription.
             * When a subscription field is updated, the method {@link MpnSubscriptionListener#onPropertyChanged(String)} is triggered.
             */
            doUpdateExistingSubscription: function(/*MpnSubscription*/ sub, /*ItemUpdate*/ itemUpdate) {
                var needsInitialization = sub.needsInitialization;
                if (needsInitialization || itemUpdate.isValueChanged("mode")) {
                    var mode = itemUpdate.getValue("mode");
                    sub.eventManager.onChangeMode(mode);
                }
                if (needsInitialization || itemUpdate.isValueChanged("group")) {
                    var group = itemUpdate.getValue("group");
                    sub.eventManager.onChangeGroup(group);
                }
                if (needsInitialization || itemUpdate.isValueChanged("schema")) {
                    var schema = itemUpdate.getValue("schema");
                    sub.eventManager.onChangeSchema(schema);
                }
                if (needsInitialization || itemUpdate.isValueChanged("adapter")) {
                    var adapter = itemUpdate.getValue("adapter");
                    sub.eventManager.onChangeAdapter(adapter);
                }
                if (needsInitialization || itemUpdate.isValueChanged("notification_format")) {
                    var format = itemUpdate.getValue("notification_format");
                    sub.eventManager.onChangeFormat(format);
                }
                if (needsInitialization || itemUpdate.isValueChanged("trigger")) {
                    var trigger = itemUpdate.getValue("trigger");
                    sub.eventManager.onChangeTrigger(trigger);
                }
                if (needsInitialization || itemUpdate.isValueChanged("requested_buffer_size")) {
                    var size = itemUpdate.getValue("requested_buffer_size");
                    sub.eventManager.onChangeRequestedBufferSize(size);
                }
                if (needsInitialization || itemUpdate.isValueChanged("requested_max_frequency")) {
                    var freq = itemUpdate.getValue("requested_max_frequency");
                    sub.eventManager.onChangeRequestedMaxFrequency(freq);
                }
                if (needsInitialization || itemUpdate.isValueChanged("status_timestamp")) {
                    var ts = itemUpdate.getValue("status_timestamp");
                    var timestamp = (ts == null ? 0 : parseInt(ts, 10));
                    sub.eventManager.onChangeTimestamp(timestamp);
                }
                if (needsInitialization || itemUpdate.isValueChanged("status")) {
                    var next = itemUpdate.getValue("status");
                    var ts = itemUpdate.getValue("status_timestamp");
                    var timestamp = (ts == null ? 0 : parseInt(ts, 10));
                    sub.eventManager.onStatusChange(next, timestamp);
                }
                /* subscription is now initialized */
                if (needsInitialization) {                
                    sub.needsInitialization = false;
                }
            },
            
            /**
             * Adds a new server subscription.
             * The method {@link MpnSubscriptionListener#onPropertyChanged(String)} is triggered for each property. 
             */
            doCreateNewSubscription: function(subId, itemUpdate) {
                /* add new subscription */
                var mode = itemUpdate.getValue("mode");
                var group = itemUpdate.getValue("group");
                var schema = itemUpdate.getValue("schema");
                var adapter = itemUpdate.getValue("adapter");
                var format = itemUpdate.getValue("notification_format");
                var trigger = itemUpdate.getValue("trigger");
                var buffSize = itemUpdate.getValue("requested_buffer_size");
                var freq = itemUpdate.getValue("requested_max_frequency");
                var status = itemUpdate.getValue("status");
                var timestamp = parseInt(itemUpdate.getValue("status_timestamp"), 10);
                var sub = new MpnSubscription(mode);
                sub.eventManager.onChangeGroup(group);
                sub.eventManager.onChangeSchema(schema);
                sub.eventManager.onChangeAdapter(adapter);
                sub.eventManager.onChangeFormat(format);
                sub.eventManager.onChangeTrigger(trigger);
                sub.eventManager.onChangeRequestedBufferSize(buffSize);
                sub.eventManager.onChangeRequestedMaxFrequency(freq);
                sub.eventManager.setSubscriptionId(subId);
                sub.eventManager.simulateSubscribe(status, timestamp);
                sub.needsInitialization = false;
                this.mpnManager.subscribeManager.onServerSubscribeOK(subId, sub);
            },
            
            /**
             * Deletes a subscription.
             * The method {@link MpnSubscriptionListener#onUnsubscription} is triggered.
             */
            onDelete: function(/*ItemUpdate*/ itemUpdate) {
                var subId = this.getSubId(itemUpdate);
                this.mpnManager.subscribeManager.onDelete(subId);
            },
            
            /**
             * Manages the publishing of a subscription.
             */
            onAdd: function(/*ItemUpdate*/ itemUpdate) {
                var subId = this.getSubId(itemUpdate);
                this.mpnManager.subscribeManager.onAddedSubscription(subId);
            },
            
            /**
             * Returns the subscription id of an item.
             * The id is stored in the field {@code key} of the update and is coded as {@code SUB-<id>}.
             */
            getSubId: function(itemUpdate) {
                var key = itemUpdate.getValue("key");
                //assert key.startsWith("SUB-");
                return key.substring(4); // strip SUB- prefix
            }
    };

function MyList() {
        this.ls = [];
    }
    
    MyList.prototype = {
        
            add: function(obj) {
                this.ls.push(obj);
            },
            
            addAll: function(list) {
                for (var i = 0, len = list.size(); i < len; i++) {
                    this.add(list.get(i));
                }
            },
            
            remove: function(obj) {
                for (var i = 0, len = this.ls.length; i < len; i++) {
                    if (this.ls[i] == obj) {
                        this.ls.splice(i, 1);
                        return true;
                    }
                }
                return false;
            },
            
            contains: function(obj) {
                for (var i = 0, len = this.ls.length; i < len; i++) {
                    if (this.ls[i] == obj) {
                        return true;
                    }
                }
                return false;
            },
            
            clear: function() {
                this.ls.splice(0);
            },
            
            get: function(i) {
                return this.ls[i];
            },
            
            getLast: function() {
                return (this.ls.length == 0 ? null : this.ls[this.ls.length - 1]);
            },
            
            size: function() {
                return this.ls.length;
            },
            
            isEmpty: function() {
                return this.ls.length == 0;
            },
            
            toArray: function() {
                return this.ls;
            }
    };
    
    /**
     * NB
     * The key stored in the map is the value returned by toString() method.
     */
    function MyMap() {
        this.map = {};
    }
    
    MyMap.prototype = {
            
            get: function(key) {
                return this.map[key];
            },
            
            put: function(key, value) {
                this.map[key] = value;
            },
            
            remove: function(key) {
                var value = this.map[key];
                delete this.map[key];
                return value;
            },
            
            clear: function() {
                for (var prop in this.map) {
                    delete this.map[prop];
                }
            },
            
            containsKey: function(key) {
                return this.get(key) != null;
            },
            
            values: function() {
                var ls = new MyList();
                for (var key in this.map) {
                    ls.add(this.map[key]);
                }
                return ls;
            }
    };
    
    /**
     * NB
     * The object stored in the set is the value returned by toString() method.
     */
    function MySet() {
        this.set = {};
        this.size = 0;
    }
    
    MySet.prototype = {
      
            add: function(obj) {
                if (! this.set[obj]) {
                    this.set[obj] = true;
                    this.size++;
                }
            },
            
            remove: function(obj) {
                var value = !! this.set[obj];
                if (value) {
                    delete this.set[obj];
                    this.size--;
                }
                return value;
            },
            
            contains: function(obj) {
                return !! this.set[obj];
            },
            
            clear: function() {
                for (var prop in this.set) {
                    delete this.set[prop];
                }
                this.size = 0;
            },
            
            isEmpty: function() {
                return this.size == 0;
            }
    };

    var MpnUtils = {
        MyList: MyList,
        MyMap: MyMap,
        MySet: MySet
    };

/**
     * A mapping from ephemeralSubId to pending subscription requests.
     * A request is pending when the request has been sent to the server but the client has not received a response
     * (i.e. MPNOK/REQERR message).
     */
    var PendingSubscriptions = function() {
        /**
         * Maps the ephemeralSubId (i.e. the values of the parameters LS_subId of the subscribe requests)
         * with the corresponding subscriptions.
         */
        /*Map<String, PendingRequest>*/ this.pendings = new MpnUtils.MyMap();
    };
    
    PendingSubscriptions.prototype = {
            
            /**
             * Associates a subscription with an ephemeralSubId.
             */
            put: function(ephemeralSubId, /*MpnSubscription*/ sub) {
                this.pendings.put(ephemeralSubId, new PendingRequest(sub));
            },
            
            /**
             * Remove the request corresponding to an ephemeralSubId.
             */
            remove: function(ephemeralSubId) {
                var /*PendingRequest*/ req = this.pendings.remove(ephemeralSubId);
                return req;
            },
            
            /**
             * Returns the list of the currently pending subscriptions.
             */
            /*List<MpnSubscription>*/ values: function() {
                var /*List<MpnSubscription>*/ ls = new MpnUtils.MyList();
                var /*List<PendingRequest>*/ values = this.pendings.values();
                for (var i = 0, len = values.size(); i < len; i++) {
                    var req = values.get(i);
                    ls.add(req.subscription);
                }
                return ls;
            },
            
            clear: function() {
                this.pendings.clear();
            },
            
            /**
             * Returns the pending request corresponding to the specified subscription.
             */
            /*PendingRequest*/ getPendingRequest: function(/*MpnSubscription*/ sub) {
                var values = this.pendings.values();
                for (var i = 0, len = values.size(); i < len; i++) {
                    var req = values.get(i);
                    if (req.subscription == sub) {
                        return req;
                    }
                }
                return null;
            }
    };
    
    /**
     * A request which has been sent to the server, but whose response has not been received.
     * A listener can be attached to a pending request. When the request is completed, the listener is fired.
     */
    var PendingRequest = function(/*MpnSubscription*/ sub) {
        this.subscription = sub;
        this.handler = null;
    };
    
    PendingRequest.prototype = {
            
            setOnCompleteHandler: function(/*OnCompleteHandler*/ handler) {
                Assertions.assert(this.handler == null);
                this.handler = handler;
            },
            
            /**
             * This method must be called when the response arrives.
             * If there is an attached listener, it is fired.
             * 
             * @param success true if the response is right. False when the response is an error.
             */
            onComplete: function(success) {
                if (this.handler != null) {
                    this.handler.onComplete(success);
                    this.handler = null;
                }
            }
    };

var logOnSubUpd = LoggerManager.getLoggerProxy(Constants.MPN);

    /**
     * Manager of {@link MpnDeviceListener#onSubscriptionsUpdated} event.
     * <p>
     * The event is fired when:
     * <ul>
     * <li>MPNOK message is received</li>
     * <li>the MPN internal adapter adds/deletes a subscription</li>
     * <li>the MPN internal adapter sends the end-of-snapshot message (*)</li>
     * <li>the session is closed</li>
     * </ul>
     * 
     * (*) When the end-of-snapshot arrives, the event onSubscriptionsUpdated is not fired immediately
     * but only when all the subscriptions in the snapshot have received the first update.
     * So the user can see the subscriptions in the snapshot all at once.
     * <p>
     * <b>State diagram of the manager:</b>
     * <div>
     * <img src="{@docRoot}/../docs/mpn/onSubscriptionsUpdated.png">
     * </div>
     */
    var OnSubscriptionsUpdatedEventManager = function(mpnManager) {
        this.mpnManager = mpnManager;
        this.state = INIT;
        /**
         * SubIds of the subscriptions in the snapshot sent by the MPN internal adapter SUBS-.
         */
        /*Set<String>*/ this.expectedSubIds = new MpnUtils.MySet();
    };
    
    OnSubscriptionsUpdatedEventManager.prototype = {
            
            reset: function() {
                this.next(INIT, "reset");
                this.expectedSubIds.clear();            
            },
            
            /**
             * Must be called when a server subscription is published by the MPN internal adapter.
             */
            onNewServerSubscription: function(subId) {
                if (logOnSubUpd.isDebugLogEnabled()) {
                    logOnSubUpd.debug("Server subscription added subId=" + subId);
                }
                switch (this.state) {
                case INIT:
                    this.expectedSubIds.add(subId);
                    this.next(NOT_EMPTY, "ADD");
                    break;
                    
                case NOT_EMPTY:
                    this.expectedSubIds.add(subId);
                    break;
                    
                case EOS:
                case DONE:
                    // ignore
                    break;
                    
                default:
                    this.throwError("onNewServerSubscription (subId=" + subId + ")");
                }
            },
            
            /**
             * Must be called when the MPN internal adapter sends the end-of-snapshot message.
             */
            onEndOfSnapshot: function() {
                switch (this.state) {
                case INIT:
                    this.fireOnSubscriptionsUpdated("empty EOS");
                    this.next(DONE, "EOS");
                    break;
                    
                case NOT_EMPTY:
                    if (this.expectedSubIds.isEmpty()) {
                        this.next(EOS, "EOS");
                        this.onEmpty();
                    } else {                    
                        this.next(EOS, "EOS");
                    }
                    break;
                    
                default:
                    this.throwError("onEndOfSnapshot");
                }
            },
      
            /**
             * Must be called when a server subscription is put in the subscription list
             * (i.e. when it receives the first update).
             * <br>
             * The method fires {@link MpnDeviceListener#onSubscriptionsUpdated} when:
             * <ol>
             * <li>ALL the subscriptions in the snapshot are in the subscription list, or</li>
             * <li>a subscription NOT in the snapshot is added to the subscription list</li>
             * </ol>
             */
            onSeverSubscriptionOK: function(subId) {
                if (logOnSubUpd.isDebugLogEnabled()) {
                    logOnSubUpd.debug("Server subscription subscribed subId=" + subId);
                }
                switch (this.state) {
                
                case NOT_EMPTY:
                    this.expectedSubIds.remove(subId);
                    break;
                    
                case EOS:
                    this.expectedSubIds.remove(subId);
                    if (this.expectedSubIds.isEmpty()) {
                        this.onEmpty();
                    }
                    break;
                    
                case DONE:
                    this.fireOnSubscriptionsUpdated("UPD");
                    break;
                    
                default:
                    this.throwError("onSeverSubscriptionOK (subId=" + subId + ")");
                }
            },
            
            /**
             * Internal transition called when the snapshot set is empty.
             */
            onEmpty: function() {
                switch (this.state) {
                case EOS:
                    this.fireOnSubscriptionsUpdated("EOS");
                    this.next(DONE, "EMPTY");
                    break;
                    
                default:
                    this.throwError("onEmpty");
                }
            },
            
            /**
             * Fires {@link MpnDeviceListener#onSubscriptionsUpdated}.
             */
            fireOnSubscriptionsUpdated: function(event) {
                if (logOnSubUpd.isDebugLogEnabled()) {
                    logOnSubUpd.debug("onSubscriptionsUpdated (" + this.mpnManager.getDeviceId() + ") fired event=" + event);
                }
                if (this.mpnManager.mpnDevice != null) {
                    this.mpnManager.mpnDevice.eventManager.onSubscriptionsUpdated();
                }
            },
            
            next: function(next, event) {
                if (logOnSubUpd.isDebugLogEnabled()) {
                    logOnSubUpd.debug("OnSubscriptionsUpdated state change (" + this.mpnManager.getDeviceId() + ") on '" + event + "': " + this.state.name + " -> " + next.name);
                }
                this.state = next;
            },
            
            throwError: function(event) {
                var msg = "Unexpected event '" + event + "' in state " + this.state.name + " (" + this.mpnManager.getDeviceId() + ")";
                logOnSubUpd.logError(msg);
                throw new Error(msg);
            }
    };
    
    /**
     * States OnSubscriptionsUpdatedEventManager. 
     * See the diagram <img src="{@docRoot}/../docs/mpn/onSubscriptionsUpdated.png">
     */
    function State(name) {
        this.name = name;
    }
    /**
     * Initial state.
     */
    var INIT = new State("INIT");
    /**
     * Filling the snapshot set. 
     * End-of-snapshot has not yet arrived.
     */
    var NOT_EMPTY = new State("NOT_EMPTY");
    /**
     * Waiting for the first update of every subscription in the snapshot.
     * End-of-snapshot has arrived.
     */
    var EOS = new State("EOS");
    /**
     * All the subscriptions in the snapshot received an update
     * (or the snapshot was empty).
     */
    var DONE = new State("DONE");

var log$4 = LoggerManager.getLoggerProxy(Constants.MPN);

    /**
     * Manages the life cycle of the subscription requests.
     * 
     * <p>
     * <b>1 - SUBSCRIPTION STATES</b><br>
     * A subscription can be in the following states:
     * <ul>
     * <li><b>waiting</b>: the subscription is waiting for the device to register. 
     * After that the subscription becomes pending and the corresponding request is sent.</li>
     * <li><b>pending</b>: the corresponding request has been sent but no response has been received yet.</li>
     * <li><b>subscribed</b>: an object is subscribed when either a subscription request receives 
     * the message MPNOK or the MPN internal adapter publishes a new subscription.</li>
     * </ul>
     * 
     * <p>
     * <b>2 - USER AND SERVER SUBSCRIPTIONS</b><br>
     * An item can be subscribed in two ways: 
     * either when the user calls the method {@link LightstreamerClient#subscribe(MpnSubscription, boolean)}
     * or when the MPN internal adapter publishes a new subscription.
     * To distinguish the two cases, the subscriptions created in the first case are called <i>user subscriptions</i>,
     * while the others are called <i>server subscriptions</i>.
     * User and server subscriptions are stored in the <i>subscription list</i>.<br>
     * There is an important point to stress: since the MPN internal adapter publishes both the user and the server subscriptions,
     * in order to distinguish them, I make the following crucial assumption:
     * <i>when the user requests a new subscription, the message MPNOK is always sent before the MPN internal adapter
     * publishes the subscription</i>.<br>
     * From this assumption I draws the following rules:
     * <ol>
     * <li>MPNOK messages always refer to user subscriptions</li>
     * <li>a user subscription is added to the subscription list when the client receives the corresponding MPNOK message</li>
     * <li>published subscriptions which are not in the subscription list always refer to server subscriptions</li>
     * <li>a server subscription is added to the subscription list when the server sends the first update of the subscription</li>
     * </ol>
     */
    var SubscribeManager = function(mpnManager) {
        this.mpnManager = mpnManager;
        /**
         * Maps the ephemeralSubId (i.e. the values of the parameters LS_subId of the subscribe requests)
         * with the corresponding subscription requests.
         * <p>
         * The state of the contained subscriptions is <b>pending</b>.
         */
        this.pendings = new PendingSubscriptions();
        /**
         * The state of the contained objects is <b>waiting</b>.
         */
        /*List<MpnSubscription>*/ this.waitings = new MpnUtils.MyList();
        /**
         * Since the rules about the firing of the event {@code onSubscriptionsUpdated} are complex,
         * this dedicated object manages them.
         */
        this.onSubUpdEventManager = new OnSubscriptionsUpdatedEventManager(mpnManager);
        
    };
    
    SubscribeManager.prototype = {
            
            /**
             * Resets the internal data structures to start a new registration.
             */
            reset: function() {
                this.mpnManager.subscriptions.clear();
                this.pendings.clear();
                this.waitings.clear();
                this.onSubUpdEventManager.reset();
            },
      
            /**
             * Adds the subscription to the waiting list.
             */
            addWaiting: function(sub) {
                this.waitings.add(sub);
            },
            
            /**
             * Removes the subscription from the waiting list.
             * Returns true if the element was in the waiting list.
             */
            removeWaiting: function(/*MpnSubscription*/ sub) {
                return this.waitings.remove(sub);
            },
            
            /**
             * Subscribes the objects on the waiting list, which are put in the pending list.
             */
            subscribeWaitings: function() {
                for (var len = this.waitings.size(), i = 0; i < len; i++) {
                    var sub = this.waitings.get(i);
                    this.subscribe(sub);
                }
                this.waitings.clear();
            },
            
            /**
             * Returns the pending request corresponding to the specified subscription.
             */
            /*PendingRequest*/ getPendingRequest: function(/*MpnSubscription*/ sub) {
                return this.pendings.getPendingRequest(sub);
            },
            
            /**
             * Tries to subscribe the object, which is put in the pending list.
             */
            subscribe: function(sub) {
                var ephemeralSubId = Utils.nextSubscriptionId();
                this.pendings.put(ephemeralSubId, sub);
                this.mpnManager.requestManager.sendSubscribeRequest(0, ephemeralSubId, sub);
            },
            
            /**
             * Fired when the MPN internal adapter sends the end-of-snapshot message.
             */
            onEndOfSnapshot: function() {
                this.onSubUpdEventManager.onEndOfSnapshot();
            },
            
            /**
             * Fired when the user subscription fails.
             * The subscription is removed from the pending list and the method {@link MpnSubscriptionListener#onSubscriptionError}
             * is triggered.
             */
            onSubscribeError: function(subId, code, message) {
                var /*PendingRequest*/ req = this.pendings.remove(subId);
                if (req == null) {
                    log$4.warn("Discarded unexpected subscription error subId=" + subId);
                    return;
                }
                var /*MpnSubscription*/ sub = req.subscription;
                sub.eventManager.onSubscribeError(code, message);
                /* fire listeners waiting for the completion of the request */
                req.onComplete(false);
            },
            
            /**
             * Fired when the message MPNOK of an user subscription is received.
             * The user subscription is put in the subscription list and the method {@link MpnDeviceListener#onSubscriptionsUpdated} 
             * is triggered. 
             */
            onUserSubscribeOK: function(ephemeralSubId, mpnSubId) {
                /* remove from pending */
                var /*PendingRequest*/ req = this.pendings.remove(ephemeralSubId);
                if (req == null) {
                    log$4.warn("Discarded unexpected subscription: subId=" + ephemeralSubId);
                    return;
                }
                var /*MpnSubscription*/ sub = req.subscription;
                /* add to subscriptions */
                this.mpnManager.subscriptions.add(mpnSubId, sub);
                /* set subscription id */
                sub.eventManager.onSubscribeOK(mpnSubId);
                /* fire device listeners */
                this.onSubUpdEventManager.fireOnSubscriptionsUpdated("MPNOK");
                /* fire listeners waiting for the completion of the request */
                req.onComplete(true);
            },
            
            /**
             * Fired when the MPN internal adapter sends the first update of a server subscription.
             * The server subscription is put in the subscription list and the method {@link MpnDeviceListener#onSubscriptionsUpdated} 
             * is triggered. 
             */
            onServerSubscribeOK: function(subId, /*MpnSubscription*/ sub) {
                this.mpnManager.subscriptions.add(subId, sub);
                /* fire device listeners */
                this.onSubUpdEventManager.onSeverSubscriptionOK(subId);
            },
            
            /**
             * Fired when the MPN internal adapter publishes a subscription.
             */
            onAddedSubscription: function(subId) {
                if (this.mpnManager.subscriptions.isSubscribed(subId)) ; else {
                    /*
                     * This is a new server subscription.
                     */
                    this.onSubUpdEventManager.onNewServerSubscription(subId);
                }
            },
            
            /**
             * Fired when the message MPNDEL of a subscription is received.
             */
            onUnsubscribeOK: function(subId) {
                if (log$4.isDebugLogEnabled()) {
                    log$4.debug("MPNDEL subId=" + subId);
                }
                this.mpnManager.unsubscribeManager.onUnsubscribeOK(subId);
            },
            
            /**
             * Fired when the MPN internal adapter removes a subscription.
             * The subscription is removed from the subscription list, and the method
             * {@link MpnDeviceListener#onSubscriptionsUpdated} is triggered.
             */
            onDelete: function(subId) {
                var that = this;
                this.mpnManager.subscriptions.remove(subId, /*SubscriptionList.Visitor*/ {
                    onEmpty: function() {
                        log$4.warn("MpnSubscription not found subId=" + subId);
                    },
                    visit: function(/*MpnSubscription*/ sub) {
                        sub.eventManager.simulateUnsubscribe();
                    },
                    afterVisit: function() {
                        /* fire device listeners */
                        that.onSubUpdEventManager.fireOnSubscriptionsUpdated("DELETE");
                    }
                });
            },
            
            /**
             * Fired when an unsubscription request receives REQERR.
             * The subscription is removed from the subscription list, and the method
             * {@link MpnDeviceListener#onSubscriptionsUpdated} is triggered.
             */
            onUnsubscribeError: function(subId, code, message) {
                var that = this;
                this.mpnManager.subscriptions.remove(subId, /*SubscriptionList.Visitor*/ {
                    
                    onEmpty: function() {
                        log$4.warn("MPN subscription not found subId=" + subId);
                    },
                    
                    visit: function(/*MpnSubscription*/ sub) {
                        sub.eventManager.onUnsubscribeError(code, message);
                    },
                    
                    afterVisit: function() {
                        /* fire device listeners */
                        that.onSubUpdEventManager.fireOnSubscriptionsUpdated("REQERR");
                    }
                });
            },
            
            /**
             * Fired when the current session is closed.
             * The pending subscriptions are marked as waiting so they will be sent when a new session
             * becomes available.
             * 
             * @param recovery if the flag is true, the closing is due to an automatic recovery.
             * Otherwise the closing is due to a disconnection made by the user
             * (see {@link LightstreamerClient#disconnect()}).
             */
            onSessionClose: function(recovery) {
                if (recovery) {
                    this.waitings.addAll(this.pendings.values());
                    this.pendings.clear();
                    
                } else {
                    this.waitings.clear();
                    this.pendings.clear();
                    this.mpnManager.subscriptions.clear();
                    /* fire the device listeners because there are no more subscriptions */
                    this.onSubUpdEventManager.fireOnSubscriptionsUpdated("Session close");
                }
                this.onSubUpdEventManager.reset();
            }
    };

/**
     * The list of active MPN subscriptions.
     * <p>
     * Each subscription in the list is subscribed: it has received a MPNOK (user subscription) or
     * it has been published by the MPN internal adapter (server subscription).   
     */
    var SubscriptionList = function() {
        /**
         * Maps the mpnSubId (i.e. the values of the second argument of the message MPNOK)
         * with the corresponding subscription objects.
         * <p>
         * The state of the contained objects is <b>subscribed</b>.
         */
        /*Map<String, List<MpnSubscription>>*/ this.subscriptions = new MpnUtils.MyMap();
    };
    
    SubscriptionList.prototype = {
            
            /**
             * Returns the objects in the subscription list satisfying the filter 
             * (that can be null, "ALL", "SUBSCRIBED" or "TRIGGERED").
             * See {@link LightstreamerClient#getMpnSubscriptions(String)}.
             * <p>
             * NB For each subId, only the last added subscription is returned.
             */
            /*List<MpnSubscription>*/ getSubscriptions: function(filter) {
                var ls = new MpnUtils.MyList();
                var all = (filter == null || filter == "ALL");
                /*List<List<MpnSubscription>>*/ var values = this.subscriptions.values();
                for (var i = 0, len = values.size(); i < len; i++) {
                    /*List<MpnSubscription>*/ var subs = values.get(i);
                    /*MpnSubscription*/ var sub = subs.getLast();
                    if (all || sub.getStatus() == filter) {
                        ls.add(sub);
                    }
                }
                return ls;
            },
            
            /**
             * Returns the last added subscription having the specified subId.
             * If there are no subscriptions with the specified subId, returns null.
             */
            /*MpnSubscription*/ findSubscription: function(subId) {
                var /*List<MpnSubscription>*/ ls = this.subscriptions.get(subId);
                return ls == null ? null : ls.getLast();
            },
            
            /**
             * Returns true if there is a subscribed items with the given subId.
             */
            isSubscribed: function(subId) {
                return this.subscriptions.containsKey(subId);
            },
            
            /**
             * Adds the subscription.
             */
            add: function(subId, /*MpnSubscription*/ sub) {
                var /*List<MpnSubscription>*/ ls = this.subscriptions.get(subId);
                if (ls == null) {
                    ls = new MpnUtils.MyList();
                    this.subscriptions.put(subId, ls);
                }
                ls.add(sub);
            },
            
            /**
             * Removes all the subscription having the specified subId.
             */
            remove: function(subId, /*Visitor*/ visitor) {
                var /*List<MpnSubscription>*/ ls = this.subscriptions.remove(subId);
                this.forEach(ls, visitor);
            },
            
            /**
             * Clears the list.
             */
            clear: function() {
                this.subscriptions.clear();
            },
            
            /**
             * Executes the visitor for each subscription having the given subId.
             */
            forEachWithSubId: function(subId, /*Visitor*/ visitor) {
                var /*List<MpnSubscription>*/ ls = this.subscriptions.get(subId);
                this.forEach(ls, visitor);
            },
            
            /**
             * Executes the visitor for each subscription in the given list.
             */
            forEach: function(/*List<MpnSubscription>*/ ls, /*Visitor*/ visitor) {
                if (ls != null && ! ls.isEmpty()) {
                    if (visitor.visit != null) {                        
                        for (var i = 0, len = ls.size(); i < len; i++) {
                            var sub = ls.get(i);
                            visitor.visit(sub);
                        }
                    }
                    if (visitor.afterVisit != null) {                        
                        visitor.afterVisit();
                    }
                    
                } else {
                    if (visitor.onEmpty != null) {                        
                        visitor.onEmpty();
                    }
                }
            }
            
            /*
            //Subscription list visitor. 
            abstract class Visitor {
                //Called when the visited list is empty.
                void onEmpty() {}
                
                //Called for each subscription in the visited list.
                abstract void visit(MpnSubscription sub);
                
                //Called after all the subscriptions in the list has been visited.
                //<br>NB The method is NOT called if the visited list is empty. 
                void afterVisit() {}
            }
            */
    };

/**
     * A filtered unsubscription can simultaneously unsubscribes from all the items sharing a given state.
     * <p>
     * The filter can be:
     * <ul>
     * <li>ALL: unsubscribes all the items</li>
     * <li>ACTIVE: unsubscribes all the active (i.e. subscribed) items</li>
     * <li>TRIGGERED: unsubscribes all the triggered items</li>
     * </ul>
     */
    function MpnUnsubscribeFilter(filter) {
        //assert filter == null || filter == "ALL" || filter == "SUBSCRIBED" || filter == "TRIGGERED"
        if (filter != null) {
            filter = filter.toUpperCase();
        }
        if (filter == null) {
            // the value null is processed as the value ALL
            filter = "ALL";
        } else if (filter == "SUBSCRIBED") {
            // NB SUBSCRIBED is translated to ACTIVE because the server expects this name
            filter = "ACTIVE";
        }
        this.filter = filter;
    }

/**
     * Manages the life cycle of the filtered unsubscription requests.
     * <p>
     * A filtered unsubscription can be in the following states:
     * <ul>
     * <li><b>waiting</b>: the filtered unsubscription is waiting for the device to register. 
     * After that the filtered unsubscription becomes pending and the corresponding request is sent.</li>
     * <li><b>pending</b>: the corresponding request has been sent but no response has been received yet.</li>
     * </ul>
     */
    var UnsubscribeFilterManager = function(mpnManager) {
        this.mpnManager = mpnManager;
        /**
         * The state of the contained objects is <b>pending</b>.
         */
        /*List<MpnUnsubscribeFilter>*/ this.pendings = new MpnUtils.MyList();
        /**
         * The state of the contained objects is <b>waiting</b>.
         */
        /*List<MpnUnsubscribeFilter>*/ this.waitings = new MpnUtils.MyList();
    };
    
    UnsubscribeFilterManager.prototype = {
            
            /**
             * Resets the internal data structures to start a new registration.
             */
            reset: function() {
                this.pendings.clear();
                this.waitings.clear();
            },
            
            /**
             * Adds the filtered unsubscription to the waiting list.
             */
            addWaiting: function(filter) {
                this.waitings.add(new MpnUnsubscribeFilter(filter));
            },
            
            /**
             * Unsubscribes the objects on the waiting list, which are put in the pending list.
             */
            unsubscribeWaitings: function() {
                for (var i = 0, len = this.waitings.size(); i < len; i++) {
                    /*MpnUnsubscribeFilter*/ var filter = this.waitings.get(i); 
                    this.unsubscribe(filter);
                }
                this.waitings.clear();
            },
            
            /**
             * Tries to unsubscribe the object, which is put in the pending list.
             */
            unsubscribe: function(/*MpnUnsubscribeFilter*/ filter) {
                Assertions.assert(! this.pendings.contains(filter));
                this.pendings.add(filter);
                this.mpnManager.requestManager.sendUnsubscribeFilteredRequest(0, filter);
            },
            
            /**
             * Fired when the message REQOK/REQERR is received.
             * The filtered unsubscription is removed from the pending list.
             */
            onUnsubscribeRepsone: function(/*MpnUnsubscribeFilter*/ filter) {
                var contained = this.pendings.remove(filter);
                Assertions.assert(contained);
            },
            
            /**
             * Fired when the current session is closed.
             * The pending filtered unsubscriptions are marked as waiting so they will be sent when a new session
             * becomes available.
             * 
             * @param recovery if the flag is true, the closing is due to an automatic recovery.
             * Otherwise the closing is due to a disconnection made by the user
             * (see {@link LightstreamerClient#disconnect()}).
             */
            onSessionClose: function(recovery) {
                if (recovery) {
                    this.waitings.addAll(this.pendings);
                    this.pendings.clear();
                    
                } else {
                    this.waitings.clear();
                    this.pendings.clear();
                }
            }
    };

var log$5 = LoggerManager.getLoggerProxy(Constants.MPN);

    /**
     * Manages the life cycle of the unsubscription requests.
     * <p>
     * An unsubscription can be in the following states:
     * <ul>
     * <li><b>waiting</b>: the unsubscription is waiting for the device to register. 
     * After that the unsubscription becomes pending and the corresponding request is sent.</li>
     * <li><b>pending</b>: the corresponding request has been sent but no response has been received yet.</li>
     * </ul>
     */
    var UnsubscribeManager = function(mpnManager) {
        this.mpnManager = mpnManager;
        /**
         * Maps the mpnSubId (i.e. the values of the second argument of the message MPNOK)
         * with the corresponding unsubscription objects.
         * <p>
         * The state of the contained objects is <b>pending</b>.
         */
        /*Map<String, MpnSubscription>*/ this.pendings = new MpnUtils.MyMap();
        /**
         * The state of the contained objects is <b>waiting</b>.
         */
        /*List<MpnSubscription>*/ this.waitings = new MpnUtils.MyList();
    };
    
    UnsubscribeManager.prototype = {
      
            /**
             * Resets the internal data structures to start a new registration.
             */
            reset: function() {
                this.pendings.clear();
                this.waitings.clear();
            },
            
            /**
             * Adds the unsubscription to the waiting list.
             */
            addWaiting: function(/*MpnSubscription*/ sub) {
                this.waitings.add(sub);
            },
            
            /**
             * Unsubscribes the objects on the waiting list, which are put in the pending list.
             */
            unsubscribeWaitings: function() {
                for (var i = 0, len = this.waitings.size(); i < len; i++) {
                    var sub = this.waitings.get(i);
                    this.unsubscribe(sub);
                }
                this.waitings.clear();
            },
            
            /**
             * Tries to unsubscribe the object, which is put in the pending list.
             */
            unsubscribe: function(/*MpnSubscription*/ sub) {
                var subId = sub.getSubscriptionId();
                Assertions.assert(subId != null);
                Assertions.assert(! this.pendings.containsKey(subId));
                this.pendings.put(subId, sub);
                this.mpnManager.requestManager.sendUnsubscribeRequest(0, sub);
            },
            
            /**
             * Fired when the message MPNDEL is received.
             * The unsubscription is removed from the pending list.
             */
            onUnsubscribeOK: function(subId) {
                this.pendings.remove(subId);
                // when the unsubscription is made using a filter, there is no pending unsubscription.
                // so subIb may not be in pendings.
            },
            
            /**
             * Fired when a REQERR is received as a response of an unsubscription request.
             */
            onUnsubscribeError: function(subId, code, message) {
                var /*MpnSubscription*/ sub = this.pendings.remove(subId);
                if (sub == null) {
                    log$5.warn("Discarded unexpected unsubscription error subId=" + subId);
                    return;
                }
                this.mpnManager.subscribeManager.onUnsubscribeError(subId, code, message);
            },
            
            /**
             * Fired when the current session is closed.
             * The pending unsubscriptions are marked as waiting so they will be sent when a new session
             * becomes available.
             * 
             * @param recovery if the flag is true, the closing is due to an automatic recovery.
             * Otherwise the closing is due to a disconnection made by the user
             * (see {@link LightstreamerClient#disconnect()}).
             */
            onSessionClose: function(recovery) {
                if (recovery) {
                    this.waitings.addAll(this.pendings.values());
                    this.pendings.clear();
                    
                } else {
                    this.waitings.clear();
                    this.pendings.clear();
                }
            }
    };

var log$6 = LoggerManager.getLoggerProxy(Constants.MPN);
	
    /**
     * @since July 2018
     */
    function MpnManager(lsClient) {
    	this.lsClient = lsClient;
        this.stateMachine = new StateMachine(this);
        this.requestManager = new MpnRequestManager(this);
        this.eventManager = new MpnEventManager(this);
        this.dev_manager = new DEV_Manager(this);
        this.subs_manager = new SUBS_Manager(this);
        this.subscribeManager = new SubscribeManager(this);
        this.subscriptions = new SubscriptionList();
        this.unsubscribeManager = new UnsubscribeManager(this);
        this.unsubscribeFilterManager = new UnsubscribeFilterManager(this);
    }
    
    MpnManager.prototype = {
    		
    		/* 
    	     * **********************************
    	     * API exposed to LightstreamerClient
    	     * **********************************
    	     */
    		
            /**
             * See {@link LightstreamerClient#registerForMpn(MpnDeviceInterface)}.
             */
    		registerForMpn: function(device) {
    	        this.stateMachine.register(device);
    	    },
    	    
    	    /**
    	     * See {@link LightstreamerClient#subscribe(MpnSubscription, boolean)}.
    	     */
    	    subscribe: function(sub, coalescing) {
    	        try {
    	            sub.eventManager.onSubscribe(coalescing);
    	            this.stateMachine.subscribe(sub);
                } catch (e) {
                    this.onFatalError(e);
                }
    	    },
    	    
    	    /**
    	     * See {@link LightstreamerClient#unsubscribe(MpnSubscription)}.
    	     */
    	    unsubscribe: function(/*MpnSubscription*/ sub) {
    	        sub.throwErrorIfInactiveOrUnsubscribing();
    	        try {
    	            sub.eventManager.onUnsubscribe();
    	            this.stateMachine.unsubscribe(sub);
                } catch (e) {
                    this.onFatalError(e);
                }
    	    },
    	    
    	    /**
    	     * See {@link LightstreamerClient#unsubscribeMpnSubscriptions(String)}.
    	     */
    	    unsubscribeFilter: function(filter) {
    	        this.stateMachine.unsubscribeFilter(filter);
    	    },
    	    
    	    /**
    	     * See {@link LightstreamerClient#getMpnSubscriptions(String)}.
    	     */
    	    /*List<MpnSubscription>*/ getSubscriptions: function(filter) {
    	        return this.subscriptions.getSubscriptions(filter);
    	    },
    	    
    	    /**
    	     * See {@link LightstreamerClient#findMpnSubscription(String)}.
    	     */
    	    /*MpnSubscription*/ findSubscription: function(subId) {
    	        return this.subscriptions.findSubscription(subId);
    	    },
    	    
    	    getDeviceId: function() {
                return this.mpnDevice == null ? null : this.mpnDevice.deviceId;
            },
            
            /*
             * Support methods
             */
            
            onFatalError: function(error) {
                this.lsClient.getLsEngine().then(function(lsEngine) {
                    lsEngine.onFatalError(error);
                });
            }
    	    
    };
    
    var StateMachine = function(mpnManager) {
    	this.mpnManager = mpnManager;
    	this.state = 0 /*NO_SESSION*/;
    };
    
    StateMachine.NO_SESSION = 0;
    StateMachine.SESSION_OK = 1;
    StateMachine.READY = 2;
    StateMachine.REGISTERING = 3;
    StateMachine.REGISTERED = 4;
    StateMachine.NAMES = [];
    StateMachine.NAMES[StateMachine.NO_SESSION] = "NO_SESSION";
    StateMachine.NAMES[StateMachine.SESSION_OK] = "SESSION_OK";
    StateMachine.NAMES[StateMachine.READY] = "READY";
    StateMachine.NAMES[StateMachine.REGISTERING] = "REGISTERING";
    StateMachine.NAMES[StateMachine.REGISTERED] = "REGISTERED";
    
    StateMachine.prototype = {
    		
    		/**
             * Fired when a new session starts.
             */
    		onSessionStart: function() {
    			var event = "onSessionStart";
    			switch (this.state) {
    			
    			case StateMachine.NO_SESSION:
    				this.next(StateMachine.SESSION_OK, event);
    				break;
    				
    			case StateMachine.READY:
    				this.mpnManager.requestManager.sendRegisterRequest(0);
    	            this.next(StateMachine.REGISTERING, event);
    	            break;
    	            
    			default:
    	            this.throwError(event);
    			}
    		},
    		
    		/**
             * Fired when the current session closes.
             * 
             * @param recovery if the flag is true, the closing is due to an automatic recovery.
             * Otherwise the closing is due to a disconnection made by the user
             * (see {@link LightstreamerClient#disconnect()}).
             */
            onSessionClose: function(recovery) {
                var event = "onSessionClose";
                this.mpnManager.dev_manager.unsubscribeFromDEVAdapter();
                this.mpnManager.subs_manager.unsubscribeFromSUBSAdapter();
                this.mpnManager.requestManager.createTutorContext();
                this.mpnManager.subscribeManager.onSessionClose(recovery);
                this.mpnManager.unsubscribeManager.onSessionClose(recovery);
                this.mpnManager.unsubscribeFilterManager.onSessionClose(recovery);
                if (this.mpnManager.mpnDevice != null) {
                    this.mpnManager.mpnDevice.eventManager.onSessionClose(recovery);
                }
            	switch (this.state) {
            	
            	case StateMachine.NO_SESSION:
            		this.next(StateMachine.NO_SESSION, event);
            		break;
            		
            	case StateMachine.SESSION_OK:
            		this.next(StateMachine.NO_SESSION, event);
            		break;
            		
            	case StateMachine.READY:
            		this.next(StateMachine.READY, event);
            		break;
            		
            	case StateMachine.REGISTERING:
            		this.next(StateMachine.READY, event);
            		break;
            		
            	case StateMachine.REGISTERED:
            		this.next(StateMachine.READY, event);
            		break;
            	}
    		},
    		
    		/**
             * Fired when the user registers the device.
             */
    		register: function(device) {
    			var event = "register";
    			switch (this.state) {
    			
    			case StateMachine.NO_SESSION:
    				this.resetDevice(device);
    				this.next(StateMachine.READY, event);
    				break;
    				
    			case StateMachine.SESSION_OK:
    				this.resetDevice(device);
    	            this.mpnManager.requestManager.sendRegisterRequest(0);
    	            this.next(StateMachine.REGISTERING, event);
    				break;
    				
    			case StateMachine.READY:
    				this.resetDevice(device);
    	            this.next(StateMachine.READY, event);
    				break;
    				
    			case StateMachine.REGISTERING:
    				this.resetDevice(device);
    	            this.mpnManager.requestManager.sendRegisterRequest(0);
    	            this.next(StateMachine.REGISTERING, event);
    				break;
    				
    			case StateMachine.REGISTERED:
    				this.resetDevice(device);
    	            this.mpnManager.requestManager.sendRegisterRequest(0);
    	            this.next(StateMachine.REGISTERING, event);
    				break;
    			}
    		},
    		
    		/**
             * Fired when the message MPNREG is received.
             */
            onRegisterOK: function(deviceId, adapterName) {
            	var event = "onRegisterOK";
            	switch (this.state) {
            	
				case StateMachine.REGISTERING:
					this.mpnManager.mpnDevice.eventManager.onRegisterOK(deviceId, adapterName);
					this.mpnManager.requestManager.sendWaitings();
					this.mpnManager.dev_manager.subscribeToDEVAdapter();
					this.mpnManager.subs_manager.subscribeToSUBSAdapter();
					this.next(StateMachine.REGISTERED, event);
					break;

				default:
				    this.throwError(event);
				}
            },
            
            /**
             * Fired when the registration fails.
             */
            onRegisterError: function(code, message) {
            	var event = "onRegisterError";
            	switch (this.state) {
            	
            	case StateMachine.REGISTERING:
            		this.mpnManager.mpnDevice.eventManager.onRegisterError(code, message);
                    this.next(StateMachine.SESSION_OK, event);
            		break;
            		
            	default:
            	    this.throwError(event);
            	}
            },
            
            /**
             * Fired when the user subscribes to an item.
             */
            subscribe: function(sub) {
                switch (this.state) {
                
                case StateMachine.REGISTERED:
                    this.mpnManager.subscribeManager.subscribe(sub);
                    break;
                    
                default:                    
                    this.mpnManager.subscribeManager.addWaiting(sub);
                }
            },
            
            /**
             * Fired when the user unsubscribes from an item.
             */
            unsubscribe: function(/*MpnSubscription*/ sub) {
                switch (this.state) {
                
                case StateMachine.REGISTERED:
                    /*
                     * Sometimes the user requests an unsubscription when the corresponding subscription has been sent 
                     * over the network and the client is awaiting the response.
                     * In this case we must await the subscription response and then send the unsubscription request.
                     */
                    var /*PendingRequest*/ req = this.mpnManager.subscribeManager.getPendingRequest(sub);
                    if (req == null) {
                        /* there is no pending subscription */
                        this.mpnManager.unsubscribeManager.unsubscribe(sub);
                        
                    } else {
                        var that = this;
                        /* set the listener that will fire the unsubscription when the subscription request is completed */
                        req.setOnCompleteHandler(/*PendingRequest.OnCompleteHandler*/ {
                            
                            onComplete: function(success) {
                                if (success) {
                                    that.mpnManager.unsubscribeManager.unsubscribe(sub);
                                }
                            }
                        });
                    }
                    break;
                
                default:
                    /*
                     * Sometimes a subscription is immediately followed by an unsubscription.
                     * If the subscription has not been sent over the network (i.e. it is in the waiting list), 
                     * we can avoid to send both the subscription and the unsubscription requests 
                     * and simply make a state transition on the subscription object.
                     */
                    var subscribeRequestWasWaiting = this.mpnManager.subscribeManager.removeWaiting(sub);
                    if (subscribeRequestWasWaiting) {
                        sub.eventManager.cancelSubscription();

                    } else {

                        /* send the unsubscription request when the the device is registered */
                        this.mpnManager.unsubscribeManager.addWaiting(sub);
                    }
                }
            },
            
            /**
             * Fired when the user unsubscribes from a set of items using a filter.
             */
            unsubscribeFilter: function(filter) {
                switch (this.state) {
                
                case StateMachine.REGISTERED:
                    this.mpnManager.unsubscribeFilterManager.unsubscribe(new MpnUnsubscribeFilter(filter));
                    break;
                    
                default:                    
                    this.mpnManager.unsubscribeFilterManager.addWaiting(filter);
                }
            },
    		
    		/**
    	     * Resets internal data structures when starting a new registration.
    	     */
            resetDevice: function(device) {
    		    /* unsbuscribe form DEV- and SUBS- */
    	        this.mpnManager.dev_manager.unsubscribeFromDEVAdapter();
    	        this.mpnManager.subs_manager.unsubscribeFromSUBSAdapter();
    			/* abort pending requests */
    	        this.mpnManager.requestManager.createTutorContext();
    	        /* clear internal data structures */
    	        this.mpnManager.subscribeManager.reset();
    	        this.mpnManager.unsubscribeManager.reset();
    	        this.mpnManager.unsubscribeFilterManager.reset();
    			/* set the new device */
    			this.mpnManager.mpnDevice = device;
    		},
    		
    		/**
             * Changes the current state.
             */
    		next: function(next, event) {
    			if (log$6.isDebugLogEnabled()) {
    				var from = StateMachine.NAMES[this.state];
    				var to = StateMachine.NAMES[next];
    				log$6.logDebug(LoggerManager.resolve(925), this.mpnManager.getDeviceId(), "on '" + event + "': " + from + " -> " + to);
    			}
    			this.state = next;
    		},
    		
    		throwError: function(event) {
                var msg = "Unexpected event '" + event + "' in state " + StateMachine.NAMES[this.state] + " (" + this.mpnManager.getDeviceId() + ")";
                log$6.logError(msg);
                throw new Error(msg);
            }
    };

var LightstreamerClient = /*@__PURE__*/(function() {
  //THIS CLASS IMPLEMENTS BeanParent

  var actionsLogger = LoggerManager.getLoggerProxy(Constants.ACTIONS);
  var sharingLogger = LoggerManager.getLoggerProxy(Constants.SHARING);

  var uniqueIDCounter = 0;

  var ext_alpha_numeric = new RegExp("^[a-zA-Z0-9_]*$");

  var INVALID_SEQUENCE = "The given sequence name is not valid, use only alphanumeric characters plus underscore, or null";

  var NO_ADDRESS = "Configure the server address before trying to connect";


  /**
   * Creates an object to be configured to connect to a Lightstreamer server
   * and to handle all the communications with it.
   * It is possible to instantiate as many LightstreamerClient as needed.
   * Each LightstreamerClient is the entry point to connect to a Lightstreamer server,
   * subscribe to as many items as needed and to send messages.
START_NODE_JSDOC_EXCLUDE
   * Multiple LightstreamerClient instances may share the same connection if
   * configured to behave that way through {@link LightstreamerClient#enableSharing}.
END_NODE_JSDOC_EXCLUDE
   * @constructor
   *
   * @exports LightstreamerClient
   *
   * @throws {IllegalArgumentException} if a not valid address is passed. See
   * {@link ConnectionDetails#setServerAddress} for details.
   *
   * @param {String} [serverAddress] the address of the Lightstreamer Server to
   * which this LightstreamerClient will connect to. It is possible not to specify
   * it at all or to specify it later. See  {@link ConnectionDetails#setServerAddress}
   * for details.
   * @param {String} [adapterSet] the name of the Adapter Set mounted on Lightstreamer Server
   * to be used to handle all requests in the Session associated with this LightstreamerClient.
   * It is possible not to specify it at all or to specify it later. See
   * {@link ConnectionDetails#setAdapterSet} for details.
   *
   * @class Facade class for the management of the communication to
   * Lightstreamer Server. Used to provide configuration settings, event
   * handlers, operations for the control of the connection lifecycle,
   * {@link Subscription} handling and to send messages.
START_NODE_JSDOC_EXCLUDE
   * <BR>It can be configured to share its connection with other LightstreamerClient
   * instances (even if on different html pages) through
   * {@link LightstreamerClient#enableSharing} calls.
END_NODE_JSDOC_EXCLUDE
   */
  var LightstreamerClient = function(serverAddress, adapterSet) {

    this["C"] = LightstreamerClient;
    this._callSuperConstructor(LightstreamerClient);

    /**
     * Data object that contains options and policies for the connection to
     * the server. This instance is set up by the LightstreamerClient object at
     * its own creation.
     * <BR>Properties of this object can be overwritten by values received from a
     * Lightstreamer Server. Such changes will be notified through a
     * {@link ClientListener#onPropertyChange} event on listeners of this instance.
START_NODE_JSDOC_EXCLUDE
     * <BR>In case of a shared connection the involved LightstreamerClient instances
     * will keep this data object synchronized so that a change on a property of an object
     * of one of the instances will be reflected on all the others. Any change will
     * be notified through a {@link ClientListener#onPropertyChange} event on
     * listeners of this instance.
END_NODE_JSDOC_EXCLUDE
     *
     * @type ConnectionOptions
     *
     * @see ClientListener#onPropertyChange
     */
    this.connectionOptions = new ConnectionOptions();

    /**
     * Data object that contains the details needed to open a connection to
     * a Lightstreamer Server. This instance is set up by the LightstreamerClient object at
     * its own creation.
     * <BR>Properties of this object can be overwritten by values received from a
     * Lightstreamer Server. Such changes will be notified through a
     * {@link ClientListener#onPropertyChange} event on listeners of this instance.
START_NODE_JSDOC_EXCLUDE
     * <BR>In case of a shared connection the involved LightstreamerClient instances
     * will keep this data object synchronized so that a change on a property of an object
     * of one of the instances will be reflected on all the others. Any change will
     * be notified through a {@link ClientListener#onPropertyChange} event on
     * listeners of this instance.
END_NODE_JSDOC_EXCLUDE
     *
     * @type ConnectionDetails
     *
     * @see ClientListener#onPropertyChange
     */
    this.connectionDetails = new ConnectionDetails();

    this["connectionOptions"] = this.connectionOptions;
    this["connectionDetails"] = this.connectionDetails;

    this["connectionSharing"] = ls_sbc(this);

    this._configuration = new Configuration();
    this._policy = this.connectionOptions; //TODO can be avoided
    this._connection = this.connectionDetails;

    //this.statistics = null;

    if (serverAddress) {
      this._connection.setServerAddress(serverAddress);
    }

    if (adapterSet) {
      this._connection.setAdapterSet(adapterSet);
    }

    this._configuration.setBroadcaster(this);
    this._policy.setBroadcaster(this);
    this._connection.setBroadcaster(this);

    this.tables = new SubscriptionsHandler(this._policy);

    this.engineHandler = null;
    this.sharing = null;
    this.sharingPhase = 0;
    this.enableSharingPhase = 0;

    this.uID = ++uniqueIDCounter;
    this.messages = new MessageProxy();
    this.lastEngineStatus = Constants.DISCONNECTED;
    this.checkEngineTask = null;

    this.usedEngines = {};

    EnvironmentStatus.addUnloadHandler(this);

    /* MpnManager */
    this.mpnManager = new MpnManager(this);
  };


//START_WEB_JSDOC_EXCLUDE
  /**
   * Static method that can be used to share cookies between connections to the Server
   * (performed by this library) and connections to other sites that are performed
   * by the application. With this method, cookies received by the application
   * can be added (or replaced if already present) to the cookie set used by the
   * library to access the Server. Obviously, only cookies whose domain is compatible
   * with the Server domain will be used internally.
   *
   * <p class="lifecycle"><b>Lifecycle:</b>This method can be called at any time;
   * it will affect the internal cookie set immediately and the sending of cookies
   * on future requests.</p>
   *
   * @param {String} uri String representation of the URI from which the supplied
   * cookies were received. It can be null.
   *
   * @param {String[]} cookies An array of String representations of the various
   * cookies to be added. Each cookie should be represented in the text format
   * provided for the Set-Cookie HTTP header by RFC 6265.
   *
   * @see LightstreamerClient.getCookies
   *
   * @static
   */
//END_WEB_JSDOC_EXCLUDE
  LightstreamerClient.addCookies = function(uri, cookieList) {
    if (Environment.isNodeJS()) {
      ServerConnection.addGlobalCookiesForNode(uri, cookieList);
    }
  };

//START_WEB_JSDOC_EXCLUDE
  /**
   * Static inquiry method that can be used to share cookies between connections to the Server
   * (performed by this library) and connections to other sites that are performed
   * by the application. With this method, cookies received from the Server can be
   * extracted for sending through other connections, according with the URI to be accessed.
   *
   * @param {String} uri String representation of the URI to which the cookies should
   * be sent, or null.
   *
   * @return {String[]} An array of String representations of the various cookies that can
   * be sent in a HTTP request for the specified URI. If a null URI was supplied,
   * the export of all available cookies, including expired ones, will be returned.
   * Each cookie is represented in the text format provided for the Set-Cookie HTTP header
   * by RFC 6265.
   *
   * @see LightstreamerClient.addCookies
   *
   * @static
   */
//END_WEB_JSDOC_EXCLUDE
  LightstreamerClient.getCookies = function(uri) {
    if (Environment.isNodeJS()) {
      var cookies = ServerConnection.getGlobalCookiesForNode(uri);
      var cookieValues = [];
      cookies.forEach(function(cookie_i, i, array) {
          // BEGIN ported from cookie_send in xmlhttprequest-cookie
          cookieValues.push(cookie_i.toString());
          // END ported from cookie_send in xmlhttprequest-cookie
      });
      return cookieValues;
    }
  };

  /**
   * Static method that permits to configure the logging system used by the library.
   * The logging system must respect the {@link LoggerProvider} interface. A custom
   * class can be used to wrap any third-party JavaScript logging system.
   * <BR>A ready-made LoggerProvider implementation is available within the
   * library in the form of the {@link SimpleLoggerProvider} class.
   * <BR>If no logging system is specified, all the generated log is discarded.
   * <BR>The following categories are available to be consumed:
   * <ul>
   * <li>
   * lightstreamer.stream:
   * <BR>logs socket activity on Lightstreamer Server connections;
   * <BR>at DEBUG level, read data is logged, write preparations are logged.
   * </li><li>
   * lightstreamer.protocol:
   * <BR>logs requests to Lightstreamer Server and Server answers;
   * <BR>at DEBUG level, request details and events from the Server are logged.
   * </li><li>
   * lightstreamer.session:
   * <BR>logs Server Session lifecycle events;
   * <BR>at INFO level, lifecycle events are logged;
   * <BR>at DEBUG level, lifecycle event details are logged.
   * </li><li>
   * lightstreamer.requests:
   * <BR>logs submission of control requests to the Server;
   * <BR>at WARN level, alert events from the Server are logged;
   * <BR>at INFO level, submission of control requests is logged;
   * <BR>at DEBUG level, requests batching and handling details are logged.
   * </li><li>
   * lightstreamer.subscriptions:
   * <BR>logs subscription requests and the related updates;
   * <BR>at INFO level, subscriptions and unsubscriptions are logged;
   * <BR>at DEBUG level, requests handling details are logged.
   * </li><li>
   * lightstreamer.messages:
   * <BR>logs sendMessage requests and the related updates;
   * <BR>at INFO level, sendMessage operations are logged;
   * <BR>at DEBUG level, request handling details are logged.
   * </li><li>
   * lightstreamer.actions:
   * <BR>logs settings / API calls.
   * </li>
START_NODE_JSDOC_EXCLUDE
   * <li>
   * lightstreamer.grids:
   * <BR>logs grid-related code.
   * </li><li>
   * lightstreamer.sharing:
   * <BR>logs creation / sharing / election of the Master and Slave
   * {@link LightstreamerClient};
   * <BR>at WARN level, problems getting a connection up and ready are logged;
   * <BR>at INFO level, found/lost events are logged;
   * <BR>at DEBUG level, connection management details and regular checks on the current connection are logged.
   * </li>
END_NODE_JSDOC_EXCLUDE
   * </ul>
   *
   * @param {LoggerProvider} provider A LoggerProvider instance that will be used
   * to generate log messages by the library classes.
   *
   * @static
   */
  LightstreamerClient.setLoggerProvider = function(provider) {
    LoggerManager.setLoggerProvider(provider);
  };

  /**
   * A constant string representing the name of the library.
   *
   * @type String
   */
  LightstreamerClient.LIB_NAME = Constants.LIBRARY_TAG;

  /**
   * A constant string representing the version of the library.
   *
   * @type String
   */
  LightstreamerClient.LIB_VERSION = Constants.LIBRARY_VERSION + " build " + Constants.BUILD;


  /**
   * @private
   */
  LightstreamerClient["simulateSilence"] = function(silence) {
    //used to test STALLED
    PushEvents.simulateSilence(silence);
  };


  LightstreamerClient.prototype = {

      toString: function() {
        return ["[","LightstreamerClient",this.uID,this.statusPhase,this.initPhase,"]"].join("|");
      },

      getTablesHandler: function() {
        return this.tables;
      },

      getMessageProxy: function() {
        return this.messages;
      },

      getEngineHandler: function() {
        return this.engineHandler;
      },

      setEngineHandler: function(newEh) {
        this.engineHandler = newEh;
        this.tables.switchEngineHandler(newEh);
        this.messages.switchEngineHandler(newEh);
        this.setEnginePhase = this.enableSharingPhase;

        this.checkEngineTask = Executor.addRepetitiveTask(newEh.checkDeath,5000,newEh);
      },

      clearEngineHandler: function() {
        if (this.engineHandler) {
          //we already have an engine, kill this one, start another

          this.usedEngines[this.engineHandler.getEngineId()] = true;

          this.tables.switchEngineHandler(null);
          this.messages.switchEngineHandler(null);

          if (this.checkEngineTask) {
            Executor.stopRepetitiveTask(this.checkEngineTask);
            this.checkEngineTask = null;
          }

          this.engineHandler.dispose();
          this.engineHandler = null;

          if (this.master) {
            this.master.dispose();
            this.master = null;
          }

          if (this._configuration.connectionRequested) {
            this.cacheEngineStatus(Constants.WILL_RETRY);
          } else {
            this.cacheEngineStatus(Constants.DISCONNECTED);
          }
        }

        if (this.search) {
          this.search.stop();
          this.search = null;
        }
      },

      broadcastSetting: function(objClass,prop,val) {
        if (this.engineHandler) {
          this.engineHandler.onClientConfigurationChange(objClass,prop,val);
        }

        return true;
      },

      notifyOptionChange: function(prop,inst) {
        //README if this method is changed take a look to lsClient of the appfiles: it contains a hack on this method
        if (inst != this._configuration) {
          this.dispatchEvent("onPropertyChange",[prop]);
        }
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Configures the client to share its connection and/or attach to a shared connection.
       * Different windows trying to share the connection to Lightstreamer Server must share the
       * exact same origin. Depending on the browser in use, connection sharing might not work.
       * Specify null to prevent any kind of sharing (this is also the default). In case
       * a connection is not currently required (i.e. the client is in DISCONNECTED status)
       * specifying null will also have the effect to dismiss resources currently held by the
       * client: failing to do that when a LightstreamerClient instance is not needed anymore
       * might prevent the VM from collecting all the allocated resources. Note that in this case
       * required resources will be prepared again once a call to {@link LightstreamerClient#connect}
       * is performed.
       *
       * <p class="default-value"><b>Default value:</b> by default no sharing is configured.</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> this method can be called at any time.
       * <BR>Note that if multiple calls to this method are performed, the last one will
       * override the previous ones. Also if a call to enableSharing is made on a
       * Master client, the current connection (if any) will be dropped and the
       * remaining clients will enter the election algorithm.</p>
       *
       * @param {ConnectionSharing} sharing The sharing parameters or null to prevent any sharing
       */
// END_NODE_JSDOC_EXCLUDE
      enableSharing: function(sharing) {
        if (this.mpnRequested) {
            throw new IllegalStateException("Sharing is not available when MPN is enabled");
        }
        var userAgent = Environment.isBrowser() ? navigator.userAgent.toLowerCase() : null;
        if (userAgent != null && (userAgent.indexOf("ucbrowser") != -1 || userAgent.indexOf("ubrowser") != -1)) {
            sharingLogger.logInfo(LoggerManager.resolve(926));
            return;
        }
        this.enableSharingPhase++;
        Executor.addTimedTask(this.enableSharingExec,0,this,[sharing,this.enableSharingPhase]);
        this.sharingRequested = (sharing != null);
      },

      enableSharingExec: function(sharing,ph) {
        if (ph != this.enableSharingPhase) {
          return;
        }

        this.sharingPhase++;

        this.clearEngineHandler();

        this.sharing = sharing;
        if (sharing && ! sharing.isPossible()) {
            sharingLogger.logInfo(LoggerManager.resolve(927));
        }
        if (sharing && sharing.isPossible()) {

          var ph = this.sharingPhase;
          var that = this;
          var nowSearching = sharing.findEngine(this);

          this.search = nowSearching;
          this.search.find(this.usedEngines)["then"](function(eh) {
            if(ph != that.sharingPhase) {
              return;
            }

            if (that.search.noHope == true) {
              that.sharing.noHope();
            }

            if (eh === null) {
              that.setupOwnEngine(ph,nowSearching.getCheckedEngineList()); //avoid suicide for an engine we failed to connect to
            } else {
              that.setEngineHandler(eh);
            }
          }, function() {
            if(ph != that.sharingPhase) {
              return;
            }
            that.dispatchEvent("onShareAbort");
          });


        } else if (sharing == null && this._configuration.connectionRequested) {
          this.setupOwnEngine();
        } //else { //no engine currently needed

      },

      /**
       * @private
       * @param suicided
       * @param noHopeToAttachToAnotherEngine if true, the client must not try to attach to another engine
       */
      engineMourningRoom: function(suicided, noHopeToAttachToAnotherEngine) {
        if (this.setEnginePhase != this.enableSharingPhase) {
          return;
        }
        //if we disposed the engine we won't reach this point as the clearEngineHandler in the enableSharing
        //prevents us from receiving the notification

        this.clearEngineHandler();

        if (EnvironmentStatus.isUnloading() || EnvironmentStatus.isUnloaded()) {
          actionsLogger.logInfo(LoggerManager.resolve(928));
          return;
        }

//>>excludeStart("debugExclude", pragmas.debugExclude);
        if (!this.sharing) {
          ASSERT.fail();
          actionsLogger.logError(LoggerManager.resolve(929));
          return;
        }
//>>excludeEnd("debugExclude");

        actionsLogger.logInfo(LoggerManager.resolve(930));

        //to avoid conflicts, we must delay the creation of the engine by giving the search algorithm
        //more time between the two checks that convinces him he is alone
        var aloneTimeout = null;
        if (this._configuration.clientsCount <= 2) ; else if (suicided) {
          //in the suicided case there was a conflict, so leave more time (there should already be an alive engine somewhere)
          aloneTimeout = 10000;
        } else {

          //if everyone has the same timeout we get a ton of collisions
          //there are currently -1 clients wondering if it is proper to create an engine

          aloneTimeout = 200 + Helpers.randomG(this._configuration.clientsCount) * 500;
          if (aloneTimeout > 5000) {
            aloneTimeout = 5000; //keep a decent limit for the worst case scenario
          }

        }

        var newSharing = this.sharing.convertToElectionVersion(aloneTimeout, noHopeToAttachToAnotherEngine);
        this.enableSharingExec(newSharing,this.setEnginePhase);

      },

      unloadEvent: function() {
        // destroy the session when the browser tab is closed
        this.disconnect();
        if (this.engineHandler) {
          this.engineHandler.clientDeath();
        }
      },

      /**
       * @private
       */
      setupOwnEngine: function(ph,dontDieFor) {
        if (ph && ph != this.sharingPhase) {
          return;
        }
        this.setEngineHandler(new NewEngineHandler(this));
        this.master = new LightstreamerEngine(
        		this._configuration,
        		this._policy,
        		this._connection,
        		this.sharing,
        		this.engineHandler,
        		dontDieFor,
        		this.mpnManager);
        this.engineHandler.setEngineId(this.master.getEngineId());
        this.engineHandler.setSessionPhase(this.master.getSessionPhase());

        return this.engineHandler;
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Inquiry method that checks if the LightstreamerClient has its own connection or if it is using
       * a connection shared by another LightstreamerClient.
       * This LightstreamerClient is not a Master if:
       * <ul>
       * <li>it is attached to another LightstreamerClient connection</li>
       * <li>no call to {@link LightstreamerClient#connect} or {@link LightstreamerClient#enableSharing}
       * was performed on it.</li>
       * <li>the {@link ClientListener#onShareAbort} event has been fired and no following
       * {@link LightstreamerClient#enableSharing} has been performed.</li>
       * <li>a call to {@link LightstreamerClient#enableSharing} has been performed and the client is currently
       * searching for a shared connection</li>
       * <li>a call to {@link LightstreamerClient#enableSharing} has been performed with null as parameter and no
       * subsequent call to connect has been performed</li>
       *
       * @return {boolean} Whenever the LightstreamerClient owning this instance is a Master or not.
       *
       * @see ConnectionSharing
       */
// END_NODE_JSDOC_EXCLUDE
      isMaster: function() {
        return this.master != null;
      },


      /**
       * Operation method that requests to open a Session against the configured
       * Lightstreamer Server.
       * <BR>When connect() is called, unless a single transport was forced through
       * {@link ConnectionOptions#setForcedTransport},
       * the so called "Stream-Sense" mechanism is started: if the client does not
       * receive any answer for some seconds from the streaming connection, then it
       * will automatically open a polling connection.
       * <BR>A polling connection may also be opened if the environment is not suitable
       * for a streaming connection.
START_NODE_JSDOC_EXCLUDE
       * <BR>When connect() is used to activate the Lightstreamer
       * Session on page start up, it is suggested to make this call as the
       * latest action of the scripts in the page. Otherwise, if the stream
       * connection is opened but third-party scripts are consuming most of the
       * CPU for page initialization (initial rendering, etc.), the parsing
       * of the streaming response could be delayed to the point that the Client
       * switches to polling mode. This is usually not the case nowadays but may
       * still happen if the client is used on old machines.
       * <BR>In case of a shared connection the connect call will apply to such
       * shared connection regardless of which LightstreamerClient is calling it.
       * <BR>If {@link LightstreamerClient#enableSharing} has not been called before the
       * first call to connect, then a default call will be performed with the
       * following parameter:
       * <BR><CODE>new ConnectionSharing("randomstring","IGNORE", "CREATE", true, null);</CODE>
END_NODE_JSDOC_EXCLUDE
       * <BR>Note that as "polling connection" we mean a loop of polling
       * requests, each of which requires opening a synchronous (i.e. not
       * streaming) connection to Lightstreamer Server.
       *
       * <p class="lifecycle"><b>Lifecycle:</b>
       * Note that the request to connect is accomplished by the client
       * asynchronously; this means that an invocation to {@link LightstreamerClient#getStatus}
       * right after connect() might not reflect the change yet. Also if a
       * CPU consuming task is performed right after the call the connection will
       * be delayed.
       * <BR>When the request to connect is finally being executed, if the current status
       * of the client is not DISCONNECTED, then nothing will be done.</p>
       *
START_NODE_JSDOC_EXCLUDE
       * @throws {IllegalStateException} if the LightstreamerClient cannot
       * connect to the server due to the sharing policies configured in the
       * {@link ConnectionSharing} object.
       * @see ConnectionSharing
       *
END_NODE_JSDOC_EXCLUDE
       * @throws {IllegalStateException} if no server address was configured
       * and there is no suitable default address to be used.
       *
       * @see LightstreamerClient#getStatus
       * @see LightstreamerClient#disconnect
       * @see ClientListener#onStatusChange
       * @see ConnectionDetails#setServerAddress
       */
      connect: function() {
        if (!this._connection.serverAddress) {
          throw new IllegalStateException(NO_ADDRESS);
        }

        actionsLogger.logInfo(LoggerManager.resolve(931));

        //this.startupStatistics();


        Executor.addTimedTask(this.asynchConnect,0,this);
      },

      asynchConnect: function() {
        if (this.lastEngineStatus) {
          // if executed while not DISCONNECTED it will be ignored.
          if(this.lastEngineStatus != Constants.DISCONNECTED){
            // note: this case includes DISCONNECTED:WILL-RETRY and DISCONNECTED:TRYING-RECOVERY.
            return;
          }
        }

        if ((this.sharing == null || ! this.sharing.isPossible()) && !this.master) {
          this.setupOwnEngine();
        }

        actionsLogger.logDebug(LoggerManager.resolve(932));

        this._configuration.simpleSetter('connectionRequested',true);

        var eh = this.getEngineHandler();
        if (eh) {
          eh.callConnect();
        }
      },
      /*
      startupStatistics: function() {
        this.dismissStatistics();
        this.statistics = new StatusStatistics();
        this.addListener(this.statistics);
      },

      dismissStatistics: function() {
        if (this.statistics) {
          this.statistics.dismiss();
          this.removeListener(this.statistics);
          delete this.statistics;
        }
      },
      */

      /**
       * Operation method that requests to close the Session opened against the
       * configured Lightstreamer Server (if any).
       * <BR>When disconnect() is called, the "Stream-Sense" mechanism is stopped.
       * <BR>Note that active {@link Subscription} instances, associated with this
       * LightstreamerClient instance, are preserved to be re-subscribed to on future
       * Sessions.
START_NODE_JSDOC_EXCLUDE
       * <BR>In case of a shared connection, the disconnect() call will apply to such
       * shared connection regardless of which LightstreamerClient is calling it.
END_NODE_JSDOC_EXCLUDE
       *
       * <p class="lifecycle"><b>Lifecycle:</b>
       * Note that the request to disconnect is accomplished by the client
       * asynchronously; this means that an invocation to {@link LightstreamerClient#getStatus}
       * right after disconnect() might not reflect the change yet. Also if a
       * CPU consuming task is performed right after the call the disconnection will
       * be delayed.
       * <BR>When the request to disconnect is finally being executed, if the status of the client is
       * "DISCONNECTED", then nothing will be done.</p>
       */
      disconnect: function() {
        actionsLogger.logInfo(LoggerManager.resolve(933));

        //this.dismissStatistics();

        Executor.addTimedTask(this.asynchDisconnect,0,this);
      },

      asynchDisconnect: function() {

        actionsLogger.logDebug(LoggerManager.resolve(934));

        this._configuration.simpleSetter('connectionRequested',false);

        var eh = this.getEngineHandler();
        if (eh) {
          eh.callDisconnect();
        }
      },

      /**
       * Inquiry method that gets the current client status and transport
       * (when applicable).
       *
       * @return {String} The current client status. It can be one of the following
       * values:
       * <ul>
       * <li>"CONNECTING" the client is waiting for a Server's response in order
       * to establish a connection;</li>
       * <li>"CONNECTED:STREAM-SENSING" the client has received a preliminary
       * response from the server and is currently verifying if a streaming connection
       * is possible;</li>
       * <li>"CONNECTED:WS-STREAMING" a streaming connection over WebSocket is active;</li>
       * <li>"CONNECTED:HTTP-STREAMING" a streaming connection over HTTP is active;</li>
       * <li>"CONNECTED:WS-POLLING" a polling connection over WebSocket is in progress;</li>
       * <li>"CONNECTED:HTTP-POLLING" a polling connection over HTTP is in progress;</li>
       * <li>"STALLED" the Server has not been sending data on an active
       * streaming connection for longer than a configured time;</li>
       * <li>"DISCONNECTED:WILL-RETRY" no connection is currently active but one will
       * be opened (possibly after a timeout).</li>
       * <li>"DISCONNECTED:TRYING-RECOVERY" no connection is currently active,
       * but one will be opened as soon as possible, as an attempt to recover
       * the current session after a connection issue;</li>
       * <li>"DISCONNECTED" no connection is currently active;</li>
       * </ul>
       *
       * @see ClientListener#onStatusChange
       */
      getStatus: function() {
        return this.lastEngineStatus;
      },

      /**
       * Operation method that sends a message to the Server. The message is
       * interpreted and handled by the Metadata Adapter associated to the
       * current Session. This operation supports in-order guaranteed message
       * delivery with automatic batching. In other words, messages are
       * guaranteed to arrive exactly once and respecting the original order,
       * whatever is the underlying transport (HTTP or WebSockets). Furthermore,
       * high frequency messages are automatically batched, if necessary,
       * to reduce network round trips.
       * <BR>Upon subsequent calls to the method, the sequential management of
       * the involved messages is guaranteed. The ordering is determined by the
       * order in which the calls to sendMessage are issued
START_NODE_JSDOC_EXCLUDE
       * ; in case of calls
       * issued from different LightstreamerClient instances on different html pages
       * sharing the same connection, the relative order is determined by the client
       * owning the shared connection. Anyway two messages sent through the same
       * LightstreamerClient instance will never surpass each other
END_NODE_JSDOC_EXCLUDE
       * .
       * <BR>If a message, for any reason, doesn't reach the Server (this is possible with the HTTP transport),
       * it will be resent; however, this may cause the subsequent messages to be delayed.
       * For this reason, each message can specify a "delayTimeout", which is the longest time the message, after
       * reaching the Server, can be kept waiting if one of more preceding messages haven't been received yet.
       * If the "delayTimeout" expires, these preceding messages will be discarded; any discarded message
       * will be notified to the listener through {@link ClientMessageListener#onDiscarded}.
       * Note that, because of the parallel transport of the messages, if a zero or very low timeout is 
       * set for a message and the previous message was sent immediately before, it is possible that the
       * latter gets discarded even if no communication issues occur.
       * The Server may also enforce its own timeout on missing messages, to prevent keeping the subsequent
       * messages for long time.
       * <BR>Sequence identifiers can also be associated with the messages.
       * In this case, the sequential management is restricted to all subsets
       * of messages with the same sequence identifier associated.
       * <BR>Notifications of the operation outcome can be received by supplying
       * a suitable listener. The supplied listener is guaranteed to be eventually
       * invoked; listeners associated with a sequence are guaranteed to be invoked
       * sequentially.
       * <BR>The "UNORDERED_MESSAGES" sequence name has a special meaning.
       * For such a sequence, immediate processing is guaranteed, while strict
       * ordering and even sequentialization of the processing is not enforced.
       * Likewise, strict ordering of the notifications is not enforced.
       * However, messages that, for any reason, should fail to reach the Server
       * whereas subsequent messages had succeeded, might still be discarded after
       * a server-side timeout, in order to ensure that the listener eventually gets a notification.
       * <BR>Moreover, if "UNORDERED_MESSAGES" is used and no listener is supplied,
       * a "fire and forget" scenario is assumed. In this case, no checks on
       * missing, duplicated or overtaken messages are performed at all, so as to
       * optimize the processing and allow the highest possible throughput.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Since a message is handled by the Metadata
       * Adapter associated to the current connection, a message can be sent
       * only if a connection is currently active.
       * If the special enqueueWhileDisconnected flag is specified it is possible to
       * call the method at any time and the client will take care of sending the
       * message as soon as a connection is available, otherwise, if the current status
       * is "DISCONNECTED*", the message will be abandoned and the
       * {@link ClientMessageListener#onAbort} event will be fired.
       * <BR>Note that, in any case, as soon as the status switches again to
       * "DISCONNECTED*", any message still pending is aborted, including messages
       * that were queued with the enqueueWhileDisconnected flag set to true.
       * <BR>Also note that forwarding of the message to the server is made
       * asynchronously; this means that if a CPU consuming task is
       * performed right after the call, the message will be delayed. Hence,
       * if a message is sent while the connection is active, it could be aborted
       * because of a subsequent disconnection. In the same way a message sent
       * while the connection is not active might be sent because of a subsequent
       * connection.</p>
       *
       * @throws: {IllegalArgumentException} if the given sequence name is
       * invalid.
       * @throws: {IllegalArgumentException} if NaN or a negative value is
       * given as delayTimeout.
       *
       * @param {String} msg a text message, whose interpretation is entirely
       * demanded to the Metadata Adapter associated to the current connection.
       * @param {String} [sequence="UNORDERED_MESSAGES"] an alphanumeric identifier, used to
       * identify a subset of messages to be managed in sequence; underscore
       * characters are also allowed. If the "UNORDERED_MESSAGES" identifier is
       * supplied, the message will be processed in the special way described
       * above.
       * <BR>The parameter is optional; if not supplied, "UNORDERED_MESSAGES" is used
       * as the sequence name.
       * @param {Number} [delayTimeout] a timeout, expressed in milliseconds.
       * If higher than the Server configured timeout on missing messages,
       * the latter will be used instead. <BR>
       * The parameter is optional; if not supplied, the Server configured timeout on missing
       * messages will be applied.
       * <BR>This timeout is ignored for the special "UNORDERED_MESSAGES" sequence,
       * although a server-side timeout on missing messages still applies.
       * @param {ClientMessageListener} [listener] an
       * object suitable for receiving notifications about the processing outcome.
       * <BR>The parameter is optional; if not supplied, no notification will be
       * available.
       * @param {boolean} [enqueueWhileDisconnected=false] if this flag is set to true, and
       * the client is in a disconnected status when the provided message
       * is handled, then the message is not aborted right away but is queued waiting
       * for a new session. Note that the message can still be aborted later when a new
       * session is established.
       */
      sendMessage: function(msg,sequence,delayTimeout,listener,enqueueWhileDisconnected) {
        if (!sequence) {
          sequence = Constants._UNORDERED_MESSAGES;
        } else if (!ext_alpha_numeric.test(sequence)){
          throw new IllegalArgumentException(INVALID_SEQUENCE);
        }

        //If a timeout is given it must be a number.
        //the values that return false from if(delayTimeout) are 0 null undefined and ""
        if (delayTimeout || delayTimeout == 0) {
          delayTimeout = this.checkPositiveNumber(delayTimeout, true);
        } else {
          delayTimeout = null;
        }

        enqueueWhileDisconnected = this.checkBool(enqueueWhileDisconnected,true);

        Executor.addTimedTask(this.asyncSendMessage,0,this,[msg,sequence,listener,delayTimeout,enqueueWhileDisconnected]);

      },

      asyncSendMessage: function(msg,sequence,listener,_timeout,enqueueWhileDisconnected) {

        if (this.engineHandler && this.engineHandler.isSessionAlive()) {
          this.messages.forwardMessage(msg,sequence,listener,_timeout);

        } else if (enqueueWhileDisconnected) {
          //we enqueue
          this.messages.enqueueMessage(msg,sequence,listener,_timeout);

        } else if (listener) {
          //we abort immediately
          //this.messages.messageAbort(listenerProxy.prog);//can't use this as we don't have the listenerProxy
          this.messages.fireEvent("onAbort",listener,[msg,false]);
        } //no listener: no abort
      },

      serverError: function(flag,mex) {
        this.dispatchEvent("onServerError",[flag,mex]);
      },

      sessionEnd: function() {
        this.getTablesHandler().pauseAllTables();
        this.getMessageProxy().cleanMessageListeners();
      },

      sessionStart: function() {
        this.getTablesHandler().handleAllWaitingTables();
        this.getMessageProxy().handleAllWaitingMessages();
        this.getLsEngine().resolve(this.master);
      },

      cacheEngineStatus: function(_status) {
        if (_status == this.lastEngineStatus) {
          return;
        }
        this.lastEngineStatus = _status;
        this.dispatchEvent("onStatusChange",[_status]);
      },

      sendLog: function(logStr) {
        if (this.engineHandler && this.engineHandler.isSessionAlive()) {
          this.engineHandler.forwardLog(logStr);
          return true;
        }
        return false;
      },

      onServerKeepalive: function() {
          this.dispatchEvent("onServerKeepalive");
      },


      /**
       * Inquiry method that returns an array containing all the {@link Subscription}
       * instances that are currently "active" on this LightstreamerClient.
       * <BR/>Internal second-level Subscription are not included.
       *
       * @return {String[]} An array, containing all the {@link Subscription} currently
       * "active" on this LightstreamerClient.
       * <BR>The array can be empty.
       */
      getSubscriptions: function() {
        var map = [];
        var origMap = this.tables.getAllTables();
        for (var _id in origMap) {
          if(!origMap[_id].isSubTable()) {
            map.push(origMap[_id]);
          }
        }
        return map;
      },

      /**
       * Operation method that adds a {@link Subscription} to the list of "active"
       * Subscriptions.
       * The Subscription cannot already be in the "active" state.
       * <BR>Active subscriptions are subscribed to through the server as soon as possible
       * (i.e. as soon as there is a session available). Active Subscription are
       * automatically persisted across different sessions as long as a related
       * unsubscribe call is not issued.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Subscriptions can be given to the LightstreamerClient at
       * any time. Once done the Subscription immediately enters the "active" state.
       * <BR>Once "active", a {@link Subscription} instance cannot be provided again
       * to a LightstreamerClient unless it is first removed from the "active" state
       * through a call to {@link LightstreamerClient#unsubscribe}.
       * <BR>Also note that forwarding of the subscription to the server is made
       * asynchronously; this means that if a CPU consuming task is
       * performed right after the call the subscription will be delayed.
       * <BR>A successful subscription to the server will be notified through a
       * {@link SubscriptionListener#onSubscription} event.</p>
       *
       * @throws {IllegalArgumentException} if the given Subscription does
       * not contain a field list/field schema.
       * @throws {IllegalArgumentException} if the given Subscription does
       * not contain a item list/item group.
       * @throws {IllegalStateException}  if the given Subscription is already "active".
       *
       * @param {Subscription} subscription A {@link Subscription} object, carrying
       * all the information needed to process its pushed values.
       *
       * @see SubscriptionListener#onSubscription
       */
      subscribe: function(subscription) {
        this.tables.addATable(subscription);
      },

      /**
       * Operation method that removes a {@link Subscription} that is currently in
       * the "active" state.
       * <BR>By bringing back a Subscription to the "inactive" state, the unsubscription
       * from all its items is requested to Lightstreamer Server.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Subscription can be unsubscribed from at
       * any time. Once done the Subscription immediately exits the "active" state.
       * <BR>Note that forwarding of the unsubscription to the server is made
       * asynchronously; this means that if a CPU consuming task is
       * performed right after the call the unsubscription will be delayed.
       * <BR>The unsubscription will be notified through a
       * {@link SubscriptionListener#onUnsubscription} event.</p>
       *
       * @throws {IllegalStateException} if the given Subscription is not
       * currently "active".
       *
       * @param {Subscription} subscription An "active" {@link Subscription} object
       * that was activated by this LightstreamerClient instance.
       *
       * @see SubscriptionListener#onUnsubscription
       */
      unsubscribe: function(subscription) {
        this.tables.removeATable(subscription);
      },

      /**
       * Adds a listener that will receive events from the LightstreamerClient
       * instance.
       * <BR>The same listener can be added to several different LightstreamerClient
       * instances.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
       *
       * @param {ClientListener} listener An object that will receive the events
       * as shown in the {@link ClientListener} interface.
       * <BR>Note that the given instance does not have to implement all of the
       * methods of the ClientListener interface. In fact it may also
       * implement none of the interface methods and still be considered a valid
       * listener. In the latter case it will obviously receive no events.
       */
      addListener: function(listener) {
        this._callSuperMethod(LightstreamerClient,"addListener",[listener]);
      },

      /**
       * Removes a listener from the LightstreamerClient instance so that it
       * will not receive events anymore.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
       *
       * @param {ClientListener} listener The listener to be removed.
       */
      removeListener: function(listener) {
        this._callSuperMethod(LightstreamerClient,"removeListener",[listener]);
      },

      /**
       * Returns an array containing the {@link ClientListener} instances that
       * were added to this client.
       *
       * @return {ClientListener[]} an array containing the listeners that were added to this client.
       * Listeners added multiple times are included multiple times in the array.
       */
      getListeners: function() {
        return this._callSuperMethod(LightstreamerClient,"getListeners");
      },

      /**
       * Returns a promise that is resolved with a LightstreamerEngine.
       * @private
       */
      getLsEngine: function() {
          if (this.lsEnginePromise == null) {
              this.lsEnginePromise = Utils.defer();
          }
          return this.lsEnginePromise;
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Operation method that registers the MPN device on the server's MPN Module.<BR>
       * By registering an MPN device, the client enables MPN functionalities such as {@link LightstreamerClient#subscribeMpn}.
       *
       * <p class="edition-note"><B>Edition Note:</B> MPN is an optional feature, available depending on Edition and License Type.
       * To know what features are enabled by your license, please see the License tab of the Monitoring Dashboard (by default,
       * available at /dashboard).</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> An {@link MpnDevice} can be registered at any time. The registration will be notified through a {@link MpnDeviceListener#onRegistered} event.</p>
       *
       * @param device An {@link MpnDevice} instance, carrying all the information about the MPN device.
       * @throws IllegalArgumentException if the specified device is null.
       *
       * @see #subscribeMpn
       */
// END_NODE_JSDOC_EXCLUDE
      registerForMpn: function(device) {
          if (this.sharingRequested) {
              throw new IllegalStateException("MPN is not available when sharing is enabled");
          }
          if (device == null) {
              throw new IllegalArgumentException("Device cannot be null");
          }
          this.mpnDevice = device;
          this.mpnManager.registerForMpn(device);
          this.mpnRequested = true;
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Operation method that subscribes an MpnSubscription on server's MPN Module.<BR>
       * This operation adds the {@link MpnSubscription} to the list of "active" subscriptions. MPN subscriptions are activated on the server as soon as possible
       * (i.e. as soon as there is a session available and subsequently as soon as the MPN device registration succeeds). Differently than real-time subscriptions,
       * MPN subscriptions are persisted on the server's MPN Module database and survive the session they were created on.<BR>
       * If the <code>coalescing</code> flag is <i>set</i>, the activation of two MPN subscriptions with the same Adapter Set, Data Adapter, Group, Schema and trigger expression will be
       * considered the same MPN subscription. Activating two such subscriptions will result in the second activation modifying the first MpnSubscription (that
       * could have been issued within a previous session). If the <code>coalescing</code> flag is <i>not set</i>, two activations are always considered different MPN subscriptions,
       * whatever the Adapter Set, Data Adapter, Group, Schema and trigger expression are set.<BR>
       * The rationale behind the <code>coalescing</code> flag is to allow simple apps to always activate their MPN subscriptions when the app starts, without worrying if
       * the same subscriptions have been activated before or not. In fact, since MPN subscriptions are persistent, if they are activated every time the app starts and
       * the <code>coalescing</code> flag is not set, every activation is a <i>new</i> MPN subscription, leading to multiple push notifications for the same event.
       *
       * <p class="edition-note"><B>Edition Note:</B> MPN is an optional feature, available depending on Edition and License Type.
       * To know what features are enabled by your license, please see the License tab of the Monitoring Dashboard (by default,
       * available at /dashboard).</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> An MpnSubscription can be given to the LightstreamerClient once an MpnDevice registration has been requested. The MpnSubscription
       * immediately enters the "active" state.<BR>
       * Once "active", an MpnSubscription instance cannot be provided again to an LightstreamerClient unless it is first removed from the "active" state through
       * a call to {@link #unsubscribeMpn}.<BR>
       * A successful subscription to the server will be notified through an {@link MpnSubscriptionListener#onSubscription} event.</p>
       *
       * @param subscription An MpnSubscription object, carrying all the information to route real-time data via push notifications.
       * @param coalescing A flag that specifies if the MPN subscription must coalesce with any pre-existing MPN subscription with the same Adapter Set, Data Adapter,
       * Group, Schema and trigger expression.
       * @throws IllegalStateException if the given MPN subscription does not contain a field list/field schema.
       * @throws IllegalStateException if the given MPN subscription does not contain a item list/item group.
       * @throws IllegalStateException if there is no MPN device registered.
       * @throws IllegalStateException if the given MPN subscription is already active.
       *
       * @see #unsubscribeMpn
       * @see #unsubscribeMpnSubscriptions
       */
// END_NODE_JSDOC_EXCLUDE
      subscribeMpn: function(subscription, coalescing) {
          if (subscription == null) {
              throw new IllegalArgumentException("MpnSubscription is null");
          }
          if (subscription.fields == null) {
              throw new IllegalArgumentException("Invalid MpnSubscription, please specify a field list or field schema");
          }
          if (subscription.items == null) {
              throw new IllegalArgumentException("Invalid MpnSubscription, please specify an item list or item group");
          }
          if (subscription.getNotificationFormat() == null) {
              throw new IllegalArgumentException("Invalid MpnSubscription, please specify a notification format");
          }
          if (subscription.isActive()) {
              throw new IllegalStateException("MpnSubscription is already active");
          }
          if (this.mpnDevice == null) {
              throw new IllegalStateException("No MPN device registered");
          }
          coalescing = !! coalescing;

          this.mpnManager.subscribe(subscription, coalescing);
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Operation method that unsubscribes an MpnSubscription from the server's MPN Module.<BR>
       * This operation removes the MpnSubscription from the list of "active" subscriptions.
       *
       * <p class="edition-note"><B>Edition Note:</B> MPN is an optional feature, available depending on Edition and License Type.
       * To know what features are enabled by your license, please see the License tab of the Monitoring Dashboard (by default,
       * available at /dashboard).</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> An MpnSubscription can be unsubscribed from at any time. Once done the MpnSubscription immediately exits the "active" state.<BR>
       * The unsubscription will be notified through an {@link MpnSubscriptionListener#onUnsubscription} event.</p>
       *
       * @param subscription An "active" MpnSubscription object.
       * @throws IllegalStateException if the given MPN subscription is not active.
       * @throws IllegalStateException if there is no MPN device registered.
       *
       * @see #subscribeMpn
       * @see #unsubscribeMpnSubscriptions
       */
// END_NODE_JSDOC_EXCLUDE
      unsubscribeMpn: function(/*MpnSubscription*/ subscription) {
          if (! subscription.isActive()) {
              throw new IllegalStateException("MpnSubscription is not active");
          }
          if (this.mpnDevice == null) {
              throw new IllegalStateException("No MPN device registered");
          }
          this.mpnManager.unsubscribe(subscription);
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Operation method that unsubscribes all the MPN subscriptions with a specified status from the server's MPN Module.<BR>
       * By specifying a status filter it is possible to unsubscribe multiple MPN subscriptions at once. E.g. by passing <code>TRIGGERED</code> it is possible
       * to unsubscribe all triggered MPN subscriptions. This operation removes the involved MPN subscriptions from the list of "active" subscriptions.
       *
       * <p class="edition-note"><B>Edition Note:</B> MPN is an optional feature, available depending on Edition and License Type.
       * To know what features are enabled by your license, please see the License tab of the Monitoring Dashboard (by default,
       * available at /dashboard).</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Multiple unsubscription can be requested at any time. Once done the involved MPN subscriptions immediately exit the "active" state.<BR>
       * The unsubscription will be notified through an {@link MpnSubscriptionListener#onUnsubscription} event to all involved MPN subscriptions.</p>
       *
       * @param filter A status name to be used to select the MPN subscriptions to unsubscribe. If null all existing MPN subscriptions
       * are unsubscribed. Possible filter values are:<ul>
       * <li><code>ALL</code> or null</li>
       * <li><code>TRIGGERED</code></li>
       * <li><code>SUBSCRIBED</code></li>
       * </ul>
       * @throws IllegalArgumentException if the given filter is not valid.
       * @throws IllegalStateException if there is no MPN device registered.
       *
       * @see #subscribeMpn
       * @see #unsubscribeMpn
       */
// END_NODE_JSDOC_EXCLUDE
      unsubscribeMpnSubscriptions: function(filter) {
          if (! (filter == null || filter == "ALL" || filter == "SUBSCRIBED" || filter == "TRIGGERED")) {
              throw new IllegalArgumentException("The given value is not valid for this setting. Use null, ALL, TRIGGERED or SUBSCRIBED instead");
          }
          if (this.mpnDevice == null) {
              throw new IllegalStateException("No MPN device registered");
          }
          this.mpnManager.unsubscribeFilter(filter);
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Inquiry method that returns a collection of the existing MPN subscription with a specified status.<BR>
       * Can return both objects created by the user, via {@link MpnSubscription} constructors, and objects created by the client, to represent pre-existing MPN subscriptions.<BR>
       * Note that objects in the collection may be substituted at any time with equivalent ones: do not rely on pointer matching, instead rely on the
       * {@link MpnSubscription#getSubscriptionId} value to verify the equivalence of two MpnSubscription objects. Substitutions may happen
       * when an MPN subscription is modified, or when it is coalesced with a pre-existing subscription.
       *
       * <p class="edition-note"><B>Edition Note:</B> MPN is an optional feature, available depending on Edition and License Type.
       * To know what features are enabled by your license, please see the License tab of the Monitoring Dashboard (by default,
       * available at /dashboard).</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The collection is available once an MpnDevice registration has been requested, but reflects the actual server's collection only
       * after an {@link MpnDeviceListener#onSubscriptionsUpdated} event has been notified.</p>
       *
       * @param {String} filter An MPN subscription status name to be used to select the MPN subscriptions to return. If null all existing MPN subscriptions
       * are returned. Possible filter values are:<ul>
       * <li><code>ALL</code> or null</li>
       * <li><code>TRIGGERED</code></li>
       * <li><code>SUBSCRIBED</code></li>
       * </ul>
       * @return {MpnSubscription[]} the collection of {@link MpnSubscription} with the specified status.
       * @throws IllegalArgumentException if the given filter is not valid.
       * @throws IllegalStateException if there is no MPN device registered.
       *
       * @see #findMpnSubscription
       */
// END_NODE_JSDOC_EXCLUDE
      getMpnSubscriptions: function(filter) {
          if (! (filter == null || "ALL" == filter || "SUBSCRIBED" == filter || "TRIGGERED" == filter)) {
              throw new IllegalArgumentException("The given value is not valid for this setting. Use null, ALL, TRIGGERED or SUBSCRIBED instead");
          }
          if (this.mpnDevice == null) {
              throw new IllegalStateException("No MPN device registered");
          }
          /*List<MpnSubscription>*/ var ls = this.mpnManager.getSubscriptions(filter);
          return ls.toArray();
      },

// START_NODE_JSDOC_EXCLUDE
      /**
       * Inquiry method that returns the MpnSubscription with the specified subscription ID, or null if not found.<BR>
       * The object returned by this method can be an object created by the user, via MpnSubscription constructors, or an object created by the client,
       * to represent pre-existing MPN subscriptions.<BR>
       * Note that objects returned by this method may be substitutued at any time with equivalent ones: do not rely on pointer matching, instead rely on the
       * {@link MpnSubscription#getSubscriptionId} value to verify the equivalence of two MpnSubscription objects. Substitutions may happen
       * when an MPN subscription is modified, or when it is coalesced with a pre-existing subscription.
       *
       * <p class="edition-note"><B>Edition Note:</B> MPN is an optional feature, available depending on Edition and License Type.
       * To know what features are enabled by your license, please see the License tab of the Monitoring Dashboard (by default,
       * available at /dashboard).</p>
       *
       * @param {String} subscriptionId The subscription ID to search for.
       * @return {MpnSubscription} the MpnSubscription with the specified ID, or null if not found.
       * @throws IllegalArgumentException if the given subscription ID is null.
       * @throws IllegalStateException if there is no MPN device registered.
       *
       * @see #getMpnSubscriptions
       */
// END_NODE_JSDOC_EXCLUDE
      findMpnSubscription: function(subscriptionId) {
          if (subscriptionId == null) {
              throw new IllegalArgumentException("Subscription id must be not null");
          }
          return this.mpnManager.findSubscription(subscriptionId);
      },
      
      /*
       * Subscribes to the given Remote Adapter status item, so that, when the status is "disconnected",
       * the client is forced to reconnect after the given reconnect delay.
       * Also, if the Metadata Adapter is disconnected and the server sends the given CONERR code, 
       * the client reconnects after the given delay instead of going to DISCONNECTED state.
       */
      handleRemoteAdapterStatus: function(metadataErrorCode, dataAdapterName, statusItemName, reconnectMaxDelay) {
          /* Adding properties to connectionOptions, they will be propagated to Master engine */
          this.connectionOptions.installRemoteAdapterStatusObserver(metadataErrorCode, dataAdapterName, statusItemName, reconnectMaxDelay);
          var adapterSub = new Subscription("MERGE", statusItemName, ["status"]);
          adapterSub.setDataAdapter(dataAdapterName);
          adapterSub.setRequestedSnapshot("yes");
          var that = this;
          adapterSub.addListener({
              // preserve the name of the method as it is called by the dispatcher
              "onItemUpdate": function(updateInfo) {
                  var status = updateInfo.getValue("status");
                  console.log("STATUS", status);
                  if (status && status != "connected") {
                      var eh = that.getEngineHandler();
                      if (eh) {
                          eh.callDisconnectAndReconnect();
                      }
                  }
              }
          });
          Executor.addTimedTask(this.subscribe, 0, this, [adapterSub]);
      }

  };

  /*
   * TEST-ONLY METHOD.
   * Enable WS if disabled.
   */
  LightstreamerClient["__restoreWs"] = WebSocketConnection.restoreClass;
  LightstreamerClient["__disableWs"] = WebSocketConnection.disableClass;

  /*
   * TEST-ONLY METHOD.
   */
  LightstreamerClient["__handleError5"] = Constants.handleError5;

  LightstreamerClient["addCookies"] = LightstreamerClient.addCookies;
  LightstreamerClient["getCookies"] = LightstreamerClient.getCookies;
  LightstreamerClient["setLoggerProvider"] = LightstreamerClient.setLoggerProvider;
  LightstreamerClient["LIB_NAME"] = LightstreamerClient.LIB_NAME;
  LightstreamerClient["LIB_VERSION"] = LightstreamerClient.LIB_VERSION;
  LightstreamerClient.prototype["connect"] = LightstreamerClient.prototype.connect;
  LightstreamerClient.prototype["disconnect"] = LightstreamerClient.prototype.disconnect;
  LightstreamerClient.prototype["getStatus"] = LightstreamerClient.prototype.getStatus;
  LightstreamerClient.prototype["sendMessage"] = LightstreamerClient.prototype.sendMessage;
  LightstreamerClient.prototype["getSubscriptions"] = LightstreamerClient.prototype.getSubscriptions;
  LightstreamerClient.prototype["subscribe"] = LightstreamerClient.prototype.subscribe;
  LightstreamerClient.prototype["unsubscribe"] = LightstreamerClient.prototype.unsubscribe;
  LightstreamerClient.prototype["addListener"] = LightstreamerClient.prototype.addListener;
  LightstreamerClient.prototype["removeListener"] = LightstreamerClient.prototype.removeListener;
  LightstreamerClient.prototype["getListeners"] = LightstreamerClient.prototype.getListeners;
  LightstreamerClient.prototype["registerForMpn"] = LightstreamerClient.prototype.registerForMpn;
  LightstreamerClient.prototype["subscribeMpn"] = LightstreamerClient.prototype.subscribeMpn;
  LightstreamerClient.prototype["unsubscribeMpn"] = LightstreamerClient.prototype.unsubscribeMpn;
  LightstreamerClient.prototype["unsubscribeMpnSubscriptions"] = LightstreamerClient.prototype.unsubscribeMpnSubscriptions;
  LightstreamerClient.prototype["findMpnSubscription"] = LightstreamerClient.prototype.findMpnSubscription;
  LightstreamerClient.prototype["getMpnSubscriptions"] = LightstreamerClient.prototype.getMpnSubscriptions;
  LightstreamerClient.prototype["handleRemoteAdapterStatus"] = LightstreamerClient.prototype.handleRemoteAdapterStatus;

  LightstreamerClient.prototype["enableSharing"] = LightstreamerClient.prototype.enableSharing;
  LightstreamerClient.prototype["isMaster"] = LightstreamerClient.prototype.isMaster;

  LightstreamerClient.prototype["unloadEvent"] = LightstreamerClient.prototype.unloadEvent;
  LightstreamerClient.prototype["preUnloadEvent"] = LightstreamerClient.prototype.unloadEvent;


  Inheritance(LightstreamerClient,EventDispatcher,false,true);
  Inheritance(LightstreamerClient,Setter,true,true);
  return LightstreamerClient;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/
var SimpleLogLevels = /*@__PURE__*/(function() {
  /**
   * @private
   */
  var logLevel = {
    "FATAL": 5,
    "ERROR": 4,
    "WARN": 3,
    "INFO": 2,
    "DEBUG": 1
  };
  
  /*
  bring around numbers instead of names?
  var logNames = {
      5: "FATAL",
      4: "ERROR",
      3: "WARN",
      2: "INFO",
      1: "DEBUG"
  }*/

  /**
   * @exports SimpleLogLevels
   */
  var SimpleLogLevels = {
    /**
     * Coupling log level names with priority.
     * @static
     *
     * @param {String} level the level to be converted into priority. Admitted values are 
     * "FATAL" (5), "ERROR" (4),  "WARN" (3), "INFO" (2), "DEBUG" (1). 
     * @returns {Number} a numeric level representing the priority of the specified log level.
     * if an invalid level is specified 0 is returned.
     */
    priority: function(level) {
      return logLevel[level] || 0;
    }
    /*
    name: function(level) {
      logNames[level];
    }  
    */
  };
  
  SimpleLogLevels["priority"] = SimpleLogLevels.priority;
  //SimpleLogLevels["name"] = SimpleLogLevels.name;
  
  return SimpleLogLevels;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var SimpleLogAppender = /*@__PURE__*/(function() {
  /**
   * This is an abstract class; no instances of this class should be created.
   * @constructor
   * 
   * @param {String} level The threshold level at which the SimpleLogAppender is created.
   * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not
   * or wrongly specified INFO is assumed.
   * @param {String} category The category this appender should listen to.
   * If not specified the appender will get log for every available category.
   * 
   * @exports SimpleLogAppender
   * @class Abstract class serving as a base class for appender classes for the {@link SimpleLoggerProvider}.
   * An instance of an appender class can be added
   * to a {@link SimpleLoggerProvider} instance in order to consume log lines.
   * <br/>Various classes that extend LogAppender and that consume the log lines
   * in various ways are provided. The definition of custom appender
   * implementations is supported through the usage of Inheritance from the utility-toolkit.
   */
  var SimpleLogAppender = function(level,category) {
 
    /**
     * @private
     */
    this.myLevel = SimpleLogLevels.priority(level) ? level : "INFO";
    
    /**
     * @private
     */
    this.catFilter = category || "*";
    
    /**
     * @private
     */
    this.myLoggerProvider = null;

  };

  SimpleLogAppender.prototype = {
      
    /**
     * Called by SimpleLoggerProvider to notify itself to a newly added appender.
     * @param {SimpleLoggerProvider} loggerProvider the SimpleLoggerProvider instance handling this appender. 
     */
    setLoggerProvider: function(loggerProvider) {
      if (loggerProvider && loggerProvider.getLogger && loggerProvider.forceLogLevelUpdate) {
        this.myLoggerProvider = loggerProvider;
      }
    },
    
    /**
     * This implementation is empty. 
     * This is the method that is supposedly written by subclasses to publish log messages
     * 
     * @param {String} category the logger category that produced the given message.
     * @param {String} level the logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL.
     * @param {String} mex the message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * @param {String} header a header for the message
     */
    log: function(category, level, mex, header) {
      
    },
    
    /**
     * Utility method that can be used by subclasses to join various info in a single line.
     * The message will be composed this way:  category + " | " + level + " | " + header + " | " + mex
     * @protected 
     * @param {String} category the message category
     * @param {String} level the message level
     * @param {String} mex the message itself
     * @param {String} header a custom header
     * @returns {String}
     */
    composeLine: function(category, level, mex, header) {
      return category + " | " + level + " | " + header + " | " + mex;
    },
     
    /**
     * Inquiry method that returns the current threshold level of this SimpleLogAppender 
     * instance. 
     * 
     * @return {String} the level of this SimpleLogAppender instance. 
     * It will be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL".
     */
    getLevel: function() {
      return this.myLevel; 
    },
    
    /**
     * Setter method that changes the current threshold level of this 
     * SimpleLogAppender instance. 
     * The filter can be changed at any time and will affect subsequent log lines
     *
     * @param {String} [level] The new level for this SimpleLogAppender instance. 
     * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not or wrongly
     * specified INFO will be used. 
     */
    setLevel: function(level) {
      level = SimpleLogLevels.priority(level) ? level : "INFO";
      this.myLevel = level; 
      if ( this.myLoggerProvider != null ) {
        this.myLoggerProvider.forceLogLevelUpdate();
      }
    },
    
    /**
     * Inquiry method that returns the category for this SimpleLogAppender instance. 
     * A SimpleLogAppender only receives log lines from the {@link Logger}
     * associated to the returned category, unless
     * "*" is returned, in which case it receives log from all loggers.
     * 
     * @return {String} The category of this SimpleLogAppender instance, or "*".
     */
    getCategoryFilter: function() {
      return this.catFilter; 
    },
    
    /**
     * Setter method that changes the current category of this 
     * SimpleLogAppender instance. 
     * <br/>This SimpleLogAppender will only receive log lines from the {@link Logger}
     * associated to the specified category, unless
     * "*" is specified, in which case it will receive log from all loggers.
     * <br/>the filter can be changed at any time and will affect subsequent log lines.
     * 
     * @param {String} [category] the new category for this SimpleLogAppender, or "*". 
     * If not specified "*" is assumed
     */
    setCategoryFilter: function(category) {
      this.catFilter = category || "*"; 
    }
  }; 
  
  //google closure exports
  SimpleLogAppender.prototype["log"] = SimpleLogAppender.prototype.log;
  SimpleLogAppender.prototype["setLoggerProvider"] = SimpleLogAppender.prototype.setLoggerProvider;
  SimpleLogAppender.prototype["composeLine"] = SimpleLogAppender.prototype.composeLine;
  SimpleLogAppender.prototype["getLevel"] = SimpleLogAppender.prototype.getLevel;
  SimpleLogAppender.prototype["setLevel"] = SimpleLogAppender.prototype.setLevel;
  SimpleLogAppender.prototype["getCategoryFilter"] = SimpleLogAppender.prototype.getCategoryFilter;
  SimpleLogAppender.prototype["setCategoryFilter"] = SimpleLogAppender.prototype.setCategoryFilter;
  
  
  return SimpleLogAppender;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var BufferAppender = /*@__PURE__*/(function() {
  /**
   * Constructor for BufferAppender.
   * @constructor
   * 
   * @param {String} level The threshold level at which the SimpleLogAppender is created.
   * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not
   * or wrongly specified INFO is assumed.
   * @param {String} category The category this appender should listen to.
   * If not specified the appender will get log for every available category.
   * See {@link SimpleLogAppender#setCategoryFilter}.
   * @param {Number} size The maximum number of log messages stored in the internal buffer. 
   * If 0 or no value is passed, unlimited is assumed.
   * 
   * @exports BufferAppender
   * @class BufferAppender extends SimpleLogAppender and implements an internal buffer 
   * store for log messages. The messages can be extracted from the buffer when needed.
   * The buffer size can be limited or unlimited. If limited it is implemented as 
   * a FIFO queue. 
   *
   * @extends SimpleLogAppender
   */
  var BufferAppender = function(level, category, size) {

    this._callSuperConstructor(BufferAppender, [level, category]);
  
    //Buffer size
    if ( !size || size < 0 ) {
      this.historyDim = 0;
    } else {
      this.historyDim = size;
    }

    //first element in the buffer
    this.first = 0;

    //last element
    this.last = -1;

    //the buffer
    this.buffer = {};
    
  };

  BufferAppender.prototype = {
      
    /**
     * Operation method that resets the buffer making it empty.
     */
    reset: function() {
      this.first = 0;
      this.last = -1;
      this.buffer = {};
    },

    /**
     * Retrieve log messages from the buffer.
     * The extracted messages are then removed from the internal buffer.
     *
     * @param {String} [sep] separator string between the log messages in the result string. If null or not specified "\n" is used.
     * 
     * @return {String} a concatenated string of all the log messages that have been retrieved.
     */
    extractLog: function(sep) {
      var res = this.getLog(null,sep);
      this.reset();
      return res;
    },
    
    /**
     * Retrieve log messages from the buffer.
     * The extracted messages are NOT removed from the internal buffer.
     *
     * @param {Number} [maxRows] the number of log lines to be retrieved. If not specified all the available lines are retrieved.
     * @param {String} [sep] separator string between the log messages in the result string. If not specified "\n" is used.
     * @param {String} [level] the level of the log to be retrieved.
     * 
     * @return {String} a concatenated string of all the log messages that have been retrieved.
     */
    getLog: function(maxRows, sep, level) {
      var i;
      var _dump = "";
        
      level = level || "DEBUG";
        
      if (!maxRows) {
        i = this.first;
      } else {   
        i = this.last - maxRows + 1;      
        if (i < this.first) {
          i = this.first;
        }
      }
       
      sep = sep || "\n";
      
      var priority = SimpleLogLevels.priority(level);
      while (i <= this.last) {
        
         if ( SimpleLogLevels.priority(this.buffer[i].level) >= priority ) {
          _dump += this.buffer[i].mex;
        }
        _dump += sep;
        i++;
      }

      return _dump;
    },
    
    /**
     * Add a log message in the internal buffer.
     * 
     * @param {String} category the logger category that produced the given message.
     * @param {String} level the logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL.
     * @param {String} mex the message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * @param {String} header a header for the message
     */
    log: function(category, level, mex, header) {
      var i = ++this.last;
      
      if ( this.historyDim != 0 && i >= this.historyDim ) {
        this.buffer[this.first] = null;
        this.first++;
      }
      
      mex = this.composeLine(category, level, mex, header);
      this.buffer[i] = {
          level: level,
          mex: mex
      };

    },
    
    /**
     * Gets the number of buffered lines
     * @returns {Number} the number of buffered lines
     */
    getLength: function() {
      return this.last-this.first+1;
    }
    
  

  };
  
  BufferAppender.prototype["reset"] = BufferAppender.prototype.reset;
  BufferAppender.prototype["getLog"] = BufferAppender.prototype.getLog;
  BufferAppender.prototype["extractLog"] = BufferAppender.prototype.extractLog;
  BufferAppender.prototype["log"] = BufferAppender.prototype.log;
  BufferAppender.prototype["getLength"] = BufferAppender.prototype.getLength;
  
  Inheritance(BufferAppender, SimpleLogAppender);
  return BufferAppender;
})();

var RemoteAppender = /*@__PURE__*/(function() {
  /**
   * Constructor for RemoteAppender.
   * @constructor
   * 
   * @exports RemoteAppender
   * 
   * @throws {IllegalArgumentException} if the LightstreamerClient parameter is missing
   * 
   * @param {String} level The threshold level at which the RemoteAppender is created.
   * It should be one of "WARN", "ERROR" and "FATAL".
   * The use for "DEBUG" and "INFO" levels is not supported on this appender.
   * @param {String} category The category this appender should listen to.
   * See {@link SimpleLogAppender#setCategoryFilter}.
   * @param {LightstreamerClient} lsClient An instance of LightstreamerClient object used to send 
   * log messages back to the server.
   * 
   * @class RemoteAppender extends SimpleLogAppender and implements the publishing 
   * of log messages by sending them back to Lightstreamer Server.
   * The Server will log the messages through its "LightstreamerLogger.webclient" logger
   * at DEBUG level.
   * <BR>Note that the delivery of some log messages to the Server may fail.
   * 
   * @extends SimpleLogAppender
   */
  var RemoteAppender = function(level, category, lsClient) {
    this._callSuperConstructor(RemoteAppender, [level, category, 10]);
        
    this.waiting = false;
    
    if (!lsClient) {
      throw new IllegalArgumentException("a LightstreamerClient instance is necessary for a RemoteAppender to work.");
    }
    
    this._client = lsClient;
  };
  
  
  RemoteAppender.prototype = {

  
    /**
     * Publish a log message by sending it to Lightstreamer server by LightstreamerClient object.
     * Specific layout: 'LS_log1=HH:mm:ss.ccc - category : message'.
     * 
     * @param category The logger category that produced the given message.
     * @param level The logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL
     * constants values. 
     * @param mex The message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * 
     */
    log: function(category, level, mex, header) {
      this._callSuperMethod(RemoteAppender,"log",[category, level, mex, header]);
      this._flush(true);
    },
    
    /**
     * @private 
     */
    _flush: function(syncCall) {
      if (this.getLength() <= 0) {
        return;
      }
      
      if (this._client.getStatus().indexOf("CONNECTED") == 0) {
        var sendObj = this.extractLogForNetwork();

        if (this._client.sendLog(sendObj)) {
          this.reset();
          this.waiting = false;
          return;
        }
      } 
      
      if (!this.waiting || !syncCall) {
        this.waiting = true;
        Executor.addTimedTask(this._flush,2000,this);
      }
    },
    
    extractLogForNetwork: function(maxRows,sepBefore) {
      var orig = this._callSuperMethod(RemoteAppender,"extractLog",["LS_log"]);
      orig = orig.split("LS_log");
      
      var sepBefore = "LS_log";
      var dump = {};
      for (var i=0; i<orig.length; i++) {
        if (orig[i].length == 0) {
          continue;
        }
        var name = sepBefore+(i+1);
        dump[name] = encodeURIComponent(orig[i].replace(/[\n\r\f]/g,"||"));
      }
      
      return dump;
    },
    
    
    /**
     * Disabled
     */
    extractLog: function() {
      return null;
    }
  };

  RemoteAppender.prototype["extractLog"] = RemoteAppender.prototype.extractLog;
  RemoteAppender.prototype["log"] = RemoteAppender.prototype.log;
  
  Inheritance(RemoteAppender, BufferAppender,false,true);
  return RemoteAppender;
})();

/**
     * API exposed to {@link MpnManager}
     */
	var DeviceEventManager = function(device) {
		this.device = device;
	};
	
	DeviceEventManager.prototype = {
	        
	        /**
	         * Fired when the current session closes.
	         * 
	         * @param recovery if the flag is true, the closing is due to an automatic recovery.
	         * Otherwise the closing is due to a disconnection made by the user
	         * (see {@link LightstreamerClient#disconnect()}).
	         */
	        onSessionClose: function(recovery) {
	            if (recovery) ; else {
	                // reset state
	                this.device.stateMachine.onSessionClose();
	                this.device.deviceId = null;
	                this.device.adapterName = null;
	                this.device.statusTimestamp = 0;
	            }
            },
		
			/**
             * Fired when the message MPNREG is received.
             */
			onRegisterOK: function(deviceId, adapterName) {
				this.device.deviceId = deviceId;
                this.device.adapterName = adapterName;
	        },
	        
	        /**
             * Fired when a REQERR is received as a response of a register request.
             */
	        onRegisterError: function(code, message) {
	        	this.device.stateMachine.error(code, message);
	        },
	        
	        /**
             * Fired when item DEV- publishes an update.
             */
	        onStatusChange: function(status, timestamp) {
	        	switch (status) {
	            
	        	case "ACTIVE":
	        		this.device.stateMachine.activate(timestamp);
	                break;
	            
	        	case "SUSPENDED":
	        		this.device.stateMachine.suspend(timestamp);
	                break;
	            }
	        },
	        
	        onSubscriptionsUpdated: function() {
	            this.device.dispatchEvent("onSubscriptionsUpdated");
            }
	};

var MpnDevice = /*@__PURE__*/(function() {
	var log = LoggerManager.getLoggerProxy(Constants.MPN);

	/**
	 * Creates an object to be used to describe an MPN device that is going to be registered to the MPN Module of Lightstreamer Server.<BR>
     * During creation the MpnDevice tries to acquires any previously registered device token from localStorage.
     * It then saves the current device token on localStorage. Saving and retrieving the previous device token is used to handle automatically
     * the cases where the token changes. The MPN Module of Lightstreamer Server is able to move
     * MPN subscriptions associated with the previous token to the new one.
     *
     * @constructor
     * @param {String} token the device token
     * @param {String} appId the application identifier
     * @param {String} platform either "Google" for Google's Firebase Cloud Messaging (FCM) or "Apple" for Apple Push Notification Service (APNs)
     *
     * @throws IllegalArgumentException if <code>token</code> or <code>appId</code> is null or <code>platform</code> is not "Google" or "Apple".
     *
	 * @exports MpnDevice
	 *
	 * @class Class representing a device that supports Web Push Notifications.<BR>
	 * It contains device details and the listener needed to monitor its status.<BR>
	 * An MPN device is created from the application identifier, the platform and a device token (a.k.a. registration token) obtained from
	 * web push notifications APIs, and must be registered on the {@link LightstreamerClient} in order to successfully subscribe an MPN subscription.
	 * See {@link MpnSubscription}.<BR>
	 * After creation, an MpnDevice object is in "unknown" state. It must then be passed to the Lightstreamer Server with the
	 * {@link LightstreamerClient#registerForMpn} method, which enables the client to subscribe MPN subscriptions and sends the device details to the
	 * server's MPN Module, where it is assigned a permanent device ID and its state is switched to "registered".<BR>
	 * Upon registration on the server, active MPN subscriptions of the device are received and exposed with the {@link LightstreamerClient#getMpnSubscriptions}
	 * method.<BR>
	 * An MpnDevice's state may become "suspended" if errors occur during push notification delivery. In this case MPN subscriptions stop sending notifications
	 * and the device state is reset to "registered" at the first subsequent registration.
	 */
    var MpnDevice = function(deviceToken, appId, platform) {
        if (deviceToken == null) {
            throw new IllegalArgumentException("Please specify a valid device token");
        }
        if (appId == null) {
            throw new IllegalArgumentException("Please specify a valid application ID");
        }
        if (platform != 'Google' && platform != 'Apple') {
            throw new IllegalArgumentException("Please specify a valid platform: Google or Apple");
        }
        this.initDispatcher();
        this.deviceToken = deviceToken;
        this.appId = appId;
        this.platform = platform;
        this.deviceId = null;
        this.statusTimestamp = 0;
        try {
            this.prevDeviceToken = window.localStorage.getItem('com.lightstreamer.mpn.device_token');
            window.localStorage.setItem('com.lightstreamer.mpn.device_token', deviceToken);
        } catch(e) {
            this.prevDeviceToken = null;
            log.error("Local storage not available", e);
        }
        this.eventManager = new DeviceEventManager(this);
        this.stateMachine = new StateMachine(this);
    };

    MpnDevice.prototype = {

            /**
             * Adds a listener that will receive events from the MpnDevice
             * instance.
             * <BR>The same listener can be added to several different MpnDevice
             * instances.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
             *
             * @param {MpnDeviceListener} listener An object that will receive the events
             * as shown in the {@link MpnDeviceListener} interface.
             * <BR>Note that the given instance does not have to implement all of the
             * methods of the MpnDeviceListener interface. In fact it may also
             * implement none of the interface methods and still be considered a valid
             * listener. In the latter case it will obviously receive no events.
             */
            addListener: function(listener) {
                this._callSuperMethod(MpnDevice, "addListener", [listener]);
            },

            /**
             * Removes a listener from the MpnDevice instance so that it
             * will not receive events anymore.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
             *
             * @param {MpnDeviceListener} listener The listener to be removed.
             */
            removeListener: function(listener) {
                this._callSuperMethod(MpnDevice, "removeListener", [listener]);
            },

            /**
             * Returns an array containing the {@link MpnDeviceListener} instances that
             * were added to this client.
             *
             * @return {MpnDeviceListener[]} an Array containing the listeners that were added to this client.
             * Listeners added multiple times are included multiple times in the array.
             */
            getListeners: function() {
                return this._callSuperMethod(MpnDevice, "getListeners");
            },

            /**
             * The platform identifier of this MPN device. It equals <code>Google</code> or <code>Apple</code> and is used by the server as part of the device identification.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the MPN device platform.
             */
            getPlatform: function() {
                return this.platform;
            },

            /**
             * The application ID of this MPN device. It is used by the server as part of the device identification.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the MPN device application ID.
             */
            getApplicationId: function() {
                return this.appId;
            },

            /**
             * The device token of this MPN device. It is passed during creation and
             * is used by the server as part of the device identification.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the MPN device token.
             */
            getDeviceToken: function() {
                return this.deviceToken;
            },

            /**
             * The previous device token of this MPN device. It is obtained automatically from
             * localStorage during creation and is used by the server to restore MPN subscriptions associated with this previous token. May be null if
             * no MPN device has been registered yet on the application.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the previous MPN device token, or null if no MPN device has been registered yet.
             */
            getPreviousDeviceToken: function() {
                return this.prevDeviceToken;
            },

            /**
             * Checks whether the MPN device object is currently registered on the server or not.<BR>
             * This flag is switched to true by server sent registration events, and back to false in case of client disconnection or server sent suspension events.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {boolean} true if the MPN device object is currently registered on the server.
             *
             * @see #getStatus
             */
            isRegistered: function() {
                return this.stateMachine.state.isRegistered;
            },

            /**
             * Checks whether the MPN device object is currently suspended on the server or not.<BR>
             * An MPN device may be suspended if errors occur during push notification delivery.<BR>
             * This flag is switched to true by server sent suspension events, and back to false in case of client disconnection or server sent resume events.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {boolean} true if the MPN device object is currently suspended on the server.
             *
             * @see #getStatus
             */
            isSuspended: function() {
                return this.stateMachine.state.isSuspended;
            },

            /**
             * The status of the device.<BR>
             * The status can be:<ul>
             * <li><code>UNKNOWN</code>: when the MPN device object has just been created or deleted. In this status {@link MpnDevice#isRegistered} and {@link MpnDevice#isSuspended} are both false.</li>
             * <li><code>REGISTERED</code>: when the MPN device object has been successfully registered on the server. In this status {@link MpnDevice#isRegistered} is true and
             * {@link MpnDevice#isSuspended} is false.</li>
             * <li><code>SUSPENDED</code>: when a server error occurred while sending push notifications to this MPN device and consequently it has been suspended. In this status
             * {@link MpnDevice#isRegistered} and {@link MpnDevice#isSuspended} are both true.</li>
             * </ul>
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the status of the device.
             *
             * @see #isRegistered
             * @see #isSuspended
             */
            getStatus: function() {
                return this.stateMachine.state.status;
            },

            /**
             * The server-side timestamp of the device status.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {Number} The server-side timestamp of the device status.
             *
             * @see #getStatus
             */
            getStatusTimestamp: function() {
                return this.statusTimestamp;
            },

            /**
             * The server-side unique persistent ID of the device.<BR>
             * The ID is available only after the MPN device object has been successfully registered on the server. I.e. when its status is <code>REGISTERED</code> or
             * <code>SUSPENDED</code>.<BR>
             * Note: a device token change, if the previous device token was correctly stored on localStorage, does not cause the device ID to change: the
             * server moves previous MPN subscriptions from the previous token to the new one and the device ID remains unaltered.
             *
             * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
             *
             * @return {String} the MPN device ID.
             */
            getDeviceId: function() {
                return this.deviceId;
            }

    };

    function State(isRegistered, isSuspended, status) {
        this.isRegistered = isRegistered;
        this.isSuspended = isSuspended;
        this.status = status;
    }

    State.UNKNOWN = new State(false, false, "UNKNOWN");
    State.REGISTERED = new State(true, false, "REGISTERED");
    State.SUSPENDED = new State(true, true, "SUSPENDED");

    var StateMachine = function(device) {
    	this.device = device;
    	this.state = State.UNKNOWN;
    };

    StateMachine.prototype = {

    		activate: function(timestamp) {
    			var event = "activate";
    			this.device.statusTimestamp = timestamp;
    			switch (this.state) {

    			case State.UNKNOWN:
    				this.next(State.REGISTERED, event);
    				this.device.dispatchEvent("onRegistered");
    				break;

    			case State.SUSPENDED:
    				this.next(State.REGISTERED, event);
    				this.device.dispatchEvent("onResumed");
    				break;

    			case State.REGISTERED:
    			    // stay registered
    	            // two activations in a row can happen if the client creates a new session after a session error:
    	            // the first activation happens in the first session, while the second activation happens in
    	            // the second session
    			    break;

    			default:
    			    this.throwError(event);
    			}
            },

            suspend: function(timestamp) {
            	var event = "suspend";
    			this.device.statusTimestamp = timestamp;
    			switch (this.state) {

    			case State.UNKNOWN:
    				this.next(State.SUSPENDED, event);
    				this.device.dispatchEvent("onSuspended");
    				break;

    			case State.REGISTERED:
    				this.next(State.SUSPENDED, event);
    				this.device.dispatchEvent("onSuspended");
    				break;

    			case State.SUSPENDED:
    			    // stay suspended
    	            // two suspensions in a row can happen if the client creates a new session after a session error
    	            // the first suspension happens in the first session, while the second suspension happens in
    	            // the second session
    			    break;

    			default:
    			    this.throwError(event);
    			}
            },

            error: function(code, message) {
                var event = "error";
                switch (this.state) {

                case State.UNKNOWN:
                    this.next(State.UNKNOWN, event);
                    this.device.dispatchEvent("onRegistrationFailed", [code, message]);
                    break;

                default:
                    this.throwError("error (" + code + " - " + message + ")");
                }
            },

            onSessionClose: function() {
                this.next(State.UNKNOWN, "onSessionClose");
            },

            next: function(next, event) {
    			if (log.isDebugLogEnabled()) {
    				var from = this.state.status;
    				var to = next.status;
    				log.logDebug(LoggerManager.resolve(935), this.device.deviceId + " on '" + event + "': " + from + " -> " + to);
    			}
    			if (next != this.state) {
    				this.state = next;
    				this.device.dispatchEvent("onStatusChanged", [this.state.status, this.device.statusTimestamp]);
    			}
    		},

    		throwError: function(event) {
    		    var msg = "Unexpected event '" + event + "' in state " + this.state.status + " (" + this.device.deviceId + ")";
    		    log.logError(msg);
    		    throw new Error(msg);
    		}
    };

    MpnDevice.prototype["getPlatform"] = MpnDevice.prototype.getPlatform;
    MpnDevice.prototype["getApplicationId"] = MpnDevice.prototype.getApplicationId;
    MpnDevice.prototype["getDeviceToken"] = MpnDevice.prototype.getDeviceToken;
    MpnDevice.prototype["getPreviousDeviceToken"] = MpnDevice.prototype.getPreviousDeviceToken;
    MpnDevice.prototype["isRegistered"] = MpnDevice.prototype.isRegistered;
    MpnDevice.prototype["isSuspended"] = MpnDevice.prototype.isSuspended;
    MpnDevice.prototype["getStatus"] = MpnDevice.prototype.getStatus;
    MpnDevice.prototype["getStatusTimestamp"] = MpnDevice.prototype.getStatusTimestamp;
    MpnDevice.prototype["getDeviceId"] = MpnDevice.prototype.getDeviceId;
    MpnDevice.prototype["addListener"] = MpnDevice.prototype.addListener;
    MpnDevice.prototype["removeListener"] = MpnDevice.prototype.removeListener;
    MpnDevice.prototype["getListeners"] = MpnDevice.prototype.getListeners;

    Inheritance(MpnDevice,EventDispatcher);
    return MpnDevice;
})();

var NotificationBuilder = function(descriptor) {
        this._descriptor = descriptor || {};
    };
    
    NotificationBuilder.prototype = {
            
            putAll: function(mapName, source) {
                var target = this.getMap(mapName);
                for (var p in source) {
                    target[p] = source[p];
                }
            },
            
            setValue: function(mapName, propName, propValue) {
                if (propValue != null) {
                    this.getMap(mapName)[propName] = propValue;
                } else {
                    delete this.getMap(mapName)[propName];
                }
                return this;
            },
            
            getValue: function(mapName, propName) {
                return this.getMap(mapName)[propName];
            },
            
            /*Map<String, Object>*/ getMap: function(path) {
                var descriptor = this._descriptor;
                var names = path.split(".");
                for (var i = 0, len = names.length; i < len; i++) {
                    var name = names[i];
                    var objectMap = descriptor[name];
                    if (objectMap == null) {
                        objectMap = {};
                        descriptor[name] = objectMap;
                    }
                    descriptor = objectMap;
                }
                return descriptor;
            },
      
            /*Map<String, Object>*/ build: function() {
                return this._descriptor;
            }
    };
    
    NotificationBuilder.prototype['putAll'] = NotificationBuilder.prototype.putAll;
    NotificationBuilder.prototype['setValue'] = NotificationBuilder.prototype.setValue;
    NotificationBuilder.prototype['getValue'] = NotificationBuilder.prototype.getValue;
    NotificationBuilder.prototype['getMap'] = NotificationBuilder.prototype.getMap;
    NotificationBuilder.prototype['build'] = NotificationBuilder.prototype.build;

var SafariMpnBuilder = /*@__PURE__*/(function() {
    /**
     * Creates an object to be used to create a push notification format.<BR>
     * Use setters methods to set the value of push notification fields or use a JSON structure to initialize the fields.
     *
     * @constructor
     * @exports SafariMpnBuilder
     * 
     * @param [notificationFormat] A JSON structure representing a push notification format.
     *
     * @class Utility class that provides methods to build or parse the JSON structure used to represent the format of a push notification.<BR>
     * It provides getters and setters for the fields of a push notification, following the format specified by Apple Push Notification Service (APNs).
     * This format is compatible with {@link MpnSubscription#setNotificationFormat}.
     *
     * @see MpnSubscription#setNotificationFormat
     */
    var SafariMpnBuilder = function(notificationFormat) {
        if (notificationFormat) {
            var descriptor = JSON.parse(notificationFormat);
            this._callSuperConstructor(SafariMpnBuilder, [descriptor]);
        } else {
            this._callSuperConstructor(SafariMpnBuilder);
        }
    };

    SafariMpnBuilder.prototype = {

            /**
             * Produces the JSON structure for the push notification format specified by this object.
             * @return {String} the JSON structure for the push notification format.
             */
            build: function() {
                var map = this._callSuperMethod(SafariMpnBuilder, "build");
                return JSON.stringify(map);
            },

            /**
             * Gets the value of <code>aps&period;alert&period;title</code> field.
             * @return {String} the value of <code>aps&period;alert&period;title</code> field, or null if absent.
             */
            getTitle: function() {
                return this.getValue("aps.alert", "title");
            },

            /**
             * Sets the <code>aps&period;alert&period;title</code> field.
             *
             * @param {String} title A string to be used for the <code>aps&period;alert&period;title</code> field value, or null to clear it.
             * @return {SafariMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setTitle: function(title) {
                return this.setValue("aps.alert", "title", title);
            },

            /**
             * Gets the value of <code>aps&period;alert&period;body</code> field.
             * @return {String} the value of <code>aps&period;alert&period;body</code> field, or null if absent.
             */
            getBody: function() {
                return this.getValue("aps.alert", "body");
            },

            /**
             * Sets the <code>aps&period;alert&period;body</code> field.
             *
             * @param {String} body A string to be used for the <code>aps&period;alert&period;body</code> field value, or null to clear it.
             * @return {SafariMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setBody: function(body) {
                return this.setValue("aps.alert", "body", body);
            },

            /**
             * Gets the value of <code>aps&period;alert&period;action</code> field.
             * @return {String} the value of <code>aps&period;alert&period;action</code> field, or null if absent.
             */
            getAction: function() {
                return this.getValue("aps.alert", "action");
            },

            /**
             * Sets the <code>aps&period;alert&period;action</code> field.
             *
             * @param {String} action A string to be used for the <code>aps&period;alert&period;action</code> field value, or null to clear it.
             * @return {SafariMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setAction: function(action) {
                return this.setValue("aps.alert", "action", action);
            },

            /**
             * Gets the value of <code>aps&period;url-args</code> field.
             * @return {String[]} the value of <code>aps&period;url-args</code> field, or null if absent.
             */
            getUrlArguments: function() {
                return this.getValue("aps", "url-args");
            },

            /**
             * Sets the <code>aps&period;url-args</code> field.
             *
             * @param {String[]} urlArguments An array to be used for the <code>aps&period;url-args</code> field value, or null to clear it.
             * @return {SafariMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setUrlArguments: function(urlArguments) {
                return this.setValue("aps", "url-args", urlArguments);
            }
    };

    SafariMpnBuilder.prototype['build'] = SafariMpnBuilder.prototype.build;
    SafariMpnBuilder.prototype['getTitle'] = SafariMpnBuilder.prototype.getTitle;
    SafariMpnBuilder.prototype['setTitle'] = SafariMpnBuilder.prototype.setTitle;
    SafariMpnBuilder.prototype['getBody'] = SafariMpnBuilder.prototype.getBody;
    SafariMpnBuilder.prototype['setBody'] = SafariMpnBuilder.prototype.setBody;
    SafariMpnBuilder.prototype['getAction'] = SafariMpnBuilder.prototype.getAction;
    SafariMpnBuilder.prototype['setAction'] = SafariMpnBuilder.prototype.setAction;
    SafariMpnBuilder.prototype['getUrlArguments'] = SafariMpnBuilder.prototype.getUrlArguments;
    SafariMpnBuilder.prototype['setUrlArguments'] = SafariMpnBuilder.prototype.setUrlArguments;

    Inheritance(SafariMpnBuilder, NotificationBuilder);
    return SafariMpnBuilder;
})();

var FirebaseMpnBuilder = /*@__PURE__*/(function() {
    /**
     * Creates an object to be used to create a push notification format.<BR>
     * Use setters methods to set the value of push notification fields or use a JSON structure to initialize the fields.
     *
     * @constructor
     * @exports FirebaseMpnBuilder
     *
     * @param [notificationFormat] A JSON structure representing a push notification format.
     *
     * @class Utility class that provides methods to build or parse the JSON structure used to represent the format of a push notification.<BR>
     * It provides getters and setters for the fields of a push notification, following the format specified by Google's Firebase Cloud Messaging (FCM).
     * This format is compatible with {@link MpnSubscription#setNotificationFormat}.
     *
     * @see MpnSubscription#setNotificationFormat
     */
    var FirebaseMpnBuilder = function(notificationFormat) {
        if (notificationFormat) {
            var descriptor = JSON.parse(notificationFormat);
            this._callSuperConstructor(FirebaseMpnBuilder, [descriptor]);
        } else {
            this._callSuperConstructor(FirebaseMpnBuilder);
        }
    };

    FirebaseMpnBuilder.prototype = {

            /**
             * Produces the JSON structure for the push notification format specified by this object.
             * @return {String} the JSON structure for the push notification format.
             */
            build: function() {
                var map = this._callSuperMethod(FirebaseMpnBuilder, "build");
                return JSON.stringify(map);
            },

            /**
             * Gets sub-fields of the <code>webpush&period;headers</code> field.
             * @return {Object} a map with sub-fields of the <code>webpush&period;headers</code> field, or null if absent.
             */
            getHeaders: function() {
                return this.getValue("webpush", "headers");
            },

            /**
             * Sets sub-fields of the <code>webpush&period;headers</code> field.
             *
             * @param {Object} headers map to be used for sub-fields of the <code>webpush&period;headers</code> field, or null to clear it.
             * @return {FirebaseMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setHeaders: function(headers) {
                if (headers != null) {
                    this.putAll("webpush.headers", headers);
                } else {
                    delete this.getMap("webpush")["headers"];
                }
                return this;
            },

            /**
             * Gets the value of <code>webpush&period;notification&period;title</code> field.
             * @return {String} the value of <code>webpush&period;notification&period;title</code> field, or null if absent.
             */
            getTitle: function() {
                return this.getValue("webpush.notification", "title");
            },

            /**
             * Sets the <code>webpush&period;notification&period;title</code> field.
             *
             * @param {String} title A string to be used for the <code>webpush&period;notification&period;title</code> field value, or null to clear it.
             * @return {FirebaseMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setTitle: function(title) {
                return this.setValue("webpush.notification", "title", title);
            },

            /**
             * Gets the value of <code>webpush&period;notification&period;body</code> field.
             * @return {String} the value of <code>webpush&period;notification&period;body</code> field, or null if absent.
             */
            getBody: function() {
                return this.getValue("webpush.notification", "body");
            },

            /**
             * Sets the <code>webpush&period;notification&period;body</code> field.
             *
             * @param {String} body A string to be used for the <code>webpush&period;notification&period;body</code> field value, or null to clear it.
             * @return {FirebaseMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setBody: function(body) {
                return this.setValue("webpush.notification", "body", body);
            },

            /**
             * Gets the value of <code>webpush&period;notification&period;icon</code> field.
             * @return {String} the value of <code>webpush&period;notification&period;icon</code> field, or null if absent.
             */
            getIcon: function() {
                return this.getValue("webpush.notification", "icon");
            },

            /**
             * Sets the <code>webpush&period;notification&period;icon</code> field.
             *
             * @param {String} icon A string to be used for the <code>webpush&period;notification&period;icon</code> field value, or null to clear it.
             * @return {FirebaseMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setIcon: function(icon) {
                return this.setValue("webpush.notification", "icon", icon);
            },

            /**
             * Gets sub-fields of the <code>webpush&period;data</code> field.
             * @return {Object} a map with sub-fields of the <code>webpush&period;data</code> field, or null if absent.
             */
            getData: function() {
                return this.getValue("webpush", "data");
            },

            /**
             * Sets sub-fields of the <code>webpush&period;data</code> field.
             *
             * @param {Object} data A map to be used for sub-fields of the <code>webpush&period;data</code> field, or null to clear it.
             * @return {FirebaseMpnBuilder} this MpnBuilder object, for fluent use.
             */
            setData: function(data) {
                if (data != null) {
                    this.putAll("webpush.data", data);
                } else {
                    delete this.getMap("webpush")["data"];
                }
                return this;
            }
    };

    FirebaseMpnBuilder.prototype['build'] = FirebaseMpnBuilder.prototype.build;
    FirebaseMpnBuilder.prototype['getHeaders'] = FirebaseMpnBuilder.prototype.getHeaders;
    FirebaseMpnBuilder.prototype['setHeaders'] = FirebaseMpnBuilder.prototype.setHeaders;
    FirebaseMpnBuilder.prototype['getTitle'] = FirebaseMpnBuilder.prototype.getTitle;
    FirebaseMpnBuilder.prototype['setTitle'] = FirebaseMpnBuilder.prototype.setTitle;
    FirebaseMpnBuilder.prototype['getBody'] = FirebaseMpnBuilder.prototype.getBody;
    FirebaseMpnBuilder.prototype['setBody'] = FirebaseMpnBuilder.prototype.setBody;
    FirebaseMpnBuilder.prototype['getIcon'] = FirebaseMpnBuilder.prototype.getIcon;
    FirebaseMpnBuilder.prototype['setIcon'] = FirebaseMpnBuilder.prototype.setIcon;
    FirebaseMpnBuilder.prototype['getData'] = FirebaseMpnBuilder.prototype.getData;
    FirebaseMpnBuilder.prototype['setData'] = FirebaseMpnBuilder.prototype.setData;

    Inheritance(FirebaseMpnBuilder, NotificationBuilder);
    return FirebaseMpnBuilder;
})();

//WARN: do not rename this variable as it is used by the build script!
  var messageStrings = [];
  
  //WARN: do not touch the following comment as it is replaced with the messageString initialization during build!
  messageStrings = ["New value for setting received from internal settings","New value for setting received from API","Broadcasting setting to shared LightstreamerClient instances","Setting changed, firing notification","Wong length!","Missing from first array","Missing from second array","Wrong  element","Not expecting a NULL","Expecting a different value","Expecting 2 different values","Expecting a valid value","Expecting a not valid value","ASSERT failed","Unexpected","Unexpectedly missing session id","Bind request generated","Create request generated","Recovery request generated","Destroy request generated","Force rebind request generated","New engine created","Engine","Subscribing subscription","Unsubscribing subscription","Enqueueing subscription update","Resuming subscription update","Executing subscription update","sending Subscription to the engine","Overriding old promise for table ","Delaying subscription completion","Resuming subscription completion","Ignored old promise triggered for table ","Ignored old promise failed for table ","Restoring all pending Subscriptions","Pausing active Subscription","Pausing all active Subscriptions","Delaying subscription action","Resuming subscription action","Executing subscription action","Delaying subscription action","Resuming subscription action","Subscription action had to be delayed on multiple instances","An error occurred while executing an event on a listener","Dispatching event on listeners","Changing reference session","Command phase check","Adding notification","Unexpected progressive","Skipping replicated progressive","Unexpected progressive","Received event prog higher than expected","Received event prog different than expected","Received event prog different than actual","Unexpected message outcome sequence","Unexpected command received, ignoring","There is probably another web application connected to the same Lightstreamer Server within this browser instance. That could prevent the current application from connecting to the Server. Please close the other application to unblock the current one","New client attached to engine","Dismissing client","Can't find subscription anymore","Can't find page anymore","Client or session unexpectedly disappeared while handling subscription","Notify back to the client that the subscription was handled","It has been detected that the JavaScript engine of this browser is not respecting the timeouts in setTimeout method calls. The Client has been disconnected from the Server in order to avoid reconnection loops. To try again, just refresh the page.","New WS connection oid=","Closing WebSocket connection","Error closing WebSocket connection","Unexpected openSocket call","Error opening WebSocket connection","Timeout event [currentConnectTimeoutWS]","error on closing a timed out WS","Unexpected WebSocket _load call","Preparing to bind on WebSocket connection","Open path is disappeared","WebSocket transport sending oid=","Error sending data over WebSocket","Unexpected send outcome while websocket is ready-to-send","WebSocket transport receiving oid=","Error on WebSocket connection oid=","WebSocket connection ready","WebSocket connection close event received","New sessionId","New session","Copying prog ","Resetting session oid=","Session state change","Mad timeouts? Avoid connection","Opening on server, send destroy","Opening new session","Unexpected phase during binding of session","Binding session","Binding session","Switch requested","Unexpected creation of a session while another one is still creating","Slow requested","Unexpected phase during slow handling","Closing session","Session shutdown","Make pause before next bind","Timeout event","Start session recovery. Cause: no response timeLeft=","Start new session. Cause: no response","Timeout: switch transport","Timeout: recover session","Timeout: new session","Unexpected timeout event while session is _OFF","Error event","Start session recovery. Cause: socket failure while receiving","Start new session. Cause: socket failure while receiving","Start session recovery. Cause: socket failure while recovering","Switching transport","Start new session. Cause: ","Unexpected loop event while session is an non-active status","Unexpected push event while session is an non-active status","Unexpected phase after create request sent","Unexpected phase after bind request sent","Status timeout in ","Unexpected phase during OK execution","Unexpected empty start time","Synch event received","Available bandwidth event received","Error41 event received","Keepalive event received","OK event received","Initializing session","Unexpected session id received on bind OK","Sync event received","Loop event received","Ignore error","End event received","Sending request to the server to force a rebind on the current connection","force_rebind request caused the error: ","Sending request to the server to destroy the current session","destroy request caused the error: ","constrain request ","New CORS-XHR connection oid=","CORS-XHR connection closed oid=","Error non closing connection opened using CORS-XHR","CORS-XHR transport sending oid=","Error opening CORS-XHR connection oid=","CORS-XHR transport receiving oid=","CORS-XHR connection error oid=","CORS-XHR request completed oid=","Error reading CORS-XHR status oid=","Closing connection opened using IEXSXHR","Error non closing connection opened using IEXSXHR","IEXSXHR transport sending","Error opening connection using IEXSXHR","Error on connection opened using IEXSXHR","IEXSXHR transport receiving","Connection opened using IEXSXHR completed","Closing connection opened using html form; actually doing nothing","Html form transport sending","Error while sending request using html form","Closing connection opened using replace on forever-frame","Replace on forever-frame transport sending","Replace on forever-frame not available","Error while sending request using  replace on forever-frame","Loading XHR frame to perform non-cross-origin requests","Client is offline, will retry later to load XHR frame","XHR frame loaded","XHR frame loading timeout expired, try to reload","XHR frame loading timeout expired again, will not try again","Passing request to the XHR frame","Error passing request to the XHR frame","XHR transport sending","Closing connection opened using XHR","Error closing connection opened using XHR","Error reading XHR status","XHR transport receiving","Error on connection opened using XHR","Error on disposing XHR's callback","Error on disposing XHR","Streaming enabled on XHR","XHR transport receiving","XHR transport receiving","Verify connection class","This class is not available on the current environment","Cross-origin request is needed, this class is not able to make cross-origin requests","Cookies on request are required, this class can't guarantee that cookies will be actually sent","Cross-protocol request is needed, this class is not able to make cross-protocol requests","Extra headers are given, this class is not able to send requests containing extra headers","This class can't be used in the current context","Connection class is good","Searching for an appropriate connection class","Restart connection selector","Client is offline, delaying connection to server","Unable to use available connections to connect to server","Unable to use available connections to connect to server","Connection request generated","Connection currently unavailable, delaying connection","Connection open to the server","Unexpected ws phase while opening connection","Open WebSocket to server","A control link was received while earlyWSOpenEnabled is set to true, a WebSocket was wasted.","Unexpected ws phase during binding","WebSockets currently unavailable, delaying connection","Unexpected WebSocket failure","Connection to server bound upon WebSocket","Connection to server open upon WebSocket","Unexpected phase for an clean end of a WS","Unexpected connection error on a connection that was not yet open","WebSocket was broken before it was used","WebSocket was broken while we were waiting the first bind","can't be unable-to-open since the connection is already open","WebSocket was broken while we were waiting","Sync message received while session wasn't in receiving status","First sync message, check not performed","Huge delay detected by sync signals. Restored from standby/hibernation?","No delay detected by sync signals","Delay detected by sync signals","No delay detected by sync signals","Duplicated message","Unexpected request type was given to this batch","Unexpected request type was given to this batch; expecting ADD REMOVE DESTROY CONSTRAIN or MPN","Storing request","Substituting CONSTRAINT/FORCE_REBIND/MPN request","Replacing 'second' ADD request with a REMOVE request for the same subscription","REMOVE request already stored, skipping","ADD request for the involved subscription was not yet sent; there is no need to send the related REMOVE request or the original ADD one, removing both","ADD after REMOVE?","Same session id on different servers, store two different DESTROY requests","Verified duplicated DESTROY request, skipping","Duplicated ADD or CHANGE_SUB request, substitute the old one with the new one","Storing confirmed","Trying to remove by index non-existent request","Trying to remove by key non-existent request","Batch length limit changed","Start sending reverse heartbeat to the server","Start sending reverse heartbeat to the server","Keep sending reverse heartbeat to the server","Preparing reverse heartbeat","Stop sending reverse heartbeat to the server","Stop sending reverse heartbeat to the server","Keep sending reverse heartbeat to the server","Close current connection if any and applicable","ControlConnectionHandler state change '","Reset Controls handler status","Batch handler unexpectedly idle; a batch was waiting","Batch handler unexpectedly not idle; nothing ready to be sent was found","Batch object not null","Enabling control requests over WebSocket now","Disabling control requests over WebSocket now","New request to be sent","Still waiting previous batch","Ready to dequeue","Waiting for dequeue","starting dequeuing","Send previous batch","Send new batch","Some requests don't need to be sent anymore, keep on dequeing","Delaying requests; waiting for a connection","Can't find a connection to send batch","Request sent through HTTP connection","Request sent through WebSocket, keep on dequeuing","Request queue is now empty","Duplicated message","Empty batch, exit","Ready to send batch, choosing connection","WebSocket should be available, try to send through it","Empty request was generated, exit","Unable to find a connection for control requests, will try again later","Connection for control batch chosen","Empty request for HTTP was generated, exit","Connection failed, will try a different connection","Connection temporarily unavailable, will try later","Unexpected sending outcome","Control request got answer","Control request got answer","Error from network","A single request size exceeds the <request_limit> configuration setting for the Server. Trying to send it anyway although it will be refused","Closing message handler","Activating message handler","Preparing message request","Forward prepared message to control handler","No ack was received for a message; forwarding it again to the control handler","Ack received for message","Ack received, stopping automatic retransmissions","Ack received, no outcome expected, clean structures","Not waiting for ack, purging","Message handled, clean structures","Message on the net notification","OK outcome received","DISCARDED outcome received","DENIED outcome received","ERROR outcome received","Enqueuing received data","Dequeuing received data","Data can't be handled","Unexpected error occurred while executing server-sent commands!","Malformed message: ","Unexpected update","New session handler oid=","SessionManager state change:","Session recovery","Session recovery: cancelled","Can't initiate session, giving up, disabling automatic reconnections","Unable to establish session of the current type. Switching session type","Unexpected fallback type; switching because the current session type cannot be established","Slow session detected. Switching session type","Unexpected fallback type; switching because of a slow connection was detected","Setting up new session type","Unexpected fallback type switching with new session","Switching current session type","Unexpected fallback type switching with a force rebind","Slow session switching","Failed to switch session type. Starting new session","Unexpected fallback type switching because of a failed force rebind","Session started","Session closed","Discarding update for dismissed page","Received new update","Discarding lost updates notification for dismissed page","Received lost updates event","Discarding end of snapshot notification for dismissed page","Received end of snapshot event","Discarding snapshot clearing notification for dismissed page","Received snapshot clearing event","Received server error event","Received subscription error event","Discarding subscription error notification for dismissed page","Received unsubscription event","Discarding unsubscription notification for dismissed page","Received reconfiguration OK event","Table of reconfiguration not found","Discarding subscription notification for dismissed page","Received subscription event","Received message ack","Received message-ok notification","Received message-deny notification","Received message-discarded notification","Received message-error notification","New control link received","unsubscription request ","configuration request [","Fatal error: ","Dismissing current session and stopping automatic reconnections.","Transport change requested","Opening a new session and starting automatic reconnections.","RUNNING EXECUTOR AT ","Shared worker is broken","RESUMED TO ","DELAYED TO ","SharedWorker receiving error","SharedWorker sending error","Unexpected sharing error","Unexpected dispatching error","Unexpected error on dispatching","SharedStatus remote sharing is ready","SharedStatus local sharing is ready","Started refresh thread","Address already removed?","Removing wrong address?","Engine is probably dying, skip one cookie refresh","Checking status","No engines","Checking shared status to verify if there are similar engines alive","Engine found, no values though","Engine found, not compatible though","Write engine shared status","Found engine","There is a concurrent engine. Close engine ","Stopped refresh thread","Remote engine","Trying to attach to a cross-page engine","Exception while trying to attach to a cross-page engine","You have Norton Internet Security or Norton\nPersonal Firewall installed on this computer.\nIf no real-time data show up, then you need\nto disable Ad Blocking in Norton Internet\nSecurity and then refresh this page","Cross-page engine not found","Probably blocked popup detected: firefox-safari case","Cross-page engine attached","Verify if the found cross-page engine can be used","can't use found cross-page engine: page is now closed","can't use found cross-page engine: uneffective popup detected, chrome case","problem closing the generated popup","Probably blocked popup detected: opera common case","can't use found cross-page engine: Lightstreamer singleton not available","can't use found cross-page engine: Lightstreamer singleton content unavailable","Ready to use found cross-page engine: looks ok","can't use found cross-page engine: exception throw while accessing it","Skipping already-used cookie","Stop search for an engine","No sharing was found, a new sharing will be created","No sharing was found, will keep on searching after a pause","No sharing was found, no sharing will be created, this client will fail","A sharing was found but attaching is disabled, this client will fail","A sharing was found, this will attach to","Engine","A sharing was found, but accordingly with the configuration it will be ignored","Searching for available sharing","Local engine found","Local engine not found. Can't search on other pages because of the current sharing configuration","Search remote engine in other page","RemoteEngine =","Can't access reference ","Search remote engine in shared storage","Storage inspection complete","No valid engine found","Valid engine found: ","Engine ","Engine ","invalid values","Unexpected missing values in sharing cookie","Skipping not compatible engine","Found a likely dead engine","Valid engine values found. Wait for popup-protection timeout","No compatible sharing detected","No valid engine values found. Check again in ","Forcing preventCrossWindowShare because page is on file:///","New connection sharing","A new sharing will be immediately created","No way to obtain a sharing, this client will fail immediately","A sharing will now be searched","An exception was thrown while executing the Function passed to the forEachChangedField method","An exception was thrown while executing the Function passed to the forEachField method","Subscription reset","Subscription entered the active state","Subscription waiting to be sent to server","Subscription queued to be sent to server","Subscription is now on hold","Subscription exits the active status; it can now be modified","Subscription is now subscribed to","Subscription is not subscribed to anymore","Subscription request generated","Received position of COMMAND and KEY fields from server","Adapter Set assigned","Selector assigned","Requested Max Frequency assigned","Requested Buffer Size assigned","Snapshot Required assigned","Second level Data Adapter Set assigned","key and/or command position not correctly configured","MpnSubscription state change","MpnManager state change","Sharing is not available on UCBrowser","Connection sharing is not available","Page is closing, won't search a new engine","no sharing on mourning room?","Sharing lost, trying to obtain a new one","Connect requested","Executing connect","Disconnect requested","Executing disconnect","MpnDevice state change","Can't remove row that does not exist","Removing row","Postpone new update until the current update/remove is completed","Postpone new remove until the current update/remove is completed","Inserting new row","Updating row","Cleaning the model","New ChartLine","Clearing ChartLine","Repainting ChartLine","ChartLine re-painted","Calculated Y unit","Y labels generated","Y labels cleared","Y labels now configured","Line style configured","Y axis is now positioned","Painter configured","Chart is now ready to be used","A DOM element must be provided as an anchor for the chart","Creating a new label for the chart","Drawing line on the chart","New line coordinates","New line was drawn","Repaint All","Calculated X unit","X labels generated","X labels cleared","Got double nulls, clear line","Got a null, ignore point","Cannot create line. Please declare the Y axis","Line removed","Cleaned all","Parse html for Chart","X axis is now configured on field","Configuring multiple Y axis","Y axis is now configured on field","removing multiple Y axis","Y axis is now removed","X axis is now positioned","X labels now configured","Merging this update values with the values of the current update","Filling formatted values in cell","Scroll direction is ignored if sort is enabled","Exception thrown while executing the iterator Function","Cannot find the scroll element","Perform auto-scroll","Can't find value for sort key field","Calculate number of pages","Unexpected position of row to be wiped","New value for setting received from internal settings","New value for setting received from API","Broadcasting setting to shared LightstreamerClient instances","Setting changed, firing notification","Wong length!","Missing from first array","Missing from second array","Wrong  element","Not expecting a NULL","Expecting a different value","Expecting 2 different values","Expecting a valid value","Expecting a not valid value","ASSERT failed","Unexpected","Unexpectedly missing session id","Bind request generated","Create request generated","Recovery request generated","Destroy request generated","Force rebind request generated","New engine created","Engine","Subscribing subscription","Unsubscribing subscription","Enqueueing subscription update","Resuming subscription update","Executing subscription update","sending Subscription to the engine","Overriding old promise for table ","Delaying subscription completion","Resuming subscription completion","Ignored old promise triggered for table ","Ignored old promise failed for table ","Restoring all pending Subscriptions","Pausing active Subscription","Pausing all active Subscriptions","Delaying subscription action","Resuming subscription action","Executing subscription action","Delaying subscription action","Resuming subscription action","Subscription action had to be delayed on multiple instances","An error occurred while executing an event on a listener","Dispatching event on listeners","Changing reference session","Command phase check","Adding notification","Unexpected progressive","Skipping replicated progressive","Unexpected progressive","Received event prog higher than expected","Received event prog different than expected","Received event prog different than actual","Unexpected message outcome sequence","Unexpected command received, ignoring","There is probably another web application connected to the same Lightstreamer Server within this browser instance. That could prevent the current application from connecting to the Server. Please close the other application to unblock the current one","New client attached to engine","Dismissing client","Can't find subscription anymore","Can't find page anymore","Client or session unexpectedly disappeared while handling subscription","Notify back to the client that the subscription was handled","It has been detected that the JavaScript engine of this browser is not respecting the timeouts in setTimeout method calls. The Client has been disconnected from the Server in order to avoid reconnection loops. To try again, just refresh the page.","New WS connection oid=","Closing WebSocket connection","Error closing WebSocket connection","Unexpected openSocket call","Error opening WebSocket connection","Timeout event [currentConnectTimeoutWS]","error on closing a timed out WS","Unexpected WebSocket _load call","Preparing to bind on WebSocket connection","Open path is disappeared","WebSocket transport sending oid=","Error sending data over WebSocket","Unexpected send outcome while websocket is ready-to-send","WebSocket transport receiving oid=","Error on WebSocket connection oid=","WebSocket connection ready","WebSocket connection close event received","New sessionId","New session","Copying prog ","Resetting session oid=","Session state change","Mad timeouts? Avoid connection","Opening on server, send destroy","Opening new session","Unexpected phase during binding of session","Binding session","Binding session","Switch requested","Unexpected creation of a session while another one is still creating","Slow requested","Unexpected phase during slow handling","Closing session","Session shutdown","Make pause before next bind","Timeout event","Start session recovery. Cause: no response timeLeft=","Start new session. Cause: no response","Timeout: switch transport","Timeout: recover session","Timeout: new session","Unexpected timeout event while session is _OFF","Error event","Start session recovery. Cause: socket failure while receiving","Start new session. Cause: socket failure while receiving","Start session recovery. Cause: socket failure while recovering","Switching transport","Start new session. Cause: ","Unexpected loop event while session is an non-active status","Unexpected push event while session is an non-active status","Unexpected phase after create request sent","Unexpected phase after bind request sent","Status timeout in ","Unexpected phase during OK execution","Unexpected empty start time","Synch event received","Available bandwidth event received","Error41 event received","Keepalive event received","OK event received","Initializing session","Unexpected session id received on bind OK","Sync event received","Loop event received","Ignore error","End event received","Sending request to the server to force a rebind on the current connection","force_rebind request caused the error: ","Sending request to the server to destroy the current session","destroy request caused the error: ","constrain request ","New CORS-XHR connection oid=","CORS-XHR connection closed oid=","Error non closing connection opened using CORS-XHR","CORS-XHR transport sending oid=","Error opening CORS-XHR connection oid=","CORS-XHR transport receiving oid=","CORS-XHR connection error oid=","CORS-XHR request completed oid=","Error reading CORS-XHR status oid=","Closing connection opened using IEXSXHR","Error non closing connection opened using IEXSXHR","IEXSXHR transport sending","Error opening connection using IEXSXHR","Error on connection opened using IEXSXHR","IEXSXHR transport receiving","Connection opened using IEXSXHR completed","Closing connection opened using html form; actually doing nothing","Html form transport sending","Error while sending request using html form","Closing connection opened using replace on forever-frame","Replace on forever-frame transport sending","Replace on forever-frame not available","Error while sending request using  replace on forever-frame","Loading XHR frame to perform non-cross-origin requests","Client is offline, will retry later to load XHR frame","XHR frame loaded","XHR frame loading timeout expired, try to reload","XHR frame loading timeout expired again, will not try again","Passing request to the XHR frame","Error passing request to the XHR frame","XHR transport sending","Closing connection opened using XHR","Error closing connection opened using XHR","Error reading XHR status","XHR transport receiving","Error on connection opened using XHR","Error on disposing XHR's callback","Error on disposing XHR","Streaming enabled on XHR","XHR transport receiving","XHR transport receiving","Verify connection class","This class is not available on the current environment","Cross-origin request is needed, this class is not able to make cross-origin requests","Cookies on request are required, this class can't guarantee that cookies will be actually sent","Cross-protocol request is needed, this class is not able to make cross-protocol requests","Extra headers are given, this class is not able to send requests containing extra headers","This class can't be used in the current context","Connection class is good","Searching for an appropriate connection class","Restart connection selector","Client is offline, delaying connection to server","Unable to use available connections to connect to server","Unable to use available connections to connect to server","Connection request generated","Connection currently unavailable, delaying connection","Connection open to the server","Unexpected ws phase while opening connection","Open WebSocket to server","A control link was received while earlyWSOpenEnabled is set to true, a WebSocket was wasted.","Unexpected ws phase during binding","WebSockets currently unavailable, delaying connection","Unexpected WebSocket failure","Connection to server bound upon WebSocket","Connection to server open upon WebSocket","Unexpected phase for an clean end of a WS","Unexpected connection error on a connection that was not yet open","WebSocket was broken before it was used","WebSocket was broken while we were waiting the first bind","can't be unable-to-open since the connection is already open","WebSocket was broken while we were waiting","Sync message received while session wasn't in receiving status","First sync message, check not performed","Huge delay detected by sync signals. Restored from standby/hibernation?","No delay detected by sync signals","Delay detected by sync signals","No delay detected by sync signals","Duplicated message","Unexpected request type was given to this batch","Unexpected request type was given to this batch; expecting ADD REMOVE DESTROY CONSTRAIN or MPN","Storing request","Substituting CONSTRAINT/FORCE_REBIND/MPN request","Replacing 'second' ADD request with a REMOVE request for the same subscription","REMOVE request already stored, skipping","ADD request for the involved subscription was not yet sent; there is no need to send the related REMOVE request or the original ADD one, removing both","ADD after REMOVE?","Same session id on different servers, store two different DESTROY requests","Verified duplicated DESTROY request, skipping","Duplicated ADD or CHANGE_SUB request, substitute the old one with the new one","Storing confirmed","Trying to remove by index non-existent request","Trying to remove by key non-existent request","Batch length limit changed","Start sending reverse heartbeat to the server","Start sending reverse heartbeat to the server","Keep sending reverse heartbeat to the server","Preparing reverse heartbeat","Stop sending reverse heartbeat to the server","Stop sending reverse heartbeat to the server","Keep sending reverse heartbeat to the server","Close current connection if any and applicable","ControlConnectionHandler state change '","Reset Controls handler status","Batch handler unexpectedly idle; a batch was waiting","Batch handler unexpectedly not idle; nothing ready to be sent was found","Batch object not null","Enabling control requests over WebSocket now","Disabling control requests over WebSocket now","New request to be sent","Still waiting previous batch","Ready to dequeue","Waiting for dequeue","starting dequeuing","Send previous batch","Send new batch","Some requests don't need to be sent anymore, keep on dequeing","Delaying requests; waiting for a connection","Can't find a connection to send batch","Request sent through HTTP connection","Request sent through WebSocket, keep on dequeuing","Request queue is now empty","Duplicated message","Empty batch, exit","Ready to send batch, choosing connection","WebSocket should be available, try to send through it","Empty request was generated, exit","Unable to find a connection for control requests, will try again later","Connection for control batch chosen","Empty request for HTTP was generated, exit","Connection failed, will try a different connection","Connection temporarily unavailable, will try later","Unexpected sending outcome","Control request got answer","Control request got answer","Error from network","A single request size exceeds the <request_limit> configuration setting for the Server. Trying to send it anyway although it will be refused","Closing message handler","Activating message handler","Preparing message request","Forward prepared message to control handler","No ack was received for a message; forwarding it again to the control handler","Ack received for message","Ack received, stopping automatic retransmissions","Ack received, no outcome expected, clean structures","Not waiting for ack, purging","Message handled, clean structures","Message on the net notification","OK outcome received","DISCARDED outcome received","DENIED outcome received","ERROR outcome received","Enqueuing received data","Dequeuing received data","Data can't be handled","Unexpected error occurred while executing server-sent commands!","Malformed message: ","Unexpected update","New session handler oid=","SessionManager state change:","Session recovery","Session recovery: cancelled","Can't initiate session, giving up, disabling automatic reconnections","Unable to establish session of the current type. Switching session type","Unexpected fallback type; switching because the current session type cannot be established","Slow session detected. Switching session type","Unexpected fallback type; switching because of a slow connection was detected","Setting up new session type","Unexpected fallback type switching with new session","Switching current session type","Unexpected fallback type switching with a force rebind","Slow session switching","Failed to switch session type. Starting new session","Unexpected fallback type switching because of a failed force rebind","Session started","Session closed","Discarding update for dismissed page","Received new update","Discarding lost updates notification for dismissed page","Received lost updates event","Discarding end of snapshot notification for dismissed page","Received end of snapshot event","Discarding snapshot clearing notification for dismissed page","Received snapshot clearing event","Received server error event","Received subscription error event","Discarding subscription error notification for dismissed page","Received unsubscription event","Discarding unsubscription notification for dismissed page","Received reconfiguration OK event","Table of reconfiguration not found","Discarding subscription notification for dismissed page","Received subscription event","Received message ack","Received message-ok notification","Received message-deny notification","Received message-discarded notification","Received message-error notification","New control link received","unsubscription request ","configuration request [","Fatal error: ","Dismissing current session and stopping automatic reconnections.","Transport change requested","Opening a new session and starting automatic reconnections.","RUNNING EXECUTOR AT ","Shared worker is broken","RESUMED TO ","DELAYED TO ","SharedWorker receiving error","SharedWorker sending error","Unexpected sharing error","Unexpected dispatching error","Unexpected error on dispatching","SharedStatus remote sharing is ready","SharedStatus local sharing is ready","Started refresh thread","Address already removed?","Removing wrong address?","Engine is probably dying, skip one cookie refresh","Checking status","No engines","Checking shared status to verify if there are similar engines alive","Engine found, no values though","Engine found, not compatible though","Write engine shared status","Found engine","There is a concurrent engine. Close engine ","Stopped refresh thread","Remote engine","Trying to attach to a cross-page engine","Exception while trying to attach to a cross-page engine","You have Norton Internet Security or Norton\nPersonal Firewall installed on this computer.\nIf no real-time data show up, then you need\nto disable Ad Blocking in Norton Internet\nSecurity and then refresh this page","Cross-page engine not found","Probably blocked popup detected: firefox-safari case","Cross-page engine attached","Verify if the found cross-page engine can be used","can't use found cross-page engine: page is now closed","can't use found cross-page engine: uneffective popup detected, chrome case","problem closing the generated popup","Probably blocked popup detected: opera common case","can't use found cross-page engine: Lightstreamer singleton not available","can't use found cross-page engine: Lightstreamer singleton content unavailable","Ready to use found cross-page engine: looks ok","can't use found cross-page engine: exception throw while accessing it","Skipping already-used cookie","Stop search for an engine","No sharing was found, a new sharing will be created","No sharing was found, will keep on searching after a pause","No sharing was found, no sharing will be created, this client will fail","A sharing was found but attaching is disabled, this client will fail","A sharing was found, this will attach to","Engine","A sharing was found, but accordingly with the configuration it will be ignored","Searching for available sharing","Local engine found","Local engine not found. Can't search on other pages because of the current sharing configuration","Search remote engine in other page","RemoteEngine =","Can't access reference ","Search remote engine in shared storage","Storage inspection complete","No valid engine found","Valid engine found: ","Engine ","Engine ","invalid values","Unexpected missing values in sharing cookie","Skipping not compatible engine","Found a likely dead engine","Valid engine values found. Wait for popup-protection timeout","No compatible sharing detected","No valid engine values found. Check again in ","Forcing preventCrossWindowShare because page is on file:///","New connection sharing","A new sharing will be immediately created","No way to obtain a sharing, this client will fail immediately","A sharing will now be searched","An exception was thrown while executing the Function passed to the forEachChangedField method","An exception was thrown while executing the Function passed to the forEachField method","Subscription reset","Subscription entered the active state","Subscription waiting to be sent to server","Subscription queued to be sent to server","Subscription is now on hold","Subscription exits the active status; it can now be modified","Subscription is now subscribed to","Subscription is not subscribed to anymore","Subscription request generated","Received position of COMMAND and KEY fields from server","Adapter Set assigned","Selector assigned","Requested Max Frequency assigned","Requested Buffer Size assigned","Snapshot Required assigned","Second level Data Adapter Set assigned","key and/or command position not correctly configured","MpnSubscription state change","MpnManager state change","Sharing is not available on UCBrowser","Connection sharing is not available","Page is closing, won't search a new engine","no sharing on mourning room?","Sharing lost, trying to obtain a new one","Connect requested","Executing connect","Disconnect requested","Executing disconnect","MpnDevice state change","Can't remove row that does not exist","Removing row","Postpone new update until the current update/remove is completed","Postpone new remove until the current update/remove is completed","Inserting new row","Updating row","Cleaning the model","New ChartLine","Clearing ChartLine","Repainting ChartLine","ChartLine re-painted","Calculated Y unit","Y labels generated","Y labels cleared","Y labels now configured","Line style configured","Y axis is now positioned","Painter configured","Chart is now ready to be used","A DOM element must be provided as an anchor for the chart","Creating a new label for the chart","Drawing line on the chart","New line coordinates","New line was drawn","Repaint All","Calculated X unit","X labels generated","X labels cleared","Got double nulls, clear line","Got a null, ignore point","Cannot create line. Please declare the Y axis","Line removed","Cleaned all","Parse html for Chart","X axis is now configured on field","Configuring multiple Y axis","Y axis is now configured on field","removing multiple Y axis","Y axis is now removed","X axis is now positioned","X labels now configured","Merging this update values with the values of the current update","Filling formatted values in cell","Scroll direction is ignored if sort is enabled","Exception thrown while executing the iterator Function","Cannot find the scroll element","Perform auto-scroll","Can't find value for sort key field","Calculate number of pages","Unexpected position of row to be wiped"];
  
  
  
  LoggerManager.resolve = function(id){
    return id + "] " + messageStrings[id];
  };
  
  /**
   * This is a fake constructor that should not be used.
   * @constructor
   * 
   * @exports LogMessages
   *
   * @class Used internally by the library to produce "real" log messages
   * in the log generated by the internal classes. If this class is not included in the 
   * generated library, only codes will be printed.
   * <BR>Note that if the library is used in the AMD version then it may be necessary,
   * depending on the AMD implementation in use, to require this class to make the 
   * "real" log messages appear in the log. 
   * <BR>It is suggested not to import this class unless a client log is needed 
   * for debugging purposes.
   * <BR>It is possible to include this class in a JavaScript application to 
   * programmatically obtain a log message associated to a given log code
   * exploiting the {@link LogMessages.getMessage} method.
   */
  var LogMessages = function() {
  };
  
  /**
   * Given a log code as generated by a library running without the LogMessages module,
   * this method can be used to extract the associated log message.
   *  
   * @param {Number} id The id of the essage to be extracted.
   */
  LogMessages.getMessage = function(id) {
    return LoggerManager.resolve(id);
  };
  
  LoggerManager["resolve"] = LoggerManager.resolve;
  LogMessages["getMessage"] = LogMessages.getMessage;

var LightstreamerConstants = /*@__PURE__*/(function() {  
  /**
   * @private
   */
  var LightstreamerConstants = {

    // connecting to the server
    CONNECTING: "CONNECTING",
    // connected prefix
    CONNECTED: "CONNECTED:",
    // create_session response received, trying to setup a streaming connection
    SENSE: "STREAM-SENSING",
    // receiving pushed data
    WS_STREAMING: "WS-STREAMING",
    HTTP_STREAMING: "HTTP-STREAMING",
    // connected but doesn't receive data
    STALLED: "STALLED",
    // polling for data
    WS_POLLING: "WS-POLLING",
    HTTP_POLLING: "HTTP-POLLING",
    // disconnected
    DISCONNECTED: "DISCONNECTED",
    WILL_RETRY: "DISCONNECTED:WILL-RETRY",
    TRYING_RECOVERY: "DISCONNECTED:TRYING-RECOVERY",

    WS_ALL: "WS",
    HTTP_ALL: "HTTP",
    
    RAW: "RAW",
    DISTINCT: "DISTINCT",
    COMMAND: "COMMAND",
    MERGE: "MERGE"
    
  };
    
  return LightstreamerConstants;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var DoubleKeyMatrix = /*@__PURE__*/(function() {
  //trick for Inheritance+closure not needed 'cause we're only calling public super-methods
  /*var names = {
    insert : "insert",
    del : "del",
    delRow: "delRow"
  };
  var reverse = {};
  for (var i in names) {
    reverse[names[i]] = i;
  }*/

  /**
   * Creates an empty DoubleKeyMatrix
   * @constructor
   *
   * @exports DoubleKeyMatrix
   * @class A very specific Matrix that keeps a map tracking on which row a determined column is: in order to 
   * do this it is mandatory that no two rows have an element in the same column: checks are not performed to
   * keep this constraint true.
   * 
   * @todo Implementation lacks most methods: I only implemented what I needed. Most likely no one will ever use
   * this class anyway.
   * 
   * @extends Matrix
   */
  var DoubleKeyMatrix = function() {
    this._callSuperConstructor(DoubleKeyMatrix);
   
    /**
     * @private
     */
    this.reverseIndex = {};
  };
  
  DoubleKeyMatrix.prototype = {
      /**
       * Inserts an element in the matrix. If another element is already present in the
       * specified position it is overwritten. The reverse-mapping is kept up to date but no
       * checks on possible duplicated column values are performed
       * @todo do the check?
       * 
       * @param insObject {Object} the element to be added.
       * @param row {String|Number} the row in the matrix where the element is placed.
       * @param column {String|Number} the column in the row where the element is placed.
       */
      insert: function(insObject,row,column) {
        if (typeof this.reverseIndex[column] != "undefined") {
          //already in map, we must not repeat the entry
          return;
        }
        
        this.reverseIndex[column] = row;
        this._callSuperMethod(DoubleKeyMatrix,"insert",[insObject,row,column]);
        
      },
      
      /*extractRow: function(row) {
        var rowObj = this._callSuperMethod(DoubleKeyMatrix,'extractRow',[row]);
        for (var column in rowObj) {
          delete(this.reverseIndex[column]);
        }
        return rowObj;
      },*/
      
      /**
       * Removes the element at the specified position in the matrix and updates the column index.
       * @param row {String|Number} the row in the matrix where the element is located.
       * @param column {String|Number} the column in the row where the element is located.
       */
      del: function(row, column) {
        this._callSuperMethod(DoubleKeyMatrix,"del",[row,column]);
        delete(this.reverseIndex[column]);
      },
      
      /**
       * Removes the element at the specified position in the matrix and updates the column index:
       * as column must be unique in the entire matrix it is enough to specify it to identify an unique
       * element within the matrix.
       * @param column {String|Number} the column where the element is located.
       */
      delReverse: function(column) {
        var row = this.reverseIndex[column];
        if (typeof row == "undefined") {
          return;
        }
        this.del(row,column);
      },
      
      /**
       * Removes the row at the specified position in the matrix and updates the column index.
       * @param row {String|Number} the row position.
       */
      delRow: function(row) {
        var rowObj = this.getRow(row);
        for (var column in rowObj) {
          delete(this.reverseIndex[column]);
        }
        this._callSuperMethod(DoubleKeyMatrix,"delRow",[row]);
      }
      
      
  };
  
  DoubleKeyMatrix.prototype["insert"] = DoubleKeyMatrix.prototype.insert;
  DoubleKeyMatrix.prototype["del"] = DoubleKeyMatrix.prototype.del;
  DoubleKeyMatrix.prototype["delReverse"] = DoubleKeyMatrix.prototype.delReverse;
  DoubleKeyMatrix.prototype["delRow"] = DoubleKeyMatrix.prototype.delRow;
 
  
  Inheritance(DoubleKeyMatrix,Matrix);
  
  return DoubleKeyMatrix;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var AbstractWidget = /*@__PURE__*/(function() {
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.grids");
  
  var ITEM_IS_KEY = "ITEM_IS_KEY";
  var UPDATE_IS_KEY = "UPDATE_IS_KEY";
  var KEY_IS_KEY = "KEY_IS_KEY";
  
  var PARSE_FIRST = "Please parse html before calling this method";
  
  var REMOVE = 1;
  var UPDATE = 2;
  
  var MAX_FIFO_HOLES = 100;
  
  /**
   * This is an abstract class; no instances of this class should be created.
   * @constructor
   * 
   * @exports AbstractWidget
   * @class The base class for the hierarchy of the provided widgets. It is an
   * abstract class representing a view on a set of tabular data, which is supposed
   * to be some sort of HTML visualization widget. Each row in the tabular model is associated with a key.
   * <BR>The class offers some management methods to modify/poll the model behind 
   * the view but also implements the {@link SubscriptionListener} interface to be
   * automatically fed by listening on a {@link Subscription}. 
   * <BR>When listening for Subscription events the widget will choose what to use
   * as key for its model based on the Subscription mode of the first Subscription
   * it was added to as a listener:
   * <ul>
   * <li>If the Subscription mode is MERGE or RAW, the widget will use the item as key:
   * each subscribed item will generate a row in the model. The key name will be
   * the item name when available, otherwise the 1-based item position within the
   * Subscription.</li>
   * <li>If the Subscription mode is COMMAND, the widget will use the value of the 
   * "key" field as key: each row in the COMMAND subscription will generate a row 
   * in the model. More precisely, the key value will be expressed as "&lt;item&gt; &lt;key&gt;"
   * where &lt;item&gt; is the item name when available, otherwise the 1-based item position
   * within the Subscription.
   * <BR>Note that this behavior is naturally extended to two-level subscriptions.</li>
   * <li>If the Subscription mode is DISTINCT, the widget will use a progressive 
   * number as key: each update will generate a row in the model.</li>
   * </ul>
   * For each update received, all the included fields will be integrated into
   * the row related to the update key. The field name will be the one specified on
   * the related Subscription, when available; otherwise, it will be the 1-based field
   * position within the related Subscription.
   * <BR>Note that if the Subscription contains the same item name or field name multiple
   * times, their updates will not be distinguished in the model and the last value
   * processed by the library for that name will be assigned to the model.
   * You should ensure that item name or field name collisions cannot occur if the
   * colliding names are used to represent different entities; for instance, this holds for
   * collisions between first-level and second-level fields in a two-level Subscription.
   * Collisions are also possible if the widget is added as a listener to
   * other Subscription instances. In this case, also note that the new updates will be
   * processed and integrated in the model in the way already determined for the first
   * Subscription associated; so, you should ensure that the various Subscriptions yield
   * compatible updates.
   * <BR>For each {@link SubscriptionListener#onClearSnapshot} event received from any
   * of the Subscription the widget is listening to, all the rows internally associated 
   * to the cleared item are removed. In case of collisions between different items feeding 
   * the same row the row will be considered pertaining to the first item that fed it.
   * <BR>
   * <BR>Note that methods from the SubscriptionListener should not be called by 
   * custom code.
   * <BR>Note that before any change to the internal model can be made, and
   * thus before an instance of this class can be used as listener for a 
   * Subscription, the {@link AbstractWidget#parseHtml} method has to be called to prepare the view.
   * <BR>The class is not meant as a base class for the creation of custom widgets.
   * The class constructor and its prototype should never be used directly.
   * 
   * @extends SubscriptionListener
   * 
   * @see Chart
   * @see AbstractGrid
   */
  var AbstractWidget = function() {
    
    this._callSuperConstructor(AbstractWidget);
    
    this.kind = ITEM_IS_KEY;
    this.keyField = null;
    this.commandField = null;
    
    this.updateCount = 0;
    this.fieldPosBased = null;
    
    this.values = new Matrix();
    
    this.parsed = false;
    
    this.id = arguments[0];
    
    this.useSynchEvents(true);
    
    this.cleanOnFirstSubscribe = false;
    this.cleanOnLastUnsubscribe = false;
    this.activeSubscriptions = 0;
    this.masterSubscription = null;
    this.forcedInterpretation = false;
    
    this.updateInProgress = null;
    this.suspendedUpdates = [];
    
    this.fifoKeys = [];
    this.fifoMap = {};
    this.fifoHoles = 0;
    this.fifoHead = 0;
    
    this.itemKeyMap = new DoubleKeyMatrix();
    
  };
  
  /**
   * @protected
   * @ignore
   */
  AbstractWidget.ITEM_IS_KEY = ITEM_IS_KEY;
  /**
   * @protected
   * @ignore
   */
  AbstractWidget.UPDATE_IS_KEY = UPDATE_IS_KEY;
  
  AbstractWidget.prototype = {
      /**
       * @ignore
       */
      getId: function() {
        return this.id;
      },
      /**
       * @protected
       * @ignore
       */
      checkParsed: function() {
        if (!this.parsed) {
          throw new IllegalStateException(PARSE_FIRST);
        }
      },
      /**
       * From SubscriptionListener
       * @inheritdoc
       */
      onItemUpdate: function(updateInfo) {
        var itemName = updateInfo.getItemName();
        var itemPos = updateInfo.getItemPos();
        
        this.updateCount++;

        var updateKey;
        var itemId = itemName == null ? itemPos : itemName;
        if (this.itemIsKey()) {
          updateKey = itemId;
        } else if (this.updateIsKey()) {
          updateKey = this.updateCount;
        } else { //this.keyIsKey() 
          updateKey = itemId+" "+updateInfo.getValue(this.keyField);
        }
        
        var updated = {}; //server values
        if (this.updateIsKey()) {
          updateInfo.forEachField(this.getForeachHandler(updated));
        } else {
          updateInfo.forEachChangedField(this.getForeachHandler(updated));
        }
        
        if (this.keyIsKey() && updated[this.commandField] == "DELETE") {
          this.removeRow(updateKey);
          //remove from itemKeyMap in any case (inside removeRow)
        } else {
          this.updateRow(updateKey,updated); //add and update collapsed
          this.itemKeyMap.insert(true,itemId,updateKey); //add to the itemKeyMap only in the onItemUpdate case 
          //in case a key is associated to two different items the first one to reach the map rules
        }
      },
      
      /**
       * From SubscriptionListener
       * @inheritdoc
       */
      onClearSnapshot: function(itemName, itemPos) {
        //get the associated row and remove them
        var itemId = itemName == null ? itemPos : itemName;

        var associatedRows = this.itemKeyMap.getRow(itemId);
        this.itemKeyMap.delRow(itemId);
        for (var key in associatedRows) {
          this.removeRow(key);
        } 
      },
      
      /*
      UNUSED SubscriptionListener methods
      
      onItemLostUpdates: function(itemName, itemPos, lostUpdates) {
        
      },
      
      onCommandSecondLevelItemLostUpdates: function(howMany, key) {
        
      },
      
      onEndOfSnapshot: function(itemName, itemPos) {
       
      },
      
      onSubscriptionError: function(code, message) {
        return;
      },
      
      onCommandSecondLevelSubscriptionError: function(code, message, key) {
        
      },
      
      */
      
      /**
       * From SubscriptionListener
       * @inheritdoc
       */
      onSubscription: function() {
        if (this.activeSubscriptions == 0 && this.cleanOnFirstSubscribe) {
          this.clean();
        }
        
        if (this.keyIsKey() && !this.keyField) {
          //masterSubscription may be not yet subscribed and I don't have info about this subscription... 
          //should I keep all the subscriptions in an array and then loop on them to find one that had already been subscribed?
          this.keyField = this.masterSubscription.getKeyPosition();
          this.commandField = this.masterSubscription.getCommandPosition();
        }
        
        this.activeSubscriptions++;        
      },
      
      /**
       * From SubscriptionListener
       * @inheritdoc
       */
      onUnsubscription: function() {
        this.activeSubscriptions--;
        
        if (this.activeSubscriptions == 0 && this.cleanOnLastUnsubscribe) {
          this.clean();
        }
      },
      
      /**
       * From SubscriptionListener
       * @inheritdoc
       */
      onListenStart: function(sub) {
        if (!this.masterSubscription) {
          this.masterSubscription = sub;
          
          if (!this.forcedInterpretation) {
            this.chooseInterpretation();
          }
      
        }
        
        if (sub.isSubscribed()) {
          this.onSubscription();
        }
      },
      
      /**
       * From SubscriptionListener
       * @inheritdoc
       */
      onListenEnd: function(sub) {
        if (sub.isSubscribed()) {
          this.onUnsubscription();
        }
      },
      
      /**
       * @protected
       * @ignore
       */
      chooseInterpretation: function() {
        if (!this.masterSubscription) {
          this.kind = ITEM_IS_KEY;
          return;
        }
        
        var sub = this.masterSubscription;
        
        if (sub.getMode() == LightstreamerConstants.MERGE || sub.getMode() == LightstreamerConstants.RAW) {
          this.kind = ITEM_IS_KEY;
          
        } else if (sub.getMode() == LightstreamerConstants.DISTINCT) {
          this.kind = UPDATE_IS_KEY;
          
        } else { //LightstreamerConstants.COMMAND
          this.kind = KEY_IS_KEY;
          
          try {
            sub.getFields();
            //field names
            this.keyField = "key";
            this.commandField  = "command";
            
          } catch (e) {
            //field position
          }
        }
      },
      
      /**
       * @private
       */
      getForeachHandler: function(updated) {
        var that = this;
        
        return function(name,pos,_new) {
          if (that.fieldPosBased === null) {
            that.fieldPosBased = name == null;
          }
          
          var index = that.fieldPosBased ? pos : name;
          updated[index] = _new;
          
        };
        
      },
      
      /**
       * @protected
       * @ignore
       */
      itemIsKey: function() {
        return this.kind == ITEM_IS_KEY;
      },
      
      /**
       * @protected
       * @ignore
       */
      updateIsKey: function() {
        return this.kind == UPDATE_IS_KEY;
      },
      
      /**
       * @protected
       * @ignore
       */
      keyIsKey: function() {
        return this.kind == KEY_IS_KEY;
      },

      /**
       * @protected
       * @ignore
       */
      getOldestKey: function() {
        if (this.fifoHead >= this.fifoKeys.length) {
          return null;
        }
        return this.fifoKeys[this.fifoHead];
      },
      
      /**
       * @protected
       * @ignore
       */
      removeFromFifo: function(key) {
        var pos = this.fifoMap[key];
        delete(this.fifoMap[key]);
        
        this.fifoKeys[pos] = null;
        this.fifoHoles++;
        
        if (pos == this.fifoHead) {
          while (this.fifoKeys[this.fifoHead] === null && this.fifoHead < this.fifoKeys.length) {
            this.fifoHead++;
          }
          
          if (this.fifoHead >= this.fifoKeys.length) {
            this.fifoKeys = [];
            this.fifoMap = {};
            this.fifoHoles = 0;
            this.fifoHead = 0;
            return;
          }
          
        } 
        
        
        if (this.fifoHoles >= MAX_FIFO_HOLES) {
          this.fifoMap = {};
          var oldArray = this.fifoKeys;
          this.fifoKeys = [];
          this.fifoHead = 0;
          this.fifoHoles = 0;
          
          for (var i=0; i<oldArray.length; i++) {
            if (oldArray[i] !== null) {
              this.newKey(oldArray[i]);
            }
          }
        }
      },
      
      /**
       * @private
       */
      newKey: function(key) {
        this.fifoMap[key] = this.fifoKeys.length;
        this.fifoKeys.push(key);
      },
      
      /**
       * Removes a row from the internal model and reflects the change on the view.
       * If no row associated with the given key is found nothing is done.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> once the {@link AbstractWidget#parseHtml} method has been called,
       * this method can be used at any time.</p>
       * 
       * @throws {IllegalStateException} if parseHtml has not been executed yet.
       * 
       * @param {String} key The key associated with the row to be removed.
       */
      removeRow: function(key) {
        this.checkParsed();
        
        if (this.updateInProgress) {
          this.deleteLater(key);
          return;
        }
        
        if (!this.values.getRow(key)) {
          gridsLogger.logWarn(LoggerManager.resolve(936),key,this);
          return;
        }
        
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(937),key,this);
        }
        
        this.updateInProgress = {}; //cannot be merged with anything but still have to pass the if (this.updateInProgress) check
        
        var exeExc = null;
        try {
          this.removeRowExecution(key);
          
          this.values.delRow(key);
          this.itemKeyMap.delReverse(key);
        
          if (this.updateIsKey()) {
            this.removeFromFifo(key);
          }
        } catch(e) {
          exeExc = e;
        }
        
        this.updateInProgress = null;
        
        this.dequeuePostponedUpdates();
        
        if (exeExc !== null) {
          throw(exeExc);
        }
        
      },

      
      /**
       * @protected
       * @ignore
       */
      updateLater: function(key,newValues) {
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(938),this);
        }
        //postpone the update
        this.suspendedUpdates.push({type:UPDATE,key:key,obj:newValues});
      },
      
      /**
       * @protected
       * @ignore
       */
      deleteLater: function(key) {
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(939),this);
        }
        
        //postpone the update
        this.suspendedUpdates.push({type:REMOVE,key:key});
      },

      /**
       * @private
       */
      dequeuePostponedUpdates: function() {
        while (this.suspendedUpdates.length > 0) {
          var otherUpdate =  this.suspendedUpdates.shift();
          
          if (otherUpdate.type == REMOVE) {
            this.removeRow(otherUpdate.key);
          } else {
            this.updateRow(otherUpdate.key,otherUpdate.obj);
          }
        }
      },
      
      /**
       * Updates a row in the internal model and reflects the change on the view.
       * If no row associated with the given key is found then a new row is
       * created.
       * <BR>Example usage:
       * <BR><code>myWidget.updateRow("key1", {field1:"val1",field2:"val2"});</code>
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> once the {@link AbstractWidget#parseHtml} method has been called,
       * this method can be used at any time. If called while an updateRow on the same
       * internal model is still executing (e.g. if called while handling an onVisualUpdate
       * callback), then the new update:
       * <ul>
       * <li>if pertaining to a different key and/or if called on a {@link Chart} instance,
       * will be postponed until the first updateRow execution terminates;</li>
       * <li>if pertaining to the same key and if called on a {@link StaticGrid} / {@link DynaGrid}
       * instance, will be merged with the current one.</li>
       * </ul>
       * </p>
       * 
       * @throws {IllegalStateException} if parseHtml has not been executed yet.
       * 
       * @param {String} key The key associated with the row to be updated/added.
       * @param {Object} newValues A JavaScript object containing name/value pairs
       * to fill the row in the mode. 
       * <BR>Note that the internal model does not have a fixed number of fields; 
       * each update can add new fields to the model by simply specifying them. 
       * Also, an update having fewer fields than the current model will have its 
       * missing fields considered as unchanged.
       */
      updateRow: function(key,newValues) { 
        this.checkParsed();
        
        if (this.updateInProgress) {
          //method called from the visualUpdate callback
          if (key == this.updateInProgress) {
            this.mergeUpdate(key,newValues);
            
          } else {
            this.updateLater(key,newValues);
          }
          
          return;
        } 


        this.updateInProgress = key;
        
        var exeExc = null;
        try {
        
          this.updateRowExecution(key,newValues);
          
          if (!this.values.getRow(key)) {
            if (gridsLogger.isDebugLogEnabled()) {
              gridsLogger.logDebug(LoggerManager.resolve(940),key,this);
            }
            
            if (this.updateIsKey()) {
              this.newKey(key);
            }
            this.values.insertRow(newValues,key);
            
          } else {
            if (gridsLogger.isDebugLogEnabled()) {
              gridsLogger.logDebug(LoggerManager.resolve(941),key,this);
            }
            for (var i in newValues) {
              this.values.insert(newValues[i],key,i);
            }
          }
        } catch(e) {
          exeExc = e;
        }
        
        this.updateInProgress = null;
        
        this.dequeuePostponedUpdates();
        
        if (exeExc !== null) {
          throw exeExc;
        }
        
      },
      
      /**
       * Removes all the rows from the model and reflects the change on the view.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> once the {@link AbstractWidget#parseHtml} method has been called,
       * this method can be used at any time.</p>
       * 
       * @throws {IllegalStateException} if parseHtml has not been executed yet.
       */
      clean: function() {
        
        gridsLogger.logInfo(LoggerManager.resolve(942),this);
        
        var keys = [];
        this.values.forEachRow(function(row) {
          keys.push(row);
        });
        for (var i=0; i<keys.length; i++) {
          this.removeRow(keys[i]);
        }
      },
      
      /**
       * Returns the value from the model for the specified key/field pair.
       * If the row for the specified key does not exist or if the specified field
       * is not available in the row then null is returned.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
       * 
       * @param {String} key The key associated with the row to be read.
       * @param {String} field The field to be read from the row.
       * 
       * @return {String} The current value for the specified field of the specified row,
       * possibly null. If the value for the specified field has never been
       * assigned in the model, the method also returns null.
       */
      getValue: function(key,field) {
        return this.values.get(key,field);
      },
      
      /**
       * Utility method that can be used to control part of the behavior of
       * the widget in case it is used as a listener for one or more 
       * {@link Subscription} instances.
       * <BR>Specifying the two flags it is possible to decide to clean the model and
       * view based on the status (subscribed or not) of the Subscriptions this 
       * instance is listening to.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> This method can be called at any time.</p>
       * 
       * @param {boolean} onFirstSubscribe If true a {@link AbstractWidget#clean} call will be
       * automatically performed if in the list of Subscriptions this instance is 
       * listening to there is no Subscription in the subscribed status and an 
       * onSubscription is fired by one of such Subscriptions.
       * <BR>As a special case, if in the list of Subscriptions this instance is 
       * listening to there is no Subscription in the subscribed status and this
       * instance starts listening to a new Subscription that is already in the 
       * subscribed status, then it will be considered as if an onSubscription
       * event was fired and thus a clean() call will be performed. 
       * 
       * @param {boolean} onLastUnsubscribe If true a {@link AbstractWidget#clean} call will be
       * automatically performed if in the list of Subscriptions this instance is 
       * listening to there is only one Subscription in the subscribed status and the 
       * onUnsubscription for such Subscription is fired.
       * <BR>As a special case, if in the list of Subscriptions this instance is 
       * listening to there is only one Subscription in the subscribed status and 
       * this instance stops listening to such Subscription then it will be 
       * considered as if the onUnsubscription event for that Subscription was fired 
       * and thus a clean() call will be performed. 
       *  
       * @see Subscription#isSubscribed 
       */
      setAutoCleanBehavior: function(onFirstSubscribe, onLastUnsubscribe) {
        this.cleanOnFirstSubscribe = this.checkBool(onFirstSubscribe);
        this.cleanOnLastUnsubscribe = this.checkBool(onLastUnsubscribe);
      },
      
      /**
       * Abstract method. See subclasses descriptions for details.
       */
      parseHtml: function() {},
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      updateRowExecution: function(key,serverValues) {},
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      removeRowExecution: function(key) {},
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      mergeUpdate: function(key,newValues) {}
  };
  
  //closure compiler exports
  AbstractWidget.prototype["onItemUpdate"] = AbstractWidget.prototype.onItemUpdate;
  AbstractWidget.prototype["onClearSnapshot"] = AbstractWidget.prototype.onClearSnapshot;
  AbstractWidget.prototype["onSubscription"] = AbstractWidget.prototype.onSubscription;
  AbstractWidget.prototype["onUnsubscription"] = AbstractWidget.prototype.onUnsubscription;
  AbstractWidget.prototype["onListenStart"] = AbstractWidget.prototype.onListenStart;
  AbstractWidget.prototype["onListenEnd"] = AbstractWidget.prototype.onListenEnd;
  AbstractWidget.prototype["removeRow"] = AbstractWidget.prototype.removeRow;
  AbstractWidget.prototype["updateRow"] = AbstractWidget.prototype.updateRow;
  AbstractWidget.prototype["clean"] = AbstractWidget.prototype.clean;
  AbstractWidget.prototype["getValue"] = AbstractWidget.prototype.getValue;
  AbstractWidget.prototype["setAutoCleanBehavior"] = AbstractWidget.prototype.setAutoCleanBehavior;
  AbstractWidget.prototype["parseHtml"] = AbstractWidget.prototype.parseHtml;
  AbstractWidget.prototype["updateRowExecution"] = AbstractWidget.prototype.updateRowExecution;
  AbstractWidget.prototype["removeRowExecution"] = AbstractWidget.prototype.removeRowExecution;
  AbstractWidget.prototype["mergeUpdate"] = AbstractWidget.prototype.mergeUpdate;
  
  Inheritance(AbstractWidget,EventDispatcher,false,true);
  Inheritance(AbstractWidget,Setter,true,true);
  return AbstractWidget;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Cell = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  var FIELD = "field";
  var TABLE = "grid";
  var ROW = "row";
  var ITEM = "item";
  var UPDATE = "update";
  var VALUE = "value";
  var IDENTIFICATION_NUMBER = "replica";
  
  var TYPE = "fieldtype";
  var VALID_TYPES = {
    "extra": true,
    "first-level": true,
    "second-level": true
  };
  var FIRST_LEVEL = "first-level";
  var SECOND_LEVEL = "second-level";
  
  var HOT = 1;
  var COLD = 2;
  
  var VOID_VAL = "\u00A0"; // Constant to be inserted into cells in the DOM to empty them.
  //var VOID_HTML = "&nbsp;"; //?
 
  var SOURCE_ATTR_NAME = "source";
  var SOURCE_ATTR_VALUE = "lightstreamer";
  
  var valueType= {
      "input": true,
      "textarea": true};
  
  
  //reads an attribute from an element
  function getLSAttribute(el,name) {
    if (Cell.useOldNames === false) {
      return getNewAttribute(el,name);
    
    } else if (Cell.useOldNames === true) {
      return getOldAttribute(el,name);
      
    } else {
      var res = getNewAttribute(el,name);
      if (res) {
        Cell.useOldNames = false;
        return res;
      }
      
      res = getOldAttribute(el,name);
      if (res) {
        Cell.useOldNames = true;
      }
      return res;
      
    }
  }
  
  function getNewAttribute(el,name) {
    if (el.dataset) {
      if (el.dataset[name]) {
        return el.dataset[name];
      } else {
        return el.getAttribute("data-"+name);  
      }
    } else {
      return el.getAttribute("data-"+name);
    }
  }
  
  function getOldAttribute(el,name) {
    return el.getAttribute(name);
  }
  
  /**
   * Merges two arrays of css attributes
   */
  function mergeStyleArrays(localAttr, rowAttr) {
    if (!localAttr) {
      return rowAttr;
    }

    for (var type in rowAttr) {
      if (!localAttr[type]) {
        if (localAttr[type] === null || localAttr[type] === ""){
          continue;
        }
        localAttr[type] = rowAttr[type];
      }
    }
    return localAttr;
  }
  
  /**
   * verifies that the source="lightstreamer" property is present
   */
  function verifyTag (node) {
    var str = getLSAttribute(node,SOURCE_ATTR_NAME);
    return str && str.toLowerCase() == SOURCE_ATTR_VALUE;
  }
  
  
/*
 * Update-What functions
 * depending on the attribute to be updated
 * a different write/read method will be attached to the cell
 */
  
  
////////////////updateWhat -> style.something
  
  function getUpdateStyleFunction(updateWhat)  {
    return function(val) {
      this.el.style[updateWhat] = val === VOID_VAL ? null : val;
    };
  }
  function getRetrieveStyleFunction(retrieveWhat) {
     return function(){
      return this.el.style[retrieveWhat] || "";
     };
  }

////////////////updateWhat -> form.value
    
  function updateFormValue(val) {
    if (!val || val === VOID_VAL) {
      this.el.value="";
    } else {
      this.el.value=val;
    }
  }
  
  function retrieveFormValue() {
    return this.el.value;
  }

////////////////updateWhat -> content <- this is the "normal" case
  
  function updateContent(val,useInner) {
    if (useInner) {
      this.el.innerHTML = val;
      
    } else { 
      if (this.el.childNodes.length != 1 || this.el.firstChild.nodeType != 3) {
        // we pass by here if
        // * in the cell there is html (more than one child indicates at least one tag; one child but not
        // nodeType 3 is not a text node): clean it
        // * or the cell is completely empty (no firstChild):
        // it was created by LS_cell and its contents was empty
        if (this.el.firstChild != null) {
          this.el.innerHTML = "";
        }
        this.el.appendChild(document.createTextNode(val));
      } else {
        // if the cell was taken over by convertHtmlStructures
        // it is definitely a TextNode;
        // if the cell has already been updated once in life
        // it is certainly a TextNode
        // in any case the test means that here there is necessarily a TextNode
        this.el.firstChild.nodeValue = val;
      }
   
    } 
  }
  function retrieveContent(getInner) {
    if (getInner) {
      return this.el.innerHTML;
    } else if(this.el.firstChild) {
      return this.el.firstChild.nodeValue;
    } 
    return "";
  }
  
////////////////updateWhat -> other attribute  
  
  function getUpdateAttributeFunction(updateWhat) {
    if (updateWhat === VALUE) {
      return updateFormValue;
    }
    return function(val) {
      if (!val || val === VOID_VAL) {
        this.el.removeAttribute(updateWhat);
      } else {
        this.el.setAttribute(updateWhat, val);
      }
    };
  }
  
  
  function getRetrieveAttributeFunction(retrieveWhat) {
    if (retrieveWhat === VALUE) {
      return retrieveFormValue;
    }
  
    return function(){
      return this.el.getAttribute(retrieveWhat);
    };
  
  }  

  
  
  var nextId = 0;
  
  /**
   * @private
   */
  var Cell = function(domCell,updateWhat) {
      this.el = domCell;
      /*public*/ this.isCell = true;
      /*public*/ this.fadePhase = 0;
     
      if (!updateWhat) {
        //reads what is to update from the HTML
        updateWhat = this.getUpdateWhat();
      }
      
      //setup read and write methods for this instance
      if (updateWhat) {
        if (updateWhat.toLowerCase().indexOf("style.") == 0) {
          var styleToUpdate = updateWhat.slice(6);
          this.updateValue = getUpdateStyleFunction(styleToUpdate);
          this.retrieveValue = getRetrieveStyleFunction(styleToUpdate);
        } else {
          this.updateValue = getUpdateAttributeFunction(updateWhat);
          this.retrieveValue = getRetrieveAttributeFunction(updateWhat);
        }
        
      } else {
        var nodeName = domCell.nodeName.toLowerCase();
        if (nodeName in valueType) {
          this.updateValue = updateFormValue;
          this.retrieveValue = retrieveFormValue;
        } else {
          this.updateValue = updateContent;
          this.retrieveValue = retrieveContent;
        }
      }
    
      this.cellId = nextId++;
      this.updateCount = 0;
     
      //will hold updates before being set on cell
      this.nextFormattedValue = null;
      this.newHotArray = null;
      this.newColdArray = null;
      
      //reads from the cell the current status for future cleaning
      this.initialValue = this.retrieveValue(true);
      this.initialClass = this.extractCSSClass();
      this.initialStyles = this.extractStyles();
      
  };
  
  //expose constants
  Cell.HOT = HOT;
  Cell.COLD = COLD;
  Cell.FIRST_LEVEL = FIRST_LEVEL;
  Cell.SECOND_LEVEL = SECOND_LEVEL;
  
  //both old and new names are accepted (i.e.: with or without the data- prefix)
  //we will not admit a mix of old and new though
  Cell.useOldNames = null; //this is only exposed for test purposes 
  

  /**
   * Extract elements from the DOM
   * @static
   */
  Cell.getLSTags = function(root,nodeTypes) {
    var lsTags = [];
    
    if (!nodeTypes) {
      nodeTypes = ["*"]; //gets all the tags
    }
     
    //TODO use selectors if available
    for (var i = 0; i < nodeTypes.length; i++) {
      var tempTags = root.getElementsByTagName(nodeTypes[i]);
      for (var v = 0; v < tempTags.length; v++) {
        if (verifyTag(tempTags[v])) {
           lsTags.push(new Cell(tempTags[v]));
        }
      }
    }
    return lsTags;
  };
  
  Cell.verifyTag = verifyTag;
 
  Cell.isAttachedToDOM = function(toFindNode) {
    var prevCurrCell = null;
    var currCell = toFindNode;
    while (currCell != null && currCell != document) {
      prevCurrCell = currCell;          
      currCell = currCell.parentNode;
    }
    if (currCell == null) {
      if (prevCurrCell != null && prevCurrCell.nodeName == "HTML") {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
 
  Cell.prototype = {
      
    //methods attached during creation
    //updateValue: function(value,useInner)  {}
    //retrieveValue: function() {}
      
    scrollHere: function(otherCell,useInner) {
      this.updateValue(otherCell.retrieveValue(),useInner); //from cell to cell, using inner is safe
      
      this.nextFormattedValue = otherCell.nextFormattedValue;
      this.newHotArray = otherCell.newHotArray;
      this.newColdArray = otherCell.newColdArray;
      this.updateCount = otherCell.updateCount;
      
      this.setAttributes(otherCell.extractStyles());
      this.updateCSSClass(otherCell.extractCSSClass());
      
      this.fadePhase = otherCell.fadePhase;
      
    },
    
    getEl: function() {
      return this.el;
    },
    
    extractStyles: function() {
      var res = {};
      for (var s in this.el.style) {
        res[s] = this.el.style[s];
      }
      return res;
    },
    
    extractCSSClass: function() {
      return this.el.className;
    },
    
    updateCSSClass: function(writeClass) {
      if (writeClass !== null && this.el.className != writeClass) {
        this.el.className = writeClass;
      }
    },
    
    setAttributes: function(attrArr) {
      if (!attrArr) {
        return;
      }
      for (var attrName in attrArr) { 
        if (attrName == "CLASS") {
           this.updateCSSClass(attrArr[attrName]);
        }
        try {
          if (attrArr[attrName] !== null) {
            this.el.style[attrName] = attrArr[attrName];
          }
          
        } catch(e) {
          //old browsers (FX2 IE6) may pass from here
        }
      }
    },
    
    asynchUpdateStyles: function(ph,applyWhat) {
      if (ph != this.updateCount) {
        return;
      }
      
      if (applyWhat == HOT) {
        this.setAttributes(this.newHotArray);
        this.newHotArray = null;
        
      } else { //if (applyWhat == COLD) 
        this.setAttributes(this.newColdArray);
        this.newColdArray = null;
        
      }
      
    },
    
    asynchUpdateValue: function(ph,useInner) {
      if (ph != this.updateCount) {
        return;
      }
            
      this.updateValue(this.nextFormattedValue,useInner);
      this.nextFormattedValue = null;
      this.asynchUpdateStyles(ph,HOT);
    },
    
    setUpdating: function() {
      this.updateCount++;
      return this.updateCount;
    },
    
    getField: function() {
      var fieldName = getLSAttribute(this.el,FIELD);
      if (!fieldName) {
        return null;
      }
      return fieldName;
    },
    
    getNum: function() {
      var identificationNum = getLSAttribute(this.el,IDENTIFICATION_NUMBER);
      if (!identificationNum) {
        return null;
      }
      return identificationNum;
    },
    
    getFieldType: function() {
      var fieldType = getLSAttribute(this.el,TYPE);
      if (!fieldType) {
        return FIRST_LEVEL;
      }
      fieldType = fieldType.toLowerCase();
      return VALID_TYPES[fieldType] ? fieldType : FIRST_LEVEL;
    },
    
    getTable: function() {
      return getLSAttribute(this.el,TABLE);
    },
    
    getRow: function() {
      var r1 = getLSAttribute(this.el,ITEM);
      if (!r1) {
        r1 = getLSAttribute(this.el,ROW);
      }
      return r1;
    },
    
    getUpdateWhat: function() {
      return getLSAttribute(this.el,UPDATE);
    },
    
    incFadePhase: function() {
      return ++this.fadePhase;
    },
    
    getFadePhase: function() {
      return this.fadePhase;
    },
    
    getCellId: function() {
      return this.cellId;
    },
    
    isSameEl: function(otherCell) {
      return otherCell.el === this.el;
    },
    
    getTagName: function() {
      return this.el.tagName;
    },
    
    isAttachedToDOM: function() {
      return Cell.isAttachedToDOM(this.el);
    },
    
    isAttachedToDOMById: function() {
      if (!this.el.id) {
        return this.isAttachedToDOM(this.el);
      }
      var found = document.getElementById(this.el.id);
      return (found === this.el);
    },
    
    setNextFormattedValue: function(fValue) {
      this.nextFormattedValue = fValue === "" ? VOID_VAL : fValue;
    },
    
    getNextFormattedValue: function() {
      return this.nextFormattedValue;
    },
    
    addStyle: function(hotValue, coldValue, type) {
      if (!this.newHotArray) {
        this.newHotArray = {};
      }
      if (!this.newColdArray) {
        this.newColdArray = {};
      }
      
      this.newHotArray[type] = hotValue || "";
      this.newColdArray[type] = coldValue || "";
    },
    
    getNextHotArray: function(mergeWith) {
      if (mergeWith) {
        this.newHotArray = mergeStyleArrays(this.newHotArray,mergeWith);
      }
      
      return this.newHotArray;
    },
    
    getNextColdArray: function(mergeWith) {
      if (mergeWith) {
        this.newColdArray = mergeStyleArrays(this.newColdArray,mergeWith);
      }
      
      return this.newColdArray;
    },

    clean: function() {
      this.updateValue(this.initialValue,true);
      this.updateCSSClass(this.initialClass);
      this.setAttributes(this.initialStyles);
    }
  };
  
  
  
  
  return Cell;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var ChartLine = /*@__PURE__*/(function() {
  function getRelativeValue(value, min, unit) {
    var val = new Number(value);
    var n = (val - min) / unit;
    return Math.round(n);
  }
  
  var BLACK = "black";
  
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.charts");
  
  var nextId = 0;
  
  /**
   * Used by Lightstreamer to provide a ChartLine object to each call of the
   * {@link ChartListener#onNewLine} event.
   * This constructor is not supposed to be used by custom code.
   * @constructor
   *
   * @exports ChartLine
   * @class Object that describes a single line of a multi-line
   * chart. Instances of this class are automatically generated by a {@link Chart} 
   * instance based on the {@link Chart#setXAxis} and {@link Chart#addYAxis} 
   * configurations and can be customized during the {@link ChartListener#onNewLine}
   * event.
   */
  var ChartLine = function() {
    //ChartLine(key,owner,xField,yField)

    this.parent = arguments[1];
    this.yField = arguments[3];
    
    this.pointColor = BLACK;
    this.lineColor = BLACK;
    
    this.pointSize = 1;
    this.lineSize = 1;
    
    this.yMin = null; 
    this.yMax = null;
    this.yUnit = null;
    this.numYLabels = 0;
    this.labelsFormatter = null;
  
    this.xArray = [];
    this.yArray = [];
    this.labels = [];
    
    this.chartId = nextId++;

    
    gridsLogger.logDebug(LoggerManager.resolve(943),this);
  };
  
  ChartLine.prototype = {
      
      /**
       * @ignore
       */
      toString: function() {
        return ["[","ChartLine",this.parent,"]"].join("|");
      },
      
      /**
       * @ignore
       */
      getId: function() {
        return this.chartId;
      },
      
      /**
       * @ignore
       */
      emptyHistory: function() {
        gridsLogger.logDebug(LoggerManager.resolve(944),this);
        
         this.yArray = [];
         this.xArray = [];
      },
      
      /**
       * @ignore
       */
      isEmpty: function() {
        return this.xArray.length <= 0;
      },
      
      /**
       * @ignore
       */
      reset: function() {
        this.emptyHistory();
        this.parent.clearLine(this);
      },
      
      /**
       * @ignore
       */
      repaint: function() {
        gridsLogger.logDebug(LoggerManager.resolve(945),this);
      
        var xArr = this.xArray;
        var yArr = this.yArray;
        
        this.reset();
        
        //ASSERT.ensureValue(xArr.length,yArr.length);
      
        while (xArr.length > 0) {
          if ((xArr.length > 1 && xArr[1] >= this.parent.xMin) || xArr[0] >= this.parent.xMin) {
            this.addPoint(xArr[0],yArr[0]);
          }
          
          xArr.shift();
          yArr.shift();
          
        }
        gridsLogger.logDebug(LoggerManager.resolve(946),this);
      },
      
      /**
       * @ignore
       */
      addPoint: function(xVal,yVal) {
        this.xArray.push(xVal);
        this.yArray.push(yVal);
        this.parent.drawLine(xVal,yVal,this);
      },

      /**
       * @ignore
       */
      calcYUnit: function() {
        this.yUnit = (this.yMax - this.yMin) / this.parent.screenY;
        gridsLogger.logDebug(LoggerManager.resolve(947),this,this.yUnit);
      },
      
      /**
       * @ignore
       */
      isYAxisPositioned: function() {
        return this.yMax !== null;
      },
      
      /**
       * @ignore
       */
      isPointInRange: function(yCoordinate) {
        return yCoordinate < this.yMax && yCoordinate > this.yMin;
      },
      
      /**
       * @ignore
       */
      getMin: function() {
        return this.yMin;
      },
      
      /**
       * @ignore
       */
      getMax: function() {
        return this.yMax;
      },
    
      /**
       * @ignore
       */
      paintYLabels: function() {
        this.clearLabels();
              
        var lblVal = "";
        var pos = -1;
        if (this.numYLabels <= 0) {
          return;
        }
        if (this.numYLabels > 0) {
          lblVal = this.labelsFormatter ? this.labelsFormatter(this.yMin) : this.yMin;
          pos = this.getRelativeY(this.yMin);
          this.labels[this.labels.length] = this.parent.createLabel(this.classYLabels, lblVal, pos, "Y");
        }
        if (this.numYLabels > 1) {
          lblVal = this.labelsFormatter ? this.labelsFormatter(this.yMax) : this.yMax;
          pos = this.getRelativeY(this.yMax);
          this.labels[this.labels.length] = this.parent.createLabel(this.classYLabels, lblVal, pos, "Y");
        }
        if (this.numYLabels > 2) {
          var divider = this.numYLabels - 1;
          var step = (this.yMax - this.yMin) / divider;
          var numVal = this.yMin;
          for (var w = 1; w < divider; w++) {
            numVal += step;
            lblVal = this.labelsFormatter ? this.labelsFormatter(numVal) : numVal;
            pos = this.getRelativeY(numVal);
            this.labels[this.labels.length] = this.parent.createLabel(this.classYLabels, lblVal, pos, "Y");
          }
        }
        gridsLogger.logDebug(LoggerManager.resolve(948),this);
      },
      
      /**
       * @ignore
       */
      getRelativeY: function(value) {
        return getRelativeValue(value, this.yMin, this.yUnit);
      },
      
      /**
       * @ignore
       */
      clearLabels: function() {
        for (var l = 0; l < this.labels.length; l++) { 
          if (this.labels[l] && Cell.isAttachedToDOM(this.labels[l])) {
             this.labels[l].parentNode.removeChild(this.labels[l]);
           }
         }  
         this.labels = [];
         gridsLogger.logDebug(LoggerManager.resolve(949),this);
      },
      
      /**
       * Setter method that configures the legend for the Y axis. The legend
       * consists of a specified number of labels for the values in the Y axis.
       * The labels values are determined based on the axis limits; the labels
       * appearance is controlled by supplying a stylesheet and a formatter
       * function.
       * <BR>Note that the room for the Y axis labels on the page is not provided
       * by the library; it should be provided by specifying a chart width
       * smaller then the container element width and displaced on the right,
       * through the {@link Chart#configureArea} setting. 
       * Moreover, as the upmost and lowest labels are centered on the chart
       * area borders, a little space should be provided also over and under
       * the chart area, through the same method.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> Labels can be configured at any time.
       * If not set, no labels are displayed relative to the Y axis.
       * If set for different ChartLine instances on the same Chart
       * then more sets of labels will be printed.</p>
       * 
       * @throws {IllegalArgumentException} if labelsNum is not a valid
       * positive integer number.
       *
       * @param {Number} labelsNum the number of labels to be spread on the
       * Y axis; it should be 1 or greater.
       * @param {String} [labelsClass] the name of an existing stylesheet, to be
       * applied to the Y axis label HTML elements. The parameter is optional;
       * if missing or null, then no specific stylesheet is applied.
       * @param {LabelsFormatter} [labelsFormatter] a Function instance
       * used to format the Y axis values designated for the labels. 
       * <BR>The function will be invoked with a Number argument and should return a String.
       * If the function is not supplied, then the value will be used with no further formatting.
       */
      setYLabels: function(labelsNum, labelsClass, labelsFormatter) {
        this.numYLabels = this.checkPositiveNumber(labelsNum,true);
        this.classYLabels = labelsClass; 
        this.labelsFormatter = labelsFormatter || null;
        
        gridsLogger.logDebug(LoggerManager.resolve(950),this);
        
        if (this.yUnit != null && this.parent && this.parent.painter) {
          //l'asse Y � gi� configurato, disegno le labels
          this.paintYLabels(); //screenY e yMax (yUnit) - chartArea.parentNode
        }
    
        
      },
      
      /**
       * Setter method that sets the style to be applied to the points
       * drawn on the chart area. Colors of the points,
       * and lines can be customized using valid CSS colors while size is specified
       * in pixels. 
       * 
       * @throws {IllegalArgumentException} if pointSize or lineSize are not
       * valid positive integer numbers.
       *
       * @param {String} [pointColor=black]the color use to draw the points on the chart.
       * A point is drawn per each new value in the model. Any valid CSS color can
       * be used. By default "black" is used.
       * @param {String} [lineColor=black] the color use to draw the lines on the chart.
       * A line is to connect two consecutive points for the same line. 
       * Any valid CSS color can be used. By default "black" is used.
       * @param {Number} [pointSize=1] the size in pixel of the drawn points.
       * By default 1 is used.
       * @param {Number} [lineSize=1] the size in pixel of the drawn lines.
       * By default 1 is used.
       */
      setStyle: function(pointColor,lineColor,pointSize,lineSize) {
        this.pointColor = pointColor;
        this.lineColor = lineColor;
        
        this.pointSize = this.checkPositiveNumber(pointSize);
        this.lineSize = this.checkPositiveNumber(lineSize);
        
        gridsLogger.logDebug(LoggerManager.resolve(951),this);
      },
      
      /**
       * Operation method that sets or changes the limits for the visible part
       * of the Y axis of the chart (that is, the minimum and maximum Y-coordinates
       * shown in the chart for this line).
       * When these limits are changed a full repaint of the line is performed.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The Y axis limits can be set at any time.</p>
       * 
       * @throws {IllegalArgumentException} if the min parameter is greater 
       * than the max one.
       *
       * @param {Number} min lower limit for the visible part of the Y axis.
       * @param {Number} max higher limit for the visible part of the Y axis.
       */
      positionYAxis: function(min, max) {
        this.yMax = Number(max);
        this.yMin = Number(min);

        
        if (isNaN(this.yMax) || isNaN(this.yMin)) {
          throw new IllegalArgumentException("Min and max must be numbers");
        } if (this.yMin > this.yMax) {
          throw new IllegalArgumentException("The maximum value must be greater than the minimum value");
        }
        
        if (this.parent && this.parent.screenY != null && this.parent.painter) {
          this.calcYUnit();
          this.paintYLabels(); //sreenY - yMax - chartArea.parentNode
          if (!this.isEmpty()) {
            this.repaint();
          } 
        }
    
        gridsLogger.logDebug(LoggerManager.resolve(952),this);
      },
      
      /**  
       * Inquiry method that retrieves the field in the Chart internal model
       * representing the Y axis to which this ChartLine pertains.
       * 
       * @return {Number} the field representing the Y axis.
       * 
       * @see Chart#addYAxis
       */
      getYField: function() {
        return this.yField;
      }
    
  };

  ChartLine.prototype["setYLabels"] = ChartLine.prototype.setYLabels;
  ChartLine.prototype["setStyle"] = ChartLine.prototype.setStyle;
  ChartLine.prototype["positionYAxis"] = ChartLine.prototype.positionYAxis;
  ChartLine.prototype["getYField"] = ChartLine.prototype.getYField;

  Inheritance(ChartLine,Setter,"O");
  return ChartLine;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var ChartPainter = /*@__PURE__*/(function() {
  /**
   * @private 
   */
  var ChartPainter = function(forcedDivPainting) {
    
    var useCanvas = false;
    if (!forcedDivPainting) { //forcedDivPainting is for testing purposes only
      try {
        var canvasEl = document.createElement("canvas");
        if (canvasEl.getContext){
          useCanvas = true;
        }
      } catch(e) {
      }
    }
    
    this.useCanvas = useCanvas;
    this.chartArea;
    this.lines = {};
  };
  
  
  ChartPainter.prototype = {
      setContainer: function(domElement) {
        this.chartArea = document.createElement("div");
        this.chartArea.style.position = "absolute";
        this.chartArea.style.overflow = "hidden";
        
        domElement.appendChild(this.chartArea);     
      },
      
      clean: function() {
        if (this.chartArea && Cell.isAttachedToDOM(this.chartArea)) {
          this.chartArea.parentNode.removeChild(this.chartArea);
        }
      },
      
      setSize: function(width, height) {
        this.chartArea.style.width = width + "px";
        this.chartArea.style.height = height + "px";
        this.areaHeight = height;
        this.areaWidth = width;
      },
      
      setOffset: function(offsetX,offsetY) {
        this.chartArea.style.top = offsetY + "px";
        this.chartArea.style.left = offsetX + "px";
      },
      
      setAreaStyle: function(areaStyle) {
        this.chartArea.className = areaStyle;
      },
      
      /////////////////
      
      addLine: function(chartLine) {
        var id = chartLine.getId();
        this.lines[id] = this.useCanvas ? new CanvasLine(chartLine,this) : new DivLine(chartLine,this);
      },
      
      removeLine: function(chartLine) { 
        var id = chartLine.getId();
        if (this.lines[id]) {
          this.lines[id].remove();
          delete(this.lines[id]);  
        }
      },
      
      clearLine: function(chartLine) {
        var id = chartLine.getId();
        if (this.lines[id]) {
          this.lines[id].clear();
        }
      },
      
      paintLine: function(chartLine,xval,yval) {
        var id = chartLine.getId();
        if (!this.lines[id]) {
          this.addLine(chartLine);
        }

        this.lines[id].drawTo(xval,yval);
      }
      
  };
  
  
  var CanvasLine = function(chartLine,painter) {
    this.chartLine = chartLine;
    this.lastX = null;
    this.lastY = null;
    this.painter = painter;
    this.canvasObj = null;
    this.canvasEl = null;
  };
  CanvasLine.prototype = {
      
      initCanvas: function() {

        if (!this.canvasEl) {
          var canvasEl = document.createElement("canvas");
          canvasEl.style.position = "absolute";
          canvasEl.style.overflow = "hidden";
          
          var canvasObj = canvasEl.getContext("2d");
          this.painter.chartArea.appendChild(canvasEl);  
          
          this.canvasEl = canvasEl;
          this.canvasObj = canvasObj;
        }
        
        this.canvasEl.width = this.painter.areaWidth;
        this.canvasEl.height = this.painter.areaHeight;
        
      },
      
      drawTo: function(xval,yval) {
        yval = this.painter.areaHeight - yval;
        if (this.lastX === null) {
          this.initCanvas();
          this.drawPoint(xval,yval);
          return;
        }
        this.canvasObj.beginPath();
        this.canvasObj.strokeStyle = this.chartLine.lineColor;
        this.canvasObj.lineWidth = this.chartLine.lineSize;
        this.canvasObj.moveTo(this.lastX,this.lastY);
        this.canvasObj.lineTo(xval,yval);
        this.canvasObj.stroke();
        
        
        this.drawPoint(xval,yval);
      },
      drawPoint: function(xval,yval) {
        this.lastX = xval;
        this.lastY = yval;
        
        var offset = Math.round(this.chartLine.pointSize/2);
        
        this.canvasObj.fillStyle = this.chartLine.pointColor;
        this.canvasObj.fillRect(xval-offset, yval-offset, this.chartLine.pointSize, this.chartLine.pointSize);
      },
      clear: function() {
        this.lastX = null;
        this.lastY = null;
        this.canvasObj.clearRect(0,0,this.canvasEl.width,this.canvasEl.height);
      },
      remove:function() {
        this.lastX = null;
        this.lastY = null;
        this.painter.chartArea.removeChild(this.canvasEl);
        this.canvasEl = null;
      }
  };
  
  
  var DivLine = function(chartLine,painter) {
    this.chartLine = chartLine;
    this.lastX = null;
    this.lastY = null;
    this.painter = painter;
    
    this.pointArray = [];
  };
  DivLine.prototype = {
      drawTo: function(xval,yval) {
        if (this.lastX === null) {
          this.drawPoint(xval,yval);
          return;
        } 
        
        //DRAW LINE
        var dx=xval-this.lastX;
        var dy=yval-this.lastY;

        var dxabs=Math.abs(dx);
        var dyabs=Math.abs(dy);
          
        var pix = null;
        var end = 0;
        var move = 0;
        var slope = 0;
        if (dxabs>=dyabs) {
          slope=dy/dx;
          end = dx;
          move = dx >= 0 ? 1 : -1;
        } else {
          slope=dx/dy;
          end = dy;
          move = dy >= 0 ? 1 : -1;
        }
          
        var pixDimX = 0;
        var pixDimY = 0;
        var pixRoundDimX = null;
        var pixRoundDimY = null;
        var getDim = true;
          
        var moreHorizontal = true;
        if (dxabs<dyabs) {
          moreHorizontal = false;
        } 
          
        for (var i = 0; i != end; i += move) {
          var px = 0;
          var py = 0;
          var pw = 0;
          var ph = 0;
          var isPointDiv = false;
          if ((i + move) == end) {
            isPointDiv = true;
            getDim = true;
          }
            
          pix=document.createElement("div");
          if (isPointDiv) {
            pix.style.backgroundColor = this.chartLine.pointColor;
            pix.style.width = this.chartLine.pointSize +"px";
            pix.style.height = this.chartLine.pointSize +"px";
          } else {
            pix.style.backgroundColor = this.chartLine.lineColor;
            pix.style.width = this.chartLine.lineSize +"px";
            pix.style.height = this.chartLine.lineSize +"px";
          }
          pix.style.position = "absolute";
          pix.style.fontSize = "0px";

          this.painter.chartArea.appendChild(pix);
          this.pointArray.push(pix);
          
          if (getDim) {
            getDim = false;
            pixRoundDimX = Math.ceil(pix.offsetWidth/2);
            pixRoundDimY = Math.ceil(pix.offsetHeight/2);
            pixDimX = pix.offsetWidth;
            pixDimY = pix.offsetHeight;
          }
          pw = pixDimX;
          ph = pixDimY;
          
          if (moreHorizontal) {
            //calculate the position of the new div
            px=Math.round(i+this.lastX);
            py=Math.round(this.painter.areaHeight -(slope*i+this.lastY));
            if (!isPointDiv) {
              //if not the latest one it could be bigger
              var morePoints = 0;
              //check if I can enlarge a point instead of creating a new one
              while (((i+move)!=(end-move))&&(py == Math.round(this.painter.areaHeight -(slope*(i+move)+this.lastY)))) {
                i += move;
                morePoints++;
              }
              
              var toAddDim = pixRoundDimX * morePoints;
              //increase div size
              pw = pixDimX + toAddDim;
              if (move < 0) {
                // if is going left but it grows to the right I have to move the position
                px -= toAddDim;
              }
            }
                
          } else {
            px=Math.round(slope*i+this.lastX);
            py=Math.round(this.painter.areaHeight -(i+this.lastY));
            if (!isPointDiv) {
              var morePoints = 0;
              while (((i+move)!=(end-move))&&(px == Math.round(slope*(i+move)+this.lastX))) {
                i += move;
                morePoints++;
              }
              var toAddDim = pixRoundDimY * morePoints;
              ph = pixDimY + toAddDim;
              if (move > 0) {
                py -= toAddDim;
              }
            }
          }
            
            
          px -= Math.floor(pixRoundDimX / 2);
          py -= Math.floor(pixRoundDimY / 2);
          
          pix.style.left=px + "px";
          pix.style.top=py + "px";
          pix.style.width=pw + "px";
          pix.style.height=ph + "px";
          
        }
        
        
        this.drawPoint(xval,yval);
        
        
      },
      
      drawPoint: function(xval,yval) {
        //in the div case we skip painting the initial point, 
        //other points are drawn by the main method
        //DRAW POINT
        
        this.lastX = xval;
        this.lastY = yval;
      },
      
      clear: function() {
        if (this.pointArray[0] && Cell.isAttachedToDOM(this.pointArray[0])) {
          for (var p = 0; p < this.pointArray.length; p++) {
            this.pointArray[p].parentNode.removeChild(this.pointArray[p]);
          }
        }
        
        this.pointArray = [];
        this.lastX = null;
        this.lastY = null;
      },
      
      remove:function() {
        this.clear();
      }
      
  };
  
  
  return ChartPainter;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var Chart = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  var NO_ANCHOR = "A DOM element must be provided as an anchor for the chart";
  
  function getRelativeValue(value, min, unit) {
    var val = new Number(value);
    var n = (val - min) / unit;
    return Math.round(n);
  }
  
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.charts");
  
  
  /*
   
   ______________________________
   | _anchor                    |
   |  ____________________      |
   |  | caContainer       |     |
   |  | ______________    |     |
   |  | | chartarea  |    |     |
   |  | |____________|    |     |
   |  | _____________     |     |
   |  | | label1    |     |     |
   |  | |___________|     |     |
   |  | _____________     |     |
   |  | | label2    |     |     |
   |  | |___________|     |     |
   |  | _____________     |     |
   |  | | labelN    |     |     |
   |  | |___________|     |     |
   |  |                   |     |
   |  |___________________|     |
   |____________________________|
   
   
   caContainer -> pos relative - overflow visible
   chartArea   -> pos absolute - overflow hidden
   
   
   */
  
  
  /**
   * Creates an object that extends {@link AbstractWidget} displaying its values
   * as a multiline chart.
   * <BR>Note that the {@link AbstractWidget#parseHtml} method is automatically called by this
   * constructor, hence the container element should have already been prepared on the page DOM. 
   * However, preparing the element later and then invoking {@link AbstractWidget#parseHtml}
   * manually is also supported.
   * @constructor
   *
   * @param {String} id The HTML "id" attribute of a DOM Element to which the chart will be attached.
   * 
   * @exports Chart
   * @class A widget displaying the data from its model as a multiline chart.
   * As with all the classes extending {@link AbstractWidget} the internal model
   * can be automatically updated by listening to one or more {@link Subscription}
   * instances. 
   * <BR>In short, once both X and Y axis have been associated to a field through 
   * {@link Chart#setXAxis} and {@link Chart#addYAxis},
   * each row in the model will be represented as a line in the chart,
   * connecting all the X,Y points corresponding to the subsequent values assumed
   * by the related fields and dynamically extending with new values. Actually,
   * it is possible to associate more fields to the Y axis so that it is possible to
   * have more than one line per row. 
   * <BR>According to the axis settings, every time a row enters the model,
   * one or more lines will be added to the chart and corresponding instances of
   * {@link ChartLine} will be generated 
   * and passed to the {@link ChartListener#onNewLine} event to be better
   * configured.
   * <BR>The behavior of the underlying model is described in {@link AbstractWidget},
   * but there is one exception: if this instance is used to listen to events from 
   * {@link Subscription} instance(s), and the first Subscription it listens to is
   * a DISTINCT Subscription, then the base behavior is overridden and the same
   * behavior defined for MERGE and RAW modes is adopted.
   * <BR>
   * <BR>Note that, in order to create a chart, the X axis should be associated
   * with a field whose values are increasing. Anyway for both X and Y axis
   * the used value must be a numeric value. If the original field values are not 
   * compliant with such restriction, they can be customized before being used by 
   * means of a parser Function.
   * <BR>Also, even if the Chart instance is listening to {@link Subscription} events,
   * it is not mandatory to use server-sent fields to plot the chart.
   * <BR>The multiline chart for the visualization of model values is
   * dynamically maintained by an instance of this class inside a container HTML 
   * element.
   * The container element must be prepared on the page in the form of any HTML 
   * element owning the "data-source='Lightstreamer'" special attribute, together 
   * with an HTML "id" attribute that has to be specified in the constructor of this class.
   * 
   * @extends AbstractWidget
   */
  var Chart = function(id) { 
    this._callSuperConstructor(Chart,arguments);
    
    this.caContainer = document.createElement("div");
    this.caContainer.style.position = "relative";
    this.caContainer.style.overflow = "visible";
    
    
    this.areaClass = "";
    this.offsetY = 0; //distance from top
    this.offsetX = 0; //distance from left
    this.screenX = null; //area width in pixel
    this.screenY = null; //area height in pixel
    this.labels = [];
    
    this.labelsFormatter = null;
    
    this.numXLabels = 0; 
    this.xFieldCode = null;
    
    this.xMin = null; //the 0 value
    this.xMax = null; //the maximum value
    this.xUnit = null; //value of a pixel
    this.xParser = null; 
    
    //by field
    this.chartArray = {};
    this.yParsers = {};
    
    this.forcedDivPainting = false;
    this.painter = null;

    this.parseHtml();
 
  };
  
  Chart.prototype = {
      /**
       * @ignore
       */
      toString: function() {
        return ["[","Chart",this.id,"]"].join("|");
      },
      
      /**
       * @ignore
       */
      forceDivPainting: function(forced) {
        //only for test purposes, disable the use of canvas methods
        this.forcedDivPainting = forced === true;
      },
      
      /**
       * @private
       */
      initPainter: function() {
        this.painter = new ChartPainter(this.forcedDivPainting);
        this.painter.setContainer(this.caContainer);
        
        this.configurePainter();
      },
      
      /**
       * @private
       */
      configurePainter: function() {
        if (this.painter) {
          this.painter.setSize(this.screenX,this.screenY);
          this.painter.setOffset(this.offsetX,this.offsetY);
          this.painter.setAreaStyle(this.areaClass);
          
          gridsLogger.logDebug(LoggerManager.resolve(953));
        }
      },

      /**
       * @private
       */
      setChartAnchor: function(anchor,cleaning) {
        if (this.painter) {
          return;
        }
                
        if (anchor && anchor.appendChild) {
          
          anchor.appendChild(this.caContainer);
          
          if (this.screenX == null) {
            this.screenX = anchor.offsetWidth;
          }
          if (this.screenY == null) {
            this.screenY = anchor.offsetHeight;
          }
          
          this.initPainter();
          
          if (this.xMax != null) {
            this.calcXUnit(); 
            this.paintXLabels(); //screenX - xMax - chartArea.parentNode
          }
          
          for (var yField in this.chartArray) {
            for (var line in this.chartArray[yField]) {
              var cLine = this.chartArray[yField][line];
              if (cLine && cLine.isYAxisPositioned()) {
                cLine.calcYUnit(); 
                cLine.paintYLabels(); //screenY - yMax - chartArea.parentNode
              }
            }
          }         
          
          gridsLogger.logInfo(LoggerManager.resolve(954),this,anchor);
        } else if (!cleaning) {
          //should never pass from here
          gridsLogger.logError(LoggerManager.resolve(955),this);
        }
      },
      
      /**
       * @private
       */
      createLabel: function(lblClass, text, pos, axis) {
        gridsLogger.logDebug(LoggerManager.resolve(956),this);
        
        var lbl=document.createElement("div");
        if (lblClass != null) {
            lbl.className = lblClass;
        }
        lbl.style.position = "absolute";
        var txt = document.createTextNode(text);
        lbl.appendChild(txt);
       
        this.caContainer.appendChild(lbl);
         
         var labelWidth = lbl.offsetWidth;
         if (axis.toUpperCase() == "X") {
           lbl.style.top = (this.screenY + 5 + this.offsetY) + "px";
           lbl.style.left = (pos - (lbl.offsetWidth / 2) + this.offsetX) + "px";
        } else if (axis.toUpperCase() == "Y") {
           lbl.style.left = (this.offsetX - labelWidth) + "px";
           lbl.style.top = ((this.screenY - pos) - (lbl.offsetHeight / 2) + this.offsetY) + "px";
        }
          
        return lbl;
      },
      
      /**
       * @ignore
       */
      clearLine: function(currLine) {
        this.painter.clearLine(currLine);
      },
      
      /**
       * @ignore
       */
      drawLine: function(xvalo, yvalo, currLine) {

        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(957),this);
        }
        
        //from values to pixels
        var xval=this.getRelativeX(xvalo);
        var yval=currLine.getRelativeY(yvalo);
        
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(958),xval,yval);
        }
        
        this.painter.paintLine(currLine,xval,yval);
      
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(959));
        }
          
      },
      
      /**
       * @ignore
       */
      repaintAll: function(xvalo, yvalo, currLine) {
        gridsLogger.logDebug(LoggerManager.resolve(960));
        for (var yField in this.chartArray) {
          for (var line in this.chartArray[yField]) {
            var cLine = this.chartArray[yField][line];
            if (cLine && !cLine.isEmpty()) {
               cLine.repaint();
            }
          }
        }
      },

      /**
       * @private
       */
      calcXUnit: function() {
        this.xUnit = (this.xMax - this.xMin) / this.screenX;
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(961),this,this.xUnit);
        }
      },

      /**
       * @private
       */
      paintXLabels: function() {
        this.clearLabels();
          
        var lblVal = "";
        var pos = -1;
        if (this.numXLabels <= 0) {
          return;
        }
        if (this.numXLabels > 0) {
          lblVal = this.labelsFormatter ? this.labelsFormatter(this.xMin) : this.xMin;
          pos = this.getRelativeX(this.xMin);
          this.labels[this.labels.length] = this.createLabel(this.classXLabels, lblVal, pos, "X");
        }
        if (this.numXLabels > 1) {
          lblVal = this.labelsFormatter ? this.labelsFormatter(this.xMax) : this.xMax;
          pos = this.getRelativeX(this.xMax);
          this.labels[this.labels.length] = this.createLabel(this.classXLabels, lblVal, pos, "X");
        }
        if (this.numXLabels > 2) {
          var divider = this.numXLabels - 1;
          var step = (this.xMax - this.xMin) / divider;
          var numVal = this.xMin;
          for (var w = 1; w < divider; w++) {
            numVal += step;
            lblVal = this.labelsFormatter ? this.labelsFormatter(numVal) : numVal;
            pos = this.getRelativeX(numVal);
            this.labels[this.labels.length] = this.createLabel(this.classXLabels, lblVal, pos, "X");
          }
        }
        gridsLogger.logDebug(LoggerManager.resolve(962),this);
      },
      
      /**
       * @private
       */
      getRelativeX: function(value) {
        return getRelativeValue(value, this.xMin,this.xUnit);
      },
      /**
       * @private
       */
      clearLabels: function() {
        for (var l = 0; l < this.labels.length; l++) { 
          if (this.labels[l] && Cell.isAttachedToDOM(this.labels[l])) {
             this.labels[l].parentNode.removeChild(this.labels[l]);
           }
         }  
         this.labels = [];
         
         gridsLogger.logDebug(LoggerManager.resolve(963),this);
      },

      /**
       * @inheritdoc
       */
      onListenStart: function(sub) {
        this._callSuperMethod(Chart,"onListenStart",[sub]);
        
        if (this.updateIsKey()) {
          //do not permit update is key on charts
          this.kind = AbstractWidget.ITEM_IS_KEY;
        }
        
      },

      /**
       * @private
       */
      parseValue: function(key,update,field,parser) {
        var val = update[field] === null || typeof(update[field]) == "undefined" ? this.values.get(key,field) : update[field];

        val = parser ? parser(val,key) : val;
        return val === null ? null : Helpers.getNumber(val);
      },

      /**
       * @ignore
       */
      mergeUpdate: function(key,newValues) {
        this.updateLater(key,newValues);
      },
      
      /**
       * @ignore
       */
      updateRowExecution: function(key,serverValues) {
        
        /*
         NOTE: null is like 0 but != 0
         isNaN(null) -> false
         null > 1 -> false
         null < 1 -> true
         null > -1 -> true
         null == 0 -> false
         
         Also:
         xMax > 0 -> always
         */
        
        //fix X
        var newPosX = this.parseValue(key,serverValues,this.xFieldCode,this.xParser);
        if (newPosX === null) {
          //no old, no new, exit
          return;
        }
        
        if (isNaN(newPosX) || (newPosX !== null && newPosX < this.xMin)) {
          return;
        }
        //notify X overflows
        if (newPosX > this.xMax) { 
          this.dispatchEvent("onXOverflow", [key, newPosX, this.xMin, this.xMax]);
        }
        
        for(var yFieldCode in this.chartArray) {
          //fix Y
          var newPosY = this.parseValue(key,serverValues,yFieldCode,this.yParsers[yFieldCode]);
          if (isNaN(newPosY)) {
            continue;
          }
          
          var chartLine =  this.chartArray[yFieldCode][key];
          
          if (newPosX == null || newPosY == null) {
            if (chartLine && newPosX == null && newPosY == null) {
              gridsLogger.logInfo(LoggerManager.resolve(964),this,chartLine);
              //both nulls means clear
              chartLine.reset();
              
              continue;
            } else {
              gridsLogger.logDebug(LoggerManager.resolve(965),this,chartLine);
              //if there are nulls we do not paint the point
              continue;
            }
          }
          
          if (!chartLine) {
            //this is an add
            chartLine = new ChartLine(key, this, this.xFieldCode, yFieldCode);
            
            this.dispatchEvent("onNewLine",[key,chartLine,newPosX,newPosY]);
            
            if (!chartLine.isYAxisPositioned()) {
              gridsLogger.logError(LoggerManager.resolve(966),this);
              return;
            }
            
            chartLine.calcYUnit();
            chartLine.paintYLabels(); //screenY - yMax - chartArea.parentNode
          
            this.chartArray[yFieldCode][key] = chartLine;
          }

          if (!chartLine.isPointInRange(newPosY)) {  
            this.dispatchEvent("onYOverflow", [key,chartLine,newPosY,chartLine.getMin(),chartLine.getMax()]);
          }
          
          chartLine.addPoint(newPosX,newPosY);
        }
        
      },
      
      /**
       * @ignore
       */ 
      removeRowExecution: function(key) {
        for (var yField in this.chartArray) {
          this.deleteChartLine(key,yField);
        }
      },
      
      /**
       * @private
       */ 
      deleteChartLine: function(key,field) {
        if (!this.chartArray[field]) {
          return;
        }
        var cLine =  this.chartArray[field][key];
        
        cLine.reset();//this removes the painting and the history
        cLine.clearLabels();//this reemoves the labels
        
        this.painter.removeLine(cLine); //this removes the handling
        
        delete(this.chartArray[field][key]);
        
        this.dispatchEvent("onRemovedLine",[key,cLine]);
        
        gridsLogger.logDebug(LoggerManager.resolve(967),this,key,field);
        
      },

      /**
       * @inheritdoc
       */
      clean: function() {
        this._callSuperMethod(Chart,"clean"); 
        //this will call removeRowExecution per each "row"
        
        //tolgo le label sulla X
        this.clearLabels();
       
        //tolgo il grafico 
        if (this.painter) {
          this.painter.clean();
        }
       
        delete (this.painter); 
        
        this.setChartAnchor(this.caContainer.parentNode,true);
        
        gridsLogger.logDebug(LoggerManager.resolve(968),this);
      },
      
      /**
       * This method is automatically called by the constructor of this class.
       * It will bind the current instance with the HTML element having the id
       * specified in the constructor.
       */
      parseHtml: function() {
        gridsLogger.logInfo(LoggerManager.resolve(969),this);
        
        var cAnchor = document.getElementById(this.id);
        if (!cAnchor) {
          //waiting for a valid call
          return;
        }
        if (!Cell.verifyTag(cAnchor)) {
          throw new IllegalStateException(NO_ANCHOR);
        }
        this.setChartAnchor(cAnchor);
        
        this.parsed = true;
        
      },
      
      
      
      /**
       * Setter method that sets the stylesheet and positioning to be applied to 
       * the chart area.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The chart area stylesheet and position attributes 
       * can be set and changed at any time.</p>
       * 
       * @throws {IllegalArgumentException} if one of the numeric values is not 
       * valid.
       *
       * @param {String} [chartCss] the name of an existing stylesheet to be applied to 
       * the chart. If not set, the stylesheet is inherited from
       * the DOM element containing the chart.
       * 
       * @param {Number} [chartHeight] the height in pixels of the chart area.
       * Such height may be set as smaller than the height of the container
       * HTML element in order to make room for the X axis labels. If not set, 
       * the whole height of the container HTML element is used.
       * 
       * @param {Number} [chartWidth] the width in pixels of the chart area.
       * Such width may be set as smaller than the width of the container HTML 
       * element in order to make room for the Y axis labels. If not set, 
       * the whole width of the container HTML element is used.
       * 
       * @param {Number} [chartTop=0] the distance in pixels between the top margin of the 
       * chart area and the top margin of the container HTML element. 
       * Such distance may be set as a nonzero value in order to make room for
       * the first Y axis label. If not set, 0 is used.
       * 
       * @param {Number} [chartLeft=0] the distance in pixels between the left margin of 
       * the chart area and the left margin of the container HTML element. 
       * Such distance may be set as a nonzero value in order to make room for the 
       * Y axis labels. If not set, 0 is used.
       */
      configureArea: function(chartCss,chartHeight,chartWidth,chartTop,chartLeft) {
        if (chartCss) {
          this.areaClass = chartCss;
        }
        if (chartTop) {
          this.offsetY = this.checkPositiveNumber(chartTop, true);
        }
        if (chartLeft) {
          this.offsetX = this.checkPositiveNumber(chartLeft, true);
        }
        if (chartHeight) {
          this.screenY = this.checkPositiveNumber(chartHeight, true);
        }
        if (chartWidth) {
          this.screenX = this.checkPositiveNumber(chartWidth, true);
        }
        
        this.configurePainter();
        
        
        
        if (chartWidth || chartHeight) {
          
          if (chartWidth && this.xMax != null) {
            this.calcXUnit();    
            this.paintXLabels(); //screenX - xMax - chartArea.parentNode
          }
          
          for (var yField in this.chartArray) {
            for (var line in this.chartArray[yField]) {
              var cLine = this.chartArray[yField][line];
              if (cLine && cLine.isYAxisPositioned() && this.xMax != null) {
                
                if (chartHeight) {
                  cLine.calcYUnit();
                  cLine.paintYLabels(); //screenY - yMax - chartArea.parentNode
                }
                
                if (cLine && !cLine.isEmpty()) {
                  cLine.repaint();
                }
              }
            }
          }
        }
        
      },

      /**
       * Setter method that sets the field to be used as the source of the
       * X-coordinate for each update. An optional parser can be passed to normalize
       * the value before it is used to plot the chart.
       * The resulting values should be in the limits posed by the 
       * {@link Chart#positionXAxis} method, otherwise a
       * {@link ChartListener#onXOverflow} event is fired to handle the situation.
       * null can also be specified, in which case, if the associated Y value is null
       * the chart will be cleared, otherwise the update will be ignored.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> The X axis field can be set at any time.
       * Until set, no chart will be printed. If already set, the new setting only
       * affects the new points while all the previously plotted points are cleaned.</p>
       * 
       * @param {String} field A field name representing the X axis.
       * @param {CustomParserFunction} [xParser] A parser function that can be used to normalize
       * the value of the X field before using it to plot the chart.
       * If the function is not supplied,
       * then the field values should represent valid numbers in JavaScript or be null.
       */
      setXAxis: function(field, xParser) {
        this.xFieldCode = field;
        this.xParser = xParser;
        this.clean();
        gridsLogger.logDebug(LoggerManager.resolve(970),field,this);
      },
      
      /**
       * Adds field(s) to be used as the source of the Y-coordinate for each update
       * An optional parser can be passed to normalize the value before it is used to 
       * plot the chart.
       * The resulting values should be in the limits posed by the 
       * {@link ChartLine#positionYAxis} related to the involved line, otherwise a 
       * {@link ChartListener#onYOverflow} event is fired to handle the situation.
       * null can also be specified, in which case, if the associated X value is null
       * the chart line will be cleared, otherwise the update will be ignored.
       * <BR>It is possible to specify an array of fields instead of specifying a 
       * single field. If that's the case multiple chart lines will be generated
       * per each row in the model.
       * <BR>Note that for each field in the underlying model it is possible to associate
       * only one line. If multiple lines based on the same fields are needed, dedicated
       * fields should be added to the model, through {@link AbstractWidget#updateRow}.
       * In case this instance is used to listen to events from {@link Subscription}
       * instance(s), updateRow() can be invoked from within {@link SubscriptionListener#onItemUpdate}.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The method can be invoked at any time, in order to
       * add fields to be plotted or in order to change the parser associated to
       * fields already being plotted.
       * Until invoked for the first time, no chart will be printed.</p>
       *
       * @param {String} field A field name representing the Y axis. An array
       * of field names can also be passed. Each field will generate its own line.
       * @param {(CustomParserFunction|CustomParserFunction[])} [yParser] A parser function that can be used to normalize
       * the value of the Y field before using it to plot the chart.
       * If the function 
       * is not supplied, then the field values should represent valid numbers in JavaScript or be null.
       * <BR>If an array has been specified for the field parameter, then an array of parser functions can 
       * also be passed. Each parser will be executed on the field having the same index
       * in the array. On the other hand, if an array of fields is passed but only one 
       * parser has been specified, then the parser will be applied to all of the fields.
       * 
       * @see Chart#removeYAxis
       */
      addYAxis: function(field, yParser) {
        if (Helpers.isArray(field)) {
          
          gridsLogger.logDebug(LoggerManager.resolve(971),this);
          
          for (var i = 0; i<field.length; i++) {
            if (Helpers.isArray(yParser)) {
              this.addYAxis(field[i],yParser[i]);
            } else {
              this.addYAxis(field[i],yParser);
            }
          }
          
        } else {
          if (!this.chartArray[field]) {
            this.chartArray[field] = {};
          }
          this.yParsers[field] = yParser;
          
          gridsLogger.logDebug(LoggerManager.resolve(972),field,this);
        }
        
      },
      
      /**
       * Removes field(s) currently used as the source of the Y-coordinate for each update
       * and all the related {@link ChartLine}. 
       * <BR>It is possible to specify an array of fields instead of specifying a 
       * single field. If that's the case all the specified fields and related chart lines 
       * will be removed.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The method can be invoked at any time, in order to
       * remove plotted fields.</p>
       *
       * @param {String} field A field name representing the Y axis. An array
       * of field names can also be passed. 
       * 
       * @see Chart#addYAxis
       */
      removeYAxis: function(field) {
        if (Helpers.isArray(field)) {
          gridsLogger.logDebug(LoggerManager.resolve(973),this);
          
          for (var i = 0; i<field.length; i++) {
            this.removeYAxis(field[i]);
          }
          
        } else {
          if (!this.chartArray[field]) {
            return;
          }
          
          for (var key in this.chartArray[field]) {
            this.deleteChartLine(key,field);
          }
          
          delete(this.chartArray[field]);
          delete(this.yParsers[field]);
        
          gridsLogger.logDebug(LoggerManager.resolve(974),field,this);
        }
        
      },
      
      /**
       * Operation method that sets or changes the limits for the visible part
       * of the X axis of the chart (that is, the minimum and maximum X-coordinates
       * shown in the chart).
       * If these limits are changed while the internal model is not empty 
       * then this causes a repaint of the whole chart.
       * <BR>Note that rising the minimum X value shown also clears from
       * the memory all the points whose X value becomes lower. So, those points
       * will not be displayed again after lowering again the minimum X value.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The X axis limits can be set at any time.</p>
       *
       * @throws {IllegalArgumentException} if the min parameter is greater 
       * than the max one.
       *
       * @param {Number} min lower limit for the visible part of the X axis.
       * @param {Number} max higher limit for the visible part of the X axis.
       */
      positionXAxis: function(min, max) {
        this.xMax = Number(max);
        this.xMin = Number(min);
        
        if (isNaN(this.xMax) || isNaN(this.xMin)) {
          throw new IllegalArgumentException("Min and max must be numbers");
        } else if (this.xMin > this.xMax) {
          throw new IllegalArgumentException("The maximum value must be greater than the minimum value");
        }
    
        
        if (this.screenX != null) {
          this.calcXUnit();
          this.paintXLabels();  //screenX - xMax - chartArea.parentNode
        }
        
        
        this.repaintAll();
        
    
        gridsLogger.logDebug(LoggerManager.resolve(975),this);
      },
        
      /**
       * Setter method that configures the legend for the X axis. The legend
       * consists of a specified number of labels for the values in the X axis.
       * The labels values are determined based on the axis limits; the labels
       * appearance is controlled by supplying a stylesheet and a formatter
       * function.
       * <BR>Note that the room for the X axis labels on the page is not provided
       * by the library; it should be provided by specifying a chart height
       * smaller than the container element height, through the
       * {@link Chart#configureArea} setting. Moreover, as the first and last labels
       * are centered on the chart area borders, a suitable space should be
       * provided also on the left and right of the chart area, through the
       * same method.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Labels can be configured at any time.
       * If not set, no labels are displayed relative to the X axis.</p>
       *
       * @throws {IllegalArgumentException} if labelsNum is not a valid
       * poisitive integer number.
       *
       * @param {Number} labelsNum the number of labels to be spread on the
       * X axis; it should be 1 or greater.
       * @param {String} [labelsClass] the name of an existing stylesheet, to be
       * applied to the X axis label HTML elements. The parameter is optional;
       * if missing or null, then no specific stylesheet will be applied.
       * @param {LabelsFormatter} [labelsFormatter] a Function instance
       * used to format the X axis values designated for the labels. 
       * If the function is not supplied, then the value will be used with no further formatting.
       * 
       */
      setXLabels: function(labelsNum, labelsClass, labelsFormatter) {
        this.numXLabels = this.checkPositiveNumber(labelsNum,true);
        this.classXLabels = labelsClass;
        this.labelsFormatter = labelsFormatter || null;
        
        if (this.xUnit != null) {
          // the X axis is already configured, I design the labels
          this.paintXLabels();  //screenX & xMax (xUnit) - chartArea.parentNode
        }
      
        gridsLogger.logDebug(LoggerManager.resolve(976),this);
      },
      
      /**
       * Adds a listener that will receive events from the Chart 
       * instance.
       * <BR>The same listener can be added to several different Chart 
       * instances.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
       * 
       * @param {ChartListener} listener An object that will receive the events
       * as shown in the {@link ChartListener} interface.
       * <BR>Note that the given instance does not have to implement all of the 
       * methods of the ChartListener interface. In fact it may also 
       * implement none of the interface methods and still be considered a valid 
       * listener. In the latter case it will obviously receive no events.
       */
      addListener: function(listener) {
        this._callSuperMethod(Chart,"addListener",[listener]);
      },
      
      /**
       * Removes a listener from the Chart instance so that it
       * will not receive events anymore.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
       * 
       * @param {ChartListener} listener The listener to be removed.
       */
      removeListener: function(listener) {
        this._callSuperMethod(Chart,"removeListener",[listener]);
      },
      
      /**
       * Returns an array containing the {@link ChartListener} instances that
       * were added to this client.
       * 
       * @return {ChartListener[]} an array containing the listeners that were added to this instance.
       * Listeners added multiple times are included multiple times in the array.
       */
      getListeners: function() {
        return this._callSuperMethod(Chart,"getListeners");
      }
      
  };
  
  //closure compiler exports
  Chart.prototype["parseHtml"] = Chart.prototype.parseHtml;
  Chart.prototype["configureArea"] = Chart.prototype.configureArea;
  Chart.prototype["setXAxis"] = Chart.prototype.setXAxis;
  Chart.prototype["addYAxis"] = Chart.prototype.addYAxis;
  Chart.prototype["removeYAxis"] = Chart.prototype.removeYAxis;
  Chart.prototype["positionXAxis"] = Chart.prototype.positionXAxis;
  Chart.prototype["setXLabels"] = Chart.prototype.setXLabels;
  Chart.prototype["addListener"] = Chart.prototype.addListener;
  Chart.prototype["removeListener"] = Chart.prototype.removeListener;
  Chart.prototype["getListeners"] = Chart.prototype.getListeners;
  Chart.prototype["clean"] = Chart.prototype.clean;
  Chart.prototype["onListenStart"] = Chart.prototype.onListenStart;
  Chart.prototype["updateRowExecution"] = Chart.prototype.updateRowExecution;
  Chart.prototype["removeRowExecution"] = Chart.prototype.removeRowExecution;
//<----  Listener Interface      
  
  
  Inheritance(Chart,AbstractWidget);
  return Chart;
})();
  
  /**
   * Callback for {@link Chart#setXAxis} and {@link Chart#addYAxis}
   * @callback CustomParserFunction
   * @param {String} fieldValue the field value to be parsed.
   * @param {String} key the key associated with the given value
   * @return {Number} a valid number to be plotted or null if the value has to be considered unchanged
   */
  
  /**
   * Callback for {@link Chart#setXLabels} and {@link ChartLine#setYLabels}
   * @callback LabelsFormatter
   * @param {Number} value the value to be formatted before being print in a label. 
   * @return {String} the String to be set as content for the label.
   */

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var CellMatrix = /*@__PURE__*/(function() {
  function rowGarbageCollection(currRow) {
    var somethingInRow = false;
    for (var field in currRow) {
      if (!singleCellGarbageCollection(currRow[field])) {
        delete(currRow[field]);
      } else {
        somethingInRow = true;
      }
    }
    return somethingInRow;
  }
  
  function singleCellGarbageCollection(currCell) {
    if (currCell.isCell) {
      return currCell.isAttachedToDOMById();
  
    } else {
      var foundGroup = false;
      for(var i=0; i<currCell.length; ) {
        if (!currCell[i].isAttachedToDOMById()) {
          currCell.splice(i,1);
        } else {
          foundGroup = true;
          i++;
        }
      }
      return foundGroup;
    }
    
  }
  
  function makeFakeCell(orig,useInner) {
    var fakeCell = new Cell(document.createElement("p"));
    fakeCell.scrollHere(orig,useInner);
    
    var origNum = orig.getNum();
    fakeCell.getNum = function() {
      return origNum;
    };
    
    return fakeCell;
  }
  
  function cleanAll(cell) {
    if (cell.isCell) {
      cell.clean();
    } else for (var n=0; n<cell.length; n++){
      cell[n].clean();
    }
  }
  
  function copyAll(cell,useInner) {
    if (cell.isCell) {
      //creating a fake cell
      return makeFakeCell(cell,useInner);
      
    } else  {
      //create multiple fake cells
      var ret = [];
      for (var n = 0; n<cell.length; n++){
        ret[n] = makeFakeCell(cell[n],useInner);
      }
      return ret;
    }
  }
  
  /**
   * @private
   */
  var CellMatrix = function(pMatrix) {
    this._callSuperConstructor(CellMatrix,[pMatrix]);
  };
  
  CellMatrix.scrollRow = function(fromRow,toRow,useInner) {
    
    //for starters let's create a list of
    //all the possible columns by scanning both
    //"from" and "to" rows
    var colList = {};
    for (var c in fromRow) {
      colList[c] = true;
    }
    if (!toRow) {
      toRow = {};
    } else for (var c in toRow) {
      colList[c] = true;
    }
    
  
    //we have to scroll a row to another row; problem is that for a column there can be
    //more than one cell AND that this can be not symmetric between two different rows.
    //ALSO some of these cells can be identified by an id and several can be identified by a NULL
   
    for (var col in colList) {
      if (!fromRow[col]) {
        //column does not exist on origin: clean target
        cleanAll(toRow[col]);
        
      } else if (!toRow[col]) {
        //column does not exist on target: make a fake row
        toRow[col] = copyAll(fromRow[col],useInner);
        
      } else if(toRow[col].isCell && fromRow[col].isCell) {
        //both are cells, simple case
        toRow[col].scrollHere(fromRow[col],useInner);
        
      } else {
        //one or both are arrays, let's search and match
        
        //make both arrays
        var fromCells = fromRow[col].isCell ? [fromRow[col]] : fromRow[col];
        if (toRow[col].isCell) { //in any case will become an array
          var orig = toRow[col];
          toRow[col] = [orig]; 
        }
        //make a copy of the to-row array so that we can cross-out matched cells
        var toCells = [].concat(toRow[col]);
        
        //scan from-cells
        for (var n=0; n<fromCells.length; n++) {
          var matched = false;
          //search the correspondant to-cell if any
          for (var m=0; m<toCells.length; m++) {
            if (toCells[m].getNum() === fromCells[n].getNum()) { //a null would match with the first null available if any
              //if found do the scoll
              toCells[m].scrollHere(fromCells[n],useInner);
              matched = true;
              //and cross-out
              toCells.splice(m,1);
              break;
            }
          }
          
          if (!matched) {
            //if not add a fake cell to the to-row
            toRow[col].push(makeFakeCell(fromCells[n],useInner));
          }
        }
        //finally clean non-matched cells
        cleanAll(toCells);
      
      }
       
    }
      
    return toRow;
  };
  
  
  CellMatrix.prototype = {
      
      alreadyInList: function(elToCheck) {
        var cell = this.getCell(elToCheck.getRow(),elToCheck.getField());
        if (!cell) {
          return false;
        }
        if (cell.isCell) {
          return cell.isSameEl(elToCheck);
          
        } else for (var i=0; i<cell.length; i++) {
          if (cell[i].isSameEl(elToCheck)) {
            return true;
          }
        }
        return false;
      },
      
      addCell: function(newCell,row,col) {
        row = row || newCell.getRow();
        col = col || newCell.getField();
        
        var cell = this.getCell(row,col);
        if (!cell) {
          this.insert(newCell,row,col);
        } else if (cell.isCell) {
          var container = [cell,newCell];
          this.insert(container,row,col);
          
        } else {
          cell.push(newCell);
          //this.insert(cell,row,col); //useless
        }
      },
      
      forEachCell: function(cb) {
        var that = this;
        this.forEachElement(function(el,row,col) {
          that.forEachCellInElement(el,row,col,cb);
        });
      },
      
      forEachCellInRow: function(_row,cb) {
        var that = this;
        this.forEachElementInRow(_row,function(el,row,col) {
          that.forEachCellInElement(el,row,col,cb);
        });
      },
      
      forEachCellInPosition: function(_row,_col,cb) {
        var _cell = this.get(_row,_col);
        if (!_cell) {
          return;
        }
        this.forEachCellInElement(_cell,_row,_col,cb);
      },
      
      /*private*/ forEachCellInElement: function(cell,row,col,cb) {
        if (cell.isCell) {
          cb(cell,row,col);
        } else for(var i=0; i<cell.length; i++) {
          cb(cell[i],row,col,cell[i].getNum());
        }
      },
      
      getCell: function(_row,_col,num) {
        if (!num) {
          return this.get(_row,_col);
        } else {
          var cell = this.get(_row,_col);
          if (cell) {
            if (!cell.isCell) {
              for (var i=0; i<cell.length; i++) {
                if (cell[i].getNum() == num) {
                  return cell[i];
                }
              }
            } else if (cell.getNum() == num) {
              return cell;
            }
          }  
          
          return null;
          
        }
      },
     
      cellsGarbageCollection: function() {
        var _cells = this.getEntireMatrix();
        for (var _row in _cells) {
          if (!rowGarbageCollection(_cells[_row])) {
            delete _cells[_row];
          }
        }
      }
  };
  
  
  Inheritance(CellMatrix,Matrix,false,true);
  
  return CellMatrix;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var ColorConverter = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  /*
    
      From the "Cascading Style Sheets, level 1 - W3C Recommendation 17 Dec 1996, revised 11 Apr 2008":
      ----
      6.3    Color units
      ...
      The RGB color model is being used in numerical color specifications. These examples all specify the same color:
      EM { color: #f00 }              // #rgb 
      EM { color: #ff0000 }           // #rrggbb 
      EM { color: rgb(255,0,0) }      // integer range 0 - 255 
      EM { color: rgb(100%, 0%, 0%) } // float range 0.0% - 100.0% 
      
      The format of an RGB value in hexadecimal notation is a '#' immediately followed by either three or six hexadecimal characters. 
      The three-digit RGB notation (#rgb) is converted into six-digit form (#rrggbb) by replicating digits, not by adding zeros. For example, 
      #fb0 expands to #ffbb00. This makes sure that white (#ffffff) can be specified with the short notation (#fff) and removes any dependencies 
      on the color depth of the display.
      ----
      [http://www.w3.org/TR/CSS1/#color-units] 
     
     */
  
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.grids");
  
  /**
   * three possible forms
   * "#FFFFFF" -> [255,255,255]
   * "FFFFFF" -> [255,255,255]
   * "#FFF" -> [255,255,255]
   * @private
   */
  function hexColorToRGBArray(hexColor) {
    if (hexColor.indexOf("#") == 0) {
      hexColor = hexColor.substring(1,hexColor.length);
    }
    if (hexColor.length == 3) {
      hexColor = hexColor.charAt(0)+hexColor.charAt(0)+hexColor.charAt(1)+hexColor.charAt(1)+hexColor.charAt(2)+hexColor.charAt(2);
    } else if (hexColor.length != 6) {
      gridsLogger.warn( "A hexadecimal color value must be 3 or 6 character long. An invalid value was specified, will be ignored");
      return null;
    }
    
    var strR = hexColor.substring(0,2);
    var strG = hexColor.substring(2,4);
    var strB = hexColor.substring(4,6);
    
    
    var numR = hexToDec(strR);
    var numG = hexToDec(strG);
    var numB = hexToDec(strB);
    if (numR == null || numG == null || numB == null) {
      return null;
    }
    
    return [numR,numG,numB];

  }
  
  var hexMap = {"A":10,"B":11,"C":12,"D":13,"E":14,"F":15};
  function makeNum(str) {
    if ((str >= 0) && (str <= 9)) {
      return new Number(str);
    }
    str = str.toUpperCase();
    
    if (hexMap[str]) {
      return hexMap[str];
    } else {
      gridsLogger.warn("A hexadecimal number must contain numbers between 0 and 9 and letters between A and F. An invalid value was specified, will be ignored");
      return null;
    }
  }  
  function hexToDec(hex) {
    //return parseInt(hex,16); <- why not?
    var res = 0;
    var cicle = 0;
    var i;
    for (i = hex.length; i >= 1; i--) {
      var tmp = makeNum(hex.substring(i-1,i));
      if (tmp == null) {
        return null;
      }
      var x;
      for (x = 1; x <= cicle; x++) {
        tmp *= 16;
      }
      cicle++;
      res += tmp;
    }
    return res;
  }
  
  function ifPercToNum(num) {
    if (num.indexOf("%") == num.length-1) {
      num = parseFloat(num.substring(0,num.length-1));
      if (num > 100 || num < 0) {
        gridsLogger.warn("A RGB element must be a number >=0 and <=255 or a percentile >=0 and <=100. An invalid value was specified, will be ignored");
        return null;
      }
      num = 2.55*num;
    }
    return num;
  }
  
  function isOkColor(foundColor, notExpectedColor) {
    if (!foundColor || foundColor == "") {
      return false;
    } else if (!notExpectedColor) {
      return true;
    } else if (foundColor != notExpectedColor) {
      return true;
    } else {
      return false;
    }
  }
  
  function translateColorNameByDIV(colorName) {
    var elem = document.createElement("DIV");
    elem.style.backgroundColor = colorName;
    var val = ColorConverter.getStyle(elem,bgJS, colorName);
    if (val == null) {
      // admitted by getStyle; but possible?
      return null;
    }
  
    if (val[0] == 255 && val[1] == 255 && val[2] == 255) {
      if (colorName.toUpperCase() != "WHITE" ) {
        //I failed. I try to hang firstly
        // the son on the page
        var bodyEl = document.getElementsByTagName("BODY")[0];
        if (bodyEl) {
          bodyEl.appendChild(elem);
          val = ColorConverter.getStyle(elem,bgJS, colorName);
          bodyEl.removeChild(elem);  
        }
      }
    }
    
    colorMap[colorName] = val;
    return colorMap[colorName];
  }
  
  /**
   * "white" -> [255,255,255]
   */
  function nameToRGBArray(colorName) {
    var res = "";
    /* on IE we notice the double change of background, on FX no
     * on FX using the engine to change the background does not work, on IE yes
     * for Opera we create a div, we assign the color and we make a getStyle
     */
    if (colorMap[colorName]) {
      return colorMap[colorName];
    }


  //if (BrowserDetection.isProbablyOldOpera()) {
  //if (window.getComputedStyle || (document.defaultView && document.defaultView.getComputedStyle)) {
  
    //20110616: IE9 is still like this
    if(!BrowserDetection.isProbablyIE()) { 
      return translateColorNameByDIV(colorName); //will fill colorMap itself
      
    } else {
      
      try {
        colorFrame = IFrameHandler.getFrameWindow("weswit__ColorFrame",true);
        if (colorFrame) {
          colorFrame.document.bgColor = colorName;
          res = colorFrame.document.bgColor;
        }
          
      } catch(_e) {
        res=null;
      }
      
    }
    //may still fail
    if (!res || res == colorName) {
      var initBG = document.bgColor;
      document.bgColor = colorName;
      res = document.bgColor;
      document.bgColor = initBG;
    }
  
    if (!res || res == colorName) {
      return translateColorNameByDIV(colorName); //will fill colorMap itself
    } //else is in the hex form
    colorMap[colorName] = hexColorToRGBArray(res);
    return colorMap[colorName];
  }
    
  function RGBStringToRGBArray(rgbColor) {
    var lenPre;
    var thirdLimit;
    if (rgbColor.indexOf("rgb(") == 0) {
      lenPre = 4;
      thirdLimit = ")";
    } else if (rgbColor.indexOf("rgba(") == 0) {
      lenPre = 5;
      thirdLimit = ",";
    } else{
      gridsLogger.warn("A RGB color value must be in the form 'rgb(x, y, z)' or 'rgba(x, y, z, a)'. An invalid value was specified, will be ignored");
      return null;
    }
    rgbColor = rgbColor.substring(lenPre,rgbColor.length);
    
    var v1 = rgbColor.indexOf(",");
    var numR = ifPercToNum(rgbColor.substring(0,v1));
    var v2 = rgbColor.indexOf(",",v1+1);
    var numG = ifPercToNum(rgbColor.substring(v1+1,v2));
    var v3 = rgbColor.indexOf(thirdLimit,v2+1);
    var numB = ifPercToNum(rgbColor.substring(v2+1,v3));
    
    if (numR == null || numG == null || numB == null) {
      return null;
    }
    
    
    return [numR,numG,numB];
  }
  
  

///////
    
  
  var bgCSS = "background-color"; 
  var bgJS = "backgroundColor";
  var transp = "transparent";
  
  var colorMap = {};
  var colorFrame=null; 

  /**
   * @private
   */
  var ColorConverter = {
   
    /**
     * Translates a color from any (string) form in an RGB array
     */
    translateToRGBArray: function(val) {
      if (val.indexOf("rgb") == 0) {
        //"rgb(0, 255, 0)"
        return RGBStringToRGBArray(val);
      } else if (val.indexOf("#") == 0) {
        //"#00FF00"
        return hexColorToRGBArray(val);
      } else {
        //"green"
        return nameToRGBArray(val);
      }
    },
    
    
    /*public*/ getStyle: function(elem,styleProp,notExpectedColor) {
      if (elem == null) {
        //no element? let's say white
        return [255,255,255];
      }
      
      var val = "";
      try {
        //do not move if conditions or opera will hate you
        if (window.getComputedStyle || (document.defaultView && document.defaultView.getComputedStyle)) {
          //try with getComputedStyle
          var styleObj = document.defaultView.getComputedStyle(elem, null);
          if (styleObj) {
            var compProp = styleProp == bgJS ? bgCSS : styleProp;
            val = styleObj.getPropertyValue(compProp);
          }
        }
      }catch(e){}
      
      
      
      try {
        if (!isOkColor(val,notExpectedColor) && elem.currentStyle) {
          //try with currentStyle
          var compProp = styleProp == bgCSS ? bgJS : styleProp;
          val = elem.currentStyle[compProp];
        }
      }catch(e){}
      
      try {
        if (!isOkColor(val,notExpectedColor)) {
          //so far so bad... let's read from css, finger crossed
          var upProp = styleProp == bgCSS ? bgJS : styleProp;
          if (elem.style[upProp] != "") {
            val = elem.style[upProp];
          } else {
            return [255,255,255];
          }
        }
      }catch(e){}
      
      if (val == transp && elem.parentNode) {
        //trasparent color, let's check the parent
        return this.getStyle(elem.parentNode,styleProp);
      } else if (val == transp) {
        return [255,255,255];
      }
      
      if (!isOkColor(val,notExpectedColor)) {
        return [255,255,255];
      }
  
      return this.translateToRGBArray(val);
    }
    
  };
  
  return ColorConverter;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var FadersHandler = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  //may convert into a full animation engine
  
  /**
   * @private
   */
  var FadersHandler = function(interval){
    this.fadeInterval = interval;
    this.freeFaders = new FaderPile();
    this.faderId = 0;
    this.faderList = {};
    this.fadeThread = false;

    this.runningFaders = {};
  };
  
  FadersHandler.prototype = {
    
    /**
     * @private
     * @param {Cell} cell
     * @param goingDown
     * @param endBack
     * @param endFore
     * @param millis
     * @param endCommand
     * @returns {String} id
     */
    /*public*/ getNewFaderId: function(cell, goingDown, endBack, endFore, millis, endCommand) {
      var steps = this.getHowManySteps(millis);
      var actPhase = cell.incFadePhase();
      if (!actPhase) {
        return;
      }
      var retId = this.freeFaders.get();
      if (retId == null) {
        this.faderList[this.faderId] = new Fader(cell, goingDown, endBack, endFore, steps, actPhase, endCommand);
        return this.faderId++;
      } else {
        this.faderList[retId].init(cell, goingDown, endBack, endFore, steps, actPhase, endCommand);
        return retId;
      }
    },
   
    /**
     * @private
     */
    getHowManySteps: function(time) {
      var steps = time/this.fadeInterval;
      return (steps > 1) ? steps : 1;
    },
    
    /*public*/ launchFader: function(id) {
      var fader = this.faderList[id];
      
      var currentPhase = fader.cell.getFadePhase();
      if (!currentPhase) {
        this.stopFader(fader.cell);
        return;
      }
      
      if (fader.phase < currentPhase) {
        return;
      }
      var oldId = this.runningFaders[fader.cell.getCellId()];
      var oldFader = this.faderList[oldId];
      if (oldFader) {
        if (!oldFader.goingDown) {
          if (fader.goingDown) {
            if(oldFader.endCommand) {
              Executor.executeTask(oldFader.endCommand);
            }
          } else {
            fader.actStep = oldFader.actStep;
            if (fader.steps < oldFader.steps) {
              fader.steps = oldFader.steps;
            }
          }
        }
        this.freeFaders.put(oldId);
      }
      this.runningFaders[fader.cell.getCellId()] = id;
          
      if (fader.endBack) {
        fader.startBack = ColorConverter.getStyle(fader.cell.getEl(),"backgroundColor");
      }
      if (fader.endFore) {
        fader.startFore = ColorConverter.getStyle(fader.cell.getEl(),"color");
      }
      
      if (!this.fadeThread) {
        this.fadeThreadStart(this.fadeInterval);
      }
    },
    
    /*public*/ stopFader: function(cell) {
      var oldId = this.runningFaders[cell.getCellId()];
      if (oldId || oldId == 0) {
        delete(this.runningFaders[cell.getCellId()]);
        this.freeFaders.put(oldId);
      }
    },
    
    /**
     * @private
     */
    doFade: function(lastEndTime) {
      var startTime = Helpers.getTimeStamp();
      
      var lostWaiting = 0;
      if (lastEndTime) {
        lostWaiting = startTime - (lastEndTime + this.fadeInterval);
      } 
      
      var atLeast1 = false;
      for (var ind in this.runningFaders) {
        var localFaderId = this.runningFaders[ind];
        var fader = this.faderList[localFaderId];
        
        if (fader.actStep > fader.steps) {
          this.freeFaders.put(localFaderId);
          delete (this.runningFaders[ind]);
          if (fader.endCommand) {
            Executor.addPackedTimedTask(fader.endCommand,0);
          }
        } else {
          var upEl = fader.cell.getEl();
          if (!upEl) {
            this.stopFader(fader.cell);
            continue;
          }

          if (fader.endBack == "transparent") {
            try {
              upEl.style.backgroundColor = "rgba(" +
              fader.startBack[0] + "," +
              fader.startBack[1] + "," +
              fader.startBack[2] + "," +
              this.easeInOut(100, 0, fader.steps, fader.actStep) / 100 + ")";
            } catch(e) {
              var timeToEnd = (fader.steps-fader.actStep)*this.fadeInterval;
              
              Executor.addTimedTask(toTransparent(upEl),timeToEnd);

              if (fader.endCommand) {
                Executor.addPackedTimedTask(fader.endCommand,timeToEnd);
              }
              
              this.stopFader(fader.cell);
              continue;
            }
          } else if (fader.endBack) {
            upEl.style.backgroundColor = "rgb("+
              this.easeInOut(fader.startBack[0],fader.endBack[0],fader.steps,fader.actStep) +","+
              this.easeInOut(fader.startBack[1],fader.endBack[1],fader.steps,fader.actStep) +","+
              this.easeInOut(fader.startBack[2],fader.endBack[2],fader.steps,fader.actStep) +")";
          }
          if (fader.endFore) {
            upEl.style.color = "rgb("+
              this.easeInOut(fader.startFore[0],fader.endFore[0],fader.steps,fader.actStep)+","+
              this.easeInOut(fader.startFore[1],fader.endFore[1],fader.steps,fader.actStep)+","+
              this.easeInOut(fader.startFore[2],fader.endFore[2],fader.steps,fader.actStep)+")";
  
          }
          atLeast1 = true;
        }
        fader.actStep++;
      }
      
      if (!atLeast1) {
        this.fadeThread = false;
      } else {
        var endTime = Helpers.getTimeStamp();
        var lostTime = (endTime - startTime);
        var gainedDelay = lostTime + lostWaiting;
        
        if (gainedDelay > this.fadeInterval) {
          //the delay is greater than the step size, we need
          //to skip steps
          
          //steps to skip
          var lostCycles = gainedDelay/this.fadeInterval;
          
          var lostCyclesNorm = Math.floor(lostCycles);
          
          var factionalCycles = lostCycles - lostCyclesNorm;
          
          this.recoverCycles(lostCyclesNorm);
                   
          gainedDelay = this.fadeInterval * factionalCycles;
        }
        
        this.nextFade(this.fadeInterval-gainedDelay,endTime);
      }
    },

    /**
     * @private
     */
    nextFade: function(pause,lastEndTime) {
      Executor.addTimedTask(this.doFade,pause,this,[lastEndTime]);
    },
    
    /**
     * @private
     */
    recoverCycles: function(lostCyclesNorm) {
      for (var ind in this.runningFaders) {
        var localFaderId = this.runningFaders[ind];
        var fader = this.faderList[localFaderId];
        if (fader.actStep > fader.steps) ; else if (fader.actStep + lostCyclesNorm < fader.steps) {
          //let's skip some steps
          fader.actStep += lostCyclesNorm;
        } else {
          //move directly to the end
          fader.actStep = fader.steps;
        }
      }
      
    },
    
    /**
     * @private
     */
    fadeThreadStart: function(timeout) {
      if (this.fadeThread == true) {
        return;
      }
      this.fadeThread = true;
      
      this.nextFade(timeout);
    },
    

    /**
     * @private
     */
    easeInOut: function(minValue,maxValue,totalSteps,actualStep) {
      minValue = new Number(minValue);
      maxValue = new Number(maxValue);
      
      var delta = maxValue - minValue;
      var stepp = minValue+(((1 / totalSteps)*actualStep)*delta);
      return Math.ceil(stepp);
    },
    
    /**
     * may be exposed to offer fade functionality to non-Cell elements
     * @private
     */
    fadeCell: function(theTag, bgColor, textColor, fadeMillis, endCommand){
      //then make it a task
      var endCommandTask = Executor.packTask(endCommand);
      
      var cell = new Cell(theTag);
      var fadeId = this.getNewFaderId(cell, false, bgColor, textColor, fadeMillis, endCommandTask);
      this.launchFader(fadeId);
      return fadeId;
    }
  
  };

  function toTransparent(upEl) {
    return function() {
      upEl.style.backgroundColor = "transparent";
    };
  }


  /**
   * @private
   */
  var FaderPile = function() {
    this.length = 0;
    this.pile = {};
  };
  
  FaderPile.prototype = {
    put: function(id) {
      this.pile[this.length] = id;
      this.length++;
    },
 
    get: function() {
      if (this.length <= 0) {
        return null;
      }
      this.length--;
      return this.pile[this.length];
    }
  };


  /**
   * @private
   */
  var Fader = function(cell, goingDown, endBack, endFore, steps, phase, endCommand) {
    this.init(cell, goingDown, endBack, endFore, steps, phase, endCommand);
  };
  
  Fader.prototype = {
    init: function(cell, goingDown, endBack, endFore, steps, phase, endCommand) {
      this.endCommand = (endCommand) ? endCommand : null; 
      this.goingDown = goingDown;
      this.cell = cell;

      if (endBack === "" || endBack == "transparent") {
        this.endBack = "transparent";
      } else {
        this.endBack = (endBack) ? ColorConverter.translateToRGBArray(endBack) : null;
      }
      this.endFore = (endFore) ? ColorConverter.translateToRGBArray(endFore) : null;
      this.steps = steps;
      this.phase = phase;
      this.actStep = 0;
    }
  };
  

  return FadersHandler;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var AbstractGrid = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  var BG_ATTR = "backgroundColor";
  var COLOR_ATTR = "color";
  
  var NO_TYPES = "The given array is not valid or empty";
  
  var WRONG_INTERPRETATION = "The given value is not valid, use UPDATE_IS_KEY or ITEM_IS_KEY.";
  var NON_EMPTY_ERROR = "This method can only be called while the grid is empty.";
  
  var defaultTags = ["div","span","input"];
  
  
  function preformatValue(val) {
    return val === null ? "" : val;
  }
  
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.grids"); 
 
  
  /**
   * This is an abstract class; no instances of this class should be created.
   * @constructor
   * 
   * @exports AbstractGrid
   * @class The base class for the hierarchy of the *Grid classes.
   * Extends {@link AbstractWidget} to abstract a representation of the
   * internal tabular model as a visible grid made of HTML elements.
   * A specialized (derived) object, rather than an AbstractGrid instance, should
   * be created and used. Two of such classes are available with the library:
   * {@link StaticGrid} and {@link DynaGrid}.
   * This class is used by the mentioned specialized grid objects to inherit the 
   * support for their basic configurations and common utilities.
   * <BR>The class is not meant as a base class for the creation of custom grids.
   * The class constructor and its prototype should never be used directly.
   *
   * @extends AbstractWidget
   */
  var AbstractGrid = function() {

    //AbstractGrid(id)
    
    this._callSuperConstructor(AbstractGrid,arguments);
    
    //AbstractGrid
    this.useInner = false;  
    this.fieldSymbols = null; 
    
    
    //ScreenTableHelper
    this.tagsToCheck = defaultTags; 
    
    //Scroll - DynaScroll
    this.addOnTop = false; 
    
    //Sorting
    this.sortField = null; 
    this.descendingSort = false;  
    this.numericSort = false;  
    this.commaAsDecimalSeparator = false; 
    
    this.fader = new FadersHandler(50); 
    
    this.currentUpdateKey = null;
    this.currentUpdateValues = null;
    
    this.rowCount = 0; 
    this.maxRow = 0; 
    
    this.grid = new CellMatrix();  
    
  };
  
  
  AbstractGrid.prototype = {
      
      /**
       * @protected
       * @param key
       * @param newValues
       * @ignore
       */
      mergeUpdate: function(key,newValues) {
        if (gridsLogger.isDebugLogEnabled()) {
          gridsLogger.logDebug(LoggerManager.resolve(977),this);
        }
        
        for (var i in newValues) {
          this.currentUpdateValues[i] = newValues[i];
        }
        
        this.fillFormattedValues(this.currentUpdateKey,newValues);
      },
      
      /**
       * @protected
       * @param gridKey
       * @param updated
       * @ignore
       */
      fillFormattedValues: function(gridKey,updated) {       
        for (var i in updated) {
          
          this.grid.forEachCellInPosition(gridKey,i, function(upCell) {
            if (gridsLogger.isDebugLogEnabled()) {
              gridsLogger.logDebug(LoggerManager.resolve(978),gridKey,i);
            }
            upCell.setNextFormattedValue(preformatValue(updated[i]));
          });
        }
      },
      
      /**
       * Sort comparison method
       * @protected
       * @ignore
       */
      isBefore: function(val1, val2) { 
        
        if (val1 == null || val2 == null) {
          if (val1 != val2) {
            //only one value is null
            if (val1 == null) {
              //consider null smaller than anything else
              return !this.descendingSort;
            } else {
              return this.descendingSort;
            }
          }
        }
        
        if (this.descendingSort) {
          return val1 > val2;
        } else {
          return val1 < val2;
        }
      },
      
      
      /**
       * Setter method that enables or disables the interpretation of the
       * values in the model as HTML code. 
       * For instance, if the value "&lt;a href='news03.htm'&gt;Click here&lt;/a&gt;"
       * is placed in the internal model (either by manual call of the 
       * {@link AbstractWidget#updateRow} method or by listening on a 
       * {@link SubscriptionListener#onItemUpdate} event)   
       * and HTML interpretation is enabled, then the target cell
       * will contain a link; otherwise it will contain that bare text.
       * Note that the setting applies to all the cells in the associated grid.
       * Anyway if it's not the content of a cell that is going to be updated,
       * but one of its properties, then this setting is irrelevant for such cell.
       * <BR>WARNING: When turning HTML interpretation on, make sure that
       * no malicious code may reach the internal model (for example 
       * through the injection of undesired JavaScript code from the Data Adapter).
       *
       * <p class="default-value"><b>Default value:</b> false.</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> this setting can be changed at any time.
       * <BR>Note that values that have already been placed in the grid cells will not
       * be updated to reflect the new setting.</p>
       * 
       * @throws {IllegalStateException} if parseHtml has not been executed yet.
       * @throws {IllegalArgumentException} if the given value is not a valid
       * boolean value. 
       *
       * @param {boolean} enable true/false to enable/disable HTML interpretation
       * for the pushed values.
       */
      setHtmlInterpretationEnabled: function(enable) { 
        this.useInner = this.checkBool(enable);
      },
      
      /**
       * Inquiry method that gets the type of interpretation to be applied for
       * the pushed values for this grid. In fact, the values can be
       * put in the target cells as HTML code or as text.
       *
       * @return {boolean} true if pushed values are interpreted as HTML code, false
       * otherwise.
       *
       * @see AbstractGrid#setHtmlInterpretationEnabled
       */
      isHtmlInterpretationEnabled: function() {
        return this.useInner;
      },
      
      /**
       * Setter method that specifies a list of HTML element types to be searched for 
       * during the mapping of the grid to the HTML made by {@link AbstractGrid#parseHtml}.
       *
       * <p class="default-value"><b>Default value:</b> an array containing DIV SPAN and INPUT.</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Node types can be specified at any time.
       * However, if the list is changed after the execution of the {@link AbstractGrid#parseHtml}
       * method then it will not be used until a new call to such method is performed.
       * </p>
       *
       * @param {String[]} nodeTypes an array of Strings representing the names of the node 
       * types to be searched for. If the array contains an asterisk (*) then all the 
       * node types will be checked.
       * 
       * @see AbstractGrid#parseHtml
       */
      setNodeTypes: function(nodeTypes) {
        if (nodeTypes && nodeTypes.length > 0) {
          this.tagsToCheck = nodeTypes;
        } else {
          throw new IllegalArgumentException(NO_TYPES);
        }
      },
      
      /**
       * Inquiry method that gets the list of node of types that would be searched
       * in case of a call to {@link AbstractGrid#parseHtml}.
       *
       * @return {String[]} a list of node type names.
       *
       * @see AbstractGrid#setNodeTypes
       */
      getNodeTypes: function() {
        return this.tagsToCheck;
      },
      
      /**
       * Setter method that decides whenever new rows entering the model will be
       * placed at the top of the grid or at the bottom.
       * <BR>Note that if the sort is enabled on the Grid through {@link AbstractGrid#setSort}
       * then this setting is ignored as new rows will be placed on their right
       * position based on the sort configuration.
       * <BR>Also note that the sort/add policy may be ignored depending on the grid
       * configuration; see the use of the "data-item" cell attribute in {@link StaticGrid}.
       * 
       * <p class="default-value"><b>Default value:</b> false.</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> this setting can be changed at any time.
       * <BR>Note anyway that changing this setting while the internal model
       * is not empty may result in a incosistent view.</p>
       *
       * @throws {IllegalArgumentException} if the given value is not a valid
       * boolean value. 
       *
       * @param {boolean} isAddOnTop true/false to place new rows entering the model
       * as the first/last row of the grid.
       */
      setAddOnTop: function(isAddOnTop) {
        if (this.sortField != null) {
          gridsLogger.logWarn(LoggerManager.resolve(979));
        }
        
        this.addOnTop = this.checkBool(isAddOnTop);
      },
      
      /**
       * Inquiry method that gets true/false depending on how new rows 
       * entering the grid are treated. If true is returned, new rows will be placed on top of
       * the grid. Viceversa, if false is returned, new rows are placed at the 
       * bottom.
       *
       * @return {boolean} true if new rows are added on top, false otherwise.
       *
       * @see AbstractGrid#setAddOnTop
       */
      isAddOnTop: function() {
        return this.addOnTop;
      },
    
      /**
       * Setter method that configures the sort policy of the grid. If no
       * sorting policy is set, new rows are always added according with the 
       * {@link AbstractGrid#setAddOnTop} setting.
       * If, on the other hand, sorting is enabled, then new
       * rows are positioned according to the sort criteria.
       * Sorting is also maintained upon update of an existing row; this may cause the row to be 
       * repositioned.
       * <BR>If asynchronous row repositioning is undesired, it is possible to 
       * set the sort and immediately disable it with two consecutive calls
       * to just enforce grid sorting based on the current contents.
       * <BR>The sort can also be performed on fields that are part of the model 
       * but not part of the grid view.
       * <BR>Note that the sort/add policy may be ignored depending on the grid
       * configuration; see the use of the "data-item" cell attribute in {@link StaticGrid}.
       *
       * <p class="default-value"><b>Default value:</b> no sort is performed.</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> The sort configuration can be set and changed
       * at any time.</p>
       * 
       * @throws {IllegalArgumentException} if one of the boolean parameters is neither
       * missing, null, nor a valid boolean value.
       * 
       * @param {String} sortField The name of the field to be used as sort field, 
       * or null to disable sorting.
       * @param {boolean} [descendingSort=false] true or false to perform descending or
       * ascending sort. This parameter is optional; if missing or null,
       * then ascending sort is performed.
       * @param {boolean} [numericSort=false] true or false to perform numeric or
       * alphabetical sort. This parameter is optional; if missing or null, then
       * alphabetical sort is performed.
       * @param {boolean} [commaAsDecimalSeparator=false] true to specify that sort
       * field values are decimal numbers in which the decimal separator is
       * a comma; false to specify it is a dot. This setting is used only if
       * numericSort is true, in which case it is optional, with false as its
       * default value.
       */
      setSort: function(sortField, descendingSort, numericSort, commaAsDecimalSeparator) {
        if (!sortField) { 
          this.sortField = null;
          return;
        }
        
        this.sortField = sortField;
        this.descendingSort = this.checkBool(descendingSort,true);
        this.numericSort = this.checkBool(numericSort,true);
        this.commaAsDecimalSeparator = this.checkBool(commaAsDecimalSeparator,true);
           
        this.sortTable();
      },
      
      /**
       * Inquiry method that gets the name of the field currently used as sort
       * field, if available.
       * 
       * @return {Number} The name of a field, or null if sorting is not currently
       * enabled.
       *
       * @see AbstractGrid#setSort
       */    
      getSortField: function() {
        return this.sortField;
      },
      
      /**
       * Inquiry method that gets the sort direction currently configured.
       *
       * @return {boolean} true if descending sort is being performed, false if ascending
       * sort is, or null if sorting is not currently enabled.
       *
       * @see AbstractGrid#setSort
       */    
      isDescendingSort: function() {
        return this.sortField === null ? null : this.descendingSort;
      },
      
      /**
       * Inquiry method that gets the type of sort currently configured.
       *
       * @return {boolean} true if numeric sort is being performed, false if alphabetical
       * sort is, or null if sorting is not currently enabled.
       *
       * @see AbstractGrid#setSort
       */     
      isNumericSort: function() {
        return this.sortField === null ? null : this.numericSort;
      },
      
      /**
       * Inquiry method that gets the type of interpretation to be used to
       * parse the sort field values in order to perform numeric sort.
       *
       * @return {boolean} true if comma is the decimal separator, false if it is a dot;
       * returns null if sorting is not currently enabled or numeric sorting
       * is not currently configured.
       *
       * @see AbstractGrid#setSort
       */    
      isCommaAsDecimalSeparator: function() {
        return this.sortField === null  || !this.numericSort ? null : this.commaAsDecimalSeparator;
      },
      
      /**
       * Creates an array containing all the unique values of the "data-field" 
       * properties in all of the HTML elements associated to this grid during the 
       * {@link AbstractGrid#parseHtml} execution. The result of this method is supposed to be
       * used as "Field List" of a Subscription.
       * <BR>Execution of this method is pointless if HTML elements associated to this
       * grid specify a field position instead of a field name in their "data-field"
       * property.
       * <BR>Note that elements specifying the "data-fieldtype" property set to "extra" or "second-level", 
       * will be ignored by this method. This permits to distinguish fields that are part
       * of the main subscription (not specifying any "data-fieldtype" or specifying "first-level"), part of a 
       * second-level Subscription (specifying "second-level") and not part of a Subscription at all, 
       * but still manageable in a direct way (specifying "extra"). 
       * 
       * @return {String[]} The list of unique values found in the "data-field" properties
       * of HTML element of this grid.
       * 
       * @see Subscription#setFields
       */
      extractFieldList: function() {
        return this.extractTypedFieldList(Cell.FIRST_LEVEL);
      },
      
      /**
       * Creates an array containing all the unique values, of the "data-field" properties
       * in all of the HTML elements, having the "data-fieldtype" property set to "second-level",
       * associated to this grid during the {@link AbstractGrid#parseHtml} execution.
       * <BR>The result of this method is supposed to be 
       * used as "Field List" of a second-level Subscription.
       * <BR>Execution of this method is pointless if HTML elements associated to this
       * grid specify a field position instead of a field name in their "data-field"
       * property.
       * 
       * @return {String[]} The list of unique values found in the "data-field" properties
       * of HTML element of this grid.
       *
       * @see AbstractGrid#extractFieldList
       * @see Subscription#setCommandSecondLevelFields
       */
      extractCommandSecondLevelFieldList: function() {
        return this.extractTypedFieldList(Cell.SECOND_LEVEL);
      },
      
      /**
       * Operation method that is used to authorize and execute the binding of the 
       * widget with the HTML of the page.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> This method can only be called once the HTML structure
       * the instance is expecting to find are ready in the DOM.
       * That said, it can be invoked at any time and subsequent invocations will update
       * the binding to the current state of the page DOM. Anyway, newly found cells
       * will be left empty until the next update involving them.</p>
       * 
       * @see Chart
       * @see DynaGrid
       * @see StaticGrid
       */
      parseHtml: function() {
        
      },
      
      /**
       * Operation method that is used to force the choice of what to use
       * as key for the integration in the internal model, when receiving
       * an update from a Subscription this grid is listening to. 
       * <BR>Specifying "ITEM_IS_KEY" tells the widget to use the item as key;
       * this is the behavior that is already the default one when the Subscription
       * is in "MERGE" or "RAW" mode (see {@link AbstractWidget} for details).
       * <BR>Specifying "UPDATE_IS_KEY" tells the widget to use a progressive number
       * as key; this is the behavior that is already the default one when the
       * Subscription is in "DISTINCT" mode (see {@link AbstractWidget} for details).
       * <BR>Note that when listening to different Subscriptions the default behavior 
       * is set when the grid is added as listener for the first one and then applied 
       * to all the others regardless of their mode. 
       * 
       * <p class="lifecycle"><b>Lifecycle:</b>this method can only be called
       * while the internal model is empty.</p>
       * 
       * @throws {IllegalArgumentException} if the given value is not valid.
       * @throws {IllegalStateException} if called while the grid is not empty.
       * 
       * @param {String} interpretation either "ITEM_IS_KEY" or "UPDATE_IS_KEY",
       * or null to restore the default behavior.
       */
      forceSubscriptionInterpretation: function(interpretation) {
        if (this.rowCount > 0) {
          throw new IllegalStateException(NON_EMPTY_ERROR);
        }
        if (!interpretation) {
          this.forcedInterpretation = false;
          this.chooseInterpretation();
          
        } else {
          if (interpretation != AbstractWidget.UPDATE_IS_KEY && interpretation != AbstractWidget.ITEM_IS_KEY) {
            throw new IllegalArgumentException(WRONG_INTERPRETATION);
          }
          
          this.kind = interpretation;
          this.forcedInterpretation = true;
        }
      },
      
      /**
       * @private
       */
      extractTypedFieldList: function(type) {
        var fieldSymbolsSet = this.computeFieldSymbolsSet(type);
        
        var incrementalSchema = [];
        
        for (var fieldSymbol in fieldSymbolsSet) {
          incrementalSchema.push(fieldSymbol);
        }
        
        return incrementalSchema; 
      },
      
      /**
       * @protected
       * @ignore
       */
      makeSortValue: function(val) {
        if (this.numericSort) {
          return Helpers.getNumber(val, this.commaAsDecimalSeparator);
        } else if (val === null) {
          return val;
        } else {
          return (new String(val)).toUpperCase();
        }
      },
      
      /**
       * @protected
       * @ignore
       */
      visualUpdateExecution: function(key,vUpdateInfo,updateKey) {
        
        updateKey = updateKey || key;
        
        var cold2HotTime = vUpdateInfo.coldToHotTime;
        var toColdFadeTime = cold2HotTime + vUpdateInfo.hotTime;
        var hot2ColdTime = toColdFadeTime + vUpdateInfo.hotToColdTime;
        var hotRowStyle = vUpdateInfo.hotRowStyle;
        var coldRowStyle = vUpdateInfo.coldRowStyle;
        
        var cold2HotCall = [];
         
        //let's pass cell by cell
        var entireRow = this.grid.getRow(key); 
        
        for (var col in entireRow) {
          
          var noNumIndex = -1;
          var mayCell = entireRow[col];
          for (var i=0; mayCell && (mayCell.isCell || i<mayCell.length); i++) {
            var cell = mayCell.isCell ? mayCell : mayCell[i];
            mayCell = mayCell.isCell ? null : mayCell;
            
            if (cell.getNum() === null) {
              noNumIndex++;
            }
            
            var slidingCell = this.getSlidingCell ? this.getSlidingCell(cell,updateKey,col,cell.getNum(),noNumIndex) : cell;
            
            var pfVal = cell.getNextFormattedValue();
            //what if the value is not yet on the cell but then we set a null?
            if(pfVal == null) {
              //we don't have to update this cell
              continue;
            }

            var phaseNum = cell.setUpdating(); //updateCount++; updating = true;

            var coldCellStyle = cell.getNextColdArray(coldRowStyle);
            var hotCellStyle = cell.getNextHotArray(hotRowStyle);
            
            if (hotCellStyle) { //if hotCellStyle is not null coldCellStyle cannot be null
              var go = false;
              var c2h = false;
              var h2c = false;
              var bgHot = null; 
              var bgCold = null; 
              var colHot = null; 
              var colCold = null; 
               
              //there are cell-bound styles: overwrite row-bound styles
              if (hotCellStyle) {
                if (hotCellStyle[BG_ATTR]) {
                  go = true;
                  bgHot = hotCellStyle[BG_ATTR];
                  bgCold = coldCellStyle[BG_ATTR];
                }
                if (hotCellStyle[COLOR_ATTR]) {
                  go = true;
                  colHot = hotCellStyle[COLOR_ATTR];
                  colCold = coldCellStyle[COLOR_ATTR];
                }
              }
              
              if (go) { //I have to do fading
                
                if (cold2HotTime > 0) {
                  var updateCellCommand = Executor.packTask(slidingCell.asynchUpdateValue,slidingCell,[phaseNum,this.useInner]);
                  var fadeId = this.fader.getNewFaderId(slidingCell, false, bgHot, colHot, cold2HotTime, updateCellCommand);
                  this.fader.launchFader(fadeId);
                  c2h = true;
                } else {   
                  this.fader.stopFader(slidingCell); //stop active fading if any
                   
                }     
              
                 
                if (vUpdateInfo.hotToColdTime > 0) {
                  var applyStyleCommand = Executor.packTask(slidingCell.asynchUpdateStyles,slidingCell,[phaseNum,Cell.COLD]);
                
                  var fadeId = this.fader.getNewFaderId(slidingCell, true, bgCold, colCold, vUpdateInfo.hotToColdTime, applyStyleCommand);
                  Executor.addTimedTask(this.fader.launchFader,toColdFadeTime,this.fader,[fadeId]);
                  
                  h2c = true;
                }
              }
              
              if (!c2h) {
                
                //cell update call 
                
                if (cold2HotTime > 0) {
                  Executor.addTimedTask(slidingCell.asynchUpdateValue,cold2HotTime,slidingCell,[phaseNum,this.useInner]); 
                } else {
                  var updateTask = Executor.packTask(slidingCell.asynchUpdateValue,slidingCell,[phaseNum,this.useInner]);
                  cold2HotCall.push(updateTask);
                }
              }  
              
              if (!h2c) {
                //final cold state call
                Executor.addTimedTask(slidingCell.asynchUpdateStyles,hot2ColdTime,slidingCell,[phaseNum,Cell.COLD]);
              }
              
              
            } else { //no styles to apply
              
              if (cold2HotTime > 0) {
                //Executor.addTimedTask(this.asynchUpdateCell,cold2HotTime,this,[updateKey,col,phaseNum]);
                Executor.addTimedTask(slidingCell.asynchUpdateValue,cold2HotTime,slidingCell,[phaseNum,this.useInner]);
              } else {
                //var updateTask = Executor.packTask(this.asynchUpdateCell,this,[updateKey,col,phaseNum]);
                var updateTask = Executor.packTask(slidingCell.asynchUpdateValue,slidingCell,[phaseNum,this.useInner]);
                cold2HotCall.push(updateTask);
              }
              
              if (coldCellStyle) {
                   //final cold state call
                   if (vUpdateInfo.hotToColdTime > 0) {
                     bgCold = coldCellStyle[BG_ATTR];
                     colCold = coldCellStyle[COLOR_ATTR];
                     
                     var applyStyleCommand = Executor.packTask(slidingCell.asynchUpdateStyles,slidingCell,[phaseNum,Cell.COLD]);
                
                     var fadeId = this.fader.getNewFaderId(slidingCell, true, bgCold, colCold, vUpdateInfo.hotToColdTime, applyStyleCommand);
                     Executor.addTimedTask(this.fader.launchFader,toColdFadeTime,this.fader,[fadeId]);
                   } else {
                     Executor.addTimedTask(slidingCell.asynchUpdateStyles,hot2ColdTime,slidingCell,[phaseNum,Cell.COLD]);
                   }
                }
              
            }   
            
          }
        }  
        
        for (var t=0; t<cold2HotCall.length; t++) {
          Executor.executeTask(cold2HotCall[t]);
        }
        
      },
      
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      updateRowExecution: function(key,serverValues) {},
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      removeRowExecution: function(key) {},
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      sortTable: function() {},   
      /** 
       * abstract method
       * @protected
       * @ignore
       */ 
      computeFieldSymbolsSet: function(type){}
      
  };
  
  //closure compiler exports
  AbstractGrid.prototype["setHtmlInterpretationEnabled"] = AbstractGrid.prototype.setHtmlInterpretationEnabled;
  AbstractGrid.prototype["isHtmlInterpretationEnabled"] = AbstractGrid.prototype.isHtmlInterpretationEnabled;
  AbstractGrid.prototype["setNodeTypes"] = AbstractGrid.prototype.setNodeTypes;
  AbstractGrid.prototype["getNodeTypes"] = AbstractGrid.prototype.getNodeTypes;
  AbstractGrid.prototype["setAddOnTop"] = AbstractGrid.prototype.setAddOnTop;
  AbstractGrid.prototype["isAddOnTop"] = AbstractGrid.prototype.isAddOnTop;
  AbstractGrid.prototype["setSort"] = AbstractGrid.prototype.setSort;
  AbstractGrid.prototype["getSortField"] = AbstractGrid.prototype.getSortField;
  AbstractGrid.prototype["isDescendingSort"] = AbstractGrid.prototype.isDescendingSort;
  AbstractGrid.prototype["isNumericSort"] = AbstractGrid.prototype.isNumericSort;
  AbstractGrid.prototype["isCommaAsDecimalSeparator"] = AbstractGrid.prototype.isCommaAsDecimalSeparator;
  AbstractGrid.prototype["extractFieldList"] = AbstractGrid.prototype.extractFieldList;
  AbstractGrid.prototype["extractCommandSecondLevelFieldList"] = AbstractGrid.prototype.extractCommandSecondLevelFieldList;
  AbstractGrid.prototype["parseHtml"] = AbstractGrid.prototype.parseHtml;
  AbstractGrid.prototype["forceSubscriptionInterpretation"] = AbstractGrid.prototype.forceSubscriptionInterpretation;
  AbstractGrid.prototype["updateRowExecution"] = AbstractGrid.prototype.updateRowExecution;
  AbstractGrid.prototype["removeRowExecution"] = AbstractGrid.prototype.removeRowExecution;
  
  Inheritance(AbstractGrid,AbstractWidget);
  return AbstractGrid;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var AbstractParent = /*@__PURE__*/(function() {  
  /**
   * @private
   */
  var AbstractParent = function(){};
  
  /**
   * @private
   */
  AbstractParent.prototype = {
    /**
     * common ancestor for VisibleParent (oneMap = true) and 
     * invisibleParent (oneMap = false)
     */
    init: function() {
      this.length = 0;
      this.hashMap = {};
      if (!this.oneMap) {
        this.map = {};
      }
    }    
  };
  
  return AbstractParent;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var VisibleParent = /*@__PURE__*/(function() {
  /**
   * @private
   */
  var VisibleParent = function(node, firstNotLSBrother, offset) {
    this._callSuperConstructor(VisibleParent);
   
    this.domNode = node;
    this.toInsBefore = firstNotLSBrother;
    this.offsetIndex = offset;
    this.oneMap = true;
    
    this.topChild = this.toInsBefore;
    
    this.init();
   
  };
  
  /**
   * @private
   */
  VisibleParent.prototype = {
   
    /*public*/ removeChild: function(node) {
      if (this.length <= 0) {
        return;
      }
      //one less child
      this.length--;
      //remove from hashmap
      delete(this.hashMap[node.getId()]);
      //remove from DOM
      var el = node.element();
      if (el == this.topChild) {
        this.topChild = el.nextSibling; 
      }
      this.domNode.removeChild(el);
      node.setParentNode(null);
    },
    
    /*public*/ insertBefore: function(newNode, node) {
      if (node == newNode) {
        //insertBefore itself. Nothing to do
        return;
      }
      if (!newNode) {
        //handle the insertion
        return;
      }
      if (!node) {
        //insertBefore nothing, consider it as an appendChild
        this.appendChild(newNode,true);
        return;
      }
      if (this.hashMap[node.getId()] == null) {
        //insertBefore a non-existent node,  consider it as an appendChild
        this.appendChild(newNode,true);
        return;
      }
      //internally handle the insertion
      this.insertOperation(newNode);
      //put it in the DOM
      this.domNode.insertBefore(newNode.element(), node.element());
    },
    
    /*public*/ appendChild: function(node, appendOnBottom) {
      if (!node) {
        //nothing to insert, nothing to do
        return;
      }
      //handle the insertion
      this.insertOperation(node);
      
      //extract the element
      var el = node.element();
      if (appendOnBottom) {
        
        if (!this.topChild) {
          this.topChild = el;
        }
        
        //place it on the DOM
        if (!this.toInsBefore) {
          //as the latest son
          this.domNode.appendChild(el);
        } else {
          //as the latest son excluding elements not handled by this class
          this.domNode.insertBefore(el,this.toInsBefore);
        }
      } else {
        //put it on top
        this.domNode.insertBefore(el,this.topChild);
        this.topChild = el;
      }
      
    },
    
    /*private*/ insertOperation: function(node) {
      if (node.isSonOf(this)) {
        //the node is already handled by this instance
        return;
      }
      //increase the counter
      this.length++;
      //save it on the hashmap
      this.hashMap[node.getId()] = node;
      //if son of someone else get rid of the connection between them
      node.isolation();
      //adopt it
      node.setParentNode(this);
    },
    
    /*public*/ getChild: function(index) {
      if (this.length <= index) {
        return null;
      }
      //get a son by index
      index += this.offsetIndex;
      //get its id to find it in the hashmap
      var mapping = this.domNode.childNodes[index].getAttribute("id");
      //get it
      return this.getElementById(mapping);
    },
    
    /*public*/ getElementById: function(id) {
      //get the element from the hashmap
      return this.hashMap[id];
    },
    
    /*public*/ clean: function() {
      if (this.domNode) {
        delete(this.domNode);
      }
      if(this.toInsBefore) {
        delete(this.toInsBefore);
      }
      for (var i in this.hashMap) {
        this.hashMap[i].clean();
      }
    }
    
  };
  
  Inheritance(VisibleParent,AbstractParent);
  return VisibleParent;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var InvisibleParent = /*@__PURE__*/(function() {
  /**
   * @private
   */
  var InvisibleParent = function() {
    this._callSuperConstructor(InvisibleParent);
    
    this.oneMap = false;
    
    this.init();
  };
  
  /**
   * @private
   */
  InvisibleParent.prototype = {
    
    /*public*/ removeChild: function(node) {
      if (this.length <= 0) {
        return;
      }
      this.length--;
      //move brothers below the removing-child
      var index = this.hashMap[node.getId()];
      var pi;
      for (pi = index; pi < this.length; pi++) {
        this.map[pi] = this.map[pi+1];
        this.hashMap[this.map[pi].getId()] = pi;
      }
      //remove references
      this.hashMap[node.getId()] = null;
      this.map[this.length] = null;
      
      node.setParentNode(null);
    },
    
    /*public*/ insertBefore: function(newNode, node) {
      if (node == newNode) {
        return;
      }
      if (!newNode) {
        return;
      }
      if (!node) {
        this.appendChild(newNode,true);
        return;
      }
      if (this.hashMap[node.getId()] == null) {
        this.appendChild(newNode,true);
        return;
      }
      //get rid of the previous parent 
      newNode.isolation();
     
      var newIndex = this.hashMap[node.getId()];
      //scroll-down following brothers
      for (var pi = this.length; pi >= newIndex + 1; pi--) {
        this.map[pi] = this.map[pi-1];
        this.hashMap[this.map[pi].getId()] = pi;
      }
      this.insertOperation(newNode, newIndex);
    },
    
    /*public*/ appendChild: function(node,appendOnBottom) {
      if (!node) {
        return;
      }
      //get rid of the previous parent 
      node.isolation();
      
      if (appendOnBottom || this.length == 0) {
        this.insertOperation(node, this.length);
      } else {
        this.insertBefore(node, this.map[0]);
      }
      
    },
    
    /*private*/ insertOperation: function(node, index) {
      this.length++;
      this.hashMap[node.getId()] = index;
      this.map[index] = node;
      node.setParentNode(this);
      node.invisible();
    },
    
    /*public*/ getChild: function(index) {
      return this.map[index];
    },
    
    /*public*/ getElementById: function(id) {
      return this.map[this.hashMap[id]];
    },
    
    /*public*/ clean: function() {
      for (var i=0; i<this.length; i++) {
        this.map[i].clean();
      }
    }
    
  };
  
  Inheritance(InvisibleParent,AbstractParent);
  return InvisibleParent;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var DynaElement = /*@__PURE__*/(function() {
  /**
   * @private
   */
  var DynaElement = function(uniqueKey,ownerTable) {
    this.key = uniqueKey;
    /*DynaGrid*/ this.ownerTable = ownerTable;
    this.myParent = null;
    this.node = null;
    this.id = "hc6|"+ownerTable.getId()+"|"+uniqueKey;  
  };
  
  DynaElement.prototype = {
    /*public*/ invisible: function() {
      if (this.node == null) {
        return;
      }
    },
    
    /*public*/ getParentNode: function() {
      return this.myParent;
    },
    
    /*public*/ setParentNode: function(newParent) {
      this.myParent = newParent;
    },
    
    /*public*/ isolation: function() {
      if (this.myParent) {
        this.myParent.removeChild(this);
      }
    },
    
    /*public*/ isSonOf: function(parent) {
      return this.myParent == parent;
    },
    
    /*public*/ getKey: function() {
      return this.key;
    },
    
    /*public*/ getId: function() {
      return this.id;
    },
    
    /*public*/ element: function() {
      if (this.node != null) {
        return this.node;
      } //else
        
      //clone template
      this.node = this.ownerTable.getTemplateClone();
      
      this.node.setAttribute("id",this.id); 
      
      //get "important" elements from the clone 
      var lsTags = Cell.getLSTags(this.node,this.ownerTable.getNodeTypes());             
      for (var pi = 0; pi < lsTags.length; pi++) {
        var currCell = lsTags[pi];
        var currFieldSymbol = currCell.getField();  
        if (!currFieldSymbol) {
          //no field specified
          continue;
        }
        
        this.ownerTable.onNewCell(currCell,this.key,currFieldSymbol);
      }
      
      return this.node;
    },
    
    /*public*/ clean: function() {
      if (this.node) {
        delete(this.node);
      }
    }
    
  };
  
  return DynaElement;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var VisualUpdate = /*@__PURE__*/(function() {
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.grids");
  
  var NO_CELL = "No cell defined for this field";
  
  var DEFAULT_HOT_TIME = 1200;
  
  /**
   * Used by Lightstreamer to provide a value object to each call of the
   * {@link StaticGridListener#onVisualUpdate} and 
   * {@link DynaGridListener#onVisualUpdate} events. This constructor
   * is not supposed to be used by custom code.
   * @constructor
   *
   * @exports VisualUpdate
   * @class Contains all the information related to a row update that is about
   * to be displayed on a grid. This may happen because of a call to the
   * {@link AbstractWidget#updateRow} method, or, in case
   * an AbstractGrid is used to listen to a {@link Subscription}, because of
   * an update received from Lightstreamer Server.
   * <BR> Specifically, for each row it supplies:
   * <ul>
   * <li>The current values for the row fields in the grid and in the
   * underlying model and a method to modify the value in the gris cells
   * before updating them on the DOM.</li>
   * <li>Methods to set the stylesheets to be applied to the HTML cells.</li>
   * <li>Methods to configure the visual effect to be applied to the HTML
   * cells in order to emphasize the changes in the cell values.</li>
   * </ul>
   * The provided visual effect consists of the following sequence:
   * <ul>
   * <li>A change in the cell colors, with a fading behaviour, to temporary
   * "hot" colors.</li>
   * <li>The change of the values to the new values and the change of the
   * stylesheets to the full "hot" stylesheet; after the change, the cell
   * stays in this "hot" phase for a while.</li>
   * <li>A change in the cell colors, with a fading behaviour, to the final
   * "cold" colors.</li>
   * <li>The change of the stylesheets to the full "cold" stylesheets.</li>
   * </ul>
   * <BR/>The class constructor, its prototype and any other properties should never
   * be used directly.
   *    
   * @see StaticGridListener#onVisualUpdate
   * @see DynaGridListener#onVisualUpdate
   */
  var VisualUpdate = function() {
    
    //TODO we didn't want the parameters to appear in the docs,
    //what about now?
    this.cellsGrid = arguments[0];
    this.updatingRow = arguments[1];
    this.key = arguments[2];
    
    
    this.coldToHotTime = 0;
    this.hotToColdTime = 0;
    this.hotTime = DEFAULT_HOT_TIME;
    
    this.hotRowStyle = null;
    this.coldRowStyle = null;
    

  };
  
  VisualUpdate.prototype = {
    
    
    /**
     * Inquiry method that gets the value that is going to be shown in the grid 
     * in a specified cell or the current value if the value is not going to be 
     * changed.
     * <BR>Note that if the value is not changing then no effects or styles are
     * going to be applied on the cell itself. If the effect is desired even if
     * the value in the cell is unchanged, then a call to {@link VisualUpdate#setCellValue} can
     * be performed using the value from this getter.
     * <BR>In order to inquiry the values for the row cells on the underlying
     * model, the {@link VisualUpdate#getChangedFieldValue} method is available.
     * 
     * @throws {IllegalArgumentException} if no cells were associated with
     * the specified field.
     * 
     * @param {String} field The field name associated with one of the cells in the
     * grid (the "data-field" attribute).  
     * @param {String} [replicaId] A custom identifier that can be used in case two
     * or more cells were defined for the same field (the "data-replica" attribute).
     * If more cells have been defined but this parameter is not specified, then a random
     * cell will be selected.
     *    
     * @return {String} A text or null; if the value for the specified field has never been
     * assigned in the model, the method also returns null.
     *
     * @see VisualUpdate#setCellValue
     * @see VisualUpdate#getChangedFieldValue
     */
    getCellValue: function(field,replicaId) { 
      var cell = this.cellsGrid.getCell(this.key,field,replicaId);
      if (!cell) {
        throw new IllegalArgumentException(NO_CELL);
      }
     
      if (!cell.isCell) {
        //multiple cells for field and replicaID not specified
        cell = cell[0];
      }
      
      return cell.getNextFormattedValue() || cell.retrieveValue();
    },
    
    /**
     * Setter method that assigns the value to be shown in a specified cell of 
     * the grid.
     * The specified value is the text that will be actually written in the cell
     * (for instance, it may be a formatted version of the original value),
     * unless it is null, in which case the value currently shown will be kept.
     * The latter may still be the initial cell value (or the cell value
     * specified on the template) if no formatted value hasn't been supplied
     * for the field yet.
     * <BR>Note that this method does not update the internal model of the AbstractGrid
     * so that if a value is set through this method it can't be used 
     * for features working on such model (e.g. it can't be used to sort the grid).
     * If a change to the model is required use the {@link AbstractWidget#updateRow} method.
     * 
     * @throws {IllegalArgumentException} if no cells were associated with
     * the specified field.
     *
     * @param {String} field The field name associated with one of the cells in the
     * grid (the "data-field" attribute).  
     * @param {String} value the value to be written in the cell, or null.
     * @param {String} [replicaId] A custom identifier that can be used in case two
     * or more cells were defined for the same field (the "data-replica" attribute).
     * If more cells were defined but this parameter is not specified, then a random
     * cell will be selected.
     */
    setCellValue: function(field, value, replicaId) { 
      var cell = this.cellsGrid.getCell(this.key,field,replicaId);
      if (!cell) {
        throw new IllegalArgumentException(NO_CELL);
      }
      if (cell.isCell) {
        cell.setNextFormattedValue(value);
      } else for (var i=0; i<cell.length; i++) {
        cell[i].setNextFormattedValue(value);
      }
    },
    
    
    /**
     * Inquiry method that gets the value that is going to update the underlying
     * model of the grid for the associated field. It can be null if no change 
     * for the specified field is going to be applied.
     * 
     * @param {String} field The name of a field from the model.    
     *
     * @return {String} The new value of the specified field (possibly null), or null
     * if the field is not changing.
     * If the value for the specified field has never been
     * assigned in the model, the method also returns null.
     */
    getChangedFieldValue: function(field) {
      return this.updatingRow[field] || null;
    },
        
    /**
     * Setter method that configures the length of the "hot" phase for the
     * current row. The "hot" phase is one of the phases of the visual effect
     * supplied by Lightstreamer to emphasize the change of the row values.
     * <br/>By default 1200 ms is set.
     *
     * @param {Number} val Duration in milliseconds of the "hot" phase.
     */
    setHotTime: function(val) { 
      this.hotTime = this.checkPositiveNumber(val, true);  
    },
  
    /**
     * Setter method that configures the length of the color fading phase
     * before the "hot" phase. This fading phase is one of the phases of
     * the visual effect supplied by Lightstreamer to emphasize the change
     * of the row values. A 0 length means that the color switch to "hot"
     * colors should be instantaneous and should happen together with value
     * and stylesheet switch.
     * <BR>Warning: The fading effect, if enabled, may be computation
     * intensive for some client environments, when high-frequency updates
     * are involved.
     * <br/>By default 0 ms (no fading at all) is set.
     * 
     * @param {Number} val Duration in milliseconds of the fading phase before
     * the "hot" phase.
     */
    setColdToHotTime: function(val) { 
      this.coldToHotTime = this.checkPositiveNumber(val, true);
    },
  
    /**
     * Setter method that configures the length of the color fading phase
     * after the "hot" phase. This fading phase is one of the phases of
     * the visual effect supplied by Lightstreamer to emphasize the change
     * of the row values. A 0 length means that the color switch from "hot"
     * to final "cold" colors should be instantaneous and should happen
     * together with the stylesheet switch.
     * <BR>Warning: The fading effect, if enabled, may be very computation
     * intensive for some client environments, when high-frequency updates
     * are involved.
     * <br/>By default 0 ms (no fading at all) is set.
     *
     * @param {Number} val Duration in milliseconds of the fading phase after
     * the "hot" phase.
     */
    setHotToColdTime: function(val) {
      this.hotToColdTime = this.checkPositiveNumber(val, true);  
    },
    

    /**
     * @private
     */
    addStyle: function(field, hotValue, coldValue, _type, num) {
      
      var cell = this.cellsGrid.getCell(this.key,field,num);
      if (!cell) {
        throw new IllegalArgumentException(NO_CELL);
      }
      if (cell.isCell) {
        cell.addStyle(hotValue, coldValue, _type);
      } else for (var i=0; i<cell.length; i++) {
        cell[i].addStyle(hotValue, coldValue, _type);
      }
      
    },
    
    /**
     * @private
     */
    addRowStyle: function(hotValue, coldValue, _type) {
      if (!this.hotRowStyle) {
        this.hotRowStyle = {};
        this.coldRowStyle = {};
      }
      
      this.hotRowStyle[_type] = hotValue || "";
      this.coldRowStyle[_type] = coldValue || "";
    },
   
    
    /**
     * Setter method that configures the stylesheet changes to be applied
     * to all the HTML cells of the involved row, while changing the field values.
     * A temporary "hot" style can
     * be specified as different than the final "cold" style. This allows
     * Lightstreamer to perform a visual effect, in which a temporary "hot"
     * phase is visible. By using this method, stylesheet attributes can be
     * specified one at a time.
     * <BR>If nonzero fading times are specified, through
     * {@link VisualUpdate#setColdToHotTime} and/or {@link VisualUpdate#setHotToColdTime},
     * then the "color" and "backgroundColor" attributes, if set, will be
     * changed with a fading behaviour.
     * Note that if color attributes are not set and nonzero fading times are
     * specified in {@link VisualUpdate#setColdToHotTime} and/or {@link VisualUpdate#setHotToColdTime},
     * this will cause a delay of the "hot" and "cold" phase switches;
     * however, as fading times refer to the whole row, you may need to set
     * them as nonzero in order to allow fading on some specific fields only.
     * <BR>If a row stylesheet is set through the {@link VisualUpdate#setStyle} method,
     * then this method should be used only to set stylesheet properties
     * not set by the row stylesheet. This condition applies throughout the
     * whole lifecycle of the cell (i.e. manipulating the same style property 
     * through both methods, even at different times, does not guarantee
     * the result).
     * <br/>By default for each stylesheet attribute that is not
     * specified neither with this method nor with {@link VisualUpdate#setStyle}, the
     * current value is left unchanged.
     *
     * @param {String} hotValue the temporary "hot" value for the involved
     * attribute, or null if the attribute should not change while entering
     * "hot" phase; an empty string causes the current attribute value
     * to be cleared.
     * @param {String} coldValue the final "cold" value for the involved
     * attribute, or null if the attribute should not change while exiting
     * "hot" phase; an empty string causes the "hot" phase attribute value
     * to be cleared.
     * @param {String} attrName the name of an HTML stylesheet attribute.
     * The DOM attribute name should be used, not the CSS name (e.g.
     * "backgroundColor" is accepted, while "background-color" is not).
     * Note that if the "color" or "backgroundColor" attribute is being set,
     * then several color name conventions are supported by the underlying
     * DOM manipulation functions; however, in order to take advantage of the
     * color fading support, only the "#RRGGBB" syntax is fully supported.
     */
    setAttribute: function(hotValue, coldValue, attrName) { 
      this.addRowStyle(hotValue, coldValue, attrName);
    },
    
    /**
     * Setter method that configures the stylesheets to be applied to the
     * HTML cells of the involved row, while changing the field values.
     * A temporary "hot" style can
     * be specified as different than the final "cold" style. This allows
     * Lightstreamer to perform a visual effect, in which a temporary "hot"
     * phase is visible. By using this method, the names of existing
     * stylesheets are supplied.
     * <BR>Note that in order to specify cell colors that can change with
     * a fading behavior, the {@link VisualUpdate#setAttribute} method should be used instead,
     * as fading is not supported when colors are specified in the stylesheets
     * with this method. So, if nonzero fading times are specified in
     * {@link VisualUpdate#setColdToHotTime} and/or {@link VisualUpdate#setHotToColdTime},
     * this will just cause a delay of the "hot" and "cold" phase switches;
     * however, as fading times refer to the whole row, you may need to set
     * them as nonzero in order to allow fading on some specific fields only.
     * for each stylesheet attribute that is not
     * specified neither with this method nor with {@link VisualUpdate#setStyle}, the
     * current value is left unchanged.
     * <br/>By default no stylesheet is applied to the cell.
     *
     * @param {String} hotStyle the name of the temporary "hot" stylesheet,
     * or null if the cells style should not change while entering "hot" phase.
     * @param {String} coldStyle the name of the final "cold" stylesheet,
     * or null if the cells style should not change while exiting "hot" phase.
     */
    setStyle: function(hotStyle, coldStyle) {
      this.addRowStyle(hotStyle, coldStyle, "CLASS");
    },
    
    /**
     * Setter method that configures the stylesheet changes to be applied
     * to the HTML cell related with a specified field, while changing its
     * value.
     * The method can be used to override, for a specific field, the settings
     * made through {@link VisualUpdate#setAttribute}.
     * <BR>If a specific stylesheet is assigned to the field through the
     * {@link VisualUpdate#setStyle} or {@link VisualUpdate#setCellStyle} method,
     * then this method can be used only in order to set stylesheet properties
     * not set by the assigned specific stylesheet. This condition applies
     * throughout the whole lifecycle of the cell (i.e. it is discouraged
     * to manipulate the same style property through both methods,
     * even at different times).
     * <br/>By default  the settings possibly made by {@link VisualUpdate#setAttribute}
     * are used.</p>
     * 
     * @throws {IllegalArgumentException} if no cells were associated with
     * the specified field.
     *
     * @param {String} field The field name associated with one of the cells in the
     * grid (the "data-field" attribute).  
     * @param {String} hotValue the temporary "hot" value for the involved
     * attribute, or null if the attribute should not change while entering
     * "hot" phase; an empty string causes the current attribute value
     * to be cleared.
     * @param {String} coldValue the final "cold" value for the involved
     * attribute, or null if the attribute should not change while exiting
     * "hot" phase; an empty string causes the "hot" phase attribute value
     * to be cleared.
     * @param {String} attrName the name of an HTML stylesheet attribute.
     * The DOM attribute name should be used, not the CSS name (e.g.
     * "backgroundColor" is accepted, while "background-color" is not).
     * @param {String} [replicaId] A custom identifier that can be used in case two
     * or more cells were defined for the same field (the "data-replica" attribute).
     * If more cells were defined but this parameter is not specified, then a random
     * cell will be selected.
     * 
     * @see VisualUpdate#setAttribute
     */
    setCellAttribute: function(field, hotValue, coldValue, attrName, replicaId) {
      this.addStyle(field, hotValue, coldValue, attrName, replicaId);      
    },
    
    /**
     * Setter method that configures the stylesheet to be applied to the
     * HTML cell related with a specified field, while changing its value.
     * <BR>This method can be used to override, for a specific field, the settings
     * made through {@link VisualUpdate#setStyle}.
     * <br/>By default the stylesheet possibly set through {@link VisualUpdate#setStyle}
     * is used.</p>
     * 
     * @throws {IllegalArgumentException} if no cells were associated with
     * the specified field.
     *
     * @param {String} field The field name associated with one of the cells in the
     * grid (the "data-field" attribute).  
     * @param {String} hotStyle the name of the temporary "hot" stylesheet,
     * or null if the cell style should not change while entering "hot" phase
     * (regardless of the settings made through {@link VisualUpdate#setStyle} and
     * {@link VisualUpdate#setAttribute}).
     * @param {String} coldStyle the name of the final "cold" stylesheet,
     * or null if the cell style should not change while exiting "hot" phase
     * (regardless of the settings made through {@link VisualUpdate#setStyle} and
     * {@link VisualUpdate#setAttribute}).
     * @param {String} [replicaId] A custom identifier that can be used in case two
     * or more cells were defined for the same field (the "data-replica" attribute).
     * If more cells were defined but this parameter is not specified, then a random
     * cell will be selected.
     * 
     * @see VisualUpdate#setStyle
     */
    setCellStyle: function(field, hotStyle, coldStyle, replicaId) { 
      this.addStyle(field, hotStyle, coldStyle, "CLASS", replicaId);
    },
    
    /**
     * Receives an iterator function and invokes it once per each field 
     * of the underlying model changed with the current update.
     * <BR>Note that in case of an event generated by the creation of a new row
     * all the field will be iterated.
     * <BR>Note that the iterator is executed before this method returns.
     * <BR>Note that the iterator will iterate through all of the changed fields
     * including fields not having associated cells. Also, even if a field is 
     * associated with more cells it will be passed to the iterator only once.
     * 
     * @param {ChangedFieldCallback} iterator Function instance that will be called once per 
     * each field changed on the current update on the internal model.
     * 
     * @see VisualUpdate#getChangedFieldValue
     */
    forEachChangedField: function(iterator) {
      for (var i in this.updatingRow) {
        try {
          iterator(i,this.updatingRow[i]);
        } catch(_e) {
          gridsLogger.logError(LoggerManager.resolve(980),_e);
        }
      }
    }
    
  };
  
  //closure compiler exports
  VisualUpdate.prototype["getCellValue"] = VisualUpdate.prototype.getCellValue;
  VisualUpdate.prototype["setCellValue"] = VisualUpdate.prototype.setCellValue;
  VisualUpdate.prototype["getChangedFieldValue"] = VisualUpdate.prototype.getChangedFieldValue;
  VisualUpdate.prototype["setHotTime"] = VisualUpdate.prototype.setHotTime;
  VisualUpdate.prototype["setColdToHotTime"] = VisualUpdate.prototype.setColdToHotTime;
  VisualUpdate.prototype["setHotToColdTime"] = VisualUpdate.prototype.setHotToColdTime;
  VisualUpdate.prototype["setAttribute"] = VisualUpdate.prototype.setAttribute;
  VisualUpdate.prototype["setStyle"] = VisualUpdate.prototype.setStyle;
  VisualUpdate.prototype["setCellAttribute"] = VisualUpdate.prototype.setCellAttribute;
  VisualUpdate.prototype["setCellStyle"] = VisualUpdate.prototype.setCellStyle;
  VisualUpdate.prototype["forEachChangedField"] = VisualUpdate.prototype.forEachChangedField;
  
  Inheritance(VisualUpdate,Setter,true,true);
  return VisualUpdate;
})();
  
  /**
   * Callback for {@link VisualUpdate#forEachChangedField}
   * @callback ChangedFieldCallback
   * @param {String} field name of the involved changed field.
   * @param {String} value the new value for the field. See {@link VisualUpdate#getChangedFieldValue} for details.
   * Note that changes to the values made through {@link VisualUpdate#setCellValue} calls will not be reflected
   * by the iterator, as they don't affect the model.
   */

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var DynaGrid = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  var ELEMENT = "ELEMENT";
  var PAGE = "PAGE";
  var OFF = "OFF";
  
  var WRONG_SCROLL_TYPE = "The given value is not a valid scroll type. Admitted values are OFF, ELEMENT, PAGE";
  var NO_TEMPLATE = "No template defined";
  var NO_SOURCE = "The template defined for the grid does not define the 'data-source' attribute";
  var NO_CELLS = "No valid cells defined for grid";
  var NO_PAGINATION = "This grid is configured to no support pagination";
  var NO_PAGE_SWITCH = "Can't switch pages while 'no-page mode' is used";
  var NO_AUTOSCROLL_ELEMENT = "Please specify an element id in order to use ELEMENT autoscroll";

  
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.grids");   

  
  /**
   * Creates an object that extends {@link AbstractGrid} displaying its values
   * in a grid made of HTML elements. The grid rows are displayed into dynamically 
   * generated HTML rows. The object can be supplied to
   * {@link Subscription#addListener} and {@link Subscription#removeListener}
   * in order to display data from one or more Subscriptions.
   * @constructor
   * 
   * @param {String} id The HTML "id" attribute of the HTML element that represents the template from
   * which rows of the grid will be cloned. The template can be either a visible
   * or a hidden part of the page; anyway, it will become invisible
   * as soon as the {@link AbstractGrid#parseHtml} method is executed. 
   *
   * @param {boolean} autoParse If true the {@link AbstractGrid#parseHtml} method is executed
   * before the constructor execution is completed. If false the parseHtml method
   * has to be called later by custom code. It can be useful to set this flag
   * to false if, at the time of the DynaGrid instance creation, the HTML element
   * designated as template is not yet ready on the page.
   * 
   * @exports DynaGrid
   * @class An {@link AbstractGrid} implementation that can be used to display
   * the values from the internal model in a dynamically created grid.   
   * The HTML structure suitable for the visualization of the tabular model values is 
   * dynamically maintained by Lightstreamer, starting from an HTML hidden template 
   * row, containing cells. The template row can be provided as any HTML element 
   * owning the "data-source='Lightstreamer'" special attribute. 
   * <BR>The association between the DynaGrid and the HTML template is made during the
   * execution of the {@link AbstractGrid#parseHtml} method: it is expected that the element 
   * representing the template row, in addition to the special "data-source" 
   * custom attribute, has an HTML "ID" attribute containing a unique value that has to be 
   * passed to the constructor of this class. The template will be then searched for by 
   * "id" on the page DOM.
   * <BR>Once the association is made with the row template, the cells within it have
   * to be recognized: all the elements of the types specified in the 
   * {@link AbstractGrid#setNodeTypes} are scanned for the "data-source='Lightstreamer'" 
   * attribute that authorizes the library to track the HTML element as a cell
   * for the row. 
   * <BR>
   * <BR>The "data-field" attribute will then instruct the library about
   * what field of the internal model has to be associated with the cell.
   * <BR>It is possible to associate more cells with the same field.
   * An optional "data-replica" attribute can be specified in this case. If used it will permit to access
   * the single cells during {@link DynaGridListener#onVisualUpdate} executions.
   * <BR>
   * <BR>By default, the content of the HTML element designated as cell will be 
   * updated with the value from the internal model; in case the cell is an INPUT
   * or a TEXTAREA element, the "value" property will be updated instead.
   * It is possible to update any attribute of the HTML element or its CSS 
   * styles by specifying the "data-update" custom attribute. 
   * To target an attribute the attribute name has to be specified; it can be a 
   * standard property (e.g. "data-update='href'"), a custom "data-" attribute 
   * (e.g. "data-update='data-foo'") or even a custom attribute not respecting
   * the "data-" standard (e.g. "data-update='foo'").
   * To target CSS attributes the "data-update='style.attributeName'" form has to 
   * be used (e.g. "data-update='style.backgroundColor'"); note that the form
   * "data-update='style.background-color'" will not be recognized by some browsers.
   * <BR>WARNING: also events like "onclick" can be assigned; in such cases make 
   * sure that no malicious code may reach the internal model (for example 
   * through the injection of undesired JavaScript code from the Data Adapter).
   * <BR>For each update to the internal model, the involved row is determined and 
   * each value is displayed in the proper cell(s). If necessary, new rows are 
   * cloned from the hidden template and attached to the DOM, or existing rows are 
   * dropped. The position of new rows is determined by the {@link AbstractGrid#setAddOnTop}
   * or {@link AbstractGrid#setSort} settings. 
   * <BR>In fact, there is a 1:1 correspondence between rows in the underlying
   * model and rows in the grid; however, pagination is also supported, so that
   * only a subset of the grid can be made visible.
   * <BR>
   * <BR>Note that the template element can contain an arbitrary HTML structure
   * and should contain HTML cells to be used to display the row field values. 
   * However, it should not contain elements to which an HTML "id" attribute has been assigned,
   * because the elements will be cloned and the HTML specification prescribes 
   * that an id must be unique in the document. (The id of the template element, 
   * required by Lightstreamer, is not cloned).
   * <BR>More visualization actions can be performed through the provided  
   * {@link VisualUpdate} event objects received on the {@link DynaGridListener}. 
   * 
   * @extends AbstractGrid
   */
  var DynaGrid = function(id,autoParse) {
    this._callSuperConstructor(DynaGrid,[id]); 
    
    this.pageNumber = 1;
    this.currentPages = 0;
    
    this.autoScrollElement = null;
    this.autoScrollType = OFF;
    

    this.initDOM();
    
    autoParse = this.checkBool(autoParse,true);
    if (autoParse) {
      this.parseHtml();
    }
    
  };
  
  
  DynaGrid.prototype = {
      
    /**
     * @ignore
     */  
    toString: function() {
      return ["[",this.id,this.rowCount,this.currentPages,"]"].join("|");
    },
   
    /**
     * Setter method that sets the maximum number of visible rows allowed
     * in the grid.
     * If a value for this property is set, then Lightstreamer
     * maintains a paging mechanism, such that only one logical page is
     * displayed at a time. Logical page 1 is shown by default, but each
     * logical page can be shown by calling the {@link DynaGrid#goToPage} method.
     * <BR>Note that, due to the dynamical nature of the grid,
     * logical pages other than page 1 may underlie to scrolling caused by
     * operations on rows belonging to lower logical pages; this effect
     * is emphasized if sorting is active.
     * <BR>Note that if this instance is used to listen to events from 
     * {@link Subscription} instance(s), and the first Subscription it listens to is
     * a DISTINCT Subscription, then the behavior is different: when the limit
     * posed by this setting is reached, adding a new row will always
     * cause the removal of the oldest row from the model, with a
     * consequent repositioning of the remaining rows.  
     *
     * <p class="default-value"><b>Default value:</b> "unlimited".</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> this setting can be set and changed at any time. 
     * If the internal model is not empty when this method is called, it will cause 
     * the immediate adjustment of the rows to reflect the change. Moreover,
     * if applicable, the current logical page is automatically switched to page 1.
     * </p>
     *
     * @param {Number} maxDynaRows The maximum number of visible rows allowed,
     * or the string "unlimited", to mean that the grid is allowed
     * to grow without limits, without the need for paging (the check is case
     * insensitive).
     */
    setMaxDynaRows: function(maxDynaRows) {
      if (!maxDynaRows || new String(maxDynaRows).toLowerCase() == "unlimited") {
        this.maxRow = 0;
      } else {
        this.maxRow = this.checkPositiveNumber(maxDynaRows,true);
      }
      
      if (this.updateIsKey()) {
        this.limitRows();
      } else {
        this.calculatePages();
        this.sortTable();
        this.changePage(1);
      }
    },   
    
    /**
     * Inquiry method that gets the maximum number of visible rows allowed
     * in the grid. 
     *
     * @return {Number} The maximum number of visible rows allowed, or the String
     * "unlimited", to notify that the grid is allowed to grow
     * without limits.
     * 
     * @see DynaGrid#setMaxDynaRows
     */ 
    getMaxDynaRows: function() {
      if (this.maxRow == 0) {
        return "unlimited";
      }
      return this.maxRow;
    },
    
    /**
     * Operation method that shows a particular logical page in the internal model.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> once the {@link AbstractGrid#parseHtml} method has been called, 
     * this method can be used at any time.</p>
     * 
     * @throws {IllegalStateException} if this instance is used to listen to events 
     * from {@link Subscription} instance(s), and the first Subscription it listens 
     * to is a DISTINCT Subscription (in such case pagination is disabled).
     * 
     * @throws {IllegalStateException} if the maximum number of visible rows is 
     * set to unlimited.
     * 
     * @throws {IllegalArgumentException} if the given value is not a valid 
     * positive integer number.
     * 
     * @param {Number} pageNumber The number of the logical page to be displayed.
     * The request is accepted even if the supplied number is higher than the
     * number of currently available logical pages, by displaying an empty
     * logical page, that may become nonempty as soon as enough rows are added
     * to the internal model.
     *
     * @see DynaGrid#setMaxDynaRows
     * @see DynaGrid#getCurrentPages
     */
    goToPage: function(pageNumber) {
      if (this.updateIsKey()) {
        throw new IllegalStateException(NO_PAGINATION);
      }
      
      if (this.maxRow == 0) {
        throw new IllegalStateException(NO_PAGE_SWITCH);
      }
      
      pageNumber = this.checkPositiveNumber(pageNumber);
      this.changePage(pageNumber);
    },
    
    /**
     * Inquiry method that gets the current number of nonempty logical pages
     * needed to show the rows in the internal model.
     *
     * @return {Number} The current number of logical pages. If pagination is not active
     * 1 is returned.
     */
    getCurrentPages: function() {
      return this.maxRow == 0 ? 1 : this.currentPages;
    },
    
    /**
     * Setter method that enables or disables the automatic adjustment of
     * the page or element scrollbars at each new update to focus on the most
     * recently updated row.
     * If a growing grid is included in an HTML element that declares
     * (and supports) the "overflow" attribute then this element may develop
     * a vertical scrollbar in order to contain all the rows. Also if the 
     * container elements do not declare any "overflow" CSS property, then the
     * same may happen to the entire HTML page. 
     * In such a cases new rows added to the grid (or moved due to the sort settings)
     * may be placed in the nonvisible part of the including element/page. 
     * <BR>This can be avoided by enabling the auto-scroll. In this case,
     * each time a row is added or updated, the scrollbar is repositioned
     * to show the row involved. This feature, however, should be used only
     * if the update rate is low or if this grid is listening to a DISTINCT 
     * Subscription; otherwise, the automatic scrolling activity may be excessive.
     * <BR>Note that in case the grid is configured in UPDATE_IS_KEY mode (that is
     * the default mode used when the grid is listening to a DISTINCT subscription) and
     * the scrollbar is moved from its automatic position, then the auto-scroll
     * is disabled until the scrollbar is repositioned to its former 
     * position. This automatic interruption of the auto scrolling is not supported
     * on pre-webkit Opera browsers.
     * <BR>The auto-scroll is performed only if single page mode is currently
     * used (i.e. the maximum number of visible rows is set to unlimited).
     *
     * <p class="default-value"><b>Default value:</b> "OFF".</p>
     *
     * <p class="lifecycle"><b>Lifecycle:</b> The auto-scroll policy can be set and changed
     * at any time.</p>
     *
     * @param {String} type The auto-scroll policy. Permitted values are:
     * <ul>
     * <li>"OFF": No auto-scrolling is required;</li>
     * <li>"ELEMENT": An element's scrollbar should auto-scroll;</li>
     * <li>"PAGE": The browser page's scrollbar should auto-scroll.</li>
     * </ul>
     * @param {String} elementId The HTML "id" attribute of the HTML element whose scrollbar
     * should auto-scroll, if the type argument is "ELEMENT"; not used,
     * otherwise.
     * @see DynaGrid#setMaxDynaRows
     * @see AbstractGrid#forceSubscriptionInterpretation
     * 
     */
    setAutoScroll: function(type, elementId) {
      if (!type) {
        throw new IllegalArgumentException(WRONG_SCROLL_TYPE);
      }
      
      type = new String(type).toUpperCase();
      
      if (type == ELEMENT) {
        if (!elementId) {
          throw new IllegalArgumentException(NO_AUTOSCROLL_ELEMENT);
        } else {
          this.autoScrollElement = elementId;
        }
        
      } else if (type != PAGE && type != OFF) {
        throw new IllegalArgumentException(WRONG_SCROLL_TYPE);

      }
      this.autoScrollType = type;
      
      this.prepareAutoScroll();
      
    },
    
    
//////////////////////////////////TEMPLATE SETUP    
    
    /**
     * @protected
     * @inheritdoc
     */
    parseHtml: function() {
      this.parsed = true;
      
      var ancestorNode = this.clonedNode;
      if (ancestorNode) {
        if (Cell.isAttachedToDOM(ancestorNode))  {
          //template already saved and still there
          return true;  
        } else {
          //the template disappeared, reset and read again
          this.initDOM();
        }
      }
      
      ancestorNode = document.getElementById(this.id);
      //verifies the template
      if (!this.templateControl(ancestorNode)) {
        return false;
      }
      
      //clone the template
      this.template = ancestorNode.cloneNode(true);
      this.template.removeAttribute("id");
  
      //save the original template for future use (var name is misleading)
      this.clonedNode = ancestorNode;
      //save its parent too, will be used to append clones
      var ancestorParent = ancestorNode.parentNode;
      this.nodeContainer = ancestorParent;
    
      //let's hide the original template
      ancestorNode.style.display = "none";
      
      //search the position of the template in its parent
      var ancestorBrothers = ancestorParent.childNodes;
      var i = 0;
      var offsetIndex = 0;
      var refererNode = null;
      for (i = 0; i < ancestorBrothers.length; i++) {
        // Both in the upwardScroll case and the reverse
        // the brother to be signed is the same, that is
        // the brother immediately following the ancestor
        // so the first inserted "will replace" the ancestor
        // (it is inserted between the ancestor and that brother, given the invisibility
        // dell'ancestor, it seems a substitution)
        if (ancestorBrothers[i] == ancestorNode) {
          if (ancestorBrothers[i+1]) {
            refererNode = ancestorBrothers[i+1];
          } 
          offsetIndex = i+1;
          break;
        }  
      }
      
      this.clonedContainer = new VisibleParent(ancestorParent, refererNode, offsetIndex);
      this.nextParent = new InvisibleParent();
      this.prevParent = new InvisibleParent();
      
      return true;
    },
    
    /**
     * @protected
     * @ignore
     */
    computeFieldSymbolsSet: function(type) {
      var template = this.clonedNode;
      var lsTags = Cell.getLSTags(template,this.tagsToCheck);
      var fieldSymbolsSet = {};
      for (var j = 0; j < lsTags.length; j++) {
        if (lsTags[j].getFieldType() == type) {
          var fieldSymbol = lsTags[j].getField();
          if (fieldSymbol) {
            fieldSymbolsSet[fieldSymbol] = true;
          }
        }
      }
      return fieldSymbolsSet;
    },
    
    /**
     * @private
     */
    templateControl: function(template) {
      //do a control on the template and its contained cells
      if (!template) {
        //no template no party!
        throw new IllegalArgumentException(NO_TEMPLATE);
      }
      
      if (!Cell.verifyTag(template)) {
        throw new IllegalArgumentException(NO_SOURCE);
      }      
      
      var validLSTags = [];
      var lsTags = Cell.getLSTags(template,this.tagsToCheck); 
      for (var pi = 0; pi < lsTags.length; pi++) {
        if (lsTags[pi].getField()) {
          validLSTags.push(lsTags[pi]);
        }
      }
      
      if (validLSTags.length <= 0) {
        throw new IllegalArgumentException(NO_CELLS);
      }
      
      return true;
    },
    
    /**
     * @private
     */
    prepareAutoScroll: function() {
       // autoscroll management: I take the node to scroll if it is autoscroll on an html element  
      if (this.autoScrollType == ELEMENT) {
        if (this.autoScrollElement && this.autoScrollElement.appendChild) ; else {
          var scrollElement = document.getElementById(this.autoScrollElement);  
          if (!scrollElement) {
            gridsLogger.logError(LoggerManager.resolve(981),this);
            this.autoScrollType = OFF;
          } else {
            this.autoScrollElement = scrollElement;
          }
        }
      } 
    },
    
////////////////////////////////////////////////////VISUAL CONTROL    
    
    /**
     * @private
     */
    initDOM: function() {
      this.clonedNode = null; //original template
      this.template = null; //template clone
      this.nodeContainer = null; //the template parent
      
      this.clonedContainer = null; //Visibleparent
      this.nextParent = null; //InvisibleParent (required for paging)
      this.prevParent = null; //InvisibleParent (required for paging)
      
      this.clonesArray = {};
    },

    /**
     * @private
     */
    getTemplateClone: function() {
      return this.template.cloneNode(true);
    },
    
    /**
     * @ignore
     */
    onNewCell: function(cell,row,field) {
      this.grid.addCell(cell,row,field);
    },
        
    /**
     * @inheritdoc
     */
    clean: function() {
    //why this useless implementation here? Is it because of closure? TODO verify
      this._callSuperMethod(DynaGrid,"clean");
    },

    /**
     * @private
     */
    willAutoScroll: function() {
      if (this.autoScrollType == OFF) {
        return false;
      }
      
      if (!this.updateIsKey()) {
        //always scroll
        return true;
        
      } else {
        var scrollEl = this.autoScrollType == ELEMENT ? this.autoScrollElement : document.body;
        
        if (this.addOnTop) {
          return scrollEl.scrollTop == 0;
        }
        
        //we only scroll if the scrollbar is on the downmost position --> (scrollEl.clientHeight + scrollEl.scrollTop) == scrollEl.scrollHeight
      
        if (BrowserDetection.isProbablyOldOpera()) {
          //Opera handling of clientHeight, scrollTop and scrollHeight
          //is a little bit different:
          //When the scrollbar is on the bottom clientHeight + scrollTop is
          //equal to scrollHeight on other browsers while on opera it might
          //be a little bigger. 
          return true;
        }
          
     
        return Math.abs(scrollEl.clientHeight + scrollEl.scrollTop - scrollEl.scrollHeight) <= 1; //rogue pixel
      }
    },
    
    /**
     * @private
     */
    getNewScrollPosition: function(el) {
      var scrollEl = this.autoScrollType == PAGE ? document.body : this.autoScrollElement;
      if (this.updateIsKey()) {
        return this.addOnTop ? 0 : scrollEl.scrollHeight-scrollEl.clientHeight;
        
      } else {
      
        return el.offsetTop - scrollEl.offsetTop;
      }
    },
    
    /**
     * @private 
     */
    doAutoScroll: function(scrollTo) {
      if (gridsLogger.isDebugLogEnabled()) {
        gridsLogger.logDebug(LoggerManager.resolve(982),this,scrollTo);
      }
      if (this.autoScrollType == PAGE) {      
        window.scrollTo(0,scrollTo);
      } else {
        this.autoScrollElement.scrollTop = scrollTo;
      }
    },
    
    /**
     * @protected
     * @ignore
     */
    sortTable: function() {
      var mySortCode = this.sortField;
      
      //temporary object, will contain all the nodes
      var tempTable = new InvisibleParent();
  
      var x = 1;
      while (this.rowCount > 0) {
        var first = this.getNodeByIndex(x);
        if (!first) {
          this.rowCount--;
          x++;
          continue;
        }
        
        //if sortField is not specified it will only reorder elements on the pages
        if (mySortCode == null) {
          tempTable.appendChild(first,true);
          this.rowCount--;
          continue;
        }
        
        var firstKey = first.getKey();
        if (firstKey == "") {
          this.rowCount--;
          x++;
          continue;
        }
        
        var sortKey = this.makeSortValue(this.values.get(firstKey,this.sortField));

        //I should exploit the calculateSortedPosition method
        
        var up = 0; 
        var down = tempTable.length - 1;
        
        while (up < down) {
          var j = Math.floor((up + down) / 2); 
          var compare = tempTable.getChild(j);
          var k = this.makeSortValue(this.values.get(compare.getKey(),this.sortField)); 
          if (!k) {
            gridsLogger.logWarn(LoggerManager.resolve(983),this);
            //can happen if a non existent field is specified
          }
          if (this.isBefore(sortKey,k)) {
            down = j - 1;
          } else {
            up = j + 1;
          }
        }
        var compare = tempTable.getChild(up);
        
        if (up == down) {
          var compareKey = this.makeSortValue(this.values.get(compare.getKey(),this.sortField)); 
          if (this.isBefore(sortKey,compareKey)) {
            tempTable.insertBefore(first,compare);
          } else {
            var afterDown = tempTable.getChild(down+1);
            if (!afterDown) {
              tempTable.appendChild(first,true);
            } else {
              tempTable.insertBefore(first,afterDown);
            }
          }
        } else {
          if (compare) {
            tempTable.insertBefore(first,compare);
          } else {
            tempTable.appendChild(first,true);
          }
          
        }
        this.rowCount--;
      }
      
        
      //everythin is in the temporary object, now distribute'em
      var z = 0;
      while (z < tempTable.length) {
        this.rowCount++;
        var el = tempTable.getChild(z);
        
        if (this.rowCount <= (this.maxRow * (this.pageNumber - 1))) {
          this.prevParent.appendChild(el,true);
        } else if ((this.maxRow <= 0)||(this.rowCount <= (this.maxRow * this.pageNumber))) {
          this.clonedContainer.appendChild(el,true);
        } else {
          this.nextParent.appendChild(el,true);
        }
  
      }
    },
    
    /**
     * @protected
     * @ignore
     */
    changePage: function(toPage) {
      if(this.rowCount <= 0) {
        return;
      }
      if (this.pageNumber >= toPage) {
        while (this.shiftDown(this.prevParent,this.clonedContainer,(toPage - 1) * this.maxRow)) {
          this.shiftDown(this.clonedContainer,this.nextParent,this.maxRow);
        }
      } else {       
        while (this.fitFreeSpace(this.clonedContainer,this.prevParent,(toPage - 1) * this.maxRow,false)) {
          this.fitFreeSpace(this.nextParent,this.clonedContainer,this.maxRow,false);
        }
      }
      
      this.pageNumber = toPage;
    },
    
    /**
     * @protected
     * @ignore
     */
    calculatePages: function() {
      if (gridsLogger.isDebugLogEnabled()) {
        gridsLogger.logDebug(LoggerManager.resolve(984),this);
      }
      
      var nowPages = 0;
      if (this.maxRow <= 0) {
        nowPages = 1;
      } else {
        nowPages = Math.ceil(this.rowCount / this.maxRow);
      }
  
      if (this.currentPages != nowPages) {
        this.currentPages = nowPages;
        this.dispatchEvent("onCurrentPagesChanged",[this.currentPages]);
      }
      
      return nowPages;
    },  
    
/////////////////////////////////////VISUAL EXECUTION    
  
    /**
     * @protected
     * @ignore
     */
    removeRowExecution: function(key) {
      var toRemove = this.clonesArray[key];
      if (!toRemove) {
        return;
      }
      this.rowCount--;
      
      this.calculatePages();
      
      //onTop is only possible if sort is disabled and grid is configured that way.
      var onTop = false;
      var upParent = this.prevParent;
      var downParent = this.nextParent;
      
      this.dispatchEvent("onVisualUpdate" ,[key,null,toRemove.element()]);
       
      if(this.updateIsKey() && this.addOnTop && this.sortField == null) {
        //only possible if updateIsKey
        onTop = this.addOnTop;
        upParent = this.nextParent;
        downParent = this.prevParent;
      }
      
      if (toRemove.isSonOf(this.clonedContainer)) { //this.clonedContainer is a VisibleParent 
        //remove from visible nodes
        this.clonedContainer.removeChild(toRemove);
        //if necessary scroll up
        this.fitFreeSpace(downParent, this.clonedContainer, this.maxRow, onTop);
      } else if (toRemove.isSonOf(downParent)) {
        //remove from non-visible nodes
        downParent.removeChild(toRemove);
      } else {
        this.prevParent.removeChild(toRemove);
        //if necessary scroll up (the visibile nodes)
        if (this.fitFreeSpace(this.clonedContainer, upParent, this.maxRow * (this.pageNumber - 1), onTop)) {
          //if necessary scroll up
          this.fitFreeSpace(downParent, this.clonedContainer, this.maxRow, onTop);
        }
      }
      
      this.grid.delRow(key);
      delete(this.clonesArray[key]);
      
    },
    
    /**
     * @protected
     * @ignore
     */
    updateRowExecution: function(key,serverValues) { 
      var calculatePagesFlag = false;   
      var toUpdate = this.clonesArray[key];
      
      if (!toUpdate) {
        //this is an add
        toUpdate = new DynaElement(key, this);
        this.clonesArray[key] = toUpdate;
        toUpdate.element();
      }

//>>excludeStart("debugExclude", pragmas.debugExclude);            
      ASSERT.verifyOk(toUpdate);
//>>excludeEnd("debugExclude"); 
      
      this.fillFormattedValues(key,serverValues);
      
      var upInfo = this.dispatchVisualUpdateEvent(key,serverValues,toUpdate);
      
      var performScroll = this.willAutoScroll();
      var isNew = !this.values.getRow(key);
      
      var oldSortVal = this.sortField != null ? this.makeSortValue(this.values.get(key,this.sortField)) : null;
      var newSortVal = this.sortField != null ? this.makeSortValue(serverValues[this.sortField]) : null;
      var dontMove = oldSortVal == newSortVal || (!serverValues[this.sortField] && serverValues[this.sortField] !== null);
      
      if (this.sortField != null && dontMove == false) {
        
        var insInd = this.calculateSortedPosition(toUpdate,oldSortVal,newSortVal);
        this.insertNodeAtIndex(insInd,toUpdate);
        
        if (isNew) {
          this.rowCount++;
          calculatePagesFlag = true;
        } 
        
      } else if (isNew) {
        
        //No sort and new row: 
        //When upward scroll is not active, new updates are placed at the top of the model data table, so that old updates scroll downward. 
        //On the other hand, when upward scroll is active, new updates are placed at the bottom of the model data table.

        this.appendNode(toUpdate,!this.addOnTop);
        this.rowCount++;
        calculatePagesFlag = true;
      } 
      
      //place new values in the cells
      this.visualUpdateExecution(key,upInfo);
      
      this.updateInProgress = null;
      
      //if too many rows and update_is_key remove the oldest one
      if (isNew && this.updateIsKey()) {
        this.limitRows();
      }

      if (performScroll && toUpdate.isSonOf(this.clonedContainer)) {
        var newScrollPos = this.getNewScrollPosition(toUpdate.element());
        this.doAutoScroll(newScrollPos);
      }
      
      if (calculatePagesFlag) {
        this.calculatePages();
      }
      
    },
    
    /**
     * @private
     */
    dispatchVisualUpdateEvent: function(key,serverValues,toUpdate) {
      
      this.currentUpdateKey = key;
      this.currentUpdateValues = serverValues;
      
      //this references are used to handle reentrant calls; if an
      //updateRow call is performed during the VisualUpdate it is 
      //merged in this update instead of spawning a new update.
      var upInfo = new VisualUpdate(this.grid,serverValues,key); 
      this.dispatchEvent("onVisualUpdate",[key,upInfo,toUpdate.element()]);
      
      this.currentUpdateKey = null;
      this.currentUpdateValues = null;

      return upInfo;
      
    },
   
    /**
     * @private
     */
    calculateSortedPosition: function(toUpdate,oldSortVal,newSortVal) {
      var up = 1;
      var down = this.rowCount;
      var j = -1;
      
      // search an equal key or the case in which up exceeds down
      while (up < down) {
        j = Math.floor((up + down) /2);
        var thisKey = null;

        if (j <= this.rowCount) {
          var compare = this.getNodeByIndex(j);
          if (compare == toUpdate) {
            thisKey = oldSortVal;
          } else {
            thisKey = this.makeSortValue(this.values.get(compare.getKey(),this.sortField)); 
          }
        }
        if (this.isBefore(newSortVal,thisKey)) {
          down = j - 1;
        } else {
          up = j + 1;
        }
      }

      if (up == down) {
        // up and down coincide, our place is immediately before or immediately after this point
        var compare = this.getNodeByIndex(up);
        var compareKey = this.makeSortValue(this.values.get(compare.getKey(),this.sortField));
        if (this.isBefore(newSortVal,compareKey)) {
          return up;
        } else {
          return up + 1;
        }
      } else {
        return up;
      }
    },

    /**
     * @protected
     * @ignore
     */
    getNodeByIndex: function(i) {
      
      if (i > this.rowCount || i <= 0) {
        return null;
      } 
      
      if (i <= this.prevParent.length) {
        return this.prevParent.getChild(i-1);
      } else {
        i -= this.prevParent.length;
        if (i <= this.clonedContainer.length) {
          return this.clonedContainer.getChild(i-1);
        } else {
          i -= this.clonedContainer.length;
          return this.nextParent.getChild(i-1);
        }
      } 
      
    },
    
    /**
     * @protected
     * @ignore
     */
    appendNode: function(toUpdate,onBottom) {
      
      var upParent = onBottom ? this.prevParent : this.nextParent;
      var downParent = onBottom ? this.nextParent : this.prevParent;
      
      if (downParent.length > 0 || (this.clonedContainer.length == this.maxRow && this.maxRow > 0)) {
        //there is no room in the central "window", so append in the downParent
        //having something in the downParent implies that the central window is full
        downParent.appendChild(toUpdate,onBottom);
        return downParent;
        
      } else if (this.clonedContainer.length > 0 || upParent.length == (this.maxRow * (this.pageNumber - 1))) { //as a consequence we pass from here if this.maxRow == 0 (upParent.length would be 0 and 0*x = 0)
        //central window is not empty (if empty the updates may have to be to be placed on the upParent)
        //or all the existing elements are in the upParent (and all the pages in the upParent are full)
        this.clonedContainer.appendChild(toUpdate,onBottom);
        return this.clonedContainer;
        
      } else {
        upParent.appendChild(toUpdate,onBottom);
        return upParent;
      }
    },
    
    /**
     * @protected
     * @ignore
     */
    insertNodeAtIndex: function(i, node) { 
      if (i > this.rowCount + 1 || i <= 0) {
        return;
      } 
      
      if (node == this.getNodeByIndex(i)) {
        return;
      }
      
      
      var firstP = node.getParentNode(); 
      var afterP;
      
      var parent = this.clonedContainer;
      var nextParent = this.nextParent;
      var prevParent = this.prevParent;
      
      var insBef = this.getNodeByIndex(i);
      if (insBef == null) {
        afterP = this.appendNode(node,true);
      
      } else {
        afterP = insBef.getParentNode(); 
        afterP.insertBefore(node,insBef);
      }
      
      //let's handle overflows
      if (afterP == parent) {
        if ((!firstP) || (firstP == nextParent)) {
          this.shiftDown(parent, nextParent, this.maxRow);
        } else if (firstP == prevParent) {
          this.fitFreeSpace(parent, prevParent, this.maxRow * (this.pageNumber - 1), false);
        } 
      } else if (afterP == prevParent) {
        if (firstP != prevParent) {
          if (this.shiftDown(prevParent, parent, this.maxRow * (this.pageNumber - 1))) {
            this.shiftDown(parent, nextParent, this.maxRow);
          }
        }
      } else if (afterP == nextParent) {
        if (firstP == prevParent) {
          this.fitFreeSpace(parent, prevParent, this.maxRow * (this.pageNumber - 1), false);
        } 
        this.fitFreeSpace(nextParent, parent, this.maxRow, false);
      }
      
    },
    
    /**
     * @private
     */
    fitFreeSpace: function(fromNode, toNode, maxForTo, onTop) {
      //if a place was freed in a parent we grab a row from the following parent and move it 
      //to the freed one
      if (this.maxRow <= 0) {
        //infinite visible places, only one parent has rows here.
        return false;
      }
      if (toNode.length < maxForTo && fromNode.length > 0) {
        var toMoveEl = fromNode.getChild(0);
        toNode.appendChild(toMoveEl,!onTop);
        return true;
      }
      return false;
    },
    
    /**
     * @private
     */
    shiftDown: function(fromNode, toNode, maxForFrom) {
      if (this.maxRow <= 0) {
        //infinite visible places
        return false;
      }
      if (fromNode.length > maxForFrom) {
        var toMoveEl = fromNode.getChild(fromNode.length-1);
        toNode.insertBefore(toMoveEl,toNode.getChild(0));
        
        return true;
      }
      return false;
    },
    
    /**
     * @private
     */
    limitRows: function() {
      //only updateiskey limits rows in this way
      while(this.maxRow > 0 && this.rowCount > this.maxRow) {
        this.removeRow(this.getOldestKey());
      }
    },
    
    /**
     * Adds a listener that will receive events from the DynaGrid 
     * instance.
     * <BR>The same listener can be added to several different DynaGrid 
     * instances.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
     * 
     * @param {DynaGridListener} listener An object that will receive the events
     * as shown in the {@link DynaGridListener} interface.
     * <BR>Note that the given instance does not have to implement all of the 
     * methods of the DynaGridListener interface. In fact it may also 
     * implement none of the interface methods and still be considered a valid 
     * listener. In the latter case it will obviously receive no events.
     */
    addListener: function(listener) {
      this._callSuperMethod(DynaGrid,"addListener",[listener]);
    },
    
    /**
     * Removes a listener from the DynaGrid instance so that it
     * will not receive events anymore.
     * 
     * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
     * 
     * @param {DynaGridListener} listener The listener to be removed.
     */
    removeListener: function(listener) {
      this._callSuperMethod(DynaGrid,"removeListener",[listener]);
    },
    
    /**
     * Returns an array containing the {@link DynaGridListener} instances that
     * were added to this client.
     * 
     * @return {DynaGridListener[]} an array containing the listeners that were added to this instance.
     * Listeners added multiple times are included multiple times in the array.
     */
    getListeners: function() {
      return this._callSuperMethod(DynaGrid,"getListeners");
    }
  
  };
  
  //closure compiler exports
  DynaGrid.prototype["setMaxDynaRows"] = DynaGrid.prototype.setMaxDynaRows;
  DynaGrid.prototype["getMaxDynaRows"] = DynaGrid.prototype.getMaxDynaRows;
  DynaGrid.prototype["goToPage"] = DynaGrid.prototype.goToPage;
  DynaGrid.prototype["getCurrentPages"] = DynaGrid.prototype.getCurrentPages;
  DynaGrid.prototype["setAutoScroll"] = DynaGrid.prototype.setAutoScroll;
  DynaGrid.prototype["parseHtml"] = DynaGrid.prototype.parseHtml;
  DynaGrid.prototype["clean"] = DynaGrid.prototype.clean;
  DynaGrid.prototype["addListener"] = DynaGrid.prototype.addListener;
  DynaGrid.prototype["removeListener"] = DynaGrid.prototype.removeListener;
  DynaGrid.prototype["getListeners"] = DynaGrid.prototype.getListeners;
  DynaGrid.prototype["updateRowExecution"] = DynaGrid.prototype.updateRowExecution;
  DynaGrid.prototype["removeRowExecution"] = DynaGrid.prototype.removeRowExecution;
//<----  Listener Interface    
  

  
  Inheritance(DynaGrid,AbstractGrid);
  return DynaGrid;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var SimpleChartListener = /*@__PURE__*/(function() {
  /**
   * Creates an object that will handle the positioning of the X axis and Y axis of 
   * a {@link Chart} based on a few simple configuration parameters.
   * <BR>Note that this listener expects to listen to only one Chart but can 
   * correctly handle different lines as long as they can be represented on the
   * same scale.
   * <BR>Methods from the {@link ChartListener} interface should not be called
   * directly on instances of this class.
   * @constructor
   * 
   * @param {Number} [xSpan=60] The size of the X axis. The units of the value depends on
   * the model of the {@link Chart} instance and possibly on the parser configured on
   * the {@link Chart#setXAxis} method. If not specified, then 60 will be used.
   * @param {Number} [yPerc=20] A percentage that is used for the first positioning of the
   * Y axis: the Y axis will have as initial maximum position a value that is yPerc% 
   * greater than the first Y position and as initial minimum position a value that
   * is yPerc% smaller than it. If not specified, then 20 (meaning 20%) will be used. 
   * 
   * @exports SimpleChartListener
   * @class Simple implementation of the {@link ChartListener} interface that can
   * be used to automatically adjust the axis of a {@link Chart} to center the lines on 
   * the Chart.
   * <BR>In case of an X overflow the X axis limits will shift by half
   * of their total length meaning that the next point falls in the middle of the
   * visible area so that the shifting is not continuous for each new value 
   * of X.
   * <BR>In case of an Y overflow the Y axis limits are stretched
   * in such a way that the new point falls on the visible part of the Y
   * axis.
   * <BR>Note that in case of an Y overflow all of the ChartLine instances of the
   * listened Chart will be stretched with the same values to keep the view consistent.
   * 
   * @extends ChartListener
   */
  var SimpleChartListener = function(xSpan,yPerc) {
    this.xSpan = xSpan || 60;
    yPerc = (yPerc || 20)/100;
    
    this.moreY = 1+yPerc;
    this.lessY = 1-yPerc;
    
    this.handledLines = new List();
    this.minY;
    this.maxY;
  };
  
  SimpleChartListener.prototype = {
    /**
     * @inheritdoc
     */
    onListenStart: function(chartTable) {
      this.chartTable = chartTable;
    },
    
    /**
     * @inheritdoc
     */
    onYOverflow: function(key,toUpdateChartLine,lastY,minY,maxY) {
      var shift = (maxY - minY)/2;
      if (lastY > maxY) {
        var newMax = maxY + shift;
        if (lastY > newMax) {
          newMax = lastY;
        }

        this.maxY = newMax;
        this.updateYAxis(minY,newMax);

      } else if (lastY < minY) {
        var newMin = minY - shift;
        if (lastY < newMin) {
          newMin = lastY;
        }
        
        this.minY = newMin;
        this.updateYAxis(newMin,maxY);
      } 
    },
    
    /**
     * @inheritdoc
     */
    onXOverflow: function(key, lastX, minX, maxX) {        
      if (lastX > maxX) {
        var xMid = (maxX + minX) /2;
        var diff = maxX - minX;
        this.chartTable.positionXAxis(xMid,xMid + diff);
      } //else {
        //overflow point from the other side are discarded
    },
    
    /**
     * @inheritdoc
     */
    onNewLine: function(key,newChartLine,nowX,nowY) {
      this.chartTable.positionXAxis(nowX,nowX+this.xSpan); 
      
      var localMin = nowY*this.lessY;
      var localMax = nowY*this.moreY;
      

      this.handledLines.add(newChartLine);
      this.minY = this.minY !== null && this.minY <= localMin ? this.minY : localMin; 
      this.maxY = this.maxY !== null && this.maxY >= localMax ? this.maxY : localMax; 
      
      this.updateYAxis(this.minY,this.maxY);
                
    },
    
    /**
     * @inheritdoc
     */
    onRemovedLine: function(key,removedChartLine) {
      this.handledLines.remove(removedChartLine);
    },
    
    /**
     * @private
     */
    updateYAxis: function(newMin,newMax) {
      this.handledLines.forEach(function(line) {
        line.positionYAxis(newMin,newMax);
      });
    }
  };
  
  //closure compiler exports
  SimpleChartListener.prototype["onListenStart"] = SimpleChartListener.prototype.onListenStart;
  SimpleChartListener.prototype["onYOverflow"] = SimpleChartListener.prototype.onYOverflow;
  SimpleChartListener.prototype["onXOverflow"] = SimpleChartListener.prototype.onXOverflow;
  SimpleChartListener.prototype["onNewLine"] = SimpleChartListener.prototype.onNewLine;
  SimpleChartListener.prototype["onRemovedLine"] = SimpleChartListener.prototype.onRemovedLine;
  
  return SimpleChartListener;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var SlidingCell = /*@__PURE__*/(function() {  
  var nextId = 0;
  
  /**
   * This class makes it possible to have a Cell interface bound to a key instead of being bound to a position.
   * So if the logic cell moves across different rows this class is always able to call methods on it.
   * This is not a complete proxy though
   * @private
   */
  var SlidingCell = function(ownerGrid, key, field, num, noNumIndex) {
    this.ownerGrid = ownerGrid;
    this.key = key;
    this.field = field;
    this.num = num || null;
    this.noNumIndex = noNumIndex;
    
    this.cellId = "s"+nextId++;
  };
  
  
  
  SlidingCell.prototype = {
    
    /*private*/ getCurrentCell: function() {
      var cell = this.ownerGrid.getCellByKey(this.key,this.field,this.num);
      if(!cell) {
        return null;
      }
      if (cell.isCell) {
        if (this.num === cell.getNum() && this.noNumIndex <= 0) {
          return cell;
        }
      } else {
        var nowI = -1;
        for (var i = 0; i < cell.length; i++) {
          var parsingCellNum = cell[i].getNum();
          if (parsingCellNum === null) {
            nowI++;
          }
          
          if (this.num === parsingCellNum && this.noNumIndex == nowI) {
            return cell[i];
          }
        }
      }
      
      return null;
      
    },
    
    
    /*public*/ incFadePhase: function() {
      var c = this.getCurrentCell();
      return c ? c.incFadePhase() : null;
    },
    /*public*/  getCellId: function() {
      return this.cellId;
    },
    /*public*/ getFadePhase: function() {
      var c = this.getCurrentCell();
      return c ? c.getFadePhase() : null;
    },
    /*public*/ getEl: function() {
      var c = this.getCurrentCell();
      return c ? c.getEl() : null;
    },
    
    /*public*/ asynchUpdateStyles: function(phaseNum,type) {
      var c = this.getCurrentCell();
      if (c) {
        c.asynchUpdateStyles(phaseNum,type);
      }
    },
    
    /*public*/ asynchUpdateValue: function(phaseNum,useInner) {
      var c = this.getCurrentCell();
      if (c) {
          c.asynchUpdateValue(phaseNum,useInner);
        }
    }
    
  };

  return SlidingCell;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var DoubleKeyMap = /*@__PURE__*/(function() {
  function checkValidValue(v) {
    return v !== null && typeof v != "undefined";
  }
  
  function doRemove(master,slave,key) {
    var val = master[key];
    if (checkValidValue(val)) {
      delete(master[key]);
      delete(slave[val]);
    }
  }
  
  /*
   * how does this work
   * 
   * A 1 | 1 A
   * B 2 | 2 B
   * C 3 | 3 C
   * 
   * 
   * CASE 1, one key overwriting
   *  
   *  set(a,7)
   *  
   *  --> just write
   *  A 7 | 2 B
   *  B 2 | 3 C
   *  C 3 | 7 A
   *  
   * CASE 2, double key overwriting
   * 
   *  set(b,3)
   *  
   *  --> swap B and C values (can also be seen as swap 2 and 3 values)
   *  A 7 | 2 C
   *  B 3 | 3 B
   *  C 2 | 7 A
   *    
   */
  function doSet(master,slave,a,b) {
    if (!checkValidValue(a) || !checkValidValue(b)) {
      throw new IllegalArgumentException("values can't be null nor missing");
    }
    var origB = master[a];
    var origA = slave[b];
    
    if (checkValidValue(origB)) {
      if (origB === b) {
        //value already set
        return;
      }
      
      if(checkValidValue(origA)) {
        //value already indexed in both master and slave, swap values
        //doSwap
        master[origA] = origB;
        master[a] = b;
        slave[b] = a;
        slave[origB] = origA;
        
      } else {
        //value already indexed in the master but not in the slave, replace in master and remove + add in slave
        doReplace(master,slave,a,b);
        
      }
    } else if(checkValidValue(origA)) {
      //value already indexed in the slave but not in the master, replace in slave and remove + add in master
      doReplace(slave,master,b,a);
      
    } else {
      //doAdd
      master[a] = b;
      slave[b] = a;
    }
  }
  function doReplace(master,slave,key,val) {
    delete(slave[master[key]]);
    master[key] = val;
    slave[val] = key;
  }
  
  function doForEach(coll,cb) {
    for (var key in coll) {
      cb(key,coll[key]);
    }
  }
  
  
  /**
   * Crates and empty DoubleKeyMap
   * @constructor
   * 
   * @exports DoubleKeyMap
   * @class Simple map implementation that also keeps a reverse map whose keys are 
   * the values and values are the keys of the first map. 
   * For this reason the map can't contain duplicated values: collisions are 
   * handled by swapping values. 
   */
  var DoubleKeyMap = function() {
    /**
     * @private
     */
    this.map = {};
    /**
     * @private
     */
    this.reverseMap = {};
  };
  
  DoubleKeyMap.prototype = {
      /**
       * Inserts new values in the maps. If one of the keys is already present in the respective map,
       * its value is overwritten and the related entry on the other map is deleted. If both the keys 
       * are already present in their respective map a swapping to maintain uniqueness in both maps is performed.
       * 
       * @throws {IllegalArgumentException} if one (or both) of the specified values is null or missing.
       * 
       * @param a {Object} the key to be used to insert the other value in the first map. It can't be null nor missing.
       * @param b {Object} the key to be used to insert the other value in the second map. It can't be null nor missing.
       */
      set: function(a,b) {
        doSet(this.map,this.reverseMap,a,b);
      },
      
      /**
       * Uses the given key to remove an element from the first map and the related element in the second map.
       * @param a {Object} the key to be used to remove the element from the first map.
       */
      remove: function(a) {
        doRemove(this.map,this.reverseMap,a);
      },
      /**
       * Uses the given key to remove an element from the second map and the related element in the first map.
       * @param b {Object} the key to be used to remove the element from the second map.
       */
      removeReverse: function(b) {
        doRemove(this.reverseMap,this.map,b);
      },
      
      /**
       * Gets an element from the first map using the given key.
       * @param a {Object} the key to be used to get the element from the first map.
       * @returns {Object} the found value if any or an undefined value 
       */
      get: function(a) {
        return this.map[a];
      },
      /**
       * Gets an element from the second map using the given key.
       * @param b {Object} the key to be used to get the element from the second map.
       * @returns {Object} the found value if any or an undefined value
       */
      getReverse: function(b) {
        return this.reverseMap[b];
      },
      
      /**
       * Checks if there is a value in the first map at the specified key. 
       * @param a {Object} the key to be used to get the element from the first map.
       * @returns {Boolean} true if the element exists, false otherwise.
       */
      exist: function(a) {
        return typeof this.get(a) != "undefined";
      },
      /**
       * Checks if there is a value in the second map at the specified key. 
       * @param b {Object} the key to be used to get the element from the second map.
       * @returns {Boolean} true if the element exists, false otherwise.
       */
      existReverse: function(b) {
        return typeof this.getReverse(b) != "undefined";
      },
      
      /**
       * Executes a given callback passing each element of the first map as the only
       * call parameter.<br/>  
       * Callbacks are executed synchronously before the method returns: calling 
       * {@link DoubleKeyMap#set}, {@link DoubleKeyMap#remove} or {@link DoubleKeyMap#removeReverse}
       * during callback execution may result in a wrong iteration.
       * 
       * @param {Function} callback The callback to be called.
       */
      forEach: function(callback) {
        doForEach(this.map,callback);
      },
      /**
       * Executes a given callback passing each element of the second map as the only
       * call parameter.<br/>  
       * Callbacks are executed synchronously before the method returns: calling 
       * {@link DoubleKeyMap#set}, {@link DoubleKeyMap#remove} or {@link DoubleKeyMap#removeReverse}
       * during callback execution may result in
       * a wrong iteration.
       * 
       * @param {Function} callback The callback to be called.
       */
      forEachReverse: function(callback) {
        doForEach(this.reverseMap,callback);
      }
      
  };
  
  DoubleKeyMap.prototype["set"] = DoubleKeyMap.prototype.set;
  DoubleKeyMap.prototype["remove"] = DoubleKeyMap.prototype.remove;
  DoubleKeyMap.prototype["removeReverse"] = DoubleKeyMap.prototype.removeReverse;
  DoubleKeyMap.prototype["get"] = DoubleKeyMap.prototype.get;
  DoubleKeyMap.prototype["getReverse"] = DoubleKeyMap.prototype.getReverse;
  DoubleKeyMap.prototype["exist"] = DoubleKeyMap.prototype.exist;
  DoubleKeyMap.prototype["existReverse"] = DoubleKeyMap.prototype.existReverse;
  DoubleKeyMap.prototype["forEach"] = DoubleKeyMap.prototype.forEach;
  DoubleKeyMap.prototype["forEachReverse"] = DoubleKeyMap.prototype.forEachReverse;
  
  
  return DoubleKeyMap;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var StaticGrid = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  var NULL_CELL = "The given cell is null or undefined";
  var WRONG_GRID = "The cell does not belong to the Grid";
  var INVALID_ROOT = "The given root element is not valid";
  var NO_ITEMS_TO_EXTRACT = "Cant extract schema from cells declared with the data-row property; use data-item instead.";
  var MIX_ROW_ITEMS = "Cant mix data-item and data-row declarations on the same grid";
  var NO_CELLS = "Please specify at least one cell";
  
  function swap(arr,a,b) {
    var tmp = arr[a];
    arr[a] = arr[b]; 
    arr[b] = tmp;
  }
  
  var gridsLogger = LoggerManager.getLoggerProxy("lightstreamer.grids");   
  
  /**
   * Creates an object that extends {@link AbstractGrid} displaying its values
   * in a grid made of HTML elements. The grid rows are displayed into statically 
   * prepared HTML rows. The object can be supplied to
   * {@link Subscription#addListener} and {@link Subscription#removeListener}
   * in order to display data from one or more Subscriptions.
   * @constructor
   * 
   * @param {String} id An identification string to be specified in the HTML element
   * as the data "data-grid" property 
   * value to make it possible for this StaticGrid instance to recognize its cells.
   * The binding between the cells and the StaticGrid is performed during the 
   * {@link AbstractGrid#parseHtml} execution. 
   * 
   * @param {boolean} autoParse If true the {@link AbstractGrid#parseHtml} method is executed
   * before the constructor execution is completed. If false the parseHtml method
   * has to be called later by custom code. It can be useful to set this flag
   * to false if, at the time of the StaticGrid instance creation, the HTML elements
   * designated as cells are not yet ready on the page.
   * 
   * @param {Object} rootEl if specified, the cells to make up the HTML grid will
   * only be searched in the list of descendants of this node. Equivalent to a
   * {@link StaticGrid#setRootNode} call, but useful if autoParse is true.
   * 
   * @param {Object[]} cells an array of DOMElement instances that will make up the
   * HTML grid for this StaticGrid instance. If specified and not empty, the parseHtml 
   * method will avoid searching cells in the DOM of the page. Equivalent to multiple
   * {@link StaticGrid#addCell} calls, but also useful if autoParse is true.
   * 
   * @exports StaticGrid
   * @class An {@link AbstractGrid} implementation that can be used to display
   * the values from the internal model in a statically prepared grid.   
   * The HTML structure suitable for the visualization of the tabular model values  
   * must be prepared up-front in the DOM of the page as a matrix of HTML cells.
   * The cells making up the grid can be any HTML element   
   * owning the "data-source='Lightstreamer'" special attribute. Such cells, to be
   * properly bound to the StatiGrid instance must also define the following
   * custom attributes:
   * <ul>
   * <li>"data-grid": an identification string that has to be equal to the id 
   * that is specified in the constructor of this class. This id is used
   * to properly bind a cell to its StaticGrid instance.</li>
   * <li>"data-field": the name of a field in the internal model whose value will
   * be displayed in this cell.</li>
   * <li>"data-fieldtype" (optional): "extra", "first-level" or "second-level" to 
   * specify the type of field. If not specified "first-level" is assumed.
   * The "data-fieldtype" property is only exploited in the {@link AbstractGrid#extractFieldList}
   * and {@link AbstractGrid#extractCommandSecondLevelFieldList} methods.</li>
   * <li>"data-row" (only if "data-item" is not specified): a progressive number
   * representing the number of the row associated with the cell.
   * When a new row enters the grid its position will be decided by the 
   * {@link AbstractGrid#setAddOnTop} and {@link AbstractGrid#setSort} settings.
   * The "data-row" attribute will define to which row a cell pertains.
   * <BR>Note that the maximum value available for a data-row attribute in all
   * the cells pertaining to this StaticGrid will define the size of the view.
   * If the number of rows in the model exceeds the number of rows defined in the 
   * HTML grid, rows that would have been displayed in the extra rows are not shown
   * in the view but are maintained in the model. 
   * <BR>Note that if this instance is used to listen to events from 
   * {@link Subscription} instance(s), and the first Subscription it listens to is
   * a DISTINCT Subscription, then the behavior is different: when the number of rows 
   * in the model exceeds the number of rows defined in the HTML grid, adding a new 
   * row will always cause the removal of the oldest row from the model, with a
   * consequent repositioning of the remaining rows. 
   * </li>
   * <li>"data-item" (only if "data-row" is not specified): the name of a row in
   * the internal model, whose value (for the chosen field) will be displayed in
   * this cell; this attribute should
   * only be used if this instance is used to listen to events from 
   * {@link Subscription} instance using the MERGE mode; so, this attribute should 
   * identify the name or the 1-based position of an item in the MERGE Subscription.
   * This way it is possible to define a static positioning for each item in 
   * the MERGE Subscription. On the contrary, by using "data-row" attributes, each
   * item will be placed based only on the {@link AbstractGrid#setAddOnTop} and
   * {@link AbstractGrid#setSort} settings and the positioning may depend on the
   * arrival order of the updates.
   * </li>
   * <li>"data-replica" (optional): this attribute can be specified in case there
   * are more cells associated to the same field. If used, it will permit to access
   * the single cells during {@link StaticGridListener#onVisualUpdate} executions.</li>
   * </ul>
   * <BR>
   * <BR>The association between the StaticGrid and the HTML cells is made during the
   * execution of the {@link AbstractGrid#parseHtml} method. Note that only the elements 
   * specified in the {@link AbstractGrid#setNodeTypes} and that are descendants of the node
   * specified in the {@link StaticGrid#setRootNode} are taken into account, unless a list
   * of cells has been manually specified in the constructor or through the {@link StaticGrid#addCell}
   * method, in which case no elements other than the given ones are taken into 
   * account.
   * <BR>Cells already associated to the grid can be removed from the page DOM,
   * hence from the grid, at any time. Cells already associated can also be moved or
   * altered so that they become no longer suitable for association or other HTML
   * elements may be made suitable, but, in this case, all changes will affect the
   * grid only after the next invocation of {@link AbstractGrid#parseHtml}.
   * <BR>Make sure that all the associated cells specify the same attribute among
   * "data-row" and "data-item"; the behavior of the grid is left unspecified
   * when this condition is not met.
   * <BR>
   * <BR>By default, the content of the HTML element designated as cell will be 
   * updated with the value from the internal model; in case the cell is an INPUT
   * or a TEXTAREA element, the "value" property will be updated instead.
   * It is possible to update any attribute of the HTML element or its CSS 
   * styles by specifying the "data-update" custom attribute. 
   * To target an attribute the attribute name has to be specified; it can be a 
   * standard property (e.g. "data-update='href'"), a custom "data-" attribute 
   * (e.g. "data-update='data-foo'") or even a custom attribute not respecting
   * the "data-" standard (e.g. "data-update='foo'").
   * To target CSS attributes the "data-update='style.attributeName'" form has to 
   * be used (e.g. "data-update='style.backgroundColor'"); note that the form
   * "data-update='style.background-color'" will not be recognized by some browsers.
   * <BR>WARNING: also events like "onclick" can be assigned; in such cases make 
   * sure that no malicious code may reach the internal model (for example 
   * through the injection of undesired JavaScript code from the Data Adapter).
   * <BR>More visualization actions can be performed through the provided  
   * {@link VisualUpdate} event objects received on the {@link StaticGridListener}. 
   *
   * @extends AbstractGrid
   */
  var StaticGrid = function(id, autoParse, rootEl, cells) {
    
    this._callSuperConstructor(StaticGrid,[id]); 
    
    this.explicitSetting = false;
    
    this.rootEl = null;
    this.setRootNode(rootEl || document);
    
    this.tableCells = [];
    if (cells) {
      this.addCell(cells);
    }
    
    this.keyRowMap = new DoubleKeyMap();
   
    this.usingItems = null;
    
    autoParse = this.checkBool(autoParse,true);
    if (autoParse) {
      this.parseHtml();
    }
    
  };
  
  StaticGrid.prototype = {
      /**
       * @ignore
       */
      toString: function() {
        return ["[",this.id,"]"].join("|");
      },
       

//////////////////////////////////TEMPLATE SETUP       
      
      /**
       * Operation method that adds an HTML cell pointer to the StaticGrid.
       * <BR>Note that if at least one cell is manually specified then the 
       * {@link AbstractGrid#parseHtml} will not perform any search in the DOM of the page
       * and will only use the given cells.
       *
       * <p class="lifecycle"><b>Lifecycle:</b> Cell pointers can be added to a StaticGrid at any time.
       * However, before an HTML element is actually used as a cell by the StaticGrid
       * a call to {@link AbstractGrid#parseHtml} is necessary.</p>
       *
       * @param {Object} cellElement A DOM pointer to an HTML node.
       * The specified HTML node should be a "legal" cell for the StaticGrid
       * (i.e. should be defined according with the requirements for the
       * StaticGrid as described in the overview of this class). Moreover, 
       * nodes of any types are allowed.
       */
      addCell: function(cellElement) {
        if (!cellElement) {
          throw new IllegalArgumentException(NULL_CELL);
        }
        
        if (Helpers.isArray(cellElement)) {
          for (var i=0; i<cellElement.length; i++) {
            this.addCell(cellElement[i]);
          }
          return;
        } 
        
        var newCell = new Cell(cellElement);
        var table = newCell.getTable();
        if (!table || table != this.id) {
          throw new IllegalArgumentException(WRONG_GRID);
        }
        this.explicitSetting = true;
        this.tableCells.push(newCell);
      },
      
      /**
       * Setter method that specifies the root node to be used when searching for
       * grid cells. If specified, only descendants of the supplied node will
       * be checked.
       * <br>Anyway note that if nodes are explicitly set through the constructor or through 
       * the {@link StaticGrid#addCell} method, then the search will not be performed at all.
       *
       * <p class="default-value"><b>Default value:</b> the entire document.</p>
       *
       * <p class="lifecycle"><b>Lifecycle:</b> a root node can be specified at any time.
       * However, before a new search is performed for the StaticGrid
       * a call to {@link AbstractGrid#parseHtml} is necessary.</p>
       *
       * @param {Object} rootNode a DOM node to be used as starting point
       * when searching for grid cells.
       */
      setRootNode: function(rootNode) {
        if (rootNode && rootNode.getElementsByTagName) {
          this.rootEl = rootNode;
        } else {
          throw new IllegalArgumentException(INVALID_ROOT);
        }
      },
      
      /**
       * Creates an array containing all of the unique values of the "data-item" 
       * properties in all of the HTML elements associated to this grid during the 
       * {@link AbstractGrid#parseHtml} execution. 
       * The result of this method is supposed to be used as "Item List" of a Subscription.
       *
       * <BR>Execution of this method is pointless if HTML elements associated to this
       * grid through "data-item" specify an item position instead of an item name.
       * 
       * @return {String[]} The list of unique values found in the "data-item" properties
       * of HTML element of this grid.
       */
      extractItemList: function() {
        this.checkParsed();
        
        if (this.usingItems === false) {
          throw new IllegalStateException(NO_ITEMS_TO_EXTRACT);
        }
        
        var itemSymbolsSet = this.computeItemSymbolsSet();
                
        var incrementalGroup = [];
        
        for (var itemSymbol in itemSymbolsSet) {
          incrementalGroup.push(itemSymbol);
        }
        
        return incrementalGroup;
      },

      /**
       * @inheritdoc
       */
      parseHtml: function() {
        this.parsed = true;
        
        this.grid.cellsGarbageCollection();
        
        var lsTags;
        if (this.explicitSetting) {
          lsTags = this.tableCells;
         
          //on the next parseHtml call only newly added cells will be parsed
          this.tableCells = [];
          
        } else {
          lsTags = Cell.getLSTags(this.rootEl,this.tagsToCheck);
          
        }
        
        for (var j = 0; j < lsTags.length; j++) {
          
          var table = lsTags[j].getTable();
          
          if (!table || table != this.id) {
            //this is not the table you're looking for
            continue;
          }
          
          var row = lsTags[j].getRow();
          
          if (!row) {
            continue;
          }
          if (!isNaN(row)) {
            row = Number(row);
          }
         
          if (this.usingItems === null) {
            this.usingItems = isNaN(row);
            
          } else if (this.usingItems != isNaN(row)) {
            throw IllegalStateException(MIX_ROW_ITEMS);
          }
         
          if (!this.usingItems) {
            this.maxRow = row > this.maxRow ? row : this.maxRow;
          }

          var fieldSymbol = lsTags[j].getField();
          if (!fieldSymbol) {
            continue;
          }
          
          if (this.grid.alreadyInList(lsTags[j])) {
            continue;
          }
          
          this.grid.addCell(lsTags[j]);
          
        }
        
        if (!this.grid.isEmpty()) {
          //at least one cell, that's ok for us
          return;
        }
       
        throw new IllegalStateException(NO_CELLS);

      },
      
      /**
       * @protected
       * @ignore
       */
      computeFieldSymbolsSet: function(type) {
        var fieldSymbolsSet = {};
        this.grid.forEachCell(function(singleCell,itemSymbol,fieldSymbol) {
          if (singleCell.getFieldType() == type) {
            fieldSymbolsSet[fieldSymbol] = true;
          }
        });
        return fieldSymbolsSet;
      },
      
      /**
       * @protected
       * @ignore
       */
      computeItemSymbolsSet: function() {
        var itemSymbolsSet = {};
        this.grid.forEachRow(function(itemSymbol){
          itemSymbolsSet[itemSymbol] = true;
        });
        return itemSymbolsSet;
      },
      
      
/////////////////////////////////////VISUAL EXECUTION      
      /**
       * @protected
       * @ignore
       */
      updateRowExecution: function(key,serverValues) {
   
        var isNew = !this.values.getRow(key);
       
        //I need to find the position of the updating row
        var gridKey;
        if (this.usingItems) {
          //special case, item instead of row, only works for itemIsKey 
          //In this case upwardScroll and/or sorting settings are ignored
          //as each key has only one possible place to go
          gridKey = key;
          
        } else { // if (!this.usingItems) {
          
          //1 choose the new position
          
          var oldSortVal = this.sortField != null ? this.makeSortValue(this.values.get(key,this.sortField)) : null;
          var newSortVal = this.sortField != null ? this.makeSortValue(serverValues[this.sortField]) : null;
          var dontMove = oldSortVal == newSortVal || (typeof serverValues[this.sortField] == "undefined"); 
          if (this.sortField != null && dontMove == false) {
            gridKey = this.calculateSortedPosition(key,oldSortVal,newSortVal);
            
          } else if (isNew) {
            //No sort and new row: 
            //When upward scroll is not active, new updates are placed at the top of the model data table, so that old updates scroll downward. 
            //On the other hand, when upward scroll is active, new updates are placed at the bottom of the model data table.
            
            if (this.addOnTop) {
              gridKey = 1; 
            } else if (this.updateIsKey()) {
              //add on bottom with update is key means place the new row in the last row and scroll upward anything else (the top row will overflow and be deleted)
              gridKey = this.rowCount == this.maxRow ? this.rowCount : this.rowCount+1;
            } else {
              //add on bottom without update is key means place the new row on the bottom even if not visible
              gridKey = this.rowCount+1;
            }
            
          } else {
            //not new and doesn't move, simply update the row
            gridKey = this.keyRowMap.get(key);
          }
          
          
          if (this.updateIsKey() && this.maxRow == this.rowCount && isNew && this.sortField != null ) {
            //new row (isNew) on a full static grid (this.maxRow == this.rowCount) on a sorted table (this.sortField != null) on a grid where overflow is deleted
            
            //I need to remove the oldest row
            var oldest = this.getOldestKey();
            var freePos = this.scrollOut(oldest);
            
            if(freePos<gridKey) {
              //if the freePos is above our target location, as everything below such pos will scroll up our target location will scroll up too 
              gridKey--;
            }
            
            //let's place the new row in the freed position, makeroom will take care of placing it in its new proper location
            this.keyRowMap.set(key,freePos);
            
            //doing so we need to inc back rowCount (was decreased by scrollOut) and then faking this as non-new row to prevent 
            //another increase
            this.rowCount++;
            isNew = false;
            
          }
          
          //2 (if necessary) scroll other rows to make room for this one 
          
          if (this.keyRowMap.existReverse(gridKey) && this.keyRowMap.getReverse(gridKey) != key) {
            //the place we want is occupied, let's scroll
            
            //this method will move the key row to the gridKey position and will scroll other rows accordingly
            this.makeRoom(gridKey,key); //NOTE: in case of updateIsKey the method will handle the scrollOut itself
          }
          
          //update references
          this.keyRowMap.set(key,gridKey);
          
        } //END-if (!this.usingItems) 
        
        if (isNew) {
          this.rowCount++;
        }
        
        if (!this.updateIsKey() && gridKey > this.maxRow && !this.grid.getRow(gridKey)) {
          //new row out of sight
          //let's make new fake cells for it
          
          //updateIsKey can't pass from here: out-of-sight rows are completely deleted
          //gridKey > this.maxRow  === out of sight
          //!this.grid.getRow(toPos) no cells defined for the row
          
          var toCopyRow = this.grid.getRow(gridKey-1);
          var fakeRow = CellMatrix.scrollRow(toCopyRow,null,this.useInner);
          this.grid.insertRow(fakeRow,gridKey);
          
        }
        
        //3 fill formatter values
        this.fillFormattedValues(gridKey,serverValues);
        
        var upInfo = this.dispatchVisualUpdateEvent(key,gridKey,serverValues);
        
        //5 do visualUpdateExecution (ie place values on cells)
        this.visualUpdateExecution(gridKey,upInfo,key); 
  
      },
      
      /**
       * @private
       */
      dispatchVisualUpdateEvent: function(key,gridKey,serverValues) {
        //this references are used to handle reentrant calls; if an
        //updateRow call is performed during the VisualUpdate it is 
        //merged in this update instead of spawning a new update.
        //TODO if the sort value is changed during the second update call
        //the row may appear in the wrong place should override
        //mergeUpdate to prevent the case
        this.currentUpdateKey = gridKey;
        this.currentUpdateValues = serverValues;
        
        //call onVisualUpdate callback
        var upInfo = new VisualUpdate(this.grid,serverValues,gridKey);  
        this.dispatchEvent("onVisualUpdate",[key,upInfo,gridKey]);
        
        this.currentUpdateKey = null;
        this.currentUpdateValues = null;
        
        return upInfo;
      },
      
      /**
       * @protected
       * @ignore
       */
      getSlidingCell: function(cell,updateKey,col,num,noNumIndex) {
        if(this.usingItems) {
          return cell;
        }       
        
        return new SlidingCell(this,updateKey,col,num,noNumIndex);
      },
      
      /**
       * @protected
       * @ignore
       */
      getCellByKey: function(key,col,num) {
        var gridKey = this.keyRowMap.get(key);
        
        return this.grid.getCell(gridKey,col,num);
      },
      
      /**
       * @protected
       * @ignore
       */
      removeRowExecution: function(key) {
        var gridKey = this.usingItems ? key : this.keyRowMap.get(key);
        
        this.dispatchEvent("onVisualUpdate",[key,null,gridKey]);
        
        if (!this.usingItems) {
          if (gridKey != this.rowCount) {
            this.makeRoom(this.rowCount,key); //make the row to be deleted the last row of the grid
            gridKey = this.keyRowMap.get(key); //reload the gridkey
          }
//>>excludeStart("debugExclude", pragmas.debugExclude);         
          if (!ASSERT.verifyValue(this.rowCount,gridKey)) {
            gridsLogger.logError(LoggerManager.resolve(985));
          }
//>>excludeEnd("debugExclude");          
        }
        
        this.grid.forEachCellInRow(gridKey,function(cell) {
          cell.clean();
        });
        
        this.rowCount--;
        
        if (!this.usingItems) {
          this.keyRowMap.remove(key);
        }
      },
      
      /**
       * @private
       */
      scrollOut: function(key) {
        var cPos = this.keyRowMap.get(key);
        this.keyRowMap.remove(key);
        
        this.rowCount--;
        this.values.delRow(key);
        
        if (this.updateIsKey()) {
          this.removeFromFifo(key);
        }
        
        
        return cPos;
      },
      
      /**
       * @private
       */
      makeRoom: function(endPos,key) {
        //myRow will go @ endPos position
        //NOTE: the only thing that scroll is this.grid (and maps have to be updated)
        
        var origPos = this.keyRowMap.get(key);
        if (endPos == origPos) {
          //it actually doesn't move
          return;
        }
        
        //move this row to a fake row
        var fakeRow = origPos ? CellMatrix.scrollRow(this.grid.getRow(origPos),null,this.useInner) : null;
        var origKey = origPos ? this.keyRowMap.getReverse(origPos) : null;
        
        var unit; //unit to go to the next row to be moved
        var start; //first rows that moves
        var stop; //last row that moves
        
        if (origPos) {
          if (origPos > endPos) {
            //goDown
            start = origPos-1; 
            stop = endPos;
            unit = -1;
            
          } else {
            //goUp
            start = origPos+1;
            stop = endPos;
            unit = 1;
            
          }
        
        } else if (this.sortField != null || this.addOnTop) {
          // goDown
          stop = endPos; //X
          start = this.rowCount; //C
          unit = -1;
          
        } else {
          //goUp
          start = 1; //A
          stop = endPos; //X  //this.rowCount
          unit = 1;
        }
        
     
        for (var fromPos = start; fromPos-unit!=stop; fromPos+=unit) {
          var toPos = fromPos-unit;
          
          var fromRow = this.grid.getRow(fromPos);
          var toRow = this.grid.getRow(toPos);
          
          if (!toRow && !this.updateIsKey()) {
            //matrix will grow
           
            toRow = {};
            this.grid.insertRow(toRow,toPos);
//>>excludeStart("debugExclude", pragmas.debugExclude);            
            ASSERT.verifyNotOk(origPos);
//>>excludeEnd("debugExclude");            
          }

          if (!toRow) {
            //overflow
//>>excludeStart("debugExclude", pragmas.debugExclude);            
            ASSERT.verifyOk(this.updateIsKey());
            ASSERT.verifyValue(fromPos,start);
//>>excludeEnd("debugExclude");            
            
            var fromKey = this.keyRowMap.getReverse(fromPos); // fromPos 10 fromKey 4 toPos 11
            
            this.scrollOut(fromKey);
          
          } else {
            CellMatrix.scrollRow(fromRow,toRow,this.useInner);
            
            var fromKey = this.keyRowMap.getReverse(fromPos);
            this.keyRowMap.set(fromKey,toPos);
          }
          
        } 
        
        if (fakeRow) {
          CellMatrix.scrollRow(fakeRow,this.grid.getRow(endPos),this.useInner);   

          this.keyRowMap.set(origKey,endPos);
        } else {
          
          this.grid.forEachCellInRow(endPos,function(cell) {
            cell.clean();
          });
          
        }
        
        
      },
      
////////LIVE SORT
      
      /**
       * @private
       */
      calculateSortedPosition: function(toUpdateKey,oldSortVal,newSortVal) {
        var up = 1;
        var down = this.rowCount;
        var j = -1;
        
        //do a binary search to find the new place
        while (up < down) {
          j = Math.floor((up + down) /2);
          var thisKey = null;
          if (j <= this.rowCount) {
            var compare = this.keyRowMap.getReverse(j);
            if (compare == toUpdateKey) {
              thisKey = oldSortVal;
            } else {
              thisKey = this.makeSortValue(this.values.get(compare,this.sortField)); 
            }
          }
          if (this.isBefore(newSortVal,thisKey)) {
            down = j - 1;
          } else {
            up = j + 1;
          }
        }
        
        if (up == down) {
          //up == down, our place is right after or right before this one
          var compare = this.keyRowMap.getReverse(up);
          var compareKey = this.makeSortValue(this.values.get(compare,this.sortField));
          
          if (this.isBefore(newSortVal,compareKey)) {
            return up;
          } else {
            return up + 1;
          }
        } else {
          return up;
        }
      },
      
////////INITIAL SORT
      
      /**
       * @private
       */
      partition: function(newRowToKey, left, right, pivotIndex) {
        
        var pivotValue = this.makeSortValue(this.values.get(newRowToKey[pivotIndex],this.sortField));
        
        //Move pivot to end
        swap(newRowToKey,right,pivotIndex);
        
        var sI = left;
        for (var i=left; i<right; i++) {
          var iVal = this.makeSortValue(this.values.get(newRowToKey[i],this.sortField));
          if (!this.isBefore(pivotValue, iVal)) {
          //if (iVal < pivotValue) {
            swap(newRowToKey,i,sI);
            sI++;
          }
        }
        swap(newRowToKey,sI,right);
        return sI;
      },
      
      /**
       * @private
       */
      quickSort: function(newRowToKey,left,right) {
        if (left < right) {
          var pivot = Math.round(left + (right-left)/2);
          
          var pivotNewIndex = this.partition(newRowToKey, left, right, pivot);
          
          this.quickSort(newRowToKey,left,pivotNewIndex-1);
          this.quickSort(newRowToKey,pivotNewIndex+1,right);
        }
      },
      
      /**
       * @protected
       * @ignore
       */
      sortTable: function() {
        if (this.usingItems) {
          return;
        }
        
        var newRowToKey = {};
        this.keyRowMap.forEachReverse(function(row,key) {
          newRowToKey[row] = key;
        });
        
        this.quickSort(newRowToKey,1,this.rowCount);
        
        var tmpGrid = {};
        var newMap = new DoubleKeyMap();
        
        for (var i in newRowToKey) {
          newMap.set(newRowToKey[i],i);
          
          var oldKeyPerPos = this.keyRowMap.getReverse(i);
          if (newRowToKey[i] == oldKeyPerPos) {
            continue;
          }
          
          //let's move the current row to a safe place before we write upon it
          var targetRow = this.grid.getRow(i);
          tmpGrid[oldKeyPerPos] = CellMatrix.scrollRow(targetRow,null,this.useInner);
          
          var keyToMove = newRowToKey[i];
          
          var rowToMove = tmpGrid[keyToMove] ? tmpGrid[keyToMove] : this.grid.getRow(this.keyRowMap.get(keyToMove));
          
          CellMatrix.scrollRow(rowToMove,targetRow,this.useInner);
          
        }
        
        this.keyRowMap = newMap;
        
      },     
      
      /**
       * Adds a listener that will receive events from the StaticGrid 
       * instance.
       * <BR>The same listener can be added to several different StaticGrid 
       * instances.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> a listener can be added at any time.</p>
       * 
       * @param {StaticGridListener} listener An object that will receive the events
       * as shown in the {@link StaticGridListener} interface.
       * <BR>Note that the given instance does not have to implement all of the 
       * methods of the StaticGridListener interface. In fact it may also 
       * implement none of the interface methods and still be considered a valid 
       * listener. In the latter case it will obviously receive no events.
       */
      addListener: function(listener) {
        this._callSuperMethod(StaticGrid,"addListener",[listener]);
      },
      
      /**
       * Removes a listener from the StaticGrid instance so that it
       * will not receive events anymore.
       * 
       * <p class="lifecycle"><b>Lifecycle:</b> a listener can be removed at any time.</p>
       * 
       * @param {StaticGridListener} listener The listener to be removed.
       */
      removeListener: function(listener) {
        this._callSuperMethod(StaticGrid,"removeListener",[listener]);
      },
      
      /**
       * Returns an array containing the {@link StaticGridListener} instances that
       * were added to this client.
       * 
       * @return {StaticGridListener[]} an array containing the listeners that were added to this instance.
       * Listeners added multiple times are included multiple times in the array.
       */
      getListeners: function() {
        return this._callSuperMethod(StaticGrid,"getListeners");
      }
      
  };
  
  //closure compiler exports
  StaticGrid.prototype["addCell"] = StaticGrid.prototype.addCell;
  StaticGrid.prototype["setRootNode"] = StaticGrid.prototype.setRootNode;
  StaticGrid.prototype["extractItemList"] = StaticGrid.prototype.extractItemList;
  StaticGrid.prototype["parseHtml"] = StaticGrid.prototype.parseHtml;
  StaticGrid.prototype["addListener"] = StaticGrid.prototype.addListener;
  StaticGrid.prototype["removeListener"] = StaticGrid.prototype.removeListener;
  StaticGrid.prototype["getListeners"] = StaticGrid.prototype.getListeners;
  StaticGrid.prototype["updateRowExecution"] = StaticGrid.prototype.updateRowExecution;
  StaticGrid.prototype["removeRowExecution"] = StaticGrid.prototype.removeRowExecution;
//<----  Listener Interface  
  
  Inheritance(StaticGrid,AbstractGrid);
  return StaticGrid;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var StatusWidget = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  var ATTACH_TO_BORDER_WRONG = "The given value is not valid. Admitted values are no, left and right";
  var DISPLAY_TYPE_WRONG = "The given value is not valid. Admitted values are open, closed and dyna";

  var widgetDisabled = BrowserDetection.isProbablyIE(6,true);

  function generateLogoFallback() {
    var sImg = createDefaultElement("div");
    applyStyles(sImg,{
      textAlign: "center",
      textOverflow: "ellipsis",
      fontFamily: "Arial, Helvetica, sans-serif",
      fontSize: "10px",
      color: "#333333",
      verticalAlign: "middle",
      paddingTop: "3px",
      width: "32px",
      height: "32px",
      display: "none"
    });
    sImg.innerHTML = NETSTATE_LABEL;
    return sImg;
  }
  
  function generateImage(src) {
    var sImg = createDefaultElement("img");
    sImg.src = src;
    
    applyStyles(sImg,{
      display: "none",
      width: "28px",
      height: "28px"
    });
    
    return sImg;
  }

  // "S" image - Base64 encoding - green version
  var GREEN_IMG = generateImage("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGl2ZWxsb18xIiBkYXRhLW5hbWU9IkxpdmVsbG8gMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDEyNi4xMDgxIDE2OS41MzgiPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJTZnVtYXR1cmFfc2VuemFfbm9tZV83NyIgZGF0YS1uYW1lPSJTZnVtYXR1cmEgc2VuemEgbm9tZSA3NyIgeDE9IjUxLjQ2MTMiIHkxPSI3NC4wMDIyIiB4Mj0iLTM3LjgyMjkiIHkyPSI0OC43MTM2IiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDYwLjE5MDkgMTEuNjQ2OCkgcm90YXRlKC0zLjc0MTUpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmZiIvPgogICAgICA8c3RvcCBvZmZzZXQ9Ii4xNjQyIiBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9Ii45NzQzIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iLjM5NTMiIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjkwMjQiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIuNjY2IiBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9Ii43ODQzIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iLjk2NDciIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjYyMTMiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9Ii42Ii8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJTZnVtYXR1cmFfc2VuemFfbm9tZV83Ny0yIiBkYXRhLW5hbWU9IlNmdW1hdHVyYSBzZW56YSBub21lIDc3IiB4MT0iMzcuNzUzMyIgeTE9Ijk1LjkzMiIgeDI9Ii01MS40MDQyIiB5Mj0iNzAuNjc5MyIgeGxpbms6aHJlZj0iI1NmdW1hdHVyYV9zZW56YV9ub21lXzc3Ii8+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9IlNmdW1hdHVyYV9zZW56YV9ub21lXzc3LTMiIGRhdGEtbmFtZT0iU2Z1bWF0dXJhIHNlbnphIG5vbWUgNzciIHgxPSItNjMuNjgwNCIgeTE9IjM1LjE3NiIgeDI9IjU1Ljc4NTgiIHkyPSIzNS4xNzYiIHhsaW5rOmhyZWY9IiNTZnVtYXR1cmFfc2VuemFfbm9tZV83NyIvPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJTZnVtYXR1cmFfc2VuemFfbm9tZV83Ny00IiBkYXRhLW5hbWU9IlNmdW1hdHVyYSBzZW56YSBub21lIDc3IiB4MT0iLTYwLjk2MjMiIHkxPSIxMDUuNjEzIiB4Mj0iNTguNTA0OCIgeTI9IjEwNS42MTMiIHhsaW5rOmhyZWY9IiNTZnVtYXR1cmFfc2VuemFfbm9tZV83NyIvPgogIDwvZGVmcz4KICA8ZyBpZD0ibG9nb01hcmsiPgogICAgPGEgeGxpbms6aHJlZj0iYWRpZW50Ij4KICAgICAgPHBhdGggaWQ9ImxvZ29NYXJrX19QYXRoSXRlbV8iIGRhdGEtbmFtZT0ibG9nb01hcmsgJmFtcDtsdDtQYXRoSXRlbSZhbXA7Z3Q7IiBkPSJNMTExLjkxODMsNjguNDEyMWMtOS4wNzU2LTkuNDUyNy0yMi45ODk1LTExLjc1NDUtMzcuNzI4OS03LjY1ODFsLTE0LjY0NzMsNC4wNDUyYy02LjYyOCwxLjg0MTYtMTIuMzk5Mi0yLjEzMDktMTIuODY2OS04Ljg1NDctLjQ2NzctNi43MjM3LDQuNTQyNi0xMy42ODk1LDExLjE3MDYtMTUuNTMxMSwwLDAtMTQuNTk1Niw0LjA1NTktMjIuODQxOCw2LjM0NzUtMS42NDQ4LDQuMTcyMi0yLjQ0MjcsOC42MTk5LTIuMTM2NSwxMy4wMjEzLDEuMDA0OSwxNC40NDc1LDEzLjE5MTcsMTkuODY3NCwyNy40MzIzLDE1LjkxMTFsMTAuMDQ0Ni0yLjc2NjFjMzMuNzg5NS05LjM4OTEsNDIuOTM4OCwxOS43NjM3LDM2LjY0NjUsMzYuNDAxOCwxMi4yMTM2LTEwLjE5ODgsMTUuMzA1Ni0yNy44NTc0LDQuOTI3NC00MC45MTY5WiIgc3R5bGU9ImZpbGw6IHVybCgjU2Z1bWF0dXJhX3NlbnphX25vbWVfNzcpOyIvPgogICAgPC9hPgogICAgPGEgeGxpbms6aHJlZj0iYWRpZW50Ij4KICAgICAgPHBhdGggaWQ9ImxvZ29NYXJrX19QYXRoSXRlbV8tMiIgZGF0YS1uYW1lPSJsb2dvTWFyayAmYW1wO2x0O1BhdGhJdGVtJmFtcDtndDsiIGQ9Ik02NS42NTQ4LDg3Ljk5MzlsLTE0LjY0NjksNC4wNDY1Yy0xNS4zOTc0LDQuMjc4MS0zOS43MTM3LTMuMDcxNC0zNy41Mzc2LTMzLjM0MTktOC44MTIyLDEwLjQwMjMtMTAuMTM1NywyNS40OTQyLS45ODQxLDM3LjAwOTUsOS4zNDA4LDguNDU4NCwyMi45OTk5LDExLjc0OTMsMzcuNzQ1NCw3LjY1MjdsMTQuNjQ3MS00LjA0NTRjNi42MjY2LTEuODQxNCwxMi4zOTg5LDIuMTI5NSwxMi44NjY2LDguODUzMiwuNDY3Nyw2LjcyMzctNC41NDM2LDEzLjY5MjktMTEuMTcwMywxNS41MzQzLC4yODE2LS4wNzkzLDE0LjQ2MDktNC4wMTg5LDIyLjY1NDctNi4yOTQ4LDcuMTc3OS0yMi45ODQyLTYuNjg2Ni0zNC4xMDYtMjMuNTc0OS0yOS40MTQxWiIgc3R5bGU9ImZpbGw6IHVybCgjU2Z1bWF0dXJhX3NlbnphX25vbWVfNzctMik7Ii8+CiAgICA8L2E+CiAgICA8cGF0aCBpZD0ibG9nb01hcmtfX0NvbXBvdW5kUGF0aEl0ZW1fIiBkYXRhLW5hbWU9ImxvZ29NYXJrICZhbXA7bHQ7Q29tcG91bmRQYXRoSXRlbSZhbXA7Z3Q7IiBkPSJNNjcuNTg5OSwxLjc1NWwtMjMuOTY0NSw2LjYzNDNDMTcuODEzOCwxNS41NjA0LTEuNzAzNSw0Mi42OTg0LC4xMTc4LDY4Ljg4MjJjLjc4MDgsMTEuMjI1NCw1LjM1ODYsMjAuNDgxLDEyLjM2ODQsMjYuODI1OUMtLjkzODMsNzguODE1MSw4LjE2MTEsNTQuMjE5LDMwLjQwNzQsNDguMDM4MmM0Ljg1NzMtMS4zNTA0LDI3LjQzODUtNy42MjQ5LDI3LjQzODUtNy42MjQ5bC40MzQ3LS4wOTdjNi42MjY3LTEuODQxNCwxMi4zOTk1LDIuMTI5NCwxMi44NjcxLDguODUzbDQ2LjU1Ni0xMi45MzU4QzExNS44ODI0LDEwLjA0OTYsOTMuNDAxNS01LjQxNzgsNjcuNTg5OSwxLjc1NVptMTcuMzIzMiwzNS40MTU0Yy00Ljc4NTctMTIuMDg5My0xOC4zNjM2LTExLjg0MjctMjUuOTMxMS05LjczODhsLTEuNjY2NCwuNDM3Ni0yNy40NDAxLDcuNjI1Yy0zLjQ0MTUsLjk1NTctNi43NDI2LDIuMjgwMi05Ljg1NywzLjkyMTgsNS44MzI0LTguODQ4LDE0LjY2MTItMTUuODUwMywyNC44MDcyLTE4LjY2OTdsMjMuOTY2MS02LjYzNDZjMTIuODQ1Ny0zLjU2OTEsMjguNTMsMi4wNTE5LDMzLjM0NjQsMTguMjczMWwtMTcuMjI1LDQuNzg1NVoiIHN0eWxlPSJmaWxsOiB1cmwoI1NmdW1hdHVyYV9zZW56YV9ub21lXzc3LTMpOyIvPgogICAgPHBhdGggaWQ9ImxvZ29NYXJrX19Db21wb3VuZFBhdGhJdGVtXy0yIiBkYXRhLW5hbWU9ImxvZ29NYXJrICZhbXA7bHQ7Q29tcG91bmRQYXRoSXRlbSZhbXA7Z3Q7IiBkPSJNMTExLjkxODMsNjguNDEyMWMxMy40MjQ0LDE2Ljg5MjksNC4zMjQ1LDQxLjQ4OS0xNy45MjEzLDQ3LjY3LTQuODU3MywxLjM1MDQtMjcuNDM4Niw3LjYyNDktMjcuNDM4Niw3LjYyNDlsLS40MzQ2LC4wOTY4Yy02LjYyNjgsMS44NDE2LTEyLjM5OTQtMi4xMjkyLTEyLjg2NzEtOC44NTI5TDYuNjk5OSwxMjcuODg2OWMxLjgyMTMsMjYuMTgzOCwyNC4zMDMsNDEuNjUxMSw1MC4xMTQ1LDM0LjQ3ODRsMjMuOTY0NC02LjYzNDJjMjUuODExOS03LjE3MTIsNDUuMzI5Mi0zNC4zMDkzLDQzLjUwNzktNjAuNDkzLS43ODA4LTExLjIyNTQtNS4zNTg4LTIwLjQ4MS0xMi4zNjg0LTI2LjgyNlptLTMyLjAwNTYsNzQuODY4NWwtMjMuOTY0NCw2LjYzNDRjLTEyLjg0NTgsMy41NjkxLTI4LjUzMTctMi4wNTItMzMuMzQ4MS0xOC4yNzNsMTcuMjI1Mi00Ljc4NThjNC43ODU3LDEyLjA4OTYsMTguMzYzNiwxMS44NDMsMjUuOTMyNyw5Ljc0MDNsMS42NjYzLS40MzksMjcuNDM4Ni03LjYyNTFjMy40NDE0LS45NTU0LDYuNzQ0Mi0yLjI3ODcsOS44NTY5LTMuOTIxNy01LjgzMDYsOC44NDk2LTE0LjY1OTQsMTUuODUwNS0yNC44MDcyLDE4LjY2OTlaIiBzdHlsZT0iZmlsbDogdXJsKCNTZnVtYXR1cmFfc2VuemFfbm9tZV83Ny00KTsiLz4KICA8L2c+Cjwvc3ZnPg==");
  // "S" image - Base64 encoding - grey version
  var GREY_IMG = GREEN_IMG; // currently the color switch is not implemented
  // "S" image - Base64 encoding - light green version
  var LIGHT_GREEN_IMG = GREEN_IMG; // currently the color switch is not implemented

  var imgFallback = false;

  var DATA_STREAMING_SERVER = "DATA STREAMING STATUS";
  var ATTACHED = " (attached)";


  var NETSTATE_LABEL = "Net<br/>State";

  var STATUS_OPEN = 0;
  var STATUS_OPENING = 1;
  var STATUS_CLOSE = 2;
  var STATUS_CLOSING = 3;
  
  var NO = "no";
  var LEFT = "left";
  var RIGHT = "right";
  var ATTACH_TO_MAP = makeMap(NO,LEFT,RIGHT);
  
  var DYNA = "dyna";
  var OPEN = "open";
  var CLOSED = "closed";
  var DISPLAY_TYPES = makeMap(DYNA,OPEN,CLOSED);
  
  function makeMap() {
    var res = {};
    for (var i=0; i<arguments.length; i++) {
      res[arguments[i]] = true;
    }
    return res;
  }
  
  function applyStyles(element,styles) {
    for (var i in styles) {
      element.style[i] = styles[i];
    }
  }
  
  function createDefaultElement(tagName) {
    var el = document.createElement(tagName);
    applyStyles(el,{
      "backgroundColor": "transparent"
    });
    return el;
  }

  function checkCSSAnimation() {
    var toCheck = ["animationName", "WebkitAnimationName", "MozAnimationName", "OAnimationName", "msAnimationName"]; 
    var testEl = document.createElement("div");
    var testElStyle = testEl.style;
    
    for ( var i = 0; i < toCheck.length; i++ ) {
      if(typeof testElStyle[toCheck[i]] != "undefined") {
        return true;
      }
    }
    return false;
  }
  var TRANSITION_SUPPORTED = checkCSSAnimation();

  /**
   * Creates an object to be used to listen to events from a 
   * {@link LightstreamerClient} instance.
   * The new object will create a small visual widget to display the status of
   * the connection.
   * The created widget will have a fixed position so that it will not move
   * when the page is scrolled. 
   * @constructor
   * 
   * @param {String} attachToBorder "left" "right" or "no" to specify if the generated
   * widget should be attached to the left border, right border or should not be 
   * attached to any border. In the latter case, it should be immediately positioned
   * manually, by acting on the DOM element obtained through {@link StatusWidget#getDomNode}.
   * @param {String} distance The distance of the widget from the top/bottom (depending
   * on the fromTop parameter). The specified distance must also contain the units
   * to be used: all and only the units supported by CSS are accepted. 
   * @param {boolean} fromTop true or false to specify if the distance is related
   * to the top or to the bottom of the page.
   * @param {String} [initialDisplay] "open" "closed" or "dyna" to specify if the generated
   * widget should be initialized open, closed or, in the "dyna" case, open and then 
   * immediately closed. By default "dyna" is used. 
   * If attachToBorder is set to "no" then this setting has no effects. 
   * 
   * @throws {IllegalArgumentException} if an invalid value was passed as 
   * attachToBorder parameter.
   * 
   * @exports StatusWidget
   * @class This class is a simple implementation of the ClientListener interface, which will display a
   * small widget with details about the status of the connection. The widget contains the "S" logo
   * and three tiny leds.
   * <ul>
   * <li>The left led indicates the transport in use: green if WS/WSS; yellow if HTTP/HTTPS.</li>
   * <li>The center led indicates the mode in use: green if streaming; yellow if polling.</li>
   * <li>The right led indicates where the physical connection is held: green if this LightstreamerClient
   * is the master instance, holding the connection; yellow if this LightstreamerClient instance is a slave
   * attached to the master Lightstreamer Client instance.</li>
   * </ul>
   * By rolling over or clicking over the widget, a panel appears with full details.
   * <BR>Note that the widget is generated using some features not available
   * on old browsers but as long as the 
   * <a href="http://tools.ietf.org/html/rfc2397">"data" URL scheme</a>  is supported 
   * the minimal functions of the widget will work (for instance, IE<=7 does not have support 
   * for the "data" URL scheme).
   * <BR>Also note that on IE if "Quirks Mode" is activated the widget will not 
   * be displayed correctly. Specify a doctype on the document where the widget
   * is going to be shown to prevent IE from entering the "Quirks Mode".
   * 
   * @extends ClientListener
   */
  var StatusWidget = function(attachToBorder, distance, fromTop, initialDisplay) {
    if (widgetDisabled) {
      return;
    }

    this.ready = false;
    this.readyStatusOpen = false;
    this.cachedStatus = null;
    this.lsClient = null;


    attachToBorder = attachToBorder || LEFT;
    if (!ATTACH_TO_MAP[attachToBorder]) {
      throw new IllegalArgumentException(ATTACH_TO_BORDER_WRONG);
    }

    initialDisplay = initialDisplay || CLOSED;
    if (!DISPLAY_TYPES[initialDisplay]) {
      throw new IllegalArgumentException(DISPLAY_TYPE_WRONG);
    }

    this.isLeftBorder = attachToBorder === LEFT;

    var topClosed = fromTop ? distance : "auto";
    var bottomClosed = fromTop ?  "auto" : distance;
        
///////////////////////HTML generation

    this.statusWidgetContainer = createDefaultElement("div");
    var widgetMainNode = createDefaultElement("div");
    this.statusTextsContainer =  createDefaultElement("div");

    applyStyles(this.statusWidgetContainer,{
      "zIndex": "99999"
    });

    applyStyles(widgetMainNode, {
      "width": "42px",
      "height": "42px",
      "opacity": "0.95",
      "filter": "alpha(opacity"+"=95)",
      "backgroundColor": "#003D06",
      "zIndex": "99999",
      "position": "relative"
    });



    applyStyles(this.statusTextsContainer,{
      "width":"245px",
      "height":"42px",
      "backgroundColor": "#E2E2E2",
      "fontFamily": "'Open Sans',Arial,sans-serif",
      "fontSize": "11px",
      "color": "#003D06",

      "position": "absolute",
      "zIndex": "99998",

      "visibility": "hidden",
      "opacity": "0",
      "filter": "alpha(opacity"+"=0)",

      "transition": "all 0.5s",
      "MozTransition": "all 0.5s",
      "-webkit-transition": "all 0.5s",
      "OTransition": "all 0.5s",
      "-ms-transition": "all 0.5s"

      /*
      "transition-duration": "0.5s",
      "MozTransitionDuration": "0.5s",
      "-webkit-transition-duration": "0.5s",
      "OTransitionDuration": "0.5s",
      "-ms-transition-duration": "0.5s",

      "transition-timing-function": "ease",
      "MozTransitionTimingFunction": "ease",
      "-webkit-transition-timing-function": "ease",
      "OTransitionTimingFunction": "ease",
      "-ms-transition-timing-function": "ease",

      "transition-property": "all",
      "MozTransitionProperty": "all",
      "-webkit-transition-property": "all",
      "OTransitionProperty": "all",
      "-ms-transition-property": "all"
      */

    });



    if (attachToBorder == "no") {
      applyStyles(this.statusWidgetContainer,{
        "position": "absolute"
      });
      applyStyles(widgetMainNode, {
        "borderRadius": "4px",
        "float": "left"
      });
      applyStyles(this.statusTextsContainer,{
        "borderTopRightRadius": "4px",
        "borderBottomRightRadius": "4px",
        "left": "38px"
      });

    } else {
      applyStyles(this.statusWidgetContainer, {
        "position": "fixed",
        "top": topClosed,
        "bottom": bottomClosed
      });

      if (attachToBorder == LEFT) {
        applyStyles(this.statusWidgetContainer, {
          "left": "0px"
        });
        applyStyles(widgetMainNode, {
          "borderTopRightRadius": "4px",
          "borderBottomRightRadius": "4px",
          "float": "left"
        });
        applyStyles(this.statusTextsContainer, {
          "borderTopRightRadius": "4px",
          "borderBottomRightRadius": "4px",
          "left": "38px"
        });

      } else {//if (attachToBorder == RIGHT)
        applyStyles(this.statusWidgetContainer, {
          "right": "0px"
        });
        applyStyles(widgetMainNode, {
          "borderTopLeftRadius": "4px",
          "borderBottomLeftRadius": "4px",
          "float": "right"
        });
        applyStyles(this.statusTextsContainer, {
          "borderTopLeftRadius": "4px",
          "borderBottomLeftRadius": "4px",
          "right": "38px"
        });

      }
    }

    this.statusWidgetContainer.appendChild(widgetMainNode);
    this.statusWidgetContainer.appendChild(this.statusTextsContainer);


    var imageContainer  = createDefaultElement("div");
    applyStyles(imageContainer,{
      "position": "absolute",
      "top": "4px",
      "left": "7px",
      "width": "28px",
      "height": "28px"
    });


    widgetMainNode.appendChild(imageContainer);
    this.initImages(imageContainer);

    this.transportLed = new Led(widgetMainNode,1);
    this.streamingLed = new Led(widgetMainNode,2);
    this.masterLed = new Led(widgetMainNode,3);

    this.dataStreamingServer = createDefaultElement("div");
    applyStyles(this.dataStreamingServer,{
      "position": "absolute",
      "top": "7px",
      "left": "13px"
    });
    this.statusTextsContainer.appendChild(this.dataStreamingServer);

    this.statusText = createDefaultElement("div");
    applyStyles(this.statusText,{
      "position": "absolute",
      "top": "21px",
      "left": "13px"
    });
    this.statusTextsContainer.appendChild(this.statusText);

    this.updateWidget(OFF_LED,OFF_LED,OFF_LED,"Ready",DATA_STREAMING_SERVER,this.greyImg);
    this.updateWidgetS(this.greyImg);
        // added temporarily, as currently the color switch is not implemented

    this.activate();

    this.displayStatus = STATUS_CLOSE;
    this.pinned = false;
    if (initialDisplay != CLOSED) {
      this.openDetails(true);

      if (initialDisplay == DYNA) {
        Executor.addTimedTask(this.getMouseoutHandler(),1000);
      } else {
        this.pinned = true;
      }
    }

    var trHandler = this.getTransitionendHandler();
    Helpers.addEvent(this.statusTextsContainer,"transitionend",trHandler);
    Helpers.addEvent(this.statusTextsContainer,"webkitTransitionEnd",trHandler);
    Helpers.addEvent(this.statusTextsContainer,"MSTransitionEnd",trHandler);
    Helpers.addEvent(this.statusTextsContainer,"oTransitionEnd",trHandler);

    Helpers.addEvent(this.statusWidgetContainer,"click",this.getClickHandler());

    Helpers.addEvent(this.statusWidgetContainer,"mouseover",this.getMouseoverHandler());
    Helpers.addEvent(this.statusWidgetContainer,"mouseout",this.getMouseoutHandler());

  };
  

    
  StatusWidget.prototype = {
      
      /**
       * Inquiry method that gets the DOM element that makes the widget container.
       * It may be necessary to extract it to specify some extra styles or to position
       * it in case "no" was specified as the attachToBorder constructor parameter.
       *
       * @return {Object} The widget DOM element.
       */
      getDomNode: function() {
        return this.statusWidgetContainer;
      },

      /**
       * @private
       */
      initImages: function(imageContainer) {

        this.greyImg = GREY_IMG.cloneNode(true);
        imageContainer.appendChild(this.greyImg);

        if (!imgFallback && this.greyImg.height != 32 && BrowserDetection.isProbablyIE(7)) {
          imageContainer.removeChild(this.greyImg);

          //fallback!
          GREY_IMG = GREEN_IMG = LIGHT_GREEN_IMG = generateLogoFallback();
          imgFallback = true;

          this.greyImg = GREY_IMG.cloneNode(true);
          imageContainer.appendChild(this.greyImg);
        }

        this.greenImg = GREEN_IMG.cloneNode(true);
        imageContainer.appendChild(this.greenImg);

        this.lgreenImg = LIGHT_GREEN_IMG.cloneNode(true);
        imageContainer.appendChild(this.lgreenImg);

      },

      /**
       * @private
       */
      activate: function() {
        if (this.ready) {
          return;
        }
        
        var body = document.getElementsByTagName("body");
        if (!body || body.length == 0) {
          //no body means we can't append; if there is no body DOMContentLoaded cannot have already being fired, so let's wait for it 
          var that = this;
          //this widget uses styles not available on older browsers so that we do not need to setup a fallback to help browsers not having the DOMContentLoadEvent
          Helpers.addEvent(document,"DOMContentLoaded",function() {
            document.getElementsByTagName("body")[0].appendChild(that.statusWidgetContainer);
            that.ready = true;
            if (that.cachedStatus) {
              that.onStatusChange(that.cachedStatus);
            }
            if (that.displayStatus == STATUS_OPEN) {
              that.openDetails();
            } else {
              that.closeDetails();
            }
          });
          
        } else {
          body[0].appendChild(this.statusWidgetContainer);
          this.ready = true;
        }
      },
      
      /**
       * @inheritdoc
       */
      onListenStart: function(lsClient) {
        if(widgetDisabled) {
          return;
        }
        this.onStatusChange(lsClient.getStatus());
        this.lsClient = lsClient;
      },

      /**
       * @inheritdoc
       */
      onListenEnd: function() {
        if(widgetDisabled) {
          return;
        }

        this.updateWidget(OFF_LED,OFF_LED,OFF_LED,"Ready",DATA_STREAMING_SERVER);
        this.lsClient = null;
      },

      /**
       * @private
       */
      updateWidget: function(l1,l2,l3,text,title,sImage) {

        this.transportLed.changeColor(l1);
        this.streamingLed.changeColor(l2);
        this.masterLed.changeColor(l3);

        this.statusText.innerHTML = text;
        this.dataStreamingServer.innerHTML = "<b>" + title + "</b>";

        // this.updateWidgetS(sImage,true);
            // removed temporarily, as currently the color switch is not implemented 
      },

      updateWidgetS: function(sImage,stopBlinking) {
        if (stopBlinking) {
          this.stopBlinking();
        }

        if (this.widgetImageNode) {
          this.widgetImageNode.style.display = "none";
        }
        sImage.style.display = "";
        this.widgetImageNode = sImage;
      },

      /**
       * @private
       */
      stopBlinking: function() {
        if (!this.blinkThread) {
          return;
        }
        this.blinkFlag = false;
        Executor.stopRepetitiveTask(this.blinkThread);
        this.blinkThread = null;
      },

      /**
       * @private
       */
      startBlinking: function() {
        // this.blinkThread = Executor.addRepetitiveTask(this.doBlinking,BLINK_TIME,this);
            // removed temporarily, as currently the color switch is not implemented 
      },

      /**
       * @private
       */
      doBlinking: function() {
        this.updateWidgetS(this.blinkFlag?this.greyImg:this.greenImg);
        this.blinkFlag = !this.blinkFlag;
      },
      
      /**
       * @inheritdoc
       */
      onStatusChange: function(status) {
        if (!this.ready || widgetDisabled) {
          this.cachedStatus = status;
          return;
        }

        var isMaster = this.lsClient && ((this.lsClient.isMaster && this.lsClient.isMaster()) || (this.lsClient.connectionSharing && this.lsClient.connectionSharing.isMaster()));

        var masterLed = isMaster ? GREEN_LED : YELLOW_LED;
        var incipit =  isMaster ? DATA_STREAMING_SERVER :  DATA_STREAMING_SERVER+ATTACHED;

        if (status == LightstreamerConstants.DISCONNECTED) {
          this.updateWidget(OFF_LED,OFF_LED,OFF_LED,"Disconnected",DATA_STREAMING_SERVER,this.greyImg);
          
        } else if (status == LightstreamerConstants.CONNECTING) {
          this.updateWidget(OFF_LED,OFF_LED,masterLed,"Connecting...",incipit,this.greyImg);
          this.startBlinking();

        } else if (status.indexOf(LightstreamerConstants.CONNECTED) == 0) {

          var HEAD_STATUS = "Connected over ";
          var separator = this.lsClient && this.lsClient.connectionDetails.getServerAddress().indexOf("https") == 0 ? "S in " : " in ";

          if (status == LightstreamerConstants.CONNECTED + LightstreamerConstants.SENSE) {
            this.updateWidget(YELLOW_LED, YELLOW_LED, masterLed, "Stream-sensing...",incipit,this.greyImg);
            this.startBlinking();

          } else if (status == LightstreamerConstants.CONNECTED + LightstreamerConstants.WS_STREAMING) {
            this.updateWidget(GREEN_LED, GREEN_LED, masterLed, HEAD_STATUS+"WS"+separator+"streaming mode",incipit,this.greenImg);

          } else if (status == LightstreamerConstants.CONNECTED + LightstreamerConstants.HTTP_STREAMING) {
            this.updateWidget(YELLOW_LED, GREEN_LED, masterLed, HEAD_STATUS+"HTTP"+separator+"streaming mode",incipit,this.greenImg);

          } else if (status == LightstreamerConstants.CONNECTED + LightstreamerConstants.WS_POLLING) {
            this.updateWidget(GREEN_LED, YELLOW_LED, masterLed, HEAD_STATUS+"WS"+separator+"polling mode",incipit,this.greenImg);

          } else if (status == LightstreamerConstants.CONNECTED + LightstreamerConstants.HTTP_POLLING) {
            this.updateWidget(YELLOW_LED, YELLOW_LED, masterLed, HEAD_STATUS+"HTTP"+separator+"polling mode",incipit,this.greenImg);
          }

        } else if (status == LightstreamerConstants.STALLED) {
          this.updateWidget(OFF_LED,OFF_LED,masterLed,"Stalled",incipit,this.lgreenImg);

        } else if (status == LightstreamerConstants.TRYING_RECOVERY) {
          this.updateWidget(OFF_LED,OFF_LED,masterLed,"Recovering...",incipit,this.lgreenImg);
          this.startBlinking();

        } else {
          this.updateWidget(OFF_LED,OFF_LED,masterLed,"Disconnected (will retry)",incipit,this.greyImg);
        }

      },
      

      openDetails: function(force) {
        if (this.displayStatus == STATUS_OPEN ||this.displayStatus == STATUS_OPENING) {
          return;
        }
        this.displayStatus = STATUS_OPENING;
        applyStyles(this.statusTextsContainer,{
          "visibility": "",
          "opacity": "1",
          "filter": "alpha(opacity"+"=100)"
        });

        if (!TRANSITION_SUPPORTED || force) {
          this.transitionendHandler();
        }
      },

      closeDetails: function(force) {
        if (this.displayStatus == STATUS_CLOSE ||this.displayStatus == STATUS_CLOSING) {
          return;
        }
        this.displayStatus = STATUS_CLOSING;
        applyStyles(this.statusTextsContainer, {
          "visibility": "hidden",
          "opacity": "0",
          "filter": "alpha(opacity" + "=0)"
        });

        this.pinned = false;

        if (!TRANSITION_SUPPORTED || force) {
          this.transitionendHandler();
        }
      },

      /**
       * @private
       */
      getMouseoverHandler: function() {
        var that = this;
        return function() {
          that.openDetails();
        };
      },

      /**
       * @private
       */
      getMouseoutHandler: function() {
        var that = this;
        return function() {
          if (!that.pinned) {
            that.closeDetails();
          }
        };
      },

      /**
       * @private
       */
      getClickHandler: function() {
        var that = this;
        return function() {
          that.clickHandler();
        };
      },

      /**
       * @private
       */
      clickHandler: function() {
        if (!this.pinned) {
          this.pinned = true;
          this.openDetails();
        } else {
          this.closeDetails();
        }
      },

      /**
       * @private
       */
      getTransitionendHandler: function() {
        var that = this;
        return function() {
          that.transitionendHandler();
        };
      },

      /**
       * @private
       */
      transitionendHandler: function() {
        if (this.statusTextsContainer.style["visibility"] == "hidden") {
          this.toggleState = STATUS_CLOSE;
        } else {
          this.toggleState = STATUS_OPEN;
        }
      }
  };

  var GREEN_LED = "#00C922";
  var YELLOW_LED = "#F4DD80";
  var OFF_LED = "#003D06";
  function Led(container,ledCount) {
    this.led = createDefaultElement("div");
    applyStyles(this.led,{
      "position": "absolute",
      "bottom": "3px",
      "left": 5+11*(ledCount-1)+"px",
      "width": "10px",
      "height": "3px",
      "borderRadius": "2px",
      "backgroundColor": OFF_LED
    });
    container.appendChild(this.led);
  }
  Led.prototype.changeColor = function(newColor) {
    applyStyles(this.led,{"backgroundColor": newColor});
  };


  
  //closure compiler eports
  StatusWidget.prototype["onStatusChange"] = StatusWidget.prototype.onStatusChange;
  StatusWidget.prototype["onListenStart"] = StatusWidget.prototype.onListenStart;
  StatusWidget.prototype["onListenEnd"] = StatusWidget.prototype.onListenEnd;
  StatusWidget.prototype["getDomNode"] = StatusWidget.prototype.getDomNode;

  return StatusWidget;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var AlertAppender = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
  
  /**
   * Constructor for AlertAppender.
   * @constructor
   * 
   * @param {String} level The threshold level at which the SimpleLogAppender is created.
   * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not
   * or wrongly specified INFO is assumed.
   * @param {String} category The category this appender should listen to.
   * If not specified the appender will get log for every available category.
   * See {@link SimpleLogAppender#setCategoryFilter}.
   * @param {Number} dim Number of log messages to wait before sending a cumulative alert.
   * This parameter is optional, if lower than 1 or no value is passed, 5 is assumed.
   * 
   * @exports AlertAppender
   * @class AlertAppender extends SimpleLogAppender and implements publishing of log messages
   * by issuing the specific browser alert.
   * AlertAppender instance objects can be configured with a window dimension, so as to wait 
   * for the specified number of messages before sending an alert.
   * 
   * @extends SimpleLogAppender
   */
  var AlertAppender = function(level, category, dim) {

    this._callSuperConstructor(AlertAppender, [level, category]);
  
    // log lines to be buffered before the alert is shown
    if ( !dim || dim < 0 ) {
      this.alertDim = 5; 
    } else {
      this.alertDim = dim;
    }
      
    // rows already buffered
    this.accumulated = 0; 
    // buffer
    this.buffer = new BufferAppender(level, category);

  };

  AlertAppender.prototype = {

    /**
     * @private
     */
    showAlert: function(text) {
      alert(text);
    },
  
    /**
     * Add a log message in a AlertAppender private instance. If the accumulated messages exceed the 
     * limit a show alert function is called.
     * 
     * @param {String} category the logger category that produced the given message.
     * @param {String} level the logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL.
     * @param {String} mex the message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * @param {String} header a header for the message
     */
    log: function(cat, level, mex, header) {
      this.accumulated++;
      this.buffer.log(cat, level, mex, header);
      if (this.accumulated >= this.alertDim) {
        this.accumulated = 0;
        
        Executor.addTimedTask(this.showAlert,0,this,[this.buffer.getLog(this.alertDim,"\n","",false,this.myLevel)]);
        
        this.buffer = new BufferAppender();
      }
    }

  };

  AlertAppender.prototype["log"] = AlertAppender.prototype.log;
  
  Inheritance(AlertAppender, SimpleLogAppender);
  return AlertAppender;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var ConsoleAppender = /*@__PURE__*/(function() {
  /**
   * Constructor for ConsoleAppender.
   * @constructor
   * 
   * @throws {IllegalStateException} if the environment does not have any console object 
   * or if such console is currently inaccessible. 
   * 
   * @param {String} level The threshold level at which the SimpleLogAppender is created.
   * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not
   * or wrongly specified INFO is assumed.
   * @param {String} category The category this appender should listen to.
   * If not specified the appender will get log for every available category.
   * See {@link SimpleLogAppender#setCategoryFilter}.
   * 
   * @exports ConsoleAppender
   * @class ConsoleAppender extends SimpleLogAppender printing messages
   * on the console.
   * 
   * @extends SimpleLogAppender
   */
  var ConsoleAppender = function(level, category) {
    if (typeof console == "undefined") {
      throw new IllegalStateException("This appender can't work if a console is not available. Enable the Browser console if possible or change appender.");
    }
    
    this._callSuperConstructor(ConsoleAppender, [level, category]);
  };

 
  ConsoleAppender.prototype = {

    /**
     * Publish a log message on the console. 
     * 
     * @param {String} category the logger category that produced the given message.
     * @param {String} level the logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL.
     * @param {String} mex the message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * @param {String} header a header for the message
     * 
     */
    log: function(category, level, mex, header) {
      mex = this.composeLine(category, level, mex, header);
      switch(level) {
        case "DEBUG": 
          if (console.debug) {
            console.debug(mex);
            return;
          }
          break;
        case "INFO": 
          if (console.info) {
            console.info(mex);
            return;
          }
          break;
        case "WARN": 
          if (console.warn) {
            console.warn(mex);
            return;
          }
          //do not break
        default: //FATAL || ERROR
          if (console.error) {
            console.error(mex);
            return;
          }
      }      console.log(mex);
    }
  };
  
  //c�losure compile exports
  ConsoleAppender.prototype["log"] = ConsoleAppender.prototype.log;  
  
  Inheritance(ConsoleAppender, SimpleLogAppender);
  return ConsoleAppender;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var DOMAppender = /*@__PURE__*/(function() {
  Environment.browserDocumentOrDie();
    
  /**
   * Constructor for DOMAppender.
   * @constructor
   * 
   * @throws {IllegalArgumentException} if the DOMElement parameter is missing.
   * 
   * @param {String} level The threshold level at which the SimpleLogAppender is created.
   * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not
   * or wrongly specified INFO is assumed.
   * @param {String} category The category this appender should listen to.
   * If not specified the appender will get log for every available category.
   * See {@link SimpleLogAppender#setCategoryFilter}.
   * @param {Object} DOMObj The DOM object to use for log message publishing.
   * 
   * @exports DOMAppender
   * @class DOMAppender extends SimpleLogAppender and implements the publishing 
   * of log messages by incrementally extending the text content of a supplied
   * container DOM object. Log lines are separated by &lt;br&gt; elements.
   * 
   * @extends SimpleLogAppender
   */
  var DOMAppender = function(level, category, DOMObj) {

    this._callSuperConstructor(DOMAppender, [level, category]);
    
    if (!DOMObj) {
      throw new IllegalArgumentException("a DOMElement instance is necessary for a DOMAppender to work.");
    }
    
    this.DOMObj = DOMObj; 
    
    this.nextOnTop = false;
    this.useInner = false;

  };
  
  
  DOMAppender.prototype = {
  
    /**
     * Setter method that specifies how new log lines have to be included 
     * in the given container DOM object. In fact, some log lines may contain
     * custom parts (for instance, field values) that may be expressed in HTML
     * and intended for HTML rendering. In this case, instead of putting the
     * log messages in text nodes, the appender can be set for directly adding messages to the
     * innerHTML of the container object.
     * <BR>WARNING: When turning HTML interpretation on, make sure that
     * no malicious code may reach the log.
     * 
     * @param {boolean} useInnerHtml Flag to switch On/Off the use of innerHTML. 
     * false by default.
     */
    setUseInnerHtml: function(useInnerHtml) {
      this.useInner = useInnerHtml === true;
    },
    
    /**
     * Setter method that specifies if new log messages have to be
     * shown on top of the previous ones.
     * 
     * @param {boolean} [nextOnTop] Layout of log messages in the DOM object; 
     * if true the newest log line is displayed on top of DOM object.
     * false by default.
     */
    setNextOnTop: function(nextOnTop) {
      this.nextOnTop = nextOnTop === true;
    },
    
    /**
     * Publish a log message on the specified DOM object. 
     * 
     * @param {String} category the logger category that produced the given message.
     * @param {String} level the logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL.
     * @param {String} mex the message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * @param {String} header a header for the message
     * 
     */  
    log: function(category, level, mex, header) {
      var _line = this.composeLine(category, level, mex, header);
      
      if (this.useInner) {
        if (this.nextOnTop) {
          this.DOMObj.innerHTML = _line + "<br>" + this.DOMObj.innerHTML;
        } else {
          this.DOMObj.innerHTML += _line + "<br>";
        }
      } else {
        if (this.nextOnTop) {
          var lineObj = document.createTextNode(_line);
          var brObj = document.createElement("br");

          this.DOMObj.insertBefore(brObj,this.DOMObj.firstChild);
          this.DOMObj.insertBefore(lineObj,this.DOMObj.firstChild);
        } else {
          var lineObj = document.createTextNode(_line);
          var brObj = document.createElement("br");
      
          this.DOMObj.appendChild(lineObj);
          this.DOMObj.appendChild(brObj);
        }       
      }
      
    }

  };

  //closure compiler externs
  DOMAppender.prototype["setUseInnerHtml"] = DOMAppender.prototype.setUseInnerHtml;
  DOMAppender.prototype["setNextOnTop"] = DOMAppender.prototype.setNextOnTop;
  DOMAppender.prototype["log"] = DOMAppender.prototype.log;
  
  Inheritance(DOMAppender, SimpleLogAppender);
  return DOMAppender;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var FunctionAppender = /*@__PURE__*/(function() {
  /**
   * Callback for {@link FunctionAppender}
   * @callback FunctionLogConsumer
   * @param {String} message the log message to be consumed. If a more detailed insight
   * on the message details is required it is suggested to implement a custom {@link SimpleLogAppender}. 
   */
  
  /**
   * Constructor for FunctionAppender.
   * @constructor
   * 
   * @param {String} level The threshold level at which the SimpleLogAppender is created.
   * It should be one of "DEBUG", "INFO", "WARN", "ERROR" and "FATAL". If not
   * or wrongly specified INFO is assumed.
   * @param {String} category The category this appender should listen to.
   * If not specified the appender will get log for every available category.
   * See {@link SimpleLogAppender#setCategoryFilter}.
   * @param {FunctionLogConsumer} functionToCall a well defined function to call passing log messages.
   * The function will be invoked with a single String argument. If a more detailed insight
   * on the message details is required it is suggested to implement a custom SimpleLogAppender. 
   * @param {Object} [objectToApplyTo] an instance of object to apply the functionToCall to.
   * 
   * @exports FunctionAppender
   * @class FunctionAppender extends SimpleLogAppender and implements the publishing 
   * of log messages by invocation of a custom function.
   *
   * @extends SimpleLogAppender
   */
  var FunctionAppender = function(level, category, functionToCall, objectToApplyTo) {
    this._callSuperConstructor(FunctionAppender, [level, category]);
          
    this.functionToCall = functionToCall;
    this.objectToApplyTo = objectToApplyTo || null;
  };

    
  FunctionAppender.prototype = {
   
    /**
     * Publish a log message by calling the specified function.
     * 
     * @param {String} category the logger category that produced the given message.
     * @param {String} level the logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL.
     * @param {String} mex the message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * @param {String} header a header for the message
     * 
     */
    log: function(category, level, mex, header) {
      var toCall = this.functionToCall;
        
      if (toCall.apply) {
        var _line = this.composeLine(category, level, mex, header);
        try {
          toCall.apply(this.objectToApplyTo, [_line]);
        } catch(_e) {
          // Nothing to do.
        }
      } //else no way to call it, btw it should never be the case as all the supported browser have the apply method
    }
  };
  
  FunctionAppender.prototype["log"] = FunctionAppender.prototype.log;  

  Inheritance(FunctionAppender, SimpleLogAppender); 
  return FunctionAppender;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var SimpleLogger = /*@__PURE__*/(function() {
  /**
   * Constructor for SimpleLogger.
   * @constructor
   *
   * @param provider A SimpleLoggerProvider object instance used to dispatch the log messages
   * produced by this Logger instance.
   * @param category A category name for the Logger instance.
   * 
   * @exports SimpleLogger
   * @class {@link Logger} implementation returned by the {@link SimpleLoggerProvider}.
   * @extends Logger
   */
  var SimpleLogger = function(provider, category) {
    
    this.logProvider = provider;
    this.category = category;
    
    this.minLevel = "DEBUG";
  };
  
  SimpleLogger.prototype = {
      
    /**
     * Receives log messages at FATAL level.
     * 
     * @param {String} message The message to be logged.  
     * @param {Error} [exception] An Exception instance related to the current log message.
     * 
     * @see LoggerProvider
     */
    fatal: function(mex,exception) {
      if ( this.isFatalEnabled() ) {
        this.logProvider.dispatchLog(this.category, "FATAL", mex);
      }
      return;
    },    
    
    /**
     * Checks if this Logger is enabled for the FATAL level. 
     * The method should return true if this Logger is enabled for FATAL events, 
     * false otherwise.
     * <BR>This property is intended to let the library save computational cost by suppressing the generation of
     * log FATAL statements. However, even if the method returns false, FATAL log 
     * lines may still be received by the {@link SimpleLogger#fatal} method
     * and should be ignored by the Logger implementation. 
     * 
     * @return {boolean} true if FATAL logging is enabled, false otherwise
     */
    isFatalEnabled: function() {
      return (SimpleLogLevels.priority("FATAL")>=SimpleLogLevels.priority(this.minLevel));
    },
    
    /**
     * Receives log messages at ERROR level.
     * 
     * @param {String} message The message to be logged.  
     * @param {Error} [exception] An Exception instance related to the current log message.
     */
    error: function(mex,exception) {
      if ( this.isErrorEnabled() ) {
        this.logProvider.dispatchLog(this.category, "ERROR", mex);
      }
      return;
    },    
      
    /**
     * Checks if this Logger is enabled for the ERROR level. 
     * The method should return true if this Logger is enabled for ERROR events, 
     * false otherwise.
     * <BR>This property is intended to let the library save computational cost by suppressing the generation of
     * log ERROR statements. However, even if the method returns false, ERROR log 
     * lines may still be received by the {@link SimpleLogger#error} method
     * and should be ignored by the Logger implementation. 
     * 
     * @return {boolean} true if ERROR logging is enabled, false otherwise
     */
    isErrorEnabled: function() {
      return (SimpleLogLevels.priority("ERROR")>=SimpleLogLevels.priority(this.minLevel));
    },
    
    /**
     * Receives log messages at WARN level.
     * 
     * @param {String} message The message to be logged.  
     * @param {Error} [exception] An Exception instance related to the current log message.
     */
    warn: function(mex,exception) {
      if ( this.isWarnEnabled() ) {
        this.logProvider.dispatchLog(this.category, "WARN", mex);
      }  
      return;
    },    
      
    /**
     * Checks if this Logger is enabled for the WARN level. 
     * The method should return true if this Logger is enabled for WARN events, 
     * false otherwise.
     * <BR>This property is intended to let the library save computational cost by suppressing the generation of
     * log WARN statements. However, even if the method returns false, WARN log 
     * lines may still be received by the {@link SimpleLogger#warn} method
     * and should be ignored by the Logger implementation. 
     * 
     * @return {boolean} true if WARN logging is enabled, false otherwise
     */
    isWarnEnabled: function() {
      return (SimpleLogLevels.priority("WARN")>=SimpleLogLevels.priority(this.minLevel));
    },
    
    /**
     * Receives log messages at INFO level.
     * 
     * @param {String} message The message to be logged.  
     * @param {Error} [exception] An Exception instance related to the current log message.
     */
    info: function(mex,exception) {
      if ( this.isInfoEnabled() ) {
        this.logProvider.dispatchLog(this.category, "INFO", mex);
      }
      return;
    },    
    
    /**
     * Checks if this Logger is enabled for the INFO level. 
     * The method should return true if this Logger is enabled for INFO events, 
     * false otherwise.
     * <BR>This property is intended to let the library save computational cost by suppressing the generation of
     * log INFO statements. However, even if the method returns false, INFO log 
     * lines may still be received by the {@link SimpleLogger#info} method
     * and should be ignored by the Logger implementation. 
     * 
     * @return {boolean} true if INFO logging is enabled, false otherwise
     */
    isInfoEnabled: function() {
      return (SimpleLogLevels.priority("INFO")>=SimpleLogLevels.priority(this.minLevel));
    },
    
    /**
     * Receives log messages at DEBUG level.
     * 
     * @param {String} message The message to be logged.  
     * @param {Error} [exception] An Exception instance related to the current log message.
     */
    debug: function(mex,exception) {
      if ( this.isDebugEnabled() ) {
        this.logProvider.dispatchLog(this.category, "DEBUG", mex);
      }
      return;
    },    
    
    /**
     * Checks if this Logger is enabled for the DEBUG level. 
     * The method should return true if this Logger is enabled for DEBUG events, 
     * false otherwise.
     * <BR>This property is intended to let the library save computational cost by suppressing the generation of
     * log DEBUG statements. However, even if the method returns false, DEBUG log 
     * lines may still be received by the {@link SimpleLogger#debug} method
     * and should be ignored by the Logger implementation. 
     * 
     * @return {boolean} true if DEBUG logging is enabled, false otherwise
     */
    isDebugEnabled: function() {
      return (SimpleLogLevels.priority("DEBUG")>=SimpleLogLevels.priority(this.minLevel));
    },
    
    /**
     * Call by SimpleLoggerProvider to configure the minimum log level enabled.
     *
     * @param {String} [level] log level enabled, if missing or if a not expected value is used
     * "DEBUG" is assumed
     */
    setLevel: function(level) {
      this.minLevel = SimpleLogLevels.priority(level) ? level : "DEBUG"; 
    }
  };
  
  //google closure exports
  SimpleLogger.prototype["fatal"] = SimpleLogger.prototype.fatal;
  SimpleLogger.prototype["isFatalEnabled"] = SimpleLogger.prototype.isFatalEnabled;
  SimpleLogger.prototype["error"] = SimpleLogger.prototype.error;
  SimpleLogger.prototype["isErrorEnabled"] = SimpleLogger.prototype.isErrorEnabled;
  SimpleLogger.prototype["warn"] = SimpleLogger.prototype.warn;
  SimpleLogger.prototype["isWarnEnabled"] = SimpleLogger.prototype.isWarnEnabled;
  SimpleLogger.prototype["info"] = SimpleLogger.prototype.info;
  SimpleLogger.prototype["isInfoEnabled"] = SimpleLogger.prototype.isInfoEnabled;
  SimpleLogger.prototype["debug"] = SimpleLogger.prototype.debug;
  SimpleLogger.prototype["isDebugEnabled"] = SimpleLogger.prototype.isDebugEnabled;
  SimpleLogger.prototype["setLevel"] = SimpleLogger.prototype.setLevel;
  

  
  return SimpleLogger;
})();

/*
  Copyright (c) Lightstreamer Srl

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

var SimpleLoggerProvider = /*@__PURE__*/(function() {
  /**
   * @private
   */
  function logHeader() {
    var _line = (typeof window != "undefined") ? (window.name + " ") : "";
    var i = 0;
    var now = new Date();
    
    i = now.getHours();
    if ( i < 10 ) {
      _line += "0";
    }
    _line += i;
    _line += ":";
    
    i = now.getMinutes();
    if ( i < 10 ) {
      _line += "0";
    }
    _line += i;
    _line += ":";
         
    i = now.getSeconds();
    if ( i < 10 ) {
      _line += "0";
    }
    _line += i;
    _line += ",";
    
    _line += now.getMilliseconds();
    
    return _line;
  }  
  /**
   * Empty constructor for SimpleLoggerProvider. 
   * @constructor
   *
   * @exports SimpleLoggerProvider
   * 
   * @class SimpleLoggerProvider implementation that can be used to consume logging
   * from the {@link module:LoggerManager}. 
   * To enable client logging, an instance of this class has to be created and supplied through the
   * {@link module:LoggerManager.setLoggerProvider} method before any log can be 
   * consumed.
   * <br/>In order to determine how to consume the log, one or multiple "appenders"
   * can be supplied to this object, through {@link SimpleLoggerProvider#addLoggerAppender}.
   * The {@link Logger} instances created by this LoggerProvider for the various log categories
   * will forward the log lines to the appenders, based on the appender preferences configured.
   * Category and level filters are available and can be configured on each appender.
   * <br/>Several appender classes are distributed with the library in 
   * order to enable custom code to consume the log in different ways:
   * {@link ConsoleAppender}, {@link AlertAppender},
   * {@link DOMAppender}, {@link FunctionAppender} and {@link BufferAppender}.  
   * <BR>
   * <BR>The SimpleLoggerProvider is available for the implementation of custom logging;
   * just invoke the {@link LoggerProvider#getLogger} method to get {@link Logger}
   * objects for custom categories, then invoke the various methods available on the
   * loggers to produce log messages to be handled by the configured appenders.
   *
   * @extends LoggerProvider
   */
  var SimpleLoggerProvider = function() { ////extend EventDispatcher?

    this.appenders = [];
    this.logInstances = {};
  };
  
  
  SimpleLoggerProvider.prototype = {
     
    /**
     * @private
     */     
     minPriority: function() { // @return {Number} min log level supported by the appenders;
      var min = 100;
      var champion = 0;
      if (this.appenders.length > 0) {
        for (var i=0; i<this.appenders.length; i++) {
          if ( SimpleLogLevels.priority(this.appenders[i].getLevel()) < min ) {
            min = SimpleLogLevels.priority(this.appenders[i].getLevel());
            champion = i;
          }
        }
        
        return this.appenders[champion].getLevel();
      } else {
        return null;
      }
    },
    
    /**
     * @private
     */     
    setLoggerLevel: function(level) {
      for (var key in this.logInstances) {
        this.logInstances[key].setLevel(level);
      }
    },
    
    /**
     * @private
     */
    checkCategoryFilter: function(_appender, category) { //Check the filter categories for a loggerAppender. 
      var appenderFilter;
      var allAppenderCategories=[];
      
      if (_appender.getCategoryFilter() === "*") {
        return true;
      } else {
        appenderFilter = _appender.getCategoryFilter();
        allAppenderCategories = appenderFilter.split(" ");
        for (var i=0; i<allAppenderCategories.length; i++) {
          if (allAppenderCategories[i] == category) {
            return true;
          }
        }
        
        return false;
      }
    },
    
    /**
     * Adds a {@link SimpleLogAppender} to this SimpleLoggerProvider instance. Such appender 
     * will receive log lines from the Logger instances generated by this SimpleLoggerProvider instance. 
     * The appender defines a category and a threshold level, 
     * so that it will receive only the log lines with a level equal to or greater
     * than the threshold and only from the Logger associated with the requested category.
     *
     * <br/>Appenders can be added at any time; any loggers already created
     * by this SimpleLoggerProvider instance will start using the new appender.
     * Until the first appender is added, all log will be discarded.
     * 
     * @param {SimpleLogAppender} logAppender An instance of SimpleLogAppender that will consume
     * the log.
     */ 
    addLoggerAppender: function(logAppender) {
      if ( logAppender && logAppender.log && logAppender.getLevel ) {
        this.appenders.push(logAppender);
        if ( logAppender.setLoggerProvider ) {
          logAppender.setLoggerProvider(this);
        }
      }
      this.setLoggerLevel(this.minPriority());
    },
    
    /**
     * Removes a {@link SimpleLogAppender} from this SimpleLoggerProvider instance.
     * <br/>Appenders can be removed at any time.
     *
     * @param {SimpleLogAppender} logAppender An instance of SimpleLogAppender that was previously 
     * added to this SimpleLoggerProvider instance.
     * 
     * @see SimpleLoggerProvider#addLoggerAppender
     */
    removeLoggerAppender: function(logAppender) {
      for (var i=0; i<this.appenders.length; i++) {
        if ( this.appenders[i] === logAppender) {
          this.appenders.splice(i,1);
          this.setLoggerLevel(this.minPriority());
          return;
        }
      }
    },
    
    
    /** 
     * @private
     */
    forceLogLevelUpdate: function() {
      //Force update of log level of all loggers upon the min level of all log appernders.
      //Used by logAppenders instances when a setLevel operation has been performed. 
      this.setLoggerLevel(this.minPriority());
    },
    
    /**
     * Logger factory that gets a logger related to a specified category name.
     * If such logger does not exist it is created.
     * A unique instance is always maintained for each logger name.
     * This method can potentially cause a memory leak as once a Logger 
     * is created it will never be dismissed. It is expected that the number of 
     * categories within a single application is somewhat limited and in any case
     * not growing with time.
     *
     * @param {String} category The name of the desired log category. 
     *
     * @return {Logger} The desired Logger instance.
     */
    getLogger: function(category) {
      if ( !this.logInstances[category] ) {
        this.logInstances[category] = new SimpleLogger(this, category);
        if (this.appenders.length > 0)
          this.logInstances[category].setLevel(this.minPriority());
      }
      return this.logInstances[category];
    },
    

    
    /**
     * Publish a log message on all SimpleLogAppender object instances added to this SimpleLoggerProvider so far.
     * 
     * @param {String} category The category name that produced the given message.
     * @param {String} level The logging level of the given message. It should be one of DEBUG INFO WARN ERROR FATAL
     * constants values. 
     * @param {*} mex The message to be logged. It could be a String instance, an Error instance or any other
     * object, provided that it has a toString method.
     * 
     */
    dispatchLog: function(category, level, mex) {
      var header = logHeader();
      var priority = SimpleLogLevels.priority(level);
      for (var i=0; i<this.appenders.length; i++) {
        if ( SimpleLogLevels.priority(this.appenders[i].getLevel()) <= priority ) {
          if (this.checkCategoryFilter(this.appenders[i],category)) {
            this.appenders[i].log(category, level, mex, header);
          }
        }
      }
    }
  };
  
  //google closure exports
  SimpleLoggerProvider.prototype["addLoggerAppender"] = SimpleLoggerProvider.prototype.addLoggerAppender;
  SimpleLoggerProvider.prototype["removeLoggerAppender"] = SimpleLoggerProvider.prototype.removeLoggerAppender;
  SimpleLoggerProvider.prototype["getLogger"] = SimpleLoggerProvider.prototype.getLogger;
  SimpleLoggerProvider.prototype["dispatchLog"] = SimpleLoggerProvider.prototype.dispatchLog;
  
  return SimpleLoggerProvider;
})();


//JSDOC_IGNORE_END

export { AlertAppender, BufferAppender, Chart, ConnectionSharing, ConsoleAppender, DOMAppender, DynaGrid, FirebaseMpnBuilder, FunctionAppender, LightstreamerClient, LogMessages, MpnDevice, MpnSubscription, RemoteAppender, SafariMpnBuilder, SimpleChartListener, SimpleLoggerProvider, StaticGrid, StatusWidget, Subscription };
